import * as yt from "react";
import $o, { createContext as cb, useContext as PA, useRef as Fa, useSyncExternalStore as IO, useCallback as ub, useMemo as oc, useEffect as ra, useLayoutEffect as kA, memo as xO, forwardRef as oe, createElement as Ed, Children as RA, isValidElement as TO, cloneElement as PO, useId as gr, useState as du } from "react";
import { createPortal as OA } from "react-dom";
const kO = {
  colors: {
    text: {
      dark: { value: "{colors.ink.800}" },
      mid: { value: "{colors.ink.500}" },
      light: { value: "{colors.ink.400}" },
      disabled: { value: "{colors.ink.300}" },
      inverse: { value: "white" },
      accent: {
        dark: { value: "{colors.blue.700}" },
        mid: { value: "{colors.blue.500}" },
        light: { value: "{colors.blue.300}" }
      },
      success: {
        dark: { value: "{colors.green.700}" },
        mid: { value: "{colors.green.500}" },
        light: { value: "{colors.green.300}" }
      },
      warning: {
        dark: { value: "{colors.orange.700}" },
        mid: { value: "{colors.orange.500}" },
        light: { value: "{colors.orange.300}" }
      },
      error: {
        dark: { value: "{colors.red.700}" },
        mid: { value: "{colors.red.500}" },
        light: { value: "{colors.red.300}" }
      },
      highlight: {
        dark: { value: "{colors.yellow.700}" },
        mid: { value: "{colors.yellow.500}" },
        light: { value: "{colors.yellow.300}" }
      }
    },
    bg: {
      darkest: { value: "{colors.ink.800}" },
      dark: { value: "{colors.ink.500}" },
      mid: { value: "{colors.ink.400}" },
      lighter: { value: "{colors.ink.300}" },
      lightest: { value: "{colors.ink.200}" },
      accent: {
        darkest: { value: "{colors.blue.700}" },
        dark: { value: "{colors.blue.500}" },
        mid: { value: "{colors.blue.300}" },
        light: { value: "{colors.blue.100}" },
        lightest: { value: "{colors.blue.50}" }
      },
      success: {
        darkest: { value: "{colors.green.700}" },
        dark: { value: "{colors.green.500}" },
        mid: { value: "{colors.green.300}" },
        light: { value: "{colors.green.100}" },
        lightest: { value: "{colors.green.50}" }
      },
      warning: {
        darkest: { value: "{colors.orange.700}" },
        dark: { value: "{colors.orange.500}" },
        mid: { value: "{colors.orange.300}" },
        light: { value: "{colors.orange.100}" },
        lightest: { value: "{colors.orange.50}" }
      },
      error: {
        darkest: { value: "{colors.red.700}" },
        dark: { value: "{colors.red.500}" },
        mid: { value: "{colors.red.300}" },
        light: { value: "{colors.red.100}" },
        lightest: { value: "{colors.red.50}" }
      },
      highlight: {
        darkest: { value: "{colors.yellow.700}" },
        dark: { value: "{colors.yellow.500}" },
        mid: { value: "{colors.yellow.300}" },
        light: { value: "{colors.yellow.100}" },
        lightest: { value: "{colors.yellow.50}" }
      },
      wa: {
        dark: { value: "{colors.cream.300}" },
        mid: { value: "{colors.cream.200}" },
        light: { value: "{colors.cream.100}" },
        lightest: { value: "{colors.cream.50}" }
      }
    },
    icon: {
      dark: { value: "{colors.ink.800}" },
      mid: { value: "{colors.ink.500}" },
      light: { value: "{colors.ink.400}" },
      disabled: { value: "{colors.ink.300}" },
      inverse: { value: "white" },
      accent: {
        dark: { value: "{colors.blue.700}" },
        mid: { value: "{colors.blue.500}" },
        light: { value: "{colors.blue.300}" }
      },
      success: {
        dark: { value: "{colors.green.700}" },
        mid: { value: "{colors.green.500}" },
        light: { value: "{colors.green.300}" }
      },
      warning: {
        dark: { value: "{colors.orange.700}" },
        mid: { value: "{colors.orange.500}" },
        light: { value: "{colors.orange.300}" }
      },
      error: {
        dark: { value: "{colors.red.700}" },
        mid: { value: "{colors.red.500}" },
        light: { value: "{colors.red.300}" }
      },
      highlight: {
        dark: { value: "{colors.yellow.700}" },
        mid: { value: "{colors.yellow.500}" },
        light: { value: "{colors.yellow.300}" }
      }
    },
    border: {
      dark: { value: "{colors.ink.800}" },
      mid: { value: "{colors.ink.400}" },
      light: { value: "{colors.ink.300}" },
      disabled: { value: "{colors.ink.200}" },
      accent: { value: "{colors.blue.500}" },
      success: { value: "{colors.green.500}" },
      warning: { value: "{colors.orange.500}" },
      error: { value: "{colors.red.500}" },
      highlight: { value: "{colors.yellow.500}" }
    }
  }
}, RO = {
  ink: {
    50: { value: "#FAFAFA" },
    100: { value: "#F4F4F5" },
    200: { value: "#EDEDEE" },
    300: { value: "#D4D4D8" },
    400: { value: "#A1A1AA" },
    500: { value: "#71717A" },
    600: { value: "#52525B" },
    700: { value: "#3F3F46" },
    800: { value: "#27272A" }
  },
  red: {
    50: { value: "#FCECE9" },
    100: { value: "#F9D9D2" },
    300: { value: "#EE9D8A" },
    500: { value: "#E14F2F" },
    700: { value: "#AC2506" }
  },
  orange: {
    50: { value: "#FBF0E0" },
    100: { value: "#FFE5BF" },
    300: { value: "#FFCE84" },
    500: { value: "#E08D11" },
    700: { value: "#8A5402" }
  },
  yellow: {
    50: { value: "#FFFAEB" },
    100: { value: "#FFF0B8" },
    300: { value: "#F8D75F" },
    500: { value: "#CA9307" },
    700: { value: "#8B6502" }
  },
  green: {
    50: { value: "#EDFAF5" },
    100: { value: "#D5F5E8" },
    300: { value: "#8ECDB3" },
    500: { value: "#429F72" },
    700: { value: "#27704C" }
  },
  blue: {
    50: { value: "#EBF2FF" },
    100: { value: "#D1E0FF" },
    300: { value: "#7B9AFF" },
    500: { value: "#2E5BEF" },
    700: { value: "#0634CC" }
  },
  cream: {
    50: { value: "#FAF7F3" },
    100: { value: "#F1EDE7" },
    200: { value: "#FBF0E0" },
    300: { value: "#DEDAD3" }
  }
}, OO = {
  0: { value: "0" },
  25: { value: "0.125rem" },
  50: { value: "0.25rem" },
  75: { value: "0.375rem" },
  100: { value: "0.5rem" },
  150: { value: "0.75rem" },
  200: { value: "1rem" },
  250: { value: "1.25rem" },
  300: { value: "1.5rem" },
  400: { value: "2rem" }
}, DO = {
  25: { value: "0 1px 2px 0 rgba(0, 0, 0, 0.05)" },
  50: { value: "0 1px 4px 0 rgba(0, 0, 0, 0.08);" },
  100: { value: "0 2px 8px 0 rgba(0, 0, 0, 0.08);" },
  200: { value: "0 4px 12px 0 rgba(0, 0, 0, 0.08)" },
  300: { value: "0 8px 20px -3px rgba(0, 0, 0, 0.15)" }
}, FO = {
  icons: {
    sm: { value: "1rem" },
    md: { value: "1.25rem" },
    lg: { value: "1.5rem" },
    xl: { value: "2rem" }
  },
  modals: {
    pane: { value: "460px" },
    center: { value: "600px" }
  }
}, NO = {
  25: { value: "0.125rem" },
  50: { value: "0.25rem" },
  75: { value: "0.375rem" },
  100: { value: "0.5rem" },
  150: { value: "0.75rem" },
  200: { value: "1rem" },
  250: { value: "1.25rem" },
  300: { value: "1.5rem" },
  400: { value: "2rem" },
  500: { value: "2.5rem" },
  600: { value: "3rem" },
  800: { value: "4rem" },
  1e3: { value: "5rem" }
}, MO = {
  letterSpacings: {
    tightest: { value: "-0.01em" },
    tighter: { value: "-0.05em" },
    tight: { value: "-0.025em" },
    normal: { value: "0" },
    wide: { value: "0.008em" },
    wider: { value: "0.024em" },
    widest: { value: "0.1em" }
  },
  lineHeights: {
    "2xs": { value: "1rem" },
    xs: { value: "1.375rem" },
    sm: { value: "1.5rem" },
    md: { value: "1.75rem" },
    lg: { value: "2rem" },
    xl: { value: "2.25rem" },
    "2xl": { value: "2.5rem" },
    "3xl": { value: "3rem" },
    "4xl": { value: "3.75rem" }
  },
  fontWeights: {
    thin: { value: 200 },
    light: { value: 300 },
    normal: { value: 400 },
    medium: { value: 500 },
    semiBold: { value: 600 },
    bold: { value: 700 },
    extraBold: { value: 800 },
    black: { value: 900 }
  },
  fonts: {
    heading: {
      value: `'Figtree Variable', 'Figtree', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
    },
    body: {
      value: `'Figtree Variable', 'Figtree', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
    },
    mono: {
      value: `'IBM Plex Mono', SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace`
    }
  },
  fontSizes: {
    "2xs": { value: "0.813rem" },
    xs: { value: "0.875rem" },
    sm: { value: "0.938rem" },
    md: { value: "1rem" },
    lg: { value: "1.125rem" },
    xl: { value: "1.25rem" },
    "2xl": { value: "1.5rem" },
    "3xl": { value: "2rem" },
    "4xl": { value: "2.25rem" },
    "5xl": { value: "3rem" }
  }
}, P0 = 2147483647, LO = {
  // Toasts should appear on top of *everything*:
  toast: { value: P0 },
  modal: { value: P0 - 1 }
}, BO = {
  standard: {
    productive: { value: "cubic-bezier(0.2, 0, 0.38, 0.9)" },
    expressive: { value: "cubic-bezier(0.4, 0.14, 0.3, 1)" }
  },
  entrance: {
    productive: { value: "cubic-bezier(0, 0, 0.38, 0.9)" },
    expressive: { value: "cubic-bezier(0, 0, 0.3, 1)" }
  },
  exit: {
    productive: { value: "cubic-bezier(0.2, 0, 1, 0.9)" },
    expressive: { value: "cubic-bezier(0.4, 0.14, 1, 1)" }
  }
}, VO = {
  fast1: { value: "70ms" },
  fast2: { value: "110ms" },
  moderate1: { value: "150ms" },
  moderate2: { value: "240ms" },
  slow1: { value: "400ms" },
  slow2: { value: "700ms" }
}, jO = {
  colors: RO,
  radii: OO,
  shadows: DO,
  sizes: FO,
  spacing: NO,
  zIndex: LO,
  easings: BO,
  durations: VO,
  ...MO
}, UO = {
  leftToOrigin: {
    from: { transform: "translateX(-100%)" },
    to: { transform: "translateX(0)" }
  },
  originToLeft: {
    from: { transform: "translateX(0)" },
    to: { transform: "translateX(-100%)" }
  },
  originToRight: {
    from: { transform: "translateX(0)" },
    to: { transform: "translateX(100%)" }
  },
  rightToOrigin: {
    from: { transform: "translateX(100%)" },
    to: { transform: "translateX(0)" }
  },
  bottomToOrigin: {
    from: { transform: "translateY(100%)" },
    to: { transform: "translateY(0)" }
  },
  originToBottom: {
    from: { transform: "translateY(0)" },
    to: { transform: "translateY(100%)" }
  },
  fadeIn: {
    from: { opacity: 0 },
    to: { opacity: 100 }
  },
  fadeOut: {
    from: { opacity: 100 },
    to: { opacity: 0 }
  },
  fadeInBottomToOrigin: {
    from: { transform: "translateY(100%)", opacity: 0 },
    to: { transform: "translateY(0)", opacity: 100 }
  },
  fadeOutOriginToBottom: {
    from: { transform: "translateY(0)", opacity: 100 },
    to: { transform: "translateY(100%)", opacity: 0 }
  },
  slideDown: {
    from: {
      opacity: 0.01,
      height: 0
    },
    to: {
      opacity: 1,
      height: "var(--height)"
    }
  },
  slideUp: {
    from: {
      opacity: 1,
      height: "var(--height)"
    },
    to: {
      opacity: 0.01,
      height: 0
    }
  }
}, WO = {
  // `preflight` injects Panda's CSS resets into the stylesheet it produces (styled-system/styles.css)
  // which is important because it helps control against unwanted style inheritance.
  // This has two important implications:
  //  - We don't have to write any styling code to override built-in browser styles (which differ per-browser anyway),
  //  since the stylesheet erases them (e.g. note how <button/> has no border or background color when
  //  styled-system/styles.css is imported).
  //  - We reduce the risk of inheriting from other styles on a webpage (e.g. if we're using design system components
  // on an external website with its own styling).
  preflight: !0,
  include: ["./src/**/*.{js,jsx,ts,tsx}"],
  jsxFramework: "react",
  cssVarRoot: ":host, :root",
  globalCss: {
    "#trekker-style-root": {
      color: "token(colors.text.dark)"
    }
  },
  theme: { extend: { tokens: jO, semanticTokens: kO, keyframes: UO } }
};
function HO(e, n) {
  return `${e} returned \`undefined\`. Seems you forgot to wrap component within ${n}`;
}
function xt(e = {}) {
  const {
    name: n,
    strict: t = !0,
    hookName: r = "useContext",
    providerName: o = "Provider",
    errorMessage: a,
    defaultValue: l
  } = e, u = cb(l);
  u.displayName = n;
  function f() {
    var y;
    const p = PA(u);
    if (!p && t) {
      const A = new Error(a ?? HO(r, o));
      throw A.name = "ContextError", (y = Error.captureStackTrace) == null || y.call(Error, A, f), A;
    }
    return p;
  }
  return [u.Provider, f, u];
}
const [GO, Hg] = xt({
  name: "AccordionContext",
  hookName: "useAccordionContext",
  providerName: "<AccordionProvider />"
}), YO = (e) => e.children(Hg());
var cg = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function DA(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ov = { exports: {} }, ug = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var k0;
function zO() {
  if (k0)
    return ug;
  k0 = 1;
  var e = $o, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(u, f, p) {
    var y, A = {}, w = null, F = null;
    p !== void 0 && (w = "" + p), f.key !== void 0 && (w = "" + f.key), f.ref !== void 0 && (F = f.ref);
    for (y in f)
      r.call(f, y) && !a.hasOwnProperty(y) && (A[y] = f[y]);
    if (u && u.defaultProps)
      for (y in f = u.defaultProps, f)
        A[y] === void 0 && (A[y] = f[y]);
    return { $$typeof: n, type: u, key: w, ref: F, props: A, _owner: o.current };
  }
  return ug.Fragment = t, ug.jsx = l, ug.jsxs = l, ug;
}
var dg = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var R0;
function ZO() {
  return R0 || (R0 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = $o, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), u = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), y = Symbol.for("react.suspense_list"), A = Symbol.for("react.memo"), w = Symbol.for("react.lazy"), F = Symbol.for("react.offscreen"), j = Symbol.iterator, N = "@@iterator";
    function D(X) {
      if (X === null || typeof X != "object")
        return null;
      var ke = j && X[j] || X[N];
      return typeof ke == "function" ? ke : null;
    }
    var k = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function z(X) {
      {
        for (var ke = arguments.length, Ve = new Array(ke > 1 ? ke - 1 : 0), at = 1; at < ke; at++)
          Ve[at - 1] = arguments[at];
        q("error", X, Ve);
      }
    }
    function q(X, ke, Ve) {
      {
        var at = k.ReactDebugCurrentFrame, St = at.getStackAddendum();
        St !== "" && (ke += "%s", Ve = Ve.concat([St]));
        var Ot = Ve.map(function(Tt) {
          return String(Tt);
        });
        Ot.unshift("Warning: " + ke), Function.prototype.apply.call(console[X], console, Ot);
      }
    }
    var Ce = !1, ee = !1, Fe = !1, Oe = !1, He = !1, Re;
    Re = Symbol.for("react.module.reference");
    function Se(X) {
      return !!(typeof X == "string" || typeof X == "function" || X === r || X === a || He || X === o || X === p || X === y || Oe || X === F || Ce || ee || Fe || typeof X == "object" && X !== null && (X.$$typeof === w || X.$$typeof === A || X.$$typeof === l || X.$$typeof === u || X.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      X.$$typeof === Re || X.getModuleId !== void 0));
    }
    function we(X, ke, Ve) {
      var at = X.displayName;
      if (at)
        return at;
      var St = ke.displayName || ke.name || "";
      return St !== "" ? Ve + "(" + St + ")" : Ve;
    }
    function ae(X) {
      return X.displayName || "Context";
    }
    function ge(X) {
      if (X == null)
        return null;
      if (typeof X.tag == "number" && z("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof X == "function")
        return X.displayName || X.name || null;
      if (typeof X == "string")
        return X;
      switch (X) {
        case r:
          return "Fragment";
        case t:
          return "Portal";
        case a:
          return "Profiler";
        case o:
          return "StrictMode";
        case p:
          return "Suspense";
        case y:
          return "SuspenseList";
      }
      if (typeof X == "object")
        switch (X.$$typeof) {
          case u:
            var ke = X;
            return ae(ke) + ".Consumer";
          case l:
            var Ve = X;
            return ae(Ve._context) + ".Provider";
          case f:
            return we(X, X.render, "ForwardRef");
          case A:
            var at = X.displayName || null;
            return at !== null ? at : ge(X.type) || "Memo";
          case w: {
            var St = X, Ot = St._payload, Tt = St._init;
            try {
              return ge(Tt(Ot));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Ie = Object.assign, Ye = 0, Ke, ze, ue, de, Q, me, Le;
    function Je() {
    }
    Je.__reactDisabledLog = !0;
    function Xe() {
      {
        if (Ye === 0) {
          Ke = console.log, ze = console.info, ue = console.warn, de = console.error, Q = console.group, me = console.groupCollapsed, Le = console.groupEnd;
          var X = {
            configurable: !0,
            enumerable: !0,
            value: Je,
            writable: !0
          };
          Object.defineProperties(console, {
            info: X,
            log: X,
            warn: X,
            error: X,
            group: X,
            groupCollapsed: X,
            groupEnd: X
          });
        }
        Ye++;
      }
    }
    function je() {
      {
        if (Ye--, Ye === 0) {
          var X = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Ie({}, X, {
              value: Ke
            }),
            info: Ie({}, X, {
              value: ze
            }),
            warn: Ie({}, X, {
              value: ue
            }),
            error: Ie({}, X, {
              value: de
            }),
            group: Ie({}, X, {
              value: Q
            }),
            groupCollapsed: Ie({}, X, {
              value: me
            }),
            groupEnd: Ie({}, X, {
              value: Le
            })
          });
        }
        Ye < 0 && z("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ue = k.ReactCurrentDispatcher, it;
    function ct(X, ke, Ve) {
      {
        if (it === void 0)
          try {
            throw Error();
          } catch (St) {
            var at = St.stack.trim().match(/\n( *(at )?)/);
            it = at && at[1] || "";
          }
        return `
` + it + X;
      }
    }
    var lt = !1, dt;
    {
      var Mt = typeof WeakMap == "function" ? WeakMap : Map;
      dt = new Mt();
    }
    function Be(X, ke) {
      if (!X || lt)
        return "";
      {
        var Ve = dt.get(X);
        if (Ve !== void 0)
          return Ve;
      }
      var at;
      lt = !0;
      var St = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ot;
      Ot = Ue.current, Ue.current = null, Xe();
      try {
        if (ke) {
          var Tt = function() {
            throw Error();
          };
          if (Object.defineProperty(Tt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Tt, []);
            } catch (an) {
              at = an;
            }
            Reflect.construct(X, [], Tt);
          } else {
            try {
              Tt.call();
            } catch (an) {
              at = an;
            }
            X.call(Tt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (an) {
            at = an;
          }
          X();
        }
      } catch (an) {
        if (an && at && typeof an.stack == "string") {
          for (var Et = an.stack.split(`
`), vn = at.stack.split(`
`), Kt = Et.length - 1, Xt = vn.length - 1; Kt >= 1 && Xt >= 0 && Et[Kt] !== vn[Xt]; )
            Xt--;
          for (; Kt >= 1 && Xt >= 0; Kt--, Xt--)
            if (Et[Kt] !== vn[Xt]) {
              if (Kt !== 1 || Xt !== 1)
                do
                  if (Kt--, Xt--, Xt < 0 || Et[Kt] !== vn[Xt]) {
                    var pn = `
` + Et[Kt].replace(" at new ", " at ");
                    return X.displayName && pn.includes("<anonymous>") && (pn = pn.replace("<anonymous>", X.displayName)), typeof X == "function" && dt.set(X, pn), pn;
                  }
                while (Kt >= 1 && Xt >= 0);
              break;
            }
        }
      } finally {
        lt = !1, Ue.current = Ot, je(), Error.prepareStackTrace = St;
      }
      var Un = X ? X.displayName || X.name : "", go = Un ? ct(Un) : "";
      return typeof X == "function" && dt.set(X, go), go;
    }
    function Wt(X, ke, Ve) {
      return Be(X, !1);
    }
    function Ht(X) {
      var ke = X.prototype;
      return !!(ke && ke.isReactComponent);
    }
    function Fn(X, ke, Ve) {
      if (X == null)
        return "";
      if (typeof X == "function")
        return Be(X, Ht(X));
      if (typeof X == "string")
        return ct(X);
      switch (X) {
        case p:
          return ct("Suspense");
        case y:
          return ct("SuspenseList");
      }
      if (typeof X == "object")
        switch (X.$$typeof) {
          case f:
            return Wt(X.render);
          case A:
            return Fn(X.type, ke, Ve);
          case w: {
            var at = X, St = at._payload, Ot = at._init;
            try {
              return Fn(Ot(St), ke, Ve);
            } catch {
            }
          }
        }
      return "";
    }
    var Fr = Object.prototype.hasOwnProperty, $n = {}, er = k.ReactDebugCurrentFrame;
    function Nr(X) {
      if (X) {
        var ke = X._owner, Ve = Fn(X.type, X._source, ke ? ke.type : null);
        er.setExtraStackFrame(Ve);
      } else
        er.setExtraStackFrame(null);
    }
    function Cr(X, ke, Ve, at, St) {
      {
        var Ot = Function.call.bind(Fr);
        for (var Tt in X)
          if (Ot(X, Tt)) {
            var Et = void 0;
            try {
              if (typeof X[Tt] != "function") {
                var vn = Error((at || "React class") + ": " + Ve + " type `" + Tt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof X[Tt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw vn.name = "Invariant Violation", vn;
              }
              Et = X[Tt](ke, Tt, at, Ve, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Kt) {
              Et = Kt;
            }
            Et && !(Et instanceof Error) && (Nr(St), z("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", at || "React class", Ve, Tt, typeof Et), Nr(null)), Et instanceof Error && !(Et.message in $n) && ($n[Et.message] = !0, Nr(St), z("Failed %s type: %s", Ve, Et.message), Nr(null));
          }
      }
    }
    var Gn = Array.isArray;
    function Rn(X) {
      return Gn(X);
    }
    function An(X) {
      {
        var ke = typeof Symbol == "function" && Symbol.toStringTag, Ve = ke && X[Symbol.toStringTag] || X.constructor.name || "Object";
        return Ve;
      }
    }
    function Sn(X) {
      try {
        return Mr(X), !1;
      } catch {
        return !0;
      }
    }
    function Mr(X) {
      return "" + X;
    }
    function ii(X) {
      if (Sn(X))
        return z("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", An(X)), Mr(X);
    }
    var tr = k.ReactCurrentOwner, tn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, co, Oo, uo;
    uo = {};
    function Do(X) {
      if (Fr.call(X, "ref")) {
        var ke = Object.getOwnPropertyDescriptor(X, "ref").get;
        if (ke && ke.isReactWarning)
          return !1;
      }
      return X.ref !== void 0;
    }
    function fo(X) {
      if (Fr.call(X, "key")) {
        var ke = Object.getOwnPropertyDescriptor(X, "key").get;
        if (ke && ke.isReactWarning)
          return !1;
      }
      return X.key !== void 0;
    }
    function xi(X, ke) {
      if (typeof X.ref == "string" && tr.current && ke && tr.current.stateNode !== ke) {
        var Ve = ge(tr.current.type);
        uo[Ve] || (z('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', ge(tr.current.type), X.ref), uo[Ve] = !0);
      }
    }
    function Fo(X, ke) {
      {
        var Ve = function() {
          co || (co = !0, z("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ke));
        };
        Ve.isReactWarning = !0, Object.defineProperty(X, "key", {
          get: Ve,
          configurable: !0
        });
      }
    }
    function Lr(X, ke) {
      {
        var Ve = function() {
          Oo || (Oo = !0, z("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ke));
        };
        Ve.isReactWarning = !0, Object.defineProperty(X, "ref", {
          get: Ve,
          configurable: !0
        });
      }
    }
    var No = function(X, ke, Ve, at, St, Ot, Tt) {
      var Et = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: X,
        key: ke,
        ref: Ve,
        props: Tt,
        // Record the component responsible for creating this element.
        _owner: Ot
      };
      return Et._store = {}, Object.defineProperty(Et._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Et, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: at
      }), Object.defineProperty(Et, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: St
      }), Object.freeze && (Object.freeze(Et.props), Object.freeze(Et)), Et;
    };
    function aa(X, ke, Ve, at, St) {
      {
        var Ot, Tt = {}, Et = null, vn = null;
        Ve !== void 0 && (ii(Ve), Et = "" + Ve), fo(ke) && (ii(ke.key), Et = "" + ke.key), Do(ke) && (vn = ke.ref, xi(ke, St));
        for (Ot in ke)
          Fr.call(ke, Ot) && !tn.hasOwnProperty(Ot) && (Tt[Ot] = ke[Ot]);
        if (X && X.defaultProps) {
          var Kt = X.defaultProps;
          for (Ot in Kt)
            Tt[Ot] === void 0 && (Tt[Ot] = Kt[Ot]);
        }
        if (Et || vn) {
          var Xt = typeof X == "function" ? X.displayName || X.name || "Unknown" : X;
          Et && Fo(Tt, Xt), vn && Lr(Tt, Xt);
        }
        return No(X, Et, vn, St, at, tr.current, Tt);
      }
    }
    var Nn = k.ReactCurrentOwner, Er = k.ReactDebugCurrentFrame;
    function Yn(X) {
      if (X) {
        var ke = X._owner, Ve = Fn(X.type, X._source, ke ? ke.type : null);
        Er.setExtraStackFrame(Ve);
      } else
        Er.setExtraStackFrame(null);
    }
    var Bt;
    Bt = !1;
    function Br(X) {
      return typeof X == "object" && X !== null && X.$$typeof === n;
    }
    function Mo() {
      {
        if (Nn.current) {
          var X = ge(Nn.current.type);
          if (X)
            return `

Check the render method of \`` + X + "`.";
        }
        return "";
      }
    }
    function Lo(X) {
      {
        if (X !== void 0) {
          var ke = X.fileName.replace(/^.*[\\\/]/, ""), Ve = X.lineNumber;
          return `

Check your code at ` + ke + ":" + Ve + ".";
        }
        return "";
      }
    }
    var Ar = {};
    function Bo(X) {
      {
        var ke = Mo();
        if (!ke) {
          var Ve = typeof X == "string" ? X : X.displayName || X.name;
          Ve && (ke = `

Check the top-level render call using <` + Ve + ">.");
        }
        return ke;
      }
    }
    function Vr(X, ke) {
      {
        if (!X._store || X._store.validated || X.key != null)
          return;
        X._store.validated = !0;
        var Ve = Bo(ke);
        if (Ar[Ve])
          return;
        Ar[Ve] = !0;
        var at = "";
        X && X._owner && X._owner !== Nn.current && (at = " It was passed a child from " + ge(X._owner.type) + "."), Yn(X), z('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Ve, at), Yn(null);
      }
    }
    function ln(X, ke) {
      {
        if (typeof X != "object")
          return;
        if (Rn(X))
          for (var Ve = 0; Ve < X.length; Ve++) {
            var at = X[Ve];
            Br(at) && Vr(at, ke);
          }
        else if (Br(X))
          X._store && (X._store.validated = !0);
        else if (X) {
          var St = D(X);
          if (typeof St == "function" && St !== X.entries)
            for (var Ot = St.call(X), Tt; !(Tt = Ot.next()).done; )
              Br(Tt.value) && Vr(Tt.value, ke);
        }
      }
    }
    function Ti(X) {
      {
        var ke = X.type;
        if (ke == null || typeof ke == "string")
          return;
        var Ve;
        if (typeof ke == "function")
          Ve = ke.propTypes;
        else if (typeof ke == "object" && (ke.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ke.$$typeof === A))
          Ve = ke.propTypes;
        else
          return;
        if (Ve) {
          var at = ge(ke);
          Cr(Ve, X.props, "prop", at, X);
        } else if (ke.PropTypes !== void 0 && !Bt) {
          Bt = !0;
          var St = ge(ke);
          z("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", St || "Unknown");
        }
        typeof ke.getDefaultProps == "function" && !ke.getDefaultProps.isReactClassApproved && z("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vo(X) {
      {
        for (var ke = Object.keys(X.props), Ve = 0; Ve < ke.length; Ve++) {
          var at = ke[Ve];
          if (at !== "children" && at !== "key") {
            Yn(X), z("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", at), Yn(null);
            break;
          }
        }
        X.ref !== null && (Yn(X), z("Invalid attribute `ref` supplied to `React.Fragment`."), Yn(null));
      }
    }
    function Pi(X, ke, Ve, at, St, Ot) {
      {
        var Tt = Se(X);
        if (!Tt) {
          var Et = "";
          (X === void 0 || typeof X == "object" && X !== null && Object.keys(X).length === 0) && (Et += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var vn = Lo(St);
          vn ? Et += vn : Et += Mo();
          var Kt;
          X === null ? Kt = "null" : Rn(X) ? Kt = "array" : X !== void 0 && X.$$typeof === n ? (Kt = "<" + (ge(X.type) || "Unknown") + " />", Et = " Did you accidentally export a JSX literal instead of a component?") : Kt = typeof X, z("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Kt, Et);
        }
        var Xt = aa(X, ke, Ve, St, Ot);
        if (Xt == null)
          return Xt;
        if (Tt) {
          var pn = ke.children;
          if (pn !== void 0)
            if (at)
              if (Rn(pn)) {
                for (var Un = 0; Un < pn.length; Un++)
                  ln(pn[Un], X);
                Object.freeze && Object.freeze(pn);
              } else
                z("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ln(pn, X);
        }
        return X === r ? Vo(Xt) : Ti(Xt), Xt;
      }
    }
    function cn(X, ke, Ve) {
      return Pi(X, ke, Ve, !0);
    }
    function ki(X, ke, Ve) {
      return Pi(X, ke, Ve, !1);
    }
    var Ba = ki, Va = cn;
    dg.Fragment = r, dg.jsx = Ba, dg.jsxs = Va;
  }()), dg;
}
process.env.NODE_ENV === "production" ? Ov.exports = zO() : Ov.exports = ZO();
var I = Ov.exports, Np = (e, n = []) => ({
  parts: (...t) => {
    if (KO(n))
      return Np(e, t);
    throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
  },
  extendWith: (...t) => Np(e, [...n, ...t]),
  rename: (t) => Np(t, n),
  keys: () => n,
  build: () => [...new Set(n)].reduce(
    (t, r) => Object.assign(t, {
      [r]: {
        selector: [
          `&[data-scope="${qd(e)}"][data-part="${qd(r)}"]`,
          `& [data-scope="${qd(e)}"][data-part="${qd(r)}"]`
        ].join(", "),
        attrs: { "data-scope": qd(e), "data-part": qd(r) }
      }
    }),
    {}
  )
}), qd = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), KO = (e) => e.length === 0, se = (e) => e ? "" : void 0, Zr = (e) => e ? "true" : void 0, FA = 2147483647, ps = (e) => typeof e == "object" && (e == null ? void 0 : e.nodeType) === Node.ELEMENT_NODE && typeof (e == null ? void 0 : e.nodeName) == "string", NA = (e) => e.nodeType === Node.DOCUMENT_NODE, XO = (e) => e != null && e === e.window, JO = (e) => e.nodeType !== void 0, QO = (e) => e && JO(e) && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in e;
function ol(e, n) {
  return !e || !n || !ps(e) || !ps(n) ? !1 : e === n || e.contains(n);
}
function Df(e) {
  return NA(e) ? e : XO(e) ? e.document : (e == null ? void 0 : e.ownerDocument) ?? document;
}
function cl(e) {
  var n;
  return QO(e) ? cl(e.host) : NA(e) ? e.defaultView ?? window : ps(e) ? ((n = e.ownerDocument) == null ? void 0 : n.defaultView) ?? window : window;
}
var Oh = () => typeof document < "u";
function qO() {
  const e = navigator.userAgentData;
  return (e == null ? void 0 : e.platform) ?? navigator.platform;
}
var db = (e) => Oh() && e.test(qO()), _O = (e) => Oh() && e.test(navigator.userAgent), $O = (e) => Oh() && e.test(navigator.vendor), MA = () => db(/^Mac/), fb = () => LA() && $O(/apple/i), eD = () => _O(/firefox\//i), LA = () => db(/mac|iphone|ipad|ipod/i), gb = () => db(/iP(hone|ad|od)|iOS/);
function tD(e) {
  var n, t, r;
  return ((n = e.composedPath) == null ? void 0 : n.call(e)) ?? ((r = (t = e.nativeEvent) == null ? void 0 : t.composedPath) == null ? void 0 : r.call(t));
}
function ou(e) {
  const n = tD(e);
  return (n == null ? void 0 : n[0]) ?? e.target;
}
var pb = (e) => ol(e.currentTarget, ou(e));
function Dv(e) {
  const n = e.currentTarget;
  if (!n)
    return !1;
  const t = LA();
  if (t && !e.metaKey || !t && !e.ctrlKey)
    return !1;
  const r = n.localName;
  return r === "a" || r === "button" && n.type === "submit" || r === "input" && n.type === "submit";
}
function Fv(e) {
  const n = e.currentTarget;
  if (!n)
    return !1;
  const t = n.localName;
  return e.altKey ? t === "a" || t === "button" && n.type === "submit" || t === "input" && n.type === "submit" : !1;
}
function hb(e) {
  var n;
  return ((n = e.nativeEvent) == null ? void 0 : n.isComposing) ?? e.isComposing;
}
var mb = (e) => e.id;
function nD(e, n, t = mb) {
  return e.find((r) => t(r) === n);
}
function vb(e, n, t = mb) {
  const r = nD(e, n, t);
  return r ? e.indexOf(r) : -1;
}
function BA(e, n, t = !0) {
  let r = vb(e, n);
  return r = t ? (r + 1) % e.length : Math.min(r + 1, e.length - 1), e[r];
}
function VA(e, n, t = !0) {
  let r = vb(e, n);
  return r === -1 ? t ? e[e.length - 1] : null : (r = t ? (r - 1 + e.length) % e.length : Math.max(0, r - 1), e[r]);
}
var rD = (e) => e.split("").map((n) => {
  const t = n.charCodeAt(0);
  return t > 0 && t < 128 ? n : t >= 128 && t <= 255 ? `/x${t.toString(16)}`.replace("/", "\\") : "";
}).join("").trim(), oD = (e) => rD(e.dataset.valuetext ?? e.textContent ?? ""), iD = (e, n) => e.trim().toLowerCase().startsWith(n.toLowerCase()), aD = (e, n) => e.map((t, r) => e[(Math.max(n, 0) + r) % e.length]);
function sD(e, n, t, r = mb) {
  const o = t ? vb(e, t, r) : -1;
  let a = t ? aD(e, o) : e;
  return n.length === 1 && (a = a.filter((u) => r(u) !== t)), a.find((u) => iD(oD(u), n));
}
function lD(e, n) {
  const { state: t, activeId: r, key: o, timeout: a = 350, itemToId: l } = n, u = t.keysSoFar + o, p = u.length > 1 && Array.from(u).every((j) => j === u[0]) ? u[0] : u;
  let y = e.slice();
  const A = sD(y, p, r, l);
  function w() {
    clearTimeout(t.timer), t.timer = -1;
  }
  function F(j) {
    t.keysSoFar = j, w(), j !== "" && (t.timer = +setTimeout(() => {
      F(""), w();
    }, a));
  }
  return F(u), A;
}
var Lg = /* @__PURE__ */ Object.assign(lD, {
  defaultOptions: { keysSoFar: "", timer: -1 },
  isValidEvent: cD
});
function cD(e) {
  return e.key.length === 1 && !e.ctrlKey && !e.metaKey;
}
var wm = /* @__PURE__ */ new WeakMap();
function uD(e) {
  return wm.has(e) || wm.set(e, cl(e).getComputedStyle(e)), wm.get(e);
}
var jA = (e) => typeof e == "object" && e !== null && e.nodeType === 1, dD = (e) => jA(e) && e.tagName === "IFRAME";
function fD(e) {
  return jA(e) ? e.offsetWidth > 0 || e.offsetHeight > 0 || e.getClientRects().length > 0 : !1;
}
function gD(e) {
  return parseInt(e.getAttribute("tabindex") || "0", 10) < 0;
}
var UA = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false']), details > summary:first-of-type";
function bb(e) {
  return !e || e.closest("[inert]") ? !1 : e.matches(UA) && fD(e);
}
function yb(e, n) {
  if (!e)
    return [];
  const t = Array.from(e.querySelectorAll(UA)), r = t.filter(O0);
  return n && O0(e) && r.unshift(e), r.forEach((o, a) => {
    if (dD(o) && o.contentDocument) {
      const l = o.contentDocument.body, u = yb(l);
      r.splice(a, 1, ...u);
    }
  }), !r.length && n ? t : r;
}
function O0(e) {
  return e != null && e.tabIndex > 0 ? !0 : bb(e) && !gD(e);
}
function WA(e, n) {
  const [t] = yb(e, n);
  return t || null;
}
function pD(e, n) {
  const t = yb(e, n), r = t[0] || null, o = t[t.length - 1] || null;
  return [r, o];
}
function Cb(e) {
  const { root: n, getInitialEl: t, enabled: r = !0 } = e;
  if (!r)
    return n || void 0;
  let o = null;
  return o || (o = typeof t == "function" ? t() : t), o || (o = n == null ? void 0 : n.querySelector("[data-autofocus],[autofocus]")), o || (o = WA(n)), o || n || void 0;
}
function HA(e) {
  const n = e.currentTarget;
  if (!n)
    return !1;
  const [t, r] = pD(n), o = n.ownerDocument || document;
  return !(o.activeElement === t && e.shiftKey || o.activeElement === r && !e.shiftKey || !t && !r);
}
function Eb(e) {
  if (e == null || !ps(e))
    return !1;
  try {
    const n = cl(e);
    return e instanceof n.HTMLInputElement && e.selectionStart != null || /(textarea|select)/.test(e.localName) || e.isContentEditable;
  } catch {
    return !1;
  }
}
var hD = /auto|scroll|overlay|hidden|clip/;
function mD(e) {
  const n = cl(e), { overflow: t, overflowX: r, overflowY: o, display: a } = n.getComputedStyle(e);
  return hD.test(t + o + r) && !["inline", "contents"].includes(a);
}
function Ab(e) {
  const n = /* @__PURE__ */ new Set();
  function t(r) {
    const o = globalThis.requestAnimationFrame(r);
    n.add(() => globalThis.cancelAnimationFrame(o));
  }
  return t(() => t(e)), function() {
    n.forEach((o) => o());
  };
}
function Ct(e) {
  const n = globalThis.requestAnimationFrame(e);
  return () => {
    globalThis.cancelAnimationFrame(n);
  };
}
function vD(e, n) {
  if (!e)
    return;
  const { attributes: t, callback: r } = n, o = e.ownerDocument.defaultView || window, a = new o.MutationObserver((l) => {
    for (const u of l)
      u.type === "attributes" && u.attributeName && t.includes(u.attributeName) && r(u);
  });
  return a.observe(e, { attributes: !0, attributeFilter: t }), () => a.disconnect();
}
function Dh(e, n) {
  const { defer: t } = n, r = t ? Ct : (a) => a(), o = [];
  return o.push(
    r(() => {
      const a = typeof e == "function" ? e() : e;
      o.push(vD(a, n));
    })
  ), () => {
    o.forEach((a) => a == null ? void 0 : a());
  };
}
function bD(e, n) {
  const { callback: t } = n;
  if (!e)
    return;
  const r = e.ownerDocument.defaultView || window, o = new r.MutationObserver(t);
  return o.observe(e, { childList: !0, subtree: !0 }), () => o.disconnect();
}
function yD(e, n) {
  const { defer: t } = n, r = t ? Ct : (a) => a(), o = [];
  return o.push(
    r(() => {
      const a = typeof e == "function" ? e() : e;
      o.push(bD(a, n));
    })
  ), () => {
    o.forEach((a) => a == null ? void 0 : a());
  };
}
function $s(e, n) {
  return Array.from((e == null ? void 0 : e.querySelectorAll(n)) ?? []);
}
function Sb(e, n) {
  return (e == null ? void 0 : e.querySelector(n)) ?? null;
}
function so(e) {
  const n = {
    getRootNode: (t) => {
      var r;
      return ((r = t.getRootNode) == null ? void 0 : r.call(t)) ?? document;
    },
    getDoc: (t) => Df(n.getRootNode(t)),
    getWin: (t) => n.getDoc(t).defaultView ?? window,
    getActiveElement: (t) => n.getDoc(t).activeElement,
    isActiveElement: (t, r) => r === n.getActiveElement(t),
    getById: (t, r) => n.getRootNode(t).getElementById(r),
    setValue: (t, r) => {
      if (t == null || r == null)
        return;
      const o = r.toString();
      t.value !== o && (t.value = r.toString());
    }
  };
  return { ...n, ...e };
}
function CD(e) {
  return e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth;
}
function wb(e, n) {
  const { rootEl: t, ...r } = n || {};
  !e || !t || !mD(t) || !CD(t) || e.scrollIntoView(r);
}
var Im = /* @__PURE__ */ new WeakMap();
function ED(e, n, t) {
  Im.has(e) || Im.set(e, /* @__PURE__ */ new Map());
  const r = Im.get(e), o = r.get(n);
  if (!o)
    return r.set(n, t()), () => {
      var u;
      (u = r.get(n)) == null || u(), r.delete(n);
    };
  const a = t(), l = () => {
    a(), o(), r.delete(n);
  };
  return r.set(n, l), () => {
    r.get(n) === l && (a(), r.set(n, o));
  };
}
function AD(e, n) {
  return e ? ED(e, "style", () => {
    const r = e.style.cssText;
    return Object.assign(e.style, n), () => {
      e.style.cssText = r;
    };
  }) : () => {
  };
}
var Ff = {
  border: "0",
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: "0",
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}, SD = 1e3 / 60;
function wD(e, n) {
  const t = e();
  if (ps(t) && t.isConnected)
    return n(t), () => {
    };
  {
    const r = setInterval(() => {
      const o = e();
      ps(o) && o.isConnected && (n(o), clearInterval(r));
    }, SD);
    return () => clearInterval(r);
  }
}
function ID(e, n) {
  const t = [];
  return e == null || e.forEach((r) => {
    const o = wD(r, n);
    t.push(o);
  }), () => {
    t.forEach((r) => r());
  };
}
var Sf = "default", Nv = "", Mp = /* @__PURE__ */ new WeakMap();
function xD(e = {}) {
  const { target: n, doc: t } = e, r = t ?? document, o = r.documentElement;
  return gb() ? (Sf === "default" && (Nv = o.style.webkitUserSelect, o.style.webkitUserSelect = "none"), Sf = "disabled") : n && (Mp.set(n, n.style.userSelect), n.style.userSelect = "none"), () => GA({ target: n, doc: r });
}
function GA(e = {}) {
  const { target: n, doc: t } = e, o = (t ?? document).documentElement;
  if (gb()) {
    if (Sf !== "disabled")
      return;
    Sf = "restoring", setTimeout(() => {
      Ab(() => {
        Sf === "restoring" && (o.style.webkitUserSelect === "none" && (o.style.webkitUserSelect = Nv || ""), Nv = "", Sf = "default");
      });
    }, 300);
  } else if (n && Mp.has(n)) {
    const a = Mp.get(n);
    n.style.userSelect === "none" && (n.style.userSelect = a ?? ""), n.getAttribute("style") === "" && n.removeAttribute("style"), Mp.delete(n);
  }
}
function Ib(e = {}) {
  const { defer: n, target: t, ...r } = e, o = n ? Ct : (l) => l(), a = [];
  return a.push(
    o(() => {
      const l = typeof t == "function" ? t() : t;
      a.push(xD({ ...r, target: l }));
    })
  ), () => {
    a.forEach((l) => l == null ? void 0 : l());
  };
}
var Dn = (e, n, t, r) => {
  const o = typeof e == "function" ? e() : e;
  return o == null || o.addEventListener(n, t, r), () => {
    o == null || o.removeEventListener(n, t, r);
  };
};
function TD(e) {
  return e.key.length === 1 && !e.ctrlKey && !e.metaKey;
}
var rc = (e) => e.button === 0, xb = (e) => e.button === 2 || MA() && e.ctrlKey && e.button === 0, Mv = (e) => e.ctrlKey || e.altKey || e.metaKey;
function PD(e, n, t) {
  const o = ((l) => {
    const u = requestAnimationFrame(l);
    return () => cancelAnimationFrame(u);
  })(() => {
    e.removeEventListener(n, a, !0), t();
  }), a = () => {
    o(), t();
  };
  return e.addEventListener(n, a, { once: !0, capture: !0 }), o;
}
function kD(e) {
  return (e == null ? void 0 : e.matches("a[href]")) ?? !1;
}
function Lv(e) {
  if (!kD(e))
    return;
  const n = () => e.click();
  eD() ? PD(e, "keyup", n) : queueMicrotask(n);
}
function D0(e, n, t) {
  if (!e)
    return;
  const r = e.ownerDocument.defaultView || window, o = new r.CustomEvent(n, t);
  return e.dispatchEvent(o);
}
var RD = {
  Up: "ArrowUp",
  Down: "ArrowDown",
  Esc: "Escape",
  " ": "Space",
  ",": "Comma",
  Left: "ArrowLeft",
  Right: "ArrowRight"
}, F0 = {
  ArrowLeft: "ArrowRight",
  ArrowRight: "ArrowLeft"
};
function il(e, n = {}) {
  const { dir: t = "ltr", orientation: r = "horizontal" } = n;
  let { key: o } = e;
  return o = RD[o] ?? o, t === "rtl" && r === "horizontal" && o in F0 && (o = F0[o]), o;
}
function OD(e, n = "client") {
  const t = e.touches[0] || e.changedTouches[0];
  return { x: t[`${n}X`], y: t[`${n}Y`] };
}
function DD(e, n = "client") {
  return { x: e[`${n}X`], y: e[`${n}Y`] };
}
var FD = (e) => "touches" in e && e.touches.length > 0;
function nu(e, n = "client") {
  return FD(e) ? OD(e, n) : DD(e, n);
}
var ND = /* @__PURE__ */ new Set(["PageUp", "PageDown"]), MD = /* @__PURE__ */ new Set(["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"]);
function Bv(e) {
  return e.ctrlKey || e.metaKey ? 0.1 : ND.has(e.key) || e.shiftKey && MD.has(e.key) ? 10 : 1;
}
function LD(e) {
  return e.nativeEvent ?? e;
}
function N0(e) {
  return Math.max(0, Math.min(1, e));
}
function M0(e, n) {
  const { left: t, top: r, width: o, height: a } = n.getBoundingClientRect(), l = { x: e.x - t, y: e.y - r }, u = { x: N0(l.x / o), y: N0(l.y / a) };
  function f(p = {}) {
    const { dir: y = "ltr", orientation: A = "horizontal", inverted: w } = p, F = typeof w == "object" ? w.x : w, j = typeof w == "object" ? w.y : w;
    return A === "horizontal" ? y === "rtl" || F ? 1 - u.x : u.x : j ? 1 - u.y : u.y;
  }
  return { offset: l, percent: u, getPercentValue: f };
}
function BD(e, n) {
  const t = e.body, r = "pointerLockElement" in e || "mozPointerLockElement" in e, o = () => !!e.pointerLockElement;
  function a() {
    n == null || n(o());
  }
  function l(f) {
    o() && (n == null || n(!1)), console.error("PointerLock error occured:", f), e.exitPointerLock();
  }
  if (!r)
    return;
  try {
    t.requestPointerLock();
  } catch {
  }
  const u = [
    Dn(e, "pointerlockchange", a, !1),
    Dn(e, "pointerlockerror", l, !1)
  ];
  return () => {
    u.forEach((f) => f()), e.exitPointerLock();
  };
}
var Lp = (...e) => (n) => e.reduce((t, r) => r(t), n), cp = () => {
}, VD = (e) => !(e.metaKey || !MA() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
function YA(e, n) {
  if (!e)
    return;
  const { onFocus: t, onBlur: r } = n, o = cl(e);
  let a = !1;
  const l = (p) => {
    let y = !1;
    try {
      y = e.matches(":focus-visible");
    } catch {
      y = !0;
    }
    y && (a = !0, t == null || t(p));
  }, u = (p) => {
    a && (a = !1, r == null || r(p));
  }, f = (p) => {
    if (!e.matches(":focus") || !VD(p))
      return;
    a = !0;
    const y = new o.FocusEvent("focus");
    t == null || t(y);
  };
  return Lp(
    Dn(e, "focusin", l),
    Dn(e, "focusout", u),
    Dn(e, "keydown", f, !0)
  );
}
function jD(e, n) {
  const { onPointerMove: t, onPointerUp: r } = n, o = [], l = [
    Dn(e, "pointermove", (u) => {
      const f = nu(u);
      o.push({ ...f, timestamp: performance.now() });
      const p = Math.sqrt(f.x ** 2 + f.y ** 2), y = u.pointerType === "touch" ? 10 : 5;
      if (!(p < y)) {
        if (u.pointerType === "mouse" && u.button === 0) {
          r();
          return;
        }
        t({ point: f, event: u, velocity: GD(o, 0.1) });
      }
    }, !1),
    Dn(e, "pointerup", r, !1),
    Dn(e, "pointercancel", r, !1),
    Dn(e, "contextmenu", r, !1),
    Ib({ doc: e })
  ];
  return () => {
    l.forEach((u) => u()), o.length = 0;
  };
}
function UD(e) {
  return e[e.length - 1];
}
function WD(e) {
  return e * 1e3;
}
function HD(e) {
  return e / 1e3;
}
function GD(e, n) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let t = e.length - 1, r = null;
  const o = UD(e);
  for (; t >= 0 && (r = e[t], !(o.timestamp - r.timestamp > WD(n))); )
    t--;
  if (!r)
    return { x: 0, y: 0 };
  const a = HD(o.timestamp - r.timestamp);
  if (a === 0)
    return { x: 0, y: 0 };
  const l = {
    x: (o.x - r.x) / a,
    y: (o.y - r.y) / a
  };
  return l.x === 1 / 0 && (l.x = 0), l.y === 1 / 0 && (l.y = 0), {
    x: Math.abs(l.x),
    y: Math.abs(l.y)
  };
}
function zA(e) {
  const {
    pointerNode: n,
    keyboardNode: t = n,
    onPress: r,
    onPressStart: o,
    onPressEnd: a,
    isValidKey: l = (q) => q.key === "Enter"
  } = e;
  if (!n)
    return cp;
  const u = cl(n), f = Df(n);
  let p = cp, y = cp, A = cp;
  const w = (q) => ({
    point: nu(q),
    event: q
  });
  function F(q) {
    o == null || o(w(q));
  }
  function j(q) {
    a == null || a(w(q));
  }
  const D = Dn(n, "pointerdown", (q) => {
    y();
    const ee = Dn(u, "pointerup", (Oe) => {
      const He = ou(Oe);
      ol(n, He) ? r == null || r(w(Oe)) : a == null || a(w(Oe));
    }, { passive: !r }), Fe = Dn(u, "pointercancel", j, { passive: !a });
    y = Lp(ee, Fe), f.activeElement === t && q.pointerType === "mouse" && q.preventDefault(), F(q);
  }, { passive: !o }), k = Dn(t, "focus", z);
  p = Lp(D, k);
  function z() {
    const q = (Oe) => {
      if (!l(Oe))
        return;
      const He = (Se) => {
        if (!l(Se))
          return;
        const we = new u.PointerEvent("pointerup"), ae = w(we);
        r == null || r(ae), a == null || a(ae);
      };
      y(), y = Dn(t, "keyup", He);
      const Re = new u.PointerEvent("pointerdown");
      F(Re);
    }, Ce = () => {
      const Oe = new u.PointerEvent("pointercancel");
      j(Oe);
    }, ee = Dn(t, "keydown", q), Fe = Dn(t, "blur", Ce);
    A = Lp(ee, Fe);
  }
  return function() {
    p(), y(), A();
  };
}
var ZA = (e) => e[0], Tb = (e) => e[e.length - 1], YD = (e, n) => e.indexOf(n) !== -1, KA = (e, ...n) => e.concat(n), XA = (e, n) => e.filter((t) => t !== n), JA = (e, n) => YD(e, n) ? XA(e, n) : KA(e, n);
function QA(e, n, t = {}) {
  const { step: r = 1, loop: o = !0 } = t, a = n + r, l = e.length, u = l - 1;
  return n === -1 ? r > 0 ? 0 : u : a < 0 ? o ? u : 0 : a >= l ? o ? 0 : n > l ? l : n : a;
}
function zD(e, n, t = {}) {
  const { step: r = 1, loop: o = !0 } = t;
  return QA(e, n, { step: -r, loop: o });
}
var L0 = (e, n) => {
  const t = [];
  return e.reduce((r, o, a) => {
    var l;
    return a % n === 0 ? r.push([o]) : (l = Tb(r)) == null || l.push(o), r;
  }, t);
}, B0 = (e) => (e == null ? void 0 : e.constructor.name) === "Array", vr = (e, n) => {
  if (Object.is(e, n))
    return !0;
  if (e == null && n != null || e != null && n == null)
    return !1;
  if (typeof (e == null ? void 0 : e.isEqual) == "function" && typeof (n == null ? void 0 : n.isEqual) == "function")
    return e.isEqual(n);
  if (typeof e == "function" && typeof n == "function")
    return e.toString() === n.toString();
  if (B0(e) && B0(n))
    return Array.from(e).toString() === Array.from(n).toString();
  if (typeof e != "object" || typeof n != "object")
    return !1;
  const t = Object.keys(n ?? /* @__PURE__ */ Object.create(null)), r = t.length;
  for (let o = 0; o < r; o++)
    if (!Reflect.has(e, t[o]))
      return !1;
  for (let o = 0; o < r; o++) {
    const a = t[o];
    if (!vr(e[a], n[a]))
      return !1;
  }
  return !0;
}, Bp = (e, ...n) => (typeof e == "function" ? e(...n) : e) ?? void 0, ZD = (e) => e, KD = () => {
}, Vv = (...e) => (...n) => {
  e.forEach(function(t) {
    t == null || t(...n);
  });
}, XD = /* @__PURE__ */ (() => {
  let e = 0;
  return () => (e++, e.toString(36));
})();
function iu(e, n, ...t) {
  var o;
  if (e in n) {
    const a = n[e];
    return typeof a == "function" ? a(...t) : a;
  }
  const r = new Error(`No matching key: ${JSON.stringify(e)} in ${JSON.stringify(Object.keys(n))}`);
  throw (o = Error.captureStackTrace) == null || o.call(Error, r, iu), r;
}
var qA = (e, n) => {
  var t;
  try {
    return e();
  } catch (r) {
    return r instanceof Error && ((t = Error.captureStackTrace) == null || t.call(Error, r, qA)), n == null ? void 0 : n();
  }
}, _A = (e) => Array.isArray(e), JD = (e) => e === !0 || e === !1, $A = (e) => typeof e == "number" && !Number.isNaN(e), QD = (e) => typeof e == "string", eS = (e) => typeof e == "function", qD = (e) => e == null;
function br(e) {
  if (!_D(e) || e === void 0)
    return e;
  const n = Reflect.ownKeys(e).filter((r) => typeof r == "string"), t = {};
  for (const r of n) {
    const o = e[r];
    o !== void 0 && (t[r] = br(o));
  }
  return t;
}
var _D = (e) => e && typeof e == "object" && e.constructor === Object;
function $D(e, n) {
  const t = {}, r = {}, o = new Set(n);
  for (const a in e)
    o.has(a) ? r[a] = e[a] : t[a] = e[a];
  return [r, t];
}
var eF = (e) => function(t) {
  return $D(t, e);
};
function Fh(...e) {
  const n = e.length === 1 ? e[0] : e[1];
  (e.length === 2 ? e[0] : !0) && process.env.NODE_ENV !== "production" && console.warn(n);
}
const tF = Symbol(), Pb = Symbol(), xg = "a", tS = "f", V0 = "p", nS = "c", rS = "t", xm = "n", Tm = "g", oS = "h", Vp = "w", iS = "o", aS = "k";
let nF = (e, n) => new Proxy(e, n);
const jv = Object.getPrototypeOf, Uv = /* @__PURE__ */ new WeakMap(), sS = (e) => e && (Uv.has(e) ? Uv.get(e) : jv(e) === Object.prototype || jv(e) === Array.prototype), j0 = (e) => typeof e == "object" && e !== null, rF = (e) => Object.values(Object.getOwnPropertyDescriptors(e)).some((n) => !n.configurable && !n.writable), oF = (e) => {
  if (Array.isArray(e))
    return Array.from(e);
  const n = Object.getOwnPropertyDescriptors(e);
  return Object.values(n).forEach((t) => {
    t.configurable = !0;
  }), Object.create(jv(e), n);
}, iF = (e, n) => {
  const t = {
    [tS]: n
  };
  let r = !1;
  const o = (u, f) => {
    if (!r) {
      let p = t[xg].get(e);
      if (p || (p = {}, t[xg].set(e, p)), u === Vp)
        p[Vp] = !0;
      else {
        let y = p[u];
        y || (y = /* @__PURE__ */ new Set(), p[u] = y), y.add(f);
      }
    }
  }, a = () => {
    r = !0, t[xg].delete(e);
  }, l = {
    get(u, f) {
      return f === Pb ? e : (o(aS, f), cS(Reflect.get(u, f), t[xg], t[nS], t[rS]));
    },
    has(u, f) {
      return f === tF ? (a(), !0) : (o(oS, f), Reflect.has(u, f));
    },
    getOwnPropertyDescriptor(u, f) {
      return o(iS, f), Reflect.getOwnPropertyDescriptor(u, f);
    },
    ownKeys(u) {
      return o(Vp), Reflect.ownKeys(u);
    }
  };
  return n && (l.set = l.deleteProperty = () => !1), [l, t];
}, lS = (e) => (
  // unwrap proxy
  e[Pb] || // otherwise
  e
), cS = (e, n, t, r) => {
  if (!sS(e))
    return e;
  let o = r && r.get(e);
  if (!o) {
    const f = lS(e);
    rF(f) ? o = [f, oF(f)] : o = [f], r == null || r.set(e, o);
  }
  const [a, l] = o;
  let u = t && t.get(a);
  return (!u || u[1][tS] !== !!l) && (u = iF(a, !!l), u[1][V0] = nF(l || a, u[0]), t && t.set(a, u)), u[1][xg] = n, u[1][nS] = t, u[1][rS] = r, u[1][V0];
}, aF = (e, n) => {
  const t = Reflect.ownKeys(e), r = Reflect.ownKeys(n);
  return t.length !== r.length || t.some((o, a) => o !== r[a]);
}, uS = (e, n, t, r, o = Object.is) => {
  if (o(e, n))
    return !1;
  if (!j0(e) || !j0(n))
    return !0;
  const a = t.get(lS(e));
  if (!a)
    return !0;
  if (r) {
    const u = r.get(e);
    if (u && u[xm] === n)
      return u[Tm];
    r.set(e, {
      [xm]: n,
      [Tm]: !1
    });
  }
  let l = null;
  try {
    for (const u of a[oS] || [])
      if (l = Reflect.has(e, u) !== Reflect.has(n, u), l)
        return l;
    if (a[Vp] === !0) {
      if (l = aF(e, n), l)
        return l;
    } else
      for (const u of a[iS] || []) {
        const f = !!Reflect.getOwnPropertyDescriptor(e, u), p = !!Reflect.getOwnPropertyDescriptor(n, u);
        if (l = f !== p, l)
          return l;
      }
    for (const u of a[aS] || [])
      if (l = uS(e[u], n[u], t, r, o), l)
        return l;
    return l === null && (l = !0), l;
  } finally {
    r && r.set(e, {
      [xm]: n,
      [Tm]: l
    });
  }
}, sF = (e) => sS(e) && e[Pb] || null, U0 = (e, n = !0) => {
  Uv.set(e, n);
};
function lF() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
}
function kb(e, n) {
  const t = lF();
  return t ? (t[e] || (t[e] = n()), t[e]) : n();
}
var lh = process.env.NODE_ENV !== "production", Pm = (e) => typeof e == "object" && e !== null, fd = kb("__zag__proxyStateMap", () => /* @__PURE__ */ new WeakMap()), Tg = kb("__zag__refSet", () => /* @__PURE__ */ new WeakSet()), cF = (e = Object.is, n = (p, y) => new Proxy(p, y), t = (p) => Pm(p) && !Tg.has(p) && (Array.isArray(p) || !(Symbol.iterator in p)) && !(p instanceof WeakMap) && !(p instanceof WeakSet) && !(p instanceof Error) && !(p instanceof Number) && !(p instanceof Date) && !(p instanceof String) && !(p instanceof RegExp) && !(p instanceof ArrayBuffer), r = (p) => {
  switch (p.status) {
    case "fulfilled":
      return p.value;
    case "rejected":
      throw p.reason;
    default:
      throw p;
  }
}, o = /* @__PURE__ */ new WeakMap(), a = (p, y, A = r) => {
  const w = o.get(p);
  if ((w == null ? void 0 : w[0]) === y)
    return w[1];
  const F = Array.isArray(p) ? [] : Object.create(Object.getPrototypeOf(p));
  return U0(F, !0), o.set(p, [y, F]), Reflect.ownKeys(p).forEach((j) => {
    const N = Reflect.get(p, j);
    Tg.has(N) ? (U0(N, !1), F[j] = N) : N instanceof Promise ? Object.defineProperty(F, j, {
      get() {
        return A(N);
      }
    }) : fd.has(N) ? F[j] = eu(N, A) : F[j] = N;
  }), Object.freeze(F);
}, l = /* @__PURE__ */ new WeakMap(), u = [1, 1], f = (p) => {
  if (!Pm(p))
    throw new Error("object required");
  const y = l.get(p);
  if (y)
    return y;
  let A = u[0];
  const w = /* @__PURE__ */ new Set(), F = (Re, Se = ++u[0]) => {
    A !== Se && (A = Se, w.forEach((we) => we(Re, Se)));
  };
  let j = u[1];
  const N = (Re = ++u[1]) => (j !== Re && !w.size && (j = Re, k.forEach(([Se]) => {
    const we = Se[1](Re);
    we > A && (A = we);
  })), A), D = (Re) => (Se, we) => {
    const ae = [...Se];
    ae[1] = [Re, ...ae[1]], F(ae, we);
  }, k = /* @__PURE__ */ new Map(), z = (Re, Se) => {
    if (lh && k.has(Re))
      throw new Error("prop listener already exists");
    if (w.size) {
      const we = Se[3](D(Re));
      k.set(Re, [Se, we]);
    } else
      k.set(Re, [Se]);
  }, q = (Re) => {
    var we;
    const Se = k.get(Re);
    Se && (k.delete(Re), (we = Se[1]) == null || we.call(Se));
  }, Ce = (Re) => (w.add(Re), w.size === 1 && k.forEach(([we, ae], ge) => {
    if (lh && ae)
      throw new Error("remove already exists");
    const Ie = we[3](D(ge));
    k.set(ge, [we, Ie]);
  }), () => {
    w.delete(Re), w.size === 0 && k.forEach(([we, ae], ge) => {
      ae && (ae(), k.set(ge, [we]));
    });
  }), ee = Array.isArray(p) ? [] : Object.create(Object.getPrototypeOf(p)), Oe = n(ee, {
    deleteProperty(Re, Se) {
      const we = Reflect.get(Re, Se);
      q(Se);
      const ae = Reflect.deleteProperty(Re, Se);
      return ae && F(["delete", [Se], we]), ae;
    },
    set(Re, Se, we, ae) {
      var Ke;
      const ge = Reflect.has(Re, Se), Ie = Reflect.get(Re, Se, ae);
      if (ge && (e(Ie, we) || l.has(we) && e(Ie, l.get(we))))
        return !0;
      q(Se), Pm(we) && (we = sF(we) || we);
      let Ye = we;
      if (!((Ke = Object.getOwnPropertyDescriptor(Re, Se)) != null && Ke.set))
        if (we instanceof Promise)
          we.then((ze) => {
            Object.assign(we, { status: "fulfilled", value: ze }), F(["resolve", [Se], ze]);
          }).catch((ze) => {
            Object.assign(we, { status: "rejected", reason: ze }), F(["reject", [Se], ze]);
          });
        else {
          !fd.has(we) && t(we) && (Ye = Rb(we));
          const ze = !Tg.has(Ye) && fd.get(Ye);
          ze && z(Se, ze);
        }
      return Reflect.set(Re, Se, Ye, ae), F(["set", [Se], we, Ie]), !0;
    }
  });
  l.set(p, Oe);
  const He = [ee, N, a, Ce];
  return fd.set(Oe, He), Reflect.ownKeys(p).forEach((Re) => {
    const Se = Object.getOwnPropertyDescriptor(p, Re);
    Se.get || Se.set ? Object.defineProperty(ee, Re, Se) : Oe[Re] = p[Re];
  }), Oe;
}) => [
  // public functions
  f,
  // shared state
  fd,
  Tg,
  // internal things
  e,
  n,
  t,
  r,
  o,
  a,
  l,
  u
], [uF] = cF();
function Rb(e = {}) {
  return uF(e);
}
function ch(e, n, t) {
  const r = fd.get(e);
  lh && !r && console.warn("Please use proxy object");
  let o;
  const a = [], l = r[3];
  let u = !1;
  const p = l((y) => {
    if (a.push(y), t) {
      n(a.splice(0));
      return;
    }
    o || (o = Promise.resolve().then(() => {
      o = void 0, u && n(a.splice(0));
    }));
  });
  return u = !0, () => {
    u = !1, p();
  };
}
function eu(e, n) {
  const t = fd.get(e);
  lh && !t && console.warn("Please use proxy object");
  const [r, o, a] = t;
  return a(r, o(), n);
}
function Hn(e) {
  return Tg.add(e), e;
}
function dF(e, n) {
  Object.keys(n).forEach((o) => {
    if (Object.getOwnPropertyDescriptor(e, o))
      throw new Error("object property already defined");
    const a = n[o], { get: l, set: u } = typeof a == "function" ? { get: a } : a, f = {};
    f.get = () => l(eu(r)), u && (f.set = (p) => u(r, p)), Object.defineProperty(e, o, f);
  });
  const r = Rb(e);
  return r;
}
function W0(e, n, t) {
  typeof t.value == "object" && (t.value = wf(t.value)), !t.enumerable || t.get || t.set || !t.configurable || !t.writable || n === "__proto__" ? Object.defineProperty(e, n, t) : e[n] = t.value;
}
function wf(e) {
  if (typeof e != "object")
    return e;
  var n = 0, t, r, o, a = Object.prototype.toString.call(e);
  if (a === "[object Object]" ? o = Object.create(e.__proto__ || null) : a === "[object Array]" ? o = Array(e.length) : a === "[object Set]" ? (o = /* @__PURE__ */ new Set(), e.forEach(function(l) {
    o.add(wf(l));
  })) : a === "[object Map]" ? (o = /* @__PURE__ */ new Map(), e.forEach(function(l, u) {
    o.set(wf(u), wf(l));
  })) : a === "[object Date]" ? o = /* @__PURE__ */ new Date(+e) : a === "[object RegExp]" ? o = new RegExp(e.source, e.flags) : a === "[object DataView]" ? o = new e.constructor(wf(e.buffer)) : a === "[object ArrayBuffer]" ? o = e.slice(0) : a.slice(-6) === "Array]" && (o = new e.constructor(e)), o) {
    for (r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      W0(o, r[n], Object.getOwnPropertyDescriptor(e, r[n]));
    for (n = 0, r = Object.getOwnPropertyNames(e); n < r.length; n++)
      Object.hasOwnProperty.call(o, t = r[n]) && o[t] === e[t] || W0(o, t, Object.getOwnPropertyDescriptor(e, t));
  }
  return o || e;
}
var fF = Object.defineProperty, gF = (e, n, t) => n in e ? fF(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, ot = (e, n, t) => (gF(e, typeof n != "symbol" ? n + "" : n, t), t);
function pF(e) {
  for (; e.length > 0; )
    e.pop();
  return e;
}
var H0 = (e, ...n) => (typeof e == "function" ? e(...n) : e) ?? void 0, ql = (e) => e, hF = () => {
}, mF = (...e) => (...n) => {
  e.forEach(function(t) {
    t == null || t(...n);
  });
}, G0 = /* @__PURE__ */ (() => {
  let e = 0;
  return () => (e++, e.toString(36));
})(), vF = () => process.env.NODE_ENV !== "production", uh = (e) => Array.isArray(e), kg = (e) => !(e == null || typeof e != "object" || uh(e)), bF = (e) => typeof e == "number" && !Number.isNaN(e), ta = (e) => typeof e == "string", dh = (e) => typeof e == "function", yF = (e, n) => Object.prototype.hasOwnProperty.call(e, n);
function fh(e) {
  if (!CF(e) || e === void 0)
    return e;
  const n = Reflect.ownKeys(e).filter((r) => typeof r == "string"), t = {};
  for (const r of n) {
    const o = e[r];
    o !== void 0 && (t[r] = fh(o));
  }
  return t;
}
var CF = (e) => e && typeof e == "object" && e.constructor === Object;
function km(...e) {
  const n = e.length === 1 ? e[0] : e[1];
  (e.length === 2 ? e[0] : !0) && process.env.NODE_ENV !== "production" && console.warn(n);
}
function jp(...e) {
  const n = e.length === 1 ? e[0] : e[1];
  if ((e.length === 2 ? e[0] : !0) && process.env.NODE_ENV !== "production")
    throw new Error(n);
}
function dS(e, ...n) {
  for (const t of n) {
    const r = fh(t);
    for (const o in r)
      kg(t[o]) ? (e[o] || (e[o] = {}), dS(e[o], t[o])) : e[o] = t[o];
  }
  return e;
}
function Y0(e) {
  return wf(e);
}
function cs(e) {
  return ta(e) ? { type: e } : e;
}
function _c(e) {
  return e ? uh(e) ? e.slice() : [e] : [];
}
function fS(e) {
  return kg(e) && e.predicate != null;
}
var gS = () => !0;
function Nh(e, n, t, r) {
  return (o) => {
    var a;
    return ta(o) ? !!((a = e[o]) != null && a.call(e, n, t, r)) : dh(o) ? o(n, t, r) : o.predicate(e)(n, t, r);
  };
}
function EF(...e) {
  return {
    predicate: (n) => (t, r, o) => e.map(Nh(n, t, r, o)).some(Boolean)
  };
}
function AF(...e) {
  return {
    predicate: (n) => (t, r, o) => e.map(Nh(n, t, r, o)).every(Boolean)
  };
}
function SF(e) {
  return {
    predicate: (n) => (t, r, o) => !Nh(n, t, r, o)(e)
  };
}
function wF(...e) {
  return (n, t, r) => r.state.matches(...e);
}
var Ma = { or: EF, and: AF, not: SF, stateIn: wF };
function IF(e) {
  return {
    predicate: (n) => (t, r, o) => {
      var a;
      return (a = e.find((l) => {
        const u = l.guard ?? gS;
        return Nh(n, t, r, o)(u);
      })) == null ? void 0 : a.actions;
    }
  };
}
function pS(e, n) {
  return e = e ?? gS, (t, r, o) => {
    if (ta(e)) {
      const a = n[e];
      return dh(a) ? a(t, r, o) : a;
    }
    return fS(e) ? e.predicate(n)(t, r, o) : e == null ? void 0 : e(t, r, o);
  };
}
function Rm(e, n) {
  return (t, r, o) => fS(e) ? e.predicate(n)(t, r, o) : e;
}
function xF(e) {
  var a, l;
  const n = e.computed ?? ql({}), t = e.context ?? ql({}), r = e.initial ? (l = (a = e.states) == null ? void 0 : a[e.initial]) == null ? void 0 : l.tags : [], o = Rb({
    value: e.initial ?? "",
    previousValue: "",
    event: ql({}),
    previousEvent: ql({}),
    context: dF(t, n),
    done: !1,
    tags: r ?? [],
    hasTag(u) {
      return this.tags.includes(u);
    },
    matches(...u) {
      return u.includes(this.value);
    },
    can(u) {
      return ql(this).nextEvents.includes(u);
    },
    get nextEvents() {
      var p, y;
      const u = ((y = (p = e.states) == null ? void 0 : p[this.value]) == null ? void 0 : y.on) ?? {}, f = (e == null ? void 0 : e.on) ?? {};
      return Object.keys({ ...u, ...f });
    },
    get changed() {
      return this.event.value === "machine.init" || !this.previousValue ? !1 : this.value !== this.previousValue;
    }
  });
  return ql(o);
}
function fg(e, n) {
  return (t, r) => {
    if (bF(e))
      return e;
    if (dh(e))
      return e(t, r);
    if (ta(e)) {
      const o = Number.parseFloat(e);
      if (!Number.isNaN(o))
        return o;
      if (n) {
        const a = n == null ? void 0 : n[e];
        return jp(
          a == null,
          `[@zag-js/core > determine-delay] Cannot determine delay for \`${e}\`. It doesn't exist in \`options.delays\``
        ), dh(a) ? a(t, r) : a;
      }
    }
  };
}
function TF(e) {
  return ta(e) ? { target: e } : e;
}
function PF(e, n) {
  return (t, r, o) => _c(e).map(TF).find((a) => pS(a.guard, n)(t, r, o) ?? a.target ?? a.actions);
}
var hS = class {
  // Let's get started!
  constructor(e, n) {
    var t, r, o, a, l;
    ot(
      this,
      "status",
      "Not Started"
      /* NotStarted */
    ), ot(this, "state"), ot(this, "initialState"), ot(this, "initialContext"), ot(this, "id"), ot(
      this,
      "type",
      "machine"
      /* Machine */
    ), ot(this, "activityEvents", /* @__PURE__ */ new Map()), ot(this, "delayedEvents", /* @__PURE__ */ new Map()), ot(this, "stateListeners", /* @__PURE__ */ new Set()), ot(this, "doneListeners", /* @__PURE__ */ new Set()), ot(this, "contextWatchers", /* @__PURE__ */ new Set()), ot(this, "removeStateListener", hF), ot(this, "parent"), ot(this, "children", /* @__PURE__ */ new Map()), ot(this, "guardMap"), ot(this, "actionMap"), ot(this, "delayMap"), ot(this, "activityMap"), ot(this, "sync"), ot(this, "options"), ot(this, "config"), ot(this, "_created", () => {
      var f;
      const u = cs(
        "machine.created"
        /* Created */
      );
      this.executeActions((f = this.config) == null ? void 0 : f.created, u);
    }), ot(this, "start", (u) => {
      if (this.state.value = "", this.state.tags = [], this.status === "Running")
        return this;
      this.status = "Running", this.removeStateListener = ch(
        this.state,
        () => {
          this.stateListeners.forEach((F) => {
            F(this.stateSnapshot);
          });
        },
        this.sync
      ), this.setupContextWatchers(), this.executeActivities(
        cs(
          "machine.start"
          /* Start */
        ),
        _c(this.config.activities),
        "machine.start"
        /* Start */
      ), this.executeActions(this.config.entry, cs(
        "machine.start"
        /* Start */
      ));
      const f = cs(
        "machine.init"
        /* Init */
      ), p = kg(u) ? u.value : u, y = kg(u) ? u.context : void 0;
      y && this.setContext(y);
      const A = {
        target: p ?? this.config.initial
      }, w = this.getNextStateInfo(A, f);
      return this.initialState = w, this.performStateChangeEffects(this.state.value, w, f), this;
    }), ot(this, "setupContextWatchers", () => {
      const { watch: u } = this.config;
      if (!u)
        return;
      let f = eu(this.state.context);
      const p = ch(this.state.context, () => {
        var A;
        const y = eu(this.state.context);
        for (const [w, F] of Object.entries(u))
          (((A = this.options.compareFns) == null ? void 0 : A[w]) ?? Object.is)(f[w], y[w]) || this.executeActions(F, this.state.event);
        f = y;
      });
      this.contextWatchers.add(p);
    }), ot(this, "stop", () => {
      if (this.status !== "Stopped")
        return this.performExitEffects(this.state.value, cs(
          "machine.stop"
          /* Stop */
        )), this.executeActions(this.config.exit, cs(
          "machine.stop"
          /* Stop */
        )), this.setState(""), this.setEvent(
          "machine.stop"
          /* Stop */
        ), this.stopStateListeners(), this.stopChildren(), this.stopActivities(), this.stopDelayedEvents(), this.stopContextWatchers(), this.status = "Stopped", this;
    }), ot(this, "stopStateListeners", () => {
      this.removeStateListener(), this.stateListeners.clear();
    }), ot(this, "stopContextWatchers", () => {
      this.contextWatchers.forEach((u) => u()), this.contextWatchers.clear();
    }), ot(this, "stopDelayedEvents", () => {
      this.delayedEvents.forEach((u) => {
        u.forEach((f) => f());
      }), this.delayedEvents.clear();
    }), ot(this, "stopActivities", (u) => {
      var f, p;
      u ? ((f = this.activityEvents.get(u)) == null || f.forEach((y) => y()), (p = this.activityEvents.get(u)) == null || p.clear(), this.activityEvents.delete(u)) : (this.activityEvents.forEach((y) => {
        y.forEach((A) => A()), y.clear();
      }), this.activityEvents.clear());
    }), ot(this, "sendChild", (u, f) => {
      const p = cs(u), y = H0(f, this.contextSnapshot), A = this.children.get(y);
      A || jp(`[@zag-js/core] Cannot send '${p.type}' event to unknown child`), A.send(p);
    }), ot(this, "stopChild", (u) => {
      this.children.has(u) || jp(`[@zag-js/core > stop-child] Cannot stop unknown child ${u}`), this.children.get(u).stop(), this.children.delete(u);
    }), ot(this, "removeChild", (u) => {
      this.children.delete(u);
    }), ot(this, "stopChildren", () => {
      this.children.forEach((u) => u.stop()), this.children.clear();
    }), ot(this, "setParent", (u) => {
      this.parent = u;
    }), ot(this, "spawn", (u, f) => {
      const p = H0(u);
      return f && (p.id = f), p.type = "machine.actor", p.setParent(this), this.children.set(p.id, ql(p)), p.onDone(() => {
        this.removeChild(p.id);
      }).start(), ql(Hn(p));
    }), ot(this, "stopActivity", (u) => {
      var p;
      if (!this.state.value)
        return;
      const f = this.activityEvents.get(this.state.value);
      (p = f == null ? void 0 : f.get(u)) == null || p(), f == null || f.delete(u);
    }), ot(this, "addActivityCleanup", (u, f, p) => {
      var y;
      u && (this.activityEvents.has(u) ? (y = this.activityEvents.get(u)) == null || y.set(f, p) : this.activityEvents.set(u, /* @__PURE__ */ new Map([[f, p]])));
    }), ot(this, "setState", (u) => {
      this.state.previousValue = this.state.value, this.state.value = u;
      const f = this.getStateNode(u);
      u == null ? pF(this.state.tags) : this.state.tags = _c(f == null ? void 0 : f.tags);
    }), ot(this, "setContext", (u) => {
      u && dS(this.state.context, fh(u));
    }), ot(this, "setOptions", (u) => {
      const f = fh(u);
      this.actionMap = { ...this.actionMap, ...f.actions }, this.delayMap = { ...this.delayMap, ...f.delays }, this.activityMap = { ...this.activityMap, ...f.activities }, this.guardMap = { ...this.guardMap, ...f.guards };
    }), ot(this, "getStateNode", (u) => {
      var f;
      if (u)
        return (f = this.config.states) == null ? void 0 : f[u];
    }), ot(this, "getNextStateInfo", (u, f) => {
      const p = this.determineTransition(u, f), y = !(p != null && p.target), A = (p == null ? void 0 : p.target) ?? this.state.value, w = this.state.value !== A, F = this.getStateNode(A), N = {
        reenter: !y && !w && !(p != null && p.internal),
        transition: p,
        stateNode: F,
        target: A,
        changed: w
      };
      return this.log("NextState:", `[${f.type}]`, this.state.value, "---->", N.target), N;
    }), ot(this, "getAfterActions", (u, f) => {
      let p;
      return {
        entry: () => {
          p = globalThis.setTimeout(() => {
            const y = this.getNextStateInfo(u, this.state.event);
            this.performStateChangeEffects(this.state.value, y, this.state.event);
          }, f);
        },
        exit: () => {
          globalThis.clearTimeout(p);
        }
      };
    }), ot(this, "getDelayedEventActions", (u) => {
      const f = this.getStateNode(u), p = this.state.event;
      if (!f || !f.after)
        return;
      const y = [], A = [];
      if (uh(f.after)) {
        const w = this.determineTransition(f.after, p);
        if (!w)
          return;
        if (!yF(w, "delay"))
          throw new Error(`[@zag-js/core > after] Delay is required for after transition: ${JSON.stringify(w)}`);
        const j = fg(w.delay, this.delayMap)(this.contextSnapshot, p), N = this.getAfterActions(w, j);
        return y.push(N.entry), A.push(N.exit), { entries: y, exits: A };
      }
      if (kg(f.after))
        for (const w in f.after) {
          const F = f.after[w], N = fg(w, this.delayMap)(this.contextSnapshot, p), D = this.getAfterActions(F, N);
          y.push(D.entry), A.push(D.exit);
        }
      return { entries: y, exits: A };
    }), ot(this, "executeActions", (u, f) => {
      var y;
      const p = Rm(u, this.guardMap)(this.contextSnapshot, f, this.guardMeta);
      for (const A of _c(p)) {
        const w = ta(A) ? (y = this.actionMap) == null ? void 0 : y[A] : A;
        km(
          ta(A) && !w,
          `[@zag-js/core > execute-actions] No implementation found for action: \`${A}\``
        ), w == null || w(this.state.context, f, this.meta);
      }
    }), ot(this, "executeActivities", (u, f, p) => {
      var y;
      for (const A of f) {
        const w = ta(A) ? (y = this.activityMap) == null ? void 0 : y[A] : A;
        if (!w) {
          km(`[@zag-js/core > execute-activity] No implementation found for activity: \`${A}\``);
          continue;
        }
        const F = w(this.state.context, u, this.meta);
        if (F) {
          const j = ta(A) ? A : A.name || G0();
          this.addActivityCleanup(p ?? this.state.value, j, F);
        }
      }
    }), ot(this, "createEveryActivities", (u, f) => {
      if (u)
        if (uh(u)) {
          const p = _c(u).find((F) => {
            const j = F.delay, D = fg(j, this.delayMap)(this.contextSnapshot, this.state.event);
            return pS(F.guard, this.guardMap)(this.contextSnapshot, this.state.event, this.guardMeta) ?? D != null;
          });
          if (!p)
            return;
          const A = fg(p.delay, this.delayMap)(this.contextSnapshot, this.state.event);
          f(() => {
            const F = globalThis.setInterval(() => {
              this.executeActions(p.actions, this.state.event);
            }, A);
            return () => {
              globalThis.clearInterval(F);
            };
          });
        } else
          for (const p in u) {
            const y = u == null ? void 0 : u[p], w = fg(p, this.delayMap)(this.contextSnapshot, this.state.event);
            f(() => {
              const j = globalThis.setInterval(() => {
                this.executeActions(y, this.state.event);
              }, w);
              return () => {
                globalThis.clearInterval(j);
              };
            });
          }
    }), ot(this, "setEvent", (u) => {
      this.state.previousEvent = this.state.event, this.state.event = Hn(cs(u));
    }), ot(this, "performExitEffects", (u, f) => {
      const p = this.state.value;
      if (p === "")
        return;
      const y = u ? this.getStateNode(u) : void 0;
      this.stopActivities(p);
      const A = Rm(y == null ? void 0 : y.exit, this.guardMap)(this.contextSnapshot, f, this.guardMeta), w = _c(A), F = this.delayedEvents.get(p);
      F && w.push(...F), this.executeActions(w, f);
    }), ot(this, "performEntryEffects", (u, f) => {
      const p = this.getStateNode(u), y = _c(p == null ? void 0 : p.activities);
      this.createEveryActivities(p == null ? void 0 : p.every, (j) => {
        y.unshift(j);
      }), y.length > 0 && this.executeActivities(f, y);
      const A = Rm(p == null ? void 0 : p.entry, this.guardMap)(
        this.contextSnapshot,
        f,
        this.guardMeta
      ), w = _c(A), F = this.getDelayedEventActions(u);
      p != null && p.after && F && (this.delayedEvents.set(u, F == null ? void 0 : F.exits), w.push(...F.entries)), this.executeActions(w, f), (p == null ? void 0 : p.type) === "final" && (this.state.done = !0, this.doneListeners.forEach((j) => {
        j(this.stateSnapshot);
      }), this.stop());
    }), ot(this, "performTransitionEffects", (u, f) => {
      const p = this.determineTransition(u, f);
      this.executeActions(p == null ? void 0 : p.actions, f);
    }), ot(this, "performStateChangeEffects", (u, f, p) => {
      this.setEvent(p);
      const y = f.changed || f.reenter;
      y && this.performExitEffects(u, p), this.performTransitionEffects(f.transition, p), this.setState(f.target), y && this.performEntryEffects(f.target, p);
    }), ot(this, "determineTransition", (u, f) => {
      const p = PF(u, this.guardMap);
      return p == null ? void 0 : p(this.contextSnapshot, f, this.guardMeta);
    }), ot(this, "sendParent", (u) => {
      var p;
      this.parent || jp("[@zag-js/core > send-parent] Cannot send event to an unknown parent");
      const f = cs(u);
      (p = this.parent) == null || p.send(f);
    }), ot(this, "log", (...u) => {
      vF() && this.options.debug && console.log(...u);
    }), ot(this, "send", (u) => {
      const f = cs(u);
      this.transition(this.state.value, f);
    }), ot(this, "transition", (u, f) => {
      var F, j;
      const p = ta(u) ? this.getStateNode(u) : u == null ? void 0 : u.stateNode, y = cs(f);
      if (!p && !this.config.on) {
        const N = this.status === "Stopped" ? "[@zag-js/core > transition] Cannot transition a stopped machine" : `[@zag-js/core > transition] State does not have a definition for \`state\`: ${u}, \`event\`: ${y.type}`;
        km(N);
        return;
      }
      const A = ((F = p == null ? void 0 : p.on) == null ? void 0 : F[y.type]) ?? ((j = this.config.on) == null ? void 0 : j[y.type]), w = this.getNextStateInfo(A, y);
      return this.performStateChangeEffects(this.state.value, w, y), w.stateNode;
    }), ot(this, "subscribe", (u) => (this.stateListeners.add(u), this.status === "Running" && u(this.stateSnapshot), () => {
      this.stateListeners.delete(u);
    })), ot(this, "onDone", (u) => (this.doneListeners.add(u), this)), ot(this, "onTransition", (u) => (this.stateListeners.add(u), this.status === "Running" && u(this.stateSnapshot), this)), this.config = Y0(e), this.options = Y0(n ?? {}), this.id = this.config.id ?? `machine-${G0()}`, this.guardMap = ((t = this.options) == null ? void 0 : t.guards) ?? {}, this.actionMap = ((r = this.options) == null ? void 0 : r.actions) ?? {}, this.delayMap = ((o = this.options) == null ? void 0 : o.delays) ?? {}, this.activityMap = ((a = this.options) == null ? void 0 : a.activities) ?? {}, this.sync = ((l = this.options) == null ? void 0 : l.sync) ?? !1, this.state = xF(this.config), this.initialContext = eu(this.state.context);
  }
  // immutable state value
  get stateSnapshot() {
    return ql(eu(this.state));
  }
  getState() {
    return this.stateSnapshot;
  }
  // immutable context value
  get contextSnapshot() {
    return this.stateSnapshot.context;
  }
  /**
   * A reference to the instance methods of the machine.
   * Useful when spawning child machines and managing the communication between them.
   */
  get self() {
    const e = this;
    return {
      id: this.id,
      send: this.send.bind(this),
      sendParent: this.sendParent.bind(this),
      sendChild: this.sendChild.bind(this),
      stop: this.stop.bind(this),
      stopChild: this.stopChild.bind(this),
      spawn: this.spawn.bind(this),
      stopActivity: this.stopActivity.bind(this),
      get state() {
        return e.stateSnapshot;
      },
      get initialContext() {
        return e.initialContext;
      },
      get initialState() {
        var n;
        return ((n = e.initialState) == null ? void 0 : n.target) ?? "";
      }
    };
  }
  get meta() {
    var e;
    return {
      state: this.stateSnapshot,
      guards: this.guardMap,
      send: this.send.bind(this),
      self: this.self,
      initialContext: this.initialContext,
      initialState: ((e = this.initialState) == null ? void 0 : e.target) ?? "",
      getState: () => this.stateSnapshot,
      getAction: (n) => this.actionMap[n],
      getGuard: (n) => this.guardMap[n]
    };
  }
  get guardMeta() {
    return {
      state: this.stateSnapshot
    };
  }
  get [Symbol.toStringTag]() {
    return "Machine";
  }
}, Rr = (e, n) => new hS(e, n), kF = (e) => e instanceof hS || (e == null ? void 0 : e.type) === "machine", RF = (...e) => e.map((n) => {
  var t;
  return (t = n == null ? void 0 : n.trim) == null ? void 0 : t.call(n);
}).filter(Boolean).join(" "), OF = /((?:--)?(?:\w+-?)+)\s*:\s*([^;]*)/g, z0 = (e) => {
  const n = {};
  let t;
  for (; t = OF.exec(e); )
    n[t[1]] = t[2];
  return n;
}, DF = (e, n) => {
  if (ta(e)) {
    if (ta(n))
      return `${e};${n}`;
    e = z0(e);
  } else
    ta(n) && (n = z0(n));
  return Object.assign({}, e ?? {}, n ?? {});
};
function be(...e) {
  let n = {};
  for (let t of e) {
    for (let r in n) {
      if (r.startsWith("on") && typeof n[r] == "function" && typeof t[r] == "function") {
        n[r] = mF(t[r], n[r]);
        continue;
      }
      if (r === "className" || r === "class") {
        n[r] = RF(n[r], t[r]);
        continue;
      }
      if (r === "style") {
        n[r] = DF(n[r], t[r]);
        continue;
      }
      n[r] = t[r] !== void 0 ? t[r] : n[r];
    }
    for (let r in t)
      n[r] === void 0 && (n[r] = t[r]);
  }
  return n;
}
function FF(e) {
  return new Proxy({}, {
    get() {
      return e;
    }
  });
}
var nn = () => (e) => Array.from(new Set(e)), NF = Np("accordion").parts("root", "item", "itemTrigger", "itemContent", "itemIndicator"), gg = NF.build(), dr = so({
  getRootId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.root) ?? `accordion:${e.id}`;
  },
  getItemId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.item) == null ? void 0 : r.call(t, n)) ?? `accordion:${e.id}:item:${n}`;
  },
  getItemContentId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.content) == null ? void 0 : r.call(t, n)) ?? `accordion:${e.id}:content:${n}`;
  },
  getItemTriggerId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.trigger) == null ? void 0 : r.call(t, n)) ?? `accordion:${e.id}:trigger:${n}`;
  },
  getRootEl: (e) => dr.getById(e, dr.getRootId(e)),
  getTriggers: (e) => {
    const t = `[aria-controls][data-ownedby='${CSS.escape(dr.getRootId(e))}']:not([disabled])`;
    return $s(dr.getRootEl(e), t);
  },
  getFirstTriggerEl: (e) => ZA(dr.getTriggers(e)),
  getLastTriggerEl: (e) => Tb(dr.getTriggers(e)),
  getNextTriggerEl: (e, n) => BA(dr.getTriggers(e), dr.getItemTriggerId(e, n)),
  getPrevTriggerEl: (e, n) => VA(dr.getTriggers(e), dr.getItemTriggerId(e, n))
});
function MF(e, n, t) {
  const r = e.context.focusedValue, o = e.context.value, a = e.context.multiple;
  function l(f) {
    let p = f;
    a && p.length > 1 && (p = [p[0]]), n({ type: "VALUE.SET", value: p });
  }
  function u(f) {
    return {
      expanded: o.includes(f.value),
      focused: r === f.value,
      disabled: !!(f.disabled ?? e.context.disabled)
    };
  }
  return {
    focusedValue: r,
    value: o,
    setValue: l,
    getItemState: u,
    getRootProps() {
      return t.element({
        ...gg.root.attrs,
        dir: e.context.dir,
        id: dr.getRootId(e.context),
        "data-orientation": e.context.orientation
      });
    },
    getItemProps(f) {
      const p = u(f);
      return t.element({
        ...gg.item.attrs,
        dir: e.context.dir,
        id: dr.getItemId(e.context, f.value),
        "data-state": p.expanded ? "open" : "closed",
        "data-focus": se(p.focused),
        "data-disabled": se(p.disabled),
        "data-orientation": e.context.orientation
      });
    },
    getItemContentProps(f) {
      const p = u(f);
      return t.element({
        ...gg.itemContent.attrs,
        dir: e.context.dir,
        role: "region",
        id: dr.getItemContentId(e.context, f.value),
        "aria-labelledby": dr.getItemTriggerId(e.context, f.value),
        hidden: !p.expanded,
        "data-state": p.expanded ? "open" : "closed",
        "data-disabled": se(p.disabled),
        "data-focus": se(p.focused),
        "data-orientation": e.context.orientation
      });
    },
    getItemIndicatorProps(f) {
      const p = u(f);
      return t.element({
        ...gg.itemIndicator.attrs,
        dir: e.context.dir,
        "aria-hidden": !0,
        "data-state": p.expanded ? "open" : "closed",
        "data-disabled": se(p.disabled),
        "data-focus": se(p.focused),
        "data-orientation": e.context.orientation
      });
    },
    getItemTriggerProps(f) {
      const { value: p } = f, y = u(f);
      return t.button({
        ...gg.itemTrigger.attrs,
        type: "button",
        dir: e.context.dir,
        id: dr.getItemTriggerId(e.context, p),
        "aria-controls": dr.getItemContentId(e.context, p),
        "aria-expanded": y.expanded,
        disabled: y.disabled,
        "data-orientation": e.context.orientation,
        "aria-disabled": y.disabled,
        "data-state": y.expanded ? "open" : "closed",
        "data-ownedby": dr.getRootId(e.context),
        onFocus() {
          y.disabled || n({ type: "TRIGGER.FOCUS", value: p });
        },
        onBlur() {
          y.disabled || n("TRIGGER.BLUR");
        },
        onClick(A) {
          y.disabled || (fb() && A.currentTarget.focus(), n({ type: "TRIGGER.CLICK", value: p }));
        },
        onKeyDown(A) {
          if (A.defaultPrevented || y.disabled)
            return;
          const w = {
            ArrowDown() {
              e.context.isHorizontal || n({ type: "GOTO.NEXT", value: p });
            },
            ArrowUp() {
              e.context.isHorizontal || n({ type: "GOTO.PREV", value: p });
            },
            ArrowRight() {
              e.context.isHorizontal && n({ type: "GOTO.NEXT", value: p });
            },
            ArrowLeft() {
              e.context.isHorizontal && n({ type: "GOTO.PREV", value: p });
            },
            Home() {
              n({ type: "GOTO.FIRST", value: p });
            },
            End() {
              n({ type: "GOTO.LAST", value: p });
            }
          }, F = il(A, {
            dir: e.context.dir,
            orientation: e.context.orientation
          }), j = w[F];
          j && (j(A), A.preventDefault());
        }
      });
    }
  };
}
var { and: LF, not: BF } = Ma;
function VF(e) {
  const n = br(e);
  return Rr(
    {
      id: "accordion",
      initial: "idle",
      context: {
        focusedValue: null,
        value: [],
        collapsible: !1,
        multiple: !1,
        orientation: "vertical",
        ...n
      },
      watch: {
        value: "coarseValue",
        multiple: "coarseValue"
      },
      created: "coarseValue",
      computed: {
        isHorizontal: (t) => t.orientation === "horizontal"
      },
      on: {
        "VALUE.SET": {
          actions: ["setValue"]
        }
      },
      states: {
        idle: {
          on: {
            "TRIGGER.FOCUS": {
              target: "focused",
              actions: "setFocusedValue"
            }
          }
        },
        focused: {
          on: {
            "GOTO.NEXT": {
              actions: "focusNextTrigger"
            },
            "GOTO.PREV": {
              actions: "focusPrevTrigger"
            },
            "TRIGGER.CLICK": [
              {
                guard: LF("isExpanded", "canToggle"),
                actions: ["collapse"]
              },
              {
                guard: BF("isExpanded"),
                actions: ["expand"]
              }
            ],
            "GOTO.FIRST": {
              actions: "focusFirstTrigger"
            },
            "GOTO.LAST": {
              actions: "focusLastTrigger"
            },
            "TRIGGER.BLUR": {
              target: "idle",
              actions: "clearFocusedValue"
            }
          }
        }
      }
    },
    {
      guards: {
        canToggle: (t) => !!t.collapsible || !!t.multiple,
        isExpanded: (t, r) => t.value.includes(r.value)
      },
      actions: {
        collapse(t, r) {
          const o = t.multiple ? XA(t.value, r.value) : [];
          pg.value(t, t.multiple ? o : []);
        },
        expand(t, r) {
          const o = t.multiple ? KA(t.value, r.value) : [r.value];
          pg.value(t, o);
        },
        focusFirstTrigger(t) {
          var r;
          (r = dr.getFirstTriggerEl(t)) == null || r.focus();
        },
        focusLastTrigger(t) {
          var r;
          (r = dr.getLastTriggerEl(t)) == null || r.focus();
        },
        focusNextTrigger(t) {
          if (!t.focusedValue)
            return;
          const r = dr.getNextTriggerEl(t, t.focusedValue);
          r == null || r.focus();
        },
        focusPrevTrigger(t) {
          if (!t.focusedValue)
            return;
          const r = dr.getPrevTriggerEl(t, t.focusedValue);
          r == null || r.focus();
        },
        setFocusedValue(t, r) {
          pg.focusedValue(t, r.value);
        },
        clearFocusedValue(t) {
          pg.focusedValue(t, null);
        },
        setValue(t, r) {
          pg.value(t, r.value);
        },
        coarseValue(t) {
          !t.multiple && t.value.length > 1 && (Fh("The value of accordion should be a single value when multiple is false."), t.value = [t.value[0]]);
        }
      }
    }
  );
}
var Z0 = {
  change(e) {
    var n;
    (n = e.onValueChange) == null || n.call(e, { value: Array.from(e.value) });
  },
  focusChange(e) {
    var n;
    (n = e.onFocusChange) == null || n.call(e, { value: e.focusedValue });
  }
}, pg = {
  value(e, n) {
    vr(e.value, n) || (e.value = n, Z0.change(e));
  },
  focusedValue(e, n) {
    vr(e.focusedValue, n) || (e.focusedValue = n, Z0.focusChange(e));
  }
};
nn()([
  "collapsible",
  "dir",
  "disabled",
  "getRootNode",
  "id",
  "ids",
  "multiple",
  "onFocusChange",
  "onValueChange",
  "orientation",
  "value"
]);
var jF = nn()(["value", "disabled"]), UF = eF(jF), yr = FF((e) => e), K0 = (e) => (e == null ? void 0 : e.constructor.name) === "Array", mS = (e, n) => {
  if (Object.is(e, n))
    return !0;
  if (e == null && n != null || e != null && n == null)
    return !1;
  if (typeof (e == null ? void 0 : e.isEqual) == "function" && typeof (n == null ? void 0 : n.isEqual) == "function")
    return e.isEqual(n);
  if (typeof e == "function" && typeof n == "function")
    return e.toString() === n.toString();
  if (K0(e) && K0(n))
    return Array.from(e).toString() === Array.from(n).toString();
  if (typeof e != "object" || typeof n != "object")
    return !1;
  const t = Object.keys(n ?? /* @__PURE__ */ Object.create(null)), r = t.length;
  for (let o = 0; o < r; o++)
    if (!Reflect.has(e, t[o]))
      return !1;
  for (let o = 0; o < r; o++) {
    const a = t[o];
    if (!mS(e[a], n[a]))
      return !1;
  }
  return !0;
};
function vS(e) {
  if (!WF(e) || e === void 0)
    return e;
  const n = Reflect.ownKeys(e).filter((r) => typeof r == "string"), t = {};
  for (const r of n) {
    const o = e[r];
    o !== void 0 && (t[r] = vS(o));
  }
  return t;
}
var WF = (e) => e && typeof e == "object" && e.constructor === Object;
function HF(e, n) {
  const t = Fa(!1), r = Fa(!1);
  ra(() => {
    if (t.current && r.current)
      return e();
    r.current = !0;
  }, n), ra(() => (t.current = !0, () => {
    t.current = !1;
  }), []);
}
var { use: X0 } = $o, GF = kb("__zag__targetCache", () => /* @__PURE__ */ new WeakMap());
function bS(e, n) {
  const { actions: t, context: r, sync: o } = n ?? {}, a = Fa(), l = Fa(), u = IO(
    ub((A) => ch(e.state, A, o), [o]),
    () => {
      const A = eu(e.state, X0);
      try {
        if (a.current && l.current && !uS(a.current, A, l.current, /* @__PURE__ */ new WeakMap()))
          return a.current;
      } catch {
      }
      return A;
    },
    () => eu(e.state, X0)
  );
  e.setOptions({ actions: t });
  const f = oc(() => vS(r ?? {}), [r]);
  HF(() => {
    const A = Object.entries(f), w = e.contextSnapshot ?? {};
    A.map(([N, D]) => ({
      key: N,
      curr: D,
      prev: w[N],
      equal: mS(w[N], D)
    })).every(({ equal: N }) => N) || e.setContext(f);
  }, [f]);
  const p = /* @__PURE__ */ new WeakMap();
  ra(() => {
    a.current = u, l.current = p;
  });
  const y = oc(() => /* @__PURE__ */ new WeakMap(), []);
  return cS(u, p, y, GF);
}
function YF(e) {
  return [bS(e), e.send];
}
function zF(e) {
  const n = Fa();
  return n.current || (n.current = { v: e() }), n.current.v;
}
var ZF = typeof document < "u" ? kA : ra;
function KF(e, n) {
  const { state: t, context: r } = n ?? {}, o = zF(() => {
    const a = typeof e == "function" ? e() : e;
    return r && a.setContext(r), a._created(), a;
  });
  return ZF(() => (o.start(t), () => {
    o.stop();
  }), []), o;
}
function Or(e, n) {
  const t = KF(e, n);
  return [bS(t, n), t.send, t];
}
const [XF, RY] = xt({
  name: "AccordionItemContext",
  hookName: "useAccordionItemContext",
  providerName: "<AccordionItemProvider />"
});
function JF(e, n) {
  typeof e == "function" ? e(n) : e != null && (e.current = n);
}
function yS(...e) {
  return (n) => {
    for (const t of e)
      JF(t, n);
  };
}
function QF(e) {
  return "ref" in e.props ? e.props.ref : "ref" in e ? e.ref : null;
}
const Om = (e) => {
  const n = xO(
    oe((t, r) => {
      const { asChild: o, children: a, ...l } = t;
      if (!o)
        return Ed(e, { ...l, ref: r }, a);
      const u = RA.only(a);
      if (!TO(u))
        return null;
      const f = QF(u);
      return PO(u, {
        ...be(l, u.props),
        ref: r ? yS(r, f) : f
      });
    })
  );
  return n.displayName = e.displayName || e.name, n;
}, qF = () => {
  const e = /* @__PURE__ */ new Map();
  return new Proxy(Om, {
    apply(n, t, r) {
      return Om(r[0]);
    },
    get(n, t) {
      const r = t;
      return e.has(r) || e.set(r, Om(r)), e.get(r);
    }
  });
}, ve = qF(), Ft = () => (e, n) => n.reduce(
  (t, r) => {
    const [o, a] = t, l = r;
    return a[l] !== void 0 && (o[l] = a[l]), delete a[l], [o, a];
  },
  [{}, { ...e }]
), _F = (e) => Ft()(e, [
  "defaultOpen",
  "disabled",
  "id",
  "ids",
  "lazyMount",
  "onExitComplete",
  "onOpenChange",
  "open",
  "unmountOnExit"
]);
var Up = (e, n = []) => ({
  parts: (...t) => {
    if ($F(n))
      return Up(e, t);
    throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
  },
  extendWith: (...t) => Up(e, [...n, ...t]),
  rename: (t) => Up(t, n),
  keys: () => n,
  build: () => [...new Set(n)].reduce(
    (t, r) => Object.assign(t, {
      [r]: {
        selector: [
          `&[data-scope="${_d(e)}"][data-part="${_d(r)}"]`,
          `& [data-scope="${_d(e)}"][data-part="${_d(r)}"]`
        ].join(", "),
        attrs: { "data-scope": _d(e), "data-part": _d(r) }
      }
    }),
    {}
  )
}), _d = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), $F = (e) => e.length === 0, eN = Up("collapsible").parts("root", "trigger", "content"), Dm = eN.build(), Da = so({
  getRootId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.root) ?? `collapsible:${e.id}`;
  },
  getContentId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.content) ?? `collapsible:${e.id}:content`;
  },
  getTriggerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.trigger) ?? `collapsible:${e.id}:trigger`;
  },
  getRootEl: (e) => Da.getById(e, Da.getRootId(e)),
  getContentEl: (e) => Da.getById(e, Da.getContentId(e)),
  getTriggerEl: (e) => Da.getById(e, Da.getTriggerId(e))
});
function tN(e, n, t) {
  const r = e.matches("open", "closing"), o = e.matches("open"), a = e.context.height, l = e.context.width, u = !!e.context.disabled, f = !e.context.initial && o;
  return {
    disabled: u,
    visible: r,
    open: o,
    setOpen(p) {
      p !== o && n(p ? "OPEN" : "CLOSE");
    },
    getRootProps() {
      return t.element({
        ...Dm.root.attrs,
        "data-state": o ? "open" : "closed",
        dir: e.context.dir,
        id: Da.getRootId(e.context)
      });
    },
    getContentProps() {
      return t.element({
        ...Dm.content.attrs,
        "data-state": f ? void 0 : o ? "open" : "closed",
        id: Da.getContentId(e.context),
        "data-disabled": se(u),
        hidden: !r,
        style: {
          "--height": a != null ? `${a}px` : void 0,
          "--width": l != null ? `${l}px` : void 0
        }
      });
    },
    getTriggerProps() {
      return t.element({
        ...Dm.trigger.attrs,
        id: Da.getTriggerId(e.context),
        dir: e.context.dir,
        type: "button",
        "data-state": o ? "open" : "closed",
        "data-disabled": se(u),
        "aria-controls": Da.getContentId(e.context),
        "aria-expanded": r || !1,
        onClick(p) {
          p.defaultPrevented || u || n({ type: o ? "CLOSE" : "OPEN", src: "trigger.click" });
        }
      });
    }
  };
}
function nN(e) {
  const n = br(e);
  return Rr(
    {
      id: "collapsible",
      initial: n.open ? "open" : "closed",
      context: {
        ...n,
        height: 0,
        width: 0,
        initial: !1,
        stylesRef: null,
        unmountAnimationName: null
      },
      watch: {
        open: ["setInitial", "computeSize", "toggleVisibility"]
      },
      exit: ["clearInitial"],
      states: {
        closed: {
          tags: ["closed"],
          on: {
            "CONTROLLED.OPEN": "open",
            OPEN: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["setInitial", "computeSize", "invokeOnOpen"]
              }
            ]
          }
        },
        closing: {
          tags: ["open"],
          activities: ["trackAnimationEvents"],
          on: {
            "CONTROLLED.CLOSE": "closed",
            "CONTROLLED.OPEN": "open",
            OPEN: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["setInitial", "invokeOnOpen"]
              }
            ],
            CLOSE: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnExitComplete"]
              },
              {
                target: "closed",
                actions: ["setInitial", "computeSize", "invokeOnExitComplete"]
              }
            ],
            "ANIMATION.END": {
              target: "closed",
              actions: ["invokeOnExitComplete"]
            }
          }
        },
        open: {
          tags: ["open"],
          on: {
            "CONTROLLED.CLOSE": "closing",
            CLOSE: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnClose"]
              },
              {
                target: "closing",
                actions: ["setInitial", "computeSize", "invokeOnClose"]
              }
            ]
          }
        }
      }
    },
    {
      guards: {
        isOpenControlled: (t) => !!t["open.controlled"]
      },
      activities: {
        trackAnimationEvents(t, r, { send: o }) {
          let a;
          const l = Ct(() => {
            const u = Da.getContentEl(t);
            if (!u)
              return;
            const f = uD(u).animationName;
            if (!f || f === "none") {
              o({ type: "ANIMATION.END" });
              return;
            }
            const y = (A) => {
              const F = (u.ownerDocument.defaultView || window).getComputedStyle(u).animationName;
              A.target === u && F === t.unmountAnimationName && o({ type: "ANIMATION.END" });
            };
            u.addEventListener("animationend", y), a = () => {
              u.removeEventListener("animationend", y);
            };
          });
          return () => {
            l(), a == null || a();
          };
        }
      },
      actions: {
        setInitial(t) {
          t.initial = !0;
        },
        clearInitial(t) {
          t.initial = !1;
        },
        computeSize(t, r) {
          var o;
          (o = t._rafCleanup) == null || o.call(t), t._rafCleanup = Ct(() => {
            const a = Da.getContentEl(t);
            if (!a)
              return;
            if (t.stylesRef || (t.stylesRef = Hn({
              animationName: a.style.animationName,
              animationDuration: a.style.animationDuration
            })), r.type === "CLOSE" || !t.open) {
              const f = a.ownerDocument.defaultView || window;
              t.unmountAnimationName = f.getComputedStyle(a).animationName;
            }
            const l = a.hidden;
            a.style.animationName = "none", a.style.animationDuration = "0s", a.hidden = !1;
            const u = a.getBoundingClientRect();
            t.height = u.height, t.width = u.width, t.initial && (a.style.animationName = t.stylesRef.animationName, a.style.animationDuration = t.stylesRef.animationDuration), a.hidden = l;
          });
        },
        invokeOnOpen: (t) => {
          var r;
          (r = t.onOpenChange) == null || r.call(t, { open: !0 });
        },
        invokeOnClose: (t) => {
          var r;
          (r = t.onOpenChange) == null || r.call(t, { open: !1 });
        },
        invokeOnExitComplete(t) {
          var r;
          (r = t.onExitComplete) == null || r.call(t);
        },
        toggleVisibility: (t, r, { send: o }) => {
          o({ type: t.open ? "CONTROLLED.OPEN" : "CONTROLLED.CLOSE" });
        }
      }
    }
  );
}
nn()([
  "dir",
  "disabled",
  "getRootNode",
  "id",
  "ids",
  "onExitComplete",
  "onOpenChange",
  "open.controlled",
  "open"
]);
const [rN, Jr] = xt({
  name: "EnvironmentContext",
  hookName: "useEnvironmentContext",
  providerName: "<EnvironmentProvider />",
  strict: !1,
  defaultValue: {
    getRootNode: () => document,
    getDocument: () => document,
    getWindow: () => window
  }
}), [OY, ko] = xt({
  name: "LocaleContext",
  hookName: "useLocaleContext",
  providerName: "<LocaleProvider />",
  strict: !1,
  defaultValue: { dir: "ltr", locale: "en-US" }
});
function en(e, n = {}) {
  const { sync: t = !1 } = n, r = oN(e);
  return ub(
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    (...o) => {
      var a;
      return t ? queueMicrotask(() => {
        var l;
        return (l = r.current) == null ? void 0 : l.call(r, ...o);
      }) : (a = r.current) == null ? void 0 : a.call(r, ...o);
    },
    [t, r]
  );
}
function oN(e) {
  const n = Fa(e);
  return n.current = e, n;
}
const iN = (e = {}) => {
  const { lazyMount: n, unmountOnExit: t, ...r } = e, o = Fa(!1), { dir: a } = ko(), { getRootNode: l } = Jr(), u = {
    id: gr(),
    dir: a,
    getRootNode: l,
    open: e.defaultOpen,
    "open.controlled": e.open !== void 0,
    ...r
  }, f = {
    ...u,
    open: e.open,
    onOpenChange: en(e.onOpenChange, { sync: !0 })
  }, [p, y] = Or(nN(u), { context: f }), A = tN(p, y, yr);
  A.visible && (o.current = !0);
  const w = !A.visible && !o.current && n || t && !A.visible && o.current;
  return { ...A, isUnmounted: w };
}, [aN, CS] = xt({
  name: "CollapsibleContext",
  hookName: "useCollapsibleContext",
  providerName: "<CollapsibleProvider />"
}), ES = oe((e, n) => {
  const [t, r] = _F(e), o = iN(t), a = be(o.getRootProps(), r);
  return /* @__PURE__ */ I.jsx(aN, { value: o, children: /* @__PURE__ */ I.jsx(ve.div, { ...a, ref: n }) });
});
ES.displayName = "CollapsibleRoot";
const [AS, SS] = xt({
  name: "RenderStrategyContext",
  hookName: "useRenderStrategyContext",
  providerName: "<RenderStrategyPropsProvider />"
}), wS = (e) => Ft()(e, ["lazyMount", "unmountOnExit"]), [sN, Ob] = xt({
  name: "AccordionItemPropsContext",
  hookName: "useAccordionItemPropsContext",
  providerName: "<AccordionItemPropsProvider />"
}), IS = oe((e, n) => {
  const [t, r] = UF(e), o = Hg(), a = SS(), l = be(o.getItemProps(t), r), u = o.getItemState(t), f = o.getItemContentProps(t);
  return /* @__PURE__ */ I.jsx(sN, { value: t, children: /* @__PURE__ */ I.jsx(XF, { value: u, children: /* @__PURE__ */ I.jsx(
    ES,
    {
      ref: n,
      open: u.expanded,
      ids: { content: f.id },
      ...a,
      ...l
    }
  ) }) });
});
IS.displayName = "AccordionItem";
const xS = oe(
  (e, n) => {
    const t = CS();
    if (t.isUnmounted)
      return null;
    const r = be(t.getContentProps(), e);
    return /* @__PURE__ */ I.jsx(ve.div, { ...r, ref: n });
  }
);
xS.displayName = "CollapsibleContent";
const lN = Ft(), Db = oe(
  (e, n) => {
    const t = Hg(), r = Ob(), o = t.getItemContentProps(r), [, a] = lN(o, ["hidden", "data-state"]), l = be(a, e);
    return /* @__PURE__ */ I.jsx(xS, { ref: n, ...l });
  }
);
Db.displayName = "AccordionItemContent";
const TS = oe(
  (e, n) => {
    const t = Hg(), r = Ob(), o = be(t.getItemIndicatorProps(r), e);
    return /* @__PURE__ */ I.jsx(ve.div, { ...o, ref: n });
  }
);
TS.displayName = "AccordionItemIndicator";
const PS = oe(
  (e, n) => {
    const t = Hg(), r = Ob(), o = CS(), a = t.getItemTriggerProps(r), l = be(
      {
        ...a,
        "aria-controls": o.isUnmounted ? void 0 : a["aria-controls"]
      },
      e
    );
    return /* @__PURE__ */ I.jsx(ve.button, { ...l, ref: n });
  }
);
PS.displayName = "AccordionItemTrigger";
const cN = (e = {}) => {
  const { getRootNode: n } = Jr(), { dir: t } = ko(), r = {
    id: gr(),
    dir: t,
    getRootNode: n,
    value: e.defaultValue,
    ...e
  }, o = {
    ...r,
    value: e.value,
    onFocusChange: en(e.onFocusChange),
    onValueChange: en(e.onValueChange)
  }, [a, l] = Or(VF(r), { context: o });
  return MF(a, l, yr);
}, kS = oe((e, n) => {
  const [t, r] = wS(e), [o, a] = Ft()(r, [
    "collapsible",
    "defaultValue",
    "disabled",
    "id",
    "ids",
    "multiple",
    "onFocusChange",
    "onValueChange",
    "orientation",
    "value"
  ]), l = cN(o), u = be(l.getRootProps(), a);
  return /* @__PURE__ */ I.jsx(GO, { value: l, children: /* @__PURE__ */ I.jsx(AS, { value: t, children: /* @__PURE__ */ I.jsx(ve.div, { ...u, ref: n }) }) });
});
kS.displayName = "AccordionRoot";
const [uN, Nf] = xt({
  name: "CarouselContext",
  hookName: "useCarouselContext",
  providerName: "<CarouselProvider />"
});
var ao = (e, n = []) => ({ parts: (...t) => {
  if (dN(n))
    return ao(e, t);
  throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
}, extendWith: (...t) => ao(e, [...n, ...t]), rename: (t) => ao(t, n), keys: () => n, build: () => [...new Set(n)].reduce((t, r) => Object.assign(t, { [r]: { selector: [`&[data-scope="${$d(e)}"][data-part="${$d(r)}"]`, `& [data-scope="${$d(e)}"][data-part="${$d(r)}"]`].join(", "), attrs: { "data-scope": $d(e), "data-part": $d(r) } } }), {}) }), $d = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), dN = (e) => e.length === 0, fN = 2147483647, gN = (e) => typeof e == "object" && (e == null ? void 0 : e.nodeType) === Node.ELEMENT_NODE && typeof (e == null ? void 0 : e.nodeName) == "string", pN = (e) => e.nodeType === Node.DOCUMENT_NODE, hN = (e) => e != null && e === e.window;
function mN(e) {
  return pN(e) ? e : hN(e) ? e.document : (e == null ? void 0 : e.ownerDocument) ?? document;
}
var RS = () => typeof document < "u";
function vN() {
  const e = navigator.userAgentData;
  return (e == null ? void 0 : e.platform) ?? navigator.platform;
}
var bN = (e) => RS() && e.test(vN()), yN = (e) => RS() && e.test(navigator.vendor), CN = () => EN() && yN(/apple/i), EN = () => bN(/mac|iphone|ipad|ipod/i), Fb = (e) => e.id;
function AN(e, n, t = Fb) {
  return e.find((r) => t(r) === n);
}
function Nb(e, n, t = Fb) {
  const r = AN(e, n, t);
  return r ? e.indexOf(r) : -1;
}
function OS(e, n, t = !0) {
  let r = Nb(e, n);
  return r = t ? (r + 1) % e.length : Math.min(r + 1, e.length - 1), e[r];
}
function DS(e, n, t = !0) {
  let r = Nb(e, n);
  return r === -1 ? t ? e[e.length - 1] : null : (r = t ? (r - 1 + e.length) % e.length : Math.max(0, r - 1), e[r]);
}
var SN = (e) => e.split("").map((n) => {
  const t = n.charCodeAt(0);
  return t > 0 && t < 128 ? n : t >= 128 && t <= 255 ? `/x${t.toString(16)}`.replace("/", "\\") : "";
}).join("").trim(), wN = (e) => SN(e.dataset.valuetext ?? e.textContent ?? ""), IN = (e, n) => e.trim().toLowerCase().startsWith(n.toLowerCase()), xN = (e, n) => e.map((t, r) => e[(Math.max(n, 0) + r) % e.length]);
function TN(e, n, t, r = Fb) {
  const o = t ? Nb(e, t, r) : -1;
  let a = t ? xN(e, o) : e;
  return n.length === 1 && (a = a.filter((u) => r(u) !== t)), a.find((u) => IN(wN(u), n));
}
function PN(e, n) {
  const { state: t, activeId: r, key: o, timeout: a = 350, itemToId: l } = n, u = t.keysSoFar + o, p = u.length > 1 && Array.from(u).every((j) => j === u[0]) ? u[0] : u;
  let y = e.slice();
  const A = TN(y, p, r, l);
  function w() {
    clearTimeout(t.timer), t.timer = -1;
  }
  function F(j) {
    t.keysSoFar = j, w(), j !== "" && (t.timer = +setTimeout(() => {
      F(""), w();
    }, a));
  }
  return F(u), A;
}
var kN = Object.assign(PN, { defaultOptions: { keysSoFar: "", timer: -1 }, isValidEvent: RN });
function RN(e) {
  return e.key.length === 1 && !e.ctrlKey && !e.metaKey;
}
function $l(e, n) {
  return Array.from((e == null ? void 0 : e.querySelectorAll(n)) ?? []);
}
function FS(e, n) {
  return (e == null ? void 0 : e.querySelector(n)) ?? null;
}
function wi(e) {
  const n = { getRootNode: (t) => {
    var r;
    return ((r = t.getRootNode) == null ? void 0 : r.call(t)) ?? document;
  }, getDoc: (t) => mN(n.getRootNode(t)), getWin: (t) => n.getDoc(t).defaultView ?? window, getActiveElement: (t) => n.getDoc(t).activeElement, isActiveElement: (t, r) => r === n.getActiveElement(t), getById: (t, r) => n.getRootNode(t).getElementById(r), setValue: (t, r) => {
    if (t == null || r == null)
      return;
    const o = r.toString();
    t.value !== o && (t.value = r.toString());
  } };
  return { ...n, ...e };
}
function J0(e) {
  return Math.max(0, Math.min(1, e));
}
function Q0(e, n) {
  const { left: t, top: r, width: o, height: a } = n.getBoundingClientRect(), l = { x: e.x - t, y: e.y - r }, u = { x: J0(l.x / o), y: J0(l.y / a) };
  function f(p = {}) {
    const { dir: y = "ltr", orientation: A = "horizontal", inverted: w } = p, F = typeof w == "object" ? w.x : w, j = typeof w == "object" ? w.y : w;
    return A === "horizontal" ? y === "rtl" || F ? 1 - u.x : u.x : j ? 1 - u.y : u.y;
  }
  return { offset: l, percent: u, getPercentValue: f };
}
var NS = (e) => e[0], MS = (e) => e[e.length - 1], En = () => (e) => Array.from(new Set(e)), LS = ao("accordion").parts("root", "item", "itemTrigger", "itemContent", "itemIndicator");
LS.build();
var qs = wi({ getRootId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.root) ?? `accordion:${e.id}`;
}, getItemId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.item) == null ? void 0 : r.call(t, n)) ?? `accordion:${e.id}:item:${n}`;
}, getItemContentId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.content) == null ? void 0 : r.call(t, n)) ?? `accordion:${e.id}:content:${n}`;
}, getItemTriggerId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.trigger) == null ? void 0 : r.call(t, n)) ?? `accordion:${e.id}:trigger:${n}`;
}, getRootEl: (e) => qs.getById(e, qs.getRootId(e)), getTriggers: (e) => {
  const t = `[aria-controls][data-ownedby='${CSS.escape(qs.getRootId(e))}']:not([disabled])`;
  return $l(qs.getRootEl(e), t);
}, getFirstTriggerEl: (e) => NS(qs.getTriggers(e)), getLastTriggerEl: (e) => MS(qs.getTriggers(e)), getNextTriggerEl: (e, n) => OS(qs.getTriggers(e), qs.getItemTriggerId(e, n)), getPrevTriggerEl: (e, n) => DS(qs.getTriggers(e), qs.getItemTriggerId(e, n)) });
En()(["collapsible", "dir", "disabled", "getRootNode", "id", "ids", "multiple", "onFocusChange", "onValueChange", "orientation", "value"]);
En()(["value", "disabled"]);
var BS = ao("carousel").parts("root", "viewport", "itemGroup", "item", "nextTrigger", "prevTrigger", "indicatorGroup", "indicator");
BS.build();
var nd = wi({ getRootId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.root) ?? `carousel:${e.id}`;
}, getViewportId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.viewport) ?? `carousel:${e.id}:viewport`;
}, getItemId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.slide) == null ? void 0 : r.call(t, n)) ?? `carousel:${e.id}:slide:${n}`;
}, getItemGroupId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.slideGroup) ?? `carousel:${e.id}:slide-group`;
}, getNextTriggerId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.nextSlideTrigger) ?? `carousel:${e.id}:next-slide-trigger`;
}, getPrevTriggerId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.prevSlideTrigger) ?? `carousel:${e.id}:prev-slide-trigger`;
}, getIndicatorGroupId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.indicatorGroup) ?? `carousel:${e.id}:indicator-group`;
}, getIndicatorId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.indicator) == null ? void 0 : r.call(t, n)) ?? `carousel:${e.id}:indicator:${n}`;
}, getRootEl: (e) => nd.getById(e, nd.getRootId(e)), getViewportEl: (e) => nd.getById(e, nd.getViewportId(e)), getSlideGroupEl: (e) => nd.getById(e, nd.getItemGroupId(e)), getSlideEls: (e) => $l(nd.getSlideGroupEl(e), "[data-part=item]") });
En()(["align", "dir", "getRootNode", "id", "ids", "index", "loop", "onIndexChange", "orientation", "slidesPerView", "spacing"]);
En()(["index", "readOnly"]);
const ON = BS.extendWith("control");
var VS = ao("checkbox").parts("root", "label", "control", "indicator");
VS.build();
var up = wi({ getRootId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.root) ?? `checkbox:${e.id}`;
}, getLabelId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.label) ?? `checkbox:${e.id}:label`;
}, getControlId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.control) ?? `checkbox:${e.id}:control`;
}, getHiddenInputId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.hiddenInput) ?? `checkbox:${e.id}:hidden`;
}, getRootEl: (e) => up.getById(e, up.getRootId(e)), getHiddenInputEl: (e) => up.getById(e, up.getHiddenInputId(e)) });
En()(["checked", "dir", "disabled", "form", "getRootNode", "id", "ids", "invalid", "name", "onCheckedChange", "readOnly", "required", "value"]);
const el = Math.min, ea = Math.max, gh = Math.round, dp = Math.floor, au = (e) => ({
  x: e,
  y: e
}), DN = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, FN = {
  start: "end",
  end: "start"
};
function Wv(e, n, t) {
  return ea(e, el(n, t));
}
function su(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function ic(e) {
  return e.split("-")[0];
}
function Mf(e) {
  return e.split("-")[1];
}
function Mb(e) {
  return e === "x" ? "y" : "x";
}
function Lb(e) {
  return e === "y" ? "height" : "width";
}
function Lf(e) {
  return ["top", "bottom"].includes(ic(e)) ? "y" : "x";
}
function Bb(e) {
  return Mb(Lf(e));
}
function NN(e, n, t) {
  t === void 0 && (t = !1);
  const r = Mf(e), o = Bb(e), a = Lb(o);
  let l = o === "x" ? r === (t ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return n.reference[a] > n.floating[a] && (l = ph(l)), [l, ph(l)];
}
function MN(e) {
  const n = ph(e);
  return [Hv(e), n, Hv(n)];
}
function Hv(e) {
  return e.replace(/start|end/g, (n) => FN[n]);
}
function LN(e, n, t) {
  const r = ["left", "right"], o = ["right", "left"], a = ["top", "bottom"], l = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return t ? n ? o : r : n ? r : o;
    case "left":
    case "right":
      return n ? a : l;
    default:
      return [];
  }
}
function BN(e, n, t, r) {
  const o = Mf(e);
  let a = LN(ic(e), t === "start", r);
  return o && (a = a.map((l) => l + "-" + o), n && (a = a.concat(a.map(Hv)))), a;
}
function ph(e) {
  return e.replace(/left|right|bottom|top/g, (n) => DN[n]);
}
function VN(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function jS(e) {
  return typeof e != "number" ? VN(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function hh(e) {
  const {
    x: n,
    y: t,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: t,
    left: n,
    right: n + r,
    bottom: t + o,
    x: n,
    y: t
  };
}
function q0(e, n, t) {
  let {
    reference: r,
    floating: o
  } = e;
  const a = Lf(n), l = Bb(n), u = Lb(l), f = ic(n), p = a === "y", y = r.x + r.width / 2 - o.width / 2, A = r.y + r.height / 2 - o.height / 2, w = r[u] / 2 - o[u] / 2;
  let F;
  switch (f) {
    case "top":
      F = {
        x: y,
        y: r.y - o.height
      };
      break;
    case "bottom":
      F = {
        x: y,
        y: r.y + r.height
      };
      break;
    case "right":
      F = {
        x: r.x + r.width,
        y: A
      };
      break;
    case "left":
      F = {
        x: r.x - o.width,
        y: A
      };
      break;
    default:
      F = {
        x: r.x,
        y: r.y
      };
  }
  switch (Mf(n)) {
    case "start":
      F[l] -= w * (t && p ? -1 : 1);
      break;
    case "end":
      F[l] += w * (t && p ? -1 : 1);
      break;
  }
  return F;
}
const jN = async (e, n, t) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: l
  } = t, u = a.filter(Boolean), f = await (l.isRTL == null ? void 0 : l.isRTL(n));
  let p = await l.getElementRects({
    reference: e,
    floating: n,
    strategy: o
  }), {
    x: y,
    y: A
  } = q0(p, r, f), w = r, F = {}, j = 0;
  for (let N = 0; N < u.length; N++) {
    const {
      name: D,
      fn: k
    } = u[N], {
      x: z,
      y: q,
      data: Ce,
      reset: ee
    } = await k({
      x: y,
      y: A,
      initialPlacement: r,
      placement: w,
      strategy: o,
      middlewareData: F,
      rects: p,
      platform: l,
      elements: {
        reference: e,
        floating: n
      }
    });
    y = z ?? y, A = q ?? A, F = {
      ...F,
      [D]: {
        ...F[D],
        ...Ce
      }
    }, ee && j <= 50 && (j++, typeof ee == "object" && (ee.placement && (w = ee.placement), ee.rects && (p = ee.rects === !0 ? await l.getElementRects({
      reference: e,
      floating: n,
      strategy: o
    }) : ee.rects), {
      x: y,
      y: A
    } = q0(p, w, f)), N = -1);
  }
  return {
    x: y,
    y: A,
    placement: w,
    strategy: o,
    middlewareData: F
  };
};
async function Vb(e, n) {
  var t;
  n === void 0 && (n = {});
  const {
    x: r,
    y: o,
    platform: a,
    rects: l,
    elements: u,
    strategy: f
  } = e, {
    boundary: p = "clippingAncestors",
    rootBoundary: y = "viewport",
    elementContext: A = "floating",
    altBoundary: w = !1,
    padding: F = 0
  } = su(n, e), j = jS(F), D = u[w ? A === "floating" ? "reference" : "floating" : A], k = hh(await a.getClippingRect({
    element: (t = await (a.isElement == null ? void 0 : a.isElement(D))) == null || t ? D : D.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(u.floating)),
    boundary: p,
    rootBoundary: y,
    strategy: f
  })), z = A === "floating" ? {
    x: r,
    y: o,
    width: l.floating.width,
    height: l.floating.height
  } : l.reference, q = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(u.floating)), Ce = await (a.isElement == null ? void 0 : a.isElement(q)) ? await (a.getScale == null ? void 0 : a.getScale(q)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, ee = hh(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: u,
    rect: z,
    offsetParent: q,
    strategy: f
  }) : z);
  return {
    top: (k.top - ee.top + j.top) / Ce.y,
    bottom: (ee.bottom - k.bottom + j.bottom) / Ce.y,
    left: (k.left - ee.left + j.left) / Ce.x,
    right: (ee.right - k.right + j.right) / Ce.x
  };
}
const UN = (e) => ({
  name: "arrow",
  options: e,
  async fn(n) {
    const {
      x: t,
      y: r,
      placement: o,
      rects: a,
      platform: l,
      elements: u,
      middlewareData: f
    } = n, {
      element: p,
      padding: y = 0
    } = su(e, n) || {};
    if (p == null)
      return {};
    const A = jS(y), w = {
      x: t,
      y: r
    }, F = Bb(o), j = Lb(F), N = await l.getDimensions(p), D = F === "y", k = D ? "top" : "left", z = D ? "bottom" : "right", q = D ? "clientHeight" : "clientWidth", Ce = a.reference[j] + a.reference[F] - w[F] - a.floating[j], ee = w[F] - a.reference[F], Fe = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(p));
    let Oe = Fe ? Fe[q] : 0;
    (!Oe || !await (l.isElement == null ? void 0 : l.isElement(Fe))) && (Oe = u.floating[q] || a.floating[j]);
    const He = Ce / 2 - ee / 2, Re = Oe / 2 - N[j] / 2 - 1, Se = el(A[k], Re), we = el(A[z], Re), ae = Se, ge = Oe - N[j] - we, Ie = Oe / 2 - N[j] / 2 + He, Ye = Wv(ae, Ie, ge), Ke = !f.arrow && Mf(o) != null && Ie !== Ye && a.reference[j] / 2 - (Ie < ae ? Se : we) - N[j] / 2 < 0, ze = Ke ? Ie < ae ? Ie - ae : Ie - ge : 0;
    return {
      [F]: w[F] + ze,
      data: {
        [F]: Ye,
        centerOffset: Ie - Ye - ze,
        ...Ke && {
          alignmentOffset: ze
        }
      },
      reset: Ke
    };
  }
}), WN = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(n) {
      var t, r;
      const {
        placement: o,
        middlewareData: a,
        rects: l,
        initialPlacement: u,
        platform: f,
        elements: p
      } = n, {
        mainAxis: y = !0,
        crossAxis: A = !0,
        fallbackPlacements: w,
        fallbackStrategy: F = "bestFit",
        fallbackAxisSideDirection: j = "none",
        flipAlignment: N = !0,
        ...D
      } = su(e, n);
      if ((t = a.arrow) != null && t.alignmentOffset)
        return {};
      const k = ic(o), z = ic(u) === u, q = await (f.isRTL == null ? void 0 : f.isRTL(p.floating)), Ce = w || (z || !N ? [ph(u)] : MN(u));
      !w && j !== "none" && Ce.push(...BN(u, N, j, q));
      const ee = [u, ...Ce], Fe = await Vb(n, D), Oe = [];
      let He = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (y && Oe.push(Fe[k]), A) {
        const ae = NN(o, l, q);
        Oe.push(Fe[ae[0]], Fe[ae[1]]);
      }
      if (He = [...He, {
        placement: o,
        overflows: Oe
      }], !Oe.every((ae) => ae <= 0)) {
        var Re, Se;
        const ae = (((Re = a.flip) == null ? void 0 : Re.index) || 0) + 1, ge = ee[ae];
        if (ge)
          return {
            data: {
              index: ae,
              overflows: He
            },
            reset: {
              placement: ge
            }
          };
        let Ie = (Se = He.filter((Ye) => Ye.overflows[0] <= 0).sort((Ye, Ke) => Ye.overflows[1] - Ke.overflows[1])[0]) == null ? void 0 : Se.placement;
        if (!Ie)
          switch (F) {
            case "bestFit": {
              var we;
              const Ye = (we = He.map((Ke) => [Ke.placement, Ke.overflows.filter((ze) => ze > 0).reduce((ze, ue) => ze + ue, 0)]).sort((Ke, ze) => Ke[1] - ze[1])[0]) == null ? void 0 : we[0];
              Ye && (Ie = Ye);
              break;
            }
            case "initialPlacement":
              Ie = u;
              break;
          }
        if (o !== Ie)
          return {
            reset: {
              placement: Ie
            }
          };
      }
      return {};
    }
  };
};
async function HN(e, n) {
  const {
    placement: t,
    platform: r,
    elements: o
  } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), l = ic(t), u = Mf(t), f = Lf(t) === "y", p = ["left", "top"].includes(l) ? -1 : 1, y = a && f ? -1 : 1, A = su(n, e);
  let {
    mainAxis: w,
    crossAxis: F,
    alignmentAxis: j
  } = typeof A == "number" ? {
    mainAxis: A,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...A
  };
  return u && typeof j == "number" && (F = u === "end" ? j * -1 : j), f ? {
    x: F * y,
    y: w * p
  } : {
    x: w * p,
    y: F * y
  };
}
const GN = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(n) {
      var t, r;
      const {
        x: o,
        y: a,
        placement: l,
        middlewareData: u
      } = n, f = await HN(n, e);
      return l === ((t = u.offset) == null ? void 0 : t.placement) && (r = u.arrow) != null && r.alignmentOffset ? {} : {
        x: o + f.x,
        y: a + f.y,
        data: {
          ...f,
          placement: l
        }
      };
    }
  };
}, YN = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(n) {
      const {
        x: t,
        y: r,
        placement: o
      } = n, {
        mainAxis: a = !0,
        crossAxis: l = !1,
        limiter: u = {
          fn: (D) => {
            let {
              x: k,
              y: z
            } = D;
            return {
              x: k,
              y: z
            };
          }
        },
        ...f
      } = su(e, n), p = {
        x: t,
        y: r
      }, y = await Vb(n, f), A = Lf(ic(o)), w = Mb(A);
      let F = p[w], j = p[A];
      if (a) {
        const D = w === "y" ? "top" : "left", k = w === "y" ? "bottom" : "right", z = F + y[D], q = F - y[k];
        F = Wv(z, F, q);
      }
      if (l) {
        const D = A === "y" ? "top" : "left", k = A === "y" ? "bottom" : "right", z = j + y[D], q = j - y[k];
        j = Wv(z, j, q);
      }
      const N = u.fn({
        ...n,
        [w]: F,
        [A]: j
      });
      return {
        ...N,
        data: {
          x: N.x - t,
          y: N.y - r
        }
      };
    }
  };
}, zN = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(n) {
      const {
        x: t,
        y: r,
        placement: o,
        rects: a,
        middlewareData: l
      } = n, {
        offset: u = 0,
        mainAxis: f = !0,
        crossAxis: p = !0
      } = su(e, n), y = {
        x: t,
        y: r
      }, A = Lf(o), w = Mb(A);
      let F = y[w], j = y[A];
      const N = su(u, n), D = typeof N == "number" ? {
        mainAxis: N,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...N
      };
      if (f) {
        const q = w === "y" ? "height" : "width", Ce = a.reference[w] - a.floating[q] + D.mainAxis, ee = a.reference[w] + a.reference[q] - D.mainAxis;
        F < Ce ? F = Ce : F > ee && (F = ee);
      }
      if (p) {
        var k, z;
        const q = w === "y" ? "width" : "height", Ce = ["top", "left"].includes(ic(o)), ee = a.reference[A] - a.floating[q] + (Ce && ((k = l.offset) == null ? void 0 : k[A]) || 0) + (Ce ? 0 : D.crossAxis), Fe = a.reference[A] + a.reference[q] + (Ce ? 0 : ((z = l.offset) == null ? void 0 : z[A]) || 0) - (Ce ? D.crossAxis : 0);
        j < ee ? j = ee : j > Fe && (j = Fe);
      }
      return {
        [w]: F,
        [A]: j
      };
    }
  };
}, ZN = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(n) {
      const {
        placement: t,
        rects: r,
        platform: o,
        elements: a
      } = n, {
        apply: l = () => {
        },
        ...u
      } = su(e, n), f = await Vb(n, u), p = ic(t), y = Mf(t), A = Lf(t) === "y", {
        width: w,
        height: F
      } = r.floating;
      let j, N;
      p === "top" || p === "bottom" ? (j = p, N = y === (await (o.isRTL == null ? void 0 : o.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (N = p, j = y === "end" ? "top" : "bottom");
      const D = F - f.top - f.bottom, k = w - f.left - f.right, z = el(F - f[j], D), q = el(w - f[N], k), Ce = !n.middlewareData.shift;
      let ee = z, Fe = q;
      if (A ? Fe = y || Ce ? el(q, k) : k : ee = y || Ce ? el(z, D) : D, Ce && !y) {
        const He = ea(f.left, 0), Re = ea(f.right, 0), Se = ea(f.top, 0), we = ea(f.bottom, 0);
        A ? Fe = w - 2 * (He !== 0 || Re !== 0 ? He + Re : ea(f.left, f.right)) : ee = F - 2 * (Se !== 0 || we !== 0 ? Se + we : ea(f.top, f.bottom));
      }
      await l({
        ...n,
        availableWidth: Fe,
        availableHeight: ee
      });
      const Oe = await o.getDimensions(a.floating);
      return w !== Oe.width || F !== Oe.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Bf(e) {
  return US(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function na(e) {
  var n;
  return (e == null || (n = e.ownerDocument) == null ? void 0 : n.defaultView) || window;
}
function lc(e) {
  var n;
  return (n = (US(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : n.documentElement;
}
function US(e) {
  return e instanceof Node || e instanceof na(e).Node;
}
function al(e) {
  return e instanceof Element || e instanceof na(e).Element;
}
function sl(e) {
  return e instanceof HTMLElement || e instanceof na(e).HTMLElement;
}
function _0(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof na(e).ShadowRoot;
}
function Gg(e) {
  const {
    overflow: n,
    overflowX: t,
    overflowY: r,
    display: o
  } = hs(e);
  return /auto|scroll|overlay|hidden|clip/.test(n + r + t) && !["inline", "contents"].includes(o);
}
function KN(e) {
  return ["table", "td", "th"].includes(Bf(e));
}
function jb(e) {
  const n = Ub(), t = hs(e);
  return t.transform !== "none" || t.perspective !== "none" || (t.containerType ? t.containerType !== "normal" : !1) || !n && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !n && (t.filter ? t.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (t.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (t.contain || "").includes(r));
}
function XN(e) {
  let n = lu(e);
  for (; sl(n) && !Tf(n); ) {
    if (jb(n))
      return n;
    n = lu(n);
  }
  return null;
}
function Ub() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Tf(e) {
  return ["html", "body", "#document"].includes(Bf(e));
}
function hs(e) {
  return na(e).getComputedStyle(e);
}
function Mh(e) {
  return al(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function lu(e) {
  if (Bf(e) === "html")
    return e;
  const n = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    _0(e) && e.host || // Fallback.
    lc(e)
  );
  return _0(n) ? n.host : n;
}
function WS(e) {
  const n = lu(e);
  return Tf(n) ? e.ownerDocument ? e.ownerDocument.body : e.body : sl(n) && Gg(n) ? n : WS(n);
}
function Bg(e, n, t) {
  var r;
  n === void 0 && (n = []), t === void 0 && (t = !0);
  const o = WS(e), a = o === ((r = e.ownerDocument) == null ? void 0 : r.body), l = na(o);
  return a ? n.concat(l, l.visualViewport || [], Gg(o) ? o : [], l.frameElement && t ? Bg(l.frameElement) : []) : n.concat(o, Bg(o, [], t));
}
function HS(e) {
  const n = hs(e);
  let t = parseFloat(n.width) || 0, r = parseFloat(n.height) || 0;
  const o = sl(e), a = o ? e.offsetWidth : t, l = o ? e.offsetHeight : r, u = gh(t) !== a || gh(r) !== l;
  return u && (t = a, r = l), {
    width: t,
    height: r,
    $: u
  };
}
function Wb(e) {
  return al(e) ? e : e.contextElement;
}
function xf(e) {
  const n = Wb(e);
  if (!sl(n))
    return au(1);
  const t = n.getBoundingClientRect(), {
    width: r,
    height: o,
    $: a
  } = HS(n);
  let l = (a ? gh(t.width) : t.width) / r, u = (a ? gh(t.height) : t.height) / o;
  return (!l || !Number.isFinite(l)) && (l = 1), (!u || !Number.isFinite(u)) && (u = 1), {
    x: l,
    y: u
  };
}
const JN = /* @__PURE__ */ au(0);
function GS(e) {
  const n = na(e);
  return !Ub() || !n.visualViewport ? JN : {
    x: n.visualViewport.offsetLeft,
    y: n.visualViewport.offsetTop
  };
}
function QN(e, n, t) {
  return n === void 0 && (n = !1), !t || n && t !== na(e) ? !1 : n;
}
function hd(e, n, t, r) {
  n === void 0 && (n = !1), t === void 0 && (t = !1);
  const o = e.getBoundingClientRect(), a = Wb(e);
  let l = au(1);
  n && (r ? al(r) && (l = xf(r)) : l = xf(e));
  const u = QN(a, t, r) ? GS(a) : au(0);
  let f = (o.left + u.x) / l.x, p = (o.top + u.y) / l.y, y = o.width / l.x, A = o.height / l.y;
  if (a) {
    const w = na(a), F = r && al(r) ? na(r) : r;
    let j = w, N = j.frameElement;
    for (; N && r && F !== j; ) {
      const D = xf(N), k = N.getBoundingClientRect(), z = hs(N), q = k.left + (N.clientLeft + parseFloat(z.paddingLeft)) * D.x, Ce = k.top + (N.clientTop + parseFloat(z.paddingTop)) * D.y;
      f *= D.x, p *= D.y, y *= D.x, A *= D.y, f += q, p += Ce, j = na(N), N = j.frameElement;
    }
  }
  return hh({
    width: y,
    height: A,
    x: f,
    y: p
  });
}
const qN = [":popover-open", ":modal"];
function Hb(e) {
  return qN.some((n) => {
    try {
      return e.matches(n);
    } catch {
      return !1;
    }
  });
}
function _N(e) {
  let {
    elements: n,
    rect: t,
    offsetParent: r,
    strategy: o
  } = e;
  const a = o === "fixed", l = lc(r), u = n ? Hb(n.floating) : !1;
  if (r === l || u && a)
    return t;
  let f = {
    scrollLeft: 0,
    scrollTop: 0
  }, p = au(1);
  const y = au(0), A = sl(r);
  if ((A || !A && !a) && ((Bf(r) !== "body" || Gg(l)) && (f = Mh(r)), sl(r))) {
    const w = hd(r);
    p = xf(r), y.x = w.x + r.clientLeft, y.y = w.y + r.clientTop;
  }
  return {
    width: t.width * p.x,
    height: t.height * p.y,
    x: t.x * p.x - f.scrollLeft * p.x + y.x,
    y: t.y * p.y - f.scrollTop * p.y + y.y
  };
}
function $N(e) {
  return Array.from(e.getClientRects());
}
function YS(e) {
  return hd(lc(e)).left + Mh(e).scrollLeft;
}
function eM(e) {
  const n = lc(e), t = Mh(e), r = e.ownerDocument.body, o = ea(n.scrollWidth, n.clientWidth, r.scrollWidth, r.clientWidth), a = ea(n.scrollHeight, n.clientHeight, r.scrollHeight, r.clientHeight);
  let l = -t.scrollLeft + YS(e);
  const u = -t.scrollTop;
  return hs(r).direction === "rtl" && (l += ea(n.clientWidth, r.clientWidth) - o), {
    width: o,
    height: a,
    x: l,
    y: u
  };
}
function tM(e, n) {
  const t = na(e), r = lc(e), o = t.visualViewport;
  let a = r.clientWidth, l = r.clientHeight, u = 0, f = 0;
  if (o) {
    a = o.width, l = o.height;
    const p = Ub();
    (!p || p && n === "fixed") && (u = o.offsetLeft, f = o.offsetTop);
  }
  return {
    width: a,
    height: l,
    x: u,
    y: f
  };
}
function nM(e, n) {
  const t = hd(e, !0, n === "fixed"), r = t.top + e.clientTop, o = t.left + e.clientLeft, a = sl(e) ? xf(e) : au(1), l = e.clientWidth * a.x, u = e.clientHeight * a.y, f = o * a.x, p = r * a.y;
  return {
    width: l,
    height: u,
    x: f,
    y: p
  };
}
function $0(e, n, t) {
  let r;
  if (n === "viewport")
    r = tM(e, t);
  else if (n === "document")
    r = eM(lc(e));
  else if (al(n))
    r = nM(n, t);
  else {
    const o = GS(e);
    r = {
      ...n,
      x: n.x - o.x,
      y: n.y - o.y
    };
  }
  return hh(r);
}
function zS(e, n) {
  const t = lu(e);
  return t === n || !al(t) || Tf(t) ? !1 : hs(t).position === "fixed" || zS(t, n);
}
function rM(e, n) {
  const t = n.get(e);
  if (t)
    return t;
  let r = Bg(e, [], !1).filter((u) => al(u) && Bf(u) !== "body"), o = null;
  const a = hs(e).position === "fixed";
  let l = a ? lu(e) : e;
  for (; al(l) && !Tf(l); ) {
    const u = hs(l), f = jb(l);
    !f && u.position === "fixed" && (o = null), (a ? !f && !o : !f && u.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Gg(l) && !f && zS(e, l)) ? r = r.filter((y) => y !== l) : o = u, l = lu(l);
  }
  return n.set(e, r), r;
}
function oM(e) {
  let {
    element: n,
    boundary: t,
    rootBoundary: r,
    strategy: o
  } = e;
  const l = [...t === "clippingAncestors" ? Hb(n) ? [] : rM(n, this._c) : [].concat(t), r], u = l[0], f = l.reduce((p, y) => {
    const A = $0(n, y, o);
    return p.top = ea(A.top, p.top), p.right = el(A.right, p.right), p.bottom = el(A.bottom, p.bottom), p.left = ea(A.left, p.left), p;
  }, $0(n, u, o));
  return {
    width: f.right - f.left,
    height: f.bottom - f.top,
    x: f.left,
    y: f.top
  };
}
function iM(e) {
  const {
    width: n,
    height: t
  } = HS(e);
  return {
    width: n,
    height: t
  };
}
function aM(e, n, t) {
  const r = sl(n), o = lc(n), a = t === "fixed", l = hd(e, !0, a, n);
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const f = au(0);
  if (r || !r && !a)
    if ((Bf(n) !== "body" || Gg(o)) && (u = Mh(n)), r) {
      const A = hd(n, !0, a, n);
      f.x = A.x + n.clientLeft, f.y = A.y + n.clientTop;
    } else
      o && (f.x = YS(o));
  const p = l.left + u.scrollLeft - f.x, y = l.top + u.scrollTop - f.y;
  return {
    x: p,
    y,
    width: l.width,
    height: l.height
  };
}
function Fm(e) {
  return hs(e).position === "static";
}
function eC(e, n) {
  return !sl(e) || hs(e).position === "fixed" ? null : n ? n(e) : e.offsetParent;
}
function ZS(e, n) {
  const t = na(e);
  if (Hb(e))
    return t;
  if (!sl(e)) {
    let o = lu(e);
    for (; o && !Tf(o); ) {
      if (al(o) && !Fm(o))
        return o;
      o = lu(o);
    }
    return t;
  }
  let r = eC(e, n);
  for (; r && KN(r) && Fm(r); )
    r = eC(r, n);
  return r && Tf(r) && Fm(r) && !jb(r) ? t : r || XN(e) || t;
}
const sM = async function(e) {
  const n = this.getOffsetParent || ZS, t = this.getDimensions, r = await t(e.floating);
  return {
    reference: aM(e.reference, await n(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function lM(e) {
  return hs(e).direction === "rtl";
}
const cM = {
  convertOffsetParentRelativeRectToViewportRelativeRect: _N,
  getDocumentElement: lc,
  getClippingRect: oM,
  getOffsetParent: ZS,
  getElementRects: sM,
  getClientRects: $N,
  getDimensions: iM,
  getScale: xf,
  isElement: al,
  isRTL: lM
};
function uM(e, n) {
  let t = null, r;
  const o = lc(e);
  function a() {
    var u;
    clearTimeout(r), (u = t) == null || u.disconnect(), t = null;
  }
  function l(u, f) {
    u === void 0 && (u = !1), f === void 0 && (f = 1), a();
    const {
      left: p,
      top: y,
      width: A,
      height: w
    } = e.getBoundingClientRect();
    if (u || n(), !A || !w)
      return;
    const F = dp(y), j = dp(o.clientWidth - (p + A)), N = dp(o.clientHeight - (y + w)), D = dp(p), z = {
      rootMargin: -F + "px " + -j + "px " + -N + "px " + -D + "px",
      threshold: ea(0, el(1, f)) || 1
    };
    let q = !0;
    function Ce(ee) {
      const Fe = ee[0].intersectionRatio;
      if (Fe !== f) {
        if (!q)
          return l();
        Fe ? l(!1, Fe) : r = setTimeout(() => {
          l(!1, 1e-7);
        }, 1e3);
      }
      q = !1;
    }
    try {
      t = new IntersectionObserver(Ce, {
        ...z,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(Ce, z);
    }
    t.observe(e);
  }
  return l(!0), a;
}
function dM(e, n, t, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: l = typeof ResizeObserver == "function",
    layoutShift: u = typeof IntersectionObserver == "function",
    animationFrame: f = !1
  } = r, p = Wb(e), y = o || a ? [...p ? Bg(p) : [], ...Bg(n)] : [];
  y.forEach((k) => {
    o && k.addEventListener("scroll", t, {
      passive: !0
    }), a && k.addEventListener("resize", t);
  });
  const A = p && u ? uM(p, t) : null;
  let w = -1, F = null;
  l && (F = new ResizeObserver((k) => {
    let [z] = k;
    z && z.target === p && F && (F.unobserve(n), cancelAnimationFrame(w), w = requestAnimationFrame(() => {
      var q;
      (q = F) == null || q.observe(n);
    })), t();
  }), p && !f && F.observe(p), F.observe(n));
  let j, N = f ? hd(e) : null;
  f && D();
  function D() {
    const k = hd(e);
    N && (k.x !== N.x || k.y !== N.y || k.width !== N.width || k.height !== N.height) && t(), N = k, j = requestAnimationFrame(D);
  }
  return t(), () => {
    var k;
    y.forEach((z) => {
      o && z.removeEventListener("scroll", t), a && z.removeEventListener("resize", t);
    }), A == null || A(), (k = F) == null || k.disconnect(), F = null, f && cancelAnimationFrame(j);
  };
}
const fM = GN, gM = YN, pM = WN, hM = ZN, mM = UN, vM = zN, bM = (e, n, t) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: cM,
    ...t
  }, a = {
    ...o.platform,
    _c: r
  };
  return jN(e, n, {
    ...o,
    platform: a
  });
};
var KS = ao("color-picker", ["root", "label", "control", "trigger", "positioner", "content", "area", "areaThumb", "areaBackground", "channelSlider", "channelSliderTrack", "channelSliderThumb", "channelInput", "transparencyGrid", "swatchGroup", "swatchTrigger", "swatchIndicator", "swatch", "eyeDropperTrigger", "formatTrigger", "formatSelect"]);
KS.build();
var Pn = wi({ getRootId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.root) ?? `color-picker:${e.id}`;
}, getLabelId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.label) ?? `color-picker:${e.id}:label`;
}, getHiddenInputId: (e) => `color-picker:${e.id}:hidden-input`, getControlId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.control) ?? `color-picker:${e.id}:control`;
}, getTriggerId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.trigger) ?? `color-picker:${e.id}:trigger`;
}, getContentId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.content) ?? `color-picker:${e.id}:content`;
}, getPositionerId: (e) => `color-picker:${e.id}:positioner`, getFormatSelectId: (e) => `color-picker:${e.id}:format-select`, getAreaId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.area) ?? `color-picker:${e.id}:area`;
}, getAreaGradientId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.areaGradient) ?? `color-picker:${e.id}:area-gradient`;
}, getAreaThumbId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.areaThumb) ?? `color-picker:${e.id}:area-thumb`;
}, getChannelSliderId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.channelSliderTrack) == null ? void 0 : r.call(t, n)) ?? `color-picker:${e.id}:slider-track:${n}`;
}, getChannelSliderThumbId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.channelSliderThumb) == null ? void 0 : r.call(t, n)) ?? `color-picker:${e.id}:slider-thumb:${n}`;
}, getContentEl: (e) => Pn.getById(e, Pn.getContentId(e)), getAreaThumbEl: (e) => Pn.getById(e, Pn.getAreaThumbId(e)), getChannelSliderThumbEl: (e, n) => Pn.getById(e, Pn.getChannelSliderThumbId(e, n)), getChannelInputEl: (e, n) => [...$l(Pn.getContentEl(e), `input[data-channel="${n}"]`), ...$l(Pn.getControlEl(e), `input[data-channel="${n}"]`)], getFormatSelectEl: (e) => Pn.getById(e, Pn.getFormatSelectId(e)), getHiddenInputEl: (e) => Pn.getById(e, Pn.getHiddenInputId(e)), getAreaEl: (e) => Pn.getById(e, Pn.getAreaId(e)), getAreaValueFromPoint(e, n) {
  const t = Pn.getAreaEl(e);
  if (!t)
    return;
  const { percent: r } = Q0(n, t);
  return r;
}, getControlEl: (e) => Pn.getById(e, Pn.getControlId(e)), getTriggerEl: (e) => Pn.getById(e, Pn.getTriggerId(e)), getPositionerEl: (e) => Pn.getById(e, Pn.getPositionerId(e)), getChannelSliderTrackEl: (e, n) => Pn.getById(e, Pn.getChannelSliderId(e, n)), getChannelSliderValueFromPoint(e, n, t) {
  const r = Pn.getChannelSliderTrackEl(e, t);
  if (!r)
    return;
  const { percent: o } = Q0(n, r);
  return o;
}, getChannelInputEls: (e) => [...$l(Pn.getContentEl(e), "input[data-channel]"), ...$l(Pn.getControlEl(e), "input[data-channel]")] });
const yM = KS.extendWith("valueText", "view");
var XS = ao("combobox").parts("root", "label", "input", "positioner", "control", "trigger", "content", "clearTrigger", "item", "itemText", "itemIndicator", "itemGroup", "itemGroupLabel");
XS.build();
var oo = wi({ getRootId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.root) ?? `combobox:${e.id}`;
}, getLabelId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.label) ?? `combobox:${e.id}:label`;
}, getControlId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.control) ?? `combobox:${e.id}:control`;
}, getInputId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.input) ?? `combobox:${e.id}:input`;
}, getContentId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.content) ?? `combobox:${e.id}:content`;
}, getPositionerId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.positioner) ?? `combobox:${e.id}:popper`;
}, getTriggerId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.trigger) ?? `combobox:${e.id}:toggle-btn`;
}, getClearTriggerId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.clearTrigger) ?? `combobox:${e.id}:clear-btn`;
}, getItemGroupId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.itemGroup) == null ? void 0 : r.call(t, n)) ?? `combobox:${e.id}:optgroup:${n}`;
}, getItemGroupLabelId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.itemGroupLabel) == null ? void 0 : r.call(t, n)) ?? `combobox:${e.id}:optgroup-label:${n}`;
}, getItemId: (e, n) => `combobox:${e.id}:option:${n}`, getContentEl: (e) => oo.getById(e, oo.getContentId(e)), getInputEl: (e) => oo.getById(e, oo.getInputId(e)), getPositionerEl: (e) => oo.getById(e, oo.getPositionerId(e)), getControlEl: (e) => oo.getById(e, oo.getControlId(e)), getTriggerEl: (e) => oo.getById(e, oo.getTriggerId(e)), getClearTriggerEl: (e) => oo.getById(e, oo.getClearTriggerId(e)), getHighlightedItemEl: (e) => {
  const n = e.highlightedValue;
  if (n != null)
    return FS(oo.getContentEl(e), `[role=option][data-value="${CSS.escape(n)}"`);
}, focusInputEl: (e) => {
  const n = oo.getInputEl(e);
  oo.getActiveElement(e) !== n && (n == null || n.focus({ preventScroll: !0 }));
}, focusTriggerEl: (e) => {
  const n = oo.getTriggerEl(e);
  oo.getActiveElement(e) !== n && (n == null || n.focus({ preventScroll: !0 }));
} });
function CM(e, n) {
  if (n.has(e))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function Gb(e, n, t) {
  CM(e, n), n.set(e, t);
}
var JS = ao("date-picker").parts("root", "label", "clearTrigger", "content", "control", "input", "monthSelect", "nextTrigger", "positioner", "prevTrigger", "rangeText", "table", "tableBody", "tableCell", "tableCellTrigger", "tableHead", "tableHeader", "tableRow", "trigger", "viewTrigger", "viewControl", "yearSelect", "presetTrigger");
JS.build();
var xo = wi({ getRootId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.root) ?? `datepicker:${e.id}`;
}, getTableId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.table) == null ? void 0 : r.call(t, n)) ?? `datepicker:${e.id}:table:${n}`;
}, getTableHeaderId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.tableHeader) == null ? void 0 : r.call(t, n)) ?? `datepicker:${e.id}:thead`;
}, getTableBodyId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.tableBody) == null ? void 0 : r.call(t, n)) ?? `datepicker:${e.id}:tbody`;
}, getTableRowId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.tableRow) == null ? void 0 : r.call(t, n)) ?? `datepicker:${e.id}:tr:${n}`;
}, getContentId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.content) ?? `datepicker:${e.id}:content`;
}, getCellTriggerId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.cellTrigger) == null ? void 0 : r.call(t, n)) ?? `datepicker:${e.id}:cell-trigger:${n}`;
}, getPrevTriggerId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.prevTrigger) == null ? void 0 : r.call(t, n)) ?? `datepicker:${e.id}:prev:${n}`;
}, getNextTriggerId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.nextTrigger) == null ? void 0 : r.call(t, n)) ?? `datepicker:${e.id}:next:${n}`;
}, getViewTriggerId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.viewTrigger) == null ? void 0 : r.call(t, n)) ?? `datepicker:${e.id}:view:${n}`;
}, getClearTriggerId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.clearTrigger) ?? `datepicker:${e.id}:clear`;
}, getControlId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.control) ?? `datepicker:${e.id}:control`;
}, getInputId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.input) == null ? void 0 : r.call(t, n)) ?? `datepicker:${e.id}:input:${n}`;
}, getTriggerId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.trigger) ?? `datepicker:${e.id}:trigger`;
}, getPositionerId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.positioner) ?? `datepicker:${e.id}:positioner`;
}, getMonthSelectId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.monthSelect) ?? `datepicker:${e.id}:month-select`;
}, getYearSelectId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.yearSelect) ?? `datepicker:${e.id}:year-select`;
}, getFocusedCell: (e, n = e.view) => FS(xo.getContentEl(e), `[data-part=table-cell-trigger][data-view=${n}][data-focus]:not([data-outside-range])`), getTriggerEl: (e) => xo.getById(e, xo.getTriggerId(e)), getContentEl: (e) => xo.getById(e, xo.getContentId(e)), getInputEls: (e) => $l(xo.getControlEl(e), "[data-part=input]"), getYearSelectEl: (e) => xo.getById(e, xo.getYearSelectId(e)), getMonthSelectEl: (e) => xo.getById(e, xo.getMonthSelectId(e)), getClearTriggerEl: (e) => xo.getById(e, xo.getClearTriggerId(e)), getPositionerEl: (e) => xo.getById(e, xo.getPositionerId(e)), getControlEl: (e) => xo.getById(e, xo.getControlId(e)) });
En()(["closeOnSelect", "dir", "disabled", "fixedWeeks", "focusedValue", "format", "getRootNode", "id", "ids", "isDateUnavailable", "isDateUnavailable", "locale", "max", "min", "modal", "name", "numOfMonths", "onFocusChange", "onOpenChange", "onValueChange", "onViewChange", "open", "open.controlled", "positioning", "readOnly", "selectionMode", "startOfWeek", "timeZone", "translations", "value", "view"]);
En()(["index"]);
En()(["value"]);
En()(["columns", "id", "view"]);
En()(["disabled", "value", "columns"]);
En()(["view"]);
const QS = JS.extendWith("view");
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var qS = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], mh = /* @__PURE__ */ qS.join(","), _S = typeof Element > "u", md = _S ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, vh = !_S && Element.prototype.getRootNode ? function(e) {
  var n;
  return e == null || (n = e.getRootNode) === null || n === void 0 ? void 0 : n.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, bh = function e(n, t) {
  var r;
  t === void 0 && (t = !0);
  var o = n == null || (r = n.getAttribute) === null || r === void 0 ? void 0 : r.call(n, "inert"), a = o === "" || o === "true", l = a || t && n && e(n.parentNode);
  return l;
}, EM = function(n) {
  var t, r = n == null || (t = n.getAttribute) === null || t === void 0 ? void 0 : t.call(n, "contenteditable");
  return r === "" || r === "true";
}, $S = function(n, t, r) {
  if (bh(n))
    return [];
  var o = Array.prototype.slice.apply(n.querySelectorAll(mh));
  return t && md.call(n, mh) && o.unshift(n), o = o.filter(r), o;
}, ew = function e(n, t, r) {
  for (var o = [], a = Array.from(n); a.length; ) {
    var l = a.shift();
    if (!bh(l, !1))
      if (l.tagName === "SLOT") {
        var u = l.assignedElements(), f = u.length ? u : l.children, p = e(f, !0, r);
        r.flatten ? o.push.apply(o, p) : o.push({
          scopeParent: l,
          candidates: p
        });
      } else {
        var y = md.call(l, mh);
        y && r.filter(l) && (t || !n.includes(l)) && o.push(l);
        var A = l.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(l), w = !bh(A, !1) && (!r.shadowRootFilter || r.shadowRootFilter(l));
        if (A && w) {
          var F = e(A === !0 ? l.children : A.children, !0, r);
          r.flatten ? o.push.apply(o, F) : o.push({
            scopeParent: l,
            candidates: F
          });
        } else
          a.unshift.apply(a, l.children);
      }
  }
  return o;
}, tw = function(n) {
  return !isNaN(parseInt(n.getAttribute("tabindex"), 10));
}, gd = function(n) {
  if (!n)
    throw new Error("No node provided");
  return n.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(n.tagName) || EM(n)) && !tw(n) ? 0 : n.tabIndex;
}, AM = function(n, t) {
  var r = gd(n);
  return r < 0 && t && !tw(n) ? 0 : r;
}, SM = function(n, t) {
  return n.tabIndex === t.tabIndex ? n.documentOrder - t.documentOrder : n.tabIndex - t.tabIndex;
}, nw = function(n) {
  return n.tagName === "INPUT";
}, wM = function(n) {
  return nw(n) && n.type === "hidden";
}, IM = function(n) {
  var t = n.tagName === "DETAILS" && Array.prototype.slice.apply(n.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return t;
}, xM = function(n, t) {
  for (var r = 0; r < n.length; r++)
    if (n[r].checked && n[r].form === t)
      return n[r];
}, TM = function(n) {
  if (!n.name)
    return !0;
  var t = n.form || vh(n), r = function(u) {
    return t.querySelectorAll('input[type="radio"][name="' + u + '"]');
  }, o;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    o = r(window.CSS.escape(n.name));
  else
    try {
      o = r(n.name);
    } catch (l) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", l.message), !1;
    }
  var a = xM(o, n.form);
  return !a || a === n;
}, PM = function(n) {
  return nw(n) && n.type === "radio";
}, kM = function(n) {
  return PM(n) && !TM(n);
}, RM = function(n) {
  var t, r = n && vh(n), o = (t = r) === null || t === void 0 ? void 0 : t.host, a = !1;
  if (r && r !== n) {
    var l, u, f;
    for (a = !!((l = o) !== null && l !== void 0 && (u = l.ownerDocument) !== null && u !== void 0 && u.contains(o) || n != null && (f = n.ownerDocument) !== null && f !== void 0 && f.contains(n)); !a && o; ) {
      var p, y, A;
      r = vh(o), o = (p = r) === null || p === void 0 ? void 0 : p.host, a = !!((y = o) !== null && y !== void 0 && (A = y.ownerDocument) !== null && A !== void 0 && A.contains(o));
    }
  }
  return a;
}, tC = function(n) {
  var t = n.getBoundingClientRect(), r = t.width, o = t.height;
  return r === 0 && o === 0;
}, OM = function(n, t) {
  var r = t.displayCheck, o = t.getShadowRoot;
  if (getComputedStyle(n).visibility === "hidden")
    return !0;
  var a = md.call(n, "details>summary:first-of-type"), l = a ? n.parentElement : n;
  if (md.call(l, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof o == "function") {
      for (var u = n; n; ) {
        var f = n.parentElement, p = vh(n);
        if (f && !f.shadowRoot && o(f) === !0)
          return tC(n);
        n.assignedSlot ? n = n.assignedSlot : !f && p !== n.ownerDocument ? n = p.host : n = f;
      }
      n = u;
    }
    if (RM(n))
      return !n.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return tC(n);
  return !1;
}, DM = function(n) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(n.tagName))
    for (var t = n.parentElement; t; ) {
      if (t.tagName === "FIELDSET" && t.disabled) {
        for (var r = 0; r < t.children.length; r++) {
          var o = t.children.item(r);
          if (o.tagName === "LEGEND")
            return md.call(t, "fieldset[disabled] *") ? !0 : !o.contains(n);
        }
        return !0;
      }
      t = t.parentElement;
    }
  return !1;
}, yh = function(n, t) {
  return !(t.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  bh(t) || wM(t) || OM(t, n) || // For a details element with a summary, the summary element gets the focus
  IM(t) || DM(t));
}, Gv = function(n, t) {
  return !(kM(t) || gd(t) < 0 || !yh(n, t));
}, FM = function(n) {
  var t = parseInt(n.getAttribute("tabindex"), 10);
  return !!(isNaN(t) || t >= 0);
}, NM = function e(n) {
  var t = [], r = [];
  return n.forEach(function(o, a) {
    var l = !!o.scopeParent, u = l ? o.scopeParent : o, f = AM(u, l), p = l ? e(o.candidates) : u;
    f === 0 ? l ? t.push.apply(t, p) : t.push(u) : r.push({
      documentOrder: a,
      tabIndex: f,
      item: o,
      isScope: l,
      content: p
    });
  }), r.sort(SM).reduce(function(o, a) {
    return a.isScope ? o.push.apply(o, a.content) : o.push(a.content), o;
  }, []).concat(t);
}, MM = function(n, t) {
  t = t || {};
  var r;
  return t.getShadowRoot ? r = ew([n], t.includeContainer, {
    filter: Gv.bind(null, t),
    flatten: !1,
    getShadowRoot: t.getShadowRoot,
    shadowRootFilter: FM
  }) : r = $S(n, t.includeContainer, Gv.bind(null, t)), NM(r);
}, LM = function(n, t) {
  t = t || {};
  var r;
  return t.getShadowRoot ? r = ew([n], t.includeContainer, {
    filter: yh.bind(null, t),
    flatten: !0,
    getShadowRoot: t.getShadowRoot
  }) : r = $S(n, t.includeContainer, yh.bind(null, t)), r;
}, ef = function(n, t) {
  if (t = t || {}, !n)
    throw new Error("No node provided");
  return md.call(n, mh) === !1 ? !1 : Gv(t, n);
}, BM = /* @__PURE__ */ qS.concat("iframe").join(","), Nm = function(n, t) {
  if (t = t || {}, !n)
    throw new Error("No node provided");
  return md.call(n, BM) === !1 ? !1 : yh(t, n);
};
/*!
* focus-trap 7.5.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function nC(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function rC(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? nC(Object(t), !0).forEach(function(r) {
      VM(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : nC(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function VM(e, n, t) {
  return n = UM(n), n in e ? Object.defineProperty(e, n, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = t, e;
}
function jM(e, n) {
  if (typeof e != "object" || e === null)
    return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(e, n || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
function UM(e) {
  var n = jM(e, "string");
  return typeof n == "symbol" ? n : String(n);
}
var oC = {
  activateTrap: function(n, t) {
    if (n.length > 0) {
      var r = n[n.length - 1];
      r !== t && r.pause();
    }
    var o = n.indexOf(t);
    o === -1 || n.splice(o, 1), n.push(t);
  },
  deactivateTrap: function(n, t) {
    var r = n.indexOf(t);
    r !== -1 && n.splice(r, 1), n.length > 0 && n[n.length - 1].unpause();
  }
}, WM = function(n) {
  return n.tagName && n.tagName.toLowerCase() === "input" && typeof n.select == "function";
}, HM = function(n) {
  return (n == null ? void 0 : n.key) === "Escape" || (n == null ? void 0 : n.key) === "Esc" || (n == null ? void 0 : n.keyCode) === 27;
}, Rg = function(n) {
  return (n == null ? void 0 : n.key) === "Tab" || (n == null ? void 0 : n.keyCode) === 9;
}, GM = function(n) {
  return Rg(n) && !n.shiftKey;
}, YM = function(n) {
  return Rg(n) && n.shiftKey;
}, iC = function(n) {
  return setTimeout(n, 0);
}, aC = function(n, t) {
  var r = -1;
  return n.every(function(o, a) {
    return t(o) ? (r = a, !1) : !0;
  }), r;
}, hg = function(n) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)
    r[o - 1] = arguments[o];
  return typeof n == "function" ? n.apply(void 0, r) : n;
}, fp = function(n) {
  return n.target.shadowRoot && typeof n.composedPath == "function" ? n.composedPath()[0] : n.target;
}, zM = [], ZM = function(n, t) {
  var r = (t == null ? void 0 : t.document) || document, o = (t == null ? void 0 : t.trapStack) || zM, a = rC({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: GM,
    isKeyBackward: YM
  }, t), l = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, u, f = function(ae, ge, Ie) {
    return ae && ae[ge] !== void 0 ? ae[ge] : a[Ie || ge];
  }, p = function(ae, ge) {
    var Ie = typeof (ge == null ? void 0 : ge.composedPath) == "function" ? ge.composedPath() : void 0;
    return l.containerGroups.findIndex(function(Ye) {
      var Ke = Ye.container, ze = Ye.tabbableNodes;
      return Ke.contains(ae) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (Ie == null ? void 0 : Ie.includes(Ke)) || ze.find(function(ue) {
        return ue === ae;
      });
    });
  }, y = function(ae) {
    var ge = a[ae];
    if (typeof ge == "function") {
      for (var Ie = arguments.length, Ye = new Array(Ie > 1 ? Ie - 1 : 0), Ke = 1; Ke < Ie; Ke++)
        Ye[Ke - 1] = arguments[Ke];
      ge = ge.apply(void 0, Ye);
    }
    if (ge === !0 && (ge = void 0), !ge) {
      if (ge === void 0 || ge === !1)
        return ge;
      throw new Error("`".concat(ae, "` was specified but was not a node, or did not return a node"));
    }
    var ze = ge;
    if (typeof ge == "string" && (ze = r.querySelector(ge), !ze))
      throw new Error("`".concat(ae, "` as selector refers to no known node"));
    return ze;
  }, A = function() {
    var ae = y("initialFocus");
    if (ae === !1)
      return !1;
    if (ae === void 0 || !Nm(ae, a.tabbableOptions))
      if (p(r.activeElement) >= 0)
        ae = r.activeElement;
      else {
        var ge = l.tabbableGroups[0], Ie = ge && ge.firstTabbableNode;
        ae = Ie || y("fallbackFocus");
      }
    if (!ae)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return ae;
  }, w = function() {
    if (l.containerGroups = l.containers.map(function(ae) {
      var ge = MM(ae, a.tabbableOptions), Ie = LM(ae, a.tabbableOptions), Ye = ge.length > 0 ? ge[0] : void 0, Ke = ge.length > 0 ? ge[ge.length - 1] : void 0, ze = Ie.find(function(Q) {
        return ef(Q);
      }), ue = Ie.slice().reverse().find(function(Q) {
        return ef(Q);
      }), de = !!ge.find(function(Q) {
        return gd(Q) > 0;
      });
      return {
        container: ae,
        tabbableNodes: ge,
        focusableNodes: Ie,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: de,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: Ye,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: Ke,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: ze,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: ue,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(me) {
          var Le = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, Je = ge.indexOf(me);
          return Je < 0 ? Le ? Ie.slice(Ie.indexOf(me) + 1).find(function(Xe) {
            return ef(Xe);
          }) : Ie.slice(0, Ie.indexOf(me)).reverse().find(function(Xe) {
            return ef(Xe);
          }) : ge[Je + (Le ? 1 : -1)];
        }
      };
    }), l.tabbableGroups = l.containerGroups.filter(function(ae) {
      return ae.tabbableNodes.length > 0;
    }), l.tabbableGroups.length <= 0 && !y("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (l.containerGroups.find(function(ae) {
      return ae.posTabIndexesFound;
    }) && l.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, F = function we(ae) {
    var ge = ae.activeElement;
    if (ge)
      return ge.shadowRoot && ge.shadowRoot.activeElement !== null ? we(ge.shadowRoot) : ge;
  }, j = function we(ae) {
    if (ae !== !1 && ae !== F(document)) {
      if (!ae || !ae.focus) {
        we(A());
        return;
      }
      ae.focus({
        preventScroll: !!a.preventScroll
      }), l.mostRecentlyFocusedNode = ae, WM(ae) && ae.select();
    }
  }, N = function(ae) {
    var ge = y("setReturnFocus", ae);
    return ge || (ge === !1 ? !1 : ae);
  }, D = function(ae) {
    var ge = ae.target, Ie = ae.event, Ye = ae.isBackward, Ke = Ye === void 0 ? !1 : Ye;
    ge = ge || fp(Ie), w();
    var ze = null;
    if (l.tabbableGroups.length > 0) {
      var ue = p(ge, Ie), de = ue >= 0 ? l.containerGroups[ue] : void 0;
      if (ue < 0)
        Ke ? ze = l.tabbableGroups[l.tabbableGroups.length - 1].lastTabbableNode : ze = l.tabbableGroups[0].firstTabbableNode;
      else if (Ke) {
        var Q = aC(l.tabbableGroups, function(Ue) {
          var it = Ue.firstTabbableNode;
          return ge === it;
        });
        if (Q < 0 && (de.container === ge || Nm(ge, a.tabbableOptions) && !ef(ge, a.tabbableOptions) && !de.nextTabbableNode(ge, !1)) && (Q = ue), Q >= 0) {
          var me = Q === 0 ? l.tabbableGroups.length - 1 : Q - 1, Le = l.tabbableGroups[me];
          ze = gd(ge) >= 0 ? Le.lastTabbableNode : Le.lastDomTabbableNode;
        } else
          Rg(Ie) || (ze = de.nextTabbableNode(ge, !1));
      } else {
        var Je = aC(l.tabbableGroups, function(Ue) {
          var it = Ue.lastTabbableNode;
          return ge === it;
        });
        if (Je < 0 && (de.container === ge || Nm(ge, a.tabbableOptions) && !ef(ge, a.tabbableOptions) && !de.nextTabbableNode(ge)) && (Je = ue), Je >= 0) {
          var Xe = Je === l.tabbableGroups.length - 1 ? 0 : Je + 1, je = l.tabbableGroups[Xe];
          ze = gd(ge) >= 0 ? je.firstTabbableNode : je.firstDomTabbableNode;
        } else
          Rg(Ie) || (ze = de.nextTabbableNode(ge));
      }
    } else
      ze = y("fallbackFocus");
    return ze;
  }, k = function(ae) {
    var ge = fp(ae);
    if (!(p(ge, ae) >= 0)) {
      if (hg(a.clickOutsideDeactivates, ae)) {
        u.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: a.returnFocusOnDeactivate
        });
        return;
      }
      hg(a.allowOutsideClick, ae) || ae.preventDefault();
    }
  }, z = function(ae) {
    var ge = fp(ae), Ie = p(ge, ae) >= 0;
    if (Ie || ge instanceof Document)
      Ie && (l.mostRecentlyFocusedNode = ge);
    else {
      ae.stopImmediatePropagation();
      var Ye, Ke = !0;
      if (l.mostRecentlyFocusedNode)
        if (gd(l.mostRecentlyFocusedNode) > 0) {
          var ze = p(l.mostRecentlyFocusedNode), ue = l.containerGroups[ze].tabbableNodes;
          if (ue.length > 0) {
            var de = ue.findIndex(function(Q) {
              return Q === l.mostRecentlyFocusedNode;
            });
            de >= 0 && (a.isKeyForward(l.recentNavEvent) ? de + 1 < ue.length && (Ye = ue[de + 1], Ke = !1) : de - 1 >= 0 && (Ye = ue[de - 1], Ke = !1));
          }
        } else
          l.containerGroups.some(function(Q) {
            return Q.tabbableNodes.some(function(me) {
              return gd(me) > 0;
            });
          }) || (Ke = !1);
      else
        Ke = !1;
      Ke && (Ye = D({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: l.mostRecentlyFocusedNode,
        isBackward: a.isKeyBackward(l.recentNavEvent)
      })), j(Ye || l.mostRecentlyFocusedNode || A());
    }
    l.recentNavEvent = void 0;
  }, q = function(ae) {
    var ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    l.recentNavEvent = ae;
    var Ie = D({
      event: ae,
      isBackward: ge
    });
    Ie && (Rg(ae) && ae.preventDefault(), j(Ie));
  }, Ce = function(ae) {
    if (HM(ae) && hg(a.escapeDeactivates, ae) !== !1) {
      ae.preventDefault(), u.deactivate();
      return;
    }
    (a.isKeyForward(ae) || a.isKeyBackward(ae)) && q(ae, a.isKeyBackward(ae));
  }, ee = function(ae) {
    var ge = fp(ae);
    p(ge, ae) >= 0 || hg(a.clickOutsideDeactivates, ae) || hg(a.allowOutsideClick, ae) || (ae.preventDefault(), ae.stopImmediatePropagation());
  }, Fe = function() {
    if (l.active)
      return oC.activateTrap(o, u), l.delayInitialFocusTimer = a.delayInitialFocus ? iC(function() {
        j(A());
      }) : j(A()), r.addEventListener("focusin", z, !0), r.addEventListener("mousedown", k, {
        capture: !0,
        passive: !1
      }), r.addEventListener("touchstart", k, {
        capture: !0,
        passive: !1
      }), r.addEventListener("click", ee, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", Ce, {
        capture: !0,
        passive: !1
      }), u;
  }, Oe = function() {
    if (l.active)
      return r.removeEventListener("focusin", z, !0), r.removeEventListener("mousedown", k, !0), r.removeEventListener("touchstart", k, !0), r.removeEventListener("click", ee, !0), r.removeEventListener("keydown", Ce, !0), u;
  }, He = function(ae) {
    var ge = ae.some(function(Ie) {
      var Ye = Array.from(Ie.removedNodes);
      return Ye.some(function(Ke) {
        return Ke === l.mostRecentlyFocusedNode;
      });
    });
    ge && j(A());
  }, Re = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(He) : void 0, Se = function() {
    Re && (Re.disconnect(), l.active && !l.paused && l.containers.map(function(ae) {
      Re.observe(ae, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return u = {
    get active() {
      return l.active;
    },
    get paused() {
      return l.paused;
    },
    activate: function(ae) {
      if (l.active)
        return this;
      var ge = f(ae, "onActivate"), Ie = f(ae, "onPostActivate"), Ye = f(ae, "checkCanFocusTrap");
      Ye || w(), l.active = !0, l.paused = !1, l.nodeFocusedBeforeActivation = r.activeElement, ge == null || ge();
      var Ke = function() {
        Ye && w(), Fe(), Se(), Ie == null || Ie();
      };
      return Ye ? (Ye(l.containers.concat()).then(Ke, Ke), this) : (Ke(), this);
    },
    deactivate: function(ae) {
      if (!l.active)
        return this;
      var ge = rC({
        onDeactivate: a.onDeactivate,
        onPostDeactivate: a.onPostDeactivate,
        checkCanReturnFocus: a.checkCanReturnFocus
      }, ae);
      clearTimeout(l.delayInitialFocusTimer), l.delayInitialFocusTimer = void 0, Oe(), l.active = !1, l.paused = !1, Se(), oC.deactivateTrap(o, u);
      var Ie = f(ge, "onDeactivate"), Ye = f(ge, "onPostDeactivate"), Ke = f(ge, "checkCanReturnFocus"), ze = f(ge, "returnFocus", "returnFocusOnDeactivate");
      Ie == null || Ie();
      var ue = function() {
        iC(function() {
          ze && j(N(l.nodeFocusedBeforeActivation)), Ye == null || Ye();
        });
      };
      return ze && Ke ? (Ke(N(l.nodeFocusedBeforeActivation)).then(ue, ue), this) : (ue(), this);
    },
    pause: function(ae) {
      if (l.paused || !l.active)
        return this;
      var ge = f(ae, "onPause"), Ie = f(ae, "onPostPause");
      return l.paused = !0, ge == null || ge(), Oe(), Se(), Ie == null || Ie(), this;
    },
    unpause: function(ae) {
      if (!l.paused || !l.active)
        return this;
      var ge = f(ae, "onUnpause"), Ie = f(ae, "onPostUnpause");
      return l.paused = !1, ge == null || ge(), w(), Fe(), Se(), Ie == null || Ie(), this;
    },
    updateContainerElements: function(ae) {
      var ge = [].concat(ae).filter(Boolean);
      return l.containers = ge.map(function(Ie) {
        return typeof Ie == "string" ? r.querySelector(Ie) : Ie;
      }), l.active && w(), Se(), this;
    }
  }, u.updateContainerElements(n), u;
}, rw = ao("file-upload").parts("root", "dropzone", "item", "itemDeleteTrigger", "itemGroup", "itemName", "itemPreview", "itemPreviewImage", "itemSizeText", "label", "trigger");
rw.build();
var gp = wi({ getRootId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.root) ?? `file:${e.id}`;
}, getDropzoneId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.dropzone) ?? `file:${e.id}:dropzone`;
}, getHiddenInputId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.hiddenInput) ?? `file:${e.id}:input`;
}, getTriggerId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.trigger) ?? `file:${e.id}:trigger`;
}, getLabelId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.label) ?? `file:${e.id}:label`;
}, getItemId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.item) == null ? void 0 : r.call(t, n)) ?? `file:${e.id}:item:${n}`;
}, getItemNameId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.itemName) == null ? void 0 : r.call(t, n)) ?? `file:${e.id}:item-name:${n}`;
}, getItemSizeTextId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.itemSizeText) == null ? void 0 : r.call(t, n)) ?? `file:${e.id}:item-size:${n}`;
}, getItemPreviewId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.itemPreview) == null ? void 0 : r.call(t, n)) ?? `file:${e.id}:item-preview:${n}`;
}, getHiddenInputEl: (e) => gp.getById(e, gp.getHiddenInputId(e)), getDropzoneEl: (e) => gp.getById(e, gp.getDropzoneId(e)) });
En()(["accept", "allowDrop", "capture", "dir", "directory", "disabled", "getRootNode", "id", "ids", "locale", "maxFiles", "maxFileSize", "minFileSize", "name", "onFileAccept", "onFileReject", "onFileChange", "translations", "validate"]);
En()(["file"]);
var ow = ao("menu").parts("arrow", "arrowTip", "content", "contextTrigger", "indicator", "item", "itemGroup", "itemGroupLabel", "itemIndicator", "itemText", "positioner", "separator", "trigger", "triggerItem");
ow.build();
var To = wi({ getTriggerId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.trigger) ?? `menu:${e.id}:trigger`;
}, getContextTriggerId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.contextTrigger) ?? `menu:${e.id}:ctx-trigger`;
}, getContentId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.content) ?? `menu:${e.id}:content`;
}, getArrowId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.arrow) ?? `menu:${e.id}:arrow`;
}, getPositionerId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.positioner) ?? `menu:${e.id}:popper`;
}, getGroupId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.group) == null ? void 0 : r.call(t, n)) ?? `menu:${e.id}:group:${n}`;
}, getGroupLabelId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.label) == null ? void 0 : r.call(t, n)) ?? `menu:${e.id}:label:${n}`;
}, getContentEl: (e) => To.getById(e, To.getContentId(e)), getPositionerEl: (e) => To.getById(e, To.getPositionerId(e)), getTriggerEl: (e) => To.getById(e, To.getTriggerId(e)), getHighlightedItemEl: (e) => e.highlightedValue ? To.getById(e, e.highlightedValue) : null, getArrowEl: (e) => To.getById(e, To.getArrowId(e)), getElements: (e) => {
  const t = `[role^="menuitem"][data-ownedby=${CSS.escape(To.getContentId(e))}]:not([data-disabled])`;
  return $l(To.getContentEl(e), t);
}, getFirstEl: (e) => NS(To.getElements(e)), getLastEl: (e) => MS(To.getElements(e)), getNextEl: (e, n) => OS(To.getElements(e), e.highlightedValue, n ?? e.loopFocus), getPrevEl: (e, n) => DS(To.getElements(e), e.highlightedValue, n ?? e.loopFocus), getElemByKey: (e, n) => kN(To.getElements(e), { state: e.typeaheadState, key: n, activeId: e.highlightedValue }), isTargetDisabled: (e) => gN(e) && (e.dataset.disabled === "" || e.hasAttribute("disabled")), isTriggerItem: (e) => {
  var n;
  return !!((n = e == null ? void 0 : e.getAttribute("role")) != null && n.startsWith("menuitem")) && !!(e != null && e.hasAttribute("aria-controls"));
}, getOptionFromItemEl(e) {
  return { id: e.id, name: e.dataset.name, value: e.dataset.value, valueText: e.dataset.valueText, type: e.dataset.type };
} });
En()(["anchorPoint", "aria-label", "closeOnSelect", "dir", "getRootNode", "highlightedValue", "id", "ids", "loopFocus", "onFocusOutside", "onInteractOutside", "onOpenChange", "onPointerDownOutside", "onEscapeKeyDown", "onSelect", "onHighlightChange", "open", "open.controlled", "positioning", "typeahead", "composite"]);
En()(["closeOnSelect", "disabled", "value", "valueText"]);
En()(["htmlFor"]);
En()(["id"]);
En()(["disabled", "valueText", "closeOnSelect", "type", "value", "checked", "onCheckedChange"]);
function KM(e, n) {
  return (e % n + n) % n;
}
function Mm(e) {
  if (typeof window.devicePixelRatio != "number")
    return Math.round(e);
  const n = window.devicePixelRatio;
  return Math.floor(e * n + 0.5) / n;
}
var iw = ao("numberInput").parts("root", "label", "input", "control", "incrementTrigger", "decrementTrigger", "scrubber");
iw.build();
var zr = wi({ getRootId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.root) ?? `number-input:${e.id}`;
}, getInputId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.input) ?? `number-input:${e.id}:input`;
}, getIncrementTriggerId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.incrementTrigger) ?? `number-input:${e.id}:inc`;
}, getDecrementTriggerId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.decrementTrigger) ?? `number-input:${e.id}:dec`;
}, getScrubberId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.scrubber) ?? `number-input:${e.id}:scrubber`;
}, getCursorId: (e) => `number-input:${e.id}:cursor`, getLabelId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.label) ?? `number-input:${e.id}:label`;
}, getInputEl: (e) => zr.getById(e, zr.getInputId(e)), getIncrementTriggerEl: (e) => zr.getById(e, zr.getIncrementTriggerId(e)), getDecrementTriggerEl: (e) => zr.getById(e, zr.getDecrementTriggerId(e)), getScrubberEl: (e) => zr.getById(e, zr.getScrubberId(e)), getCursorEl: (e) => zr.getDoc(e).getElementById(zr.getCursorId(e)), getPressedTriggerEl: (e, n = e.hint) => {
  let t = null;
  return n === "increment" && (t = zr.getIncrementTriggerEl(e)), n === "decrement" && (t = zr.getDecrementTriggerEl(e)), t;
}, setupVirtualCursor(e) {
  if (!CN())
    return zr.createVirtualCursor(e), () => {
      var n;
      (n = zr.getCursorEl(e)) == null || n.remove();
    };
}, preventTextSelection(e) {
  const n = zr.getDoc(e), t = n.documentElement, r = n.body;
  return r.style.pointerEvents = "none", t.style.userSelect = "none", t.style.cursor = "ew-resize", () => {
    r.style.pointerEvents = "", t.style.userSelect = "", t.style.cursor = "", t.style.length || t.removeAttribute("style"), r.style.length || r.removeAttribute("style");
  };
}, getMousementValue(e, n) {
  const t = Mm(n.movementX), r = Mm(n.movementY);
  let o = t > 0 ? "increment" : t < 0 ? "decrement" : null;
  e.isRtl && o === "increment" && (o = "decrement"), e.isRtl && o === "decrement" && (o = "increment");
  const a = { x: e.scrubberCursorPoint.x + t, y: e.scrubberCursorPoint.y + r }, u = zr.getWin(e).innerWidth, f = Mm(7.5);
  return a.x = KM(a.x + f, u) - f, { hint: o, point: a };
}, createVirtualCursor(e) {
  const n = zr.getDoc(e), t = n.createElement("div");
  t.className = "scrubber--cursor", t.id = zr.getCursorId(e), Object.assign(t.style, { width: "15px", height: "15px", position: "fixed", pointerEvents: "none", left: "0px", top: "0px", zIndex: fN, transform: e.scrubberCursorPoint ? `translate3d(${e.scrubberCursorPoint.x}px, ${e.scrubberCursorPoint.y}px, 0px)` : void 0, willChange: "transform" }), t.innerHTML = `
        <svg width="46" height="15" style="left: -15.5px; position: absolute; top: 0; filter: drop-shadow(rgba(0, 0, 0, 0.4) 0px 1px 1.1px);">
          <g transform="translate(2 3)">
            <path fill-rule="evenodd" d="M 15 4.5L 15 2L 11.5 5.5L 15 9L 15 6.5L 31 6.5L 31 9L 34.5 5.5L 31 2L 31 4.5Z" style="stroke-width: 2px; stroke: white;"></path>
            <path fill-rule="evenodd" d="M 15 4.5L 15 2L 11.5 5.5L 15 9L 15 6.5L 31 6.5L 31 9L 34.5 5.5L 31 2L 31 4.5Z"></path>
          </g>
        </svg>`, n.body.appendChild(t);
} }), aw = ao("pagination").parts("root", "item", "ellipsis", "prevTrigger", "nextTrigger");
aw.build();
wi({ getRootId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.root) ?? `pagination:${e.id}`;
}, getPrevTriggerId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.prevTrigger) ?? `pagination:${e.id}:prev`;
}, getNextTriggerId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.nextTrigger) ?? `pagination:${e.id}:next`;
}, getEllipsisId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.ellipsis) == null ? void 0 : r.call(t, n)) ?? `pagination:${e.id}:ellipsis:${n}`;
}, getItemId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.item) == null ? void 0 : r.call(t, n)) ?? `pagination:${e.id}:item:${n}`;
} });
En()(["count", "dir", "getRootNode", "id", "ids", "onPageChange", "onPageSizeChange", "page", "pageSize", "siblingCount", "translations", "type"]);
En()(["value", "type"]);
En()(["index"]);
var Yb = ao("radio-group").parts("root", "label", "item", "itemText", "itemControl", "indicator");
Yb.build();
var Po = wi({ getRootId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.root) ?? `radio-group:${e.id}`;
}, getLabelId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.label) ?? `radio-group:${e.id}:label`;
}, getItemId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.item) == null ? void 0 : r.call(t, n)) ?? `radio-group:${e.id}:radio:${n}`;
}, getItemHiddenInputId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.itemHiddenInput) == null ? void 0 : r.call(t, n)) ?? `radio-group:${e.id}:radio:input:${n}`;
}, getItemControlId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.itemControl) == null ? void 0 : r.call(t, n)) ?? `radio-group:${e.id}:radio:control:${n}`;
}, getItemLabelId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.itemLabel) == null ? void 0 : r.call(t, n)) ?? `radio-group:${e.id}:radio:label:${n}`;
}, getIndicatorId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.indicator) ?? `radio-group:${e.id}:indicator`;
}, getRootEl: (e) => Po.getById(e, Po.getRootId(e)), getItemHiddenInputEl: (e, n) => Po.getById(e, Po.getItemHiddenInputId(e, n)), getIndicatorEl: (e) => Po.getById(e, Po.getIndicatorId(e)), getFirstEnabledInputEl: (e) => {
  var n;
  return (n = Po.getRootEl(e)) == null ? void 0 : n.querySelector("input:not(:disabled)");
}, getFirstEnabledAndCheckedInputEl: (e) => {
  var n;
  return (n = Po.getRootEl(e)) == null ? void 0 : n.querySelector("input:not(:disabled):checked");
}, getInputEls: (e) => {
  const t = `input[type=radio][data-ownedby='${CSS.escape(Po.getRootId(e))}']:not([disabled])`;
  return $l(Po.getRootEl(e), t);
}, getActiveRadioEl: (e) => {
  if (e.value)
    return Po.getById(e, Po.getItemId(e, e.value));
}, getOffsetRect: (e) => ({ left: (e == null ? void 0 : e.offsetLeft) ?? 0, top: (e == null ? void 0 : e.offsetTop) ?? 0, width: (e == null ? void 0 : e.offsetWidth) ?? 0, height: (e == null ? void 0 : e.offsetHeight) ?? 0 }), getRectById: (e, n) => {
  const t = Po.getById(e, Po.getItemId(e, n));
  if (t)
    return Po.resolveRect(Po.getOffsetRect(t));
}, resolveRect: (e) => ({ width: `${e.width}px`, height: `${e.height}px`, left: `${e.left}px`, top: `${e.top}px` }) });
En()(["dir", "disabled", "form", "getRootNode", "id", "ids", "name", "onValueChange", "orientation", "readOnly", "value"]);
En()(["value", "disabled", "invalid"]);
const Vf = Yb.rename("segment-group");
var sw = ao("select").parts("label", "positioner", "trigger", "indicator", "clearTrigger", "item", "itemText", "itemIndicator", "itemGroup", "itemGroupLabel", "content", "root", "control");
sw.build();
var yi = wi({ getRootId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.root) ?? `select:${e.id}`;
}, getContentId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.content) ?? `select:${e.id}:content`;
}, getTriggerId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.trigger) ?? `select:${e.id}:trigger`;
}, getClearTriggerId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.clearTrigger) ?? `select:${e.id}:clear-trigger`;
}, getLabelId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.label) ?? `select:${e.id}:label`;
}, getControlId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.control) ?? `select:${e.id}:control`;
}, getItemId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.item) == null ? void 0 : r.call(t, n)) ?? `select:${e.id}:option:${n}`;
}, getHiddenSelectId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.hiddenSelect) ?? `select:${e.id}:select`;
}, getPositionerId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.positioner) ?? `select:${e.id}:positioner`;
}, getItemGroupId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.itemGroup) == null ? void 0 : r.call(t, n)) ?? `select:${e.id}:optgroup:${n}`;
}, getItemGroupLabelId: (e, n) => {
  var t, r;
  return ((r = (t = e.ids) == null ? void 0 : t.itemGroupLabel) == null ? void 0 : r.call(t, n)) ?? `select:${e.id}:optgroup-label:${n}`;
}, getHiddenSelectEl: (e) => yi.getById(e, yi.getHiddenSelectId(e)), getContentEl: (e) => yi.getById(e, yi.getContentId(e)), getControlEl: (e) => yi.getById(e, yi.getControlId(e)), getTriggerEl: (e) => yi.getById(e, yi.getTriggerId(e)), getClearTriggerEl: (e) => yi.getById(e, yi.getClearTriggerId(e)), getPositionerEl: (e) => yi.getById(e, yi.getPositionerId(e)), getHighlightedOptionEl(e) {
  return e.highlightedValue ? yi.getById(e, yi.getItemId(e, e.highlightedValue)) : null;
} });
En()(["closeOnSelect", "collection", "dir", "disabled", "form", "getRootNode", "highlightedValue", "id", "ids", "invalid", "loopFocus", "multiple", "name", "onFocusOutside", "onHighlightChange", "onInteractOutside", "onOpenChange", "onPointerDownOutside", "onValueChange", "open.controlled", "open", "composite", "positioning", "readOnly", "scrollToIndexFn", "value"]);
En()(["item", "persistFocus"]);
En()(["id"]);
En()(["htmlFor"]);
const lw = sw.extendWith("valueText");
var cw = ao("switch").parts("root", "label", "control", "thumb");
cw.build();
var pp = wi({ getRootId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.root) ?? `switch:${e.id}`;
}, getLabelId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.label) ?? `switch:${e.id}:label`;
}, getThumbId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.thumb) ?? `switch:${e.id}:thumb`;
}, getControlId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.control) ?? `switch:${e.id}:control`;
}, getRootEl: (e) => pp.getById(e, pp.getRootId(e)), getHiddenInputId: (e) => {
  var n;
  return ((n = e.ids) == null ? void 0 : n.input) ?? `switch:${e.id}:input`;
}, getHiddenInputEl: (e) => pp.getById(e, pp.getHiddenInputId(e)) });
En()(["checked", "dir", "disabled", "form", "getRootNode", "id", "ids", "invalid", "label", "name", "onCheckedChange", "readOnly", "required", "value"]);
var uw = ao("toast").parts("group", "root", "title", "description", "actionTrigger", "closeTrigger");
uw.build();
var Lm = wi({ getRegionId: (e) => `toast-group:${e}`, getRegionEl: (e, n) => Lm.getById(e, `toast-group:${n}`), getRootId: (e) => `toast:${e.id}`, getRootEl: (e) => Lm.getById(e, Lm.getRootId(e)), getTitleId: (e) => `toast:${e.id}:title`, getDescriptionId: (e) => `toast:${e.id}:description`, getCloseTriggerId: (e) => `toast${e.id}:close` });
const dw = oe((e, n) => /* @__PURE__ */ I.jsx(ve.div, { ...ON.build().control.attrs, ...e, ref: n }));
dw.displayName = "CarouselControl";
const fw = oe((e, n) => {
  const [t, r] = Ft()(e, ["index"]), o = Nf(), a = be(o.getItemProps(t), r);
  return /* @__PURE__ */ I.jsx(ve.div, { ...a, ref: n });
});
fw.displayName = "CarouselItem";
const gw = oe(
  (e, n) => {
    const t = Nf(), r = be(t.getItemGroupProps(), e);
    return /* @__PURE__ */ I.jsx(ve.div, { ...r, ref: n });
  }
);
gw.displayName = "CarouselItemGroup";
const pw = oe(
  (e, n) => {
    const t = Nf(), r = be(t.getNextTriggerProps(), e);
    return /* @__PURE__ */ I.jsx(ve.button, { ...r, ref: n });
  }
);
pw.displayName = "CarouselNextTrigger";
const hw = oe(
  (e, n) => {
    const t = Nf(), r = be(t.getPrevTriggerProps(), e);
    return /* @__PURE__ */ I.jsx(ve.button, { ...r, ref: n });
  }
);
hw.displayName = "CarouselPrevTrigger";
var Wp = (e, n = []) => ({
  parts: (...t) => {
    if (XM(n))
      return Wp(e, t);
    throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
  },
  extendWith: (...t) => Wp(e, [...n, ...t]),
  rename: (t) => Wp(t, n),
  keys: () => n,
  build: () => [...new Set(n)].reduce(
    (t, r) => Object.assign(t, {
      [r]: {
        selector: [
          `&[data-scope="${tf(e)}"][data-part="${tf(r)}"]`,
          `& [data-scope="${tf(e)}"][data-part="${tf(r)}"]`
        ].join(", "),
        attrs: { "data-scope": tf(e), "data-part": tf(r) }
      }
    }),
    {}
  )
}), tf = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), XM = (e) => e.length === 0, JM = Wp("carousel").parts(
  "root",
  "viewport",
  "itemGroup",
  "item",
  "nextTrigger",
  "prevTrigger",
  "indicatorGroup",
  "indicator"
), Jc = JM.build(), jn = so({
  getRootId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.root) ?? `carousel:${e.id}`;
  },
  getViewportId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.viewport) ?? `carousel:${e.id}:viewport`;
  },
  getItemId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.slide) == null ? void 0 : r.call(t, n)) ?? `carousel:${e.id}:slide:${n}`;
  },
  getItemGroupId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.slideGroup) ?? `carousel:${e.id}:slide-group`;
  },
  getNextTriggerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.nextSlideTrigger) ?? `carousel:${e.id}:next-slide-trigger`;
  },
  getPrevTriggerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.prevSlideTrigger) ?? `carousel:${e.id}:prev-slide-trigger`;
  },
  getIndicatorGroupId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.indicatorGroup) ?? `carousel:${e.id}:indicator-group`;
  },
  getIndicatorId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.indicator) == null ? void 0 : r.call(t, n)) ?? `carousel:${e.id}:indicator:${n}`;
  },
  getRootEl: (e) => jn.getById(e, jn.getRootId(e)),
  getViewportEl: (e) => jn.getById(e, jn.getViewportId(e)),
  getSlideGroupEl: (e) => jn.getById(e, jn.getItemGroupId(e)),
  getSlideEls: (e) => $s(jn.getSlideGroupEl(e), "[data-part=item]")
});
function mw(e, n) {
  const t = Math.abs(e - n);
  function r(f) {
    return f < e;
  }
  function o(f) {
    return f > n;
  }
  function a(f) {
    return r(f) || o(f);
  }
  function l(f) {
    return a(f) ? r(f) ? e : n : f;
  }
  function u(f) {
    return t ? f - t * Math.ceil((f - n) / t) : f;
  }
  return {
    length: t,
    max: n,
    min: e,
    constrain: l,
    reachedAny: a,
    reachedMax: o,
    reachedMin: r,
    removeOffset: u
  };
}
var QM = (e, n) => {
  const t = { start: r, center: o, end: a };
  function r() {
    return 0;
  }
  function o(u) {
    return a(u) / 2;
  }
  function a(u) {
    return n - u;
  }
  function l() {
    return n * Number(e);
  }
  return (u) => $A(e) ? l() : t[e](u);
};
function qM(e, n, t) {
  function r(a, l) {
    return Array.from(a.keys()).filter((u) => u % l === 0).map((u) => a.slice(u, u + l));
  }
  function o(a) {
    return Array.from(a.keys()).reduce((l, u) => {
      const p = n.slice(l.at(-1), u + 1).reduce((y, A) => y + A, 0);
      return !u || p > e ? l.concat(u) : l;
    }, []).map((l, u, f) => a.slice(l, f[u + 1]));
  }
  return function(l) {
    return $A(t) ? r(l, t) : o(l);
  };
}
function _M(e) {
  const n = t();
  function t() {
    if (!e.containerRect)
      return 0;
    const l = e.slideRects[0];
    return Math.abs(e.containerRect[e.startEdge] - l[e.startEdge]);
  }
  function r() {
    return e.slideRects.map((l, u, f) => u ? u === f.length - 1 ? Math.abs(o[u]) : Math.abs(f[u + 1][e.startEdge] - l[e.startEdge]) : Math.abs(o[u] + n));
  }
  const o = e.slideRects.map((l) => e.isVertical ? l.height : l.width), a = r();
  return {
    slideSizes: o,
    slideSizesWithGaps: a
  };
}
var Bm = (e) => e[$M(e)], $M = (e) => Math.max(0, e.length - 1);
function vw(e) {
  const { slideSizes: n, slideSizesWithGaps: t } = _M(e), r = qM(e.containerSize, t, e.slidesPerView);
  function o() {
    return r(e.slideRects).map((w) => Bm(w)[e.endEdge] - w[0][e.startEdge]).map(Math.abs);
  }
  function a() {
    return e.slideRects.map((w) => e.containerRect[e.startEdge] - w[e.startEdge]).map((w) => -Math.abs(w));
  }
  function l() {
    const w = QM(e.align, e.containerSize), F = o().map(w);
    return r(u).map((j) => j[0]).map((j, N) => j + F[N]);
  }
  const u = a(), f = l(), p = -Bm(u) + Bm(t), y = mw(u[u.length - 1], u[0]), A = (f[e.index] - y.max) / -y.length;
  return {
    snaps: u,
    snapsAligned: f,
    slideSizes: n,
    slideSizesWithGaps: t,
    contentSize: p,
    scrollLimit: y,
    scrollProgress: Math.abs(A)
  };
}
var eL = 0;
function tL(e) {
  const t = [0], { snaps: r, slideSizes: o, scrollLimit: a } = vw(e), l = o.map((f) => mw(0.5, f - 0.5).constrain(f * eL)), u = t.reduce((f, p) => {
    const y = r.map((A, w) => ({
      start: A - o[w] + l[w] + p,
      end: A + e.containerSize - l[w] + p,
      index: w
    }));
    return f.concat(y);
  }, []);
  return (f) => {
    const p = a.constrain(f);
    return u.reduce((y, A) => {
      const { index: w, start: F, end: j } = A, N = y.includes(w), D = F < p && j > p;
      return !N && D ? y.concat([w]) : y;
    }, []);
  };
}
function nL(e, n, t) {
  const r = e.context.canScrollNext, o = e.context.canScrollPrev, a = e.context.isHorizontal, l = e.matches("autoplay"), u = e.context.scrollSnaps[e.context.index], f = Oh() ? tL(e.context)(u) : [];
  function p(y) {
    return {
      valueText: `Slide ${y.index + 1}`,
      current: y.index === e.context.index,
      next: y.index === e.context.index + 1,
      previous: y.index === e.context.index - 1,
      inView: f.includes(y.index)
    };
  }
  return {
    index: e.context.index,
    scrollProgress: e.context.scrollProgress,
    autoPlaying: l,
    canScrollNext: r,
    canScrollPrev: o,
    scrollTo(y, A) {
      n({ type: "GOTO", index: y, jump: A });
    },
    scrollToNext() {
      n("NEXT");
    },
    scrollToPrevious() {
      n("PREV");
    },
    getItemState: p,
    play() {
      n("PLAY");
    },
    pause() {
      n("PAUSE");
    },
    getRootProps() {
      return t.element({
        ...Jc.root.attrs,
        id: jn.getRootId(e.context),
        role: "region",
        "aria-roledescription": "carousel",
        "data-orientation": e.context.orientation,
        dir: e.context.dir,
        "aria-label": "Carousel",
        style: {
          "--slide-spacing": e.context.spacing,
          "--slide-size": `calc(100% / ${e.context.slidesPerView} - var(--slide-spacing))`
        }
      });
    },
    getViewportProps() {
      return t.element({
        ...Jc.viewport.attrs,
        dir: e.context.dir,
        id: jn.getViewportId(e.context),
        "data-orientation": e.context.orientation
      });
    },
    getItemGroupProps() {
      return t.element({
        ...Jc.itemGroup.attrs,
        id: jn.getItemGroupId(e.context),
        "data-orientation": e.context.orientation,
        dir: e.context.dir,
        style: {
          display: "flex",
          flexDirection: a ? "row" : "column",
          [a ? "height" : "width"]: "auto",
          gap: "var(--slide-spacing)",
          transform: e.context.translateValue,
          transitionProperty: "transform",
          willChange: "transform",
          transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
          transitionDuration: "0.3s"
        }
      });
    },
    getItemProps(y) {
      const A = p(y);
      return t.element({
        ...Jc.item.attrs,
        id: jn.getItemId(e.context, y.index),
        dir: e.context.dir,
        "data-current": se(A.current),
        "data-inview": se(A.inView),
        role: "group",
        "aria-roledescription": "slide",
        "data-orientation": e.context.orientation,
        "aria-label": A.valueText,
        style: {
          position: "relative",
          flex: "0 0 var(--slide-size)",
          [a ? "minWidth" : "minHeight"]: "0px"
        }
      });
    },
    getPrevTriggerProps() {
      return t.button({
        ...Jc.prevTrigger.attrs,
        id: jn.getPrevTriggerId(e.context),
        type: "button",
        tabIndex: -1,
        disabled: !o,
        dir: e.context.dir,
        "aria-label": "Previous Slide",
        "data-orientation": e.context.orientation,
        "aria-controls": jn.getItemGroupId(e.context),
        onClick() {
          n("PREV");
        }
      });
    },
    getNextTriggerProps() {
      return t.button({
        ...Jc.nextTrigger.attrs,
        dir: e.context.dir,
        id: jn.getNextTriggerId(e.context),
        type: "button",
        tabIndex: -1,
        "aria-label": "Next Slide",
        "data-orientation": e.context.orientation,
        "aria-controls": jn.getItemGroupId(e.context),
        disabled: !r,
        onClick() {
          n("NEXT");
        }
      });
    },
    getIndicatorGroupProps() {
      return t.element({
        ...Jc.indicatorGroup.attrs,
        dir: e.context.dir,
        id: jn.getIndicatorGroupId(e.context),
        "data-orientation": e.context.orientation
      });
    },
    getIndicatorProps(y) {
      return t.button({
        ...Jc.indicator.attrs,
        dir: e.context.dir,
        id: jn.getIndicatorId(e.context, y.index),
        type: "button",
        "data-orientation": e.context.orientation,
        "data-index": y.index,
        "data-readonly": se(y.readOnly),
        "data-current": se(y.index === e.context.index),
        onClick() {
          y.readOnly || n({ type: "GOTO", index: y.index });
        }
      });
    }
  };
}
function rL(e) {
  const n = br(e);
  return Rr(
    {
      id: "carousel",
      initial: "idle",
      context: {
        index: 0,
        orientation: "horizontal",
        align: "start",
        loop: !1,
        slidesPerView: 1,
        spacing: "0px",
        ...n,
        scrollSnaps: [],
        scrollProgress: 0,
        containerSize: 0,
        slideRects: []
      },
      watch: {
        index: ["setScrollSnaps"]
      },
      on: {
        NEXT: {
          actions: ["scrollToNext"]
        },
        PREV: {
          actions: ["scrollToPrev"]
        },
        GOTO: {
          actions: ["scrollTo"]
        },
        MEASURE_DOM: {
          actions: ["measureElements", "setScrollSnaps"]
        },
        PLAY: "autoplay"
      },
      states: {
        idle: {
          on: {
            POINTER_DOWN: "dragging"
          }
        },
        autoplay: {
          activities: ["trackDocumentVisibility"],
          every: {
            2e3: ["scrollToNext"]
          },
          on: {
            PAUSE: "idle"
          }
        },
        dragging: {
          on: {
            POINTER_UP: "idle",
            POINTER_MOVE: {
              actions: ["setScrollSnaps"]
            }
          }
        }
      },
      activities: ["trackContainerResize", "trackSlideMutation"],
      entry: ["measureElements", "setScrollSnaps"],
      computed: {
        isRtl: (t) => t.dir === "rtl",
        isHorizontal: (t) => t.orientation === "horizontal",
        isVertical: (t) => t.orientation === "vertical",
        canScrollNext: (t) => t.loop || t.index < t.scrollSnaps.length - 1,
        canScrollPrev: (t) => t.loop || t.index > 0,
        startEdge(t) {
          return t.isVertical ? "top" : t.isRtl ? "right" : "left";
        },
        endEdge(t) {
          return t.isVertical ? "bottom" : t.isRtl ? "left" : "right";
        },
        translateValue: (t) => {
          const r = t.scrollSnaps[t.index];
          return t.isHorizontal ? `translate3d(${r}px, 0, 0)` : `translate3d(0, ${r}px, 0)`;
        }
      }
    },
    {
      activities: {
        trackSlideMutation(t, r, { send: o }) {
          const a = jn.getSlideGroupEl(t);
          if (!a)
            return;
          const l = jn.getWin(t), u = new l.MutationObserver(() => {
            o({ type: "MEASURE_DOM", src: "mutation" });
          });
          return u.observe(a, { childList: !0 }), () => {
            u.disconnect();
          };
        },
        trackContainerResize(t, r, { send: o }) {
          const a = jn.getSlideGroupEl(t);
          if (!a)
            return;
          const l = jn.getWin(t), u = new l.ResizeObserver((f) => {
            f.forEach((p) => {
              p.target === a && o({ type: "MEASURE_DOM", src: "resize" });
            });
          });
          return u.observe(a), () => {
            u.disconnect();
          };
        },
        trackDocumentVisibility(t, r, { send: o }) {
          const a = jn.getDoc(t), l = () => {
            a.visibilityState !== "visible" && o({ type: "PAUSE", src: "document-hidden" });
          };
          return a.addEventListener("visibilitychange", l), () => {
            a.removeEventListener("visibilitychange", l);
          };
        }
      },
      guards: {
        loop: (t) => t.loop,
        isLastSlide: (t) => t.index === t.slideRects.length - 1,
        isFirstSlide: (t) => t.index === 0
      },
      actions: {
        scrollToNext(t) {
          const r = QA(t.slideRects, t.index);
          Vm.index(t, r);
        },
        scrollToPrev(t) {
          const r = zD(t.slideRects, t.index);
          Vm.index(t, r);
        },
        setScrollSnaps(t) {
          const { snapsAligned: r, scrollProgress: o } = vw(t);
          t.scrollSnaps = r, t.scrollProgress = o;
        },
        scrollTo(t, r) {
          const o = Math.max(0, Math.min(r.index, t.slideRects.length - 1));
          Vm.index(t, o);
        },
        measureElements: oL
      }
    }
  );
}
var oL = (e) => {
  const n = jn.getSlideGroupEl(e);
  n && (e.containerRect = Hn(n.getBoundingClientRect()), e.containerSize = e.isHorizontal ? e.containerRect.width : e.containerRect.height, e.slideRects = Hn(jn.getSlideEls(e).map((t) => t.getBoundingClientRect())));
}, iL = {
  change: (e) => {
    var n;
    (n = e.onIndexChange) == null || n.call(e, { index: e.index });
  }
}, Vm = {
  index: (e, n) => {
    vr(e.index, n) || (e.index = n, iL.change(e));
  }
};
nn()([
  "align",
  "dir",
  "getRootNode",
  "id",
  "ids",
  "index",
  "loop",
  "onIndexChange",
  "orientation",
  "slidesPerView",
  "spacing"
]);
nn()(["index", "readOnly"]);
const aL = (e = {}) => {
  const { getRootNode: n } = Jr(), { dir: t } = ko(), r = {
    id: gr(),
    dir: t,
    getRootNode: n,
    index: e.defaultIndex,
    ...e
  }, o = {
    ...r,
    index: e.index,
    onIndexChange: en(e.onIndexChange, { sync: !0 })
  }, [a, l] = Or(rL(r), { context: o });
  return nL(a, l, yr);
}, bw = oe((e, n) => {
  const [t, r] = Ft()(e, [
    "align",
    "defaultIndex",
    "id",
    "ids",
    "index",
    "loop",
    "onIndexChange",
    "orientation",
    "slidesPerView",
    "spacing"
  ]), o = aL(t), a = be(o.getRootProps(), r);
  return /* @__PURE__ */ I.jsx(uN, { value: o, children: /* @__PURE__ */ I.jsx(ve.div, { ...a, ref: n }) });
});
bw.displayName = "CarouselRoot";
const yw = oe((e, n) => {
  const t = Nf(), r = be(t.getViewportProps(), e);
  return /* @__PURE__ */ I.jsx(ve.div, { ...r, ref: n });
});
yw.displayName = "CarouselViewport";
const [sL, zb] = xt({
  name: "CheckboxContext",
  hookName: "useCheckboxContext",
  providerName: "<CheckboxProvider />"
}), Cw = oe((e, n) => {
  const t = zb(), r = be(t.getControlProps(), e);
  return /* @__PURE__ */ I.jsx(ve.div, { ...r, ref: n });
});
Cw.displayName = "CheckboxControl";
const Ew = oe(
  (e, n) => {
    const t = zb(), r = be(t.getHiddenInputProps(), e);
    return /* @__PURE__ */ I.jsx(ve.input, { ...r, ref: n });
  }
);
Ew.displayName = "CheckboxHiddenInput";
var Hp = (e, n = []) => ({
  parts: (...t) => {
    if (lL(n))
      return Hp(e, t);
    throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
  },
  extendWith: (...t) => Hp(e, [...n, ...t]),
  rename: (t) => Hp(t, n),
  keys: () => n,
  build: () => [...new Set(n)].reduce(
    (t, r) => Object.assign(t, {
      [r]: {
        selector: [
          `&[data-scope="${nf(e)}"][data-part="${nf(r)}"]`,
          `& [data-scope="${nf(e)}"][data-part="${nf(r)}"]`
        ].join(", "),
        attrs: { "data-scope": nf(e), "data-part": nf(r) }
      }
    }),
    {}
  )
}), nf = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), lL = (e) => e.length === 0, Zb = (e) => e.ownerDocument.defaultView || window;
function Aw(e, n) {
  const { type: t = "HTMLInputElement", property: r = "value" } = n, o = Zb(e)[t].prototype;
  return Object.getOwnPropertyDescriptor(o, r) ?? {};
}
function cL(e, n, t = {}) {
  var o;
  (o = Aw(e, t).set) == null || o.call(e, n), e.setAttribute("value", n);
}
function Sw(e, n) {
  var r;
  (r = Aw(e, { type: "HTMLInputElement", property: "checked" }).set) == null || r.call(e, n), n ? e.setAttribute("checked", "") : e.removeAttribute("checked");
}
function uL(e, n) {
  const { value: t, bubbles: r = !0 } = n;
  if (!e)
    return;
  const o = Zb(e);
  e instanceof o.HTMLInputElement && (cL(e, `${t}`), e.dispatchEvent(new o.Event("input", { bubbles: r })));
}
function Kb(e, n) {
  const { checked: t, bubbles: r = !0 } = n;
  if (!e)
    return;
  const o = Zb(e);
  e instanceof o.HTMLInputElement && (Sw(e, t), e.dispatchEvent(new o.Event("click", { bubbles: r })), e.dispatchEvent(new o.Event("change", { bubbles: r })));
}
function dL(e) {
  return fL(e) ? e.form : e.closest("form");
}
function fL(e) {
  return e.matches("textarea, input, select, button");
}
function gL(e, n) {
  if (!e)
    return;
  const t = dL(e);
  return t == null || t.addEventListener("reset", n, { passive: !0 }), () => {
    t == null || t.removeEventListener("reset", n);
  };
}
function pL(e, n) {
  const t = e == null ? void 0 : e.closest("fieldset");
  if (!t)
    return;
  n(t.disabled);
  const r = t.ownerDocument.defaultView || window, o = new r.MutationObserver(() => n(t.disabled));
  return o.observe(t, {
    attributes: !0,
    attributeFilter: ["disabled"]
  }), () => o.disconnect();
}
function jf(e, n) {
  if (!e)
    return;
  const { onFieldsetDisabledChange: t, onFormReset: r } = n, o = [gL(e, r), pL(e, t)];
  return () => {
    o.forEach((a) => a == null ? void 0 : a());
  };
}
var hL = Hp("checkbox").parts("root", "label", "control", "indicator"), hp = hL.build(), io = so({
  getRootId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.root) ?? `checkbox:${e.id}`;
  },
  getLabelId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.label) ?? `checkbox:${e.id}:label`;
  },
  getControlId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.control) ?? `checkbox:${e.id}:control`;
  },
  getHiddenInputId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.hiddenInput) ?? `checkbox:${e.id}:hidden`;
  },
  getRootEl: (e) => io.getById(e, io.getRootId(e)),
  getHiddenInputEl: (e) => io.getById(e, io.getHiddenInputId(e))
});
function mL(e, n, t) {
  const r = e.context.isDisabled, o = !r && e.context.focused, a = e.context.isChecked, l = e.context.isIndeterminate, u = e.context.readOnly, f = {
    "data-active": se(e.context.active),
    "data-focus": se(o),
    "data-readonly": se(u),
    "data-hover": se(e.context.hovered),
    "data-disabled": se(r),
    "data-state": l ? "indeterminate" : e.context.checked ? "checked" : "unchecked",
    "data-invalid": se(e.context.invalid)
  };
  return {
    checked: a,
    disabled: r,
    indeterminate: l,
    focused: o,
    checkedState: e.context.checked,
    setChecked(p) {
      n({ type: "CHECKED.SET", checked: p, isTrusted: !1 });
    },
    toggleChecked() {
      n({ type: "CHECKED.TOGGLE", checked: a, isTrusted: !1 });
    },
    getRootProps() {
      return t.label({
        ...hp.root.attrs,
        ...f,
        dir: e.context.dir,
        id: io.getRootId(e.context),
        htmlFor: io.getHiddenInputId(e.context),
        onPointerMove() {
          r || n({ type: "CONTEXT.SET", context: { hovered: !0 } });
        },
        onPointerLeave() {
          r || n({ type: "CONTEXT.SET", context: { hovered: !1 } });
        },
        onClick(p) {
          p.target === io.getHiddenInputEl(e.context) && p.stopPropagation();
        }
      });
    },
    getLabelProps() {
      return t.element({
        ...hp.label.attrs,
        ...f,
        dir: e.context.dir,
        id: io.getLabelId(e.context)
      });
    },
    getControlProps() {
      return t.element({
        ...hp.control.attrs,
        ...f,
        dir: e.context.dir,
        id: io.getControlId(e.context),
        "aria-hidden": !0
      });
    },
    getIndicatorProps() {
      return t.element({
        ...hp.indicator.attrs,
        ...f,
        dir: e.context.dir,
        hidden: !l && !e.context.checked
      });
    },
    getHiddenInputProps() {
      return t.input({
        id: io.getHiddenInputId(e.context),
        type: "checkbox",
        required: e.context.required,
        defaultChecked: a,
        disabled: r,
        "aria-labelledby": io.getLabelId(e.context),
        "aria-invalid": e.context.invalid,
        name: e.context.name,
        form: e.context.form,
        value: e.context.value,
        style: Ff,
        onChange(p) {
          if (u) {
            p.preventDefault();
            return;
          }
          const y = p.currentTarget.checked;
          n({ type: "CHECKED.SET", checked: y, isTrusted: !0 });
        }
      });
    }
  };
}
var { not: sC } = Ma;
function vL(e) {
  const n = br(e);
  return Rr(
    {
      id: "checkbox",
      initial: "ready",
      context: {
        checked: !1,
        value: "on",
        disabled: !1,
        ...n,
        fieldsetDisabled: !1
      },
      watch: {
        disabled: "removeFocusIfNeeded",
        checked: "syncInputElement"
      },
      activities: ["trackFormControlState", "trackPressEvent", "trackFocusVisible"],
      on: {
        "CHECKED.TOGGLE": [
          {
            guard: sC("isTrusted"),
            actions: ["toggleChecked", "dispatchChangeEvent"]
          },
          {
            actions: ["toggleChecked"]
          }
        ],
        "CHECKED.SET": [
          {
            guard: sC("isTrusted"),
            actions: ["setChecked", "dispatchChangeEvent"]
          },
          {
            actions: ["setChecked"]
          }
        ],
        "CONTEXT.SET": {
          actions: ["setContext"]
        }
      },
      computed: {
        isIndeterminate: (t) => Yv(t.checked),
        isChecked: (t) => lC(t.checked),
        isDisabled: (t) => !!t.disabled || t.fieldsetDisabled
      },
      states: {
        ready: {}
      }
    },
    {
      guards: {
        isTrusted: (t, r) => !!r.isTrusted
      },
      activities: {
        trackPressEvent(t) {
          if (!t.isDisabled)
            return zA({
              pointerNode: io.getRootEl(t),
              keyboardNode: io.getHiddenInputEl(t),
              isValidKey: (r) => r.key === " ",
              onPress: () => t.active = !1,
              onPressStart: () => t.active = !0,
              onPressEnd: () => t.active = !1
            });
        },
        trackFocusVisible(t) {
          if (!t.isDisabled)
            return YA(io.getHiddenInputEl(t), {
              onFocus: () => t.focused = !0,
              onBlur: () => t.focused = !1
            });
        },
        trackFormControlState(t, r, { send: o, initialContext: a }) {
          return jf(io.getHiddenInputEl(t), {
            onFieldsetDisabledChange(l) {
              t.fieldsetDisabled = l;
            },
            onFormReset() {
              o({ type: "CHECKED.SET", checked: !!a.checked });
            }
          });
        }
      },
      actions: {
        setContext(t, r) {
          Object.assign(t, r.context);
        },
        syncInputElement(t) {
          const r = io.getHiddenInputEl(t);
          r && (Sw(r, t.isChecked), r.indeterminate = t.isIndeterminate);
        },
        removeFocusIfNeeded(t) {
          t.disabled && t.focused && (t.focused = !1);
        },
        setChecked(t, r) {
          cC.checked(t, r.checked);
        },
        toggleChecked(t) {
          const r = Yv(t.checked) ? !0 : !t.checked;
          cC.checked(t, r);
        },
        dispatchChangeEvent(t) {
          const r = io.getHiddenInputEl(t);
          Kb(r, { checked: lC(t.checked) });
        }
      }
    }
  );
}
function Yv(e) {
  return e === "indeterminate";
}
function lC(e) {
  return Yv(e) ? !1 : !!e;
}
var bL = {
  change: (e) => {
    var n;
    (n = e.onCheckedChange) == null || n.call(e, { checked: e.checked });
  }
}, cC = {
  checked: (e, n) => {
    vr(e.checked, n) || (e.checked = n, bL.change(e));
  }
};
nn()([
  "checked",
  "dir",
  "disabled",
  "form",
  "getRootNode",
  "id",
  "ids",
  "invalid",
  "name",
  "onCheckedChange",
  "readOnly",
  "required",
  "value"
]);
const yL = (e = {}) => {
  const { getRootNode: n } = Jr(), { dir: t } = ko(), r = {
    id: gr(),
    dir: t,
    getRootNode: n,
    checked: e.defaultChecked,
    ...e
  }, o = {
    ...r,
    checked: e.checked,
    onCheckedChange: en(e.onCheckedChange, { sync: !0 })
  }, [a, l] = Or(vL(r), { context: o });
  return mL(a, l, yr);
}, ww = oe((e, n) => {
  const [t, r] = Ft()(e, [
    "checked",
    "defaultChecked",
    "disabled",
    "form",
    "id",
    "ids",
    "invalid",
    "name",
    "onCheckedChange",
    "readOnly",
    "required",
    "value"
  ]), o = yL(t), a = be(o.getRootProps(), r);
  return /* @__PURE__ */ I.jsx(sL, { value: o, children: /* @__PURE__ */ I.jsx(ve.label, { ...a, ref: n }) });
});
ww.displayName = "CheckboxRoot";
const [CL, Xb] = xt({
  name: "ClipboardContext",
  hookName: "useClipboardContext",
  providerName: "<ClipboardProvider />"
}), Iw = oe((e, n) => {
  const t = Xb(), r = be(t.getControlProps(), e);
  return /* @__PURE__ */ I.jsx(ve.div, { ...r, ref: n });
});
Iw.displayName = "ClipboardControl";
const xw = oe(
  (e, n) => {
    const { children: t, copied: r, ...o } = e, a = Xb(), l = be(
      a.getIndicatorProps({ copied: a.copied }),
      o
    );
    return /* @__PURE__ */ I.jsx(ve.div, { ...l, ref: n, children: a.copied ? r : t });
  }
);
xw.displayName = "ClipboardIndicator";
var Gp = (e, n = []) => ({
  parts: (...t) => {
    if (EL(n))
      return Gp(e, t);
    throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
  },
  extendWith: (...t) => Gp(e, [...n, ...t]),
  rename: (t) => Gp(t, n),
  keys: () => n,
  build: () => [...new Set(n)].reduce(
    (t, r) => Object.assign(t, {
      [r]: {
        selector: [
          `&[data-scope="${rf(e)}"][data-part="${rf(r)}"]`,
          `& [data-scope="${rf(e)}"][data-part="${rf(r)}"]`
        ].join(", "),
        attrs: { "data-scope": rf(e), "data-part": rf(r) }
      }
    }),
    {}
  )
}), rf = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), EL = (e) => e.length === 0, AL = Gp("clipboard").parts("root", "control", "trigger", "indicator", "input", "label"), of = AL.build(), tl = so({
  getRootId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.root) ?? `clip-${e.id}`;
  },
  getInputId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.input) ?? `clip-input-${e.id}`;
  },
  getLabelId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.label) ?? `clip-label-${e.id}`;
  },
  getInputEl: (e) => tl.getById(e, tl.getInputId(e)),
  writeToClipboard: (e) => IL(tl.getDoc(e), e.value)
});
function SL(e, n) {
  const t = e.createElement("pre");
  return Object.assign(t.style, {
    width: "1px",
    height: "1px",
    position: "fixed",
    top: "5px"
  }), t.textContent = n, t;
}
function wL(e) {
  const t = cl(e).getSelection();
  if (t == null)
    return Promise.reject(new Error());
  t.removeAllRanges();
  const r = e.ownerDocument, o = r.createRange();
  return o.selectNodeContents(e), t.addRange(o), r.execCommand("copy"), t.removeAllRanges(), Promise.resolve();
}
function IL(e, n) {
  var o;
  const t = e.defaultView || window;
  if (((o = t.navigator.clipboard) == null ? void 0 : o.writeText) !== void 0)
    return t.navigator.clipboard.writeText(n);
  if (!e.body)
    return Promise.reject(new Error());
  const r = SL(e, n);
  return e.body.appendChild(r), wL(r), e.body.removeChild(r), Promise.resolve();
}
function xL(e, n, t) {
  const r = e.matches("copied");
  return {
    copied: r,
    value: e.context.value,
    setValue(o) {
      n({ type: "VALUE.SET", value: o });
    },
    copy() {
      n({ type: "COPY" });
    },
    getRootProps() {
      return t.element({
        ...of.root.attrs,
        "data-copied": se(r),
        id: tl.getRootId(e.context)
      });
    },
    getLabelProps() {
      return t.label({
        ...of.label.attrs,
        htmlFor: tl.getInputId(e.context),
        "data-copied": se(r),
        id: tl.getLabelId(e.context)
      });
    },
    getControlProps() {
      return t.element({
        ...of.control.attrs,
        "data-copied": se(r)
      });
    },
    getInputProps() {
      return t.input({
        ...of.input.attrs,
        defaultValue: e.context.value,
        "data-copied": se(r),
        readOnly: !0,
        "data-readonly": "true",
        id: tl.getInputId(e.context),
        onFocus(o) {
          o.currentTarget.select();
        },
        onCopy() {
          n({ type: "INPUT.COPY" });
        }
      });
    },
    getTriggerProps() {
      return t.button({
        ...of.trigger.attrs,
        "aria-label": r ? "Copied to clipboard" : "Copy to clipboard",
        "data-copied": se(r),
        onClick() {
          n({ type: "COPY" });
        }
      });
    },
    getIndicatorProps(o) {
      return t.element({
        ...of.indicator.attrs,
        hidden: o.copied !== r
      });
    }
  };
}
function TL(e) {
  const n = br(e);
  return Rr(
    {
      id: "clipboard",
      initial: "idle",
      context: {
        value: "",
        timeout: 3e3,
        ...n
      },
      watch: {
        value: ["syncInputElement"]
      },
      on: {
        "VALUE.SET": {
          actions: ["setValue"]
        },
        COPY: {
          target: "copied",
          actions: ["copyToClipboard", "invokeOnCopy"]
        }
      },
      states: {
        idle: {
          on: {
            "INPUT.COPY": {
              target: "copied",
              actions: ["invokeOnCopy"]
            }
          }
        },
        copied: {
          after: {
            COPY_TIMEOUT: "idle"
          },
          on: {
            COPY: {
              target: "copied",
              actions: ["copyToClipboard", "invokeOnCopy"]
            },
            "INPUT.COPY": {
              actions: ["invokeOnCopy"]
            }
          }
        }
      }
    },
    {
      actions: {
        setValue(t, r) {
          t.value = r.value;
        },
        copyToClipboard(t) {
          tl.writeToClipboard(t);
        },
        invokeOnCopy(t) {
          var r;
          (r = t.onStatusChange) == null || r.call(t, { copied: !0 });
        },
        syncInputElement(t) {
          tl.setValue(tl.getInputEl(t), t.value);
        }
      },
      delays: {
        COPY_TIMEOUT: (t) => t.timeout
      }
    }
  );
}
nn()([
  "getRootNode",
  "id",
  "ids",
  "value",
  "timeout",
  "onStatusChange"
]);
nn()(["copied"]);
const PL = (e) => {
  const { getRootNode: n } = Jr(), t = {
    id: gr(),
    getRootNode: n,
    ...e
  }, r = {
    ...t
  }, [o, a] = Or(TL(t), { context: r });
  return xL(o, a, yr);
}, Tw = oe((e, n) => {
  const [t, r] = Ft()(e, [
    "id",
    "ids",
    "onStatusChange",
    "timeout",
    "value"
  ]), o = PL(t), a = be(o.getRootProps(), r);
  return /* @__PURE__ */ I.jsx(CL, { value: o, children: /* @__PURE__ */ I.jsx(ve.div, { ref: n, ...a }) });
});
Tw.displayName = "ClipboardRoot";
const Pw = oe(
  (e, n) => {
    const t = Xb(), r = be(t.getTriggerProps(), e);
    return /* @__PURE__ */ I.jsx(ve.button, { ...r, ref: n });
  }
);
Pw.displayName = "ClipboardTrigger";
const [kL, kw] = xt({
  name: "ColorPickerAreaContext",
  hookName: "useColorPickerAreaContext",
  providerName: "<ColorPickerAreaProvider />"
}), [RL, lo] = xt({
  name: "ColorPickerContext",
  hookName: "useColorPickerContext",
  providerName: "<ColorPickerProvider />"
}), Rw = oe((e, n) => {
  const [t, r] = Ft()(e, ["xChannel", "yChannel"]), o = lo(), a = be(o.getAreaProps(t), r);
  return /* @__PURE__ */ I.jsx(kL, { value: t, children: /* @__PURE__ */ I.jsx(ve.div, { ...a, ref: n }) });
});
Rw.displayName = "ColorPickerArea";
const Ow = oe(
  (e, n) => {
    const t = lo(), r = kw(), o = be(t.getAreaBackgroundProps(r), e);
    return /* @__PURE__ */ I.jsx(ve.div, { ...o, ref: n });
  }
);
Ow.displayName = "ColorPickerAreaBackground";
const Dw = oe(
  (e, n) => {
    const t = lo(), r = kw(), o = be(t.getAreaThumbProps(r), e);
    return /* @__PURE__ */ I.jsx(ve.div, { ...o, ref: n });
  }
);
Dw.displayName = "ColorPickerAreaThumb";
const Fw = oe(
  (e, n) => {
    const [t, r] = Ft()(e, [
      "channel",
      "orientation"
    ]), o = lo(), a = be(o.getChannelInputProps(t), r);
    return /* @__PURE__ */ I.jsx(ve.input, { ...a, ref: n });
  }
);
Fw.displayName = "ColorPickerChannelInput";
const [OL, Nw] = xt({
  name: "ColorPickerChannelSliderContext",
  hookName: "useColorPickerChannelSliderContext",
  providerName: "<ColorPickerChannelSliderProvider />"
}), Mw = oe(
  (e, n) => {
    const [t, r] = Ft()(e, [
      "channel",
      "orientation"
    ]), o = lo(), a = be(o.getChannelSliderProps(t), r);
    return /* @__PURE__ */ I.jsx(OL, { value: t, children: /* @__PURE__ */ I.jsx(ve.div, { ...a, ref: n }) });
  }
);
Mw.displayName = "ColorPickerChannelSlider";
const Lw = oe((e, n) => {
  const t = lo(), r = Nw(), o = be(t.getChannelSliderThumbProps(r), e);
  return /* @__PURE__ */ I.jsx(ve.div, { ...o, ref: n });
});
Lw.displayName = "ColorPickerChannelSliderThumb";
const Bw = oe((e, n) => {
  const t = lo(), r = Nw(), o = be(t.getChannelSliderTrackProps(r), e);
  return /* @__PURE__ */ I.jsx(ve.div, { ...o, ref: n });
});
Bw.displayName = "ColorPickerChannelSliderTrack";
const [Ad, oa] = xt({
  name: "PresenceContext",
  hookName: "usePresenceContext",
  providerName: "<PresenceProvider />"
}), Vw = oe(
  (e, n) => {
    const t = lo(), r = oa(), o = be(
      t.getContentProps(),
      r.getPresenceProps(n),
      e
    );
    return r.unmounted ? null : /* @__PURE__ */ I.jsx(ve.div, { ...o });
  }
);
Vw.displayName = "ColorPickerContent";
const DL = (e) => e.children(lo()), jw = oe(
  (e, n) => {
    const t = lo(), r = be(t.getControlProps(), e);
    return /* @__PURE__ */ I.jsx(ve.div, { ...r, ref: n });
  }
);
jw.displayName = "ColorPickerControl";
const Uw = oe((e, n) => {
  const t = lo(), r = be(t.getEyeDropperTriggerProps(), e);
  return /* @__PURE__ */ I.jsx(ve.button, { ...r, ref: n });
});
Uw.displayName = "ColorPickerEyeDropperTrigger";
const Ww = oe(
  (e, n) => {
    const t = lo(), r = be(t.getHiddenInputProps(), e);
    return /* @__PURE__ */ I.jsx(ve.input, { ...r, ref: n });
  }
);
Ww.displayName = "ColorPickerHiddenInput";
const Hw = oe(
  (e, n) => {
    const t = lo(), r = be(t.getLabelProps(), e);
    return /* @__PURE__ */ I.jsx(ve.label, { ...r, ref: n });
  }
);
Hw.displayName = "ColorPickerLabel";
const Gw = oe(
  (e, n) => {
    const t = lo(), r = be(t.getPositionerProps(), e);
    return oa().unmounted ? null : /* @__PURE__ */ I.jsx(ve.div, { ...r, ref: n });
  }
);
Gw.displayName = "ColorPickerPositioner";
const fu = (e) => Ft()(e, [
  "lazyMount",
  "onExitComplete",
  "present",
  "unmountOnExit"
]);
function FL(e, n, t) {
  const r = e.matches("mounted", "unmountSuspended");
  return {
    skip: !e.context.initial && r,
    present: r,
    setNode(o) {
      o && n({ type: "NODE.SET", node: o });
    },
    unmount() {
      n({ type: "UNMOUNT" });
    }
  };
}
function mp(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function NL(e) {
  return Rr(
    {
      initial: e.present ? "mounted" : "unmounted",
      context: {
        node: null,
        styles: null,
        unmountAnimationName: null,
        prevAnimationName: null,
        present: !1,
        initial: !1,
        ...e
      },
      exit: ["clearInitial"],
      watch: {
        present: ["setInitial", "syncPresence"]
      },
      on: {
        "NODE.SET": {
          actions: ["setNode", "setStyles"]
        }
      },
      states: {
        mounted: {
          on: {
            UNMOUNT: {
              target: "unmounted",
              actions: ["invokeOnExitComplete"]
            },
            "UNMOUNT.SUSPEND": "unmountSuspended"
          }
        },
        unmountSuspended: {
          activities: ["trackAnimationEvents"],
          on: {
            MOUNT: {
              target: "mounted",
              actions: ["setPrevAnimationName"]
            },
            "ANIMATION.END": {
              target: "unmounted",
              actions: ["invokeOnExitComplete"]
            },
            UNMOUNT: {
              target: "unmounted",
              actions: ["invokeOnExitComplete"]
            }
          }
        },
        unmounted: {
          entry: ["clearPrevAnimationName"],
          on: {
            MOUNT: {
              target: "mounted",
              actions: ["setPrevAnimationName"]
            }
          }
        }
      }
    },
    {
      actions: {
        setInitial(n) {
          n.initial = !0;
        },
        clearInitial(n) {
          n.initial = !1;
        },
        invokeOnExitComplete(n) {
          var t;
          (t = n.onExitComplete) == null || t.call(n);
        },
        setNode(n, t) {
          n.node = Hn(t.node);
        },
        setStyles(n, t) {
          const r = t.node.ownerDocument.defaultView || window;
          n.styles = Hn(r.getComputedStyle(t.node));
        },
        syncPresence(n, t, { send: r }) {
          if (n.rafId && cancelAnimationFrame(n.rafId), n.present) {
            r({ type: "MOUNT", src: "presence.changed" });
            return;
          }
          n.rafId = requestAnimationFrame(() => {
            var a;
            const o = mp(n.styles);
            n.unmountAnimationName = o, o === "none" || o === n.prevAnimationName || ((a = n.styles) == null ? void 0 : a.display) === "none" ? r({ type: "UNMOUNT", src: "presence.changed" }) : r({ type: "UNMOUNT.SUSPEND" });
          });
        },
        setPrevAnimationName(n) {
          requestAnimationFrame(() => {
            n.prevAnimationName = mp(n.styles);
          });
        },
        clearPrevAnimationName(n) {
          n.prevAnimationName = null;
        }
      },
      activities: {
        trackAnimationEvents(n, t, { send: r }) {
          const o = n.node;
          if (!o)
            return;
          const a = (u) => {
            u.target === o && (n.prevAnimationName = mp(n.styles));
          }, l = (u) => {
            const f = mp(n.styles);
            u.target === o && f === n.unmountAnimationName && r({ type: "UNMOUNT", src: "animationend" });
          };
          return o.addEventListener("animationstart", a), o.addEventListener("animationcancel", l), o.addEventListener("animationend", l), () => {
            o.removeEventListener("animationstart", a), o.removeEventListener("animationcancel", l), o.removeEventListener("animationend", l);
          };
        }
      }
    }
  );
}
nn()(["onExitComplete", "present"]);
const cc = (e) => {
  const { lazyMount: n, unmountOnExit: t, ...r } = e, o = Fa(!1), a = {
    ...r,
    onExitComplete: en(e.onExitComplete)
  }, [l, u] = Or(NL(a), { context: a }), f = FL(l, u);
  f.present && (o.current = !0);
  const p = !f.present && !o.current && n || t && !f.present && o.current;
  return {
    getPresenceProps: (A) => ({
      ref: yS(f.setNode, A),
      "data-state": e.present ? "open" : "closed",
      hidden: !f.present
    }),
    present: f.present,
    unmounted: p
  };
};
var Yp = (e, n = []) => ({
  parts: (...t) => {
    if (ML(n))
      return Yp(e, t);
    throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
  },
  extendWith: (...t) => Yp(e, [...n, ...t]),
  rename: (t) => Yp(t, n),
  keys: () => n,
  build: () => [...new Set(n)].reduce(
    (t, r) => Object.assign(t, {
      [r]: {
        selector: [
          `&[data-scope="${af(e)}"][data-part="${af(r)}"]`,
          `& [data-scope="${af(e)}"][data-part="${af(r)}"]`
        ].join(", "),
        attrs: { "data-scope": af(e), "data-part": af(r) }
      }
    }),
    {}
  )
}), af = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), ML = (e) => e.length === 0;
function LL(e, n, t) {
  return Math.round((e - n) / t) * t + n;
}
function nl(e, n, t) {
  return Math.min(Math.max(e, n), t);
}
function BL(e, n, t) {
  return (e - n) / (t - n);
}
function VL(e, n, t, r) {
  const o = e * (t - n) + n, a = LL(o, n, r);
  return nl(a, n, t);
}
function vp(e, n) {
  let t = e, r = n.toString(), o = r.indexOf("."), a = o >= 0 ? r.length - o : 0;
  if (a > 0) {
    let l = Math.pow(10, a);
    t = Math.round(t * l) / l;
  }
  return t;
}
function uC(e, n, t, r) {
  n = Number(n), t = Number(t);
  let o = (e - (isNaN(n) ? 0 : n)) % r, a = vp(
    Math.abs(o) * 2 >= r ? e + Math.sign(o) * (r - Math.abs(o)) : e - o,
    r
  );
  return isNaN(n) ? !isNaN(t) && a > t && (a = Math.floor(vp(t / r, r)) * r) : a < n ? a = n : !isNaN(t) && a > t && (a = n + Math.floor(vp((t - n) / r, r)) * r), a = vp(a, r), a;
}
function kn(e, n = 0, t = 10) {
  const r = Math.pow(t, n);
  return Math.round(e * r) / r;
}
function Yw(e, n) {
  return (e % n + n) % n;
}
var jL = Object.defineProperty, UL = (e, n, t) => n in e ? jL(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, Jb = (e, n, t) => (UL(e, typeof n != "symbol" ? n + "" : n, t), t), WL = (e, n, t) => {
  const r = `linear-gradient(to ${e[+!n]}, transparent, #000)`;
  return {
    areaStyles: {
      backgroundImage: `linear-gradient(to ${e[Number(n)]},rgb(${t},0,0),rgb(${t},255,0))`
    },
    areaGradientStyles: {
      backgroundImage: `linear-gradient(to ${e[Number(n)]},rgb(${t},0,255),rgb(${t},255,255))`,
      WebkitMaskImage: r,
      maskImage: r
    }
  };
}, HL = (e, n, t) => {
  const r = `linear-gradient(to ${e[+!n]}, transparent, #000)`;
  return {
    areaStyles: {
      backgroundImage: `linear-gradient(to ${e[Number(n)]},rgb(0,${t},0),rgb(255,${t},0))`
    },
    areaGradientStyles: {
      backgroundImage: `linear-gradient(to ${e[Number(n)]},rgb(0,${t},255),rgb(255,${t},255))`,
      WebkitMaskImage: r,
      maskImage: r
    }
  };
}, GL = (e, n, t) => {
  const r = `linear-gradient(to ${e[+!n]}, transparent, #000)`;
  return {
    areaStyles: {
      backgroundImage: `linear-gradient(to ${e[Number(n)]},rgb(0,0,${t}),rgb(255,0,${t}))`
    },
    areaGradientStyles: {
      backgroundImage: `linear-gradient(to ${e[Number(n)]},rgb(0,255,${t}),rgb(255,255,${t}))`,
      WebkitMaskImage: r,
      maskImage: r
    }
  };
}, YL = (e, n, t) => ({
  areaStyles: {},
  areaGradientStyles: {
    background: [
      `linear-gradient(to ${e[Number(n)]}, hsla(0,0%,0%,1) 0%, hsla(0,0%,0%,0) 50%, hsla(0,0%,100%,0) 50%, hsla(0,0%,100%,1) 100%)`,
      `linear-gradient(to ${e[+!n]},hsl(0,0%,50%),hsla(0,0%,50%,0))`,
      `hsl(${t}, 100%, 50%)`
    ].join(",")
  }
}), zL = (e, n, t) => ({
  areaStyles: {},
  areaGradientStyles: {
    background: [
      `linear-gradient(to ${e[+!n]}, hsla(0,0%,0%,${t}) 0%, hsla(0,0%,0%,0) 50%, hsla(0,0%,100%,0) 50%, hsla(0,0%,100%,${t}) 100%)`,
      `linear-gradient(to ${e[Number(n)]},hsla(0,100%,50%,${t}),hsla(60,100%,50%,${t}),hsla(120,100%,50%,${t}),hsla(180,100%,50%,${t}),hsla(240,100%,50%,${t}),hsla(300,100%,50%,${t}),hsla(359,100%,50%,${t}))`,
      "hsl(0, 0%, 50%)"
    ].join(",")
  }
}), ZL = (e, n, t) => ({
  areaStyles: {},
  areaGradientStyles: {
    backgroundImage: [
      `linear-gradient(to ${e[+!n]},hsl(0,0%,${t}%),hsla(0,0%,${t}%,0))`,
      `linear-gradient(to ${e[Number(n)]},hsl(0,100%,${t}%),hsl(60,100%,${t}%),hsl(120,100%,${t}%),hsl(180,100%,${t}%),hsl(240,100%,${t}%),hsl(300,100%,${t}%),hsl(360,100%,${t}%))`
    ].join(",")
  }
}), KL = (e, n, t) => ({
  areaStyles: {},
  areaGradientStyles: {
    background: [
      `linear-gradient(to ${e[Number(n)]},hsl(0,0%,0%),hsla(0,0%,0%,0))`,
      `linear-gradient(to ${e[+!n]},hsl(0,0%,100%),hsla(0,0%,100%,0))`,
      `hsl(${t}, 100%, 50%)`
    ].join(",")
  }
}), XL = (e, n, t) => ({
  areaStyles: {},
  areaGradientStyles: {
    background: [
      `linear-gradient(to ${e[+!n]},hsla(0,0%,0%,${t}),hsla(0,0%,0%,0))`,
      `linear-gradient(to ${e[Number(n)]},hsla(0,100%,50%,${t}),hsla(60,100%,50%,${t}),hsla(120,100%,50%,${t}),hsla(180,100%,50%,${t}),hsla(240,100%,50%,${t}),hsla(300,100%,50%,${t}),hsla(359,100%,50%,${t}))`,
      `linear-gradient(to ${e[+!n]},hsl(0,0%,0%),hsl(0,0%,100%))`
    ].join(",")
  }
}), JL = (e, n, t) => ({
  areaStyles: {},
  areaGradientStyles: {
    background: [
      `linear-gradient(to ${e[+!n]},hsla(0,0%,100%,${t}),hsla(0,0%,100%,0))`,
      `linear-gradient(to ${e[Number(n)]},hsla(0,100%,50%,${t}),hsla(60,100%,50%,${t}),hsla(120,100%,50%,${t}),hsla(180,100%,50%,${t}),hsla(240,100%,50%,${t}),hsla(300,100%,50%,${t}),hsla(359,100%,50%,${t}))`,
      "#000"
    ].join(",")
  }
});
function dC(e, n) {
  const { xChannel: t, yChannel: r, dir: o = "ltr" } = n, { zChannel: a } = e.getColorAxes({ xChannel: t, yChannel: r }), l = e.getChannelValue(a), { minValue: u, maxValue: f } = e.getChannelRange(a), p = ["top", o === "rtl" ? "left" : "right"];
  let y = !1, A = { areaStyles: {}, areaGradientStyles: {} }, w = (l - u) / (f - u), F = e.getFormat() === "hsla";
  switch (a) {
    case "red": {
      y = t === "green", A = WL(p, y, l);
      break;
    }
    case "green": {
      y = t === "red", A = HL(p, y, l);
      break;
    }
    case "blue": {
      y = t === "red", A = GL(p, y, l);
      break;
    }
    case "hue": {
      y = t !== "saturation", F ? A = YL(p, y, l) : A = KL(p, y, l);
      break;
    }
    case "saturation": {
      y = t === "hue", F ? A = zL(p, y, w) : A = XL(p, y, w);
      break;
    }
    case "brightness": {
      y = t === "hue", A = JL(p, y, w);
      break;
    }
    case "lightness": {
      y = t === "hue", A = ZL(p, y, l);
      break;
    }
  }
  return A;
}
var QL = (e, n) => {
  if (Object.keys(e).length !== Object.keys(n).length)
    return !1;
  for (let t in e)
    if (e[t] !== n[t])
      return !1;
  return !0;
}, Qb = class {
  toHexInt() {
    return this.toFormat("rgba").toHexInt();
  }
  getChannelValue(e) {
    if (e in this)
      return this[e];
    throw new Error("Unsupported color channel: " + e);
  }
  getChannelValuePercent(e, n) {
    const t = n ?? this.getChannelValue(e), { minValue: r, maxValue: o } = this.getChannelRange(e);
    return BL(t, r, o);
  }
  getChannelPercentValue(e, n) {
    const { minValue: t, maxValue: r, step: o } = this.getChannelRange(e), a = VL(n, t, r, o);
    return uC(a, t, r, o);
  }
  withChannelValue(e, n) {
    const { minValue: t, maxValue: r } = this.getChannelRange(e);
    if (e in this) {
      let o = this.clone();
      return o[e] = nl(n, t, r), o;
    }
    throw new Error("Unsupported color channel: " + e);
  }
  getColorAxes(e) {
    let { xChannel: n, yChannel: t } = e, r = n || this.getChannels().find((l) => l !== t), o = t || this.getChannels().find((l) => l !== r), a = this.getChannels().find((l) => l !== r && l !== o);
    return { xChannel: r, yChannel: o, zChannel: a };
  }
  incrementChannel(e, n) {
    const { minValue: t, maxValue: r, step: o } = this.getChannelRange(e), a = uC(
      nl(this.getChannelValue(e) + n, t, r),
      t,
      r,
      o
    );
    return this.withChannelValue(e, a);
  }
  decrementChannel(e, n) {
    return this.incrementChannel(e, -n);
  }
  isEqual(e) {
    return QL(this.toJSON(), e.toJSON()) && this.getChannelValue("alpha") === e.getChannelValue("alpha");
  }
}, zw = class zp extends Qb {
  constructor(n, t, r, o) {
    super(), this.red = n, this.green = t, this.blue = r, this.alpha = o;
  }
  static parse(n) {
    let t = [];
    if (/^#[\da-f]+$/i.test(n) && [4, 5, 7, 9].includes(n.length)) {
      const o = (n.length < 6 ? n.replace(/[^#]/gi, "$&$&") : n).slice(1).split("");
      for (; o.length > 0; )
        t.push(parseInt(o.splice(0, 2).join(""), 16));
      t[3] = t[3] !== void 0 ? t[3] / 255 : void 0;
    }
    const r = n.match(/^rgba?\((.*)\)$/);
    return r != null && r[1] && (t = r[1].split(",").map((o) => Number(o.trim())).map((o, a) => nl(o, 0, a < 3 ? 255 : 1))), t.length < 3 ? void 0 : new zp(t[0], t[1], t[2], t[3] ?? 1);
  }
  toString(n) {
    switch (n) {
      case "hex":
        return "#" + (this.red.toString(16).padStart(2, "0") + this.green.toString(16).padStart(2, "0") + this.blue.toString(16).padStart(2, "0")).toUpperCase();
      case "hexa":
        return "#" + (this.red.toString(16).padStart(2, "0") + this.green.toString(16).padStart(2, "0") + this.blue.toString(16).padStart(2, "0") + Math.round(this.alpha * 255).toString(16).padStart(2, "0")).toUpperCase();
      case "rgb":
        return `rgb(${this.red}, ${this.green}, ${this.blue})`;
      case "css":
      case "rgba":
        return `rgba(${this.red}, ${this.green}, ${this.blue}, ${this.alpha})`;
      case "hsl":
        return this.toHSL().toString("hsl");
      case "hsb":
        return this.toHSB().toString("hsb");
      default:
        return this.toFormat(n).toString(n);
    }
  }
  toFormat(n) {
    switch (n) {
      case "rgba":
        return this;
      case "hsba":
        return this.toHSB();
      case "hsla":
        return this.toHSL();
      default:
        throw new Error("Unsupported color conversion: rgb -> " + n);
    }
  }
  toHexInt() {
    return this.red << 16 | this.green << 8 | this.blue;
  }
  /**
   * Converts an RGB color value to HSB.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#From_RGB.
   * @returns An HSBColor object.
   */
  toHSB() {
    const n = this.red / 255, t = this.green / 255, r = this.blue / 255, o = Math.min(n, t, r), a = Math.max(n, t, r), l = a - o, u = a === 0 ? 0 : l / a;
    let f = 0;
    if (l !== 0) {
      switch (a) {
        case n:
          f = (t - r) / l + (t < r ? 6 : 0);
          break;
        case t:
          f = (r - n) / l + 2;
          break;
        case r:
          f = (n - t) / l + 4;
          break;
      }
      f /= 6;
    }
    return new $b(
      kn(f * 360, 2),
      kn(u * 100, 2),
      kn(a * 100, 2),
      kn(this.alpha, 2)
    );
  }
  /**
   * Converts an RGB color value to HSL.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#From_RGB.
   * @returns An HSLColor object.
   */
  toHSL() {
    const n = this.red / 255, t = this.green / 255, r = this.blue / 255, o = Math.min(n, t, r), a = Math.max(n, t, r), l = (a + o) / 2, u = a - o;
    let f = -1, p = -1;
    if (u === 0)
      f = p = 0;
    else {
      switch (p = u / (l < 0.5 ? a + o : 2 - a - o), a) {
        case n:
          f = (t - r) / u + (t < r ? 6 : 0);
          break;
        case t:
          f = (r - n) / u + 2;
          break;
        case r:
          f = (n - t) / u + 4;
          break;
      }
      f /= 6;
    }
    return new _b(
      kn(f * 360, 2),
      kn(p * 100, 2),
      kn(l * 100, 2),
      kn(this.alpha, 2)
    );
  }
  clone() {
    return new zp(this.red, this.green, this.blue, this.alpha);
  }
  getChannelRange(n) {
    switch (n) {
      case "red":
      case "green":
      case "blue":
        return { minValue: 0, maxValue: 255, step: 1, pageSize: 17 };
      case "alpha":
        return { minValue: 0, maxValue: 1, step: 0.01, pageSize: 0.1 };
      default:
        throw new Error("Unknown color channel: " + n);
    }
  }
  toJSON() {
    return { r: this.red, g: this.green, b: this.blue, a: this.alpha };
  }
  getFormat() {
    return "rgba";
  }
  getChannels() {
    return zp.colorChannels;
  }
};
Jb(zw, "colorChannels", ["red", "green", "blue"]);
var qb = zw, qL = /hsl\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%)\)|hsla\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d(.\d+)?)\)/, Zw = class Zp extends Qb {
  constructor(n, t, r, o) {
    super(), this.hue = n, this.saturation = t, this.lightness = r, this.alpha = o;
  }
  static parse(n) {
    let t;
    if (t = n.match(qL)) {
      const [r, o, a, l] = (t[1] ?? t[2]).split(",").map((u) => Number(u.trim().replace("%", "")));
      return new Zp(Yw(r, 360), nl(o, 0, 100), nl(a, 0, 100), nl(l ?? 1, 0, 1));
    }
  }
  toString(n) {
    switch (n) {
      case "hex":
        return this.toRGB().toString("hex");
      case "hexa":
        return this.toRGB().toString("hexa");
      case "hsl":
        return `hsl(${this.hue}, ${kn(this.saturation, 2)}%, ${kn(this.lightness, 2)}%)`;
      case "css":
      case "hsla":
        return `hsla(${this.hue}, ${kn(this.saturation, 2)}%, ${kn(this.lightness, 2)}%, ${this.alpha})`;
      case "hsb":
        return this.toHSB().toString("hsb");
      case "rgb":
        return this.toRGB().toString("rgb");
      default:
        return this.toFormat(n).toString(n);
    }
  }
  toFormat(n) {
    switch (n) {
      case "hsla":
        return this;
      case "hsba":
        return this.toHSB();
      case "rgba":
        return this.toRGB();
      default:
        throw new Error("Unsupported color conversion: hsl -> " + n);
    }
  }
  /**
   * Converts a HSL color to HSB.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_HSV.
   * @returns An HSBColor object.
   */
  toHSB() {
    let n = this.saturation / 100, t = this.lightness / 100, r = t + n * Math.min(t, 1 - t);
    return n = r === 0 ? 0 : 2 * (1 - t / r), new $b(
      kn(this.hue, 2),
      kn(n * 100, 2),
      kn(r * 100, 2),
      kn(this.alpha, 2)
    );
  }
  /**
   * Converts a HSL color to RGB.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_RGB_alternative.
   * @returns An RGBColor object.
   */
  toRGB() {
    let n = this.hue, t = this.saturation / 100, r = this.lightness / 100, o = t * Math.min(r, 1 - r), a = (l, u = (l + n / 30) % 12) => r - o * Math.max(Math.min(u - 3, 9 - u, 1), -1);
    return new qb(
      Math.round(a(0) * 255),
      Math.round(a(8) * 255),
      Math.round(a(4) * 255),
      kn(this.alpha, 2)
    );
  }
  clone() {
    return new Zp(this.hue, this.saturation, this.lightness, this.alpha);
  }
  getChannelRange(n) {
    switch (n) {
      case "hue":
        return { minValue: 0, maxValue: 360, step: 1, pageSize: 15 };
      case "saturation":
      case "lightness":
        return { minValue: 0, maxValue: 100, step: 1, pageSize: 10 };
      case "alpha":
        return { minValue: 0, maxValue: 1, step: 0.01, pageSize: 0.1 };
      default:
        throw new Error("Unknown color channel: " + n);
    }
  }
  toJSON() {
    return { h: this.hue, s: this.saturation, l: this.lightness, a: this.alpha };
  }
  getFormat() {
    return "hsla";
  }
  getChannels() {
    return Zp.colorChannels;
  }
};
Jb(Zw, "colorChannels", ["hue", "saturation", "lightness"]);
var _b = Zw, _L = /hsb\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%)\)|hsba\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d(.\d+)?)\)/, Kw = class Kp extends Qb {
  constructor(n, t, r, o) {
    super(), this.hue = n, this.saturation = t, this.brightness = r, this.alpha = o;
  }
  static parse(n) {
    let t;
    if (t = n.match(_L)) {
      const [r, o, a, l] = (t[1] ?? t[2]).split(",").map((u) => Number(u.trim().replace("%", "")));
      return new Kp(Yw(r, 360), nl(o, 0, 100), nl(a, 0, 100), nl(l ?? 1, 0, 1));
    }
  }
  toString(n) {
    switch (n) {
      case "css":
        return this.toHSL().toString("css");
      case "hex":
        return this.toRGB().toString("hex");
      case "hexa":
        return this.toRGB().toString("hexa");
      case "hsb":
        return `hsb(${this.hue}, ${kn(this.saturation, 2)}%, ${kn(this.brightness, 2)}%)`;
      case "hsba":
        return `hsba(${this.hue}, ${kn(this.saturation, 2)}%, ${kn(this.brightness, 2)}%, ${this.alpha})`;
      case "hsl":
        return this.toHSL().toString("hsl");
      case "rgb":
        return this.toRGB().toString("rgb");
      default:
        return this.toFormat(n).toString(n);
    }
  }
  toFormat(n) {
    switch (n) {
      case "hsba":
        return this;
      case "hsla":
        return this.toHSL();
      case "rgba":
        return this.toRGB();
      default:
        throw new Error("Unsupported color conversion: hsb -> " + n);
    }
  }
  /**
   * Converts a HSB color to HSL.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSV_to_HSL.
   * @returns An HSLColor object.
   */
  toHSL() {
    let n = this.saturation / 100, t = this.brightness / 100, r = t * (1 - n / 2);
    return n = r === 0 || r === 1 ? 0 : (t - r) / Math.min(r, 1 - r), new _b(
      kn(this.hue, 2),
      kn(n * 100, 2),
      kn(r * 100, 2),
      kn(this.alpha, 2)
    );
  }
  /**
   * Converts a HSV color value to RGB.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSV_to_RGB_alternative.
   * @returns An RGBColor object.
   */
  toRGB() {
    let n = this.hue, t = this.saturation / 100, r = this.brightness / 100, o = (a, l = (a + n / 60) % 6) => r - t * r * Math.max(Math.min(l, 4 - l, 1), 0);
    return new qb(
      Math.round(o(5) * 255),
      Math.round(o(3) * 255),
      Math.round(o(1) * 255),
      kn(this.alpha, 2)
    );
  }
  clone() {
    return new Kp(this.hue, this.saturation, this.brightness, this.alpha);
  }
  getChannelRange(n) {
    switch (n) {
      case "hue":
        return { minValue: 0, maxValue: 360, step: 1, pageSize: 15 };
      case "saturation":
      case "brightness":
        return { minValue: 0, maxValue: 100, step: 1, pageSize: 10 };
      case "alpha":
        return { minValue: 0, maxValue: 1, step: 0.01, pageSize: 0.1 };
      default:
        throw new Error("Unknown color channel: " + n);
    }
  }
  toJSON() {
    return { h: this.hue, s: this.saturation, b: this.brightness, a: this.alpha };
  }
  getFormat() {
    return "hsba";
  }
  getChannels() {
    return Kp.colorChannels;
  }
};
Jb(Kw, "colorChannels", ["hue", "saturation", "brightness"]);
var $b = Kw, $L = "aliceblue:f0f8ff,antiquewhite:faebd7,aqua:00ffff,aquamarine:7fffd4,azure:f0ffff,beige:f5f5dc,bisque:ffe4c4,black:000000,blanchedalmond:ffebcd,blue:0000ff,blueviolet:8a2be2,brown:a52a2a,burlywood:deb887,cadetblue:5f9ea0,chartreuse:7fff00,chocolate:d2691e,coral:ff7f50,cornflowerblue:6495ed,cornsilk:fff8dc,crimson:dc143c,cyan:00ffff,darkblue:00008b,darkcyan:008b8b,darkgoldenrod:b8860b,darkgray:a9a9a9,darkgreen:006400,darkkhaki:bdb76b,darkmagenta:8b008b,darkolivegreen:556b2f,darkorange:ff8c00,darkorchid:9932cc,darkred:8b0000,darksalmon:e9967a,darkseagreen:8fbc8f,darkslateblue:483d8b,darkslategray:2f4f4f,darkturquoise:00ced1,darkviolet:9400d3,deeppink:ff1493,deepskyblue:00bfff,dimgray:696969,dodgerblue:1e90ff,firebrick:b22222,floralwhite:fffaf0,forestgreen:228b22,fuchsia:ff00ff,gainsboro:dcdcdc,ghostwhite:f8f8ff,gold:ffd700,goldenrod:daa520,gray:808080,green:008000,greenyellow:adff2f,honeydew:f0fff0,hotpink:ff69b4,indianred:cd5c5c,indigo:4b0082,ivory:fffff0,khaki:f0e68c,lavender:e6e6fa,lavenderblush:fff0f5,lawngreen:7cfc00,lemonchiffon:fffacd,lightblue:add8e6,lightcoral:f08080,lightcyan:e0ffff,lightgoldenrodyellow:fafad2,lightgrey:d3d3d3,lightgreen:90ee90,lightpink:ffb6c1,lightsalmon:ffa07a,lightseagreen:20b2aa,lightskyblue:87cefa,lightslategray:778899,lightsteelblue:b0c4de,lightyellow:ffffe0,lime:00ff00,limegreen:32cd32,linen:faf0e6,magenta:ff00ff,maroon:800000,mediumaquamarine:66cdaa,mediumblue:0000cd,mediumorchid:ba55d3,mediumpurple:9370d8,mediumseagreen:3cb371,mediumslateblue:7b68ee,mediumspringgreen:00fa9a,mediumturquoise:48d1cc,mediumvioletred:c71585,midnightblue:191970,mintcream:f5fffa,mistyrose:ffe4e1,moccasin:ffe4b5,navajowhite:ffdead,navy:000080,oldlace:fdf5e6,olive:808000,olivedrab:6b8e23,orange:ffa500,orangered:ff4500,orchid:da70d6,palegoldenrod:eee8aa,palegreen:98fb98,paleturquoise:afeeee,palevioletred:d87093,papayawhip:ffefd5,peachpuff:ffdab9,peru:cd853f,pink:ffc0cb,plum:dda0dd,powderblue:b0e0e6,purple:800080,red:ff0000,rosybrown:bc8f8f,royalblue:4169e1,saddlebrown:8b4513,salmon:fa8072,sandybrown:f4a460,seagreen:2e8b57,seashell:fff5ee,sienna:a0522d,silver:c0c0c0,skyblue:87ceeb,slateblue:6a5acd,slategray:708090,snow:fffafa,springgreen:00ff7f,steelblue:4682b4,tan:d2b48c,teal:008080,thistle:d8bfd8,tomato:ff6347,turquoise:40e0d0,violet:ee82ee,wheat:f5deb3,white:ffffff,whitesmoke:f5f5f5,yellow:ffff00,yellowgreen:9acd32", eB = (e) => {
  const n = /* @__PURE__ */ new Map(), t = e.split(",");
  for (let r = 0; r < t.length; r++) {
    const [o, a] = t[r].split(":");
    n.set(o, `#${a}`);
  }
  return n;
}, fC = eB($L), cu = (e) => {
  var t;
  if (fC.has(e))
    return cu(fC.get(e));
  const n = qb.parse(e) || $b.parse(e) || _b.parse(e);
  if (!n) {
    const r = new Error("Invalid color value: " + e);
    throw (t = Error.captureStackTrace) == null || t.call(Error, r, cu), r;
  }
  return n;
}, gC = (e) => typeof e == "string" ? cu(e) : e;
function pC(e = 0, n = 0, t = 0, r = 0) {
  if (typeof DOMRect == "function")
    return new DOMRect(e, n, t, r);
  const o = {
    x: e,
    y: n,
    width: t,
    height: r,
    top: n,
    right: e + t,
    bottom: n + r,
    left: e
  };
  return { ...o, toJSON: () => o };
}
function tB(e) {
  if (!e)
    return pC();
  const { x: n, y: t, width: r, height: o } = e;
  return pC(n, t, r, o);
}
function nB(e, n) {
  return {
    contextElement: ps(e) ? e : void 0,
    getBoundingClientRect: () => {
      const t = e, r = n == null ? void 0 : n(t);
      return r || !t ? tB(r) : t.getBoundingClientRect();
    }
  };
}
var mg = (e) => ({ variable: e, reference: `var(${e})` }), Ql = {
  arrowSize: mg("--arrow-size"),
  arrowSizeHalf: mg("--arrow-size-half"),
  arrowBg: mg("--arrow-background"),
  transformOrigin: mg("--transform-origin"),
  arrowOffset: mg("--arrow-offset")
}, rB = (e) => ({
  top: "bottom center",
  "top-start": e ? `${e.x}px bottom` : "left bottom",
  "top-end": e ? `${e.x}px bottom` : "right bottom",
  bottom: "top center",
  "bottom-start": e ? `${e.x}px top` : "top left",
  "bottom-end": e ? `${e.x}px top` : "top right",
  left: "right center",
  "left-start": e ? `right ${e.y}px` : "right top",
  "left-end": e ? `right ${e.y}px` : "right bottom",
  right: "left center",
  "right-start": e ? `left ${e.y}px` : "left top",
  "right-end": e ? `left ${e.y}px` : "left bottom"
}), oB = {
  name: "transformOrigin",
  fn({ placement: e, elements: n, middlewareData: t }) {
    const { arrow: r } = t, o = rB(r)[e], { floating: a } = n;
    return a.style.setProperty(Ql.transformOrigin.variable, o), {
      data: { transformOrigin: o }
    };
  }
}, iB = {
  name: "rects",
  fn({ rects: e }) {
    return {
      data: e
    };
  }
}, aB = (e) => {
  if (e)
    return {
      name: "shiftArrow",
      fn({ placement: n, middlewareData: t }) {
        if (!t.arrow)
          return {};
        const { x: r, y: o } = t.arrow, a = n.split("-")[0];
        return Object.assign(e.style, {
          left: r != null ? `${r}px` : "",
          top: o != null ? `${o}px` : "",
          [a]: `calc(100% + ${Ql.arrowOffset.reference})`
        }), {};
      }
    };
};
function sB(e) {
  const [n, t] = e.split("-");
  return { side: n, align: t, hasAlign: t != null };
}
function lB(e) {
  return e.split("-")[0];
}
var cB = {
  strategy: "absolute",
  placement: "bottom",
  listeners: !0,
  gutter: 8,
  flip: !0,
  slide: !0,
  overlap: !1,
  sameWidth: !1,
  fitViewport: !1,
  overflowPadding: 8,
  arrowPadding: 4
};
function hC(e, n) {
  const t = e.devicePixelRatio || 1;
  return Math.round(n * t) / t;
}
function Xw(e) {
  return Bp(e.boundary);
}
function uB(e, n) {
  if (e)
    return mM({
      element: e,
      padding: n.arrowPadding
    });
}
function dB(e, n) {
  if (!qD(n.offset ?? n.gutter))
    return fM(({ placement: t }) => {
      var p, y;
      const r = ((e == null ? void 0 : e.clientHeight) || 0) / 2, o = ((p = n.offset) == null ? void 0 : p.mainAxis) ?? n.gutter, a = typeof o == "number" ? o + r : o ?? r, { hasAlign: l } = sB(t), u = l ? void 0 : n.shift, f = ((y = n.offset) == null ? void 0 : y.crossAxis) ?? u;
      return br({
        crossAxis: f,
        mainAxis: a,
        alignmentAxis: n.shift
      });
    });
}
function fB(e) {
  if (e.flip)
    return pM({
      boundary: Xw(e),
      padding: e.overflowPadding,
      fallbackPlacements: e.flip === !0 ? void 0 : e.flip
    });
}
function gB(e) {
  if (!(!e.slide && !e.overlap))
    return gM({
      boundary: Xw(e),
      mainAxis: e.slide,
      crossAxis: e.overlap,
      padding: e.overflowPadding,
      limiter: vM()
    });
}
function pB(e) {
  return hM({
    padding: e.overflowPadding,
    apply({ elements: n, rects: t, availableHeight: r, availableWidth: o }) {
      const a = n.floating, l = Math.round(t.reference.width);
      o = Math.floor(o), r = Math.floor(r), a.style.setProperty("--reference-width", `${l}px`), a.style.setProperty("--available-width", `${o}px`), a.style.setProperty("--available-height", `${r}px`);
    }
  });
}
function hB(e) {
  return e ? e === !0 ? { ancestorResize: !0, ancestorScroll: !0, elementResize: !0, layoutShift: !0 } : e : {};
}
function mB(e, n, t = {}) {
  const r = nB(e, t.getAnchorRect);
  if (!n || !r)
    return;
  const o = Object.assign({}, cB, t), a = n.querySelector("[data-part=arrow]"), l = [
    dB(a, o),
    fB(o),
    gB(o),
    uB(a, o),
    aB(a),
    oB,
    pB(o),
    iB
  ], { placement: u, strategy: f, onComplete: p, onPositioned: y } = o, A = async () => {
    if (!r || !n)
      return;
    const N = await bM(r, n, {
      placement: u,
      middleware: l,
      strategy: f
    });
    p == null || p(N), y == null || y({ placed: !0 });
    const D = cl(n), k = hC(D, N.x), z = hC(D, N.y);
    n.style.setProperty("--x", `${k}px`), n.style.setProperty("--y", `${z}px`);
    const q = n.firstElementChild;
    if (q) {
      const Ce = D.getComputedStyle(q).zIndex;
      n.style.setProperty("--z-index", Ce);
    }
  }, w = async () => {
    t.updatePosition ? (await t.updatePosition({ updatePosition: A }), y == null || y({ placed: !0 })) : await A();
  }, F = hB(o.listeners), j = o.listeners ? dM(r, n, w, F) : KD;
  return w(), () => {
    j == null || j(), y == null || y({ placed: !1 });
  };
}
function uu(e, n, t = {}) {
  const { defer: r, ...o } = t, a = r ? Ct : (u) => u(), l = [];
  return l.push(
    a(() => {
      const u = typeof e == "function" ? e() : e, f = typeof n == "function" ? n() : n;
      l.push(mB(u, f, o));
    })
  ), () => {
    l.forEach((u) => u == null ? void 0 : u());
  };
}
var vB = {
  bottom: "rotate(45deg)",
  left: "rotate(135deg)",
  top: "rotate(225deg)",
  right: "rotate(315deg)"
};
function Yg(e = {}) {
  const { placement: n, sameWidth: t, fitViewport: r, strategy: o = "absolute" } = e;
  return {
    arrow: {
      position: "absolute",
      width: Ql.arrowSize.reference,
      height: Ql.arrowSize.reference,
      [Ql.arrowSizeHalf.variable]: `calc(${Ql.arrowSize.reference} / 2)`,
      [Ql.arrowOffset.variable]: `calc(${Ql.arrowSizeHalf.reference} * -1)`
    },
    arrowTip: {
      transform: n ? vB[n.split("-")[0]] : void 0,
      background: Ql.arrowBg.reference,
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      position: "absolute",
      zIndex: "inherit"
    },
    floating: {
      position: o,
      isolation: "isolate",
      minWidth: t ? void 0 : "max-content",
      width: t ? "var(--reference-width)" : void 0,
      maxWidth: r ? "var(--available-width)" : void 0,
      maxHeight: r ? "var(--available-height)" : void 0,
      top: "0px",
      left: "0px",
      // move off-screen if placement is not defined
      transform: n ? "translate3d(var(--x), var(--y), 0)" : "translate3d(0, -100vh, 0)",
      zIndex: "var(--z-index)"
    }
  };
}
function bB(e) {
  const n = {
    each(t) {
      var r;
      for (let o = 0; o < ((r = e.frames) == null ? void 0 : r.length); o += 1) {
        const a = e.frames[o];
        a && t(a);
      }
    },
    addEventListener(t, r, o) {
      return n.each((a) => {
        try {
          a.document.addEventListener(t, r, o);
        } catch {
        }
      }), () => {
        try {
          n.removeEventListener(t, r, o);
        } catch {
        }
      };
    },
    removeEventListener(t, r, o) {
      n.each((a) => {
        try {
          a.document.removeEventListener(t, r, o);
        } catch {
        }
      });
    }
  };
  return n;
}
var mC = "pointerdown.outside", vC = "focus.outside";
function yB(e) {
  for (const n of e)
    if (ps(n) && bb(n))
      return !0;
  return !1;
}
var Jw = (e) => "clientY" in e;
function CB(e, n) {
  if (!Jw(n) || !e)
    return !1;
  const t = e.getBoundingClientRect();
  return t.width === 0 || t.height === 0 ? !1 : t.top <= n.clientY && n.clientY <= t.top + t.height && t.left <= n.clientX && n.clientX <= t.left + t.width;
}
function EB(e) {
  const n = ou(e);
  if (!n || !Jw(e))
    return !1;
  const r = n.scrollHeight > n.clientHeight && e.clientX > n.clientWidth, a = n.scrollWidth > n.clientWidth && e.clientY > n.clientHeight;
  return r || a;
}
function AB(e, n) {
  const { exclude: t, onFocusOutside: r, onPointerDownOutside: o, onInteractOutside: a, defer: l } = n;
  if (!e)
    return;
  const u = Df(e), f = cl(e), p = bB(f);
  function y(D) {
    const k = ou(D);
    return !ps(k) || ol(e, k) || CB(e, D) || EB(D) ? !1 : !(t != null && t(k));
  }
  let A;
  function w(D) {
    function k() {
      var Ce;
      const z = l ? Ct : (ee) => ee(), q = ((Ce = D.composedPath) == null ? void 0 : Ce.call(D)) ?? [D.target];
      z(() => {
        if (!(!e || !y(D))) {
          if (o || a) {
            const ee = Vv(o, a);
            e.addEventListener(mC, ee, { once: !0 });
          }
          D0(e, mC, {
            bubbles: !1,
            cancelable: !0,
            detail: {
              originalEvent: D,
              contextmenu: xb(D),
              focusable: yB(q)
            }
          });
        }
      });
    }
    D.pointerType === "touch" ? (p.removeEventListener("click", k), u.removeEventListener("click", k), A = k, u.addEventListener("click", k, { once: !0 }), p.addEventListener("click", k, { once: !0 })) : k();
  }
  const F = /* @__PURE__ */ new Set(), j = setTimeout(() => {
    F.add(p.addEventListener("pointerdown", w, !0)), F.add(Dn(u, "pointerdown", w, !0));
  }, 0);
  function N(D) {
    (l ? Ct : (z) => z())(() => {
      if (!(!e || !y(D))) {
        if (r || a) {
          const z = Vv(r, a);
          e.addEventListener(vC, z, { once: !0 });
        }
        D0(e, vC, {
          bubbles: !1,
          cancelable: !0,
          detail: {
            originalEvent: D,
            contextmenu: !1,
            focusable: bb(ou(D))
          }
        });
      }
    });
  }
  return F.add(Dn(u, "focusin", N, !0)), F.add(p.addEventListener("focusin", N, !0)), () => {
    clearTimeout(j), A && (p.removeEventListener("click", A), u.removeEventListener("click", A)), F.forEach((D) => D());
  };
}
function SB(e, n) {
  const { defer: t } = n, r = t ? Ct : (a) => a(), o = [];
  return o.push(
    r(() => {
      const a = typeof e == "function" ? e() : e;
      o.push(AB(a, n));
    })
  ), () => {
    o.forEach((a) => a == null ? void 0 : a());
  };
}
function wB(e, n) {
  const t = (r) => {
    r.key === "Escape" && (r.isComposing || n == null || n(r));
  };
  return Dn(Df(e), "keydown", t, { capture: !0 });
}
var $i = {
  layers: [],
  branches: [],
  count() {
    return this.layers.length;
  },
  pointerBlockingLayers() {
    return this.layers.filter((e) => e.pointerBlocking);
  },
  topMostPointerBlockingLayer() {
    return [...this.pointerBlockingLayers()].slice(-1)[0];
  },
  hasPointerBlockingLayer() {
    return this.pointerBlockingLayers().length > 0;
  },
  isBelowPointerBlockingLayer(e) {
    var r;
    const n = this.indexOf(e), t = this.topMostPointerBlockingLayer() ? this.indexOf((r = this.topMostPointerBlockingLayer()) == null ? void 0 : r.node) : -1;
    return n < t;
  },
  isTopMost(e) {
    const n = this.layers[this.count() - 1];
    return (n == null ? void 0 : n.node) === e;
  },
  getNestedLayers(e) {
    return Array.from(this.layers).slice(this.indexOf(e) + 1);
  },
  isInNestedLayer(e, n) {
    return this.getNestedLayers(e).some((t) => ol(t.node, n));
  },
  isInBranch(e) {
    return Array.from(this.branches).some((n) => ol(n, e));
  },
  add(e) {
    const n = this.layers.push(e);
    e.node.style.setProperty("--layer-index", `${n}`);
  },
  addBranch(e) {
    this.branches.push(e);
  },
  remove(e) {
    const n = this.indexOf(e);
    n < 0 || (n < this.count() - 1 && this.getNestedLayers(e).forEach((r) => r.dismiss()), this.layers.splice(n, 1), e.style.removeProperty("--layer-index"));
  },
  removeBranch(e) {
    const n = this.branches.indexOf(e);
    n >= 0 && this.branches.splice(n, 1);
  },
  indexOf(e) {
    return this.layers.findIndex((n) => n.node === e);
  },
  dismiss(e) {
    var n;
    (n = this.layers[this.indexOf(e)]) == null || n.dismiss();
  },
  clear() {
    this.remove(this.layers[0].node);
  }
}, bC;
function yC() {
  $i.layers.forEach(({ node: e }) => {
    e.style.pointerEvents = $i.isBelowPointerBlockingLayer(e) ? "none" : "auto";
  });
}
function IB(e) {
  e.style.pointerEvents = "";
}
function xB(e, n) {
  const t = Df(e), r = [];
  if ($i.hasPointerBlockingLayer() && !t.body.hasAttribute("data-inert") && (bC = document.body.style.pointerEvents, queueMicrotask(() => {
    t.body.style.pointerEvents = "none", t.body.setAttribute("data-inert", "");
  })), n) {
    const o = ID(n, (a) => {
      r.push(AD(a, { pointerEvents: "auto" }));
    });
    r.push(o);
  }
  return () => {
    $i.hasPointerBlockingLayer() || (queueMicrotask(() => {
      t.body.style.pointerEvents = bC, t.body.removeAttribute("data-inert"), t.body.style.length === 0 && t.body.removeAttribute("style");
    }), r.forEach((o) => o()));
  };
}
function TB(e, n) {
  if (!e) {
    Fh("[@zag-js/dismissable] node is `null` or `undefined`");
    return;
  }
  const { onDismiss: t, pointerBlocking: r, exclude: o, debug: a } = n, l = { dismiss: t, node: e, pointerBlocking: r };
  $i.add(l), yC();
  function u(w) {
    var j, N;
    const F = ou(w.detail.originalEvent);
    $i.isBelowPointerBlockingLayer(e) || $i.isInBranch(F) || ((j = n.onPointerDownOutside) == null || j.call(n, w), (N = n.onInteractOutside) == null || N.call(n, w), !w.defaultPrevented && (a && console.log("onPointerDownOutside:", w.detail.originalEvent), t == null || t()));
  }
  function f(w) {
    var j, N;
    const F = ou(w.detail.originalEvent);
    $i.isInBranch(F) || ((j = n.onFocusOutside) == null || j.call(n, w), (N = n.onInteractOutside) == null || N.call(n, w), !w.defaultPrevented && (a && console.log("onFocusOutside:", w.detail.originalEvent), t == null || t()));
  }
  function p(w) {
    var F;
    $i.isTopMost(e) && ((F = n.onEscapeKeyDown) == null || F.call(n, w), !w.defaultPrevented && t && (w.preventDefault(), t()));
  }
  function y(w) {
    var D;
    if (!e)
      return !1;
    const F = typeof o == "function" ? o() : o, j = Array.isArray(F) ? F : [F], N = (D = n.persistentElements) == null ? void 0 : D.map((k) => k()).filter(ps);
    return N && j.push(...N), j.some((k) => ol(k, w)) || $i.isInNestedLayer(e, w);
  }
  const A = [
    r ? xB(e, n.persistentElements) : void 0,
    wB(e, p),
    SB(e, { exclude: y, onFocusOutside: f, onPointerDownOutside: u, defer: n.defer })
  ];
  return () => {
    $i.remove(e), yC(), IB(e), A.forEach((w) => w == null ? void 0 : w());
  };
}
function Uf(e, n) {
  const { defer: t } = n, r = t ? Ct : (a) => a(), o = [];
  return o.push(
    r(() => {
      const a = eS(e) ? e() : e;
      o.push(TB(a, n));
    })
  ), () => {
    o.forEach((a) => a == null ? void 0 : a());
  };
}
function PB(e, n = {}) {
  const { defer: t } = n, r = t ? Ct : (a) => a(), o = [];
  return o.push(
    r(() => {
      const a = eS(e) ? e() : e;
      if (!a) {
        Fh("[@zag-js/dismissable] branch node is `null` or `undefined`");
        return;
      }
      $i.addBranch(a), o.push(() => {
        $i.removeBranch(a);
      });
    })
  ), () => {
    o.forEach((a) => a == null ? void 0 : a());
  };
}
var kB = Yp("color-picker", [
  "root",
  "label",
  "control",
  "trigger",
  "positioner",
  "content",
  "area",
  "areaThumb",
  "areaBackground",
  "channelSlider",
  "channelSliderTrack",
  "channelSliderThumb",
  "channelInput",
  "transparencyGrid",
  "swatchGroup",
  "swatchTrigger",
  "swatchIndicator",
  "swatch",
  "eyeDropperTrigger",
  "formatTrigger",
  "formatSelect"
]), ur = kB.build(), $e = so({
  getRootId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.root) ?? `color-picker:${e.id}`;
  },
  getLabelId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.label) ?? `color-picker:${e.id}:label`;
  },
  getHiddenInputId: (e) => `color-picker:${e.id}:hidden-input`,
  getControlId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.control) ?? `color-picker:${e.id}:control`;
  },
  getTriggerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.trigger) ?? `color-picker:${e.id}:trigger`;
  },
  getContentId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.content) ?? `color-picker:${e.id}:content`;
  },
  getPositionerId: (e) => `color-picker:${e.id}:positioner`,
  getFormatSelectId: (e) => `color-picker:${e.id}:format-select`,
  getAreaId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.area) ?? `color-picker:${e.id}:area`;
  },
  getAreaGradientId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.areaGradient) ?? `color-picker:${e.id}:area-gradient`;
  },
  getAreaThumbId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.areaThumb) ?? `color-picker:${e.id}:area-thumb`;
  },
  getChannelSliderId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.channelSliderTrack) == null ? void 0 : r.call(t, n)) ?? `color-picker:${e.id}:slider-track:${n}`;
  },
  getChannelSliderThumbId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.channelSliderThumb) == null ? void 0 : r.call(t, n)) ?? `color-picker:${e.id}:slider-thumb:${n}`;
  },
  getContentEl: (e) => $e.getById(e, $e.getContentId(e)),
  getAreaThumbEl: (e) => $e.getById(e, $e.getAreaThumbId(e)),
  getChannelSliderThumbEl: (e, n) => $e.getById(e, $e.getChannelSliderThumbId(e, n)),
  getChannelInputEl: (e, n) => [
    ...$s($e.getContentEl(e), `input[data-channel="${n}"]`),
    ...$s($e.getControlEl(e), `input[data-channel="${n}"]`)
  ],
  getFormatSelectEl: (e) => $e.getById(e, $e.getFormatSelectId(e)),
  getHiddenInputEl: (e) => $e.getById(e, $e.getHiddenInputId(e)),
  getAreaEl: (e) => $e.getById(e, $e.getAreaId(e)),
  getAreaValueFromPoint(e, n) {
    const t = $e.getAreaEl(e);
    if (!t)
      return;
    const { percent: r } = M0(n, t);
    return r;
  },
  getControlEl: (e) => $e.getById(e, $e.getControlId(e)),
  getTriggerEl: (e) => $e.getById(e, $e.getTriggerId(e)),
  getPositionerEl: (e) => $e.getById(e, $e.getPositionerId(e)),
  getChannelSliderTrackEl: (e, n) => $e.getById(e, $e.getChannelSliderId(e, n)),
  getChannelSliderValueFromPoint(e, n, t) {
    const r = $e.getChannelSliderTrackEl(e, t);
    if (!r)
      return;
    const { percent: o } = M0(n, r);
    return o;
  },
  getChannelInputEls: (e) => [
    ...$s($e.getContentEl(e), "input[data-channel]"),
    ...$s($e.getControlEl(e), "input[data-channel]")
  ]
});
function RB(e, n) {
  switch (n) {
    case "hue":
      return cu(`hsl(${e.getChannelValue("hue")}, 100%, 50%)`);
    case "lightness":
    case "brightness":
    case "saturation":
    case "red":
    case "green":
    case "blue":
      return e.withChannelValue("alpha", 1);
    case "alpha":
      return e;
    default:
      throw new Error("Unknown color channel: " + n);
  }
}
function zv(e, n) {
  if (n == null)
    return "";
  if (n === "hex")
    return e.toString("hex");
  if (n === "css")
    return e.toString("css");
  if (n in e)
    return e.getChannelValue(n).toString();
  const t = e.getFormat() === "hsla";
  switch (n) {
    case "hue":
      return t ? e.toFormat("hsla").getChannelValue("hue").toString() : e.toFormat("hsba").getChannelValue("hue").toString();
    case "saturation":
      return t ? e.toFormat("hsla").getChannelValue("saturation").toString() : e.toFormat("hsba").getChannelValue("saturation").toString();
    case "lightness":
      return e.toFormat("hsla").getChannelValue("lightness").toString();
    case "brightness":
      return e.toFormat("hsba").getChannelValue("brightness").toString();
    case "red":
    case "green":
    case "blue":
      return e.toFormat("rgba").getChannelValue(n).toString();
    default:
      return e.getChannelValue(n).toString();
  }
}
function OB(e, n) {
  switch (n) {
    case "hex":
      const t = cu("#000000"), r = cu("#FFFFFF");
      return {
        minValue: t.toHexInt(),
        maxValue: r.toHexInt(),
        pageSize: 10,
        step: 1
      };
    case "css":
      return;
    case "hue":
    case "saturation":
    case "lightness":
      return e.toFormat("hsla").getChannelRange(n);
    case "brightness":
      return e.toFormat("hsba").getChannelRange(n);
    case "red":
    case "green":
    case "blue":
      return e.toFormat("rgba").getChannelRange(n);
    default:
      return e.getChannelRange(n);
  }
}
function DB(e, n) {
  return e === "vertical" ? "top" : n === "ltr" ? "right" : "left";
}
var FB = (e) => {
  const { channel: n, value: t, dir: r } = e, o = DB(e.orientation, r), { minValue: a, maxValue: l } = t.getChannelRange(n);
  switch (n) {
    case "hue":
      return `linear-gradient(to ${o}, rgb(255, 0, 0) 0%, rgb(255, 255, 0) 17%, rgb(0, 255, 0) 33%, rgb(0, 255, 255) 50%, rgb(0, 0, 255) 67%, rgb(255, 0, 255) 83%, rgb(255, 0, 0) 100%)`;
    case "lightness": {
      let u = t.withChannelValue(n, a).toString("css"), f = t.withChannelValue(n, (l - a) / 2).toString("css"), p = t.withChannelValue(n, l).toString("css");
      return `linear-gradient(to ${o}, ${u}, ${f}, ${p})`;
    }
    case "saturation":
    case "brightness":
    case "red":
    case "green":
    case "blue":
    case "alpha": {
      let u = t.withChannelValue(n, a).toString("css"), f = t.withChannelValue(n, l).toString("css");
      return `linear-gradient(to ${o}, ${u}, ${f})`;
    }
    default:
      throw new Error("Unknown color channel: " + n);
  }
};
function NB(e, n, t) {
  const r = e.context.value, o = e.context.areaValue, a = e.context.valueAsString, l = e.context.isDisabled, u = e.context.isInteractive, f = e.hasTag("dragging"), p = e.hasTag("open"), y = e.hasTag("focused"), A = (N) => {
    const D = o.getChannels();
    return {
      xChannel: N.xChannel ?? D[1],
      yChannel: N.yChannel ?? D[2]
    };
  }, w = e.context.currentPlacement, F = Yg({
    ...e.context.positioning,
    placement: w
  });
  function j(N) {
    const D = gC(N.value).toFormat(e.context.format);
    return {
      value: D,
      valueAsString: D.toString("hex"),
      checked: D.isEqual(r),
      disabled: N.disabled || !u
    };
  }
  return {
    dragging: f,
    open: p,
    valueAsString: a,
    value: r,
    setOpen(N) {
      N !== p && n({ type: N ? "OPEN" : "CLOSE" });
    },
    setValue(N) {
      n({ type: "VALUE.SET", value: gC(N), src: "set-color" });
    },
    getChannelValue(N) {
      return zv(r, N);
    },
    setChannelValue(N, D) {
      const k = r.withChannelValue(N, D);
      n({ type: "VALUE.SET", value: k, src: "set-channel" });
    },
    format: e.context.format,
    setFormat(N) {
      const D = r.toFormat(N);
      n({ type: "VALUE.SET", value: D, src: "set-format" });
    },
    alpha: r.getChannelValue("alpha"),
    setAlpha(N) {
      const D = r.withChannelValue("alpha", N);
      n({ type: "VALUE.SET", value: D, src: "set-alpha" });
    },
    getRootProps() {
      return t.element({
        ...ur.root.attrs,
        dir: e.context.dir,
        id: $e.getRootId(e.context),
        "data-disabled": se(l),
        "data-readonly": se(e.context.readOnly),
        style: {
          "--value": r.toString("css")
        }
      });
    },
    getLabelProps() {
      return t.element({
        ...ur.label.attrs,
        dir: e.context.dir,
        id: $e.getLabelId(e.context),
        htmlFor: $e.getHiddenInputId(e.context),
        "data-disabled": se(l),
        "data-readonly": se(e.context.readOnly),
        "data-focus": se(y),
        onClick(N) {
          N.preventDefault();
          const D = Sb($e.getControlEl(e.context), "[data-channel=hex]");
          D == null || D.focus({ preventScroll: !0 });
        }
      });
    },
    getControlProps() {
      return t.element({
        ...ur.control.attrs,
        id: $e.getControlId(e.context),
        dir: e.context.dir,
        "data-disabled": se(l),
        "data-readonly": se(e.context.readOnly),
        "data-state": p ? "open" : "closed",
        "data-focus": se(y)
      });
    },
    getTriggerProps() {
      return t.button({
        ...ur.trigger.attrs,
        id: $e.getTriggerId(e.context),
        dir: e.context.dir,
        disabled: l,
        "aria-label": `select color. current color is ${a}`,
        "aria-controls": $e.getContentId(e.context),
        "aria-labelledby": $e.getLabelId(e.context),
        "data-disabled": se(l),
        "data-readonly": se(e.context.readOnly),
        "data-placement": w,
        "aria-expanded": se(p),
        "data-state": p ? "open" : "closed",
        "data-focus": se(y),
        type: "button",
        onClick() {
          u && n({ type: "TRIGGER.CLICK" });
        },
        onBlur() {
          u && n({ type: "TRIGGER.BLUR" });
        },
        style: {
          position: "relative"
        }
      });
    },
    getPositionerProps() {
      return t.element({
        ...ur.positioner.attrs,
        id: $e.getPositionerId(e.context),
        dir: e.context.dir,
        style: F.floating
      });
    },
    getContentProps() {
      return t.element({
        ...ur.content.attrs,
        id: $e.getContentId(e.context),
        dir: e.context.dir,
        "data-placement": w,
        "data-state": p ? "open" : "closed",
        hidden: !p
      });
    },
    getAreaProps(N = {}) {
      const { xChannel: D, yChannel: k } = A(N), { areaStyles: z } = dC(o, {
        xChannel: D,
        yChannel: k,
        dir: e.context.dir
      });
      return t.element({
        ...ur.area.attrs,
        id: $e.getAreaId(e.context),
        role: "group",
        onPointerDown(q) {
          if (!u || !rc(q) || Mv(q))
            return;
          const Ce = nu(q);
          n({ type: "AREA.POINTER_DOWN", point: Ce, channel: { xChannel: D, yChannel: k }, id: "area" }), q.preventDefault();
        },
        style: {
          position: "relative",
          touchAction: "none",
          forcedColorAdjust: "none",
          ...z
        }
      });
    },
    getAreaBackgroundProps(N = {}) {
      const { xChannel: D, yChannel: k } = A(N), { areaGradientStyles: z } = dC(o, {
        xChannel: D,
        yChannel: k,
        dir: e.context.dir
      });
      return t.element({
        ...ur.areaBackground.attrs,
        id: $e.getAreaGradientId(e.context),
        style: {
          position: "relative",
          touchAction: "none",
          forcedColorAdjust: "none",
          ...z
        }
      });
    },
    getAreaThumbProps(N = {}) {
      const { xChannel: D, yChannel: k } = A(N), z = { xChannel: D, yChannel: k }, q = o.getChannelValuePercent(D), Ce = 1 - o.getChannelValuePercent(k), ee = o.getChannelValue(D), Fe = o.getChannelValue(k);
      return t.element({
        ...ur.areaThumb.attrs,
        id: $e.getAreaThumbId(e.context),
        dir: e.context.dir,
        tabIndex: l ? void 0 : 0,
        "data-disabled": se(l),
        role: "slider",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": ee,
        "aria-label": `${D} and ${k}`,
        "aria-roledescription": "2d slider",
        "aria-valuetext": `${D} ${ee}, ${k} ${Fe}`,
        style: {
          position: "absolute",
          left: `${q * 100}%`,
          top: `${Ce * 100}%`,
          transform: "translate(-50%, -50%)",
          touchAction: "none",
          forcedColorAdjust: "none",
          background: o.withChannelValue("alpha", 1).toString("css")
        },
        onFocus() {
          u && n({ type: "AREA.FOCUS", id: "area", channel: z });
        },
        onKeyDown(Oe) {
          if (Oe.defaultPrevented || !u)
            return;
          const He = Bv(Oe), Se = {
            ArrowUp() {
              n({ type: "AREA.ARROW_UP", channel: z, step: He });
            },
            ArrowDown() {
              n({ type: "AREA.ARROW_DOWN", channel: z, step: He });
            },
            ArrowLeft() {
              n({ type: "AREA.ARROW_LEFT", channel: z, step: He });
            },
            ArrowRight() {
              n({ type: "AREA.ARROW_RIGHT", channel: z, step: He });
            },
            PageUp() {
              n({ type: "AREA.PAGE_UP", channel: z, step: He });
            },
            PageDown() {
              n({ type: "AREA.PAGE_DOWN", channel: z, step: He });
            },
            Escape(we) {
              we.stopPropagation();
            }
          }[il(Oe, e.context)];
          Se && (Se(Oe), Oe.preventDefault());
        }
      });
    },
    getTransparencyGridProps(N = {}) {
      const { size: D = "12px" } = N;
      return t.element({
        ...ur.transparencyGrid.attrs,
        style: {
          "--size": D,
          width: "100%",
          height: "100%",
          position: "absolute",
          backgroundColor: "#fff",
          backgroundImage: "conic-gradient(#eeeeee 0 25%, transparent 0 50%, #eeeeee 0 75%, transparent 0)",
          backgroundSize: "var(--size) var(--size)",
          inset: "0px",
          zIndex: "auto",
          pointerEvents: "none"
        }
      });
    },
    getChannelSliderProps(N) {
      const { orientation: D = "horizontal", channel: k } = N;
      return t.element({
        ...ur.channelSlider.attrs,
        "data-channel": k,
        "data-orientation": D,
        role: "presentation",
        onPointerDown(z) {
          if (!u || !rc(z) || Mv(z))
            return;
          const q = nu(z);
          n({ type: "CHANNEL_SLIDER.POINTER_DOWN", channel: k, point: q, id: k, orientation: D }), z.preventDefault();
        },
        style: {
          position: "relative",
          touchAction: "none"
        }
      });
    },
    getChannelSliderTrackProps(N) {
      const { orientation: D = "horizontal", channel: k } = N;
      return t.element({
        ...ur.channelSliderTrack.attrs,
        id: $e.getChannelSliderId(e.context, k),
        role: "group",
        "data-channel": k,
        "data-orientation": D,
        style: {
          position: "relative",
          forcedColorAdjust: "none",
          backgroundImage: FB({
            orientation: D,
            channel: k,
            dir: e.context.dir,
            value: o
          })
        }
      });
    },
    getChannelSliderThumbProps(N) {
      const { orientation: D = "horizontal", channel: k } = N, { minValue: z, maxValue: q, step: Ce } = o.getChannelRange(k), ee = o.getChannelValue(k), Fe = (ee - z) / (q - z), Oe = D === "horizontal" ? { left: `${Fe * 100}%`, top: "50%" } : { top: `${Fe * 100}%`, left: "50%" };
      return t.element({
        ...ur.channelSliderThumb.attrs,
        id: $e.getChannelSliderThumbId(e.context, k),
        role: "slider",
        "aria-label": k,
        tabIndex: l ? void 0 : 0,
        "data-channel": k,
        "data-disabled": se(l),
        "data-orientation": D,
        "aria-disabled": se(l),
        "aria-orientation": D,
        "aria-valuemax": q,
        "aria-valuemin": z,
        "aria-valuenow": ee,
        "aria-valuetext": `${k} ${ee}`,
        style: {
          forcedColorAdjust: "none",
          position: "absolute",
          background: RB(o, k).toString("css"),
          ...Oe
        },
        onFocus() {
          u && n({ type: "CHANNEL_SLIDER.FOCUS", channel: k });
        },
        onKeyDown(He) {
          if (He.defaultPrevented || !u)
            return;
          const Re = Bv(He) * Ce, we = {
            ArrowUp() {
              n({ type: "CHANNEL_SLIDER.ARROW_UP", channel: k, step: Re });
            },
            ArrowDown() {
              n({ type: "CHANNEL_SLIDER.ARROW_DOWN", channel: k, step: Re });
            },
            ArrowLeft() {
              n({ type: "CHANNEL_SLIDER.ARROW_LEFT", channel: k, step: Re });
            },
            ArrowRight() {
              n({ type: "CHANNEL_SLIDER.ARROW_RIGHT", channel: k, step: Re });
            },
            PageUp() {
              n({ type: "CHANNEL_SLIDER.PAGE_UP", channel: k });
            },
            PageDown() {
              n({ type: "CHANNEL_SLIDER.PAGE_DOWN", channel: k });
            },
            Home() {
              n({ type: "CHANNEL_SLIDER.HOME", channel: k });
            },
            End() {
              n({ type: "CHANNEL_SLIDER.END", channel: k });
            },
            Escape(ae) {
              ae.stopPropagation();
            }
          }[il(He, e.context)];
          we && (we(He), He.preventDefault());
        }
      });
    },
    getChannelInputProps(N) {
      const { channel: D } = N, k = D === "hex" || D === "css", z = OB(r, D);
      return t.input({
        ...ur.channelInput.attrs,
        dir: e.context.dir,
        type: k ? "text" : "number",
        "data-channel": D,
        "aria-label": D,
        spellCheck: !1,
        autoComplete: "off",
        disabled: l,
        "data-disabled": se(l),
        readOnly: e.context.readOnly,
        defaultValue: zv(r, D),
        min: z == null ? void 0 : z.minValue,
        max: z == null ? void 0 : z.maxValue,
        step: z == null ? void 0 : z.step,
        onBeforeInput(q) {
          if (k || !u)
            return;
          q.currentTarget.value.match(/[^0-9.]/g) && q.preventDefault();
        },
        onFocus(q) {
          u && (n({ type: "CHANNEL_INPUT.FOCUS", channel: D }), q.target.select());
        },
        onBlur(q) {
          if (!u)
            return;
          const Ce = k ? q.currentTarget.value : q.currentTarget.valueAsNumber;
          n({ type: "CHANNEL_INPUT.BLUR", channel: D, value: Ce, isTextField: k });
        },
        onKeyDown(q) {
          if (!q.defaultPrevented && u && q.key === "Enter") {
            const Ce = k ? q.currentTarget.value : q.currentTarget.valueAsNumber;
            n({ type: "CHANNEL_INPUT.CHANGE", channel: D, value: Ce, isTextField: k }), q.preventDefault();
          }
        },
        style: {
          appearance: "none",
          WebkitAppearance: "none",
          MozAppearance: "textfield"
        }
      });
    },
    getHiddenInputProps() {
      return t.input({
        type: "text",
        disabled: l,
        name: e.context.name,
        id: $e.getHiddenInputId(e.context),
        style: Ff,
        defaultValue: a
      });
    },
    getEyeDropperTriggerProps() {
      return t.button({
        ...ur.eyeDropperTrigger.attrs,
        type: "button",
        dir: e.context.dir,
        disabled: l,
        "data-disabled": se(l),
        "aria-label": "Pick a color from the screen",
        onClick() {
          u && n("EYEDROPPER.CLICK");
        }
      });
    },
    getSwatchGroupProps() {
      return t.element({
        ...ur.swatchGroup.attrs,
        role: "group"
      });
    },
    getSwatchTriggerState: j,
    getSwatchTriggerProps(N) {
      const D = j(N);
      return t.button({
        ...ur.swatchTrigger.attrs,
        disabled: D.disabled,
        dir: e.context.dir,
        type: "button",
        "aria-label": `select ${D.valueAsString} as the color`,
        "data-state": D.checked ? "checked" : "unchecked",
        "data-value": D.valueAsString,
        "data-disabled": se(D.disabled),
        onClick() {
          D.disabled || n({ type: "SWATCH_TRIGGER.CLICK", value: D.value });
        },
        style: {
          position: "relative"
        }
      });
    },
    getSwatchIndicatorProps(N) {
      const D = j(N);
      return t.element({
        ...ur.swatchIndicator.attrs,
        dir: e.context.dir,
        hidden: !D.checked
      });
    },
    getSwatchProps(N) {
      const { respectAlpha: D = !0 } = N, k = j(N);
      return t.element({
        ...ur.swatch.attrs,
        dir: e.context.dir,
        "data-state": k.checked ? "checked" : "unchecked",
        "data-value": k.valueAsString,
        style: {
          position: "relative",
          background: k.value.toString(D ? "css" : "hex")
        }
      });
    },
    getFormatTriggerProps() {
      return t.button({
        ...ur.formatTrigger.attrs,
        dir: e.context.dir,
        type: "button",
        "aria-label": `change color format to ${CC(e.context.format)}`,
        onClick(N) {
          if (N.currentTarget.disabled)
            return;
          const D = CC(e.context.format);
          n({ type: "FORMAT.SET", format: D, src: "format-trigger" });
        }
      });
    },
    getFormatSelectProps() {
      return t.select({
        ...ur.formatSelect.attrs,
        "aria-label": "change color format",
        dir: e.context.dir,
        defaultValue: e.context.format,
        disabled: l,
        onChange(N) {
          const D = LB(N.currentTarget.value);
          n({ type: "FORMAT.SET", format: D, src: "format-select" });
        }
      });
    }
  };
}
var Xp = ["hsba", "hsla", "rgba"], MB = new RegExp(`^(${Xp.join("|")})$`);
function CC(e) {
  const n = Xp.indexOf(e);
  return Xp[n + 1] ?? Xp[0];
}
function LB(e) {
  if (MB.test(e))
    return e;
  throw new Error(`Unsupported color format: ${e}`);
}
var Og = (e) => cu(e), { and: BB } = Ma;
function VB(e) {
  const n = br(e);
  return Rr(
    {
      id: "color-picker",
      initial: n.open ? "open" : "idle",
      context: {
        dir: "ltr",
        value: Og("#000000"),
        format: "rgba",
        disabled: !1,
        closeOnSelect: !1,
        ...n,
        activeId: null,
        activeChannel: null,
        activeOrientation: null,
        fieldsetDisabled: !1,
        restoreFocus: !0,
        positioning: {
          ...n.positioning,
          placement: "bottom"
        }
      },
      computed: {
        isRtl: (t) => t.dir === "rtl",
        isDisabled: (t) => !!t.disabled || t.fieldsetDisabled,
        isInteractive: (t) => !(t.isDisabled || t.readOnly),
        valueAsString: (t) => t.value.toString(t.format),
        areaValue: (t) => {
          const r = t.format.startsWith("hsl") ? "hsla" : "hsba";
          return t.value.toFormat(r);
        }
      },
      activities: ["trackFormControl"],
      watch: {
        value: ["syncInputElements"],
        format: ["syncFormatSelectElement"],
        open: ["toggleVisibility"]
      },
      on: {
        "VALUE.SET": {
          actions: ["setValue"]
        },
        "FORMAT.SET": {
          actions: ["setFormat"]
        },
        "CHANNEL_INPUT.CHANGE": {
          actions: ["setChannelColorFromInput"]
        },
        "EYEDROPPER.CLICK": {
          actions: ["openEyeDropper"]
        }
      },
      states: {
        idle: {
          tags: ["closed"],
          on: {
            "CONTROLLED.OPEN": {
              target: "open",
              actions: ["setInitialFocus"]
            },
            OPEN: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["invokeOnOpen", "setInitialFocus"]
              }
            ],
            "TRIGGER.CLICK": [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["invokeOnOpen", "setInitialFocus"]
              }
            ],
            "CHANNEL_INPUT.FOCUS": {
              target: "focused",
              actions: ["setActiveChannel"]
            }
          }
        },
        focused: {
          tags: ["closed", "focused"],
          on: {
            "CONTROLLED.OPEN": {
              target: "open",
              actions: ["setInitialFocus"]
            },
            OPEN: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["invokeOnOpen", "setInitialFocus"]
              }
            ],
            "TRIGGER.CLICK": [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["invokeOnOpen", "setInitialFocus"]
              }
            ],
            "CHANNEL_INPUT.FOCUS": {
              actions: ["setActiveChannel"]
            },
            "CHANNEL_INPUT.BLUR": {
              target: "idle",
              actions: ["setChannelColorFromInput"]
            },
            "TRIGGER.BLUR": {
              target: "idle"
            }
          }
        },
        open: {
          tags: ["open"],
          activities: ["trackPositioning", "trackDismissableElement"],
          on: {
            "CONTROLLED.CLOSE": [
              {
                guard: "shouldRestoreFocus",
                target: "focused",
                actions: ["setReturnFocus"]
              },
              {
                target: "idle"
              }
            ],
            "TRIGGER.CLICK": [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnClose"]
              },
              {
                target: "idle",
                actions: ["invokeOnClose"]
              }
            ],
            "AREA.POINTER_DOWN": {
              target: "open:dragging",
              actions: ["setActiveChannel", "setAreaColorFromPoint", "focusAreaThumb"]
            },
            "AREA.FOCUS": {
              actions: ["setActiveChannel"]
            },
            "CHANNEL_SLIDER.POINTER_DOWN": {
              target: "open:dragging",
              actions: ["setActiveChannel", "setChannelColorFromPoint", "focusChannelThumb"]
            },
            "CHANNEL_SLIDER.FOCUS": {
              actions: ["setActiveChannel"]
            },
            "AREA.ARROW_LEFT": {
              actions: ["decrementXChannel"]
            },
            "AREA.ARROW_RIGHT": {
              actions: ["incrementXChannel"]
            },
            "AREA.ARROW_UP": {
              actions: ["incrementYChannel"]
            },
            "AREA.ARROW_DOWN": {
              actions: ["decrementYChannel"]
            },
            "AREA.PAGE_UP": {
              actions: ["incrementXChannel"]
            },
            "AREA.PAGE_DOWN": {
              actions: ["decrementXChannel"]
            },
            "CHANNEL_SLIDER.ARROW_LEFT": {
              actions: ["decrementChannel"]
            },
            "CHANNEL_SLIDER.ARROW_RIGHT": {
              actions: ["incrementChannel"]
            },
            "CHANNEL_SLIDER.ARROW_UP": {
              actions: ["incrementChannel"]
            },
            "CHANNEL_SLIDER.ARROW_DOWN": {
              actions: ["decrementChannel"]
            },
            "CHANNEL_SLIDER.PAGE_UP": {
              actions: ["incrementChannel"]
            },
            "CHANNEL_SLIDER.PAGE_DOWN": {
              actions: ["decrementChannel"]
            },
            "CHANNEL_SLIDER.HOME": {
              actions: ["setChannelToMin"]
            },
            "CHANNEL_SLIDER.END": {
              actions: ["setChannelToMax"]
            },
            "CHANNEL_INPUT.BLUR": {
              actions: ["setChannelColorFromInput"]
            },
            INTERACT_OUTSIDE: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnClose"]
              },
              {
                guard: "shouldRestoreFocus",
                target: "focused",
                actions: ["invokeOnClose", "setReturnFocus"]
              },
              {
                target: "idle",
                actions: ["invokeOnClose"]
              }
            ],
            CLOSE: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnClose"]
              },
              {
                target: "idle",
                actions: ["invokeOnClose"]
              }
            ],
            "SWATCH_TRIGGER.CLICK": [
              {
                guard: BB("isOpenControlled", "closeOnSelect"),
                actions: ["setValue", "invokeOnClose"]
              },
              {
                guard: "closeOnSelect",
                target: "focused",
                actions: ["setValue", "invokeOnClose", "setReturnFocus"]
              },
              {
                actions: ["setValue"]
              }
            ]
          }
        },
        "open:dragging": {
          tags: ["open"],
          exit: ["clearActiveChannel"],
          activities: ["trackPointerMove", "disableTextSelection", "trackPositioning", "trackDismissableElement"],
          on: {
            "CONTROLLED.CLOSE": [
              {
                guard: "shouldRestoreFocus",
                target: "focused",
                actions: ["setReturnFocus"]
              },
              {
                target: "idle"
              }
            ],
            "AREA.POINTER_MOVE": {
              actions: ["setAreaColorFromPoint", "focusAreaThumb"]
            },
            "AREA.POINTER_UP": {
              target: "open",
              actions: ["invokeOnChangeEnd"]
            },
            "CHANNEL_SLIDER.POINTER_MOVE": {
              actions: ["setChannelColorFromPoint", "focusChannelThumb"]
            },
            "CHANNEL_SLIDER.POINTER_UP": {
              target: "open",
              actions: ["invokeOnChangeEnd"]
            },
            INTERACT_OUTSIDE: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnClose"]
              },
              {
                guard: "shouldRestoreFocus",
                target: "focused",
                actions: ["invokeOnClose", "setReturnFocus"]
              },
              {
                target: "idle",
                actions: ["invokeOnClose"]
              }
            ],
            CLOSE: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnClose"]
              },
              {
                target: "idle",
                actions: ["invokeOnClose"]
              }
            ]
          }
        }
      }
    },
    {
      guards: {
        closeOnSelect: (t) => !!t.closeOnSelect,
        isOpenControlled: (t) => !!t["open.controlled"],
        shouldRestoreFocus: (t) => !!t.restoreFocus
      },
      activities: {
        trackPositioning(t) {
          t.currentPlacement = t.positioning.placement;
          const r = $e.getTriggerEl(t);
          return uu(r, () => $e.getPositionerEl(t), {
            ...t.positioning,
            defer: !0,
            onComplete(a) {
              t.currentPlacement = a.placement;
            }
          });
        },
        trackDismissableElement(t, r, { send: o }) {
          return Uf(() => $e.getContentEl(t), {
            exclude: $e.getTriggerEl(t),
            defer: !0,
            onInteractOutside(l) {
              var u;
              (u = t.onInteractOutside) == null || u.call(t, l), !l.defaultPrevented && (t.restoreFocus = !(l.detail.focusable || l.detail.contextmenu));
            },
            onPointerDownOutside: t.onPointerDownOutside,
            onFocusOutside: t.onFocusOutside,
            onDismiss() {
              o({ type: "INTERACT_OUTSIDE" });
            }
          });
        },
        trackFormControl(t, r, { send: o, initialContext: a }) {
          const l = $e.getHiddenInputEl(t);
          return jf(l, {
            onFieldsetDisabledChange(u) {
              t.fieldsetDisabled = u;
            },
            onFormReset() {
              o({ type: "VALUE.SET", value: a.value, src: "form.reset" });
            }
          });
        },
        trackPointerMove(t, r, { send: o }) {
          return jD($e.getDoc(t), {
            onPointerMove({ point: a }) {
              const l = t.activeId === "area" ? "AREA.POINTER_MOVE" : "CHANNEL_SLIDER.POINTER_MOVE";
              o({ type: l, point: a });
            },
            onPointerUp() {
              const a = t.activeId === "area" ? "AREA.POINTER_UP" : "CHANNEL_SLIDER.POINTER_UP";
              o({ type: a });
            }
          });
        },
        disableTextSelection(t) {
          return Ib({ doc: $e.getDoc(t), target: $e.getContentEl(t) });
        }
      },
      actions: {
        openEyeDropper(t) {
          if (!("EyeDropper" in $e.getWin(t)))
            return;
          const o = $e.getWin(t);
          new o.EyeDropper().open().then(({ sRGBHex: l }) => {
            var p;
            const u = t.value.getFormat(), f = cu(l).toFormat(u);
            Ci.value(t, f), (p = t.onValueChangeEnd) == null || p.call(t, { value: t.value, valueAsString: t.valueAsString });
          }).catch(() => {
          });
        },
        setActiveChannel(t, r) {
          t.activeId = r.id, r.channel && (t.activeChannel = r.channel), r.orientation && (t.activeOrientation = r.orientation);
        },
        clearActiveChannel(t) {
          t.activeChannel = null, t.activeId = null, t.activeOrientation = null;
        },
        setAreaColorFromPoint(t, r) {
          const { xChannel: o, yChannel: a } = r.channel || t.activeChannel, l = $e.getAreaValueFromPoint(t, r.point);
          if (!l)
            return;
          const u = t.areaValue.getChannelPercentValue(o, l.x), f = t.areaValue.getChannelPercentValue(a, 1 - l.y), p = t.areaValue.withChannelValue(o, u).withChannelValue(a, f);
          Ci.value(t, p);
        },
        setChannelColorFromPoint(t, r) {
          const o = r.channel || t.activeId, a = $e.getChannelSliderValueFromPoint(t, r.point, o);
          if (!a)
            return;
          const u = (t.activeOrientation || "horizontal") === "horizontal" ? a.x : a.y, f = t.areaValue.getChannelPercentValue(o, u), p = t.areaValue.withChannelValue(o, f);
          Ci.value(t, p);
        },
        setValue(t, r) {
          Ci.value(t, r.value);
        },
        setFormat(t, r) {
          Ci.format(t, r.format);
        },
        syncInputElements(t) {
          jm.inputs(t);
        },
        invokeOnChangeEnd(t) {
          Zv.changeEnd(t);
        },
        setChannelColorFromInput(t, r) {
          const { channel: o, isTextField: a, value: l } = r, u = t.value.getChannelValue("alpha");
          let f;
          if (o === "alpha") {
            let p = parseFloat(l);
            p = Number.isNaN(p) ? u : p, f = t.value.withChannelValue("alpha", p);
          } else if (a)
            f = qA(
              () => Og(l).withChannelValue("alpha", u),
              () => t.value
            );
          else {
            const p = t.value.toFormat(t.format), y = Number.isNaN(l) ? p.getChannelValue(o) : l;
            f = p.withChannelValue(o, y);
          }
          jm.inputs(t, f), Ci.value(t, f);
        },
        incrementChannel(t, r) {
          const o = t.value.incrementChannel(r.channel, r.step);
          Ci.value(t, o);
        },
        decrementChannel(t, r) {
          const o = t.value.decrementChannel(r.channel, r.step);
          Ci.value(t, o);
        },
        incrementXChannel(t, r) {
          const { xChannel: o } = r.channel, a = t.areaValue.incrementChannel(o, r.step);
          Ci.value(t, a);
        },
        decrementXChannel(t, r) {
          const { xChannel: o } = r.channel, a = t.areaValue.decrementChannel(o, r.step);
          Ci.value(t, a);
        },
        incrementYChannel(t, r) {
          const { yChannel: o } = r.channel, a = t.areaValue.incrementChannel(o, r.step);
          Ci.value(t, a);
        },
        decrementYChannel(t, r) {
          const { yChannel: o } = r.channel, a = t.areaValue.decrementChannel(o, r.step);
          Ci.value(t, a);
        },
        setChannelToMax(t, r) {
          const o = t.value.getChannelRange(r.channel), a = t.value.withChannelValue(r.channel, o.maxValue);
          Ci.value(t, a);
        },
        setChannelToMin(t, r) {
          const o = t.value.getChannelRange(r.channel), a = t.value.withChannelValue(r.channel, o.minValue);
          Ci.value(t, a);
        },
        focusAreaThumb(t) {
          Ct(() => {
            var r;
            (r = $e.getAreaThumbEl(t)) == null || r.focus({ preventScroll: !0 });
          });
        },
        focusChannelThumb(t, r) {
          Ct(() => {
            var o;
            (o = $e.getChannelSliderThumbEl(t, r.channel)) == null || o.focus({ preventScroll: !0 });
          });
        },
        setInitialFocus(t) {
          Ct(() => {
            const r = Cb({
              root: $e.getContentEl(t),
              getInitialEl: t.initialFocusEl
            });
            r == null || r.focus({ preventScroll: !0 });
          });
        },
        setReturnFocus(t) {
          Ct(() => {
            var r;
            (r = $e.getTriggerEl(t)) == null || r.focus({ preventScroll: !0 });
          });
        },
        syncFormatSelectElement(t) {
          jm.formatSelect(t);
        },
        invokeOnOpen(t) {
          var r;
          (r = t.onOpenChange) == null || r.call(t, { open: !0 });
        },
        invokeOnClose(t) {
          var r;
          (r = t.onOpenChange) == null || r.call(t, { open: !1 });
        },
        toggleVisibility(t, r, { send: o }) {
          o({ type: t.open ? "CONTROLLED.OPEN" : "CONTROLLED.CLOSE", previousEvent: r });
        }
      },
      compareFns: {
        value: (t, r) => t.isEqual(r)
      }
    }
  );
}
var jm = {
  // sync channel inputs
  inputs(e, n) {
    const t = $e.getChannelInputEls(e);
    Ct(() => {
      t.forEach((r) => {
        const o = r.dataset.channel;
        $e.setValue(r, zv(n || e.value, o));
      });
    });
  },
  // sync format select
  formatSelect(e) {
    const n = $e.getFormatSelectEl(e);
    Ct(() => {
      $e.setValue(n, e.format);
    });
  }
}, Zv = {
  changeEnd(e) {
    var t;
    const n = e.value.toFormat(e.format);
    (t = e.onValueChangeEnd) == null || t.call(e, {
      value: n,
      valueAsString: e.valueAsString
    });
  },
  change(e) {
    var t;
    const n = e.value.toFormat(e.format);
    (t = e.onValueChange) == null || t.call(e, {
      value: n,
      valueAsString: e.valueAsString
    }), uL($e.getHiddenInputEl(e), { value: e.valueAsString });
  },
  formatChange(e) {
    var n;
    (n = e.onFormatChange) == null || n.call(e, { format: e.format });
  }
}, Ci = {
  value(e, n) {
    !n || e.value.isEqual(n) || (e.value = n, Zv.change(e));
  },
  format(e, n) {
    e.format !== n && (e.format = n, Zv.formatChange(e));
  }
};
const jB = (e) => {
  const { getRootNode: n } = Jr(), { dir: t } = ko(), r = {
    id: gr(),
    dir: t,
    getRootNode: n,
    open: e.defaultOpen,
    "open.controlled": e.open !== void 0,
    ...e,
    value: e.value ? Og(e.value) : e.defaultValue ? Og(e.defaultValue) : void 0
  }, o = {
    ...r,
    value: e.value ? Og(e.value) : void 0,
    onValueChange: en(e.onValueChange, { sync: !0 }),
    onValueChangeEnd: en(e.onValueChangeEnd)
  }, [a, l] = Or(VB(r), { context: o });
  return NB(a, l, yr);
}, Qw = oe((e, n) => {
  const [t, r] = fu(e), [o, a] = Ft()(
    r,
    [
      "closeOnSelect",
      "defaultOpen",
      "defaultValue",
      "disabled",
      "format",
      "id",
      "ids",
      "initialFocusEl",
      "name",
      "name",
      "onFocusOutside",
      "onFormatChange",
      "onInteractOutside",
      "onOpenChange",
      "onPointerDownOutside",
      "onValueChange",
      "onValueChangeEnd",
      "open",
      "positioning",
      "readOnly",
      "value"
    ]
  ), l = jB(o), u = cc(be({ present: l.open }, t)), f = be(l.getRootProps(), a);
  return /* @__PURE__ */ I.jsx(RL, { value: l, children: /* @__PURE__ */ I.jsx(Ad, { value: u, children: /* @__PURE__ */ I.jsx(ve.div, { ...f, ref: n }) }) });
});
Qw.displayName = "ColorPickerRoot";
const [UB, DY] = xt({
  name: "ColorPickerSwatchContext",
  hookName: "useColorPickerSwatchContext",
  providerName: "<ColorPickerSwatchProvider />"
}), qw = oe(
  (e, n) => {
    const [t, r] = Ft()(e, [
      "respectAlpha",
      "value"
    ]), o = lo(), a = be(o.getSwatchProps(t), r);
    return /* @__PURE__ */ I.jsx(UB, { value: t, children: /* @__PURE__ */ I.jsx(ve.div, { ...a, ref: n }) });
  }
);
qw.displayName = "ColorPickerSwatch";
const _w = oe((e, n) => {
  const [t, r] = Ft()(e, ["size"]), o = lo(), a = be(o.getTransparencyGridProps(t), r);
  return /* @__PURE__ */ I.jsx(ve.div, { ...a, ref: n });
});
_w.displayName = "ColorPickerTransparencyGrid";
const $w = oe(
  (e, n) => {
    const t = lo(), r = be(t.getTriggerProps(), e);
    return /* @__PURE__ */ I.jsx(ve.button, { ...r, ref: n });
  }
);
$w.displayName = "ColorPickerTrigger";
const [eI, ia] = xt({
  name: "ComboboxContext",
  hookName: "useComboboxContext",
  providerName: "<ComboboxProvider />"
}), tI = oe(
  (e, n) => {
    const t = ia(), r = be(t.getClearTriggerProps(), e);
    return /* @__PURE__ */ I.jsx(ve.button, { ...r, ref: n });
  }
);
tI.displayName = "ComboboxClearTrigger";
const ey = oe((e, n) => {
  const t = ia(), r = oa(), o = be(t.getContentProps(), r.getPresenceProps(n), e);
  return r.unmounted ? null : /* @__PURE__ */ I.jsx(ve.div, { ...o });
});
ey.displayName = "ComboboxContent";
const WB = (e) => e.children(ia()), ty = oe((e, n) => {
  const t = ia(), r = be(t.getControlProps(), e);
  return /* @__PURE__ */ I.jsx(ve.div, { ...r, ref: n });
});
ty.displayName = "ComboboxControl";
const ny = oe((e, n) => {
  const t = ia(), r = be(t.getInputProps(), e);
  return /* @__PURE__ */ I.jsx(ve.input, { ...r, ref: n });
});
ny.displayName = "ComboboxInput";
const [HB, GB] = xt(
  {
    name: "ComboboxItemContext",
    hookName: "useComboboxItemContext",
    providerName: "<ComboboxItemProvider />"
  }
), [YB, nI] = xt({
  name: "ComboboxItemPropsContext",
  hookName: "useComboboxItemPropsContext",
  providerName: "<ComboboxItemPropsProvider />"
}), ry = oe((e, n) => {
  const [t, r] = Ft()(e, ["item", "persistFocus"]), o = ia(), a = be(o.getItemProps(t), r), l = o.getItemState(t);
  return /* @__PURE__ */ I.jsx(YB, { value: t, children: /* @__PURE__ */ I.jsx(HB, { value: l, children: /* @__PURE__ */ I.jsx(ve.div, { ...a, ref: n }) }) });
});
ry.displayName = "ComboboxItem";
const zB = (e) => e.children(GB()), [ZB, KB] = xt({
  name: "ComboboxItemGroupPropsContext",
  hookName: "useComboboxItemGroupPropsContext",
  providerName: "<ComboboxItemGroupPropsProvider />"
}), oy = oe(
  (e, n) => {
    const t = gr(), [r, o] = Ft()(e, ["id"]), a = { id: t, ...r }, l = ia(), u = be(l.getItemGroupProps(a), o);
    return /* @__PURE__ */ I.jsx(ZB, { value: a, children: /* @__PURE__ */ I.jsx(ve.div, { ...u, ref: n }) });
  }
);
oy.displayName = "ComboboxItemGroup";
const iy = oe(
  (e, n) => {
    const t = ia(), r = KB(), o = be(
      t.getItemGroupLabelProps({ htmlFor: r.id }),
      e
    );
    return /* @__PURE__ */ I.jsx(ve.div, { ...o, ref: n });
  }
);
iy.displayName = "ComboboxItemGroupLabel";
const ay = oe(
  (e, n) => {
    const t = ia(), r = nI(), o = be(t.getItemIndicatorProps(r), e);
    return /* @__PURE__ */ I.jsx(ve.div, { ...o, ref: n });
  }
);
ay.displayName = "ComboboxItemIndicator";
const sy = oe((e, n) => {
  const t = ia(), r = nI(), o = be(t.getItemTextProps(r), e);
  return /* @__PURE__ */ I.jsx(ve.span, { ...o, ref: n });
});
sy.displayName = "ComboboxItemText";
const ly = oe((e, n) => {
  const t = ia(), r = be(t.getLabelProps(), e);
  return /* @__PURE__ */ I.jsx(ve.label, { ...r, ref: n });
});
ly.displayName = "ComboboxLabel";
const cy = oe(
  (e, n) => {
    const t = ia(), r = oa(), o = be(t.getPositionerProps(), e);
    return r.unmounted ? null : /* @__PURE__ */ I.jsx(ve.div, { ...o, ref: n });
  }
);
cy.displayName = "ComboboxPositioner";
var Jp = (e, n = []) => ({
  parts: (...t) => {
    if (XB(n))
      return Jp(e, t);
    throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
  },
  extendWith: (...t) => Jp(e, [...n, ...t]),
  rename: (t) => Jp(t, n),
  keys: () => n,
  build: () => [...new Set(n)].reduce(
    (t, r) => Object.assign(t, {
      [r]: {
        selector: [
          `&[data-scope="${sf(e)}"][data-part="${sf(r)}"]`,
          `& [data-scope="${sf(e)}"][data-part="${sf(r)}"]`
        ].join(", "),
        attrs: { "data-scope": sf(e), "data-part": sf(r) }
      }
    }),
    {}
  )
}), sf = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), XB = (e) => e.length === 0, JB = Object.defineProperty, QB = (e, n, t) => n in e ? JB(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, dn = (e, n, t) => (QB(e, typeof n != "symbol" ? n + "" : n, t), t);
function qB(e) {
  let n, t, r = 2166136261;
  for (n = 0, t = e.length; n < t; n++)
    r ^= e.charCodeAt(n), r += (r << 1) + (r << 4) + (r << 7) + (r << 8) + (r << 24);
  return `00000${(r >>> 0).toString(36)}`.slice(-6);
}
var Um = (e) => typeof e == "object" && e !== null && !Array.isArray(e), Wm = (e, n) => Object.prototype.hasOwnProperty.call(e, n), Qp = {
  itemToValue(e) {
    return typeof e == "string" ? e : Um(e) && Wm(e, "value") ? e.value : "";
  },
  itemToString(e) {
    return typeof e == "string" ? e : Um(e) && Wm(e, "label") ? e.label : Qp.itemToValue(e);
  },
  itemToDisabled(e) {
    return Um(e) && Wm(e, "disabled") ? !!e.disabled : !1;
  }
}, Lh = class {
  constructor(e) {
    this.options = e, dn(this, "nodes", /* @__PURE__ */ new Map()), dn(this, "disabledValues", /* @__PURE__ */ new Set()), dn(this, "_firstValue", null), dn(this, "_lastValue", null), dn(this, "hash", ""), dn(this, "isEqual", (n) => this.hash === n.hash), dn(this, "iterate", () => {
      const { items: n } = this.options, t = /* @__PURE__ */ new Set();
      for (let r = 0; r < n.length; r++) {
        const o = n[r], a = this.itemToValue(o), l = this.itemToString(o), u = this.itemToDisabled(o);
        t.add(JSON.stringify({ value: a, label: l, disabled: u }));
        const f = {
          // freeze item to prevent mutation by frameworks like Solid.js
          item: Object.freeze(o),
          index: r,
          label: l,
          value: a,
          previousValue: this.itemToValue(n[r - 1]) ?? null,
          nextValue: this.itemToValue(n[r + 1]) ?? null
        };
        this.nodes.set(a, f), u && this.disabledValues.add(a), r === 0 && (this._firstValue = a), r === n.length - 1 && (this._lastValue = a);
      }
      return this.hash = qB(Array.from(t).join("")), this;
    }), dn(this, "setItems", (n) => (this.options.items = n, this.iterate())), dn(this, "item", (n) => {
      var t;
      return n === null ? null : ((t = this.nodes.get(n)) == null ? void 0 : t.item) ?? null;
    }), dn(this, "items", (n) => n.map((t) => this.item(t)).filter(Boolean)), dn(this, "at", (n) => {
      for (const t of this.nodes.values())
        if (t.index === n)
          return t.item;
      return null;
    }), dn(this, "sortFn", (n, t) => {
      const r = this.nodes.get(n), o = this.nodes.get(t);
      return ((r == null ? void 0 : r.index) ?? 0) - ((o == null ? void 0 : o.index) ?? 0);
    }), dn(this, "sort", (n) => [...n].sort(this.sortFn)), dn(this, "itemToValue", (n) => {
      var t, r;
      return n ? ((r = (t = this.options).itemToValue) == null ? void 0 : r.call(t, n)) ?? Qp.itemToValue(n) : "";
    }), dn(this, "itemToString", (n) => {
      var t, r;
      return n ? ((r = (t = this.options).itemToString) == null ? void 0 : r.call(t, n)) ?? Qp.itemToString(n) : "";
    }), dn(this, "itemToDisabled", (n) => {
      var t, r;
      return n ? ((r = (t = this.options).isItemDisabled) == null ? void 0 : r.call(t, n)) ?? Qp.itemToDisabled(n) : !1;
    }), dn(this, "valueToString", (n) => {
      var t;
      return n == null ? "" : ((t = this.nodes.get(n)) == null ? void 0 : t.label) ?? "";
    }), dn(this, "itemsToString", (n, t = ", ") => n.map((r) => this.itemToString(r)).filter(Boolean).join(t)), dn(this, "has", (n) => n == null ? !1 : this.nodes.has(n)), dn(this, "count", () => this.nodes.size), dn(this, "first", () => {
      let n = this._firstValue;
      for (; n != null; ) {
        let t = this.nodes.get(n);
        if (t != null && !this.disabledValues.has(t.value))
          return n;
        n = (t == null ? void 0 : t.nextValue) ?? null;
      }
      return null;
    }), dn(this, "last", () => {
      let n = this._lastValue;
      for (; n != null; ) {
        let t = this.nodes.get(n);
        if (t != null && !this.disabledValues.has(t.value))
          return n;
        n = (t == null ? void 0 : t.previousValue) ?? null;
      }
      return null;
    }), dn(this, "next", (n) => {
      if (n == null)
        return null;
      const t = this.nodes.get(n);
      let r = (t == null ? void 0 : t.nextValue) ?? null;
      for (; r != null; ) {
        let o = this.nodes.get(r);
        if (o != null && !this.disabledValues.has(o.value))
          return r;
        r = (o == null ? void 0 : o.nextValue) ?? null;
      }
      return null;
    }), dn(this, "prev", (n) => {
      if (n == null)
        return null;
      const t = this.nodes.get(n);
      let r = (t == null ? void 0 : t.previousValue) ?? null;
      for (; r != null; ) {
        let o = this.nodes.get(r);
        if (o != null && !this.disabledValues.has(o.value))
          return r;
        r = (o == null ? void 0 : o.previousValue) ?? null;
      }
      return null;
    }), dn(this, "isItemDisabled", (n) => this.disabledValues.has(this.itemToValue(n))), dn(this, "toArray", () => Array.from(this.nodes.values())), dn(this, "indexOf", (n) => {
      var t;
      return n == null ? -1 : ((t = this.nodes.get(n)) == null ? void 0 : t.index) ?? -1;
    }), dn(this, "getByText", (n, t) => {
      const r = this.indexOf(t);
      let o = t != null ? $B(this.toArray(), r) : this.toArray();
      return n.length === 1 && (o = o.filter((l) => l.value !== t)), o.find((l) => _B(l.label, n));
    }), dn(this, "search", (n, t) => {
      var w;
      const { state: r, currentValue: o, timeout: a = 350 } = t, l = r.keysSoFar + n, f = l.length > 1 && Array.from(l).every((F) => F === l[0]) ? l[0] : l, p = ((w = this.getByText(f, o)) == null ? void 0 : w.value) ?? null;
      function y() {
        clearTimeout(r.timer), r.timer = -1;
      }
      function A(F) {
        r.keysSoFar = F, y(), F !== "" && (r.timer = +setTimeout(() => {
          A(""), y();
        }, a));
      }
      return A(l), p;
    }), dn(this, "toJSON", () => ({
      size: this.count(),
      first: this.first(),
      last: this.last()
    })), this.iterate();
  }
}, _B = (e, n) => e.toLowerCase().startsWith(n.toLowerCase()), $B = (e, n) => e.map((t, r) => e[(Math.max(n, 0) + r) % e.length]), vg = /* @__PURE__ */ new WeakMap(), ka = [];
function eV(e, n = {}) {
  const { rootEl: t } = n, r = e.filter(Boolean);
  if (r.length === 0)
    return;
  const o = r[0].ownerDocument || document, a = o.defaultView ?? window, l = new Set(r), u = /* @__PURE__ */ new Set(), f = t ?? o.body;
  let p = (F) => {
    for (let k of F.querySelectorAll("[data-live-announcer], [data-zag-top-layer]"))
      l.add(k);
    let j = (k) => {
      if (l.has(k) || u.has(k.parentElement) && k.parentElement.getAttribute("role") !== "row")
        return NodeFilter.FILTER_REJECT;
      for (let z of l)
        if (k.contains(z))
          return NodeFilter.FILTER_SKIP;
      return NodeFilter.FILTER_ACCEPT;
    }, N = o.createTreeWalker(F, NodeFilter.SHOW_ELEMENT, { acceptNode: j }), D = j(F);
    if (D === NodeFilter.FILTER_ACCEPT && y(F), D !== NodeFilter.FILTER_REJECT) {
      let k = N.nextNode();
      for (; k != null; )
        y(k), k = N.nextNode();
    }
  }, y = (F) => {
    let j = vg.get(F) ?? 0;
    F.getAttribute("aria-hidden") === "true" && j === 0 || (j === 0 && F.setAttribute("aria-hidden", "true"), u.add(F), vg.set(F, j + 1));
  };
  ka.length && ka[ka.length - 1].disconnect(), p(f);
  const A = new a.MutationObserver((F) => {
    for (let j of F)
      if (!(j.type !== "childList" || j.addedNodes.length === 0) && ![...l, ...u].some((N) => N.contains(j.target))) {
        for (let N of j.removedNodes)
          N instanceof a.Element && (l.delete(N), u.delete(N));
        for (let N of j.addedNodes)
          (N instanceof a.HTMLElement || N instanceof a.SVGElement) && (N.dataset.liveAnnouncer === "true" || N.dataset.zagTopLayer === "true") ? l.add(N) : N instanceof a.Element && p(N);
      }
  });
  A.observe(f, { childList: !0, subtree: !0 });
  let w = {
    observe() {
      A.observe(f, { childList: !0, subtree: !0 });
    },
    disconnect() {
      A.disconnect();
    }
  };
  return ka.push(w), () => {
    A.disconnect();
    for (let F of u) {
      let j = vg.get(F);
      j === 1 ? (F.removeAttribute("aria-hidden"), vg.delete(F)) : vg.set(F, j - 1);
    }
    w === ka[ka.length - 1] ? (ka.pop(), ka.length && ka[ka.length - 1].observe()) : ka.splice(ka.indexOf(w), 1);
  };
}
function rI(e, n = {}) {
  const { defer: t } = n, r = t ? Ct : (a) => a(), o = [];
  return o.push(
    r(() => {
      const a = typeof e == "function" ? e() : e;
      o.push(eV(a, n));
    })
  ), () => {
    o.forEach((a) => a == null ? void 0 : a());
  };
}
var tV = Jp("combobox").parts(
  "root",
  "label",
  "input",
  "positioner",
  "control",
  "trigger",
  "content",
  "clearTrigger",
  "item",
  "itemText",
  "itemIndicator",
  "itemGroup",
  "itemGroupLabel"
), qi = tV.build(), uy = (e) => Hn(new Lh(e));
uy.empty = () => Hn(new Lh({ items: [] }));
var tt = so({
  getRootId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.root) ?? `combobox:${e.id}`;
  },
  getLabelId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.label) ?? `combobox:${e.id}:label`;
  },
  getControlId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.control) ?? `combobox:${e.id}:control`;
  },
  getInputId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.input) ?? `combobox:${e.id}:input`;
  },
  getContentId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.content) ?? `combobox:${e.id}:content`;
  },
  getPositionerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.positioner) ?? `combobox:${e.id}:popper`;
  },
  getTriggerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.trigger) ?? `combobox:${e.id}:toggle-btn`;
  },
  getClearTriggerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.clearTrigger) ?? `combobox:${e.id}:clear-btn`;
  },
  getItemGroupId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.itemGroup) == null ? void 0 : r.call(t, n)) ?? `combobox:${e.id}:optgroup:${n}`;
  },
  getItemGroupLabelId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.itemGroupLabel) == null ? void 0 : r.call(t, n)) ?? `combobox:${e.id}:optgroup-label:${n}`;
  },
  getItemId: (e, n) => `combobox:${e.id}:option:${n}`,
  getContentEl: (e) => tt.getById(e, tt.getContentId(e)),
  getInputEl: (e) => tt.getById(e, tt.getInputId(e)),
  getPositionerEl: (e) => tt.getById(e, tt.getPositionerId(e)),
  getControlEl: (e) => tt.getById(e, tt.getControlId(e)),
  getTriggerEl: (e) => tt.getById(e, tt.getTriggerId(e)),
  getClearTriggerEl: (e) => tt.getById(e, tt.getClearTriggerId(e)),
  getHighlightedItemEl: (e) => {
    const n = e.highlightedValue;
    if (n != null)
      return Sb(tt.getContentEl(e), `[role=option][data-value="${CSS.escape(n)}"`);
  },
  focusInputEl: (e) => {
    const n = tt.getInputEl(e);
    tt.getActiveElement(e) !== n && (n == null || n.focus({ preventScroll: !0 }));
  },
  focusTriggerEl: (e) => {
    const n = tt.getTriggerEl(e);
    tt.getActiveElement(e) !== n && (n == null || n.focus({ preventScroll: !0 }));
  }
});
function nV(e, n, t) {
  const r = e.context.translations, o = e.context.collection, a = e.context.disabled, l = e.context.isInteractive, u = e.context.invalid, f = e.context.readOnly, p = e.hasTag("open"), y = e.hasTag("focused"), A = e.context.composite, w = e.context.highlightedValue, F = Yg({
    ...e.context.positioning,
    placement: e.context.currentPlacement
  });
  function j(N) {
    const { item: D } = N, k = o.isItemDisabled(D), z = o.itemToValue(D);
    return {
      value: z,
      disabled: !!(k || k),
      highlighted: w === z,
      selected: e.context.value.includes(z)
    };
  }
  return {
    focused: y,
    open: p,
    inputValue: e.context.inputValue,
    highlightedValue: w,
    highlightedItem: e.context.highlightedItem,
    value: e.context.value,
    valueAsString: e.context.valueAsString,
    hasSelectedItems: e.context.hasSelectedItems,
    selectedItems: e.context.selectedItems,
    collection: e.context.collection,
    reposition(N = {}) {
      n({ type: "POSITIONING.SET", options: N });
    },
    setCollection(N) {
      n({ type: "COLLECTION.SET", value: N });
    },
    setHighlightValue(N) {
      n({ type: "HIGHLIGHTED_VALUE.SET", value: N });
    },
    selectValue(N) {
      n({ type: "ITEM.SELECT", value: N });
    },
    setValue(N) {
      n({ type: "VALUE.SET", value: N });
    },
    setInputValue(N) {
      n({ type: "INPUT_VALUE.SET", value: N });
    },
    clearValue(N) {
      N != null ? n({ type: "ITEM.CLEAR", value: N }) : n("VALUE.CLEAR");
    },
    focus() {
      var N;
      (N = tt.getInputEl(e.context)) == null || N.focus();
    },
    setOpen(N) {
      N !== p && n(N ? "OPEN" : "CLOSE");
    },
    getRootProps() {
      return t.element({
        ...qi.root.attrs,
        dir: e.context.dir,
        id: tt.getRootId(e.context),
        "data-invalid": se(u),
        "data-readonly": se(f)
      });
    },
    getLabelProps() {
      return t.label({
        ...qi.label.attrs,
        dir: e.context.dir,
        htmlFor: tt.getInputId(e.context),
        id: tt.getLabelId(e.context),
        "data-readonly": se(f),
        "data-disabled": se(a),
        "data-invalid": se(u),
        "data-focus": se(y),
        onClick(N) {
          var D;
          A || (N.preventDefault(), (D = tt.getTriggerEl(e.context)) == null || D.focus({ preventScroll: !0 }));
        }
      });
    },
    getControlProps() {
      return t.element({
        ...qi.control.attrs,
        dir: e.context.dir,
        id: tt.getControlId(e.context),
        "data-state": p ? "open" : "closed",
        "data-focus": se(y),
        "data-disabled": se(a),
        "data-invalid": se(u)
      });
    },
    getPositionerProps() {
      return t.element({
        ...qi.positioner.attrs,
        dir: e.context.dir,
        id: tt.getPositionerId(e.context),
        style: F.floating
      });
    },
    getInputProps() {
      return t.input({
        ...qi.input.attrs,
        dir: e.context.dir,
        "aria-invalid": Zr(u),
        "data-invalid": se(u),
        name: e.context.name,
        form: e.context.form,
        disabled: a,
        autoFocus: e.context.autoFocus,
        autoComplete: "off",
        autoCorrect: "off",
        autoCapitalize: "none",
        spellCheck: "false",
        readOnly: f,
        placeholder: e.context.placeholder,
        id: tt.getInputId(e.context),
        type: "text",
        role: "combobox",
        defaultValue: e.context.inputValue,
        "aria-autocomplete": e.context.autoComplete ? "both" : "list",
        "aria-controls": tt.getContentId(e.context),
        "aria-expanded": p,
        "data-state": p ? "open" : "closed",
        "aria-activedescendant": w ? tt.getItemId(e.context, w) : void 0,
        onClick(N) {
          N.defaultPrevented || e.context.openOnClick && l && n("INPUT.CLICK");
        },
        onFocus() {
          a || n("INPUT.FOCUS");
        },
        onBlur() {
          a || n("INPUT.BLUR");
        },
        onChange(N) {
          n({ type: "INPUT.CHANGE", value: N.currentTarget.value });
        },
        onKeyDown(N) {
          if (N.defaultPrevented || !l || N.ctrlKey || N.shiftKey || hb(N))
            return;
          const D = e.context.openOnKeyPress, k = N.ctrlKey || N.metaKey || N.shiftKey, z = !0, q = {
            ArrowDown(Fe) {
              !D && !p || (n({ type: Fe.altKey ? "OPEN" : "INPUT.ARROW_DOWN", keypress: z }), Fe.preventDefault());
            },
            ArrowUp() {
              !D && !p || (n({ type: N.altKey ? "CLOSE" : "INPUT.ARROW_UP", keypress: z }), N.preventDefault());
            },
            Home(Fe) {
              k || (n({ type: "INPUT.HOME", keypress: z }), p && Fe.preventDefault());
            },
            End(Fe) {
              k || (n({ type: "INPUT.END", keypress: z }), p && Fe.preventDefault());
            },
            Enter(Fe) {
              n({ type: "INPUT.ENTER", keypress: z }), p && Fe.preventDefault();
              const Oe = tt.getHighlightedItemEl(e.context);
              Lv(Oe);
            },
            Escape() {
              n({ type: "INPUT.ESCAPE", keypress: z }), N.preventDefault();
            }
          }, Ce = il(N, e.context), ee = q[Ce];
          ee == null || ee(N);
        }
      });
    },
    getTriggerProps(N = {}) {
      return t.button({
        ...qi.trigger.attrs,
        dir: e.context.dir,
        id: tt.getTriggerId(e.context),
        "aria-haspopup": A ? "listbox" : "dialog",
        type: "button",
        tabIndex: N.focusable ? void 0 : -1,
        "aria-label": r.triggerLabel,
        "aria-expanded": p,
        "data-state": p ? "open" : "closed",
        "aria-controls": p ? tt.getContentId(e.context) : void 0,
        disabled: a,
        "data-focusable": se(N.focusable),
        "data-readonly": se(f),
        "data-disabled": se(a),
        onFocus() {
          N.focusable && n({ type: "INPUT.FOCUS", src: "trigger" });
        },
        onClick(D) {
          D.defaultPrevented || l && rc(D) && n("TRIGGER.CLICK");
        },
        onPointerDown(D) {
          l && D.pointerType !== "touch" && (D.preventDefault(), queueMicrotask(() => {
            var k;
            (k = tt.getInputEl(e.context)) == null || k.focus({ preventScroll: !0 });
          }));
        },
        onKeyDown(D) {
          if (D.defaultPrevented || A)
            return;
          const k = {
            ArrowDown() {
              n({ type: "INPUT.ARROW_DOWN", src: "trigger" });
            },
            ArrowUp() {
              n({ type: "INPUT.ARROW_UP", src: "trigger" });
            }
          }, z = il(D, e.context), q = k[z];
          q && (q(D), D.preventDefault());
        }
      });
    },
    getContentProps() {
      return t.element({
        ...qi.content.attrs,
        dir: e.context.dir,
        id: tt.getContentId(e.context),
        role: A ? "listbox" : "dialog",
        tabIndex: -1,
        hidden: !p,
        "data-state": p ? "open" : "closed",
        "aria-labelledby": tt.getLabelId(e.context),
        "aria-multiselectable": e.context.multiple && A ? !0 : void 0,
        onPointerDown(N) {
          N.preventDefault();
        }
      });
    },
    getListProps() {
      return t.element({
        role: A ? void 0 : "listbox",
        "aria-labelledby": tt.getLabelId(e.context),
        "aria-multiselectable": e.context.multiple && !A ? !0 : void 0
      });
    },
    getClearTriggerProps() {
      return t.button({
        ...qi.clearTrigger.attrs,
        dir: e.context.dir,
        id: tt.getClearTriggerId(e.context),
        type: "button",
        tabIndex: -1,
        disabled: a,
        "aria-label": r.clearTriggerLabel,
        "aria-controls": tt.getInputId(e.context),
        hidden: !e.context.value.length,
        onPointerDown(N) {
          N.preventDefault();
        },
        onClick(N) {
          N.defaultPrevented || l && n({ type: "VALUE.CLEAR", src: "clear-trigger" });
        }
      });
    },
    getItemState: j,
    getItemProps(N) {
      const D = j(N), k = D.value;
      return t.element({
        ...qi.item.attrs,
        dir: e.context.dir,
        id: tt.getItemId(e.context, k),
        role: "option",
        tabIndex: -1,
        "data-highlighted": se(D.highlighted),
        "data-state": D.selected ? "checked" : "unchecked",
        "aria-selected": D.highlighted,
        "aria-disabled": D.disabled,
        "data-disabled": se(D.disabled),
        "data-value": D.value,
        onPointerMove() {
          D.disabled || D.highlighted || n({ type: "ITEM.POINTER_MOVE", value: k });
        },
        onPointerLeave() {
          N.persistFocus || D.disabled || !e.previousEvent.type.includes("POINTER") || n({ type: "ITEM.POINTER_LEAVE", value: k });
        },
        onPointerUp(z) {
          Fv(z) || Dv(z) || xb(z) || D.disabled || n({ type: "ITEM.CLICK", src: "pointerup", value: k });
        },
        onTouchEnd(z) {
          z.preventDefault(), z.stopPropagation();
        }
      });
    },
    getItemTextProps(N) {
      const D = j(N);
      return t.element({
        ...qi.itemText.attrs,
        dir: e.context.dir,
        "data-disabled": se(D.disabled),
        "data-highlighted": se(D.highlighted)
      });
    },
    getItemIndicatorProps(N) {
      const D = j(N);
      return t.element({
        "aria-hidden": !0,
        ...qi.itemIndicator.attrs,
        dir: e.context.dir,
        "data-state": D.selected ? "checked" : "unchecked",
        hidden: !D.selected
      });
    },
    getItemGroupProps(N) {
      const { id: D } = N;
      return t.element({
        ...qi.itemGroup.attrs,
        dir: e.context.dir,
        id: tt.getItemGroupId(e.context, D),
        "aria-labelledby": tt.getItemGroupLabelId(e.context, D)
      });
    },
    getItemGroupLabelProps(N) {
      const { htmlFor: D } = N;
      return t.element({
        ...qi.itemGroupLabel.attrs,
        dir: e.context.dir,
        id: tt.getItemGroupLabelId(e.context, D),
        role: "group"
      });
    }
  };
}
var { and: Ei, not: bg } = Ma;
function rV(e) {
  const n = br(e);
  return Rr(
    {
      id: "combobox",
      initial: n.open ? "suggesting" : "idle",
      context: {
        loopFocus: !0,
        openOnClick: !1,
        value: [],
        highlightedValue: null,
        inputValue: "",
        allowCustomValue: !1,
        closeOnSelect: !n.multiple,
        inputBehavior: "none",
        selectionBehavior: "replace",
        openOnKeyPress: !0,
        openOnChange: !0,
        composite: !0,
        ...n,
        highlightedItem: null,
        selectedItems: [],
        valueAsString: "",
        collection: n.collection ?? uy.empty(),
        positioning: {
          placement: "bottom",
          flip: !1,
          sameWidth: !0,
          ...n.positioning
        },
        translations: {
          triggerLabel: "Toggle suggestions",
          clearTriggerLabel: "Clear value",
          ...n.translations
        }
      },
      created: ["syncInitialValues", "syncSelectionBehavior"],
      computed: {
        isInputValueEmpty: (t) => t.inputValue.length === 0,
        isInteractive: (t) => !(t.readOnly || t.disabled),
        autoComplete: (t) => t.inputBehavior === "autocomplete",
        autoHighlight: (t) => t.inputBehavior === "autohighlight",
        hasSelectedItems: (t) => t.value.length > 0
      },
      watch: {
        value: ["syncSelectedItems"],
        inputValue: ["syncInputValue"],
        highlightedValue: ["syncHighlightedItem", "autofillInputValue"],
        multiple: ["syncSelectionBehavior"],
        open: ["toggleVisibility"]
      },
      on: {
        "HIGHLIGHTED_VALUE.SET": {
          actions: ["setHighlightedItem"]
        },
        "ITEM.SELECT": {
          actions: ["selectItem"]
        },
        "ITEM.CLEAR": {
          actions: ["clearItem"]
        },
        "VALUE.SET": {
          actions: ["setSelectedItems"]
        },
        "INPUT_VALUE.SET": {
          actions: "setInputValue"
        },
        "COLLECTION.SET": {
          actions: ["setCollection"]
        },
        "POSITIONING.SET": {
          actions: ["reposition"]
        }
      },
      states: {
        idle: {
          tags: ["idle", "closed"],
          entry: ["scrollContentToTop", "clearHighlightedItem"],
          on: {
            "CONTROLLED.OPEN": {
              target: "interacting"
            },
            "TRIGGER.CLICK": [
              {
                guard: "isOpenControlled",
                actions: ["setInitialFocus", "highlightFirstSelectedItem", "invokeOnOpen"]
              },
              {
                target: "interacting",
                actions: ["setInitialFocus", "highlightFirstSelectedItem", "invokeOnOpen"]
              }
            ],
            "INPUT.CLICK": [
              {
                guard: "isOpenControlled",
                actions: ["highlightFirstSelectedItem", "invokeOnOpen"]
              },
              {
                target: "interacting",
                actions: ["highlightFirstSelectedItem", "invokeOnOpen"]
              }
            ],
            "INPUT.FOCUS": {
              target: "focused"
            },
            OPEN: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnOpen"]
              },
              {
                target: "interacting",
                actions: ["invokeOnOpen"]
              }
            ],
            "VALUE.CLEAR": {
              target: "focused",
              actions: ["clearInputValue", "clearSelectedItems", "setInitialFocus"]
            }
          }
        },
        focused: {
          tags: ["focused", "closed"],
          entry: ["scrollContentToTop", "clearHighlightedItem"],
          on: {
            "CONTROLLED.OPEN": [
              {
                guard: "isChangeEvent",
                target: "suggesting"
              },
              {
                target: "interacting"
              }
            ],
            "INPUT.CHANGE": [
              {
                guard: Ei("isOpenControlled", "openOnChange"),
                actions: ["setInputValue", "invokeOnOpen", "highlightFirstItemIfNeeded"]
              },
              {
                guard: "openOnChange",
                target: "suggesting",
                actions: ["setInputValue", "invokeOnOpen", "highlightFirstItemIfNeeded"]
              },
              {
                actions: "setInputValue"
              }
            ],
            "LAYER.INTERACT_OUTSIDE": {
              target: "idle"
            },
            "INPUT.ESCAPE": {
              guard: Ei("isCustomValue", bg("allowCustomValue")),
              actions: "revertInputValue"
            },
            "INPUT.BLUR": {
              target: "idle"
            },
            "INPUT.CLICK": [
              {
                guard: "isOpenControlled",
                actions: ["highlightFirstSelectedItem", "invokeOnOpen"]
              },
              {
                target: "interacting",
                actions: ["highlightFirstSelectedItem", "invokeOnOpen"]
              }
            ],
            "TRIGGER.CLICK": [
              {
                guard: "isOpenControlled",
                actions: ["setInitialFocus", "highlightFirstSelectedItem", "invokeOnOpen"]
              },
              {
                target: "interacting",
                actions: ["setInitialFocus", "highlightFirstSelectedItem", "invokeOnOpen"]
              }
            ],
            "INPUT.ARROW_DOWN": [
              // == group 1 ==
              {
                guard: Ei("isOpenControlled", "autoComplete"),
                actions: ["invokeOnOpen"]
              },
              {
                guard: "autoComplete",
                target: "interacting",
                actions: ["invokeOnOpen"]
              },
              // == group 2 ==
              {
                guard: "isOpenControlled",
                actions: ["highlightFirstOrSelectedItem", "invokeOnOpen"]
              },
              {
                target: "interacting",
                actions: ["highlightFirstOrSelectedItem", "invokeOnOpen"]
              }
            ],
            "INPUT.ARROW_UP": [
              // == group 1 ==
              {
                guard: "autoComplete",
                target: "interacting",
                actions: "invokeOnOpen"
              },
              {
                guard: "autoComplete",
                target: "interacting",
                actions: "invokeOnOpen"
              },
              // == group 2 ==
              {
                target: "interacting",
                actions: ["highlightLastOrSelectedItem", "invokeOnOpen"]
              },
              {
                target: "interacting",
                actions: ["highlightLastOrSelectedItem", "invokeOnOpen"]
              }
            ],
            OPEN: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnOpen"]
              },
              {
                target: "interacting",
                actions: ["invokeOnOpen"]
              }
            ],
            "VALUE.CLEAR": {
              actions: ["clearInputValue", "clearSelectedItems"]
            }
          }
        },
        interacting: {
          tags: ["open", "focused"],
          entry: ["setInitialFocus"],
          activities: ["scrollToHighlightedItem", "trackDismissableLayer", "computePlacement", "hideOtherElements"],
          on: {
            "CONTROLLED.CLOSE": [
              {
                guard: "restoreFocus",
                target: "focused",
                actions: ["setFinalFocus"]
              },
              {
                target: "idle"
              }
            ],
            "INPUT.HOME": {
              actions: ["highlightFirstItem"]
            },
            "INPUT.END": {
              actions: ["highlightLastItem"]
            },
            "INPUT.ARROW_DOWN": [
              {
                guard: Ei("autoComplete", "isLastItemHighlighted"),
                actions: ["clearHighlightedItem", "scrollContentToTop"]
              },
              {
                actions: ["highlightNextItem"]
              }
            ],
            "INPUT.ARROW_UP": [
              {
                guard: Ei("autoComplete", "isFirstItemHighlighted"),
                actions: "clearHighlightedItem"
              },
              {
                actions: "highlightPrevItem"
              }
            ],
            "INPUT.ENTER": [
              {
                guard: Ei("isOpenControlled", "closeOnSelect"),
                actions: ["selectHighlightedItem", "invokeOnClose"]
              },
              {
                guard: "closeOnSelect",
                target: "focused",
                actions: ["selectHighlightedItem", "invokeOnClose", "setFinalFocus"]
              },
              {
                actions: ["selectHighlightedItem"]
              }
            ],
            "INPUT.CHANGE": [
              {
                guard: "autoComplete",
                target: "suggesting",
                actions: ["setInputValue", "invokeOnOpen"]
              },
              {
                target: "suggesting",
                actions: ["clearHighlightedItem", "setInputValue", "invokeOnOpen"]
              }
            ],
            "ITEM.POINTER_MOVE": {
              actions: ["setHighlightedItem"]
            },
            "ITEM.POINTER_LEAVE": {
              actions: ["clearHighlightedItem"]
            },
            "ITEM.CLICK": [
              {
                guard: Ei("isOpenControlled", "closeOnSelect"),
                actions: ["selectItem", "invokeOnClose"]
              },
              {
                guard: "closeOnSelect",
                target: "focused",
                actions: ["selectItem", "invokeOnClose", "setFinalFocus"]
              },
              {
                actions: ["selectItem"]
              }
            ],
            "LAYER.ESCAPE": [
              {
                guard: Ei("isOpenControlled", "autoComplete"),
                actions: ["syncInputValue", "invokeOnClose"]
              },
              {
                guard: "autoComplete",
                target: "focused",
                actions: ["syncInputValue", "invokeOnClose"]
              },
              {
                guard: "isOpenControlled",
                actions: "invokeOnClose"
              },
              {
                target: "focused",
                actions: ["invokeOnClose", "setFinalFocus"]
              }
            ],
            "TRIGGER.CLICK": [
              {
                guard: "isOpenControlled",
                actions: "invokeOnClose"
              },
              {
                target: "focused",
                actions: "invokeOnClose"
              }
            ],
            "LAYER.INTERACT_OUTSIDE": [
              // == group 1 ==
              {
                guard: Ei("isOpenControlled", "isCustomValue", bg("allowCustomValue")),
                actions: ["revertInputValue", "invokeOnClose"]
              },
              {
                guard: Ei("isCustomValue", bg("allowCustomValue")),
                target: "idle",
                actions: ["revertInputValue", "invokeOnClose"]
              },
              // == group 2 ==
              {
                guard: "isOpenControlled",
                actions: "invokeOnClose"
              },
              {
                target: "idle",
                actions: "invokeOnClose"
              }
            ],
            CLOSE: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnClose"]
              },
              {
                target: "focused",
                actions: ["invokeOnClose", "setFinalFocus"]
              }
            ],
            "VALUE.CLEAR": [
              {
                guard: "isOpenControlled",
                actions: ["clearInputValue", "clearSelectedItems", "invokeOnClose"]
              },
              {
                target: "focused",
                actions: ["clearInputValue", "clearSelectedItems", "invokeOnClose", "setFinalFocus"]
              }
            ]
          }
        },
        suggesting: {
          tags: ["open", "focused"],
          activities: [
            "trackDismissableLayer",
            "scrollToHighlightedItem",
            "computePlacement",
            "trackChildNodes",
            "hideOtherElements"
          ],
          entry: ["setInitialFocus"],
          on: {
            "CONTROLLED.CLOSE": [
              {
                guard: "restoreFocus",
                target: "focused",
                actions: ["setFinalFocus"]
              },
              {
                target: "idle"
              }
            ],
            CHILDREN_CHANGE: {
              actions: ["highlightFirstItem"]
            },
            "INPUT.ARROW_DOWN": {
              target: "interacting",
              actions: ["highlightNextItem"]
            },
            "INPUT.ARROW_UP": {
              target: "interacting",
              actions: ["highlightPrevItem"]
            },
            "INPUT.HOME": {
              target: "interacting",
              actions: ["highlightFirstItem"]
            },
            "INPUT.END": {
              target: "interacting",
              actions: ["highlightLastItem"]
            },
            "INPUT.ENTER": [
              {
                guard: Ei("isOpenControlled", "closeOnSelect"),
                actions: ["selectHighlightedItem", "invokeOnClose"]
              },
              {
                guard: "closeOnSelect",
                target: "focused",
                actions: ["selectHighlightedItem", "invokeOnClose", "setFinalFocus"]
              },
              {
                actions: ["selectHighlightedItem"]
              }
            ],
            "INPUT.CHANGE": [
              {
                guard: "autoHighlight",
                actions: ["setInputValue"]
              },
              {
                actions: ["setInputValue"]
              }
            ],
            "LAYER.ESCAPE": [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnClose"]
              },
              {
                target: "focused",
                actions: ["invokeOnClose"]
              }
            ],
            "ITEM.POINTER_MOVE": {
              target: "interacting",
              actions: ["setHighlightedItem"]
            },
            "ITEM.POINTER_LEAVE": {
              actions: ["clearHighlightedItem"]
            },
            "LAYER.INTERACT_OUTSIDE": [
              // == group 1 ==
              {
                guard: Ei("isOpenControlled", "isCustomValue", bg("allowCustomValue")),
                actions: ["revertInputValue", "invokeOnClose"]
              },
              {
                guard: Ei("isCustomValue", bg("allowCustomValue")),
                target: "idle",
                actions: ["revertInputValue", "invokeOnClose"]
              },
              // == group 2 ==
              {
                guard: "isOpenControlled",
                actions: ["invokeOnClose"]
              },
              {
                target: "idle",
                actions: ["invokeOnClose"]
              }
            ],
            "TRIGGER.CLICK": [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnClose"]
              },
              {
                target: "focused",
                actions: ["invokeOnClose"]
              }
            ],
            "ITEM.CLICK": [
              {
                guard: Ei("isOpenControlled", "closeOnSelect"),
                actions: ["selectItem", "invokeOnClose"]
              },
              {
                guard: "closeOnSelect",
                target: "focused",
                actions: ["selectItem", "invokeOnClose", "setFinalFocus"]
              },
              {
                actions: ["selectItem"]
              }
            ],
            CLOSE: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnClose"]
              },
              {
                target: "focused",
                actions: ["invokeOnClose", "setFinalFocus"]
              }
            ],
            "VALUE.CLEAR": [
              {
                guard: "isOpenControlled",
                actions: ["clearInputValue", "clearSelectedItems", "invokeOnClose"]
              },
              {
                target: "focused",
                actions: ["clearInputValue", "clearSelectedItems", "invokeOnClose", "setFinalFocus"]
              }
            ]
          }
        }
      }
    },
    {
      guards: {
        isInputValueEmpty: (t) => t.isInputValueEmpty,
        autoComplete: (t) => t.autoComplete && !t.multiple,
        autoHighlight: (t) => t.autoHighlight,
        isFirstItemHighlighted: (t) => t.collection.first() === t.highlightedValue,
        isLastItemHighlighted: (t) => t.collection.last() === t.highlightedValue,
        isCustomValue: (t) => t.inputValue !== t.valueAsString,
        allowCustomValue: (t) => !!t.allowCustomValue,
        hasHighlightedItem: (t) => t.highlightedValue != null,
        closeOnSelect: (t) => !!t.closeOnSelect,
        isOpenControlled: (t) => !!t["open.controlled"],
        openOnChange: (t, r) => {
          var o;
          return JD(t.openOnChange) ? t.openOnChange : !!((o = t.openOnChange) != null && o.call(t, { inputValue: r.value }));
        },
        restoreFocus: (t, r) => r.restoreFocus == null ? !0 : !!r.restoreFocus,
        isChangeEvent: (t, r) => {
          var o;
          return ((o = r.previousEvent) == null ? void 0 : o.type) === "INPUT.CHANGE";
        }
      },
      activities: {
        trackDismissableLayer(t, r, { send: o }) {
          return t.disableLayer ? void 0 : Uf(() => tt.getContentEl(t), {
            defer: !0,
            exclude: () => [tt.getInputEl(t), tt.getTriggerEl(t), tt.getClearTriggerEl(t)],
            onFocusOutside: t.onFocusOutside,
            onPointerDownOutside: t.onPointerDownOutside,
            onInteractOutside: t.onInteractOutside,
            onEscapeKeyDown(l) {
              l.preventDefault(), l.stopPropagation(), o("LAYER.ESCAPE");
            },
            onDismiss() {
              o({ type: "LAYER.INTERACT_OUTSIDE", restoreFocus: !1 });
            }
          });
        },
        hideOtherElements(t) {
          return rI([tt.getInputEl(t), tt.getContentEl(t), tt.getTriggerEl(t)]);
        },
        computePlacement(t) {
          const r = () => tt.getControlEl(t), o = () => tt.getPositionerEl(t);
          return t.currentPlacement = t.positioning.placement, uu(r, o, {
            ...t.positioning,
            defer: !0,
            onComplete(a) {
              t.currentPlacement = a.placement;
            }
          });
        },
        // in event the options are fetched (async), we still want to auto-highlight the first option
        trackChildNodes(t, r, { send: o }) {
          return t.autoHighlight ? yD(() => tt.getContentEl(t), {
            callback: () => o("CHILDREN_CHANGE"),
            defer: !0
          }) : void 0;
        },
        scrollToHighlightedItem(t, r, { getState: o }) {
          const a = tt.getInputEl(t);
          let l = [];
          const u = (y) => {
            if (o().event.type.includes("POINTER") || !t.highlightedValue)
              return;
            const F = tt.getHighlightedItemEl(t), j = tt.getContentEl(t);
            if (t.scrollToIndexFn) {
              const D = t.collection.indexOf(t.highlightedValue);
              t.scrollToIndexFn({ index: D, immediate: y });
              return;
            }
            const N = Ct(() => {
              wb(F, { rootEl: j, block: "nearest" });
            });
            l.push(N);
          }, f = Ct(() => u(!0));
          l.push(f);
          const p = Dh(a, {
            attributes: ["aria-activedescendant"],
            callback: () => u(!1)
          });
          return l.push(p), () => {
            l.forEach((y) => y());
          };
        }
      },
      actions: {
        reposition(t, r) {
          uu(() => tt.getControlEl(t), () => tt.getPositionerEl(t), {
            ...t.positioning,
            ...r.options,
            defer: !0,
            listeners: !1,
            onComplete(l) {
              t.currentPlacement = l.placement;
            }
          });
        },
        setHighlightedItem(t, r) {
          r.value != null && Pr.highlightedValue(t, r.value);
        },
        clearHighlightedItem(t) {
          Pr.highlightedValue(t, null, !0);
        },
        selectHighlightedItem(t) {
          Pr.value(t, t.highlightedValue);
        },
        selectItem(t, r) {
          r.value != null && Pr.value(t, r.value);
        },
        clearItem(t, r) {
          if (r.value == null)
            return;
          const o = t.value.filter((a) => a !== r.value);
          Pr.value(t, o);
        },
        setInitialFocus(t) {
          Ct(() => {
            tt.focusInputEl(t);
          });
        },
        setFinalFocus(t) {
          Ct(() => {
            const r = tt.getTriggerEl(t);
            (r == null ? void 0 : r.dataset.focusable) == null ? tt.focusInputEl(t) : tt.focusTriggerEl(t);
          });
        },
        syncInputValue(t) {
          const r = tt.getInputEl(t);
          r && (r.value = t.inputValue, queueMicrotask(() => {
            const { selectionStart: o, selectionEnd: a } = r;
            Math.abs((a ?? 0) - (o ?? 0)) === 0 && o === 0 && r.setSelectionRange(r.value.length, r.value.length);
          }));
        },
        setInputValue(t, r) {
          Pr.inputValue(t, r.value);
        },
        clearInputValue(t) {
          Pr.inputValue(t, "");
        },
        revertInputValue(t) {
          const r = iu(t.selectionBehavior, {
            replace: t.hasSelectedItems ? t.valueAsString : "",
            preserve: t.inputValue,
            clear: ""
          });
          Pr.inputValue(t, r);
        },
        syncInitialValues(t) {
          const r = t.collection.items(t.value), o = t.collection.itemsToString(r);
          t.highlightedItem = t.collection.item(t.highlightedValue), t.selectedItems = r, t.valueAsString = o, t.inputValue = iu(t.selectionBehavior, {
            preserve: t.inputValue || o,
            replace: o,
            clear: ""
          });
        },
        syncSelectionBehavior(t) {
          t.multiple && (t.selectionBehavior = "clear");
        },
        setSelectedItems(t, r) {
          _A(r.value) && Pr.value(t, r.value);
        },
        clearSelectedItems(t) {
          Pr.value(t, []);
        },
        scrollContentToTop(t) {
          if (t.scrollToIndexFn)
            t.scrollToIndexFn({ index: 0, immediate: !0 });
          else {
            const r = tt.getContentEl(t);
            if (!r)
              return;
            r.scrollTop = 0;
          }
        },
        invokeOnOpen(t) {
          var r;
          (r = t.onOpenChange) == null || r.call(t, { open: !0 });
        },
        invokeOnClose(t) {
          var r;
          (r = t.onOpenChange) == null || r.call(t, { open: !1 });
        },
        highlightFirstItem(t) {
          Ct(() => {
            const r = t.collection.first();
            Pr.highlightedValue(t, r);
          });
        },
        highlightFirstItemIfNeeded(t) {
          t.autoHighlight && Ct(() => {
            const r = t.collection.first();
            Pr.highlightedValue(t, r);
          });
        },
        highlightLastItem(t) {
          Ct(() => {
            const r = t.collection.last();
            Pr.highlightedValue(t, r);
          });
        },
        highlightNextItem(t) {
          let r = null;
          t.highlightedValue ? (r = t.collection.next(t.highlightedValue), !r && t.loopFocus && (r = t.collection.first())) : r = t.collection.first(), Pr.highlightedValue(t, r);
        },
        highlightPrevItem(t) {
          let r = null;
          t.highlightedValue ? (r = t.collection.prev(t.highlightedValue), !r && t.loopFocus && (r = t.collection.last())) : r = t.collection.last(), Pr.highlightedValue(t, r);
        },
        highlightFirstSelectedItem(t) {
          Ct(() => {
            const [r] = t.collection.sort(t.value);
            Pr.highlightedValue(t, r);
          });
        },
        highlightFirstOrSelectedItem(t) {
          Ct(() => {
            let r = null;
            t.hasSelectedItems ? r = t.collection.sort(t.value)[0] : r = t.collection.first(), Pr.highlightedValue(t, r);
          });
        },
        highlightLastOrSelectedItem(t) {
          Ct(() => {
            let r = null;
            t.hasSelectedItems ? r = t.collection.sort(t.value)[0] : r = t.collection.last(), Pr.highlightedValue(t, r);
          });
        },
        autofillInputValue(t, r) {
          const o = tt.getInputEl(t);
          if (!t.autoComplete || !o || !r.keypress)
            return;
          const a = t.collection.valueToString(t.highlightedValue);
          Ct(() => {
            o.value = a || t.inputValue;
          });
        },
        setCollection(t, r) {
          t.collection = r.value;
        },
        syncSelectedItems(t) {
          Ch.valueChange(t);
        },
        syncHighlightedItem(t) {
          Ch.highlightChange(t);
        },
        toggleVisibility(t, r, { send: o }) {
          o({ type: t.open ? "CONTROLLED.OPEN" : "CONTROLLED.CLOSE", previousEvent: r });
        }
      }
    }
  );
}
var Ch = {
  valueChange: (e) => {
    const n = e.selectedItems;
    e.selectedItems = e.value.map((o) => {
      const a = n.find((l) => e.collection.itemToValue(l) === o);
      return a || e.collection.item(o);
    });
    const t = e.collection.itemsToString(e.selectedItems);
    e.valueAsString = t;
    let r;
    e.getSelectionValue ? r = e.getSelectionValue({
      inputValue: e.inputValue,
      selectedItems: Array.from(e.selectedItems),
      valueAsString: t
    }) : r = iu(e.selectionBehavior, {
      replace: e.valueAsString,
      preserve: e.inputValue,
      clear: ""
    }), Pr.inputValue(e, r);
  },
  highlightChange: (e) => {
    e.highlightedItem = e.collection.item(e.highlightedValue);
  }
}, bp = {
  valueChange: (e) => {
    var n;
    Ch.valueChange(e), (n = e.onValueChange) == null || n.call(e, {
      value: Array.from(e.value),
      items: Array.from(e.selectedItems)
    });
  },
  highlightChange: (e) => {
    var n;
    Ch.highlightChange(e), (n = e.onHighlightChange) == null || n.call(e, {
      highlightedValue: e.highlightedValue,
      highlightedItem: e.highlightedItem
    });
  },
  inputChange: (e) => {
    var n;
    (n = e.onInputValueChange) == null || n.call(e, { inputValue: e.inputValue });
  }
}, Pr = {
  value: (e, n, t = !1) => {
    if (!vr(e.value, n) && !(n == null && !t)) {
      if (n == null && t) {
        e.value = [], bp.valueChange(e);
        return;
      }
      _A(n) ? e.value = n : n != null && (e.value = e.multiple ? JA(e.value, n) : [n]), bp.valueChange(e);
    }
  },
  highlightedValue: (e, n, t = !1) => {
    vr(e.highlightedValue, n) || !n && !t || (e.highlightedValue = n || null, bp.highlightChange(e));
  },
  inputValue: (e, n) => {
    vr(e.inputValue, n) || (e.inputValue = n, bp.inputChange(e));
  }
};
const oV = (e) => {
  const [n, t] = Ft()(e, [
    "isItemDisabled",
    "itemToValue",
    "itemToString",
    "items"
  ]), r = oc(
    () => uy(n),
    Object.values(n)
  ), { dir: o } = ko(), { getRootNode: a } = Jr(), l = {
    id: gr(),
    dir: o,
    getRootNode: a,
    collection: r,
    open: e.defaultOpen,
    value: e.defaultValue,
    "open.controlled": e.open !== void 0,
    ...t
  }, u = {
    ...l,
    collection: r,
    value: e.value,
    onValueChange: en(e.onValueChange, { sync: !0 }),
    onInputValueChange: en(e.onInputValueChange, { sync: !0 }),
    onHighlightChange: en(e.onHighlightChange),
    onOpenChange: en(e.onOpenChange)
  }, [f, p] = Or(rV(l), {
    context: u
  });
  return nV(f, p, yr);
}, iV = (e, n) => {
  const [t, r] = fu(e), [o, a] = Ft()(r, [
    "allowCustomValue",
    "autoFocus",
    "closeOnSelect",
    "composite",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "disableLayer",
    "form",
    "getSelectionValue",
    "highlightedValue",
    "id",
    "ids",
    "inputBehavior",
    "inputValue",
    "invalid",
    "isItemDisabled",
    "items",
    "itemToString",
    "itemToValue",
    "loopFocus",
    "multiple",
    "name",
    "onFocusOutside",
    "onHighlightChange",
    "onInputValueChange",
    "onInteractOutside",
    "onOpenChange",
    "onOpenChange",
    "onPointerDownOutside",
    "onValueChange",
    "open",
    "openOnChange",
    "openOnClick",
    "openOnKeyPress",
    "placeholder",
    "positioning",
    "readOnly",
    "scrollToIndexFn",
    "selectionBehavior",
    "translations",
    "value"
  ]), l = oV(o), u = cc(be({ present: l.open }, t)), f = be(l.getRootProps(), a);
  return /* @__PURE__ */ I.jsx(eI, { value: l, children: /* @__PURE__ */ I.jsx(Ad, { value: u, children: /* @__PURE__ */ I.jsx(ve.div, { ...f, ref: n }) }) });
}, oI = oe(iV), aV = (e, n) => {
  const [t, r] = fu(e), [{ value: o }, a] = Ft()(
    r,
    ["value"]
  ), l = cc(be({ present: o.open }, t)), u = be(o.getRootProps(), a);
  return /* @__PURE__ */ I.jsx(eI, { value: o, children: /* @__PURE__ */ I.jsx(Ad, { value: l, children: /* @__PURE__ */ I.jsx(ve.div, { ...u, ref: n }) }) });
}, sV = oe(aV), dy = oe((e, n) => {
  const t = ia(), r = be(t.getTriggerProps(), e);
  return /* @__PURE__ */ I.jsx(ve.button, { ...r, ref: n });
});
dy.displayName = "ComboboxTrigger";
const FY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ClearTrigger: tI,
  Content: ey,
  Context: WB,
  Control: ty,
  Input: ny,
  Item: ry,
  ItemContext: zB,
  ItemGroup: oy,
  ItemGroupLabel: iy,
  ItemIndicator: ay,
  ItemText: sy,
  Label: ly,
  Positioner: cy,
  Root: oI,
  RootProvider: sV,
  Trigger: dy
}, Symbol.toStringTag, { value: "Module" })), [lV, Dr] = xt({
  name: "DatePickerContext",
  hookName: "useDatePickerContext",
  providerName: "<DatePickerProvider />"
}), iI = oe(
  (e, n) => {
    const t = Dr(), r = oa(), o = be(
      t.getContentProps(),
      r.getPresenceProps(n),
      e
    );
    return r.unmounted ? null : /* @__PURE__ */ I.jsx(ve.div, { ...o });
  }
);
iI.displayName = "DatePickerContent";
const EC = (e) => e.children(Dr()), aI = oe(
  (e, n) => {
    const t = Dr(), r = be(t.getMonthSelectProps(), e);
    return /* @__PURE__ */ I.jsx(ve.select, { ...r, ref: n, children: t.getMonths().map((o, a) => /* @__PURE__ */ I.jsx("option", { value: o.value, children: o.label }, a)) });
  }
);
aI.displayName = "DatePickerMonthSelect";
const [cV, Sd] = xt({
  name: "DatePickerViewContext",
  hookName: "useDatePickerViewContext",
  providerName: "<DatePickerViewProvider />",
  strict: !1,
  defaultValue: { view: "day" }
}), sI = oe(
  (e, n) => {
    const t = Dr(), r = Sd(), o = be(t.getNextTriggerProps(r), e);
    return /* @__PURE__ */ I.jsx(ve.button, { ...o, ref: n });
  }
);
sI.displayName = "DatePickerNextTrigger";
const lI = oe(
  (e, n) => {
    const t = Dr(), r = be(t.getPositionerProps(), e);
    return oa().unmounted ? null : /* @__PURE__ */ I.jsx(ve.div, { ...r, ref: n });
  }
);
lI.displayName = "DatePickerPositioner";
const cI = oe(
  (e, n) => {
    const [t, r] = Ft()(e, [
      "value"
    ]), o = Dr(), a = be(o.getPresetTriggerProps(t), r);
    return /* @__PURE__ */ I.jsx(ve.button, { ...a, ref: n });
  }
);
cI.displayName = "DatePickerPresetTrigger";
const uI = oe(
  (e, n) => {
    const t = Dr(), r = Sd(), o = be(t.getPrevTriggerProps(r), e);
    return /* @__PURE__ */ I.jsx(ve.button, { ...o, ref: n });
  }
);
uI.displayName = "DatePickerPrevTrigger";
const dI = oe(
  (e, n) => {
    const t = Dr(), r = be(t.getRangeTextProps(), e);
    return /* @__PURE__ */ I.jsx(ve.div, { ...r, ref: n, children: t.visibleRangeText.start });
  }
);
dI.displayName = "DatePickerRangeText";
var qp = (e, n = []) => ({
  parts: (...t) => {
    if (uV(n))
      return qp(e, t);
    throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
  },
  extendWith: (...t) => qp(e, [...n, ...t]),
  rename: (t) => qp(t, n),
  keys: () => n,
  build: () => [...new Set(n)].reduce(
    (t, r) => Object.assign(t, {
      [r]: {
        selector: [
          `&[data-scope="${lf(e)}"][data-part="${lf(r)}"]`,
          `& [data-scope="${lf(e)}"][data-part="${lf(r)}"]`
        ].join(", "),
        attrs: { "data-scope": lf(e), "data-part": lf(r) }
      }
    }),
    {}
  )
}), lf = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), uV = (e) => e.length === 0;
function Hm(e, n) {
  return e - n * Math.floor(e / n);
}
const fI = 1721426;
function yp(e, n, t, r) {
  n = fy(e, n);
  let o = n - 1, a = -2;
  return t <= 2 ? a = 0 : _p(n) && (a = -1), fI - 1 + 365 * o + Math.floor(o / 4) - Math.floor(o / 100) + Math.floor(o / 400) + Math.floor((367 * t - 362) / 12 + a + r);
}
function _p(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function fy(e, n) {
  return e === "BC" ? 1 - n : n;
}
function dV(e) {
  let n = "AD";
  return e <= 0 && (n = "BC", e = 1 - e), [
    n,
    e
  ];
}
const fV = {
  standard: [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ],
  leapyear: [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ]
};
class Pf {
  fromJulianDay(n) {
    let t = n, r = t - fI, o = Math.floor(r / 146097), a = Hm(r, 146097), l = Math.floor(a / 36524), u = Hm(a, 36524), f = Math.floor(u / 1461), p = Hm(u, 1461), y = Math.floor(p / 365), A = o * 400 + l * 100 + f * 4 + y + (l !== 4 && y !== 4 ? 1 : 0), [w, F] = dV(A), j = t - yp(w, F, 1, 1), N = 2;
    t < yp(w, F, 3, 1) ? N = 0 : _p(F) && (N = 1);
    let D = Math.floor(((j + N) * 12 + 373) / 367), k = t - yp(w, F, D, 1) + 1;
    return new ac(w, F, D, k);
  }
  toJulianDay(n) {
    return yp(n.era, n.year, n.month, n.day);
  }
  getDaysInMonth(n) {
    return fV[_p(n.year) ? "leapyear" : "standard"][n.month - 1];
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getMonthsInYear(n) {
    return 12;
  }
  getDaysInYear(n) {
    return _p(n.year) ? 366 : 365;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getYearsInEra(n) {
    return 9999;
  }
  getEras() {
    return [
      "BC",
      "AD"
    ];
  }
  isInverseEra(n) {
    return n.era === "BC";
  }
  balanceDate(n) {
    n.year <= 0 && (n.era = n.era === "BC" ? "AD" : "BC", n.year = 1 - n.year);
  }
  constructor() {
    this.identifier = "gregory";
  }
}
const gV = {
  "001": 1,
  AD: 1,
  AE: 6,
  AF: 6,
  AI: 1,
  AL: 1,
  AM: 1,
  AN: 1,
  AR: 1,
  AT: 1,
  AU: 1,
  AX: 1,
  AZ: 1,
  BA: 1,
  BE: 1,
  BG: 1,
  BH: 6,
  BM: 1,
  BN: 1,
  BY: 1,
  CH: 1,
  CL: 1,
  CM: 1,
  CN: 1,
  CR: 1,
  CY: 1,
  CZ: 1,
  DE: 1,
  DJ: 6,
  DK: 1,
  DZ: 6,
  EC: 1,
  EE: 1,
  EG: 6,
  ES: 1,
  FI: 1,
  FJ: 1,
  FO: 1,
  FR: 1,
  GB: 1,
  GE: 1,
  GF: 1,
  GP: 1,
  GR: 1,
  HR: 1,
  HU: 1,
  IE: 1,
  IQ: 6,
  IR: 6,
  IS: 1,
  IT: 1,
  JO: 6,
  KG: 1,
  KW: 6,
  KZ: 1,
  LB: 1,
  LI: 1,
  LK: 1,
  LT: 1,
  LU: 1,
  LV: 1,
  LY: 6,
  MC: 1,
  MD: 1,
  ME: 1,
  MK: 1,
  MN: 1,
  MQ: 1,
  MV: 5,
  MY: 1,
  NL: 1,
  NO: 1,
  NZ: 1,
  OM: 6,
  PL: 1,
  QA: 6,
  RE: 1,
  RO: 1,
  RS: 1,
  RU: 1,
  SD: 6,
  SE: 1,
  SI: 1,
  SK: 1,
  SM: 1,
  SY: 6,
  TJ: 1,
  TM: 1,
  TR: 1,
  UA: 1,
  UY: 1,
  UZ: 1,
  VA: 1,
  VN: 1,
  XK: 1
};
function Wf(e, n) {
  return n = fs(n, e.calendar), e.era === n.era && e.year === n.year && e.month === n.month && e.day === n.day;
}
function pV(e, n) {
  return e.calendar.identifier === n.calendar.identifier && e.era === n.era && e.year === n.year && e.month === n.month && e.day === n.day;
}
function hV(e, n) {
  return Wf(e, Vh(n));
}
function Bh(e, n) {
  let t = e.calendar.toJulianDay(e), r = Math.ceil(t + 1 - bV(n)) % 7;
  return r < 0 && (r += 7), r;
}
function gI(e) {
  return ec(Date.now(), e);
}
function Vh(e) {
  return Rf(gI(e));
}
function pI(e, n) {
  return e.calendar.toJulianDay(e) - n.calendar.toJulianDay(n);
}
function mV(e, n) {
  return AC(e) - AC(n);
}
function AC(e) {
  return e.hour * 36e5 + e.minute * 6e4 + e.second * 1e3 + e.millisecond;
}
let Gm = null;
function gy() {
  return Gm == null && (Gm = new Intl.DateTimeFormat().resolvedOptions().timeZone), Gm;
}
function tu(e) {
  return e.subtract({
    days: e.day - 1
  });
}
function Kv(e) {
  return e.add({
    days: e.calendar.getDaysInMonth(e) - e.day
  });
}
function Xv(e) {
  return tu(e.subtract({
    months: e.month - 1
  }));
}
function vV(e) {
  return Kv(e.add({
    months: e.calendar.getMonthsInYear(e) - e.month
  }));
}
function Eh(e, n) {
  let t = Bh(e, n);
  return e.subtract({
    days: t
  });
}
function SC(e, n) {
  return Eh(e, n).add({
    days: 6
  });
}
const wC = /* @__PURE__ */ new Map();
function hI(e) {
  if (Intl.Locale) {
    let t = wC.get(e);
    return t || (t = new Intl.Locale(e).maximize().region, t && wC.set(e, t)), t;
  }
  let n = e.split("-")[1];
  return n === "u" ? void 0 : n;
}
function bV(e) {
  let n = hI(e);
  return n && gV[n] || 0;
}
function yV(e, n) {
  let t = e.calendar.getDaysInMonth(e);
  return Math.ceil((Bh(tu(e), n) + t) / 7);
}
function mI(e, n) {
  return e && n ? e.compare(n) <= 0 ? e : n : e || n;
}
function vI(e, n) {
  return e && n ? e.compare(n) >= 0 ? e : n : e || n;
}
const CV = {
  AF: [
    4,
    5
  ],
  AE: [
    5,
    6
  ],
  BH: [
    5,
    6
  ],
  DZ: [
    5,
    6
  ],
  EG: [
    5,
    6
  ],
  IL: [
    5,
    6
  ],
  IQ: [
    5,
    6
  ],
  IR: [
    5,
    5
  ],
  JO: [
    5,
    6
  ],
  KW: [
    5,
    6
  ],
  LY: [
    5,
    6
  ],
  OM: [
    5,
    6
  ],
  QA: [
    5,
    6
  ],
  SA: [
    5,
    6
  ],
  SD: [
    5,
    6
  ],
  SY: [
    5,
    6
  ],
  YE: [
    5,
    6
  ]
};
function EV(e, n) {
  let t = e.calendar.toJulianDay(e), r = Math.ceil(t + 1) % 7;
  r < 0 && (r += 7);
  let o = hI(n), [a, l] = CV[o] || [
    6,
    0
  ];
  return r === a || r === l;
}
function kf(e) {
  e = fs(e, new Pf());
  let n = fy(e.era, e.year);
  return bI(n, e.month, e.day, e.hour, e.minute, e.second, e.millisecond);
}
function bI(e, n, t, r, o, a, l) {
  let u = /* @__PURE__ */ new Date();
  return u.setUTCHours(r, o, a, l), u.setUTCFullYear(e, n - 1, t), u.getTime();
}
function Jv(e, n) {
  if (n === "UTC")
    return 0;
  if (e > 0 && n === gy())
    return new Date(e).getTimezoneOffset() * -6e4;
  let { year: t, month: r, day: o, hour: a, minute: l, second: u } = yI(e, n);
  return bI(t, r, o, a, l, u, 0) - Math.floor(e / 1e3) * 1e3;
}
const IC = /* @__PURE__ */ new Map();
function yI(e, n) {
  let t = IC.get(n);
  t || (t = new Intl.DateTimeFormat("en-US", {
    timeZone: n,
    hour12: !1,
    era: "short",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }), IC.set(n, t));
  let r = t.formatToParts(new Date(e)), o = {};
  for (let a of r)
    a.type !== "literal" && (o[a.type] = a.value);
  return {
    // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
    year: o.era === "BC" || o.era === "B" ? -o.year + 1 : +o.year,
    month: +o.month,
    day: +o.day,
    hour: o.hour === "24" ? 0 : +o.hour,
    minute: +o.minute,
    second: +o.second
  };
}
const xC = 864e5;
function AV(e, n, t, r) {
  return (t === r ? [
    t
  ] : [
    t,
    r
  ]).filter((a) => SV(e, n, a));
}
function SV(e, n, t) {
  let r = yI(t, n);
  return e.year === r.year && e.month === r.month && e.day === r.day && e.hour === r.hour && e.minute === r.minute && e.second === r.second;
}
function _l(e, n, t = "compatible") {
  let r = vd(e);
  if (n === "UTC")
    return kf(r);
  if (n === gy() && t === "compatible") {
    r = fs(r, new Pf());
    let f = /* @__PURE__ */ new Date(), p = fy(r.era, r.year);
    return f.setFullYear(p, r.month - 1, r.day), f.setHours(r.hour, r.minute, r.second, r.millisecond), f.getTime();
  }
  let o = kf(r), a = Jv(o - xC, n), l = Jv(o + xC, n), u = AV(r, n, o - a, o - l);
  if (u.length === 1)
    return u[0];
  if (u.length > 1)
    switch (t) {
      case "compatible":
      case "earlier":
        return u[0];
      case "later":
        return u[u.length - 1];
      case "reject":
        throw new RangeError("Multiple possible absolute times found");
    }
  switch (t) {
    case "earlier":
      return Math.min(o - a, o - l);
    case "compatible":
    case "later":
      return Math.max(o - a, o - l);
    case "reject":
      throw new RangeError("No such absolute time found");
  }
}
function CI(e, n, t = "compatible") {
  return new Date(_l(e, n, t));
}
function ec(e, n) {
  let t = Jv(e, n), r = new Date(e + t), o = r.getUTCFullYear(), a = r.getUTCMonth() + 1, l = r.getUTCDate(), u = r.getUTCHours(), f = r.getUTCMinutes(), p = r.getUTCSeconds(), y = r.getUTCMilliseconds();
  return new Vg(o, a, l, n, t, u, f, p, y);
}
function Rf(e) {
  return new ac(e.calendar, e.era, e.year, e.month, e.day);
}
function vd(e, n) {
  let t = 0, r = 0, o = 0, a = 0;
  if ("timeZone" in e)
    ({ hour: t, minute: r, second: o, millisecond: a } = e);
  else if ("hour" in e && !n)
    return e;
  return n && ({ hour: t, minute: r, second: o, millisecond: a } = n), new Sh(e.calendar, e.era, e.year, e.month, e.day, t, r, o, a);
}
function fs(e, n) {
  if (e.calendar.identifier === n.identifier)
    return e;
  let t = n.fromJulianDay(e.calendar.toJulianDay(e)), r = e.copy();
  return r.calendar = n, r.era = t.era, r.year = t.year, r.month = t.month, r.day = t.day, bd(r), r;
}
function wV(e, n, t) {
  if (e instanceof Vg)
    return e.timeZone === n ? e : xV(e, n);
  let r = _l(e, n, t);
  return ec(r, n);
}
function IV(e) {
  let n = kf(e) - e.offset;
  return new Date(n);
}
function xV(e, n) {
  let t = kf(e) - e.offset;
  return fs(ec(t, n), e.calendar);
}
const yg = 36e5;
function jh(e, n) {
  let t = e.copy(), r = "hour" in t ? RV(t, n) : 0;
  Qv(t, n.years || 0), t.calendar.balanceYearMonth && t.calendar.balanceYearMonth(t, e), t.month += n.months || 0, qv(t), EI(t), t.day += (n.weeks || 0) * 7, t.day += n.days || 0, t.day += r, TV(t), t.calendar.balanceDate && t.calendar.balanceDate(t), t.year < 1 && (t.year = 1, t.month = 1, t.day = 1);
  let o = t.calendar.getYearsInEra(t);
  if (t.year > o) {
    var a, l;
    let f = (a = (l = t.calendar).isInverseEra) === null || a === void 0 ? void 0 : a.call(l, t);
    t.year = o, t.month = f ? 1 : t.calendar.getMonthsInYear(t), t.day = f ? 1 : t.calendar.getDaysInMonth(t);
  }
  t.month < 1 && (t.month = 1, t.day = 1);
  let u = t.calendar.getMonthsInYear(t);
  return t.month > u && (t.month = u, t.day = t.calendar.getDaysInMonth(t)), t.day = Math.max(1, Math.min(t.calendar.getDaysInMonth(t), t.day)), t;
}
function Qv(e, n) {
  var t, r;
  !((t = (r = e.calendar).isInverseEra) === null || t === void 0) && t.call(r, e) && (n = -n), e.year += n;
}
function qv(e) {
  for (; e.month < 1; )
    Qv(e, -1), e.month += e.calendar.getMonthsInYear(e);
  let n = 0;
  for (; e.month > (n = e.calendar.getMonthsInYear(e)); )
    e.month -= n, Qv(e, 1);
}
function TV(e) {
  for (; e.day < 1; )
    e.month--, qv(e), e.day += e.calendar.getDaysInMonth(e);
  for (; e.day > e.calendar.getDaysInMonth(e); )
    e.day -= e.calendar.getDaysInMonth(e), e.month++, qv(e);
}
function EI(e) {
  e.month = Math.max(1, Math.min(e.calendar.getMonthsInYear(e), e.month)), e.day = Math.max(1, Math.min(e.calendar.getDaysInMonth(e), e.day));
}
function bd(e) {
  e.calendar.constrainDate && e.calendar.constrainDate(e), e.year = Math.max(1, Math.min(e.calendar.getYearsInEra(e), e.year)), EI(e);
}
function AI(e) {
  let n = {};
  for (let t in e)
    typeof e[t] == "number" && (n[t] = -e[t]);
  return n;
}
function SI(e, n) {
  return jh(e, AI(n));
}
function py(e, n) {
  let t = e.copy();
  return n.era != null && (t.era = n.era), n.year != null && (t.year = n.year), n.month != null && (t.month = n.month), n.day != null && (t.day = n.day), bd(t), t;
}
function Ah(e, n) {
  let t = e.copy();
  return n.hour != null && (t.hour = n.hour), n.minute != null && (t.minute = n.minute), n.second != null && (t.second = n.second), n.millisecond != null && (t.millisecond = n.millisecond), kV(t), t;
}
function PV(e) {
  e.second += Math.floor(e.millisecond / 1e3), e.millisecond = Cp(e.millisecond, 1e3), e.minute += Math.floor(e.second / 60), e.second = Cp(e.second, 60), e.hour += Math.floor(e.minute / 60), e.minute = Cp(e.minute, 60);
  let n = Math.floor(e.hour / 24);
  return e.hour = Cp(e.hour, 24), n;
}
function kV(e) {
  e.millisecond = Math.max(0, Math.min(e.millisecond, 1e3)), e.second = Math.max(0, Math.min(e.second, 59)), e.minute = Math.max(0, Math.min(e.minute, 59)), e.hour = Math.max(0, Math.min(e.hour, 23));
}
function Cp(e, n) {
  let t = e % n;
  return t < 0 && (t += n), t;
}
function RV(e, n) {
  return e.hour += n.hours || 0, e.minute += n.minutes || 0, e.second += n.seconds || 0, e.millisecond += n.milliseconds || 0, PV(e);
}
function hy(e, n, t, r) {
  let o = e.copy();
  switch (n) {
    case "era": {
      let u = e.calendar.getEras(), f = u.indexOf(e.era);
      if (f < 0)
        throw new Error("Invalid era: " + e.era);
      f = tc(f, t, 0, u.length - 1, r == null ? void 0 : r.round), o.era = u[f], bd(o);
      break;
    }
    case "year":
      var a, l;
      !((a = (l = o.calendar).isInverseEra) === null || a === void 0) && a.call(l, o) && (t = -t), o.year = tc(e.year, t, -1 / 0, 9999, r == null ? void 0 : r.round), o.year === -1 / 0 && (o.year = 1), o.calendar.balanceYearMonth && o.calendar.balanceYearMonth(o, e);
      break;
    case "month":
      o.month = tc(e.month, t, 1, e.calendar.getMonthsInYear(e), r == null ? void 0 : r.round);
      break;
    case "day":
      o.day = tc(e.day, t, 1, e.calendar.getDaysInMonth(e), r == null ? void 0 : r.round);
      break;
    default:
      throw new Error("Unsupported field " + n);
  }
  return e.calendar.balanceDate && e.calendar.balanceDate(o), bd(o), o;
}
function wI(e, n, t, r) {
  let o = e.copy();
  switch (n) {
    case "hour": {
      let a = e.hour, l = 0, u = 23;
      if ((r == null ? void 0 : r.hourCycle) === 12) {
        let f = a >= 12;
        l = f ? 12 : 0, u = f ? 23 : 11;
      }
      o.hour = tc(a, t, l, u, r == null ? void 0 : r.round);
      break;
    }
    case "minute":
      o.minute = tc(e.minute, t, 0, 59, r == null ? void 0 : r.round);
      break;
    case "second":
      o.second = tc(e.second, t, 0, 59, r == null ? void 0 : r.round);
      break;
    case "millisecond":
      o.millisecond = tc(e.millisecond, t, 0, 999, r == null ? void 0 : r.round);
      break;
    default:
      throw new Error("Unsupported field " + n);
  }
  return o;
}
function tc(e, n, t, r, o = !1) {
  if (o) {
    e += Math.sign(n), e < t && (e = r);
    let a = Math.abs(n);
    n > 0 ? e = Math.ceil(e / a) * a : e = Math.floor(e / a) * a, e > r && (e = t);
  } else
    e += n, e < t ? e = r - (t - e - 1) : e > r && (e = t + (e - r - 1));
  return e;
}
function II(e, n) {
  let t;
  if (n.years != null && n.years !== 0 || n.months != null && n.months !== 0 || n.weeks != null && n.weeks !== 0 || n.days != null && n.days !== 0) {
    let o = jh(vd(e), {
      years: n.years,
      months: n.months,
      weeks: n.weeks,
      days: n.days
    });
    t = _l(o, e.timeZone);
  } else
    t = kf(e) - e.offset;
  t += n.milliseconds || 0, t += (n.seconds || 0) * 1e3, t += (n.minutes || 0) * 6e4, t += (n.hours || 0) * 36e5;
  let r = ec(t, e.timeZone);
  return fs(r, e.calendar);
}
function OV(e, n) {
  return II(e, AI(n));
}
function DV(e, n, t, r) {
  switch (n) {
    case "hour": {
      let o = 0, a = 23;
      if ((r == null ? void 0 : r.hourCycle) === 12) {
        let j = e.hour >= 12;
        o = j ? 12 : 0, a = j ? 23 : 11;
      }
      let l = vd(e), u = fs(Ah(l, {
        hour: o
      }), new Pf()), f = [
        _l(u, e.timeZone, "earlier"),
        _l(u, e.timeZone, "later")
      ].filter((j) => ec(j, e.timeZone).day === u.day)[0], p = fs(Ah(l, {
        hour: a
      }), new Pf()), y = [
        _l(p, e.timeZone, "earlier"),
        _l(p, e.timeZone, "later")
      ].filter((j) => ec(j, e.timeZone).day === p.day).pop(), A = kf(e) - e.offset, w = Math.floor(A / yg), F = A % yg;
      return A = tc(w, t, Math.floor(f / yg), Math.floor(y / yg), r == null ? void 0 : r.round) * yg + F, fs(ec(A, e.timeZone), e.calendar);
    }
    case "minute":
    case "second":
    case "millisecond":
      return wI(e, n, t, r);
    case "era":
    case "year":
    case "month":
    case "day": {
      let o = hy(vd(e), n, t, r), a = _l(o, e.timeZone);
      return fs(ec(a, e.timeZone), e.calendar);
    }
    default:
      throw new Error("Unsupported field " + n);
  }
}
function FV(e, n, t) {
  let r = vd(e), o = Ah(py(r, n), n);
  if (o.compare(r) === 0)
    return e;
  let a = _l(o, e.timeZone, t);
  return fs(ec(a, e.timeZone), e.calendar);
}
const NV = /^(\d{4})-(\d{2})-(\d{2})$/;
function MV(e) {
  let n = e.match(NV);
  if (!n)
    throw new Error("Invalid ISO 8601 date string: " + e);
  let t = new ac(Ym(n[1], 0, 9999), Ym(n[2], 1, 12), 1);
  return t.day = Ym(n[3], 0, t.calendar.getDaysInMonth(t)), t;
}
function Ym(e, n, t) {
  let r = Number(e);
  if (r < n || r > t)
    throw new RangeError(`Value out of range: ${n} <= ${r} <= ${t}`);
  return r;
}
function LV(e) {
  return `${String(e.hour).padStart(2, "0")}:${String(e.minute).padStart(2, "0")}:${String(e.second).padStart(2, "0")}${e.millisecond ? String(e.millisecond / 1e3).slice(1) : ""}`;
}
function xI(e) {
  let n = fs(e, new Pf());
  return `${String(n.year).padStart(4, "0")}-${String(n.month).padStart(2, "0")}-${String(n.day).padStart(2, "0")}`;
}
function TI(e) {
  return `${xI(e)}T${LV(e)}`;
}
function BV(e) {
  let n = Math.sign(e) < 0 ? "-" : "+";
  e = Math.abs(e);
  let t = Math.floor(e / 36e5), r = e % 36e5 / 6e4;
  return `${n}${String(t).padStart(2, "0")}:${String(r).padStart(2, "0")}`;
}
function VV(e) {
  return `${TI(e)}${BV(e.offset)}[${e.timeZone}]`;
}
function my(e) {
  let n = typeof e[0] == "object" ? e.shift() : new Pf(), t;
  if (typeof e[0] == "string")
    t = e.shift();
  else {
    let l = n.getEras();
    t = l[l.length - 1];
  }
  let r = e.shift(), o = e.shift(), a = e.shift();
  return [
    n,
    t,
    r,
    o,
    a
  ];
}
var jV = /* @__PURE__ */ new WeakMap();
class ac {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new ac(this.calendar, this.era, this.year, this.month, this.day) : new ac(this.calendar, this.year, this.month, this.day);
  }
  /** Returns a new `CalendarDate` with the given duration added to it. */
  add(n) {
    return jh(this, n);
  }
  /** Returns a new `CalendarDate` with the given duration subtracted from it. */
  subtract(n) {
    return SI(this, n);
  }
  /** Returns a new `CalendarDate` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(n) {
    return py(this, n);
  }
  /**
  * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(n, t, r) {
    return hy(this, n, t, r);
  }
  /** Converts the date to a native JavaScript Date object, with the time set to midnight in the given time zone. */
  toDate(n) {
    return CI(this, n);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return xI(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(n) {
    return pI(this, n);
  }
  constructor(...n) {
    Gb(this, jV, {
      writable: !0,
      value: void 0
    });
    let [t, r, o, a, l] = my(n);
    this.calendar = t, this.era = r, this.year = o, this.month = a, this.day = l, bd(this);
  }
}
var UV = /* @__PURE__ */ new WeakMap();
class Sh {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new Sh(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond) : new Sh(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `CalendarDateTime` with the given duration added to it. */
  add(n) {
    return jh(this, n);
  }
  /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */
  subtract(n) {
    return SI(this, n);
  }
  /** Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(n) {
    return py(Ah(this, n), n);
  }
  /**
  * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(n, t, r) {
    switch (n) {
      case "era":
      case "year":
      case "month":
      case "day":
        return hy(this, n, t, r);
      default:
        return wI(this, n, t, r);
    }
  }
  /** Converts the date to a native JavaScript Date object in the given time zone. */
  toDate(n, t) {
    return CI(this, n, t);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return TI(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(n) {
    let t = pI(this, n);
    return t === 0 ? mV(this, vd(n)) : t;
  }
  constructor(...n) {
    Gb(this, UV, {
      writable: !0,
      value: void 0
    });
    let [t, r, o, a, l] = my(n);
    this.calendar = t, this.era = r, this.year = o, this.month = a, this.day = l, this.hour = n.shift() || 0, this.minute = n.shift() || 0, this.second = n.shift() || 0, this.millisecond = n.shift() || 0, bd(this);
  }
}
var WV = /* @__PURE__ */ new WeakMap();
class Vg {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new Vg(this.calendar, this.era, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond) : new Vg(this.calendar, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `ZonedDateTime` with the given duration added to it. */
  add(n) {
    return II(this, n);
  }
  /** Returns a new `ZonedDateTime` with the given duration subtracted from it. */
  subtract(n) {
    return OV(this, n);
  }
  /** Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(n, t) {
    return FV(this, n, t);
  }
  /**
  * Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(n, t, r) {
    return DV(this, n, t, r);
  }
  /** Converts the date to a native JavaScript Date object. */
  toDate() {
    return IV(this);
  }
  /** Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone identifier. */
  toString() {
    return VV(this);
  }
  /** Converts the date to an ISO 8601 formatted string in UTC. */
  toAbsoluteString() {
    return this.toDate().toISOString();
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(n) {
    return this.toDate().getTime() - wV(n, this.timeZone).toDate().getTime();
  }
  constructor(...n) {
    Gb(this, WV, {
      writable: !0,
      value: void 0
    });
    let [t, r, o, a, l] = my(n), u = n.shift(), f = n.shift();
    this.calendar = t, this.era = r, this.year = o, this.month = a, this.day = l, this.timeZone = u, this.offset = f, this.hour = n.shift() || 0, this.minute = n.shift() || 0, this.second = n.shift() || 0, this.millisecond = n.shift() || 0, bd(this);
  }
}
let zm = /* @__PURE__ */ new Map();
class rl {
  /** Formats a date as a string according to the locale and format options passed to the constructor. */
  format(n) {
    return this.formatter.format(n);
  }
  /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */
  formatToParts(n) {
    return this.formatter.formatToParts(n);
  }
  /** Formats a date range as a string. */
  formatRange(n, t) {
    if (typeof this.formatter.formatRange == "function")
      return this.formatter.formatRange(n, t);
    if (t < n)
      throw new RangeError("End date must be >= start date");
    return `${this.formatter.format(n)} – ${this.formatter.format(t)}`;
  }
  /** Formats a date range as an array of parts. */
  formatRangeToParts(n, t) {
    if (typeof this.formatter.formatRangeToParts == "function")
      return this.formatter.formatRangeToParts(n, t);
    if (t < n)
      throw new RangeError("End date must be >= start date");
    let r = this.formatter.formatToParts(n), o = this.formatter.formatToParts(t);
    return [
      ...r.map((a) => ({
        ...a,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...o.map((a) => ({
        ...a,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let n = this.formatter.resolvedOptions();
    return YV() && (this.resolvedHourCycle || (this.resolvedHourCycle = zV(n.locale, this.options)), n.hourCycle = this.resolvedHourCycle, n.hour12 = this.resolvedHourCycle === "h11" || this.resolvedHourCycle === "h12"), n.calendar === "ethiopic-amete-alem" && (n.calendar = "ethioaa"), n;
  }
  constructor(n, t = {}) {
    this.formatter = PI(n, t), this.options = t;
  }
}
const HV = {
  true: {
    // Only Japanese uses the h11 style for 12 hour time. All others use h12.
    ja: "h11"
  },
  false: {}
};
function PI(e, n = {}) {
  if (typeof n.hour12 == "boolean" && GV()) {
    n = {
      ...n
    };
    let o = HV[String(n.hour12)][e.split("-")[0]], a = n.hour12 ? "h12" : "h23";
    n.hourCycle = o ?? a, delete n.hour12;
  }
  let t = e + (n ? Object.entries(n).sort((o, a) => o[0] < a[0] ? -1 : 1).join() : "");
  if (zm.has(t))
    return zm.get(t);
  let r = new Intl.DateTimeFormat(e, n);
  return zm.set(t, r), r;
}
let Zm = null;
function GV() {
  return Zm == null && (Zm = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    hour12: !1
  }).format(new Date(2020, 2, 3, 0)) === "24"), Zm;
}
let Km = null;
function YV() {
  return Km == null && (Km = new Intl.DateTimeFormat("fr", {
    hour: "numeric",
    hour12: !1
  }).resolvedOptions().hourCycle === "h12"), Km;
}
function zV(e, n) {
  if (!n.timeStyle && !n.hour)
    return;
  e = e.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, ""), e += (e.includes("-u-") ? "" : "-u") + "-nu-latn";
  let t = PI(e, {
    ...n,
    timeZone: void 0
    // use local timezone
  }), r = parseInt(t.formatToParts(new Date(2020, 2, 3, 0)).find((a) => a.type === "hour").value, 10), o = parseInt(t.formatToParts(new Date(2020, 2, 3, 23)).find((a) => a.type === "hour").value, 10);
  if (r === 0 && o === 23)
    return "h23";
  if (r === 24 && o === 23)
    return "h24";
  if (r === 0 && o === 11)
    return "h11";
  if (r === 12 && o === 11)
    return "h12";
  throw new Error("Unexpected hour cycle result");
}
function ZV(e, n, t, r, o) {
  let a = {};
  for (let u in n)
    a[u] = Math.floor(n[u] / 2), a[u] > 0 && n[u] % 2 === 0 && a[u]--;
  let l = wd(e, n, t).subtract(a);
  return zg(e, l, n, t, r, o);
}
function wd(e, n, t, r, o) {
  let a = e;
  return n.years ? a = Xv(e) : n.months ? a = tu(e) : n.weeks && (a = Eh(e, t)), zg(e, a, n, t, r, o);
}
function vy(e, n, t, r, o) {
  let a = { ...n };
  a.days ? a.days-- : a.weeks ? a.weeks-- : a.months ? a.months-- : a.years && a.years--;
  let l = wd(e, n, t).subtract(a);
  return zg(e, l, n, t, r, o);
}
function zg(e, n, t, r, o, a) {
  return o && e.compare(o) >= 0 && (n = vI(n, wd(Rf(o), t, r))), a && e.compare(a) <= 0 && (n = mI(n, vy(Rf(a), t, r))), n;
}
function nc(e, n, t) {
  return n && (e = vI(e, Rf(n))), t && (e = mI(e, Rf(t))), e;
}
function kI(e, n, t, r, o, a) {
  switch (n) {
    case "start":
      return wd(e, t, r, o, a);
    case "end":
      return vy(e, t, r, o, a);
    case "center":
    default:
      return ZV(e, t, r, o, a);
  }
}
function KV(e, n) {
  return hV(e, n);
}
function gs(e, n) {
  return n != null && Wf(e, n);
}
function ru(e, n, t) {
  return n != null && e.compare(n) < 0 || t != null && e.compare(t) > 0;
}
function XV(e, n, t, r, o) {
  return by(e, n, t) || ru(e, r, o);
}
function TC(e, n, t, r, o) {
  return e ? n != null && n(e, t) ? !0 : ru(e, r, o) : !1;
}
function by(e, n, t) {
  return e.compare(n) < 0 || e.compare(t) > 0;
}
function JV(e, n, t) {
  const r = e.subtract({ days: 1 });
  return Wf(r, e) || ru(r, n, t);
}
function QV(e, n, t) {
  const r = e.add({ days: 1 });
  return Wf(r, e) || ru(r, n, t);
}
function yy(e) {
  let n = { ...e };
  for (let t in n)
    n[t] = 1;
  return n;
}
function RI(e, n) {
  let t = { ...n };
  return t.days ? t.days-- : t.days = -1, e.add(t);
}
function qV(e, n, t, r, o) {
  let a = t.formatRangeToParts(e.toDate(o), n.toDate(o)), l = -1;
  for (let p = 0; p < a.length; p++) {
    let y = a[p];
    if (y.source === "shared" && y.type === "literal")
      l = p;
    else if (y.source === "endRange")
      break;
  }
  let u = "", f = "";
  for (let p = 0; p < a.length; p++)
    p < l ? u += a[p].value : p > l && (f += a[p].value);
  return r(u, f);
}
function OI(e) {
  return (e == null ? void 0 : e.calendar.identifier) === "gregory" && e.era === "BC" ? "short" : void 0;
}
function DI(e, n) {
  const t = vd(Vh(n));
  return new rl(e, {
    weekday: "long",
    month: "long",
    year: "numeric",
    day: "numeric",
    era: OI(t),
    timeZone: n
  });
}
function _V(e, n, t, r) {
  let o = e, a = n ?? e, l = DI(t, r);
  return Wf(o, a) ? l.format(o.toDate(r)) : qV(o, a, l, (u, f) => `${u} – ${f}`, r);
}
function $V(e, n) {
  const t = Rf(Vh(n));
  return new rl(e, {
    month: "long",
    year: "numeric",
    era: OI(t),
    calendar: t == null ? void 0 : t.calendar.identifier,
    timeZone: n
  });
}
function wh(e) {
  const n = e - e % 10 - 1, t = [];
  for (let r = 0; r < 12; r += 1) {
    const o = n + r;
    t.push(o);
  }
  return t;
}
function FI(e, n, t = 0) {
  const o = (Bh(e, n) - t + 7) % 7;
  return e.subtract({ days: o });
}
function NI(e, n, t, r) {
  const o = n.add({ weeks: e }), a = [];
  let l = FI(o, t, r);
  for (; a.length < 7; ) {
    a.push(l);
    let u = l.add({ days: 1 });
    if (Wf(l, u))
      break;
    l = u;
  }
  return a;
}
function ej(e, n, t) {
  if (t == null)
    return yV(e, n);
  const r = (Bh(tu(e), n) - t + 7) % 7;
  return Math.ceil((r + e.calendar.getDaysInMonth(e)) / 7);
}
function tj(e, n, t, r) {
  const o = t ?? ej(e, n, r);
  return [...new Array(o).keys()].map((l) => NI(l, e, n, r));
}
function nj(e, n = "long") {
  const t = new Date(2021, 0, 1), r = [];
  for (let o = 0; o < 12; o++)
    r.push(t.toLocaleString(e, { month: n })), t.setMonth(t.getMonth() + 1);
  return r;
}
function rj(e, n) {
  const t = new rl(e, { weekday: "long", timeZone: n }), r = new rl(e, { weekday: "short", timeZone: n }), o = new rl(e, { weekday: "narrow", timeZone: n });
  return (a) => {
    const l = a instanceof Date ? a : a.toDate(n);
    return {
      value: a,
      short: r.format(l),
      long: t.format(l),
      narrow: o.format(l)
    };
  };
}
function oj(e, n, t, r) {
  const o = FI(e, r, n), a = [...new Array(7).keys()], l = rj(r, t);
  return a.map((u) => l(o.add({ days: u })));
}
function If(e) {
  return Vh(e ?? gy());
}
function ij(e) {
  return e.add({ days: 1 });
}
function aj(e) {
  return e.subtract({ days: 1 });
}
function sj(e, n) {
  return e.set({ month: n });
}
function lj(e, n) {
  return e.set({ year: n });
}
function Zg(e, n, t, r) {
  return function(a) {
    const { startDate: l, focusedDate: u } = a, f = RI(l, e);
    return ru(u, t, r) ? {
      startDate: l,
      focusedDate: nc(u, t, r),
      endDate: f
    } : u.compare(l) < 0 ? {
      startDate: vy(u, e, n, t, r),
      focusedDate: nc(u, t, r),
      endDate: f
    } : u.compare(f) > 0 ? {
      startDate: wd(u, e, n, t, r),
      endDate: f,
      focusedDate: nc(u, t, r)
    } : {
      startDate: l,
      endDate: f,
      focusedDate: nc(u, t, r)
    };
  };
}
function MI(e, n, t, r, o, a) {
  const l = Zg(t, r, o, a), u = n.add(t);
  return l({
    focusedDate: e.add(t),
    startDate: wd(
      zg(e, u, t, r, o, a),
      t,
      r
    )
  });
}
function LI(e, n, t, r, o, a) {
  const l = Zg(t, r, o, a);
  let u = n.subtract(t);
  return l({
    focusedDate: e.subtract(t),
    startDate: wd(
      zg(e, u, t, r, o, a),
      t,
      r
    )
  });
}
function cj(e, n, t, r, o, a, l) {
  const u = Zg(r, o, a, l);
  if (!t && !r.days)
    return u({
      focusedDate: e.add(yy(r)),
      startDate: n
    });
  if (r.days)
    return MI(e, n, r, o, a, l);
  if (r.weeks)
    return u({
      focusedDate: e.add({ months: 1 }),
      startDate: n
    });
  if (r.months || r.years)
    return u({
      focusedDate: e.add({ years: 1 }),
      startDate: n
    });
}
function uj(e, n, t, r, o, a, l) {
  const u = Zg(r, o, a, l);
  if (!t && !r.days)
    return u({
      focusedDate: e.subtract(yy(r)),
      startDate: n
    });
  if (r.days)
    return LI(e, n, r, o, a, l);
  if (r.weeks)
    return u({
      focusedDate: e.subtract({ months: 1 }),
      startDate: n
    });
  if (r.months || r.years)
    return u({
      focusedDate: e.subtract({ years: 1 }),
      startDate: n
    });
}
var dj = (e) => e != null && e.length === 4, fj = (e) => e != null && parseFloat(e) <= 12, gj = (e) => e != null && parseFloat(e) <= 31;
function PC(e, n, t) {
  const r = pj(n, t);
  let { year: o, month: a, day: l } = hj(r, e) ?? {};
  if (o != null || a != null || l != null) {
    const p = /* @__PURE__ */ new Date();
    o || (o = p.getFullYear().toString()), a || (a = (p.getMonth() + 1).toString()), l || (l = p.getDate().toString());
  }
  if (dj(o) && fj(a) && gj(l))
    return new ac(+o, +a, +l);
  const f = Date.parse(e);
  if (!isNaN(f)) {
    const p = new Date(f);
    return new ac(p.getFullYear(), p.getMonth() + 1, p.getDate());
  }
}
function pj(e, n) {
  return new rl(e, { day: "numeric", month: "numeric", year: "numeric", timeZone: n }).formatToParts(new Date(2e3, 11, 25)).map(({ type: o, value: a }) => o === "literal" ? `${a}?` : `((?!=<${o}>)\\d+)?`).join("");
}
function hj(e, n) {
  var r;
  const t = n.match(e);
  return (r = e.toString().match(/<(.+?)>/g)) == null ? void 0 : r.map((o) => {
    var l;
    const a = o.match(/<(.+)>/);
    return !a || a.length <= 0 ? null : (l = o.match(/<(.+)>/)) == null ? void 0 : l[1];
  }).reduce((o, a, l) => (a && (t && t.length > l ? o[a] = t[l + 1] : o[a] = null), o), {});
}
function kC(e, n, t) {
  const r = gI(t);
  switch (e) {
    case "thisWeek":
      return [Eh(r, n), SC(r, n)];
    case "thisMonth":
      return [tu(r), r];
    case "thisQuarter":
      return [tu(r).add({ months: -r.month % 3 }), r];
    case "thisYear":
      return [Xv(r), r];
    case "last3Days":
      return [r.add({ days: -2 }), r];
    case "last7Days":
      return [r.add({ days: -6 }), r];
    case "last14Days":
      return [r.add({ days: -13 }), r];
    case "last30Days":
      return [r.add({ days: -29 }), r];
    case "last90Days":
      return [r.add({ days: -89 }), r];
    case "lastMonth":
      return [tu(r.add({ months: -1 })), Kv(r.add({ months: -1 }))];
    case "lastQuarter":
      return [
        tu(r.add({ months: -r.month % 3 - 3 })),
        Kv(r.add({ months: -r.month % 3 - 1 }))
      ];
    case "lastWeek":
      return [Eh(r, n).add({ weeks: -1 }), SC(r, n).add({ weeks: -1 })];
    case "lastYear":
      return [Xv(r.add({ years: -1 })), vV(r.add({ years: -1 }))];
    default:
      throw new Error(`Invalid date range preset: ${e}`);
  }
}
var Ep = "__live-region__";
function mj(e = {}) {
  const { level: n = "polite", document: t = document, root: r, delay: o = 0 } = e, a = t.defaultView ?? window, l = r ?? t.body;
  function u(p, y) {
    const A = t.getElementById(Ep);
    A == null || A.remove(), y = y ?? o;
    const w = t.createElement("span");
    w.id = Ep, w.dataset.liveAnnouncer = "true";
    const F = n !== "assertive" ? "status" : "alert";
    w.setAttribute("aria-live", n), w.setAttribute("role", F), Object.assign(w.style, {
      border: "0",
      clip: "rect(0 0 0 0)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: "0",
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap",
      wordWrap: "normal"
    }), l.appendChild(w), a.setTimeout(() => {
      w.textContent = p;
    }, y);
  }
  function f() {
    const p = t.getElementById(Ep);
    p == null || p.remove();
  }
  return {
    announce: u,
    destroy: f,
    toJSON() {
      return Ep;
    }
  };
}
var vj = qp("date-picker").parts(
  "root",
  "label",
  "clearTrigger",
  "content",
  "control",
  "input",
  "monthSelect",
  "nextTrigger",
  "positioner",
  "prevTrigger",
  "rangeText",
  "table",
  "tableBody",
  "tableCell",
  "tableCellTrigger",
  "tableHead",
  "tableHeader",
  "tableRow",
  "trigger",
  "viewTrigger",
  "viewControl",
  "yearSelect",
  "presetTrigger"
), In = vj.build(), ut = so({
  getRootId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.root) ?? `datepicker:${e.id}`;
  },
  getTableId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.table) == null ? void 0 : r.call(t, n)) ?? `datepicker:${e.id}:table:${n}`;
  },
  getTableHeaderId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.tableHeader) == null ? void 0 : r.call(t, n)) ?? `datepicker:${e.id}:thead`;
  },
  getTableBodyId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.tableBody) == null ? void 0 : r.call(t, n)) ?? `datepicker:${e.id}:tbody`;
  },
  getTableRowId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.tableRow) == null ? void 0 : r.call(t, n)) ?? `datepicker:${e.id}:tr:${n}`;
  },
  getContentId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.content) ?? `datepicker:${e.id}:content`;
  },
  getCellTriggerId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.cellTrigger) == null ? void 0 : r.call(t, n)) ?? `datepicker:${e.id}:cell-trigger:${n}`;
  },
  getPrevTriggerId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.prevTrigger) == null ? void 0 : r.call(t, n)) ?? `datepicker:${e.id}:prev:${n}`;
  },
  getNextTriggerId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.nextTrigger) == null ? void 0 : r.call(t, n)) ?? `datepicker:${e.id}:next:${n}`;
  },
  getViewTriggerId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.viewTrigger) == null ? void 0 : r.call(t, n)) ?? `datepicker:${e.id}:view:${n}`;
  },
  getClearTriggerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.clearTrigger) ?? `datepicker:${e.id}:clear`;
  },
  getControlId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.control) ?? `datepicker:${e.id}:control`;
  },
  getInputId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.input) == null ? void 0 : r.call(t, n)) ?? `datepicker:${e.id}:input:${n}`;
  },
  getTriggerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.trigger) ?? `datepicker:${e.id}:trigger`;
  },
  getPositionerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.positioner) ?? `datepicker:${e.id}:positioner`;
  },
  getMonthSelectId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.monthSelect) ?? `datepicker:${e.id}:month-select`;
  },
  getYearSelectId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.yearSelect) ?? `datepicker:${e.id}:year-select`;
  },
  getFocusedCell: (e, n = e.view) => Sb(
    ut.getContentEl(e),
    `[data-part=table-cell-trigger][data-view=${n}][data-focus]:not([data-outside-range])`
  ),
  getTriggerEl: (e) => ut.getById(e, ut.getTriggerId(e)),
  getContentEl: (e) => ut.getById(e, ut.getContentId(e)),
  getInputEls: (e) => $s(ut.getControlEl(e), "[data-part=input]"),
  getYearSelectEl: (e) => ut.getById(e, ut.getYearSelectId(e)),
  getMonthSelectEl: (e) => ut.getById(e, ut.getMonthSelectId(e)),
  getClearTriggerEl: (e) => ut.getById(e, ut.getClearTriggerId(e)),
  getPositionerEl: (e) => ut.getById(e, ut.getPositionerId(e)),
  getControlEl: (e) => ut.getById(e, ut.getControlId(e))
});
function _v(e) {
  const [n, t] = e;
  return !n || !t || n.compare(t) <= 0 ? e : [t, n];
}
function RC(e, n) {
  const [t, r] = n;
  return !t || !r ? !1 : t.compare(e) <= 0 && r.compare(e) >= 0;
}
function $v(e) {
  return e.sort((n, t) => n.compare(t));
}
function bj(e) {
  return iu(e, {
    year: "Switch to next decade",
    month: "Switch to next year",
    day: "Switch to next month"
  });
}
function yj(e) {
  return iu(e, {
    year: "Switch to previous decade",
    month: "Switch to previous year",
    day: "Switch to previous month"
  });
}
function Cj(e) {
  return iu(e, {
    year: "calendar decade",
    month: "calendar year",
    day: "calendar month"
  });
}
function Ej(e) {
  return iu(e, {
    year: "Switch to month view",
    month: "Switch to day view",
    day: "Switch to year view"
  });
}
var Aj = { day: "dd", month: "mm", year: "yyyy" };
function Sj(e) {
  return new rl(e).formatToParts(/* @__PURE__ */ new Date()).map((n) => Aj[n.type] ?? n.value).join("");
}
var BI = (e, n) => e ? /\d/.test(e) || e === n || e.length !== 1 : !0, wj = (e, n) => e.split("").filter((t) => BI(t, n)).join("");
function Ij(e) {
  const r = new Intl.DateTimeFormat(e).formatToParts(/* @__PURE__ */ new Date()).find((o) => o.type === "literal");
  return r ? r.value : "/";
}
var OC = (e) => e.toString().split("T")[0];
function xj(e, n, t) {
  const r = e.context.startValue, o = e.context.endValue, a = e.context.value, l = e.context.focusedValue, u = e.context.hoveredValue, f = u ? _v([a[0], u]) : [], p = e.context.disabled, y = e.context.readOnly, A = e.context.isInteractive, w = e.context.min, F = e.context.max, j = e.context.locale, N = e.context.timeZone, D = e.context.startOfWeek, k = e.matches("focused"), z = e.matches("open"), q = e.context.selectionMode === "range", Ce = e.context.isDateUnavailable, ee = e.context.currentPlacement, Fe = Yg({
    ...e.context.positioning,
    placement: ee
  }), Oe = Ij(j);
  function He(ue = r) {
    const de = e.context.fixedWeeks ? 6 : void 0;
    return tj(ue, j, de, D);
  }
  function Re(ue = {}) {
    const { format: de } = ue;
    return nj(j, de).map((Q, me) => ({ label: Q, value: me + 1 }));
  }
  function Se() {
    return wh(l.year).map((ue) => ({
      label: ue.toString(),
      value: ue
    }));
  }
  function we(ue) {
    return TC(ue, Ce, j, w, F);
  }
  function ae(ue) {
    const de = sj(r ?? If(N), ue);
    n({ type: "FOCUS.SET", value: de });
  }
  function ge(ue) {
    const de = lj(r ?? If(N), ue);
    n({ type: "FOCUS.SET", value: de });
  }
  function Ie(ue) {
    const { value: de, disabled: Q } = ue, me = l.set({ year: de }), Le = {
      focused: l.year === ue.value,
      selectable: !ru(me, w, F),
      selected: !!a.find((Je) => Je.year === de),
      valueText: de.toString(),
      get disabled() {
        return Q || !Le.selectable;
      }
    };
    return Le;
  }
  function Ye(ue) {
    const { value: de, disabled: Q } = ue, me = l.set({ month: de }), Le = $V(j, N), Je = {
      focused: l.month === ue.value,
      selectable: !ru(me, w, F),
      selected: !!a.find((Xe) => Xe.month === de && Xe.year === l.year),
      valueText: Le.format(me.toDate(N)),
      get disabled() {
        return Q || !Je.selectable;
      }
    };
    return Je;
  }
  function Ke(ue) {
    const { value: de, disabled: Q, visibleRange: me = e.context.visibleRange } = ue, Le = DI(j, N), Je = yy(e.context.visibleDuration), Xe = me.start.add(Je).subtract({ days: 1 }), je = {
      invalid: ru(de, w, F),
      disabled: Q || XV(de, me.start, Xe, w, F),
      selected: a.some((Ue) => gs(de, Ue)),
      unavailable: TC(de, Ce, j, w, F) && !Q,
      outsideRange: by(de, me.start, Xe),
      inRange: q && (RC(de, a) || RC(de, f)),
      firstInRange: q && gs(de, a[0]),
      lastInRange: q && gs(de, a[1]),
      today: KV(de, N),
      weekend: EV(de, j),
      formattedDate: Le.format(de.toDate(N)),
      get focused() {
        return gs(de, l) && !je.outsideRange;
      },
      get ariaLabel() {
        return je.unavailable ? `Not available. ${je.formattedDate}` : je.selected ? `Selected date. ${je.formattedDate}` : `Choose ${je.formattedDate}`;
      },
      get selectable() {
        return !je.disabled && !je.unavailable;
      }
    };
    return je;
  }
  function ze(ue) {
    const { view: de = "day", id: Q } = ue;
    return [de, Q].filter(Boolean).join(" ");
  }
  return {
    focused: k,
    open: z,
    view: e.context.view,
    getRangePresetValue(ue) {
      return kC(ue, j, N);
    },
    getDaysInWeek(ue, de = r) {
      return NI(ue, de, j, D);
    },
    getOffset(ue) {
      const de = r.add(ue);
      return {
        visibleRange: { start: de, end: o.add(ue) },
        weeks: He(de)
      };
    },
    getMonthWeeks: He,
    isUnavailable: we,
    weeks: He(),
    weekDays: oj(If(N), D, N, j),
    visibleRangeText: e.context.visibleRangeText,
    value: a,
    valueAsDate: a.map((ue) => ue.toDate(N)),
    valueAsString: a.map(OC),
    focusedValue: l,
    focusedValueAsDate: l == null ? void 0 : l.toDate(N),
    focusedValueAsString: OC(l),
    visibleRange: e.context.visibleRange,
    selectToday() {
      const ue = nc(If(N), w, F);
      n({ type: "VALUE.SET", value: ue });
    },
    setValue(ue) {
      const de = ue.map((Q) => nc(Q, w, F));
      n({ type: "VALUE.SET", value: de });
    },
    clearValue() {
      n("VALUE.CLEAR");
    },
    setFocusedValue(ue) {
      n({ type: "FOCUS.SET", value: ue });
    },
    setOpen(ue) {
      ue !== z && n(ue ? "OPEN" : "CLOSE");
    },
    focusMonth: ae,
    focusYear: ge,
    getYears: Se,
    getMonths: Re,
    getYearsGrid(ue = {}) {
      const { columns: de = 1 } = ue;
      return L0(Se(), de);
    },
    getDecade() {
      const ue = wh(l.year);
      return { start: ue.at(0), end: ue.at(-1) };
    },
    getMonthsGrid(ue = {}) {
      const { columns: de = 1, format: Q } = ue;
      return L0(Re({ format: Q }), de);
    },
    format(ue, de = { month: "long", year: "numeric" }) {
      return new rl(j, de).format(ue.toDate(N));
    },
    setView(ue) {
      n({ type: "VIEW.SET", cell: ue });
    },
    goToNext() {
      n({ type: "GOTO.NEXT", view: e.context.view });
    },
    goToPrev() {
      n({ type: "GOTO.PREV", view: e.context.view });
    },
    getRootProps() {
      return t.element({
        ...In.root.attrs,
        dir: e.context.dir,
        id: ut.getRootId(e.context),
        "data-state": z ? "open" : "closed",
        "data-disabled": se(p),
        "data-readonly": se(y)
      });
    },
    getLabelProps() {
      return t.label({
        ...In.label.attrs,
        dir: e.context.dir,
        htmlFor: ut.getInputId(e.context, 0),
        "data-state": z ? "open" : "closed",
        "data-disabled": se(p),
        "data-readonly": se(y)
      });
    },
    getControlProps() {
      return t.element({
        ...In.control.attrs,
        dir: e.context.dir,
        id: ut.getControlId(e.context),
        "data-disabled": se(p)
      });
    },
    getRangeTextProps() {
      return t.element({
        ...In.rangeText.attrs,
        dir: e.context.dir
      });
    },
    getContentProps() {
      return t.element({
        ...In.content.attrs,
        hidden: !z,
        dir: e.context.dir,
        "data-state": z ? "open" : "closed",
        "data-placement": ee,
        id: ut.getContentId(e.context),
        role: "application",
        "aria-roledescription": "datepicker",
        "aria-label": "calendar"
      });
    },
    getTableProps(ue = {}) {
      const { view: de = "day", columns: Q = de === "day" ? 7 : 4 } = ue, me = ze(ue);
      return t.element({
        ...In.table.attrs,
        role: "grid",
        "data-columns": Q,
        "aria-roledescription": Cj(de),
        id: ut.getTableId(e.context, me),
        "aria-readonly": Zr(y),
        "aria-disabled": Zr(p),
        "aria-multiselectable": Zr(e.context.selectionMode !== "single"),
        "data-view": de,
        dir: e.context.dir,
        tabIndex: -1,
        onKeyDown(Le) {
          if (Le.defaultPrevented)
            return;
          const Xe = {
            Enter() {
              we(l) || n({ type: "TABLE.ENTER", view: de, columns: Q, focus: !0 });
            },
            ArrowLeft() {
              n({ type: "TABLE.ARROW_LEFT", view: de, columns: Q, focus: !0 });
            },
            ArrowRight() {
              n({ type: "TABLE.ARROW_RIGHT", view: de, columns: Q, focus: !0 });
            },
            ArrowUp() {
              n({ type: "TABLE.ARROW_UP", view: de, columns: Q, focus: !0 });
            },
            ArrowDown() {
              n({ type: "TABLE.ARROW_DOWN", view: de, columns: Q, focus: !0 });
            },
            PageUp(je) {
              n({ type: "TABLE.PAGE_UP", larger: je.shiftKey, view: de, columns: Q, focus: !0 });
            },
            PageDown(je) {
              n({ type: "TABLE.PAGE_DOWN", larger: je.shiftKey, view: de, columns: Q, focus: !0 });
            },
            Home() {
              n({ type: "TABLE.HOME", view: de, columns: Q, focus: !0 });
            },
            End() {
              n({ type: "TABLE.END", view: de, columns: Q, focus: !0 });
            }
          }[il(Le, e.context)];
          Xe && (Xe(Le), Le.preventDefault(), Le.stopPropagation());
        },
        onPointerLeave() {
          n({ type: "TABLE.POINTER_LEAVE" });
        },
        onPointerDown() {
          n({ type: "TABLE.POINTER_DOWN", view: de });
        },
        onPointerUp() {
          n({ type: "TABLE.POINTER_UP", view: de });
        }
      });
    },
    getTableHeadProps(ue = {}) {
      const { view: de = "day" } = ue;
      return t.element({
        ...In.tableHead.attrs,
        "aria-hidden": !0,
        dir: e.context.dir,
        "data-view": de,
        "data-disabled": se(p)
      });
    },
    getTableHeaderProps(ue = {}) {
      const { view: de = "day" } = ue;
      return t.element({
        ...In.tableHeader.attrs,
        dir: e.context.dir,
        "data-view": de,
        "data-disabled": se(p)
      });
    },
    getTableBodyProps(ue = {}) {
      const { view: de = "day" } = ue;
      return t.element({
        ...In.tableBody.attrs,
        "data-view": de,
        "data-disabled": se(p)
      });
    },
    getTableRowProps(ue = {}) {
      const { view: de = "day" } = ue;
      return t.element({
        ...In.tableRow.attrs,
        "aria-disabled": Zr(p),
        "data-disabled": se(p),
        "data-view": de
      });
    },
    getDayTableCellState: Ke,
    getDayTableCellProps(ue) {
      const { value: de } = ue, Q = Ke(ue);
      return t.element({
        ...In.tableCell.attrs,
        role: "gridcell",
        "aria-disabled": Zr(!Q.selectable),
        "aria-selected": Q.selected || Q.inRange,
        "aria-invalid": Zr(Q.invalid),
        "aria-current": Q.today ? "date" : void 0,
        "data-value": de.toString()
      });
    },
    getDayTableCellTriggerProps(ue) {
      const { value: de } = ue, Q = Ke(ue);
      return t.element({
        ...In.tableCellTrigger.attrs,
        id: ut.getCellTriggerId(e.context, de.toString()),
        role: "button",
        dir: e.context.dir,
        tabIndex: Q.focused ? 0 : -1,
        "aria-label": Q.ariaLabel,
        "aria-disabled": Zr(!Q.selectable),
        "aria-invalid": Zr(Q.invalid),
        "data-disabled": se(!Q.selectable),
        "data-selected": se(Q.selected),
        "data-value": de.toString(),
        "data-view": "day",
        "data-today": se(Q.today),
        "data-focus": se(Q.focused),
        "data-unavailable": se(Q.unavailable),
        "data-range-start": se(Q.firstInRange),
        "data-range-end": se(Q.lastInRange),
        "data-in-range": se(Q.inRange),
        "data-outside-range": se(Q.outsideRange),
        "data-weekend": se(Q.weekend),
        onClick(me) {
          me.defaultPrevented || Q.selectable && n({ type: "CELL.CLICK", cell: "day", value: de });
        },
        onPointerMove(me) {
          if (me.pointerType === "touch" || !Q.selectable)
            return;
          const Le = me.currentTarget.ownerDocument.activeElement !== me.currentTarget;
          u && pV(de, u) || n({ type: "CELL.POINTER_MOVE", cell: "day", value: de, focus: Le });
        }
      });
    },
    getMonthTableCellState: Ye,
    getMonthTableCellProps(ue) {
      const { value: de, columns: Q } = ue, me = Ye(ue);
      return t.element({
        ...In.tableCell.attrs,
        dir: e.context.dir,
        colSpan: Q,
        role: "gridcell",
        "aria-selected": Zr(me.selected),
        "data-selected": se(me.selected),
        "aria-disabled": Zr(!me.selectable),
        "data-value": de
      });
    },
    getMonthTableCellTriggerProps(ue) {
      const { value: de } = ue, Q = Ye(ue);
      return t.element({
        ...In.tableCellTrigger.attrs,
        dir: e.context.dir,
        role: "button",
        id: ut.getCellTriggerId(e.context, de.toString()),
        "data-selected": se(Q.selected),
        "aria-disabled": Zr(!Q.selectable),
        "data-disabled": se(!Q.selectable),
        "data-focus": se(Q.focused),
        "aria-label": Q.valueText,
        "data-view": "month",
        "data-value": de,
        tabIndex: Q.focused ? 0 : -1,
        onClick(me) {
          me.defaultPrevented || Q.selectable && n({ type: "CELL.CLICK", cell: "month", value: de });
        }
      });
    },
    getYearTableCellState: Ie,
    getYearTableCellProps(ue) {
      const { value: de, columns: Q } = ue, me = Ie(ue);
      return t.element({
        ...In.tableCell.attrs,
        dir: e.context.dir,
        colSpan: Q,
        role: "gridcell",
        "aria-selected": Zr(me.selected),
        "data-selected": se(me.selected),
        "aria-disabled": Zr(!me.selectable),
        "data-value": de
      });
    },
    getYearTableCellTriggerProps(ue) {
      const { value: de } = ue, Q = Ie(ue);
      return t.element({
        ...In.tableCellTrigger.attrs,
        dir: e.context.dir,
        role: "button",
        id: ut.getCellTriggerId(e.context, de.toString()),
        "data-selected": se(Q.selected),
        "data-focus": se(Q.focused),
        "aria-disabled": Zr(!Q.selectable),
        "data-disabled": se(!Q.selectable),
        "aria-label": Q.valueText,
        "data-value": de,
        "data-view": "year",
        tabIndex: Q.focused ? 0 : -1,
        onClick(me) {
          me.defaultPrevented || Q.selectable && n({ type: "CELL.CLICK", cell: "year", value: de });
        }
      });
    },
    getNextTriggerProps(ue = {}) {
      const { view: de = "day" } = ue;
      return t.button({
        ...In.nextTrigger.attrs,
        dir: e.context.dir,
        id: ut.getNextTriggerId(e.context, de),
        type: "button",
        "aria-label": bj(de),
        disabled: p || !e.context.isNextVisibleRangeValid,
        onClick(Q) {
          Q.defaultPrevented || n({ type: "GOTO.NEXT", view: de });
        }
      });
    },
    getPrevTriggerProps(ue = {}) {
      const { view: de = "day" } = ue;
      return t.button({
        ...In.prevTrigger.attrs,
        dir: e.context.dir,
        id: ut.getPrevTriggerId(e.context, de),
        type: "button",
        "aria-label": yj(de),
        disabled: p || !e.context.isPrevVisibleRangeValid,
        onClick(Q) {
          Q.defaultPrevented || n({ type: "GOTO.PREV", view: de });
        }
      });
    },
    getClearTriggerProps() {
      return t.button({
        ...In.clearTrigger.attrs,
        id: ut.getClearTriggerId(e.context),
        dir: e.context.dir,
        type: "button",
        "aria-label": "Clear dates",
        hidden: !e.context.value.length,
        onClick(ue) {
          ue.defaultPrevented || n("VALUE.CLEAR");
        }
      });
    },
    getTriggerProps() {
      return t.button({
        ...In.trigger.attrs,
        id: ut.getTriggerId(e.context),
        dir: e.context.dir,
        type: "button",
        "data-placement": ee,
        "aria-label": z ? "Close calendar" : "Open calendar",
        "aria-controls": ut.getContentId(e.context),
        "data-state": z ? "open" : "closed",
        "aria-haspopup": "grid",
        disabled: p,
        onClick(ue) {
          ue.defaultPrevented || A && n("TRIGGER.CLICK");
        }
      });
    },
    getViewTriggerProps(ue = {}) {
      const { view: de = "day" } = ue;
      return t.button({
        ...In.viewTrigger.attrs,
        "data-view": de,
        dir: e.context.dir,
        id: ut.getViewTriggerId(e.context, de),
        type: "button",
        disabled: p,
        "aria-label": Ej(e.context.view),
        onClick(Q) {
          Q.defaultPrevented || A && n("VIEW.CHANGE");
        }
      });
    },
    getViewControlProps(ue = {}) {
      const { view: de = "day" } = ue;
      return t.element({
        ...In.viewControl.attrs,
        "data-view": de,
        dir: e.context.dir
      });
    },
    getInputProps(ue = {}) {
      const { index: de = 0 } = ue;
      return t.input({
        ...In.input.attrs,
        id: ut.getInputId(e.context, de),
        autoComplete: "off",
        autoCorrect: "off",
        spellCheck: "false",
        dir: e.context.dir,
        name: e.context.name,
        "data-state": z ? "open" : "closed",
        readOnly: y,
        disabled: p,
        placeholder: Sj(j),
        defaultValue: e.context.formattedValue[de],
        onBeforeInput(Q) {
          const { data: me } = LD(Q);
          BI(me, Oe) || Q.preventDefault();
        },
        onFocus() {
          n({ type: "INPUT.FOCUS", index: de });
        },
        onBlur(Q) {
          n({ type: "INPUT.BLUR", value: Q.currentTarget.value, index: de });
        },
        onKeyDown(Q) {
          Q.defaultPrevented || A && (hb(Q) || Q.key === "Enter" && (we(e.context.focusedValue) || (n({ type: "INPUT.ENTER", value: Q.currentTarget.value, index: de }), Q.preventDefault())));
        },
        onChange(Q) {
          const { value: me } = Q.target;
          n({ type: "INPUT.CHANGE", value: wj(me, Oe), index: de });
        }
      });
    },
    getMonthSelectProps() {
      return t.select({
        ...In.monthSelect.attrs,
        id: ut.getMonthSelectId(e.context),
        "aria-label": "Select month",
        disabled: p,
        dir: e.context.dir,
        defaultValue: r.month,
        onChange(ue) {
          ae(Number(ue.currentTarget.value));
        }
      });
    },
    getYearSelectProps() {
      return t.select({
        ...In.yearSelect.attrs,
        id: ut.getYearSelectId(e.context),
        disabled: p,
        "aria-label": "Select year",
        dir: e.context.dir,
        defaultValue: r.year,
        onChange(ue) {
          ge(Number(ue.currentTarget.value));
        }
      });
    },
    getPositionerProps() {
      return t.element({
        id: ut.getPositionerId(e.context),
        ...In.positioner.attrs,
        dir: e.context.dir,
        style: Fe.floating
      });
    },
    getPresetTriggerProps(ue) {
      const de = Array.isArray(ue.value) ? ue.value : kC(ue.value, j, N);
      return t.button({
        ...In.presetTrigger.attrs,
        "aria-label": Array.isArray(ue.value) ? `select ${de[0].toString()} to ${de[1].toString()}` : `select ${de}`,
        type: "button",
        onClick(Q) {
          Q.defaultPrevented || n({ type: "PRESET.CLICK", value: de });
        }
      });
    }
  };
}
var { and: Ra } = Ma, Tj = (e) => {
  const n = e.locale || "en-US", t = e.timeZone || "UTC", r = e.selectionMode || "single", o = e.numOfMonths || 1, a = $v(e.value || []).map((f) => nc(f, e.min, e.max));
  let l = a[0] || e.focusedValue || If(t);
  l = nc(l, e.min, e.max);
  const u = kI(l, "start", { months: o }, n);
  return {
    locale: n,
    numOfMonths: o,
    focusedValue: l,
    startValue: u,
    timeZone: t,
    value: a,
    selectionMode: r,
    view: "day",
    activeIndex: 0,
    hoveredValue: null,
    closeOnSelect: !0,
    ...e,
    positioning: {
      placement: "bottom",
      ...e.positioning
    }
  };
};
function Pj(e) {
  const n = br(e);
  return Rr(
    {
      id: "datepicker",
      initial: n.open ? "open" : "idle",
      context: Tj(n),
      computed: {
        valueAsString: (t) => t.value.map((r) => _V(r, null, t.locale, t.timeZone)),
        isInteractive: (t) => !t.disabled && !t.readOnly,
        visibleDuration: (t) => ({ months: t.numOfMonths }),
        endValue: (t) => RI(t.startValue, t.visibleDuration),
        visibleRange: (t) => ({ start: t.startValue, end: t.endValue }),
        visibleRangeText(t) {
          const r = new rl(t.locale, { month: "long", year: "numeric", timeZone: t.timeZone }), o = r.format(t.startValue.toDate(t.timeZone)), a = r.format(t.endValue.toDate(t.timeZone)), l = t.selectionMode === "range" ? `${o} - ${a}` : o;
          return { start: o, end: a, formatted: l };
        },
        isPrevVisibleRangeValid: (t) => !JV(t.startValue, t.min, t.max),
        isNextVisibleRangeValid: (t) => !QV(t.endValue, t.min, t.max),
        formattedValue(t) {
          const r = { timeZone: t.timeZone, day: "2-digit", month: "2-digit", year: "numeric" }, o = new rl(t.locale, r);
          return t.value.map((a) => {
            var l;
            return ((l = t.format) == null ? void 0 : l.call(t, a)) ?? o.format(a.toDate(t.timeZone));
          });
        }
      },
      activities: ["setupLiveRegion"],
      created: ["setStartValue"],
      watch: {
        locale: ["setStartValue"],
        focusedValue: [
          "setStartValue",
          "syncMonthSelectElement",
          "syncYearSelectElement",
          "focusActiveCellIfNeeded",
          "setHoveredValueIfKeyboard"
        ],
        value: ["syncInputElement"],
        valueAsString: ["announceValueText"],
        view: ["focusActiveCell"],
        open: ["toggleVisibility"]
      },
      on: {
        "VALUE.SET": {
          actions: ["setDateValue", "setFocusedDate"]
        },
        "VIEW.SET": {
          actions: ["setView"]
        },
        "FOCUS.SET": {
          actions: ["setFocusedDate"]
        },
        "VALUE.CLEAR": {
          actions: ["clearDateValue", "clearFocusedDate", "focusFirstInputElement"]
        },
        "INPUT.CHANGE": {
          actions: ["focusParsedDate"]
        },
        "INPUT.ENTER": {
          actions: ["focusParsedDate", "selectFocusedDate"]
        },
        "INPUT.FOCUS": {
          actions: ["setActiveIndex"]
        },
        "INPUT.BLUR": [
          {
            guard: "isOpenControlled",
            actions: ["setActiveIndexToStart", "selectParsedDate", "invokeOnClose"]
          },
          {
            target: "idle",
            actions: ["setActiveIndexToStart", "selectParsedDate"]
          }
        ],
        "PRESET.CLICK": [
          {
            guard: "isOpenControlled",
            actions: ["setDateValue", "setFocusedDate", "invokeOnClose"]
          },
          {
            target: "focused",
            actions: ["setDateValue", "setFocusedDate", "focusInputElement"]
          }
        ],
        "GOTO.NEXT": [
          {
            guard: "isYearView",
            actions: ["focusNextDecade", "announceVisibleRange"]
          },
          {
            guard: "isMonthView",
            actions: ["focusNextYear", "announceVisibleRange"]
          },
          {
            actions: ["focusNextPage"]
          }
        ],
        "GOTO.PREV": [
          {
            guard: "isYearView",
            actions: ["focusPreviousDecade", "announceVisibleRange"]
          },
          {
            guard: "isMonthView",
            actions: ["focusPreviousYear", "announceVisibleRange"]
          },
          {
            actions: ["focusPreviousPage"]
          }
        ]
      },
      states: {
        idle: {
          tags: "closed",
          on: {
            "CONTROLLED.OPEN": {
              target: "open",
              actions: ["focusFirstSelectedDate", "focusActiveCell"]
            },
            "TRIGGER.CLICK": [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["focusFirstSelectedDate", "focusActiveCell", "invokeOnOpen"]
              }
            ],
            OPEN: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["focusFirstSelectedDate", "focusActiveCell", "invokeOnOpen"]
              }
            ]
          }
        },
        focused: {
          tags: "closed",
          on: {
            "CONTROLLED.OPEN": {
              target: "open",
              actions: ["focusFirstSelectedDate", "focusActiveCell"]
            },
            "TRIGGER.CLICK": [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["focusFirstSelectedDate", "focusActiveCell", "invokeOnOpen"]
              }
            ],
            OPEN: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["focusFirstSelectedDate", "focusActiveCell", "invokeOnOpen"]
              }
            ]
          }
        },
        open: {
          tags: "open",
          activities: ["trackDismissableElement", "trackPositioning"],
          exit: ["clearHoveredDate", "resetView"],
          on: {
            "CONTROLLED.CLOSE": [
              {
                guard: Ra("shouldRestoreFocus", "isInteractOutsideEvent"),
                target: "focused",
                actions: ["focusTriggerElement"]
              },
              {
                guard: "shouldRestoreFocus",
                target: "focused",
                actions: ["focusInputElement"]
              },
              {
                target: "idle"
              }
            ],
            "CELL.CLICK": [
              {
                guard: "isMonthView",
                actions: ["setFocusedMonth", "setViewToDay"]
              },
              {
                guard: "isYearView",
                actions: ["setFocusedYear", "setViewToMonth"]
              },
              {
                guard: Ra("isRangePicker", "hasSelectedRange"),
                actions: [
                  "setActiveIndexToStart",
                  "clearDateValue",
                  "setFocusedDate",
                  "setSelectedDate",
                  "setActiveIndexToEnd"
                ]
              },
              // === Grouped transitions (based on `closeOnSelect` and `isOpenControlled`) ===
              {
                guard: Ra("isRangePicker", "isSelectingEndDate", "closeOnSelect", "isOpenControlled"),
                actions: [
                  "setFocusedDate",
                  "setSelectedDate",
                  "setActiveIndexToStart",
                  "invokeOnClose",
                  "setRestoreFocus"
                ]
              },
              {
                guard: Ra("isRangePicker", "isSelectingEndDate", "closeOnSelect"),
                target: "focused",
                actions: [
                  "setFocusedDate",
                  "setSelectedDate",
                  "setActiveIndexToStart",
                  "invokeOnClose",
                  "focusInputElement"
                ]
              },
              {
                guard: Ra("isRangePicker", "isSelectingEndDate"),
                actions: ["setFocusedDate", "setSelectedDate", "setActiveIndexToStart", "clearHoveredDate"]
              },
              // ===
              {
                guard: "isRangePicker",
                actions: ["setFocusedDate", "setSelectedDate", "setActiveIndexToEnd"]
              },
              {
                guard: "isMultiPicker",
                actions: ["setFocusedDate", "toggleSelectedDate"]
              },
              // === Grouped transitions (based on `closeOnSelect` and `isOpenControlled`) ===
              {
                guard: Ra("closeOnSelect", "isOpenControlled"),
                actions: ["setFocusedDate", "setSelectedDate", "invokeOnClose"]
              },
              {
                guard: "closeOnSelect",
                target: "focused",
                actions: ["setFocusedDate", "setSelectedDate", "invokeOnClose", "focusInputElement"]
              },
              {
                actions: ["setFocusedDate", "setSelectedDate"]
              }
              // ===
            ],
            "CELL.POINTER_MOVE": {
              guard: Ra("isRangePicker", "isSelectingEndDate"),
              actions: ["setHoveredDate", "setFocusedDate"]
            },
            "TABLE.POINTER_LEAVE": {
              guard: "isRangePicker",
              actions: ["clearHoveredDate"]
            },
            "TABLE.POINTER_DOWN": {
              actions: ["disableTextSelection"]
            },
            "TABLE.POINTER_UP": {
              actions: ["enableTextSelection"]
            },
            "TABLE.ESCAPE": [
              {
                guard: "isOpenControlled",
                actions: ["focusFirstSelectedDate", "invokeOnClose"]
              },
              {
                target: "focused",
                actions: ["focusFirstSelectedDate", "invokeOnClose", "focusTriggerElement"]
              }
            ],
            "TABLE.ENTER": [
              {
                guard: "isMonthView",
                actions: "setViewToDay"
              },
              {
                guard: "isYearView",
                actions: "setViewToMonth"
              },
              {
                guard: Ra("isRangePicker", "hasSelectedRange"),
                actions: ["setActiveIndexToStart", "clearDateValue", "setSelectedDate", "setActiveIndexToEnd"]
              },
              // === Grouped transitions (based on `closeOnSelect` and `isOpenControlled`) ===
              {
                guard: Ra("isRangePicker", "isSelectingEndDate", "closeOnSelect", "isOpenControlled"),
                actions: ["setSelectedDate", "setActiveIndexToStart", "invokeOnClose"]
              },
              {
                guard: Ra("isRangePicker", "isSelectingEndDate", "closeOnSelect"),
                target: "focused",
                actions: ["setSelectedDate", "setActiveIndexToStart", "invokeOnClose", "focusInputElement"]
              },
              {
                guard: Ra("isRangePicker", "isSelectingEndDate"),
                actions: ["setSelectedDate", "setActiveIndexToStart"]
              },
              // ===
              {
                guard: "isRangePicker",
                actions: ["setSelectedDate", "setActiveIndexToEnd", "focusNextDay"]
              },
              {
                guard: "isMultiPicker",
                actions: ["toggleSelectedDate"]
              },
              // === Grouped transitions (based on `closeOnSelect` and `isOpenControlled`) ===
              {
                guard: Ra("closeOnSelect", "isOpenControlled"),
                actions: ["selectFocusedDate", "invokeOnClose"]
              },
              {
                guard: "closeOnSelect",
                target: "focused",
                actions: ["selectFocusedDate", "invokeOnClose", "focusInputElement"]
              },
              {
                actions: ["selectFocusedDate"]
              }
              // ===
            ],
            "TABLE.ARROW_RIGHT": [
              {
                guard: "isMonthView",
                actions: "focusNextMonth"
              },
              {
                guard: "isYearView",
                actions: "focusNextYear"
              },
              {
                actions: ["focusNextDay", "setHoveredDate"]
              }
            ],
            "TABLE.ARROW_LEFT": [
              {
                guard: "isMonthView",
                actions: "focusPreviousMonth"
              },
              {
                guard: "isYearView",
                actions: "focusPreviousYear"
              },
              {
                actions: ["focusPreviousDay"]
              }
            ],
            "TABLE.ARROW_UP": [
              {
                guard: "isMonthView",
                actions: "focusPreviousMonthColumn"
              },
              {
                guard: "isYearView",
                actions: "focusPreviousYearColumn"
              },
              {
                actions: ["focusPreviousWeek"]
              }
            ],
            "TABLE.ARROW_DOWN": [
              {
                guard: "isMonthView",
                actions: "focusNextMonthColumn"
              },
              {
                guard: "isYearView",
                actions: "focusNextYearColumn"
              },
              {
                actions: ["focusNextWeek"]
              }
            ],
            "TABLE.PAGE_UP": {
              actions: ["focusPreviousSection"]
            },
            "TABLE.PAGE_DOWN": {
              actions: ["focusNextSection"]
            },
            "TABLE.HOME": [
              {
                guard: "isMonthView",
                actions: ["focusFirstMonth"]
              },
              {
                guard: "isYearView",
                actions: ["focusFirstYear"]
              },
              {
                actions: ["focusSectionStart"]
              }
            ],
            "TABLE.END": [
              {
                guard: "isMonthView",
                actions: ["focusLastMonth"]
              },
              {
                guard: "isYearView",
                actions: ["focusLastYear"]
              },
              {
                actions: ["focusSectionEnd"]
              }
            ],
            "TRIGGER.CLICK": [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnClose"]
              },
              {
                target: "focused",
                actions: ["invokeOnClose"]
              }
            ],
            "VIEW.CHANGE": [
              {
                guard: "isDayView",
                actions: ["setViewToMonth"]
              },
              {
                guard: "isMonthView",
                actions: ["setViewToYear"]
              }
            ],
            INTERACT_OUTSIDE: [
              {
                guard: "isOpenControlled",
                actions: ["setActiveIndexToStart", "invokeOnClose"]
              },
              {
                guard: "shouldRestoreFocus",
                target: "focused",
                actions: ["setActiveIndexToStart", "invokeOnClose", "focusTriggerElement"]
              },
              {
                target: "idle",
                actions: ["setActiveIndexToStart", "invokeOnClose"]
              }
            ],
            CLOSE: [
              {
                guard: "isOpenControlled",
                actions: ["setActiveIndexToStart", "invokeOnClose"]
              },
              {
                target: "idle",
                actions: ["setActiveIndexToStart", "invokeOnClose"]
              }
            ]
          }
        }
      }
    },
    {
      guards: {
        isDayView: (t, r) => (r.view || t.view) === "day",
        isMonthView: (t, r) => (r.view || t.view) === "month",
        isYearView: (t, r) => (r.view || t.view) === "year",
        isRangePicker: (t) => t.selectionMode === "range",
        hasSelectedRange: (t) => t.value.length === 2,
        isMultiPicker: (t) => t.selectionMode === "multiple",
        shouldRestoreFocus: (t) => !!t.restoreFocus,
        isSelectingEndDate: (t) => t.activeIndex === 1,
        closeOnSelect: (t) => !!t.closeOnSelect,
        isOpenControlled: (t) => !!t["open.controlled"],
        isInteractOutsideEvent: (t, r) => {
          var o;
          return ((o = r.previousEvent) == null ? void 0 : o.type) === "INTERACT_OUTSIDE";
        }
      },
      activities: {
        trackPositioning(t) {
          t.currentPlacement = t.positioning.placement;
          const r = ut.getControlEl(t);
          return uu(r, () => ut.getPositionerEl(t), {
            ...t.positioning,
            defer: !0,
            onComplete(a) {
              t.currentPlacement = a.placement;
            }
          });
        },
        setupLiveRegion(t) {
          const r = ut.getDoc(t);
          return t.announcer = mj({ level: "assertive", document: r }), () => {
            var o, a;
            return (a = (o = t.announcer) == null ? void 0 : o.destroy) == null ? void 0 : a.call(o);
          };
        },
        trackDismissableElement(t, r, { send: o }) {
          return Uf(() => ut.getContentEl(t), {
            defer: !0,
            exclude: [...ut.getInputEls(t), ut.getTriggerEl(t), ut.getClearTriggerEl(t)],
            onInteractOutside(l) {
              t.restoreFocus = !l.detail.focusable;
            },
            onDismiss() {
              o({ type: "INTERACT_OUTSIDE" });
            },
            onEscapeKeyDown(l) {
              l.preventDefault(), o({ type: "TABLE.ESCAPE", src: "dismissable" });
            }
          });
        }
      },
      actions: {
        setViewToDay(t) {
          Rt.view(t, "day");
        },
        setViewToMonth(t) {
          Rt.view(t, "month");
        },
        setViewToYear(t) {
          Rt.view(t, "year");
        },
        setView(t, r) {
          Rt.view(t, r.cell);
        },
        setRestoreFocus(t) {
          t.restoreFocus = !0;
        },
        announceValueText(t) {
          var r;
          (r = t.announcer) == null || r.announce(t.valueAsString.join(","), 3e3);
        },
        announceVisibleRange(t) {
          var o;
          const { formatted: r } = t.visibleRangeText;
          (o = t.announcer) == null || o.announce(r);
        },
        disableTextSelection(t) {
          Ib({ target: ut.getContentEl(t), doc: ut.getDoc(t) });
        },
        enableTextSelection(t) {
          GA({ doc: ut.getDoc(t), target: ut.getContentEl(t) });
        },
        focusFirstSelectedDate(t) {
          t.value.length && Rt.focusedValue(t, t.value[0]);
        },
        syncInputElement(t) {
          Ct(() => {
            ut.getInputEls(t).forEach((o, a) => {
              ut.setValue(o, t.formattedValue[a] || "");
            });
          });
        },
        setFocusedDate(t, r) {
          const o = Array.isArray(r.value) ? r.value[0] : r.value;
          Rt.focusedValue(t, o);
        },
        setFocusedMonth(t, r) {
          Rt.focusedValue(t, t.focusedValue.set({ month: r.value }));
        },
        focusNextMonth(t) {
          Rt.focusedValue(t, t.focusedValue.add({ months: 1 }));
        },
        focusPreviousMonth(t) {
          Rt.focusedValue(t, t.focusedValue.subtract({ months: 1 }));
        },
        setFocusedYear(t, r) {
          Rt.focusedValue(t, t.focusedValue.set({ year: r.value }));
        },
        setDateValue(t, r) {
          if (!Array.isArray(r.value))
            return;
          const o = r.value.map((a) => nc(a, t.min, t.max));
          Rt.value(t, o);
        },
        clearDateValue(t) {
          Rt.value(t, []);
        },
        setSelectedDate(t, r) {
          const o = Array.from(t.value);
          o[t.activeIndex] = r.value ?? t.focusedValue, Rt.value(t, _v(o));
        },
        toggleSelectedDate(t, r) {
          const o = r.value ?? t.focusedValue, a = t.value.findIndex((l) => gs(l, o));
          if (a === -1) {
            const l = [...t.value, o];
            Rt.value(t, $v(l));
          } else {
            const l = Array.from(t.value);
            l.splice(a, 1), Rt.value(t, $v(l));
          }
        },
        setHoveredDate(t, r) {
          t.hoveredValue = r.value;
        },
        clearHoveredDate(t) {
          t.hoveredValue = null;
        },
        selectFocusedDate(t) {
          const r = Array.from(t.value);
          r[t.activeIndex] = t.focusedValue.copy(), Rt.value(t, _v(r));
        },
        setPreviousDate(t) {
          Rt.focusedValue(t, aj(t.focusedValue));
        },
        setNextDate(t) {
          Rt.focusedValue(t, ij(t.focusedValue));
        },
        focusPreviousDay(t) {
          Rt.focusedValue(t, t.focusedValue.subtract({ days: 1 }));
        },
        focusNextDay(t) {
          Rt.focusedValue(t, t.focusedValue.add({ days: 1 }));
        },
        focusPreviousWeek(t) {
          Rt.focusedValue(t, t.focusedValue.subtract({ weeks: 1 }));
        },
        focusNextWeek(t) {
          Rt.focusedValue(t, t.focusedValue.add({ weeks: 1 }));
        },
        focusNextPage(t) {
          const r = MI(
            t.focusedValue,
            t.startValue,
            t.visibleDuration,
            t.locale,
            t.min,
            t.max
          );
          Rt.adjustedValue(t, r);
        },
        focusPreviousPage(t) {
          const r = LI(
            t.focusedValue,
            t.startValue,
            t.visibleDuration,
            t.locale,
            t.min,
            t.max
          );
          Rt.adjustedValue(t, r);
        },
        focusSectionStart(t) {
          Rt.focusedValue(t, t.startValue.copy());
        },
        focusSectionEnd(t) {
          Rt.focusedValue(t, t.endValue.copy());
        },
        focusNextSection(t, r) {
          const o = cj(
            t.focusedValue,
            t.startValue,
            r.larger,
            t.visibleDuration,
            t.locale,
            t.min,
            t.max
          );
          o && Rt.adjustedValue(t, o);
        },
        focusPreviousSection(t, r) {
          const o = uj(
            t.focusedValue,
            t.startValue,
            r.larger,
            t.visibleDuration,
            t.locale,
            t.min,
            t.max
          );
          o && Rt.adjustedValue(t, o);
        },
        focusNextYear(t) {
          Rt.focusedValue(t, t.focusedValue.add({ years: 1 }));
        },
        focusPreviousYear(t) {
          Rt.focusedValue(t, t.focusedValue.subtract({ years: 1 }));
        },
        focusNextDecade(t) {
          Rt.focusedValue(t, t.focusedValue.add({ years: 10 }));
        },
        focusPreviousDecade(t) {
          Rt.focusedValue(t, t.focusedValue.subtract({ years: 10 }));
        },
        clearFocusedDate(t) {
          Rt.focusedValue(t, If(t.timeZone));
        },
        focusPreviousMonthColumn(t, r) {
          Rt.focusedValue(t, t.focusedValue.subtract({ months: r.columns }));
        },
        focusNextMonthColumn(t, r) {
          Rt.focusedValue(t, t.focusedValue.add({ months: r.columns }));
        },
        focusPreviousYearColumn(t, r) {
          Rt.focusedValue(t, t.focusedValue.subtract({ years: r.columns }));
        },
        focusNextYearColumn(t, r) {
          Rt.focusedValue(t, t.focusedValue.add({ years: r.columns }));
        },
        focusFirstMonth(t) {
          Rt.focusedValue(t, t.focusedValue.set({ month: 0 }));
        },
        focusLastMonth(t) {
          Rt.focusedValue(t, t.focusedValue.set({ month: 12 }));
        },
        focusFirstYear(t) {
          const r = wh(t.focusedValue.year);
          Rt.focusedValue(t, t.focusedValue.set({ year: r.at(0) }));
        },
        focusLastYear(t) {
          const r = wh(t.focusedValue.year);
          Rt.focusedValue(t, t.focusedValue.set({ year: r.at(-1) }));
        },
        setActiveIndex(t, r) {
          t.activeIndex = r.index;
        },
        setActiveIndexToEnd(t) {
          t.activeIndex = 1;
        },
        setActiveIndexToStart(t) {
          t.activeIndex = 0;
        },
        focusActiveCell(t) {
          Ct(() => {
            var r;
            (r = ut.getFocusedCell(t)) == null || r.focus({ preventScroll: !0 });
          });
        },
        focusActiveCellIfNeeded(t, r) {
          r.focus && Ct(() => {
            var o;
            (o = ut.getFocusedCell(t)) == null || o.focus({ preventScroll: !0 });
          });
        },
        setHoveredValueIfKeyboard(t, r) {
          !r.type.startsWith("TABLE.ARROW") || t.selectionMode !== "range" || t.activeIndex === 0 || (t.hoveredValue = t.focusedValue.copy());
        },
        focusTriggerElement(t) {
          Ct(() => {
            var r;
            (r = ut.getTriggerEl(t)) == null || r.focus({ preventScroll: !0 });
          });
        },
        focusFirstInputElement(t) {
          Ct(() => {
            const r = ut.getInputEls(t)[0];
            r == null || r.focus({ preventScroll: !0 });
          });
        },
        focusInputElement(t) {
          Ct(() => {
            const r = ut.getInputEls(t), o = r.findLastIndex((u) => u.value !== ""), a = Math.max(o, 0), l = r[a];
            l == null || l.focus({ preventScroll: !0 }), l == null || l.setSelectionRange(l.value.length, l.value.length);
          });
        },
        syncMonthSelectElement(t) {
          const r = ut.getMonthSelectEl(t);
          r && (r.value = t.startValue.month.toString());
        },
        syncYearSelectElement(t) {
          const r = ut.getYearSelectEl(t);
          r && (r.value = t.startValue.year.toString());
        },
        focusParsedDate(t, r) {
          if (r.index == null)
            return;
          const o = PC(r.value, t.locale, t.timeZone);
          o && Rt.focusedValue(t, o);
        },
        selectParsedDate(t, r) {
          if (r.index == null)
            return;
          const o = PC(r.value, t.locale, t.timeZone);
          if (!o)
            return;
          const a = Array.from(t.value);
          a[r.index] = o, Rt.value(t, a);
        },
        resetView(t, r, { initialContext: o }) {
          Rt.view(t, o.view);
        },
        setStartValue(t) {
          if (!by(t.focusedValue, t.startValue, t.endValue))
            return;
          const o = kI(t.focusedValue, "start", { months: t.numOfMonths }, t.locale);
          t.startValue = o;
        },
        invokeOnOpen(t) {
          var r;
          (r = t.onOpenChange) == null || r.call(t, { open: !0 });
        },
        invokeOnClose(t) {
          var r;
          (r = t.onOpenChange) == null || r.call(t, { open: !1 });
        },
        toggleVisibility(t, r, { send: o }) {
          o({ type: t.open ? "CONTROLLED.OPEN" : "CONTROLLED.CLOSE", previousEvent: r });
        }
      },
      compareFns: {
        startValue: gs,
        endValue: gs,
        focusedValue: gs,
        value: VI
      }
    }
  );
}
var Ap = {
  change(e) {
    var r;
    const n = Array.from(e.value), t = n.map((o) => o.toString());
    (r = e.onValueChange) == null || r.call(e, {
      value: n,
      valueAsString: t,
      view: e.view
    });
  },
  focusChange(e) {
    var r;
    const n = Array.from(e.value), t = n.map((o) => o.toString());
    (r = e.onFocusChange) == null || r.call(e, {
      focusedValue: e.focusedValue,
      value: n,
      valueAsString: t,
      view: e.view
    });
  },
  viewChange(e) {
    var n;
    (n = e.onViewChange) == null || n.call(e, { view: e.view });
  }
}, VI = (e, n) => e.length !== n.length ? !1 : e.every((t, r) => gs(t, n[r])), Rt = {
  value(e, n) {
    VI(e.value, n) || (e.value = n, Ap.change(e));
  },
  focusedValue(e, n) {
    if (!n || gs(e.focusedValue, n))
      return;
    const r = Zg(e.visibleDuration, e.locale, e.min, e.max)({
      focusedDate: n,
      startDate: e.startValue
    });
    e.startValue = r.startDate, e.focusedValue = r.focusedDate, Ap.focusChange(e);
  },
  adjustedValue(e, n) {
    e.startValue = n.startDate, !gs(e.focusedValue, n.focusedDate) && (e.focusedValue = n.focusedDate, Ap.focusChange(e));
  },
  view(e, n) {
    vr(e.view, n) || (e.view = n, Ap.viewChange(e));
  }
};
function $c(e) {
  return Array.isArray(e) ? e.map((n) => $c(n)) : e instanceof Date ? new ac(e.getFullYear(), e.getMonth() + 1, e.getDate()) : MV(e);
}
nn()([
  "closeOnSelect",
  "dir",
  "disabled",
  "fixedWeeks",
  "focusedValue",
  "format",
  "getRootNode",
  "id",
  "ids",
  "isDateUnavailable",
  "isDateUnavailable",
  "locale",
  "max",
  "min",
  "modal",
  "name",
  "numOfMonths",
  "onFocusChange",
  "onOpenChange",
  "onValueChange",
  "onViewChange",
  "open",
  "open.controlled",
  "positioning",
  "readOnly",
  "selectionMode",
  "startOfWeek",
  "timeZone",
  "translations",
  "value",
  "view"
]);
nn()(["index"]);
nn()(["value"]);
nn()(["columns", "id", "view"]);
nn()(["disabled", "value", "columns"]);
nn()(["view"]);
const kj = (e = {}) => {
  const { getRootNode: n } = Jr(), { dir: t } = ko(), r = {
    id: gr(),
    dir: t,
    getRootNode: n,
    open: e.defaultOpen,
    "open.controlled": e.open !== void 0,
    ...e,
    focusedValue: e.focusedValue ? $c(e.focusedValue) : void 0,
    value: e.defaultValue ? $c(e.defaultValue) : void 0,
    max: e.max ? $c(e.max) : void 0,
    min: e.min ? $c(e.min) : void 0
  }, o = {
    ...r,
    max: e.max ? $c(e.max) : void 0,
    min: e.min ? $c(e.min) : void 0,
    value: e.value ? $c(e.value) : void 0,
    onValueChange: en(e.onValueChange, { sync: !0 }),
    onFocusChange: en(e.onFocusChange),
    onViewChange: en(e.onViewChange),
    onOpenChange: en(e.onOpenChange)
  }, [a, l] = Or(Pj(r), { context: o });
  return xj(a, l, yr);
}, jI = oe((e, n) => {
  const [t, r] = fu(e), [o, a] = Ft()(r, [
    "closeOnSelect",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "fixedWeeks",
    "focusedValue",
    "format",
    "id",
    "ids",
    "isDateUnavailable",
    "isDateUnavailable",
    "locale",
    "max",
    "min",
    "modal",
    "name",
    "numOfMonths",
    "onFocusChange",
    "onOpenChange",
    "onValueChange",
    "onViewChange",
    "open",
    "positioning",
    "readOnly",
    "selectionMode",
    "startOfWeek",
    "timeZone",
    "translations",
    "value",
    "view"
  ]), l = kj(o), u = cc(be({ present: l.open }, t)), f = be(l.getRootProps(), a);
  return /* @__PURE__ */ I.jsx(lV, { value: l, children: /* @__PURE__ */ I.jsx(Ad, { value: u, children: /* @__PURE__ */ I.jsx(ve.div, { ...f, ref: n }) }) });
});
jI.displayName = "DatePickerRoot";
const [Rj, Uh] = xt({
  name: "DatePickerTableContext",
  hookName: "useDatePickerTableContext",
  providerName: "<DatePickerTableProvider />"
}), UI = oe((e, n) => {
  const [{ columns: t }, r] = Ft()(e, [
    "columns"
  ]), o = Dr(), a = Sd(), l = { columns: t, id: gr(), ...a }, u = be(o.getTableProps(l), r);
  return /* @__PURE__ */ I.jsx(Rj, { value: l, children: /* @__PURE__ */ I.jsx(ve.table, { ...u, ref: n }) });
});
UI.displayName = "DatePickerTable";
const WI = oe(
  (e, n) => {
    const t = Dr(), r = Uh(), o = be(t.getTableBodyProps(r), e);
    return /* @__PURE__ */ I.jsx(ve.tbody, { ...o, ref: n });
  }
);
WI.displayName = "DatePickerTableBody";
const [Oj, Dj] = xt({
  name: "DatePickerTableCellContext",
  hookName: "useDatePickerTableCellContext",
  providerName: "<DatePickerTableCellProvider />"
}), HI = oe(
  (e, n) => {
    const [t, r] = Ft()(e, [
      "disabled",
      "value",
      "visibleRange",
      "columns"
    ]), o = Dr(), a = Sd(), l = {
      day: o.getDayTableCellProps,
      month: o.getMonthTableCellProps,
      year: o.getYearTableCellProps
      // @ts-expect-error value is number filter
    }[a.view](t), u = be(l, r);
    return /* @__PURE__ */ I.jsx(Oj, { value: t, children: /* @__PURE__ */ I.jsx(ve.td, { ref: n, ...u }) });
  }
);
HI.displayName = "DatePickerTableCell";
const GI = oe((e, n) => {
  const t = Dr(), r = Dj(), o = Sd(), l = {
    day: t.getDayTableCellTriggerProps,
    month: t.getMonthTableCellTriggerProps,
    year: t.getYearTableCellTriggerProps
  }[o.view], u = l(r), f = be(u, e);
  return /* @__PURE__ */ I.jsx(ve.div, { ref: n, ...f });
});
GI.displayName = "DatePickerTableCellTrigger";
const YI = oe(
  (e, n) => {
    const t = Dr(), r = Uh(), o = be(t.getTableHeadProps(r), e);
    return /* @__PURE__ */ I.jsx(ve.thead, { ...o, ref: n });
  }
);
YI.displayName = "DatePickerTableHead";
const zI = oe(
  (e, n) => {
    const t = Dr(), r = Uh(), o = be(t.getTableHeaderProps(r), e);
    return /* @__PURE__ */ I.jsx(ve.th, { ...o, ref: n });
  }
);
zI.displayName = "DatePickerTableHeader";
const ZI = oe(
  (e, n) => {
    const t = Dr(), r = Uh(), o = be(t.getTableRowProps(r), e);
    return /* @__PURE__ */ I.jsx(ve.tr, { ...o, ref: n });
  }
);
ZI.displayName = "DatePickerTableRow";
const KI = oe((e, n) => {
  const [t, r] = Ft()(e, ["view"]), o = Dr();
  return /* @__PURE__ */ I.jsx(cV, { value: t, children: /* @__PURE__ */ I.jsx(
    ve.div,
    {
      hidden: o.view !== t.view,
      ...QS.build().view.attrs,
      ...r,
      ref: n
    }
  ) });
});
KI.displayName = "DatePickerView";
const XI = oe(
  (e, n) => {
    const t = Dr(), r = Sd(), o = be(t.getViewControlProps(r), e);
    return /* @__PURE__ */ I.jsx(ve.div, { ...o, ref: n });
  }
);
XI.displayName = "DatePickerViewControl";
const JI = oe(
  (e, n) => {
    const t = Dr(), r = Sd(), o = be(t.getViewTriggerProps(r), e);
    return /* @__PURE__ */ I.jsx(ve.button, { ...o, ref: n });
  }
);
JI.displayName = "DatePickerViewTrigger";
const QI = oe(
  (e, n) => {
    const t = Dr(), r = be(t.getYearSelectProps(), e);
    return /* @__PURE__ */ I.jsx(ve.select, { ...r, ref: n, children: Fj({ from: 1e3, to: 4e3 }).map((o, a) => /* @__PURE__ */ I.jsx("option", { value: o, children: o }, a)) });
  }
);
QI.displayName = "DatePickerYearSelect";
function Fj(e) {
  const n = [];
  for (let t = e.from; t <= e.to; t += 1)
    n.push(t);
  return n;
}
const [Nj, Wh] = xt({
  name: "DialogContext",
  hookName: "useDialogContext",
  providerName: "<DialogProvider />"
}), qI = oe((e, n) => {
  const t = Wh(), r = SS(), o = cc({ ...r, present: t.open }), a = be(t.getBackdropProps(), o.getPresenceProps(n), e);
  return o.unmounted ? null : /* @__PURE__ */ I.jsx(ve.div, { ...a });
});
qI.displayName = "DialogBackdrop";
const _I = oe(
  (e, n) => {
    const t = Wh(), r = be(t.getCloseTriggerProps(), e);
    return /* @__PURE__ */ I.jsx(ve.button, { ...r, ref: n });
  }
);
_I.displayName = "DialogCloseTrigger";
const $I = oe((e, n) => {
  const t = Wh(), r = oa(), o = be(t.getContentProps(), r.getPresenceProps(n), e);
  return r.unmounted ? null : /* @__PURE__ */ I.jsx(ve.div, { ...o });
});
$I.displayName = "DialogContent";
const ex = oe((e, n) => {
  const t = Wh(), r = be(t.getPositionerProps(), e);
  return oa().unmounted ? null : /* @__PURE__ */ I.jsx(ve.div, { ...r, ref: n });
});
ex.displayName = "DialogPositioner";
var $p = (e, n = []) => ({
  parts: (...t) => {
    if (Mj(n))
      return $p(e, t);
    throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
  },
  extendWith: (...t) => $p(e, [...n, ...t]),
  rename: (t) => $p(t, n),
  keys: () => n,
  build: () => [...new Set(n)].reduce(
    (t, r) => Object.assign(t, {
      [r]: {
        selector: [
          `&[data-scope="${cf(e)}"][data-part="${cf(r)}"]`,
          `& [data-scope="${cf(e)}"][data-part="${cf(r)}"]`
        ].join(", "),
        attrs: { "data-scope": cf(e), "data-part": cf(r) }
      }
    }),
    {}
  )
}), cf = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), Mj = (e) => e.length === 0, Xm = "data-zag-scroll-lock";
function DC(e, n) {
  if (!e)
    return;
  const t = e.style.cssText;
  return Object.assign(e.style, n), () => {
    e.style.cssText = t;
  };
}
function Lj(e, n, t) {
  if (!e)
    return;
  const r = e.style.getPropertyValue(n);
  return e.style.setProperty(n, t), () => {
    r ? e.style.setProperty(n, r) : e.style.removeProperty(n);
  };
}
function Bj(e) {
  const n = e.getBoundingClientRect().left;
  return Math.round(n) + e.scrollLeft ? "paddingLeft" : "paddingRight";
}
function Vj(e) {
  const n = e ?? document, t = n.defaultView ?? window, { documentElement: r, body: o } = n;
  if (o.hasAttribute(Xm))
    return;
  o.setAttribute(Xm, "");
  const l = t.innerWidth - r.clientWidth, u = () => Lj(r, "--scrollbar-width", `${l}px`), f = Bj(r), p = () => DC(o, {
    overflow: "hidden",
    [f]: `${l}px`
  }), y = () => {
    const { scrollX: w, scrollY: F, visualViewport: j } = t, N = (j == null ? void 0 : j.offsetLeft) ?? 0, D = (j == null ? void 0 : j.offsetTop) ?? 0, k = DC(o, {
      position: "fixed",
      overflow: "hidden",
      top: `${-(F - Math.floor(D))}px`,
      left: `${-(w - Math.floor(N))}px`,
      right: "0",
      [f]: `${l}px`
    });
    return () => {
      k == null || k(), t.scrollTo({ left: w, top: F, behavior: "instant" });
    };
  }, A = [u(), gb() ? y() : p()];
  return () => {
    A.forEach((w) => w == null ? void 0 : w()), o.removeAttribute(Xm);
  };
}
var jj = $p("dialog").parts(
  "trigger",
  "backdrop",
  "positioner",
  "content",
  "title",
  "description",
  "closeTrigger"
), rd = jj.build(), zt = so({
  getPositionerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.positioner) ?? `dialog:${e.id}:positioner`;
  },
  getBackdropId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.backdrop) ?? `dialog:${e.id}:backdrop`;
  },
  getContentId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.content) ?? `dialog:${e.id}:content`;
  },
  getTriggerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.trigger) ?? `dialog:${e.id}:trigger`;
  },
  getTitleId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.title) ?? `dialog:${e.id}:title`;
  },
  getDescriptionId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.description) ?? `dialog:${e.id}:description`;
  },
  getCloseTriggerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.closeTrigger) ?? `dialog:${e.id}:close`;
  },
  getContentEl: (e) => zt.getById(e, zt.getContentId(e)),
  getPositionerEl: (e) => zt.getById(e, zt.getPositionerId(e)),
  getBackdropEl: (e) => zt.getById(e, zt.getBackdropId(e)),
  getTriggerEl: (e) => zt.getById(e, zt.getTriggerId(e)),
  getTitleEl: (e) => zt.getById(e, zt.getTitleId(e)),
  getDescriptionEl: (e) => zt.getById(e, zt.getDescriptionId(e)),
  getCloseTriggerEl: (e) => zt.getById(e, zt.getCloseTriggerId(e))
});
function Uj(e, n, t) {
  const r = e.context["aria-label"], o = e.matches("open"), a = e.context.renderedElements;
  return {
    open: o,
    setOpen(l) {
      l !== o && n(l ? "OPEN" : "CLOSE");
    },
    getTriggerProps() {
      return t.button({
        ...rd.trigger.attrs,
        dir: e.context.dir,
        id: zt.getTriggerId(e.context),
        "aria-haspopup": "dialog",
        type: "button",
        "aria-expanded": o,
        "data-state": o ? "open" : "closed",
        "aria-controls": zt.getContentId(e.context),
        onClick(l) {
          l.defaultPrevented || n("TOGGLE");
        }
      });
    },
    getBackdropProps() {
      return t.element({
        ...rd.backdrop.attrs,
        dir: e.context.dir,
        hidden: !o,
        id: zt.getBackdropId(e.context),
        "data-state": o ? "open" : "closed"
      });
    },
    getPositionerProps() {
      return t.element({
        ...rd.positioner.attrs,
        dir: e.context.dir,
        id: zt.getPositionerId(e.context),
        style: {
          pointerEvents: o ? void 0 : "none"
        }
      });
    },
    getContentProps() {
      return t.element({
        ...rd.content.attrs,
        dir: e.context.dir,
        role: e.context.role,
        hidden: !o,
        id: zt.getContentId(e.context),
        tabIndex: -1,
        "data-state": o ? "open" : "closed",
        "aria-modal": !0,
        "aria-label": r || void 0,
        "aria-labelledby": r || !a.title ? void 0 : zt.getTitleId(e.context),
        "aria-describedby": a.description ? zt.getDescriptionId(e.context) : void 0
      });
    },
    getTitleProps() {
      return t.element({
        ...rd.title.attrs,
        dir: e.context.dir,
        id: zt.getTitleId(e.context)
      });
    },
    getDescriptionProps() {
      return t.element({
        ...rd.description.attrs,
        dir: e.context.dir,
        id: zt.getDescriptionId(e.context)
      });
    },
    getCloseTriggerProps() {
      return t.button({
        ...rd.closeTrigger.attrs,
        dir: e.context.dir,
        id: zt.getCloseTriggerId(e.context),
        type: "button",
        onClick(l) {
          l.defaultPrevented || (l.stopPropagation(), n("CLOSE"));
        }
      });
    }
  };
}
function Wj(e) {
  const n = br(e);
  return Rr(
    {
      id: "dialog",
      initial: n.open ? "open" : "closed",
      context: {
        role: "dialog",
        renderedElements: {
          title: !0,
          description: !0
        },
        modal: !0,
        trapFocus: !0,
        preventScroll: !0,
        closeOnInteractOutside: !0,
        closeOnEscape: !0,
        restoreFocus: !0,
        ...n
      },
      created: ["checkInitialFocusEl"],
      watch: {
        open: ["toggleVisibility"]
      },
      states: {
        open: {
          entry: ["checkRenderedElements", "syncZIndex"],
          activities: ["trackDismissableElement", "trapFocus", "preventScroll", "hideContentBelow"],
          on: {
            "CONTROLLED.CLOSE": {
              target: "closed",
              actions: ["setFinalFocus"]
            },
            CLOSE: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnClose"]
              },
              {
                target: "closed",
                actions: ["invokeOnClose", "setFinalFocus"]
              }
            ],
            TOGGLE: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnClose"]
              },
              {
                target: "closed",
                actions: ["invokeOnClose", "setFinalFocus"]
              }
            ]
          }
        },
        closed: {
          on: {
            "CONTROLLED.OPEN": {
              target: "open"
            },
            OPEN: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["invokeOnOpen"]
              }
            ],
            TOGGLE: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["invokeOnOpen"]
              }
            ]
          }
        }
      }
    },
    {
      guards: {
        isOpenControlled: (t) => !!t["open.controlled"]
      },
      activities: {
        trackDismissableElement(t, r, { send: o }) {
          return Uf(() => zt.getContentEl(t), {
            defer: !0,
            pointerBlocking: t.modal,
            exclude: [zt.getTriggerEl(t)],
            onInteractOutside(l) {
              var u;
              (u = t.onInteractOutside) == null || u.call(t, l), (!t.closeOnInteractOutside || t.role === "alertdialog") && l.preventDefault();
            },
            persistentElements: t.persistentElements,
            onFocusOutside: t.onFocusOutside,
            onPointerDownOutside: t.onPointerDownOutside,
            onEscapeKeyDown(l) {
              var u;
              (u = t.onEscapeKeyDown) == null || u.call(t, l), t.closeOnEscape ? o({ type: "CLOSE", src: "escape-key" }) : l.preventDefault();
            },
            onDismiss() {
              o({ type: "CLOSE", src: "interact-outside" });
            }
          });
        },
        preventScroll(t) {
          if (t.preventScroll)
            return Vj(zt.getDoc(t));
        },
        trapFocus(t) {
          if (!t.trapFocus || !t.modal)
            return;
          let r;
          const o = Ab(() => {
            const a = zt.getContentEl(t);
            if (a) {
              r = ZM(a, {
                document: zt.getDoc(t),
                escapeDeactivates: !1,
                preventScroll: !0,
                returnFocusOnDeactivate: !1,
                fallbackFocus: a,
                allowOutsideClick: !0,
                initialFocus: Cb({
                  root: a,
                  getInitialEl: t.initialFocusEl
                })
              });
              try {
                r.activate();
              } catch {
              }
            }
          });
          return () => {
            r == null || r.deactivate(), o();
          };
        },
        hideContentBelow(t) {
          return t.modal ? rI(() => [zt.getContentEl(t)], { defer: !0 }) : void 0;
        }
      },
      actions: {
        checkInitialFocusEl(t) {
          !t.initialFocusEl && t.role === "alertdialog" && (t.initialFocusEl = () => zt.getCloseTriggerEl(t));
        },
        checkRenderedElements(t) {
          Ct(() => {
            t.renderedElements.title = !!zt.getTitleEl(t), t.renderedElements.description = !!zt.getDescriptionEl(t);
          });
        },
        syncZIndex(t) {
          Ct(() => {
            const r = zt.getContentEl(t);
            if (!r)
              return;
            const a = zt.getWin(t).getComputedStyle(r);
            [zt.getPositionerEl(t), zt.getBackdropEl(t)].forEach((u) => {
              u == null || u.style.setProperty("--z-index", a.zIndex);
            });
          });
        },
        invokeOnClose(t) {
          var r;
          (r = t.onOpenChange) == null || r.call(t, { open: !1 });
        },
        invokeOnOpen(t) {
          var r;
          (r = t.onOpenChange) == null || r.call(t, { open: !0 });
        },
        toggleVisibility(t, r, { send: o }) {
          o({ type: t.open ? "CONTROLLED.OPEN" : "CONTROLLED.CLOSE", previousEvent: r });
        },
        setFinalFocus(t) {
          t.restoreFocus && queueMicrotask(() => {
            var o;
            const r = ((o = t.finalFocusEl) == null ? void 0 : o.call(t)) ?? zt.getTriggerEl(t);
            r == null || r.focus({ preventScroll: !0 });
          });
        }
      }
    }
  );
}
nn()([
  "aria-label",
  "closeOnEscape",
  "closeOnInteractOutside",
  "dir",
  "finalFocusEl",
  "getRootNode",
  "getRootNode",
  "id",
  "id",
  "ids",
  "initialFocusEl",
  "modal",
  "onEscapeKeyDown",
  "onFocusOutside",
  "onInteractOutside",
  "onOpenChange",
  "onPointerDownOutside",
  "open.controlled",
  "open",
  "persistentElements",
  "preventScroll",
  "restoreFocus",
  "role",
  "trapFocus"
]);
const Hj = (e = {}) => {
  const { getRootNode: n } = Jr(), { dir: t } = ko(), r = {
    id: gr(),
    getRootNode: n,
    dir: t,
    open: e.defaultOpen,
    "open.controlled": e.open !== void 0,
    ...e
  }, o = {
    ...r,
    open: e.open,
    onOpenChange: en(e.onOpenChange, { sync: !0 }),
    onEscapeKeyDown: en(e.onEscapeKeyDown),
    onInteractOutside: en(e.onInteractOutside)
  }, [a, l] = Or(Wj(r), { context: o });
  return Uj(a, l, yr);
}, Gj = (e) => {
  const [n, { children: t, ...r }] = fu(e), [o] = wS(n), a = Hj(r), l = cc(be({ present: a.open }, n));
  return /* @__PURE__ */ I.jsx(Nj, { value: a, children: /* @__PURE__ */ I.jsx(AS, { value: o, children: /* @__PURE__ */ I.jsx(Ad, { value: l, children: t }) }) });
}, [Yj, La] = xt({
  name: "FileUploadContext",
  hookName: "useFileUploadContext",
  providerName: "<FileUploadProvider />"
}), zj = (e) => e.children(La()), tx = oe(
  (e, n) => {
    const t = La(), r = be(t.getDropzoneProps(), e);
    return /* @__PURE__ */ I.jsx(ve.div, { ...r, ref: n });
  }
);
tx.displayName = "FileUploadDropzone";
const nx = oe(
  (e, n) => {
    const t = La(), r = be(t.getHiddenInputProps(), e);
    return /* @__PURE__ */ I.jsx(ve.input, { ...r, ref: n });
  }
);
nx.displayName = "FileUploadHiddenInput";
const [Zj, Kg] = xt({
  name: "FileUploadItemPropsContext",
  hookName: "useFileUploadItemPropsContext",
  providerName: "<FileUploadItemPropsProvider />"
}), rx = oe((e, n) => {
  const [t, r] = Ft()(e, ["file"]), o = La(), a = be(o.getItemProps(t), r);
  return /* @__PURE__ */ I.jsx(Zj, { value: t, children: /* @__PURE__ */ I.jsx(ve.li, { ...a, ref: n }) });
});
rx.displayName = "FileUploadItem";
const ox = oe((e, n) => {
  const t = La(), r = Kg(), o = be(t.getItemDeleteTriggerProps(r), e);
  return /* @__PURE__ */ I.jsx(ve.button, { ...o, ref: n });
});
ox.displayName = "FileUploadItemDeleteTrigger";
const ix = oe(
  (e, n) => {
    const t = La(), r = be(t.getItemGroupProps(), e);
    return /* @__PURE__ */ I.jsx(ve.ul, { ...r, ref: n });
  }
);
ix.displayName = "FileUploadItemGroup";
const ax = oe(
  (e, n) => {
    const { children: t, ...r } = e, o = La(), a = Kg(), l = be(o.getItemNameProps(a), r);
    return /* @__PURE__ */ I.jsx(ve.div, { ...l, ref: n, children: t || a.file.name });
  }
);
ax.displayName = "FileUploadItemName";
const sx = oe(
  (e, n) => {
    const t = La(), r = Kg(), o = be(t.getItemPreviewProps(r), e);
    return r.file.type.match(e.type ?? ".*") ? /* @__PURE__ */ I.jsx(ve.div, { ...o, ref: n }) : null;
  }
);
sx.displayName = "FileUploadItemPreview";
const lx = oe((e, n) => {
  const [t, r] = du(""), o = La(), a = Kg(), l = be(o.getItemPreviewImageProps({ ...a, url: t }), e);
  return ra(() => {
    o.createFileUrl(a.file, (u) => r(u));
  }, [a, o]), /* @__PURE__ */ I.jsx(ve.img, { ...l, ref: n });
});
lx.displayName = "FileUploadItemPreviewImage";
const cx = oe(
  (e, n) => {
    const { children: t, ...r } = e, o = La(), a = Kg(), l = be(o.getItemSizeTextProps(a), r);
    return /* @__PURE__ */ I.jsx(ve.div, { ...l, ref: n, children: t || o.getFileSize(a.file) });
  }
);
cx.displayName = "FileUploadItemSizeText";
const ux = oe((e, n) => {
  const t = La(), r = be(t.getLabelProps(), e);
  return /* @__PURE__ */ I.jsx(ve.label, { ...r, ref: n });
});
ux.displayName = "FileUploadLabel";
var eh = (e, n = []) => ({
  parts: (...t) => {
    if (Kj(n))
      return eh(e, t);
    throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
  },
  extendWith: (...t) => eh(e, [...n, ...t]),
  rename: (t) => eh(t, n),
  keys: () => n,
  build: () => [...new Set(n)].reduce(
    (t, r) => Object.assign(t, {
      [r]: {
        selector: [
          `&[data-scope="${uf(e)}"][data-part="${uf(r)}"]`,
          `& [data-scope="${uf(e)}"][data-part="${uf(r)}"]`
        ].join(", "),
        attrs: { "data-scope": uf(e), "data-part": uf(r) }
      }
    }),
    {}
  )
}), uf = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), Kj = (e) => e.length === 0;
function Xj(e) {
  const n = /* @__PURE__ */ new Map();
  return function(r, o) {
    const a = r + (o ? Object.entries(o).sort((u, f) => u[0] < f[0] ? -1 : 1).join() : "");
    if (n.has(a))
      return n.get(a);
    let l = new e(r, o);
    return n.set(a, l), l;
  };
}
var Jj = Xj(Intl.NumberFormat);
function Qj(e, n, t = {}) {
  return Jj(n, t).format(e);
}
var qj = ["", "kilo", "mega", "giga", "tera"], _j = ["", "kilo", "mega", "giga", "tera", "peta"], $j = (e, n = "en-US", t = {}) => {
  if (isNaN(e))
    return "";
  if (e === 0)
    return "0 B";
  const { unit: r = "byte", unitDisplay: o = "short" } = t, a = r === "bit" ? qj : _j, l = Math.max(0, Math.min(Math.floor(Math.log10(e) / 3), a.length - 1)), u = a[l] + r, f = o || "short", p = parseFloat((e / Math.pow(1e3, l)).toPrecision(3));
  return Qj(p, n, {
    style: "unit",
    unit: u,
    unitDisplay: f
  });
};
function e5(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || /\w+\/[-+.\w]+/g.test(e);
}
function t5(e) {
  return /^.*\.[\w]+$/.test(e);
}
function n5(e) {
  if (e)
    return typeof e == "string" ? e : Object.entries(e).reduce((n, [t, r]) => [...n, t, ...r], []).filter((n) => e5(n) || t5(n)).join(",");
}
var r5 = (e, n) => e.name === n.name && e.size === n.size && e.type === n.type, Cg = (e) => e != null;
function o5(e, n, t) {
  if (Cg(e.size))
    if (Cg(n) && Cg(t)) {
      if (e.size > t)
        return [!1, "FILE_TOO_LARGE"];
      if (e.size < n)
        return [!1, "FILE_TOO_SMALL"];
    } else {
      if (Cg(n) && e.size < n)
        return [!1, "FILE_TOO_SMALL"];
      if (Cg(t) && e.size > t)
        return [!1, "FILE_TOO_LARGE"];
    }
  return [!0, null];
}
function i5(e, n) {
  if (e && n) {
    const t = Array.isArray(n) ? n : n.split(","), r = e.name || "", o = (e.type || "").toLowerCase(), a = o.replace(/\/.*$/, "");
    return t.some((l) => {
      const u = l.trim().toLowerCase();
      return u.charAt(0) === "." ? r.toLowerCase().endsWith(u) : u.endsWith("/*") ? a === u.replace(/\/.*$/, "") : o === u;
    });
  }
  return !0;
}
function a5(e, n) {
  const t = e.type === "application/x-moz-file" || i5(e, n);
  return [t, t ? null : "FILE_INVALID_TYPE"];
}
var s5 = eh("file-upload").parts(
  "root",
  "dropzone",
  "item",
  "itemDeleteTrigger",
  "itemGroup",
  "itemName",
  "itemPreview",
  "itemPreviewImage",
  "itemSizeText",
  "label",
  "trigger"
), us = s5.build(), kr = so({
  getRootId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.root) ?? `file:${e.id}`;
  },
  getDropzoneId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.dropzone) ?? `file:${e.id}:dropzone`;
  },
  getHiddenInputId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.hiddenInput) ?? `file:${e.id}:input`;
  },
  getTriggerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.trigger) ?? `file:${e.id}:trigger`;
  },
  getLabelId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.label) ?? `file:${e.id}:label`;
  },
  getItemId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.item) == null ? void 0 : r.call(t, n)) ?? `file:${e.id}:item:${n}`;
  },
  getItemNameId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.itemName) == null ? void 0 : r.call(t, n)) ?? `file:${e.id}:item-name:${n}`;
  },
  getItemSizeTextId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.itemSizeText) == null ? void 0 : r.call(t, n)) ?? `file:${e.id}:item-size:${n}`;
  },
  getItemPreviewId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.itemPreview) == null ? void 0 : r.call(t, n)) ?? `file:${e.id}:item-preview:${n}`;
  },
  getHiddenInputEl: (e) => kr.getById(e, kr.getHiddenInputId(e)),
  getDropzoneEl: (e) => kr.getById(e, kr.getDropzoneId(e))
});
function FC(e) {
  return e.dataTransfer ? e.dataTransfer.types.some((n) => n === "Files" || n === "application/x-moz-file") : !!e.target && "files" in e.target;
}
function dx(e, n) {
  return !e.multiple && n > 1 ? !1 : !e.multiple && n + e.acceptedFiles.length === 2 ? !0 : !(n + e.acceptedFiles.length > e.maxFiles);
}
function l5(e, n) {
  const t = [], r = [];
  return n.forEach((o) => {
    var A;
    const [a, l] = a5(o, e.acceptAttr), [u, f] = o5(o, e.minFileSize, e.maxFileSize), p = (A = e.validate) == null ? void 0 : A.call(e, o), y = p ? p.length === 0 : !0;
    if (a && u && y)
      t.push(o);
    else {
      const w = [l, f];
      y || w.push(...p ?? []), r.push({ file: o, errors: w.filter(Boolean) });
    }
  }), dx(e, t.length) || (t.forEach((o) => {
    r.push({ file: o, errors: ["TOO_MANY_FILES"] });
  }), t.splice(0)), {
    acceptedFiles: t,
    rejectedFiles: r
  };
}
function c5(e, n, t) {
  const r = e.context.disabled, o = e.context.allowDrop, a = e.context.translations, l = e.matches("dragging"), u = e.matches("focused") && !r;
  return {
    dragging: l,
    focused: u,
    openFilePicker() {
      n("OPEN");
    },
    deleteFile(f) {
      n({ type: "FILE.DELETE", file: f });
    },
    acceptedFiles: e.context.acceptedFiles,
    rejectedFiles: e.context.rejectedFiles,
    setFiles(f) {
      const p = f.length;
      n({ type: "FILES.SET", files: f, count: p });
    },
    clearFiles() {
      n({ type: "FILES.CLEAR" });
    },
    getFileSize(f) {
      return $j(f.size, e.context.locale);
    },
    createFileUrl(f, p) {
      const y = kr.getWin(e.context), A = y.URL.createObjectURL(f);
      return p(A), () => y.URL.revokeObjectURL(A);
    },
    getRootProps() {
      return t.element({
        ...us.root.attrs,
        dir: e.context.dir,
        id: kr.getRootId(e.context),
        "data-disabled": se(r),
        "data-dragging": se(l)
      });
    },
    getDropzoneProps() {
      return t.element({
        ...us.dropzone.attrs,
        dir: e.context.dir,
        id: kr.getDropzoneId(e.context),
        tabIndex: r ? void 0 : 0,
        "aria-disabled": r,
        "aria-invalid": e.context.invalid,
        "data-invalid": se(e.context.invalid),
        "data-disabled": se(r),
        "data-dragging": se(l),
        onKeyDown(f) {
          f.defaultPrevented || pb(f) && (f.key !== "Enter" && f.key !== " " || n({ type: "DROPZONE.CLICK", src: "keydown" }));
        },
        onClick(f) {
          f.currentTarget.localName === "label" && f.preventDefault(), n("DROPZONE.CLICK");
        },
        onDragOver(f) {
          if (!o)
            return;
          f.preventDefault(), f.stopPropagation();
          try {
            f.dataTransfer.dropEffect = "copy";
          } catch {
          }
          if (!FC(f))
            return;
          const y = f.dataTransfer.items.length;
          n({ type: "DROPZONE.DRAG_OVER", count: y });
        },
        onDragLeave(f) {
          !o || r || ol(f.currentTarget, f.relatedTarget) || n({ type: "DROPZONE.DRAG_LEAVE" });
        },
        onDrop(f) {
          o && (f.preventDefault(), f.stopPropagation());
          const p = FC(f);
          r || !p || n({ type: "DROPZONE.DROP", files: Array.from(f.dataTransfer.files) });
        },
        onFocus() {
          n("DROPZONE.FOCUS");
        },
        onBlur() {
          n("DROPZONE.BLUR");
        }
      });
    },
    getTriggerProps() {
      return t.button({
        ...us.trigger.attrs,
        dir: e.context.dir,
        id: kr.getTriggerId(e.context),
        disabled: r,
        "data-disabled": se(r),
        type: "button",
        onClick(f) {
          r || (ol(kr.getDropzoneEl(e.context), f.currentTarget) && f.stopPropagation(), n("OPEN"));
        }
      });
    },
    getHiddenInputProps() {
      return t.input({
        id: kr.getHiddenInputId(e.context),
        tabIndex: -1,
        disabled: r,
        type: "file",
        capture: e.context.capture,
        name: e.context.name,
        accept: e.context.acceptAttr,
        webkitdirectory: e.context.capture ? "" : void 0,
        multiple: e.context.multiple || e.context.maxFiles > 1,
        onClick(f) {
          f.stopPropagation(), f.currentTarget.value = "";
        },
        onChange(f) {
          if (r)
            return;
          const { files: p } = f.currentTarget;
          n({ type: "FILES.SET", files: p ? Array.from(p) : [] });
        },
        style: Ff
      });
    },
    getItemGroupProps() {
      return t.element({
        ...us.itemGroup.attrs,
        dir: e.context.dir,
        "data-disabled": se(r)
      });
    },
    getItemProps(f) {
      const { file: p } = f;
      return t.element({
        ...us.item.attrs,
        dir: e.context.dir,
        id: kr.getItemId(e.context, p.name),
        "data-disabled": se(r)
      });
    },
    getItemNameProps(f) {
      const { file: p } = f;
      return t.element({
        ...us.itemName.attrs,
        dir: e.context.dir,
        id: kr.getItemNameId(e.context, p.name),
        "data-disabled": se(r)
      });
    },
    getItemSizeTextProps(f) {
      const { file: p } = f;
      return t.element({
        ...us.itemSizeText.attrs,
        dir: e.context.dir,
        id: kr.getItemSizeTextId(e.context, p.name),
        "data-disabled": se(r)
      });
    },
    getItemPreviewProps(f) {
      const { file: p } = f;
      return t.element({
        ...us.itemPreview.attrs,
        dir: e.context.dir,
        id: kr.getItemPreviewId(e.context, p.name),
        "data-disabled": se(r)
      });
    },
    getItemPreviewImageProps(f) {
      const { file: p, url: y } = f;
      if (!p.type.startsWith("image/"))
        throw new Error("Preview Image is only supported for image files");
      return t.img({
        ...us.itemPreviewImage.attrs,
        alt: a.itemPreview(p),
        src: y,
        "data-disabled": se(r)
      });
    },
    getItemDeleteTriggerProps(f) {
      const { file: p } = f;
      return t.button({
        ...us.itemDeleteTrigger.attrs,
        dir: e.context.dir,
        type: "button",
        disabled: r,
        "data-disabled": se(r),
        "aria-label": a.deleteFile(p),
        onClick() {
          r || n({ type: "FILE.DELETE", file: p });
        }
      });
    },
    getLabelProps() {
      return t.label({
        ...us.label.attrs,
        dir: e.context.dir,
        id: kr.getLabelId(e.context),
        htmlFor: kr.getHiddenInputId(e.context),
        "data-disabled": se(r)
      });
    }
  };
}
var { not: NC } = Ma;
function u5(e) {
  const n = br(e);
  return Rr(
    {
      id: "fileupload",
      initial: "idle",
      context: {
        minFileSize: 0,
        maxFileSize: 1 / 0,
        maxFiles: 1,
        allowDrop: !0,
        ...n,
        acceptedFiles: Hn([]),
        rejectedFiles: Hn([]),
        invalid: !1,
        translations: {
          itemPreview: (t) => `preview of ${t.name}`,
          deleteFile: (t) => `delete file ${t.name}`,
          ...n.translations
        }
      },
      computed: {
        acceptAttr: (t) => n5(t.accept),
        multiple: (t) => t.maxFiles > 1
      },
      on: {
        "FILES.SET": {
          actions: ["setFilesFromEvent"]
        },
        "FILE.DELETE": {
          actions: ["removeFile"]
        },
        "FILES.CLEAR": {
          actions: ["clearFiles"]
        }
      },
      states: {
        idle: {
          on: {
            OPEN: {
              actions: ["openFilePicker"]
            },
            "DROPZONE.CLICK": {
              actions: ["openFilePicker"]
            },
            "DROPZONE.FOCUS": "focused",
            "DROPZONE.DRAG_OVER": [
              {
                guard: NC("isWithinRange"),
                target: "dragging",
                actions: ["setInvalid"]
              },
              { target: "dragging" }
            ]
          }
        },
        focused: {
          on: {
            "DROPZONE.BLUR": "idle",
            OPEN: {
              actions: ["openFilePicker"]
            },
            "DROPZONE.CLICK": {
              actions: ["openFilePicker"]
            },
            "DROPZONE.DRAG_OVER": [
              {
                guard: NC("isWithinRange"),
                target: "dragging",
                actions: ["setInvalid"]
              },
              { target: "dragging" }
            ]
          }
        },
        dragging: {
          on: {
            "DROPZONE.DROP": {
              target: "idle",
              actions: ["clearInvalid", "setFilesFromEvent", "syncInputElement"]
            },
            "DROPZONE.DRAG_LEAVE": {
              target: "idle",
              actions: ["clearInvalid"]
            }
          }
        }
      }
    },
    {
      guards: {
        isWithinRange: (t, r) => dx(t, r.count)
      },
      actions: {
        syncInputElement(t) {
          const r = kr.getHiddenInputEl(t);
          if (!r)
            return;
          const o = kr.getWin(t), a = new o.DataTransfer();
          t.acceptedFiles.forEach((l) => {
            a.items.add(l);
          }), r.files = a.files;
        },
        openFilePicker(t) {
          Ct(() => {
            var r;
            (r = kr.getHiddenInputEl(t)) == null || r.click();
          });
        },
        setInvalid(t) {
          t.invalid = !0;
        },
        clearInvalid(t) {
          t.invalid = !1;
        },
        setFilesFromEvent(t, r) {
          const o = l5(t, r.files), { acceptedFiles: a, rejectedFiles: l } = o;
          if (t.multiple) {
            const u = Hn([...t.acceptedFiles, ...a]);
            Eg.files(t, u, l);
            return;
          }
          if (a.length) {
            const u = Hn([a[0]]);
            Eg.files(t, u, l);
          } else
            l.length && Eg.files(t, [], l);
        },
        removeFile(t, r) {
          const o = t.acceptedFiles.filter((a) => a !== r.file);
          Eg.files(t, o);
        },
        clearFiles(t) {
          Eg.files(t, []);
        }
      },
      compareFns: {
        acceptedFiles: (t, r) => t.length === r.length && t.every((o, a) => r5(o, r[a]))
      }
    }
  );
}
var Jm = {
  change: (e) => {
    var n;
    (n = e.onFileChange) == null || n.call(e, {
      acceptedFiles: e.acceptedFiles,
      rejectedFiles: e.rejectedFiles
    });
  },
  accept: (e) => {
    var n;
    (n = e.onFileAccept) == null || n.call(e, { files: e.acceptedFiles });
  },
  reject: (e) => {
    var n;
    (n = e.onFileReject) == null || n.call(e, { files: e.rejectedFiles });
  }
}, Eg = {
  files: (e, n, t) => {
    e.acceptedFiles = Hn(n), Jm.accept(e), t && (e.rejectedFiles = Hn(t), Jm.reject(e)), Jm.change(e);
  }
};
nn()([
  "accept",
  "allowDrop",
  "capture",
  "dir",
  "directory",
  "disabled",
  "getRootNode",
  "id",
  "ids",
  "locale",
  "maxFiles",
  "maxFileSize",
  "minFileSize",
  "name",
  "onFileAccept",
  "onFileReject",
  "onFileChange",
  "translations",
  "validate"
]);
nn()(["file"]);
const d5 = (e = {}) => {
  const { getRootNode: n } = Jr(), { dir: t } = ko(), r = {
    id: gr(),
    dir: t,
    getRootNode: n,
    ...e
  }, o = {
    ...r,
    onFileAccept: en(e.onFileAccept),
    onFileReject: en(e.onFileReject),
    onFileChange: en(e.onFileChange, { sync: !0 })
  }, [a, l] = Or(u5(r), { context: o });
  return c5(a, l, yr);
}, fx = oe((e, n) => {
  const [t, r] = Ft()(e, [
    "accept",
    "allowDrop",
    "capture",
    "directory",
    "disabled",
    "id",
    "ids",
    "locale",
    "maxFiles",
    "maxFileSize",
    "minFileSize",
    "name",
    "onFileAccept",
    "onFileChange",
    "onFileReject",
    "translations",
    "validate"
  ]), o = d5(t), a = be(o.getRootProps(), r);
  return /* @__PURE__ */ I.jsx(Yj, { value: o, children: /* @__PURE__ */ I.jsx(ve.div, { ...a, ref: n }) });
});
fx.displayName = "FileUploadRoot";
const gx = oe(
  (e, n) => {
    const t = La(), r = be(t.getTriggerProps(), e);
    return /* @__PURE__ */ I.jsx(ve.button, { ...r, ref: n });
  }
);
gx.displayName = "FileUploadTrigger";
const [f5, gu] = xt({
  name: "MenuContext",
  hookName: "useMenuContext",
  providerName: "<MenuProvider />",
  strict: !1
}), [g5, NY] = xt({
  name: "MenuItemContext",
  hookName: "useMenuItemContext",
  providerName: "<MenuItemProvider />"
}), px = oe((e, n) => {
  const t = gu(), r = oa(), o = be(t.getContentProps(), r.getPresenceProps(n), e);
  return r.unmounted ? null : /* @__PURE__ */ I.jsx(ve.div, { ...o });
});
px.displayName = "MenuContent";
const hx = oe((e, n) => {
  const [t, r] = Ft()(e, [
    "closeOnSelect",
    "disabled",
    "value",
    "valueText"
  ]), o = gu(), a = be(o.getItemProps(t), r), l = o.getItemState(t);
  return /* @__PURE__ */ I.jsx(g5, { value: l, children: /* @__PURE__ */ I.jsx(ve.div, { ...a, ref: n }) });
});
hx.displayName = "MenuItem";
const [p5, h5] = xt({
  name: "MenuItemGroupContext",
  hookName: "useMenuItemGroupContext",
  providerName: "<MenuItemGroupProvider />"
}), mx = oe((e, n) => {
  const [t, r] = Ft()(e, [
    "id"
  ]), o = gu(), l = { id: gr(), ...t }, u = be(o.getItemGroupProps(l), r);
  return /* @__PURE__ */ I.jsx(p5, { value: l, children: /* @__PURE__ */ I.jsx(ve.div, { ...u, ref: n }) });
});
mx.displayName = "MenuItemGroup";
const vx = oe(
  (e, n) => {
    const t = gu(), r = h5(), o = be(t.getItemGroupLabelProps({ htmlFor: r.id }), e);
    return /* @__PURE__ */ I.jsx(ve.div, { ...o, ref: n });
  }
);
vx.displayName = "MenuItemGroupLabel";
const bx = oe((e, n) => {
  const t = gu(), r = be(t.getPositionerProps(), e);
  return oa().unmounted ? null : /* @__PURE__ */ I.jsx(ve.div, { ...r, ref: n });
});
bx.displayName = "MenuPositioner";
const m5 = (e) => {
  const n = Fa(e), t = Fa(!1);
  ra(() => {
    n.current = e;
  }), ra(() => {
    t.current !== !0 && (t.current = !0, n.current());
  }, []);
};
var th = (e, n = []) => ({
  parts: (...t) => {
    if (v5(n))
      return th(e, t);
    throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
  },
  extendWith: (...t) => th(e, [...n, ...t]),
  rename: (t) => th(t, n),
  keys: () => n,
  build: () => [...new Set(n)].reduce(
    (t, r) => Object.assign(t, {
      [r]: {
        selector: [
          `&[data-scope="${df(e)}"][data-part="${df(r)}"]`,
          `& [data-scope="${df(e)}"][data-part="${df(r)}"]`
        ].join(", "),
        attrs: { "data-scope": df(e), "data-part": df(r) }
      }
    }),
    {}
  )
}), df = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), v5 = (e) => e.length === 0, Pg = (e, n) => ({ x: e, y: n });
function b5(e) {
  const { x: n, y: t, width: r, height: o } = e, a = n + r / 2, l = t + o / 2;
  return {
    x: n,
    y: t,
    width: r,
    height: o,
    minX: n,
    minY: t,
    maxX: n + r,
    maxY: t + o,
    midX: a,
    midY: l,
    center: Pg(a, l)
  };
}
function y5(e) {
  const n = Pg(e.minX, e.minY), t = Pg(e.maxX, e.minY), r = Pg(e.maxX, e.maxY), o = Pg(e.minX, e.maxY);
  return { top: n, right: t, bottom: r, left: o };
}
function C5(e, n) {
  const t = b5(e), { top: r, right: o, left: a, bottom: l } = y5(t), [u] = n.split("-");
  return {
    top: [a, r, o, l],
    right: [r, o, l, a],
    bottom: [r, a, l, o],
    left: [o, r, a, l]
  }[u];
}
function E5(e, n) {
  const { x: t, y: r } = n;
  let o = !1;
  for (let a = 0, l = e.length - 1; a < e.length; l = a++) {
    const u = e[a].x, f = e[a].y, p = e[l].x, y = e[l].y;
    f > r != y > r && t < (p - u) * (r - f) / (y - f) + u && (o = !o);
  }
  return o;
}
var A5 = th("menu").parts(
  "arrow",
  "arrowTip",
  "content",
  "contextTrigger",
  "indicator",
  "item",
  "itemGroup",
  "itemGroupLabel",
  "itemIndicator",
  "itemText",
  "positioner",
  "separator",
  "trigger",
  "triggerItem"
), _o = A5.build(), st = so({
  getTriggerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.trigger) ?? `menu:${e.id}:trigger`;
  },
  getContextTriggerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.contextTrigger) ?? `menu:${e.id}:ctx-trigger`;
  },
  getContentId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.content) ?? `menu:${e.id}:content`;
  },
  getArrowId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.arrow) ?? `menu:${e.id}:arrow`;
  },
  getPositionerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.positioner) ?? `menu:${e.id}:popper`;
  },
  getGroupId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.group) == null ? void 0 : r.call(t, n)) ?? `menu:${e.id}:group:${n}`;
  },
  getGroupLabelId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.label) == null ? void 0 : r.call(t, n)) ?? `menu:${e.id}:label:${n}`;
  },
  getContentEl: (e) => st.getById(e, st.getContentId(e)),
  getPositionerEl: (e) => st.getById(e, st.getPositionerId(e)),
  getTriggerEl: (e) => st.getById(e, st.getTriggerId(e)),
  getHighlightedItemEl: (e) => e.highlightedValue ? st.getById(e, e.highlightedValue) : null,
  getArrowEl: (e) => st.getById(e, st.getArrowId(e)),
  getElements: (e) => {
    const t = `[role^="menuitem"][data-ownedby=${CSS.escape(st.getContentId(e))}]:not([data-disabled])`;
    return $s(st.getContentEl(e), t);
  },
  getFirstEl: (e) => ZA(st.getElements(e)),
  getLastEl: (e) => Tb(st.getElements(e)),
  getNextEl: (e, n) => BA(st.getElements(e), e.highlightedValue, n ?? e.loopFocus),
  getPrevEl: (e, n) => VA(st.getElements(e), e.highlightedValue, n ?? e.loopFocus),
  getElemByKey: (e, n) => Lg(st.getElements(e), { state: e.typeaheadState, key: n, activeId: e.highlightedValue }),
  isTargetDisabled: (e) => ps(e) && (e.dataset.disabled === "" || e.hasAttribute("disabled")),
  isTriggerItem: (e) => {
    var n;
    return !!((n = e == null ? void 0 : e.getAttribute("role")) != null && n.startsWith("menuitem")) && !!(e != null && e.hasAttribute("aria-controls"));
  },
  getOptionFromItemEl(e) {
    return {
      id: e.id,
      name: e.dataset.name,
      value: e.dataset.value,
      valueText: e.dataset.valueText,
      type: e.dataset.type
    };
  }
});
function S5(e, n, t) {
  const r = e.context.isSubmenu, o = e.context.isTypingAhead, a = e.context.composite, l = e.hasTag("open"), u = Yg({
    ...e.context.positioning,
    placement: e.context.anchorPoint ? "bottom" : e.context.currentPlacement
  });
  function f(w) {
    return {
      disabled: !!w.disabled,
      highlighted: e.context.highlightedValue === w.value
    };
  }
  function p(w) {
    const F = w.valueText ?? w.value;
    return { ...w, id: w.value, valueText: F };
  }
  function y(w) {
    return {
      ...f(p(w)),
      checked: !!w.checked
    };
  }
  function A(w) {
    const { value: F, closeOnSelect: j, valueText: N } = w, D = f(w);
    return t.element({
      ..._o.item.attrs,
      id: F,
      role: "menuitem",
      "aria-disabled": D.disabled,
      "data-disabled": se(D.disabled),
      "data-ownedby": st.getContentId(e.context),
      "data-highlighted": se(D.highlighted),
      "data-valuetext": N,
      onDragStart(k) {
        k.currentTarget.matches("a[href]") && k.preventDefault();
      },
      onPointerMove(k) {
        if (D.disabled || k.pointerType !== "mouse")
          return;
        const z = k.currentTarget;
        D.highlighted || n({ type: "ITEM_POINTERMOVE", id: F, target: z, closeOnSelect: j });
      },
      onPointerLeave(k) {
        if (D.disabled || k.pointerType !== "mouse" || !e.previousEvent.type.includes("POINTER"))
          return;
        const q = k.currentTarget;
        n({ type: "ITEM_POINTERLEAVE", id: F, target: q, closeOnSelect: j });
      },
      onPointerDown(k) {
        if (D.disabled)
          return;
        const z = k.currentTarget;
        n({ type: "ITEM_POINTERDOWN", target: z, id: F, closeOnSelect: j });
      },
      onPointerUp(k) {
        if (Fv(k) || Dv(k) || D.disabled || !rc(k))
          return;
        const z = k.currentTarget;
        n({ type: "ITEM_CLICK", src: "pointerup", target: z, id: F, closeOnSelect: j }), k.pointerType === "touch" && Lv(z);
      },
      onTouchEnd(k) {
        k.preventDefault(), k.stopPropagation();
      }
    });
  }
  return {
    highlightedValue: e.context.highlightedValue,
    open: l,
    setOpen(w) {
      w !== l && n(w ? "OPEN" : "CLOSE");
    },
    setHighlightedValue(w) {
      n({ type: "HIGHLIGHTED.SET", id: w });
    },
    setParent(w) {
      n({ type: "PARENT.SET", value: w, id: w.state.context.id });
    },
    setChild(w) {
      n({ type: "CHILD.SET", value: w, id: w.state.context.id });
    },
    reposition(w = {}) {
      n({ type: "POSITIONING.SET", options: w });
    },
    getContextTriggerProps() {
      return t.element({
        ..._o.contextTrigger.attrs,
        dir: e.context.dir,
        id: st.getContextTriggerId(e.context),
        onPointerDown(w) {
          if (w.pointerType === "mouse")
            return;
          const F = nu(w);
          n({ type: "CONTEXT_MENU_START", point: F });
        },
        onPointerCancel(w) {
          w.pointerType !== "mouse" && n("CONTEXT_MENU_CANCEL");
        },
        onPointerMove(w) {
          w.pointerType !== "mouse" && n("CONTEXT_MENU_CANCEL");
        },
        onPointerUp(w) {
          w.pointerType !== "mouse" && n("CONTEXT_MENU_CANCEL");
        },
        onContextMenu(w) {
          const F = nu(w);
          n({ type: "CONTEXT_MENU", point: F }), w.preventDefault();
        },
        style: {
          WebkitTouchCallout: "none",
          userSelect: "none"
        }
      });
    },
    getTriggerItemProps(w) {
      return be(
        A({ value: w.getTriggerProps().id }),
        w.getTriggerProps()
      );
    },
    getTriggerProps() {
      return t.button({
        ...r ? _o.triggerItem.attrs : _o.trigger.attrs,
        "data-placement": e.context.currentPlacement,
        type: "button",
        dir: e.context.dir,
        id: st.getTriggerId(e.context),
        "data-uid": e.context.id,
        "aria-haspopup": a ? "menu" : "dialog",
        "aria-controls": st.getContentId(e.context),
        "aria-expanded": l || void 0,
        "data-state": l ? "open" : "closed",
        onPointerMove(w) {
          w.pointerType !== "mouse" || st.isTargetDisabled(w.currentTarget) || !r || n({ type: "TRIGGER_POINTERMOVE", target: w.currentTarget });
        },
        onPointerLeave(w) {
          if (w.pointerType !== "mouse" || st.isTargetDisabled(w.currentTarget) || !r)
            return;
          const j = nu(w);
          n({ type: "TRIGGER_POINTERLEAVE", target: w.currentTarget, point: j });
        },
        onClick(w) {
          st.isTriggerItem(w.currentTarget) && n({ type: "TRIGGER_CLICK", target: w.currentTarget });
        },
        onPointerDown(w) {
          const F = st.isTargetDisabled(w.currentTarget);
          !rc(w) || F || xb(w) || (w.preventDefault(), st.isTriggerItem(w.currentTarget) || n({ type: "TRIGGER_CLICK", target: w.currentTarget }));
        },
        onBlur() {
          n("TRIGGER_BLUR");
        },
        onFocus() {
          n("TRIGGER_FOCUS");
        },
        onKeyDown(w) {
          if (w.defaultPrevented)
            return;
          const F = {
            ArrowDown() {
              n("ARROW_DOWN");
            },
            ArrowUp() {
              n("ARROW_UP");
            },
            Enter() {
              n({ type: "ARROW_DOWN", src: "enter" });
            },
            Space() {
              n({ type: "ARROW_DOWN", src: "space" });
            }
          }, j = il(w, e.context), N = F[j];
          N && (w.preventDefault(), N(w));
        }
      });
    },
    getIndicatorProps() {
      return t.element({
        ..._o.indicator.attrs,
        dir: e.context.dir,
        "data-state": l ? "open" : "closed"
      });
    },
    getPositionerProps() {
      return t.element({
        ..._o.positioner.attrs,
        dir: e.context.dir,
        id: st.getPositionerId(e.context),
        style: u.floating
      });
    },
    getArrowProps() {
      return t.element({
        id: st.getArrowId(e.context),
        ..._o.arrow.attrs,
        dir: e.context.dir,
        style: u.arrow
      });
    },
    getArrowTipProps() {
      return t.element({
        ..._o.arrowTip.attrs,
        dir: e.context.dir,
        style: u.arrowTip
      });
    },
    getContentProps() {
      return t.element({
        ..._o.content.attrs,
        id: st.getContentId(e.context),
        "aria-label": e.context["aria-label"],
        hidden: !l,
        "data-state": l ? "open" : "closed",
        role: a ? "menu" : "dialog",
        tabIndex: 0,
        dir: e.context.dir,
        "aria-activedescendant": e.context.highlightedValue ?? void 0,
        "aria-labelledby": st.getTriggerId(e.context),
        "data-placement": e.context.currentPlacement,
        onPointerEnter(w) {
          w.pointerType === "mouse" && n("MENU_POINTERENTER");
        },
        onKeyDown(w) {
          if (w.defaultPrevented || !pb(w))
            return;
          const F = ou(w);
          if (!((F == null ? void 0 : F.closest("[role=menu]")) === w.currentTarget || F === w.currentTarget))
            return;
          if (w.key === "Tab" && !HA(w)) {
            w.preventDefault();
            return;
          }
          const N = st.getHighlightedItemEl(e.context), D = {
            ArrowDown() {
              n("ARROW_DOWN");
            },
            ArrowUp() {
              n("ARROW_UP");
            },
            ArrowLeft() {
              n("ARROW_LEFT");
            },
            ArrowRight() {
              n("ARROW_RIGHT");
            },
            Enter() {
              n("ENTER"), Lv(N);
            },
            Space(q) {
              var Ce;
              o ? n({ type: "TYPEAHEAD", key: q.key }) : (Ce = D.Enter) == null || Ce.call(D, q);
            },
            Home() {
              n("HOME");
            },
            End() {
              n("END");
            }
          }, k = il(w, { dir: e.context.dir }), z = D[k];
          if (z) {
            z(w), w.stopPropagation(), w.preventDefault();
            return;
          }
          e.context.typeahead && TD(w) && (Mv(w) || Eb(F) || (n({ type: "TYPEAHEAD", key: w.key }), w.preventDefault()));
        }
      });
    },
    getSeparatorProps() {
      return t.element({
        ..._o.separator.attrs,
        role: "separator",
        dir: e.context.dir,
        "aria-orientation": "horizontal"
      });
    },
    getItemState: f,
    getItemProps: A,
    getOptionItemState: y,
    getOptionItemProps(w) {
      const { type: F, disabled: j, onCheckedChange: N, closeOnSelect: D } = w, k = p(w), z = y(w);
      return {
        ...A(k),
        ...t.element({
          "data-type": F,
          ..._o.item.attrs,
          dir: e.context.dir,
          "data-value": k.value,
          role: `menuitem${F}`,
          "aria-checked": !!z.checked,
          "data-state": z.checked ? "checked" : "unchecked",
          onPointerUp(q) {
            if (!rc(q) || j || Fv(q) || Dv(q))
              return;
            const Ce = q.currentTarget;
            n({ type: "ITEM_CLICK", src: "pointerup", target: Ce, option: k, closeOnSelect: D }), N == null || N(!z.checked);
          }
        })
      };
    },
    getItemIndicatorProps(w) {
      const F = y(w);
      return t.element({
        ..._o.itemIndicator.attrs,
        dir: e.context.dir,
        "data-disabled": se(F.disabled),
        "data-highlighted": se(F.highlighted),
        "data-state": F.checked ? "checked" : "unchecked",
        hidden: !F.checked
      });
    },
    getItemTextProps(w) {
      const F = y(w);
      return t.element({
        ..._o.itemText.attrs,
        dir: e.context.dir,
        "data-disabled": se(F.disabled),
        "data-highlighted": se(F.highlighted),
        "data-state": F.checked ? "checked" : "unchecked"
      });
    },
    getItemGroupLabelProps(w) {
      return t.element({
        id: st.getGroupLabelId(e.context, w.htmlFor),
        dir: e.context.dir,
        ..._o.itemGroupLabel.attrs
      });
    },
    getItemGroupProps(w) {
      return t.element({
        id: st.getGroupId(e.context, w.id),
        ..._o.itemGroup.attrs,
        dir: e.context.dir,
        "aria-labelledby": st.getGroupLabelId(e.context, w.id),
        role: "group"
      });
    }
  };
}
var { not: Oa, and: od, or: w5 } = Ma;
function I5(e) {
  const n = br(e);
  return Rr(
    {
      id: "menu",
      initial: n.open ? "open" : "idle",
      context: {
        highlightedValue: null,
        loopFocus: !1,
        anchorPoint: null,
        closeOnSelect: !0,
        typeahead: !0,
        composite: !0,
        ...n,
        positioning: {
          placement: "bottom-start",
          gutter: 8,
          ...n.positioning
        },
        intentPolygon: null,
        parent: null,
        lastHighlightedValue: null,
        children: ZD(Hn({})),
        suspendPointer: !1,
        restoreFocus: !0,
        typeaheadState: Lg.defaultOptions
      },
      computed: {
        isSubmenu: (t) => t.parent !== null,
        isRtl: (t) => t.dir === "rtl",
        isTypingAhead: (t) => t.typeaheadState.keysSoFar !== ""
      },
      watch: {
        isSubmenu: "setSubmenuPlacement",
        anchorPoint: "reposition",
        open: "toggleVisibility"
      },
      on: {
        "PARENT.SET": {
          actions: "setParentMenu"
        },
        "CHILD.SET": {
          actions: "setChildMenu"
        },
        OPEN: [
          {
            guard: "isOpenControlled",
            actions: "invokeOnOpen"
          },
          {
            target: "open",
            actions: "invokeOnOpen"
          }
        ],
        OPEN_AUTOFOCUS: [
          {
            guard: "isOpenControlled",
            actions: ["invokeOnOpen"]
          },
          {
            internal: !0,
            target: "open",
            actions: ["highlightFirstItem", "invokeOnOpen"]
          }
        ],
        CLOSE: [
          {
            guard: "isOpenControlled",
            actions: "invokeOnClose"
          },
          {
            target: "closed",
            actions: "invokeOnClose"
          }
        ],
        "HIGHLIGHTED.RESTORE": {
          actions: "restoreHighlightedItem"
        },
        "HIGHLIGHTED.SET": {
          actions: "setHighlightedItem"
        }
      },
      states: {
        idle: {
          tags: ["closed"],
          on: {
            "CONTROLLED.OPEN": "open",
            "CONTROLLED.CLOSE": "closed",
            CONTEXT_MENU_START: {
              target: "opening:contextmenu",
              actions: "setAnchorPoint"
            },
            CONTEXT_MENU: [
              {
                guard: "isOpenControlled",
                actions: ["setAnchorPoint", "invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["setAnchorPoint", "invokeOnOpen"]
              }
            ],
            TRIGGER_CLICK: [
              {
                guard: "isOpenControlled",
                actions: "invokeOnOpen"
              },
              {
                target: "open",
                actions: "invokeOnOpen"
              }
            ],
            TRIGGER_FOCUS: {
              guard: Oa("isSubmenu"),
              target: "closed"
            },
            TRIGGER_POINTERMOVE: {
              guard: "isSubmenu",
              target: "opening"
            }
          }
        },
        "opening:contextmenu": {
          tags: ["closed"],
          after: {
            LONG_PRESS_DELAY: [
              {
                guard: "isOpenControlled",
                actions: "invokeOnOpen"
              },
              {
                target: "open",
                actions: "invokeOnOpen"
              }
            ]
          },
          on: {
            "CONTROLLED.OPEN": "open",
            "CONTROLLED.CLOSE": "closed",
            CONTEXT_MENU_CANCEL: [
              {
                guard: "isOpenControlled",
                actions: "invokeOnClose"
              },
              {
                target: "closed",
                actions: "invokeOnClose"
              }
            ]
          }
        },
        opening: {
          tags: ["closed"],
          after: {
            SUBMENU_OPEN_DELAY: [
              {
                guard: "isOpenControlled",
                actions: "invokeOnOpen"
              },
              {
                target: "open",
                actions: "invokeOnOpen"
              }
            ]
          },
          on: {
            "CONTROLLED.OPEN": "open",
            "CONTROLLED.CLOSE": "closed",
            BLUR: [
              {
                guard: "isOpenControlled",
                actions: "invokeOnClose"
              },
              {
                target: "closed",
                actions: "invokeOnClose"
              }
            ],
            TRIGGER_POINTERLEAVE: [
              {
                guard: "isOpenControlled",
                actions: "invokeOnClose"
              },
              {
                target: "closed",
                actions: "invokeOnClose"
              }
            ]
          }
        },
        closing: {
          tags: ["open"],
          activities: ["trackPointerMove", "trackInteractOutside"],
          after: {
            SUBMENU_CLOSE_DELAY: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnClose"]
              },
              {
                target: "closed",
                actions: ["focusParentMenu", "restoreParentHiglightedItem", "invokeOnClose"]
              }
            ]
          },
          on: {
            "CONTROLLED.OPEN": "open",
            "CONTROLLED.CLOSE": {
              target: "closed",
              actions: ["focusParentMenu", "restoreParentHiglightedItem"]
            },
            // don't invoke on open here since the menu is still open (we're only keeping it open)
            MENU_POINTERENTER: {
              target: "open",
              actions: "clearIntentPolygon"
            },
            POINTER_MOVED_AWAY_FROM_SUBMENU: [
              {
                guard: "isOpenControlled",
                actions: "invokeOnClose"
              },
              {
                target: "closed",
                actions: ["focusParentMenu", "restoreParentHiglightedItem"]
              }
            ]
          }
        },
        closed: {
          tags: ["closed"],
          entry: ["clearHighlightedItem", "focusTrigger", "clearAnchorPoint", "resumePointer"],
          on: {
            "CONTROLLED.OPEN": [
              {
                guard: w5("isOpenAutoFocusEvent", "isArrowDownEvent"),
                target: "open",
                actions: "highlightFirstItem"
              },
              {
                guard: "isArrowUpEvent",
                target: "open",
                actions: "highlightLastItem"
              },
              {
                target: "open"
              }
            ],
            CONTEXT_MENU_START: {
              target: "opening:contextmenu",
              actions: "setAnchorPoint"
            },
            CONTEXT_MENU: [
              {
                guard: "isOpenControlled",
                actions: ["setAnchorPoint", "invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["setAnchorPoint", "invokeOnOpen"]
              }
            ],
            TRIGGER_CLICK: [
              {
                guard: "isOpenControlled",
                actions: "invokeOnOpen"
              },
              {
                target: "open",
                actions: "invokeOnOpen"
              }
            ],
            TRIGGER_POINTERMOVE: {
              guard: "isTriggerItem",
              target: "opening"
            },
            TRIGGER_BLUR: "idle",
            ARROW_DOWN: [
              {
                guard: "isOpenControlled",
                actions: "invokeOnOpen"
              },
              {
                target: "open",
                actions: ["highlightFirstItem", "invokeOnOpen"]
              }
            ],
            ARROW_UP: [
              {
                guard: "isOpenControlled",
                actions: "invokeOnOpen"
              },
              {
                target: "open",
                actions: ["highlightLastItem", "invokeOnOpen"]
              }
            ]
          }
        },
        open: {
          tags: ["open"],
          activities: ["trackInteractOutside", "trackPositioning", "scrollToHighlightedItem"],
          entry: ["focusMenu", "resumePointer"],
          on: {
            "CONTROLLED.CLOSE": [
              {
                target: "closed",
                guard: "isArrowLeftEvent",
                actions: ["focusParentMenu"]
              },
              {
                target: "closed"
              }
            ],
            TRIGGER_CLICK: [
              {
                guard: od(Oa("isTriggerItem"), "isOpenControlled"),
                actions: "invokeOnClose"
              },
              {
                guard: Oa("isTriggerItem"),
                target: "closed",
                actions: "invokeOnClose"
              }
            ],
            ARROW_UP: {
              actions: ["highlightPrevItem", "focusMenu"]
            },
            ARROW_DOWN: {
              actions: ["highlightNextItem", "focusMenu"]
            },
            ARROW_LEFT: [
              {
                guard: od("isSubmenu", "isOpenControlled"),
                actions: "invokeOnClose"
              },
              {
                guard: "isSubmenu",
                target: "closed",
                actions: ["focusParentMenu", "invokeOnClose"]
              }
            ],
            HOME: {
              actions: ["highlightFirstItem", "focusMenu"]
            },
            END: {
              actions: ["highlightLastItem", "focusMenu"]
            },
            ARROW_RIGHT: {
              guard: "isTriggerItemHighlighted",
              actions: "openSubmenu"
            },
            ENTER: [
              {
                guard: "isTriggerItemHighlighted",
                actions: "openSubmenu"
              },
              // == grouped ==
              {
                guard: od("closeOnSelect", "isOpenControlled"),
                actions: ["clickHighlightedItem", "invokeOnClose"]
              },
              {
                guard: "closeOnSelect",
                target: "closed",
                actions: "clickHighlightedItem"
              },
              //
              {
                actions: "clickHighlightedItem"
              }
            ],
            ITEM_POINTERMOVE: [
              {
                guard: Oa("suspendPointer"),
                actions: ["setHighlightedItem", "focusMenu"]
              },
              {
                actions: "setLastHighlightedItem"
              }
            ],
            ITEM_POINTERLEAVE: {
              guard: od(Oa("suspendPointer"), Oa("isTriggerItem")),
              actions: "clearHighlightedItem"
            },
            ITEM_CLICK: [
              // == grouped ==
              {
                guard: od(
                  Oa("isTriggerItemHighlighted"),
                  Oa("isHighlightedItemEditable"),
                  "closeOnSelect",
                  "isOpenControlled"
                ),
                actions: ["invokeOnSelect", "setOptionState", "closeRootMenu", "invokeOnClose"]
              },
              {
                guard: od(Oa("isTriggerItemHighlighted"), Oa("isHighlightedItemEditable"), "closeOnSelect"),
                target: "closed",
                actions: ["invokeOnSelect", "setOptionState", "closeRootMenu", "invokeOnClose"]
              },
              //
              {
                guard: od(Oa("isTriggerItemHighlighted"), Oa("isHighlightedItemEditable")),
                actions: ["invokeOnSelect", "setOptionState"]
              },
              { actions: "setHighlightedItem" }
            ],
            TRIGGER_POINTERLEAVE: {
              target: "closing",
              actions: "setIntentPolygon"
            },
            ITEM_POINTERDOWN: {
              actions: "setHighlightedItem"
            },
            TYPEAHEAD: {
              actions: "highlightMatchedItem"
            },
            FOCUS_MENU: {
              actions: "focusMenu"
            },
            "POSITIONING.SET": {
              actions: "reposition"
            }
          }
        }
      }
    },
    {
      delays: {
        LONG_PRESS_DELAY: 700,
        SUBMENU_OPEN_DELAY: 100,
        SUBMENU_CLOSE_DELAY: 100
      },
      guards: {
        closeOnSelect: (t, r) => !!((r == null ? void 0 : r.closeOnSelect) ?? t.closeOnSelect),
        // whether the trigger is also a menu item
        isTriggerItem: (t, r) => st.isTriggerItem(r.target),
        // whether the trigger item is the active item
        isTriggerItemHighlighted: (t, r) => {
          const o = r.target ?? st.getHighlightedItemEl(t);
          return !!(o != null && o.hasAttribute("aria-controls"));
        },
        isSubmenu: (t) => t.isSubmenu,
        suspendPointer: (t) => t.suspendPointer,
        isHighlightedItemEditable: (t) => Eb(st.getHighlightedItemEl(t)),
        isWithinPolygon: (t, r) => t.intentPolygon ? E5(t.intentPolygon, r.point) : !1,
        // guard assertions (for controlled mode)
        isOpenControlled: (t) => !!t["open.controlled"],
        isArrowLeftEvent: (t, r) => {
          var o;
          return ((o = r.previousEvent) == null ? void 0 : o.type) === "ARROW_LEFT";
        },
        isArrowUpEvent: (t, r) => {
          var o;
          return ((o = r.previousEvent) == null ? void 0 : o.type) === "ARROW_UP";
        },
        isArrowDownEvent: (t, r) => {
          var o;
          return ((o = r.previousEvent) == null ? void 0 : o.type) === "ARROW_DOWN";
        },
        isOpenAutoFocusEvent: (t, r) => {
          var o;
          return ((o = r.previousEvent) == null ? void 0 : o.type) === "OPEN_AUTOFOCUS";
        }
      },
      activities: {
        trackPositioning(t) {
          if (t.anchorPoint)
            return;
          t.currentPlacement = t.positioning.placement;
          const r = () => st.getPositionerEl(t);
          return uu(st.getTriggerEl(t), r, {
            ...t.positioning,
            defer: !0,
            onComplete(o) {
              t.currentPlacement = o.placement;
            }
          });
        },
        trackInteractOutside(t, r, { send: o }) {
          return Uf(() => st.getContentEl(t), {
            defer: !0,
            exclude: [st.getTriggerEl(t)],
            onInteractOutside: t.onInteractOutside,
            onFocusOutside: t.onFocusOutside,
            onEscapeKeyDown(l) {
              var u;
              (u = t.onEscapeKeyDown) == null || u.call(t, l), t.isSubmenu && l.preventDefault(), MC(t);
            },
            onPointerDownOutside(l) {
              var u;
              t.restoreFocus = !l.detail.focusable, (u = t.onPointerDownOutside) == null || u.call(t, l);
            },
            onDismiss() {
              o({ type: "CLOSE", src: "interact-outside" });
            }
          });
        },
        trackPointerMove(t, r, { guards: o, send: a }) {
          const { isWithinPolygon: l } = o;
          t.parent.state.context.suspendPointer = !0;
          const u = st.getDoc(t);
          return Dn(u, "pointermove", (f) => {
            const p = { x: f.clientX, y: f.clientY };
            l(t, { point: p }) || (a("POINTER_MOVED_AWAY_FROM_SUBMENU"), t.parent.state.context.suspendPointer = !1);
          });
        },
        scrollToHighlightedItem(t, r, { getState: o }) {
          const a = () => {
            if (o().event.type.startsWith("ITEM_POINTER"))
              return;
            const f = st.getHighlightedItemEl(t), p = st.getContentEl(t);
            wb(f, { rootEl: p, block: "nearest" });
          };
          return Ct(() => a()), Dh(() => st.getContentEl(t), {
            defer: !0,
            attributes: ["aria-activedescendant"],
            callback: a
          });
        }
      },
      actions: {
        setAnchorPoint(t, r) {
          t.anchorPoint = r.point;
        },
        clearAnchorPoint(t) {
          t.anchorPoint = null;
        },
        setSubmenuPlacement(t) {
          t.isSubmenu && (t.positioning.placement = t.isRtl ? "left-start" : "right-start", t.positioning.gutter = 0);
        },
        reposition(t, r) {
          const o = () => st.getPositionerEl(t), a = t.anchorPoint ? () => ({ width: 0, height: 0, ...t.anchorPoint }) : void 0;
          uu(st.getTriggerEl(t), o, {
            ...t.positioning,
            getAnchorRect: a,
            ...r.options ?? {},
            listeners: !1,
            onComplete(l) {
              t.currentPlacement = l.placement;
            }
          });
        },
        setOptionState(t, r) {
          if (!r.option)
            return;
          const { checked: o, onCheckedChange: a, type: l } = r.option;
          l === "radio" ? a == null || a(!0) : l === "checkbox" && (a == null || a(!o));
        },
        clickHighlightedItem(t, r, { send: o }) {
          const a = st.getHighlightedItemEl(t);
          if (!a || a.dataset.disabled)
            return;
          const l = st.getOptionFromItemEl(a);
          o({
            type: "ITEM_CLICK",
            src: "enter",
            target: a,
            id: l.id,
            option: l,
            closeOnSelect: t.closeOnSelect
          });
        },
        setIntentPolygon(t, r) {
          const o = st.getContentEl(t), a = t.currentPlacement;
          if (!o || !a)
            return;
          const l = o.getBoundingClientRect(), u = C5(l, a);
          if (!u)
            return;
          const p = lB(a) === "right" ? -5 : 5;
          t.intentPolygon = [{ ...r.point, x: r.point.x + p }, ...u];
        },
        clearIntentPolygon(t) {
          t.intentPolygon = null;
        },
        resumePointer(t) {
          t.parent && (t.parent.state.context.suspendPointer = !1);
        },
        setHighlightedItem(t, r) {
          Qc.highlighted(t, r.id);
        },
        clearHighlightedItem(t) {
          Qc.highlighted(t, null);
        },
        focusMenu(t) {
          Ct(() => {
            const r = st.getContentEl(t);
            if (ol(r, st.getActiveElement(t)))
              return;
            const o = WA(r, !1) || r;
            o == null || o.focus({ preventScroll: !0 });
          });
        },
        highlightFirstItem(t) {
          const r = st.getFirstEl(t);
          r && Qc.highlighted(t, r.id);
        },
        highlightLastItem(t) {
          const r = st.getLastEl(t);
          r && Qc.highlighted(t, r.id);
        },
        highlightNextItem(t, r) {
          const o = st.getNextEl(t, r.loop);
          Qc.highlighted(t, (o == null ? void 0 : o.id) ?? null);
        },
        highlightPrevItem(t, r) {
          const o = st.getPrevEl(t, r.loop);
          Qc.highlighted(t, (o == null ? void 0 : o.id) ?? null);
        },
        invokeOnSelect(t) {
          var r;
          t.highlightedValue && ((r = t.onSelect) == null || r.call(t, { value: t.highlightedValue }));
        },
        focusTrigger(t) {
          t.isSubmenu || t.anchorPoint || !t.restoreFocus || Ct(() => {
            var r;
            return (r = st.getTriggerEl(t)) == null ? void 0 : r.focus({ preventScroll: !0 });
          });
        },
        highlightMatchedItem(t, r) {
          const o = st.getElemByKey(t, r.key);
          o && Qc.highlighted(t, o.id);
        },
        setParentMenu(t, r) {
          t.parent = Hn(r.value);
        },
        setChildMenu(t, r) {
          t.children[r.id] = Hn(r.value);
        },
        closeRootMenu(t) {
          MC(t);
        },
        openSubmenu(t) {
          const r = st.getHighlightedItemEl(t), o = r == null ? void 0 : r.getAttribute("data-uid"), a = o ? t.children[o] : null;
          a == null || a.send("OPEN_AUTOFOCUS");
        },
        focusParentMenu(t) {
          var r;
          (r = t.parent) == null || r.send("FOCUS_MENU");
        },
        setLastHighlightedItem(t, r) {
          t.lastHighlightedValue = r.id;
        },
        restoreHighlightedItem(t) {
          t.lastHighlightedValue && (Qc.highlighted(t, t.lastHighlightedValue), t.lastHighlightedValue = null);
        },
        restoreParentHiglightedItem(t) {
          var r;
          (r = t.parent) == null || r.send("HIGHLIGHTED.RESTORE");
        },
        invokeOnOpen(t) {
          var r;
          (r = t.onOpenChange) == null || r.call(t, { open: !0 });
        },
        invokeOnClose(t) {
          var r;
          (r = t.onOpenChange) == null || r.call(t, { open: !1 });
        },
        toggleVisibility(t, r, { send: o }) {
          o({ type: t.open ? "CONTROLLED.OPEN" : "CONTROLLED.CLOSE", previousEvent: r });
        }
      }
    }
  );
}
function MC(e) {
  let n = e.parent;
  for (; n && n.state.context.isSubmenu; )
    n = n.state.context.parent;
  n == null || n.send("CLOSE");
}
var Qc = {
  highlighted(e, n) {
    var t;
    vr(e.highlightedValue, n) || (e.highlightedValue = n, (t = e.onHighlightChange) == null || t.call(e, { highlightedValue: n }));
  }
};
nn()([
  "anchorPoint",
  "aria-label",
  "closeOnSelect",
  "dir",
  "getRootNode",
  "highlightedValue",
  "id",
  "ids",
  "loopFocus",
  "onFocusOutside",
  "onInteractOutside",
  "onOpenChange",
  "onPointerDownOutside",
  "onEscapeKeyDown",
  "onSelect",
  "onHighlightChange",
  "open",
  "open.controlled",
  "positioning",
  "typeahead",
  "composite"
]);
nn()(["closeOnSelect", "disabled", "value", "valueText"]);
nn()(["htmlFor"]);
nn()(["id"]);
nn()([
  "disabled",
  "valueText",
  "closeOnSelect",
  "type",
  "value",
  "checked",
  "onCheckedChange"
]);
const x5 = (e = {}) => {
  const { getRootNode: n } = Jr(), { dir: t } = ko(), r = {
    id: gr(),
    dir: t,
    getRootNode: n,
    open: e.defaultOpen,
    "open.controlled": e.open !== void 0,
    ...e
  }, o = {
    ...r,
    onOpenChange: en(e.onOpenChange),
    onSelect: en(e.onSelect)
  }, [a, l, u] = Or(I5(r), { context: o });
  return { api: S5(a, l, yr), machine: u };
}, [T5, P5] = xt({
  name: "MenuMachineContext",
  hookName: "useMenuMachineContext",
  providerName: "<MenuMachineProvider />",
  strict: !1
}), [k5, R5] = xt({
  name: "MenuMachineContext",
  hookName: "useMenuMachineContext",
  providerName: "<MenuMachineProvider />",
  strict: !1
}), O5 = (e) => {
  const [n, t] = fu(e), [r, o] = Ft()(t, [
    "anchorPoint",
    "aria-label",
    "closeOnSelect",
    "composite",
    "defaultOpen",
    "highlightedValue",
    "id",
    "ids",
    "loopFocus",
    "onEscapeKeyDown",
    "onFocusOutside",
    "onHighlightChange",
    "onInteractOutside",
    "onOpenChange",
    "onPointerDownOutside",
    "onSelect",
    "open",
    "positioning",
    "typeahead"
  ]), a = gu(), l = P5(), { api: u, machine: f } = x5(r), p = cc(be({ present: u.open }, n));
  m5(() => {
    l && a && (a.setChild(f), u.setParent(l));
  });
  const y = ub(
    () => a == null ? void 0 : a.getTriggerItemProps(u),
    [u, a]
  );
  return /* @__PURE__ */ I.jsx(k5, { value: y, children: /* @__PURE__ */ I.jsx(T5, { value: f, children: /* @__PURE__ */ I.jsx(f5, { value: u, children: /* @__PURE__ */ I.jsx(Ad, { value: p, ...o }) }) }) });
}, yx = oe((e, n) => {
  const t = gu(), r = be(t.getSeparatorProps(), e);
  return /* @__PURE__ */ I.jsx(ve.hr, { ...r, ref: n });
});
yx.displayName = "MenuSeparator";
const Cx = oe((e, n) => {
  const t = gu(), r = oa(), o = be(
    {
      ...t.getTriggerProps(),
      "aria-controls": r.unmounted ? void 0 : t.getTriggerProps()["aria-controls"]
    },
    e
  );
  return /* @__PURE__ */ I.jsx(ve.button, { ...o, ref: n });
});
Cx.displayName = "MenuTrigger";
const Ex = oe((e, n) => {
  const t = R5(), r = be((t == null ? void 0 : t()) ?? {}, e);
  return /* @__PURE__ */ I.jsx(ve.div, { ...r, ref: n });
});
Ex.displayName = "MenuTriggerItem";
const [D5, Xg] = xt({
  name: "NumberInputContext",
  hookName: "useNumberInputContext",
  providerName: "<NumberInputProvider />"
}), Ax = oe(
  (e, n) => {
    const t = Xg(), r = be(t.getControlProps(), e);
    return /* @__PURE__ */ I.jsx(ve.div, { ...r, ref: n });
  }
);
Ax.displayName = "NumberInputControl";
const Sx = oe((e, n) => {
  const t = Xg(), r = be(t.getDecrementTriggerProps(), e);
  return /* @__PURE__ */ I.jsx(ve.button, { ...r, ref: n });
});
Sx.displayName = "NumberInputDecrementTrigger";
const wx = oe((e, n) => {
  const t = Xg(), r = be(t.getIncrementTriggerProps(), e);
  return /* @__PURE__ */ I.jsx(ve.button, { ...r, ref: n });
});
wx.displayName = "NumberInputIncrementTrigger";
const Ix = oe(
  (e, n) => {
    const t = Xg(), r = be(t.getInputProps(), e);
    return /* @__PURE__ */ I.jsx(ve.input, { ...r, ref: n });
  }
);
Ix.displayName = "NumberInputInput";
const xx = oe(
  (e, n) => {
    const t = Xg(), r = be(t.getLabelProps(), e);
    return /* @__PURE__ */ I.jsx(ve.label, { ...r, ref: n });
  }
);
xx.displayName = "NumberInputLabel";
var nh = (e, n = []) => ({
  parts: (...t) => {
    if (F5(n))
      return nh(e, t);
    throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
  },
  extendWith: (...t) => nh(e, [...n, ...t]),
  rename: (t) => nh(t, n),
  keys: () => n,
  build: () => [...new Set(n)].reduce(
    (t, r) => Object.assign(t, {
      [r]: {
        selector: [
          `&[data-scope="${ff(e)}"][data-part="${ff(r)}"]`,
          `& [data-scope="${ff(e)}"][data-part="${ff(r)}"]`
        ].join(", "),
        attrs: { "data-scope": ff(e), "data-part": ff(r) }
      }
    }),
    {}
  )
}), ff = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), F5 = (e) => e.length === 0;
function N5(e, n) {
  return (e % n + n) % n;
}
function Dg(e) {
  if (typeof window.devicePixelRatio != "number")
    return Math.round(e);
  const n = window.devicePixelRatio;
  return Math.floor(e * n + 0.5) / n;
}
function Sp(e, n) {
  return Math.min(Math.max(yd(e), n.min), n.max);
}
function LC(e) {
  if (!Number.isFinite(e))
    return 0;
  let n = 1, t = 0;
  for (; Math.round(e * n) / n !== e; )
    n *= 10, t += 1;
  return t;
}
var M5 = (e, n) => Tx(yd(e), "+", n), L5 = (e, n) => Tx(yd(e), "-", n);
function yd(e) {
  return Number.isNaN(e) ? 0 : e;
}
function B5(e, n) {
  return yd(e) >= n.max;
}
function V5(e, n) {
  return yd(e) <= n.min;
}
function j5(e, n) {
  return yd(e) >= n.min && yd(e) <= n.max;
}
function Tx(e, n, t) {
  let r = n === "+" ? e + t : e - t;
  if (e % 1 !== 0 || t % 1 !== 0) {
    const o = 10 ** Math.max(LC(e), LC(t));
    e = Math.round(e * o), t = Math.round(t * o), r = n === "+" ? e + t : e - t, r /= o;
  }
  return r;
}
let Qm = /* @__PURE__ */ new Map(), eb = !1;
try {
  eb = new Intl.NumberFormat("de-DE", {
    signDisplay: "exceptZero"
  }).resolvedOptions().signDisplay === "exceptZero";
} catch {
}
let Ih = !1;
try {
  Ih = new Intl.NumberFormat("de-DE", {
    style: "unit",
    unit: "degree"
  }).resolvedOptions().style === "unit";
} catch {
}
const Px = {
  degree: {
    narrow: {
      default: "°",
      "ja-JP": " 度",
      "zh-TW": "度",
      "sl-SI": " °"
    }
  }
};
class U5 {
  /** Formats a number value as a string, according to the locale and options provided to the constructor. */
  format(n) {
    let t = "";
    if (!eb && this.options.signDisplay != null ? t = H5(this.numberFormatter, this.options.signDisplay, n) : t = this.numberFormatter.format(n), this.options.style === "unit" && !Ih) {
      var r;
      let { unit: o, unitDisplay: a = "short", locale: l } = this.resolvedOptions();
      if (!o)
        return t;
      let u = (r = Px[o]) === null || r === void 0 ? void 0 : r[a];
      t += u[l] || u.default;
    }
    return t;
  }
  /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */
  formatToParts(n) {
    return this.numberFormatter.formatToParts(n);
  }
  /** Formats a number range as a string. */
  formatRange(n, t) {
    if (typeof this.numberFormatter.formatRange == "function")
      return this.numberFormatter.formatRange(n, t);
    if (t < n)
      throw new RangeError("End date must be >= start date");
    return `${this.format(n)} – ${this.format(t)}`;
  }
  /** Formats a number range as an array of parts. */
  formatRangeToParts(n, t) {
    if (typeof this.numberFormatter.formatRangeToParts == "function")
      return this.numberFormatter.formatRangeToParts(n, t);
    if (t < n)
      throw new RangeError("End date must be >= start date");
    let r = this.numberFormatter.formatToParts(n), o = this.numberFormatter.formatToParts(t);
    return [
      ...r.map((a) => ({
        ...a,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...o.map((a) => ({
        ...a,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let n = this.numberFormatter.resolvedOptions();
    return !eb && this.options.signDisplay != null && (n = {
      ...n,
      signDisplay: this.options.signDisplay
    }), !Ih && this.options.style === "unit" && (n = {
      ...n,
      style: "unit",
      unit: this.options.unit,
      unitDisplay: this.options.unitDisplay
    }), n;
  }
  constructor(n, t = {}) {
    this.numberFormatter = W5(n, t), this.options = t;
  }
}
function W5(e, n = {}) {
  let { numberingSystem: t } = n;
  if (t && e.includes("-nu-") && (e.includes("-u-") || (e += "-u-"), e += `-nu-${t}`), n.style === "unit" && !Ih) {
    var r;
    let { unit: l, unitDisplay: u = "short" } = n;
    if (!l)
      throw new Error('unit option must be provided with style: "unit"');
    if (!(!((r = Px[l]) === null || r === void 0) && r[u]))
      throw new Error(`Unsupported unit ${l} with unitDisplay = ${u}`);
    n = {
      ...n,
      style: "decimal"
    };
  }
  let o = e + (n ? Object.entries(n).sort((l, u) => l[0] < u[0] ? -1 : 1).join() : "");
  if (Qm.has(o))
    return Qm.get(o);
  let a = new Intl.NumberFormat(e, n);
  return Qm.set(o, a), a;
}
function H5(e, n, t) {
  if (n === "auto")
    return e.format(t);
  if (n === "never")
    return e.format(Math.abs(t));
  {
    let r = !1;
    if (n === "always" ? r = t > 0 || Object.is(t, 0) : n === "exceptZero" && (Object.is(t, -0) || Object.is(t, 0) ? t = Math.abs(t) : r = t > 0), r) {
      let o = e.format(-t), a = e.format(t), l = o.replace(a, "").replace(/\u200e|\u061C/, "");
      return [
        ...l
      ].length !== 1 && console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case"), o.replace(a, "!!!").replace(l, "+").replace("!!!", a);
    } else
      return e.format(t);
  }
}
const G5 = new RegExp("^.*\\(.*\\).*$"), Y5 = [
  "latn",
  "arab",
  "hanidec"
];
class kx {
  /**
  * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
  */
  parse(n) {
    return qm(this.locale, this.options, n).parse(n);
  }
  /**
  * Returns whether the given string could potentially be a valid number. This should be used to
  * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
  * of the minus/plus sign characters can be checked.
  */
  isValidPartialNumber(n, t, r) {
    return qm(this.locale, this.options, n).isValidPartialNumber(n, t, r);
  }
  /**
  * Returns a numbering system for which the given string is valid in the current locale.
  * If no numbering system could be detected, the default numbering system for the current
  * locale is returned.
  */
  getNumberingSystem(n) {
    return qm(this.locale, this.options, n).options.numberingSystem;
  }
  constructor(n, t = {}) {
    this.locale = n, this.options = t;
  }
}
const BC = /* @__PURE__ */ new Map();
function qm(e, n, t) {
  let r = VC(e, n);
  if (!e.includes("-nu-") && !r.isValidPartialNumber(t)) {
    for (let o of Y5)
      if (o !== r.options.numberingSystem) {
        let a = VC(e + (e.includes("-u-") ? "-nu-" : "-u-nu-") + o, n);
        if (a.isValidPartialNumber(t))
          return a;
      }
  }
  return r;
}
function VC(e, n) {
  let t = e + (n ? Object.entries(n).sort((o, a) => o[0] < a[0] ? -1 : 1).join() : ""), r = BC.get(t);
  return r || (r = new z5(e, n), BC.set(t, r)), r;
}
class z5 {
  parse(n) {
    let t = this.sanitize(n);
    if (this.symbols.group && (t = wp(t, this.symbols.group, "")), this.symbols.decimal && (t = t.replace(this.symbols.decimal, ".")), this.symbols.minusSign && (t = t.replace(this.symbols.minusSign, "-")), t = t.replace(this.symbols.numeral, this.symbols.index), this.options.style === "percent") {
      let l = t.indexOf("-");
      t = t.replace("-", "");
      let u = t.indexOf(".");
      u === -1 && (u = t.length), t = t.replace(".", ""), u - 2 === 0 ? t = `0.${t}` : u - 2 === -1 ? t = `0.0${t}` : u - 2 === -2 ? t = "0.00" : t = `${t.slice(0, u - 2)}.${t.slice(u - 2)}`, l > -1 && (t = `-${t}`);
    }
    let r = t ? +t : NaN;
    if (isNaN(r))
      return NaN;
    if (this.options.style === "percent") {
      var o, a;
      let l = {
        ...this.options,
        style: "decimal",
        minimumFractionDigits: Math.min(((o = this.options.minimumFractionDigits) !== null && o !== void 0 ? o : 0) + 2, 20),
        maximumFractionDigits: Math.min(((a = this.options.maximumFractionDigits) !== null && a !== void 0 ? a : 0) + 2, 20)
      };
      return new kx(this.locale, l).parse(new U5(this.locale, l).format(r));
    }
    return this.options.currencySign === "accounting" && G5.test(n) && (r = -1 * r), r;
  }
  sanitize(n) {
    return n = n.replace(this.symbols.literals, ""), this.symbols.minusSign && (n = n.replace("-", this.symbols.minusSign)), this.options.numberingSystem === "arab" && (this.symbols.decimal && (n = n.replace(",", this.symbols.decimal), n = n.replace("،", this.symbols.decimal)), this.symbols.group && (n = wp(n, ".", this.symbols.group))), this.options.locale === "fr-FR" && (n = wp(n, ".", " ")), n;
  }
  isValidPartialNumber(n, t = -1 / 0, r = 1 / 0) {
    return n = this.sanitize(n), this.symbols.minusSign && n.startsWith(this.symbols.minusSign) && t < 0 ? n = n.slice(this.symbols.minusSign.length) : this.symbols.plusSign && n.startsWith(this.symbols.plusSign) && r > 0 && (n = n.slice(this.symbols.plusSign.length)), this.symbols.group && n.startsWith(this.symbols.group) || this.symbols.decimal && n.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0 ? !1 : (this.symbols.group && (n = wp(n, this.symbols.group, "")), n = n.replace(this.symbols.numeral, ""), this.symbols.decimal && (n = n.replace(this.symbols.decimal, "")), n.length === 0);
  }
  constructor(n, t = {}) {
    this.locale = n, this.formatter = new Intl.NumberFormat(n, t), this.options = this.formatter.resolvedOptions(), this.symbols = K5(n, this.formatter, this.options, t);
    var r, o;
    this.options.style === "percent" && (((r = this.options.minimumFractionDigits) !== null && r !== void 0 ? r : 0) > 18 || ((o = this.options.maximumFractionDigits) !== null && o !== void 0 ? o : 0) > 18) && console.warn("NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.");
  }
}
const jC = /* @__PURE__ */ new Set([
  "decimal",
  "fraction",
  "integer",
  "minusSign",
  "plusSign",
  "group"
]), Z5 = [
  0,
  4,
  2,
  1,
  11,
  20,
  3,
  7,
  100,
  21,
  0.1,
  1.1
];
function K5(e, n, t, r) {
  var o, a, l, u;
  let f = new Intl.NumberFormat(e, {
    ...t,
    minimumSignificantDigits: 1,
    maximumSignificantDigits: 21
  }), p = f.formatToParts(-10000.111), y = f.formatToParts(10000.111), A = Z5.map((Se) => f.formatToParts(Se));
  var w;
  let F = (w = (o = p.find((Se) => Se.type === "minusSign")) === null || o === void 0 ? void 0 : o.value) !== null && w !== void 0 ? w : "-", j = (a = y.find((Se) => Se.type === "plusSign")) === null || a === void 0 ? void 0 : a.value;
  !j && ((r == null ? void 0 : r.signDisplay) === "exceptZero" || (r == null ? void 0 : r.signDisplay) === "always") && (j = "+");
  let D = (l = new Intl.NumberFormat(e, {
    ...t,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).formatToParts(1e-3).find((Se) => Se.type === "decimal")) === null || l === void 0 ? void 0 : l.value, k = (u = p.find((Se) => Se.type === "group")) === null || u === void 0 ? void 0 : u.value, z = p.filter((Se) => !jC.has(Se.type)).map((Se) => UC(Se.value)), q = A.flatMap((Se) => Se.filter((we) => !jC.has(we.type)).map((we) => UC(we.value))), Ce = [
    .../* @__PURE__ */ new Set([
      ...z,
      ...q
    ])
  ].sort((Se, we) => we.length - Se.length), ee = Ce.length === 0 ? new RegExp("[\\p{White_Space}]", "gu") : new RegExp(`${Ce.join("|")}|[\\p{White_Space}]`, "gu"), Fe = [
    ...new Intl.NumberFormat(t.locale, {
      useGrouping: !1
    }).format(9876543210)
  ].reverse(), Oe = new Map(Fe.map((Se, we) => [
    Se,
    we
  ])), He = new RegExp(`[${Fe.join("")}]`, "g");
  return {
    minusSign: F,
    plusSign: j,
    decimal: D,
    group: k,
    literals: ee,
    numeral: He,
    index: (Se) => String(Oe.get(Se))
  };
}
function wp(e, n, t) {
  return e.replaceAll ? e.replaceAll(n, t) : e.split(n).join(t);
}
function UC(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
var X5 = nh("numberInput").parts(
  "root",
  "label",
  "input",
  "control",
  "incrementTrigger",
  "decrementTrigger",
  "scrubber"
), id = X5.build(), Nt = so({
  getRootId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.root) ?? `number-input:${e.id}`;
  },
  getInputId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.input) ?? `number-input:${e.id}:input`;
  },
  getIncrementTriggerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.incrementTrigger) ?? `number-input:${e.id}:inc`;
  },
  getDecrementTriggerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.decrementTrigger) ?? `number-input:${e.id}:dec`;
  },
  getScrubberId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.scrubber) ?? `number-input:${e.id}:scrubber`;
  },
  getCursorId: (e) => `number-input:${e.id}:cursor`,
  getLabelId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.label) ?? `number-input:${e.id}:label`;
  },
  getInputEl: (e) => Nt.getById(e, Nt.getInputId(e)),
  getIncrementTriggerEl: (e) => Nt.getById(e, Nt.getIncrementTriggerId(e)),
  getDecrementTriggerEl: (e) => Nt.getById(e, Nt.getDecrementTriggerId(e)),
  getScrubberEl: (e) => Nt.getById(e, Nt.getScrubberId(e)),
  getCursorEl: (e) => Nt.getDoc(e).getElementById(Nt.getCursorId(e)),
  getPressedTriggerEl: (e, n = e.hint) => {
    let t = null;
    return n === "increment" && (t = Nt.getIncrementTriggerEl(e)), n === "decrement" && (t = Nt.getDecrementTriggerEl(e)), t;
  },
  setupVirtualCursor(e) {
    if (!fb())
      return Nt.createVirtualCursor(e), () => {
        var n;
        (n = Nt.getCursorEl(e)) == null || n.remove();
      };
  },
  preventTextSelection(e) {
    const n = Nt.getDoc(e), t = n.documentElement, r = n.body;
    return r.style.pointerEvents = "none", t.style.userSelect = "none", t.style.cursor = "ew-resize", () => {
      r.style.pointerEvents = "", t.style.userSelect = "", t.style.cursor = "", t.style.length || t.removeAttribute("style"), r.style.length || r.removeAttribute("style");
    };
  },
  getMousementValue(e, n) {
    const t = Dg(n.movementX), r = Dg(n.movementY);
    let o = t > 0 ? "increment" : t < 0 ? "decrement" : null;
    e.isRtl && o === "increment" && (o = "decrement"), e.isRtl && o === "decrement" && (o = "increment");
    const a = {
      x: e.scrubberCursorPoint.x + t,
      y: e.scrubberCursorPoint.y + r
    }, u = Nt.getWin(e).innerWidth, f = Dg(7.5);
    return a.x = N5(a.x + f, u) - f, { hint: o, point: a };
  },
  createVirtualCursor(e) {
    const n = Nt.getDoc(e), t = n.createElement("div");
    t.className = "scrubber--cursor", t.id = Nt.getCursorId(e), Object.assign(t.style, {
      width: "15px",
      height: "15px",
      position: "fixed",
      pointerEvents: "none",
      left: "0px",
      top: "0px",
      zIndex: FA,
      transform: e.scrubberCursorPoint ? `translate3d(${e.scrubberCursorPoint.x}px, ${e.scrubberCursorPoint.y}px, 0px)` : void 0,
      willChange: "transform"
    }), t.innerHTML = `
        <svg width="46" height="15" style="left: -15.5px; position: absolute; top: 0; filter: drop-shadow(rgba(0, 0, 0, 0.4) 0px 1px 1.1px);">
          <g transform="translate(2 3)">
            <path fill-rule="evenodd" d="M 15 4.5L 15 2L 11.5 5.5L 15 9L 15 6.5L 31 6.5L 31 9L 34.5 5.5L 31 2L 31 4.5Z" style="stroke-width: 2px; stroke: white;"></path>
            <path fill-rule="evenodd" d="M 15 4.5L 15 2L 11.5 5.5L 15 9L 15 6.5L 31 6.5L 31 9L 34.5 5.5L 31 2L 31 4.5Z"></path>
          </g>
        </svg>`, n.body.appendChild(t);
  }
});
function J5(e, n, t) {
  const r = e.hasTag("focus"), o = e.context.isDisabled, a = e.context.readOnly, l = e.context.isValueEmpty, u = e.context.isOutOfRange || !!e.context.invalid, f = o || !e.context.canIncrement || a, p = o || !e.context.canDecrement || a, y = e.context.translations;
  return {
    focused: r,
    invalid: u,
    empty: l,
    value: e.context.formattedValue,
    valueAsNumber: e.context.valueAsNumber,
    setValue(A) {
      n({ type: "VALUE.SET", value: A });
    },
    clearValue() {
      n("VALUE.CLEAR");
    },
    increment() {
      n("VALUE.INCREMENT");
    },
    decrement() {
      n("VALUE.DECREMENT");
    },
    setToMax() {
      n({ type: "VALUE.SET", value: e.context.max });
    },
    setToMin() {
      n({ type: "VALUE.SET", value: e.context.min });
    },
    focus() {
      var A;
      (A = Nt.getInputEl(e.context)) == null || A.focus();
    },
    getRootProps() {
      return t.element({
        id: Nt.getRootId(e.context),
        ...id.root.attrs,
        dir: e.context.dir,
        "data-disabled": se(o),
        "data-focus": se(r),
        "data-invalid": se(u)
      });
    },
    getLabelProps() {
      return t.label({
        ...id.label.attrs,
        dir: e.context.dir,
        "data-disabled": se(o),
        "data-focus": se(r),
        "data-invalid": se(u),
        id: Nt.getLabelId(e.context),
        htmlFor: Nt.getInputId(e.context)
      });
    },
    getControlProps() {
      return t.element({
        ...id.control.attrs,
        dir: e.context.dir,
        role: "group",
        "aria-disabled": o,
        "data-focus": se(r),
        "data-disabled": se(o),
        "data-invalid": se(u),
        "aria-invalid": Zr(e.context.invalid)
      });
    },
    getInputProps() {
      return t.input({
        ...id.input.attrs,
        dir: e.context.dir,
        name: e.context.name,
        form: e.context.form,
        id: Nt.getInputId(e.context),
        role: "spinbutton",
        defaultValue: e.context.formattedValue,
        pattern: e.context.pattern,
        inputMode: e.context.inputMode,
        "aria-invalid": Zr(u),
        "data-invalid": se(u),
        disabled: o,
        "data-disabled": se(o),
        readOnly: !!e.context.readOnly,
        autoComplete: "off",
        autoCorrect: "off",
        spellCheck: "false",
        type: "text",
        "aria-roledescription": "numberfield",
        "aria-valuemin": e.context.min,
        "aria-valuemax": e.context.max,
        "aria-valuenow": Number.isNaN(e.context.valueAsNumber) ? void 0 : e.context.valueAsNumber,
        "aria-valuetext": e.context.valueText,
        onFocus() {
          n("INPUT.FOCUS");
        },
        onBlur() {
          n({ type: "INPUT.COMMIT", src: "blur" });
        },
        onChange(A) {
          n({ type: "INPUT.CHANGE", target: A.currentTarget, hint: "set" });
        },
        onBeforeInput(A) {
          try {
            const { selectionStart: w, selectionEnd: F, value: j } = A.currentTarget, N = j.slice(0, w) + (A.data ?? "") + j.slice(F);
            e.context.parser.isValidPartialNumber(N) || A.preventDefault();
          } catch {
          }
        },
        onKeyDown(A) {
          if (A.defaultPrevented || a || hb(A))
            return;
          const w = Bv(A) * e.context.step, j = {
            ArrowUp() {
              n({ type: "INPUT.ARROW_UP", step: w }), A.preventDefault();
            },
            ArrowDown() {
              n({ type: "INPUT.ARROW_DOWN", step: w }), A.preventDefault();
            },
            Home() {
              n("INPUT.HOME"), A.preventDefault();
            },
            End() {
              n("INPUT.END"), A.preventDefault();
            },
            Enter() {
              n({ type: "INPUT.COMMIT", src: "enter" });
            }
          }[A.key];
          j == null || j(A);
        }
      });
    },
    getDecrementTriggerProps() {
      return t.button({
        ...id.decrementTrigger.attrs,
        dir: e.context.dir,
        id: Nt.getDecrementTriggerId(e.context),
        disabled: p,
        "data-disabled": se(p),
        "aria-label": y.decrementLabel,
        type: "button",
        tabIndex: -1,
        "aria-controls": Nt.getInputId(e.context),
        onPointerDown(A) {
          var w;
          p || !rc(A) || (n({ type: "TRIGGER.PRESS_DOWN", hint: "decrement", pointerType: A.pointerType }), A.pointerType === "mouse" && A.preventDefault(), A.pointerType === "touch" && ((w = A.currentTarget) == null || w.focus({ preventScroll: !0 })));
        },
        onPointerUp(A) {
          n({ type: "TRIGGER.PRESS_UP", hint: "decrement", pointerType: A.pointerType });
        },
        onPointerLeave() {
          p || n({ type: "TRIGGER.PRESS_UP", hint: "decrement" });
        }
      });
    },
    getIncrementTriggerProps() {
      return t.button({
        ...id.incrementTrigger.attrs,
        dir: e.context.dir,
        id: Nt.getIncrementTriggerId(e.context),
        disabled: f,
        "data-disabled": se(f),
        "aria-label": y.incrementLabel,
        type: "button",
        tabIndex: -1,
        "aria-controls": Nt.getInputId(e.context),
        onPointerDown(A) {
          var w;
          f || !rc(A) || (n({ type: "TRIGGER.PRESS_DOWN", hint: "increment", pointerType: A.pointerType }), A.pointerType === "mouse" && A.preventDefault(), A.pointerType === "touch" && ((w = A.currentTarget) == null || w.focus({ preventScroll: !0 })));
        },
        onPointerUp(A) {
          n({ type: "TRIGGER.PRESS_UP", hint: "increment", pointerType: A.pointerType });
        },
        onPointerLeave(A) {
          n({ type: "TRIGGER.PRESS_UP", hint: "increment", pointerType: A.pointerType });
        }
      });
    },
    getScrubberProps() {
      return t.element({
        ...id.scrubber.attrs,
        dir: e.context.dir,
        "data-disabled": se(o),
        id: Nt.getScrubberId(e.context),
        role: "presentation",
        onMouseDown(A) {
          if (o)
            return;
          const w = nu(A);
          w.x = w.x - Dg(7.5), w.y = w.y - Dg(7.5), n({ type: "SCRUBBER.PRESS_DOWN", point: w }), A.preventDefault();
        },
        style: {
          cursor: o ? void 0 : "ew-resize"
        }
      });
    }
  };
}
function Q5(e) {
  if (e.ownerDocument.activeElement === e)
    try {
      const { selectionStart: n, selectionEnd: t, value: r } = e, o = r.substring(0, n), a = r.substring(t);
      return {
        start: n,
        end: t,
        value: r,
        beforeTxt: o,
        afterTxt: a
      };
    } catch {
    }
}
function q5(e, n) {
  if (e.ownerDocument.activeElement === e) {
    if (!n) {
      e.setSelectionRange(e.value.length, e.value.length);
      return;
    }
    try {
      const { value: t } = e, { beforeTxt: r = "", afterTxt: o = "", start: a } = n;
      let l = t.length;
      if (t.endsWith(o))
        l = t.length - o.length;
      else if (t.startsWith(r))
        l = r.length;
      else if (a != null) {
        const u = r[a - 1], f = t.indexOf(u, a - 1);
        f !== -1 && (l = f + 1);
      }
      e.setSelectionRange(l, l);
    } catch {
    }
  }
}
var WC = (e, n = {}) => Hn(new Intl.NumberFormat(e, n)), HC = (e, n = {}) => Hn(new kx(e, n)), GC = (e, n) => e.formatOptions ? e.parser.parse(String(n)) : parseFloat(n), ad = (e, n) => Number.isNaN(n) ? "" : e.formatOptions ? e.formatter.format(n) : n.toString(), { not: _m, and: Ip } = Ma;
function _5(e) {
  const n = br(e);
  return Rr(
    {
      id: "number-input",
      initial: "idle",
      context: {
        dir: "ltr",
        locale: "en-US",
        focusInputOnChange: !0,
        clampValueOnBlur: !0,
        allowOverflow: !1,
        inputMode: "decimal",
        pattern: "[0-9]*(.[0-9]+)?",
        value: "",
        step: 1,
        min: Number.MIN_SAFE_INTEGER,
        max: Number.MAX_SAFE_INTEGER,
        invalid: !1,
        spinOnPress: !0,
        ...n,
        hint: null,
        scrubberCursorPoint: null,
        fieldsetDisabled: !1,
        formatter: WC(n.locale || "en-US", n.formatOptions),
        parser: HC(n.locale || "en-US", n.formatOptions),
        translations: {
          incrementLabel: "increment value",
          decrementLabel: "decrease value",
          ...n.translations
        }
      },
      computed: {
        isRtl: (t) => t.dir === "rtl",
        valueAsNumber: (t) => GC(t, t.value),
        formattedValue: (t) => ad(t, t.valueAsNumber),
        isAtMin: (t) => V5(t.valueAsNumber, t),
        isAtMax: (t) => B5(t.valueAsNumber, t),
        isOutOfRange: (t) => !j5(t.valueAsNumber, t),
        isValueEmpty: (t) => t.value === "",
        isDisabled: (t) => !!t.disabled || t.fieldsetDisabled,
        canIncrement: (t) => t.allowOverflow || !t.isAtMax,
        canDecrement: (t) => t.allowOverflow || !t.isAtMin,
        valueText: (t) => {
          var r, o;
          return (o = (r = t.translations).valueText) == null ? void 0 : o.call(r, t.value);
        }
      },
      watch: {
        formatOptions: ["setFormatterAndParser", "syncInputElement"],
        locale: ["setFormatterAndParser", "syncInputElement"],
        value: ["syncInputElement"],
        isOutOfRange: ["invokeOnInvalid"],
        scrubberCursorPoint: ["setVirtualCursorPosition"]
      },
      activities: ["trackFormControl"],
      on: {
        "VALUE.SET": {
          actions: ["setRawValue", "setHintToSet"]
        },
        "VALUE.CLEAR": {
          actions: ["clearValue"]
        },
        "VALUE.INCREMENT": {
          actions: ["increment"]
        },
        "VALUE.DECREMENT": {
          actions: ["decrement"]
        }
      },
      states: {
        idle: {
          on: {
            "TRIGGER.PRESS_DOWN": [
              { guard: "isTouchPointer", target: "before:spin", actions: ["setHint"] },
              {
                target: "before:spin",
                actions: ["focusInput", "invokeOnFocus", "setHint"]
              }
            ],
            "SCRUBBER.PRESS_DOWN": {
              target: "scrubbing",
              actions: ["focusInput", "invokeOnFocus", "setHint", "setCursorPoint"]
            },
            "INPUT.FOCUS": {
              target: "focused",
              actions: ["focusInput", "invokeOnFocus"]
            }
          }
        },
        focused: {
          tags: "focus",
          activities: "attachWheelListener",
          on: {
            "TRIGGER.PRESS_DOWN": [
              { guard: "isTouchPointer", target: "before:spin", actions: ["setHint"] },
              { target: "before:spin", actions: ["focusInput", "setHint"] }
            ],
            "SCRUBBER.PRESS_DOWN": {
              target: "scrubbing",
              actions: ["focusInput", "setHint", "setCursorPoint"]
            },
            "INPUT.ARROW_UP": {
              actions: "increment"
            },
            "INPUT.ARROW_DOWN": {
              actions: "decrement"
            },
            "INPUT.HOME": {
              actions: "decrementToMin"
            },
            "INPUT.END": {
              actions: "incrementToMax"
            },
            "INPUT.CHANGE": {
              actions: ["setValue", "setHint"]
            },
            "INPUT.COMMIT": [
              {
                guard: Ip("clampValueOnBlur", _m("isInRange")),
                target: "idle",
                actions: ["setClampedValue", "clearHint", "invokeOnBlur"]
              },
              {
                target: "idle",
                actions: ["setFormattedValue", "clearHint", "invokeOnBlur"]
              }
            ]
          }
        },
        "before:spin": {
          tags: "focus",
          activities: "trackButtonDisabled",
          entry: IF([
            { guard: "isIncrementHint", actions: "increment" },
            { guard: "isDecrementHint", actions: "decrement" }
          ]),
          after: {
            CHANGE_DELAY: {
              target: "spinning",
              guard: Ip("isInRange", "spinOnPress")
            }
          },
          on: {
            "TRIGGER.PRESS_UP": [
              { guard: "isTouchPointer", target: "focused", actions: "clearHint" },
              { target: "focused", actions: ["focusInput", "clearHint"] }
            ]
          }
        },
        spinning: {
          tags: "focus",
          activities: "trackButtonDisabled",
          every: [
            {
              delay: "CHANGE_INTERVAL",
              guard: Ip(_m("isAtMin"), "isIncrementHint"),
              actions: "increment"
            },
            {
              delay: "CHANGE_INTERVAL",
              guard: Ip(_m("isAtMax"), "isDecrementHint"),
              actions: "decrement"
            }
          ],
          on: {
            "TRIGGER.PRESS_UP": {
              target: "focused",
              actions: ["focusInput", "clearHint"]
            }
          }
        },
        scrubbing: {
          tags: "focus",
          activities: ["activatePointerLock", "trackMousemove", "setupVirtualCursor", "preventTextSelection"],
          on: {
            "SCRUBBER.POINTER_UP": {
              target: "focused",
              actions: ["focusInput", "clearCursorPoint"]
            },
            "SCRUBBER.POINTER_MOVE": [
              {
                guard: "isIncrementHint",
                actions: ["increment", "setCursorPoint"]
              },
              {
                guard: "isDecrementHint",
                actions: ["decrement", "setCursorPoint"]
              }
            ]
          }
        }
      }
    },
    {
      delays: {
        CHANGE_INTERVAL: 50,
        CHANGE_DELAY: 300
      },
      guards: {
        clampValueOnBlur: (t) => t.clampValueOnBlur,
        isAtMin: (t) => t.isAtMin,
        spinOnPress: (t) => !!t.spinOnPress,
        isAtMax: (t) => t.isAtMax,
        isInRange: (t) => !t.isOutOfRange,
        isDecrementHint: (t, r) => (r.hint ?? t.hint) === "decrement",
        isIncrementHint: (t, r) => (r.hint ?? t.hint) === "increment",
        isTouchPointer: (t, r) => r.pointerType === "touch"
      },
      activities: {
        trackFormControl(t, r, { initialContext: o }) {
          const a = Nt.getInputEl(t);
          return jf(a, {
            onFieldsetDisabledChange(l) {
              t.fieldsetDisabled = l;
            },
            onFormReset() {
              _s.value(t, o.value);
            }
          });
        },
        setupVirtualCursor(t) {
          return Nt.setupVirtualCursor(t);
        },
        preventTextSelection(t) {
          return Nt.preventTextSelection(t);
        },
        trackButtonDisabled(t, r, { send: o }) {
          const a = Nt.getPressedTriggerEl(t, t.hint);
          return Dh(a, {
            attributes: ["disabled"],
            callback() {
              o({ type: "TRIGGER.PRESS_UP", src: "attr" });
            }
          });
        },
        attachWheelListener(t, r, { send: o }) {
          const a = Nt.getInputEl(t);
          if (!a || !Nt.isActiveElement(t, a) || !t.allowMouseWheel)
            return;
          function l(u) {
            u.preventDefault();
            const f = Math.sign(u.deltaY) * -1;
            f === 1 ? o("VALUE.INCREMENT") : f === -1 && o("VALUE.DECREMENT");
          }
          return Dn(a, "wheel", l, { passive: !1 });
        },
        activatePointerLock(t) {
          if (!fb())
            return BD(Nt.getDoc(t));
        },
        trackMousemove(t, r, { send: o }) {
          const a = Nt.getDoc(t);
          function l(f) {
            if (!t.scrubberCursorPoint)
              return;
            const p = Nt.getMousementValue(t, f);
            p.hint && o({
              type: "SCRUBBER.POINTER_MOVE",
              hint: p.hint,
              point: p.point
            });
          }
          function u() {
            o("SCRUBBER.POINTER_UP");
          }
          return Vv(
            Dn(a, "mousemove", l, !1),
            Dn(a, "mouseup", u, !1)
          );
        }
      },
      actions: {
        focusInput(t) {
          if (!t.focusInputOnChange)
            return;
          const r = Nt.getInputEl(t);
          Nt.isActiveElement(t, r) || Ct(() => r == null ? void 0 : r.focus({ preventScroll: !0 }));
        },
        increment(t, r) {
          const o = M5(t.valueAsNumber, r.step ?? t.step), a = ad(t, Sp(o, t));
          _s.value(t, a);
        },
        decrement(t, r) {
          const o = L5(t.valueAsNumber, r.step ?? t.step), a = ad(t, Sp(o, t));
          _s.value(t, a);
        },
        setClampedValue(t) {
          const r = Sp(t.valueAsNumber, t);
          _s.value(t, ad(t, r));
        },
        setRawValue(t, r) {
          const o = GC(t, r.value), a = ad(t, Sp(o, t));
          _s.value(t, a);
        },
        setValue(t, r) {
          var a;
          const o = ((a = r.target) == null ? void 0 : a.value) ?? r.value;
          _s.value(t, o);
        },
        clearValue(t) {
          _s.value(t, "");
        },
        incrementToMax(t) {
          const r = ad(t, t.max);
          _s.value(t, r);
        },
        decrementToMin(t) {
          const r = ad(t, t.min);
          _s.value(t, r);
        },
        setHint(t, r) {
          t.hint = r.hint;
        },
        clearHint(t) {
          t.hint = null;
        },
        setHintToSet(t) {
          t.hint = "set";
        },
        invokeOnFocus(t) {
          var r;
          (r = t.onFocusChange) == null || r.call(t, {
            focused: !0,
            value: t.formattedValue,
            valueAsNumber: t.valueAsNumber
          });
        },
        invokeOnBlur(t) {
          var r;
          (r = t.onFocusChange) == null || r.call(t, {
            focused: !1,
            value: t.formattedValue,
            valueAsNumber: t.valueAsNumber
          });
        },
        invokeOnInvalid(t) {
          var o;
          if (!t.isOutOfRange)
            return;
          const r = t.valueAsNumber > t.max ? "rangeOverflow" : "rangeUnderflow";
          (o = t.onValueInvalid) == null || o.call(t, {
            reason: r,
            value: t.formattedValue,
            valueAsNumber: t.valueAsNumber
          });
        },
        syncInputElement(t, r) {
          const o = r.type.endsWith("CHANGE") ? t.value : t.formattedValue;
          $5.input(t, o);
        },
        setFormattedValue(t) {
          _s.value(t, t.formattedValue);
        },
        setCursorPoint(t, r) {
          t.scrubberCursorPoint = r.point;
        },
        clearCursorPoint(t) {
          t.scrubberCursorPoint = null;
        },
        setVirtualCursorPosition(t) {
          const r = Nt.getCursorEl(t);
          if (!r || !t.scrubberCursorPoint)
            return;
          const { x: o, y: a } = t.scrubberCursorPoint;
          r.style.transform = `translate3d(${o}px, ${a}px, 0px)`;
        },
        setFormatterAndParser(t) {
          t.locale && (t.formatter = WC(t.locale, t.formatOptions), t.parser = HC(t.locale, t.formatOptions));
        }
      },
      compareFns: {
        formatOptions: (t, r) => vr(t, r),
        scrubberCursorPoint: (t, r) => vr(t, r)
      }
    }
  );
}
var $5 = {
  input(e, n) {
    const t = Nt.getInputEl(e);
    if (!t)
      return;
    const r = Q5(t);
    Ct(() => {
      Nt.setValue(t, n), q5(t, r);
    });
  }
}, eU = {
  onChange: (e) => {
    var n;
    (n = e.onValueChange) == null || n.call(e, {
      value: e.value,
      valueAsNumber: e.valueAsNumber
    });
  }
}, _s = {
  value: (e, n) => {
    vr(e.value, n) || (e.value = n, eU.onChange(e));
  }
};
const tU = (e = {}) => {
  const { getRootNode: n } = Jr(), { dir: t } = ko(), r = {
    id: gr(),
    dir: t,
    getRootNode: n,
    value: e.defaultValue,
    ...e
  }, o = {
    ...r,
    value: e.value,
    onValueChange: en(e.onValueChange, { sync: !0 }),
    onValueInvalid: en(e.onValueInvalid),
    onFocusChange: en(e.onFocusChange)
  }, [a, l] = Or(_5(r), { context: o });
  return J5(a, l, yr);
}, Rx = oe((e, n) => {
  const [t, r] = Ft()(e, [
    "allowMouseWheel",
    "allowOverflow",
    "clampValueOnBlur",
    "defaultValue",
    "disabled",
    "focusInputOnChange",
    "form",
    "formatOptions",
    "id",
    "ids",
    "inputMode",
    "invalid",
    "locale",
    "max",
    "min",
    "name",
    "onFocusChange",
    "onValueChange",
    "onValueInvalid",
    "pattern",
    "readOnly",
    "spinOnPress",
    "step",
    "translations",
    "value"
  ]), o = tU(t), a = be(o.getRootProps(), r);
  return /* @__PURE__ */ I.jsx(D5, { value: o, children: /* @__PURE__ */ I.jsx(ve.div, { ...a, ref: n }) });
});
Rx.displayName = "NumberInputRoot";
const [nU, Jg] = xt({
  name: "PaginationContext",
  hookName: "usePaginationContext",
  providerName: "<PaginationProvider />"
}), rU = (e) => e.children(Jg()), Ox = oe(
  (e, n) => {
    const [t, r] = Ft()(e, ["index"]), o = Jg(), a = be(o.getEllipsisProps(t), r);
    return /* @__PURE__ */ I.jsx(ve.div, { ...a, ref: n });
  }
);
Ox.displayName = "PaginationEllipsis";
const Dx = oe((e, n) => {
  const [t, r] = Ft()(e, ["value", "type"]), o = Jg(), a = be(o.getItemProps(t), r);
  return /* @__PURE__ */ I.jsx(ve.button, { ...a, ref: n });
});
Dx.displayName = "PaginationItem";
const Fx = oe(
  (e, n) => {
    const t = Jg(), r = be(t.getNextTriggerProps(), e);
    return /* @__PURE__ */ I.jsx(ve.button, { ...r, ref: n });
  }
);
Fx.displayName = "PaginationNextTrigger";
const Nx = oe(
  (e, n) => {
    const t = Jg(), r = be(t.getPrevTriggerProps(), e);
    return /* @__PURE__ */ I.jsx(ve.button, { ...r, ref: n });
  }
);
Nx.displayName = "PaginationPrevTrigger";
var rh = (e, n = []) => ({
  parts: (...t) => {
    if (oU(n))
      return rh(e, t);
    throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
  },
  extendWith: (...t) => rh(e, [...n, ...t]),
  rename: (t) => rh(t, n),
  keys: () => n,
  build: () => [...new Set(n)].reduce(
    (t, r) => Object.assign(t, {
      [r]: {
        selector: [
          `&[data-scope="${gf(e)}"][data-part="${gf(r)}"]`,
          `& [data-scope="${gf(e)}"][data-part="${gf(r)}"]`
        ].join(", "),
        attrs: { "data-scope": gf(e), "data-part": gf(r) }
      }
    }),
    {}
  )
}), gf = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), oU = (e) => e.length === 0, iU = rh("pagination").parts("root", "item", "ellipsis", "prevTrigger", "nextTrigger"), Ag = iU.build(), Sg = so({
  getRootId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.root) ?? `pagination:${e.id}`;
  },
  getPrevTriggerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.prevTrigger) ?? `pagination:${e.id}:prev`;
  },
  getNextTriggerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.nextTrigger) ?? `pagination:${e.id}:next`;
  },
  getEllipsisId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.ellipsis) == null ? void 0 : r.call(t, n)) ?? `pagination:${e.id}:ellipsis:${n}`;
  },
  getItemId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.item) == null ? void 0 : r.call(t, n)) ?? `pagination:${e.id}:item:${n}`;
  }
}), xp = (e, n) => {
  let t = n - e + 1;
  return Array.from({ length: t }, (r, o) => o + e);
}, aU = (e) => e.map((n) => typeof n == "number" ? { type: "page", value: n } : { type: "ellipsis" }), Tp = "ellipsis", sU = (e) => {
  const n = Math.min(2 * e.siblingCount + 5, e.totalPages), t = 1, r = e.totalPages, o = Math.max(e.page - e.siblingCount, t), a = Math.min(e.page + e.siblingCount, r), l = o > t + 1, u = a < r - 1, f = n - 2;
  if (!l && u)
    return [...xp(1, f), Tp, r];
  if (l && !u) {
    const y = xp(r - f + 1, r);
    return [t, Tp, ...y];
  }
  if (l && u) {
    const y = xp(o, a);
    return [t, Tp, ...y, Tp, r];
  }
  return xp(t, r);
}, lU = (e) => aU(sU(e));
function cU(e, n, t) {
  const r = e.context.totalPages, o = e.context.page, a = e.context.translations, l = e.context.previousPage, u = e.context.nextPage, f = e.context.pageRange, y = e.context.type === "button", A = o === 1, w = o === r;
  return {
    page: o,
    pageSize: e.context.pageSize,
    totalPages: r,
    pages: lU(e.context),
    previousPage: l,
    nextPage: u,
    pageRange: f,
    slice(F) {
      return F.slice(f.start, f.end);
    },
    setCount(F) {
      n({ type: "SET_COUNT", count: F });
    },
    setPageSize(F) {
      n({ type: "SET_PAGE_SIZE", size: F });
    },
    setPage(F) {
      n({ type: "SET_PAGE", page: F });
    },
    getRootProps() {
      return t.element({
        id: Sg.getRootId(e.context),
        ...Ag.root.attrs,
        dir: e.context.dir,
        "aria-label": a.rootLabel
      });
    },
    getEllipsisProps(F) {
      return t.element({
        id: Sg.getEllipsisId(e.context, F.index),
        ...Ag.ellipsis.attrs,
        dir: e.context.dir
      });
    },
    getItemProps(F) {
      var D;
      const j = F.value, N = j === e.context.page;
      return t.element({
        id: Sg.getItemId(e.context, j),
        ...Ag.item.attrs,
        dir: e.context.dir,
        "data-index": j,
        "data-selected": se(N),
        "aria-current": N ? "page" : void 0,
        "aria-label": (D = a.itemLabel) == null ? void 0 : D.call(a, { page: j, totalPages: r }),
        onClick() {
          n({ type: "SET_PAGE", page: j });
        },
        ...y && { type: "button" }
      });
    },
    getPrevTriggerProps() {
      return t.element({
        id: Sg.getPrevTriggerId(e.context),
        ...Ag.prevTrigger.attrs,
        dir: e.context.dir,
        "data-disabled": se(A),
        "aria-label": a.prevTriggerLabel,
        onClick() {
          n({ type: "PREVIOUS_PAGE" });
        },
        ...y && { disabled: A, type: "button" }
      });
    },
    getNextTriggerProps() {
      return t.element({
        id: Sg.getNextTriggerId(e.context),
        ...Ag.nextTrigger.attrs,
        dir: e.context.dir,
        "data-disabled": se(w),
        "aria-label": a.nextTriggerLabel,
        onClick() {
          n({ type: "NEXT_PAGE" });
        },
        ...y && { disabled: w, type: "button" }
      });
    }
  };
}
function uU(e) {
  const n = br(e);
  return Rr(
    {
      id: "pagination",
      initial: "idle",
      context: {
        pageSize: 10,
        siblingCount: 1,
        page: 1,
        type: "button",
        translations: {
          rootLabel: "pagination",
          prevTriggerLabel: "previous page",
          nextTriggerLabel: "next page",
          itemLabel({ page: t, totalPages: r }) {
            return `${r > 1 && t === r ? "last page, " : ""}page ${t}`;
          },
          ...n.translations
        },
        ...n
      },
      watch: {
        pageSize: ["setPageIfNeeded"]
      },
      computed: {
        totalPages: (t) => Math.ceil(t.count / t.pageSize),
        previousPage: (t) => t.page === 1 ? null : t.page - 1,
        nextPage: (t) => t.page === t.totalPages ? null : t.page + 1,
        pageRange: (t) => {
          const r = (t.page - 1) * t.pageSize, o = r + t.pageSize;
          return { start: r, end: o };
        },
        isValidPage: (t) => t.page >= 1 && t.page <= t.totalPages
      },
      on: {
        SET_COUNT: [
          {
            guard: "isValidCount",
            actions: ["setCount", "goToFirstPage"]
          },
          {
            actions: "setCount"
          }
        ],
        SET_PAGE: {
          guard: "isValidPage",
          actions: "setPage"
        },
        SET_PAGE_SIZE: {
          actions: "setPageSize"
        },
        PREVIOUS_PAGE: {
          guard: "canGoToPrevPage",
          actions: "goToPrevPage"
        },
        NEXT_PAGE: {
          guard: "canGoToNextPage",
          actions: "goToNextPage"
        }
      },
      states: {
        idle: {}
      }
    },
    {
      guards: {
        isValidPage: (t, r) => r.page >= 1 && r.page <= t.totalPages,
        isValidCount: (t, r) => t.page > r.count,
        canGoToNextPage: (t) => t.page < t.totalPages,
        canGoToPrevPage: (t) => t.page > 1
      },
      actions: {
        setCount(t, r) {
          t.count = r.count;
        },
        setPage(t, r) {
          pf.page(t, r.page);
        },
        setPageSize(t, r) {
          pf.pageSize(t, r.size);
        },
        goToFirstPage(t) {
          pf.page(t, 1);
        },
        goToPrevPage(t) {
          pf.page(t, t.page - 1);
        },
        goToNextPage(t) {
          pf.page(t, t.page + 1);
        },
        setPageIfNeeded(t, r) {
          t.isValidPage || pf.page(t, 1);
        }
      }
    }
  );
}
var pf = {
  pageSize: (e, n) => {
    var t;
    vr(e.pageSize, n) || (e.pageSize = n, (t = e.onPageSizeChange) == null || t.call(e, { pageSize: e.pageSize }));
  },
  page: (e, n) => {
    var t;
    vr(e.page, n) || (e.page = n, (t = e.onPageChange) == null || t.call(e, { page: e.page, pageSize: e.pageSize }));
  }
};
nn()([
  "count",
  "dir",
  "getRootNode",
  "id",
  "ids",
  "onPageChange",
  "onPageSizeChange",
  "page",
  "pageSize",
  "siblingCount",
  "translations",
  "type"
]);
nn()(["value", "type"]);
nn()(["index"]);
const dU = (e) => {
  const { getRootNode: n } = Jr(), { dir: t } = ko(), r = {
    id: gr(),
    dir: t,
    getRootNode: n,
    page: e.defaultPage,
    ...e
  }, o = {
    ...r,
    page: e.page,
    onPageChange: en(e.onPageChange, { sync: !0 })
  }, [a, l] = Or(uU(r), { context: o });
  return cU(a, l, yr);
}, Mx = oe((e, n) => {
  const [t, r] = Ft()(e, [
    "count",
    "defaultPage",
    "id",
    "ids",
    "onPageChange",
    "onPageSizeChange",
    "page",
    "pageSize",
    "siblingCount",
    "translations",
    "type"
  ]), o = dU(t), a = be(o.getRootProps(), r);
  return /* @__PURE__ */ I.jsx(nU, { value: o, children: /* @__PURE__ */ I.jsx(ve.nav, { ...a, ref: n }) });
});
Mx.displayName = "PaginationRoot";
const fU = () => {
  const [e, n] = du(!0);
  return ra(() => {
    n(!1);
  }, []), e;
}, Lx = (e) => {
  const { children: n, container: t, disabled: r } = e, o = fU(), { getRootNode: a } = Jr();
  if (o || r)
    return /* @__PURE__ */ I.jsx(I.Fragment, { children: n });
  const l = (a == null ? void 0 : a().ownerDocument) ?? document, u = (t == null ? void 0 : t.current) ?? l.body;
  return /* @__PURE__ */ I.jsx(I.Fragment, { children: RA.map(n, (f) => OA(f, u)) });
}, Bx = oe((e, n) => {
  const [t, r] = fu(e), o = cc(t);
  return o.unmounted ? null : /* @__PURE__ */ I.jsx(
    ve.div,
    {
      ...r,
      ...o.getPresenceProps(n),
      "data-scope": "presence",
      "data-part": "root"
    }
  );
});
Bx.displayName = "Presence";
const [gU, Hh] = xt({
  name: "RadioGroupContext",
  hookName: "useRadioGroupContext",
  providerName: "<RadioGroupProvider />"
}), [pU, MY] = xt({
  name: "RadioGroupItemContext",
  hookName: "useRadioGroupItemContext",
  providerName: "<RadioGroupItemProvider />"
}), [hU, Cy] = xt({
  name: "RadioGroupItemPropsContext",
  hookName: "useRadioGroupItemPropsContext",
  providerName: "<RadioGroupItemPropsProvider />"
}), Vx = oe((e, n) => {
  const [t, r] = Ft()(e, [
    "value",
    "disabled",
    "invalid"
  ]), o = Hh(), a = be(o.getItemProps(t), r), l = o.getItemState(t);
  return /* @__PURE__ */ I.jsx(pU, { value: l, children: /* @__PURE__ */ I.jsx(hU, { value: t, children: /* @__PURE__ */ I.jsx(ve.label, { ...a, ref: n }) }) });
});
Vx.displayName = "RadioGroupItem";
const jx = oe(
  (e, n) => {
    const t = Hh(), r = Cy(), o = be(t.getItemControlProps(r), e);
    return /* @__PURE__ */ I.jsx(ve.div, { ...o, ref: n });
  }
);
jx.displayName = "RadioGroupItemControl";
const Ux = oe((e, n) => {
  const t = Hh(), r = Cy(), o = be(t.getItemHiddenInputProps(r), e);
  return /* @__PURE__ */ I.jsx(ve.input, { ...o, ref: n });
});
Ux.displayName = "RadioGroupItemHiddenInput";
const Wx = oe(
  (e, n) => {
    const t = Hh(), r = Cy(), o = be(t.getItemTextProps(r), e);
    return /* @__PURE__ */ I.jsx(ve.span, { ...o, ref: n });
  }
);
Wx.displayName = "RadioGroupItemText";
var oh = (e, n = []) => ({
  parts: (...t) => {
    if (mU(n))
      return oh(e, t);
    throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
  },
  extendWith: (...t) => oh(e, [...n, ...t]),
  rename: (t) => oh(t, n),
  keys: () => n,
  build: () => [...new Set(n)].reduce(
    (t, r) => Object.assign(t, {
      [r]: {
        selector: [
          `&[data-scope="${hf(e)}"][data-part="${hf(r)}"]`,
          `& [data-scope="${hf(e)}"][data-part="${hf(r)}"]`
        ].join(", "),
        attrs: { "data-scope": hf(e), "data-part": hf(r) }
      }
    }),
    {}
  )
}), hf = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), mU = (e) => e.length === 0, tb, ud = /* @__PURE__ */ new Map(), vU = (e) => e.getBoundingClientRect();
function bU(e, n) {
  const { scope: t = "rect", getRect: r = vU, onChange: o } = n, a = yU({ scope: t, getRect: r }), l = ud.get(e);
  return l ? (l.callbacks.push(o), o(r(e))) : (ud.set(e, {
    rect: {},
    callbacks: [o]
  }), ud.size === 1 && (tb = requestAnimationFrame(a))), function() {
    const f = ud.get(e);
    if (!f)
      return;
    const p = f.callbacks.indexOf(o);
    p > -1 && f.callbacks.splice(p, 1), f.callbacks.length === 0 && (ud.delete(e), ud.size === 0 && cancelAnimationFrame(tb));
  };
}
function yU(e) {
  const { scope: n, getRect: t } = e, r = EU(n);
  return function o() {
    const a = [];
    ud.forEach((l, u) => {
      const f = t(u);
      r(l.rect, f) || (l.rect = f, a.push(l));
    }), a.forEach((l) => {
      l.callbacks.forEach((u) => u(l.rect));
    }), tb = requestAnimationFrame(o);
  };
}
var Hx = (e, n) => e.width === n.width && e.height === n.height, Gx = (e, n) => e.top === n.top && e.left === n.left, CU = (e, n) => Hx(e, n) && Gx(e, n);
function EU(e) {
  return e === "size" ? Hx : e === "position" ? Gx : CU;
}
var AU = oh("radio-group").parts(
  "root",
  "label",
  "item",
  "itemText",
  "itemControl",
  "indicator"
), mf = AU.build(), qt = so({
  getRootId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.root) ?? `radio-group:${e.id}`;
  },
  getLabelId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.label) ?? `radio-group:${e.id}:label`;
  },
  getItemId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.item) == null ? void 0 : r.call(t, n)) ?? `radio-group:${e.id}:radio:${n}`;
  },
  getItemHiddenInputId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.itemHiddenInput) == null ? void 0 : r.call(t, n)) ?? `radio-group:${e.id}:radio:input:${n}`;
  },
  getItemControlId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.itemControl) == null ? void 0 : r.call(t, n)) ?? `radio-group:${e.id}:radio:control:${n}`;
  },
  getItemLabelId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.itemLabel) == null ? void 0 : r.call(t, n)) ?? `radio-group:${e.id}:radio:label:${n}`;
  },
  getIndicatorId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.indicator) ?? `radio-group:${e.id}:indicator`;
  },
  getRootEl: (e) => qt.getById(e, qt.getRootId(e)),
  getItemHiddenInputEl: (e, n) => qt.getById(e, qt.getItemHiddenInputId(e, n)),
  getIndicatorEl: (e) => qt.getById(e, qt.getIndicatorId(e)),
  getFirstEnabledInputEl: (e) => {
    var n;
    return (n = qt.getRootEl(e)) == null ? void 0 : n.querySelector("input:not(:disabled)");
  },
  getFirstEnabledAndCheckedInputEl: (e) => {
    var n;
    return (n = qt.getRootEl(e)) == null ? void 0 : n.querySelector("input:not(:disabled):checked");
  },
  getInputEls: (e) => {
    const t = `input[type=radio][data-ownedby='${CSS.escape(qt.getRootId(e))}']:not([disabled])`;
    return $s(qt.getRootEl(e), t);
  },
  getActiveRadioEl: (e) => {
    if (e.value)
      return qt.getById(e, qt.getItemId(e, e.value));
  },
  getOffsetRect: (e) => ({
    left: (e == null ? void 0 : e.offsetLeft) ?? 0,
    top: (e == null ? void 0 : e.offsetTop) ?? 0,
    width: (e == null ? void 0 : e.offsetWidth) ?? 0,
    height: (e == null ? void 0 : e.offsetHeight) ?? 0
  }),
  getRectById: (e, n) => {
    const t = qt.getById(e, qt.getItemId(e, n));
    if (t)
      return qt.resolveRect(qt.getOffsetRect(t));
  },
  resolveRect: (e) => ({
    width: `${e.width}px`,
    height: `${e.height}px`,
    left: `${e.left}px`,
    top: `${e.top}px`
  })
});
function Yx(e, n, t) {
  const r = e.context.isDisabled, o = e.context.readOnly;
  function a(f) {
    return {
      invalid: !!f.invalid,
      disabled: !!f.disabled || r,
      checked: e.context.value === f.value,
      focused: e.context.focusedValue === f.value,
      hovered: e.context.hoveredValue === f.value,
      active: e.context.activeValue === f.value
    };
  }
  function l(f) {
    const p = a(f);
    return {
      "data-focus": se(p.focused),
      "data-disabled": se(p.disabled),
      "dats-readonly": se(o),
      "data-state": p.checked ? "checked" : "unchecked",
      "data-hover": se(p.hovered),
      "data-invalid": se(p.invalid),
      "data-orientation": e.context.orientation
    };
  }
  const u = () => {
    const f = qt.getFirstEnabledAndCheckedInputEl(e.context);
    if (f) {
      f.focus();
      return;
    }
    const p = qt.getFirstEnabledInputEl(e.context);
    p == null || p.focus();
  };
  return {
    focus: u,
    value: e.context.value,
    setValue(f) {
      n({ type: "SET_VALUE", value: f, isTrusted: !1 });
    },
    clearValue() {
      n({ type: "SET_VALUE", value: null, isTrusted: !1 });
    },
    getRootProps() {
      return t.element({
        ...mf.root.attrs,
        role: "radiogroup",
        id: qt.getRootId(e.context),
        "aria-labelledby": qt.getLabelId(e.context),
        "data-orientation": e.context.orientation,
        "data-disabled": se(r),
        "aria-orientation": e.context.orientation,
        dir: e.context.dir,
        style: {
          position: "relative"
        }
      });
    },
    getLabelProps() {
      return t.element({
        ...mf.label.attrs,
        dir: e.context.dir,
        "data-orientation": e.context.orientation,
        "data-disabled": se(r),
        id: qt.getLabelId(e.context),
        onClick: u
      });
    },
    getItemState: a,
    getItemProps(f) {
      const p = a(f);
      return t.label({
        ...mf.item.attrs,
        dir: e.context.dir,
        id: qt.getItemId(e.context, f.value),
        htmlFor: qt.getItemHiddenInputId(e.context, f.value),
        ...l(f),
        onPointerMove() {
          p.disabled || p.hovered || n({ type: "SET_HOVERED", value: f.value, hovered: !0 });
        },
        onPointerLeave() {
          p.disabled || n({ type: "SET_HOVERED", value: null });
        },
        onPointerDown(y) {
          p.disabled || (p.focused && y.pointerType === "mouse" && y.preventDefault(), n({ type: "SET_ACTIVE", value: f.value, active: !0 }));
        },
        onPointerUp() {
          p.disabled || n({ type: "SET_ACTIVE", value: null });
        }
      });
    },
    getItemTextProps(f) {
      return t.element({
        ...mf.itemText.attrs,
        dir: e.context.dir,
        id: qt.getItemLabelId(e.context, f.value),
        ...l(f)
      });
    },
    getItemControlProps(f) {
      const p = a(f);
      return t.element({
        ...mf.itemControl.attrs,
        dir: e.context.dir,
        id: qt.getItemControlId(e.context, f.value),
        "data-active": se(p.active),
        "aria-hidden": !0,
        ...l(f)
      });
    },
    getItemHiddenInputProps(f) {
      const p = a(f);
      return t.input({
        "data-ownedby": qt.getRootId(e.context),
        id: qt.getItemHiddenInputId(e.context, f.value),
        type: "radio",
        name: e.context.name || e.context.id,
        form: e.context.form,
        value: f.value,
        onChange(y) {
          if (o) {
            y.preventDefault();
            return;
          }
          y.target.checked && n({ type: "SET_VALUE", value: f.value, isTrusted: !0 });
        },
        onBlur() {
          n({ type: "SET_FOCUSED", value: null });
        },
        onFocus() {
          n({ type: "SET_FOCUSED", value: f.value, focused: !0 });
        },
        onKeyDown(y) {
          y.defaultPrevented || y.key === " " && n({ type: "SET_ACTIVE", value: f.value, active: !0 });
        },
        onKeyUp(y) {
          y.defaultPrevented || y.key === " " && n({ type: "SET_ACTIVE", value: null });
        },
        disabled: p.disabled,
        defaultChecked: p.checked,
        style: Ff
      });
    },
    getIndicatorProps() {
      var f, p, y, A;
      return t.element({
        id: qt.getIndicatorId(e.context),
        ...mf.indicator.attrs,
        dir: e.context.dir,
        hidden: e.context.value == null,
        "data-disabled": se(r),
        "data-orientation": e.context.orientation,
        style: {
          "--transition-property": "left, top, width, height",
          "--left": (f = e.context.indicatorRect) == null ? void 0 : f.left,
          "--top": (p = e.context.indicatorRect) == null ? void 0 : p.top,
          "--width": (y = e.context.indicatorRect) == null ? void 0 : y.width,
          "--height": (A = e.context.indicatorRect) == null ? void 0 : A.height,
          position: "absolute",
          willChange: "var(--transition-property)",
          transitionProperty: "var(--transition-property)",
          transitionDuration: e.context.canIndicatorTransition ? "var(--transition-duration, 150ms)" : "0ms",
          transitionTimingFunction: "var(--transition-timing-function)",
          [e.context.orientation === "horizontal" ? "left" : "top"]: e.context.orientation === "horizontal" ? "var(--left)" : "var(--top)"
        }
      });
    }
  };
}
var { not: SU } = Ma;
function zx(e) {
  const n = br(e);
  return Rr(
    {
      id: "radio",
      initial: "idle",
      context: {
        value: null,
        activeValue: null,
        focusedValue: null,
        hoveredValue: null,
        disabled: !1,
        orientation: "vertical",
        ...n,
        indicatorRect: {},
        canIndicatorTransition: !1,
        fieldsetDisabled: !1
      },
      computed: {
        isDisabled: (t) => !!t.disabled || t.fieldsetDisabled
      },
      entry: ["syncIndicatorRect"],
      exit: ["cleanupObserver"],
      activities: ["trackFormControlState"],
      watch: {
        value: ["setIndicatorTransition", "syncIndicatorRect", "syncInputElements"]
      },
      on: {
        SET_VALUE: [
          {
            guard: SU("isTrusted"),
            actions: ["setValue", "dispatchChangeEvent"]
          },
          {
            actions: ["setValue"]
          }
        ],
        SET_HOVERED: {
          actions: "setHovered"
        },
        SET_ACTIVE: {
          actions: "setActive"
        },
        SET_FOCUSED: {
          actions: "setFocused"
        }
      },
      states: {
        idle: {}
      }
    },
    {
      guards: {
        isTrusted: (t, r) => !!r.isTrusted
      },
      activities: {
        trackFormControlState(t, r, { send: o, initialContext: a }) {
          return jf(qt.getRootEl(t), {
            onFieldsetDisabledChange(l) {
              t.fieldsetDisabled = l;
            },
            onFormReset() {
              o({ type: "SET_VALUE", value: a.value });
            }
          });
        }
      },
      actions: {
        setValue(t, r) {
          IU.value(t, r.value);
        },
        setHovered(t, r) {
          t.hoveredValue = r.value;
        },
        setActive(t, r) {
          t.activeValue = r.value;
        },
        setFocused(t, r) {
          t.focusedValue = r.value;
        },
        syncInputElements(t) {
          qt.getInputEls(t).forEach((o) => {
            o.checked = o.value === t.value;
          });
        },
        setIndicatorTransition(t) {
          t.canIndicatorTransition = QD(t.value);
        },
        cleanupObserver(t) {
          var r;
          (r = t.indicatorCleanup) == null || r.call(t);
        },
        syncIndicatorRect(t) {
          var a;
          if ((a = t.indicatorCleanup) == null || a.call(t), !qt.getIndicatorEl(t))
            return;
          const r = t.value, o = qt.getActiveRadioEl(t);
          if (r == null || !o) {
            t.indicatorRect = {};
            return;
          }
          t.indicatorCleanup = bU(o, {
            getRect(l) {
              return qt.getOffsetRect(l);
            },
            onChange(l) {
              t.indicatorRect = qt.resolveRect(l), Ab(() => {
                t.canIndicatorTransition = !1;
              });
            }
          });
        },
        dispatchChangeEvent(t) {
          qt.getInputEls(t).forEach((o) => {
            const a = o.value === t.value;
            a !== o.checked && Kb(o, { checked: a });
          });
        }
      }
    }
  );
}
var wU = {
  change: (e) => {
    var n;
    e.value != null && ((n = e.onValueChange) == null || n.call(e, { value: e.value }));
  }
}, IU = {
  value: (e, n) => {
    vr(e.value, n) || (e.value = n, wU.change(e));
  }
};
nn()([
  "dir",
  "disabled",
  "form",
  "getRootNode",
  "id",
  "ids",
  "name",
  "onValueChange",
  "orientation",
  "readOnly",
  "value"
]);
nn()(["value", "disabled", "invalid"]);
const xU = (e) => {
  const { getRootNode: n } = Jr(), { dir: t } = ko(), r = {
    id: gr(),
    dir: t,
    getRootNode: n,
    value: e.defaultValue,
    ...e
  }, o = {
    ...r,
    value: e.value,
    onValueChange: en(e.onValueChange, { sync: !0 })
  }, [a, l] = Or(zx(r), {
    context: o
  });
  return Yx(a, l, yr);
}, Zx = oe((e, n) => {
  const [t, r] = Ft()(e, [
    "defaultValue",
    "disabled",
    "form",
    "id",
    "ids",
    "name",
    "onValueChange",
    "orientation",
    "readOnly",
    "value"
  ]), o = xU(t), a = be(o.getRootProps(), r);
  return /* @__PURE__ */ I.jsx(gU, { value: o, children: /* @__PURE__ */ I.jsx(ve.div, { ...a, ref: n }) });
});
Zx.displayName = "RadioGroupRoot";
const [TU, Qg] = xt(
  {
    name: "SegmentGroupContext",
    hookName: "useSegmentGroupContext",
    providerName: "<SegmentGroupProvider />"
  }
), Kx = oe(
  (e, n) => {
    const t = Qg(), r = be(
      t.getIndicatorProps(),
      Vf.build().indicator.attrs,
      e
    );
    return /* @__PURE__ */ I.jsx(ve.div, { ...r, ref: n });
  }
);
Kx.displayName = "SegmentGroupIndicator";
const [PU, LY] = xt({
  name: "SegmentGroupItemContext",
  hookName: "useSegmentGroupItemContext",
  providerName: "<SegmentGroupItemProvider />"
}), [kU, Ey] = xt({
  name: "SegmentGroupItemPropsContext",
  hookName: "useSegmentGroupItemPropsContext",
  providerName: "<SegmentGroupItemPropsProvider />"
}), Xx = oe(
  (e, n) => {
    const [t, r] = Ft()(e, [
      "value",
      "disabled",
      "invalid"
    ]), o = Qg(), a = be(
      o.getItemProps(t),
      Vf.build().item.attrs,
      r
    ), l = o.getItemState(t);
    return /* @__PURE__ */ I.jsx(kU, { value: t, children: /* @__PURE__ */ I.jsx(PU, { value: l, children: /* @__PURE__ */ I.jsx(ve.label, { ...a, ref: n }) }) });
  }
);
Xx.displayName = "SegmentGroupItem";
const Jx = oe(
  (e, n) => {
    const t = Qg(), r = Ey(), o = be(
      t.getItemControlProps(r),
      Vf.build().itemControl.attrs,
      e
    );
    return /* @__PURE__ */ I.jsx(ve.div, { ...o, ref: n });
  }
);
Jx.displayName = "SegmentGroupItemControl";
const Qx = oe((e, n) => {
  const t = Qg(), r = Ey(), o = be(t.getItemHiddenInputProps(r), e);
  return /* @__PURE__ */ I.jsx(ve.input, { ...o, ref: n });
});
Qx.displayName = "SegmentGroupItemHiddenInput";
const qx = oe(
  (e, n) => {
    const t = Qg(), r = Ey(), o = be(
      t.getItemTextProps(r),
      Vf.build().itemText.attrs,
      e
    );
    return /* @__PURE__ */ I.jsx(ve.span, { ...o, ref: n });
  }
);
qx.displayName = "SegmentGroupItemText";
const RU = (e) => {
  const { getRootNode: n } = Jr(), { dir: t } = ko(), r = {
    id: gr(),
    dir: t,
    getRootNode: n,
    value: e.defaultValue,
    ...e
  }, o = {
    ...r,
    value: e.value,
    onValueChange: en(e.onValueChange, { sync: !0 })
  }, [a, l] = Or(zx(r), {
    context: o
  });
  return Yx(a, l, yr);
}, _x = oe((e, n) => {
  const [t, r] = Ft()(e, [
    "defaultValue",
    "disabled",
    "form",
    "id",
    "ids",
    "name",
    "onValueChange",
    "orientation",
    "readOnly",
    "value"
  ]), o = RU(t), a = be(
    o.getRootProps(),
    Vf.build().root.attrs,
    r
  );
  return /* @__PURE__ */ I.jsx(TU, { value: o, children: /* @__PURE__ */ I.jsx(ve.div, { ...a, ref: n }) });
});
_x.displayName = "SegmentGroupRoot";
const [OU, ms] = xt({
  name: "SelectContext",
  hookName: "useSelectContext",
  providerName: "<SelectProvider />"
}), $x = oe((e, n) => {
  const t = ms(), r = oa(), o = be(t.getContentProps(), r.getPresenceProps(n), e);
  return r.unmounted ? null : /* @__PURE__ */ I.jsx(ve.div, { ...o });
});
$x.displayName = "SelectContent";
const eT = oe((e, n) => {
  const t = ms(), r = be(t.getControlProps(), e);
  return /* @__PURE__ */ I.jsx(ve.div, { ...r, ref: n });
});
eT.displayName = "SelectControl";
const [DU, BY] = xt({
  name: "SelectItemContext",
  hookName: "useSelectItemContext",
  providerName: "<SelectItemProvider />"
}), [FU, tT] = xt({
  name: "SelectItemPropsContext",
  hookName: "useSelectItemPropsContext",
  providerName: "<SelectItemPropsProvider />"
}), nT = oe((e, n) => {
  const [t, r] = Ft()(e, ["item", "persistFocus"]), o = ms(), a = be(o.getItemProps(t), r), l = o.getItemState(t);
  return /* @__PURE__ */ I.jsx(FU, { value: t, children: /* @__PURE__ */ I.jsx(DU, { value: l, children: /* @__PURE__ */ I.jsx(ve.div, { ...a, ref: n }) }) });
});
nT.displayName = "SelectItem";
const [NU, MU] = xt({
  name: "SelectItemGroupPropsContext",
  hookName: "useSelectItemGroupPropsContext",
  providerName: "<SelectItemGroupPropsProvider />"
}), rT = oe((e, n) => {
  const t = gr(), [r, o] = Ft()(e, ["id"]), a = { id: t, ...r }, l = ms(), u = be(l.getItemGroupProps(a), o);
  return /* @__PURE__ */ I.jsx(NU, { value: a, children: /* @__PURE__ */ I.jsx(ve.div, { ...u, ref: n }) });
});
rT.displayName = "SelectItemGroup";
const oT = oe(
  (e, n) => {
    const t = ms(), r = MU(), o = be(
      t.getItemGroupLabelProps({ htmlFor: r.id }),
      e
    );
    return /* @__PURE__ */ I.jsx(ve.div, { ...o, ref: n });
  }
);
oT.displayName = "SelectItemGroupLabel";
const iT = oe(
  (e, n) => {
    const t = ms(), r = tT(), o = be(t.getItemIndicatorProps(r), e);
    return /* @__PURE__ */ I.jsx(ve.div, { ...o, ref: n });
  }
);
iT.displayName = "SelectItemIndicator";
const aT = oe((e, n) => {
  const t = ms(), r = tT(), o = be(t.getItemTextProps(r), e);
  return /* @__PURE__ */ I.jsx(ve.span, { ...o, ref: n });
});
aT.displayName = "SelectItemText";
const sT = oe((e, n) => {
  const t = ms(), r = be(t.getLabelProps(), e);
  return /* @__PURE__ */ I.jsx(ve.label, { ...r, ref: n });
});
sT.displayName = "SelectLabel";
const lT = oe((e, n) => {
  const t = ms(), r = be(t.getPositionerProps(), e);
  return oa().unmounted ? null : /* @__PURE__ */ I.jsx(ve.div, { ...r, ref: n });
});
lT.displayName = "SelectPositioner";
var ih = (e, n = []) => ({
  parts: (...t) => {
    if (LU(n))
      return ih(e, t);
    throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
  },
  extendWith: (...t) => ih(e, [...n, ...t]),
  rename: (t) => ih(t, n),
  keys: () => n,
  build: () => [...new Set(n)].reduce(
    (t, r) => Object.assign(t, {
      [r]: {
        selector: [
          `&[data-scope="${vf(e)}"][data-part="${vf(r)}"]`,
          `& [data-scope="${vf(e)}"][data-part="${vf(r)}"]`
        ].join(", "),
        attrs: { "data-scope": vf(e), "data-part": vf(r) }
      }
    }),
    {}
  )
}), vf = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), LU = (e) => e.length === 0, BU = ih("select").parts(
  "label",
  "positioner",
  "trigger",
  "indicator",
  "clearTrigger",
  "item",
  "itemText",
  "itemIndicator",
  "itemGroup",
  "itemGroupLabel",
  "content",
  "root",
  "control"
), _i = BU.build(), Ay = (e) => Hn(new Lh(e));
Ay.empty = () => Hn(new Lh({ items: [] }));
var ft = so({
  getRootId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.root) ?? `select:${e.id}`;
  },
  getContentId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.content) ?? `select:${e.id}:content`;
  },
  getTriggerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.trigger) ?? `select:${e.id}:trigger`;
  },
  getClearTriggerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.clearTrigger) ?? `select:${e.id}:clear-trigger`;
  },
  getLabelId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.label) ?? `select:${e.id}:label`;
  },
  getControlId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.control) ?? `select:${e.id}:control`;
  },
  getItemId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.item) == null ? void 0 : r.call(t, n)) ?? `select:${e.id}:option:${n}`;
  },
  getHiddenSelectId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.hiddenSelect) ?? `select:${e.id}:select`;
  },
  getPositionerId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.positioner) ?? `select:${e.id}:positioner`;
  },
  getItemGroupId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.itemGroup) == null ? void 0 : r.call(t, n)) ?? `select:${e.id}:optgroup:${n}`;
  },
  getItemGroupLabelId: (e, n) => {
    var t, r;
    return ((r = (t = e.ids) == null ? void 0 : t.itemGroupLabel) == null ? void 0 : r.call(t, n)) ?? `select:${e.id}:optgroup-label:${n}`;
  },
  getHiddenSelectEl: (e) => ft.getById(e, ft.getHiddenSelectId(e)),
  getContentEl: (e) => ft.getById(e, ft.getContentId(e)),
  getControlEl: (e) => ft.getById(e, ft.getControlId(e)),
  getTriggerEl: (e) => ft.getById(e, ft.getTriggerId(e)),
  getClearTriggerEl: (e) => ft.getById(e, ft.getClearTriggerId(e)),
  getPositionerEl: (e) => ft.getById(e, ft.getPositionerId(e)),
  getHighlightedOptionEl(e) {
    return e.highlightedValue ? ft.getById(e, ft.getItemId(e, e.highlightedValue)) : null;
  }
});
function VU(e, n, t) {
  const r = e.context.isDisabled, o = e.context.invalid, a = e.context.readOnly, l = e.context.isInteractive, u = e.context.composite, f = e.hasTag("open"), p = e.matches("focused"), y = e.context.highlightedValue, A = e.context.highlightedItem, w = e.context.selectedItems, F = e.context.isTypingAhead, j = y ? ft.getItemId(e.context, y) : void 0;
  function N(k) {
    const z = e.context.collection.isItemDisabled(k.item), q = e.context.collection.itemToValue(k.item);
    return {
      value: q,
      disabled: !!(r || z),
      highlighted: y === q,
      selected: e.context.value.includes(q)
    };
  }
  const D = Yg({
    ...e.context.positioning,
    placement: e.context.currentPlacement
  });
  return {
    open: f,
    focused: p,
    empty: e.context.value.length === 0,
    highlightedItem: A,
    highlightedValue: y,
    selectedItems: w,
    hasSelectedItems: e.context.hasSelectedItems,
    value: e.context.value,
    valueAsString: e.context.valueAsString,
    collection: e.context.collection,
    setCollection(k) {
      n({ type: "COLLECTION.SET", value: k });
    },
    reposition(k = {}) {
      n({ type: "POSITIONING.SET", options: k });
    },
    focus() {
      var k;
      (k = ft.getTriggerEl(e.context)) == null || k.focus({ preventScroll: !0 });
    },
    setOpen(k) {
      k !== f && n(k ? "OPEN" : "CLOSE");
    },
    selectValue(k) {
      n({ type: "ITEM.SELECT", value: k });
    },
    setValue(k) {
      n({ type: "VALUE.SET", value: k });
    },
    highlightValue(k) {
      n({ type: "HIGHLIGHTED_VALUE.SET", value: k });
    },
    clearValue(k) {
      n(k ? { type: "ITEM.CLEAR", value: k } : { type: "VALUE.CLEAR" });
    },
    getItemState: N,
    getRootProps() {
      return t.element({
        ..._i.root.attrs,
        dir: e.context.dir,
        id: ft.getRootId(e.context),
        "data-invalid": se(o),
        "data-readonly": se(a)
      });
    },
    getLabelProps() {
      return t.label({
        dir: e.context.dir,
        id: ft.getLabelId(e.context),
        ..._i.label.attrs,
        "data-disabled": se(r),
        "data-invalid": se(o),
        "data-readonly": se(a),
        htmlFor: ft.getHiddenSelectId(e.context),
        onClick(k) {
          var z;
          k.defaultPrevented || r || (z = ft.getTriggerEl(e.context)) == null || z.focus({ preventScroll: !0 });
        }
      });
    },
    getControlProps() {
      return t.element({
        ..._i.control.attrs,
        dir: e.context.dir,
        id: ft.getControlId(e.context),
        "data-state": f ? "open" : "closed",
        "data-focus": se(p),
        "data-disabled": se(r),
        "data-invalid": se(o)
      });
    },
    getTriggerProps() {
      return t.button({
        id: ft.getTriggerId(e.context),
        disabled: r,
        dir: e.context.dir,
        type: "button",
        role: "combobox",
        "aria-controls": ft.getContentId(e.context),
        "aria-expanded": f,
        "aria-haspopup": "listbox",
        "data-state": f ? "open" : "closed",
        "aria-invalid": o,
        "aria-labelledby": ft.getLabelId(e.context),
        ..._i.trigger.attrs,
        "data-disabled": se(r),
        "data-invalid": se(o),
        "data-readonly": se(a),
        "data-placement": e.context.currentPlacement,
        "data-placeholder-shown": se(!e.context.hasSelectedItems),
        onPointerDown(k) {
          rc(k) && l && (k.currentTarget.dataset.pointerType = k.pointerType, !(r || k.pointerType === "touch") && n({ type: "TRIGGER.CLICK" }));
        },
        onClick(k) {
          !l || k.button || k.currentTarget.dataset.pointerType === "touch" && n({ type: "TRIGGER.CLICK" });
        },
        onFocus() {
          n("TRIGGER.FOCUS");
        },
        onBlur() {
          n("TRIGGER.BLUR");
        },
        onKeyDown(k) {
          if (k.defaultPrevented || !l)
            return;
          const q = {
            ArrowUp() {
              n({ type: "TRIGGER.ARROW_UP" });
            },
            ArrowDown(Ce) {
              n({ type: Ce.altKey ? "OPEN" : "TRIGGER.ARROW_DOWN" });
            },
            ArrowLeft() {
              n({ type: "TRIGGER.ARROW_LEFT" });
            },
            ArrowRight() {
              n({ type: "TRIGGER.ARROW_RIGHT" });
            },
            Home() {
              n({ type: "TRIGGER.HOME" });
            },
            End() {
              n({ type: "TRIGGER.END" });
            },
            Enter() {
              n({ type: "TRIGGER.ENTER" });
            },
            Space(Ce) {
              n(F ? { type: "TRIGGER.TYPEAHEAD", key: Ce.key } : { type: "TRIGGER.ENTER" });
            }
          }[il(k, e.context)];
          if (q) {
            q(k), k.preventDefault();
            return;
          }
          Lg.isValidEvent(k) && (n({ type: "TRIGGER.TYPEAHEAD", key: k.key }), k.preventDefault());
        }
      });
    },
    getIndicatorProps() {
      return t.element({
        ..._i.indicator.attrs,
        dir: e.context.dir,
        "aria-hidden": !0,
        "data-state": f ? "open" : "closed",
        "data-disabled": se(r),
        "data-invalid": se(o),
        "data-readonly": se(a)
      });
    },
    getItemProps(k) {
      const z = N(k);
      return t.element({
        id: ft.getItemId(e.context, z.value),
        role: "option",
        ..._i.item.attrs,
        dir: e.context.dir,
        "data-value": z.value,
        "aria-selected": z.selected,
        "data-state": z.selected ? "checked" : "unchecked",
        "data-highlighted": se(z.highlighted),
        "data-disabled": se(z.disabled),
        "aria-disabled": Zr(z.disabled),
        onPointerMove(q) {
          z.disabled || q.pointerType !== "mouse" || z.value !== e.context.highlightedValue && n({ type: "ITEM.POINTER_MOVE", value: z.value });
        },
        onPointerUp() {
          z.disabled || n({ type: "ITEM.CLICK", src: "pointerup", value: z.value });
        },
        onPointerLeave(q) {
          z.disabled || k.persistFocus || q.pointerType !== "mouse" || ["CONTENT.ARROW_UP", "CONTENT.ARROW_DOWN"].includes(e.event.type) || n({ type: "ITEM.POINTER_LEAVE" });
        },
        onTouchEnd(q) {
          q.preventDefault(), q.stopPropagation();
        }
      });
    },
    getItemTextProps(k) {
      const z = N(k);
      return t.element({
        ..._i.itemText.attrs,
        "data-disabled": se(z.disabled),
        "data-highlighted": se(z.highlighted)
      });
    },
    getItemIndicatorProps(k) {
      const z = N(k);
      return t.element({
        "aria-hidden": !0,
        ..._i.itemIndicator.attrs,
        "data-state": z.selected ? "checked" : "unchecked",
        hidden: !z.selected
      });
    },
    getItemGroupLabelProps(k) {
      const { htmlFor: z } = k;
      return t.element({
        ..._i.itemGroupLabel.attrs,
        id: ft.getItemGroupLabelId(e.context, z),
        role: "group",
        dir: e.context.dir
      });
    },
    getItemGroupProps(k) {
      const { id: z } = k;
      return t.element({
        ..._i.itemGroup.attrs,
        "data-disabled": se(r),
        id: ft.getItemGroupId(e.context, z),
        "aria-labelledby": ft.getItemGroupLabelId(e.context, z),
        dir: e.context.dir
      });
    },
    getClearTriggerProps() {
      return t.button({
        ..._i.clearTrigger.attrs,
        id: ft.getClearTriggerId(e.context),
        type: "button",
        "aria-label": "Clear value",
        disabled: r,
        hidden: !e.context.hasSelectedItems,
        dir: e.context.dir,
        onClick(k) {
          k.defaultPrevented || n("VALUE.CLEAR");
        }
      });
    },
    getHiddenSelectProps() {
      return t.select({
        name: e.context.name,
        form: e.context.form,
        disabled: r,
        multiple: e.context.multiple,
        "aria-hidden": !0,
        id: ft.getHiddenSelectId(e.context),
        defaultValue: e.context.multiple ? e.context.value : e.context.value[0],
        style: Ff,
        tabIndex: -1,
        // Some browser extensions will focus the hidden select.
        // Let's forward the focus to the trigger.
        onFocus() {
          var k;
          (k = ft.getTriggerEl(e.context)) == null || k.focus({ preventScroll: !0 });
        },
        "aria-labelledby": ft.getLabelId(e.context)
      });
    },
    getPositionerProps() {
      return t.element({
        ..._i.positioner.attrs,
        dir: e.context.dir,
        id: ft.getPositionerId(e.context),
        style: D.floating
      });
    },
    getContentProps() {
      return t.element({
        hidden: !f,
        dir: e.context.dir,
        id: ft.getContentId(e.context),
        role: u ? "listbox" : "dialog",
        ..._i.content.attrs,
        "data-state": f ? "open" : "closed",
        "data-placement": e.context.currentPlacement,
        "data-activedescendant": j,
        "aria-activedescendant": u ? j : void 0,
        "aria-multiselectable": e.context.multiple && u ? !0 : void 0,
        "aria-labelledby": ft.getLabelId(e.context),
        tabIndex: 0,
        onKeyDown(k) {
          if (!l || !pb(k))
            return;
          if (k.key === "Tab" && !HA(k)) {
            k.preventDefault();
            return;
          }
          const z = {
            ArrowUp() {
              n({ type: "CONTENT.ARROW_UP" });
            },
            ArrowDown() {
              n({ type: "CONTENT.ARROW_DOWN" });
            },
            Home() {
              n({ type: "CONTENT.HOME" });
            },
            End() {
              n({ type: "CONTENT.END" });
            },
            Enter() {
              n({ type: "ITEM.CLICK", src: "keydown.enter" });
            },
            Space(Ce) {
              var ee;
              F ? n({ type: "CONTENT.TYPEAHEAD", key: Ce.key }) : (ee = z.Enter) == null || ee.call(z, Ce);
            }
          }, q = z[il(k)];
          if (q) {
            q(k), k.preventDefault();
            return;
          }
          Eb(k.target) || Lg.isValidEvent(k) && (n({ type: "CONTENT.TYPEAHEAD", key: k.key }), k.preventDefault());
        }
      });
    },
    getListProps() {
      return t.element({
        tabIndex: 0,
        role: u ? void 0 : "listbox",
        "aria-labelledby": ft.getTriggerId(e.context),
        "aria-activedescendant": u ? void 0 : j,
        "aria-multiselectable": !u && e.context.multiple ? !0 : void 0
      });
    }
  };
}
var { and: bf, not: sd, or: jU } = Ma;
function UU(e) {
  const n = br(e);
  return Rr(
    {
      id: "select",
      context: {
        value: [],
        highlightedValue: null,
        loopFocus: !1,
        closeOnSelect: !0,
        disabled: !1,
        composite: !0,
        ...n,
        highlightedItem: null,
        selectedItems: [],
        valueAsString: "",
        collection: n.collection ?? Ay.empty(),
        typeahead: Lg.defaultOptions,
        fieldsetDisabled: !1,
        restoreFocus: !0,
        positioning: {
          placement: "bottom-start",
          gutter: 8,
          ...n.positioning
        }
      },
      computed: {
        hasSelectedItems: (t) => t.value.length > 0,
        isTypingAhead: (t) => t.typeahead.keysSoFar !== "",
        isDisabled: (t) => !!t.disabled || t.fieldsetDisabled,
        isInteractive: (t) => !(t.isDisabled || t.readOnly)
      },
      initial: n.open ? "open" : "idle",
      created: ["syncCollection"],
      entry: ["syncSelectElement"],
      watch: {
        open: ["toggleVisibility"],
        value: ["syncSelectedItems", "syncSelectElement"],
        highlightedValue: ["syncHighlightedItem"],
        collection: ["syncCollection"]
      },
      on: {
        "HIGHLIGHTED_VALUE.SET": {
          actions: ["setHighlightedItem"]
        },
        "ITEM.SELECT": {
          actions: ["selectItem"]
        },
        "ITEM.CLEAR": {
          actions: ["clearItem"]
        },
        "VALUE.SET": {
          actions: ["setSelectedItems"]
        },
        "VALUE.CLEAR": {
          actions: ["clearSelectedItems"]
        },
        "COLLECTION.SET": {
          actions: ["setCollection"]
        }
      },
      activities: ["trackFormControlState"],
      states: {
        idle: {
          tags: ["closed"],
          on: {
            "CONTROLLED.OPEN": [
              {
                guard: "isTriggerClickEvent",
                target: "open",
                actions: ["highlightFirstSelectedItem"]
              },
              {
                target: "open"
              }
            ],
            "TRIGGER.CLICK": [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["invokeOnOpen", "highlightFirstSelectedItem"]
              }
            ],
            "TRIGGER.FOCUS": {
              target: "focused"
            },
            OPEN: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["invokeOnOpen"]
              }
            ]
          }
        },
        focused: {
          tags: ["closed"],
          entry: ["setFinalFocus"],
          on: {
            "CONTROLLED.OPEN": [
              {
                guard: "isTriggerClickEvent",
                target: "open",
                actions: ["highlightFirstSelectedItem"]
              },
              {
                guard: "isTriggerArrowUpEvent",
                target: "open",
                actions: ["highlightComputedLastItem"]
              },
              {
                guard: jU("isTriggerArrowDownEvent", "isTriggerEnterEvent"),
                target: "open",
                actions: ["highlightComputedFirstItem"]
              },
              {
                target: "open"
              }
            ],
            OPEN: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["invokeOnOpen"]
              }
            ],
            "TRIGGER.BLUR": {
              target: "idle"
            },
            "TRIGGER.CLICK": [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["invokeOnOpen", "highlightFirstSelectedItem"]
              }
            ],
            "TRIGGER.ENTER": [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["invokeOnOpen", "highlightComputedFirstItem"]
              }
            ],
            "TRIGGER.ARROW_UP": [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["invokeOnOpen", "highlightComputedLastItem"]
              }
            ],
            "TRIGGER.ARROW_DOWN": [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["invokeOnOpen", "highlightComputedFirstItem"]
              }
            ],
            "TRIGGER.ARROW_LEFT": [
              {
                guard: bf(sd("multiple"), "hasSelectedItems"),
                actions: ["selectPreviousItem"]
              },
              {
                guard: sd("multiple"),
                actions: ["selectLastItem"]
              }
            ],
            "TRIGGER.ARROW_RIGHT": [
              {
                guard: bf(sd("multiple"), "hasSelectedItems"),
                actions: ["selectNextItem"]
              },
              {
                guard: sd("multiple"),
                actions: ["selectFirstItem"]
              }
            ],
            "TRIGGER.HOME": {
              guard: sd("multiple"),
              actions: ["selectFirstItem"]
            },
            "TRIGGER.END": {
              guard: sd("multiple"),
              actions: ["selectLastItem"]
            },
            "TRIGGER.TYPEAHEAD": {
              guard: sd("multiple"),
              actions: ["selectMatchingItem"]
            }
          }
        },
        open: {
          tags: ["open"],
          entry: ["setInitialFocus"],
          exit: ["scrollContentToTop"],
          activities: ["trackDismissableElement", "computePlacement", "scrollToHighlightedItem"],
          on: {
            "CONTROLLED.CLOSE": [
              {
                guard: "shouldRestoreFocus",
                target: "focused",
                actions: ["clearHighlightedItem"]
              },
              {
                target: "idle",
                actions: ["clearHighlightedItem"]
              }
            ],
            CLOSE: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnClose"]
              },
              {
                target: "focused",
                actions: ["invokeOnClose", "clearHighlightedItem"]
              }
            ],
            "TRIGGER.CLICK": [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnClose"]
              },
              {
                target: "focused",
                actions: ["invokeOnClose", "clearHighlightedItem"]
              }
            ],
            "ITEM.CLICK": [
              {
                guard: bf("closeOnSelect", "isOpenControlled"),
                actions: ["selectHighlightedItem", "invokeOnClose"]
              },
              {
                guard: "closeOnSelect",
                target: "focused",
                actions: ["selectHighlightedItem", "invokeOnClose", "clearHighlightedItem"]
              },
              {
                actions: ["selectHighlightedItem"]
              }
            ],
            "CONTENT.INTERACT_OUTSIDE": [
              // == group 1 ==
              {
                guard: bf("shouldRestoreFocus", "isOpenControlled"),
                actions: ["invokeOnClose"]
              },
              {
                guard: "shouldRestoreFocus",
                target: "focused",
                actions: ["invokeOnClose", "clearHighlightedItem"]
              },
              // == group 2 ==
              {
                guard: "isOpenControlled",
                actions: ["invokeOnClose"]
              },
              {
                target: "idle",
                actions: ["invokeOnClose", "clearHighlightedItem"]
              }
            ],
            "CONTENT.HOME": {
              actions: ["highlightFirstItem"]
            },
            "CONTENT.END": {
              actions: ["highlightLastItem"]
            },
            "CONTENT.ARROW_DOWN": [
              {
                guard: bf("hasHighlightedItem", "loop", "isLastItemHighlighted"),
                actions: ["highlightFirstItem"]
              },
              {
                guard: "hasHighlightedItem",
                actions: ["highlightNextItem"]
              },
              {
                actions: ["highlightFirstItem"]
              }
            ],
            "CONTENT.ARROW_UP": [
              {
                guard: bf("hasHighlightedItem", "loop", "isFirstItemHighlighted"),
                actions: ["highlightLastItem"]
              },
              {
                guard: "hasHighlightedItem",
                actions: ["highlightPreviousItem"]
              },
              {
                actions: ["highlightLastItem"]
              }
            ],
            "CONTENT.TYPEAHEAD": {
              actions: ["highlightMatchingItem"]
            },
            "ITEM.POINTER_MOVE": {
              actions: ["highlightItem"]
            },
            "ITEM.POINTER_LEAVE": {
              actions: ["clearHighlightedItem"]
            },
            "POSITIONING.SET": {
              actions: ["reposition"]
            }
          }
        }
      }
    },
    {
      guards: {
        loop: (t) => !!t.loopFocus,
        multiple: (t) => !!t.multiple,
        hasSelectedItems: (t) => !!t.hasSelectedItems,
        hasHighlightedItem: (t) => t.highlightedValue != null,
        isFirstItemHighlighted: (t) => t.highlightedValue === t.collection.first(),
        isLastItemHighlighted: (t) => t.highlightedValue === t.collection.last(),
        closeOnSelect: (t, r) => t.multiple ? !1 : !!(r.closeOnSelect ?? t.closeOnSelect),
        shouldRestoreFocus: (t) => !!t.restoreFocus,
        // guard assertions (for controlled mode)
        isOpenControlled: (t) => !!t["open.controlled"],
        isTriggerClickEvent: (t, r) => {
          var o;
          return ((o = r.previousEvent) == null ? void 0 : o.type) === "TRIGGER.CLICK";
        },
        isTriggerEnterEvent: (t, r) => {
          var o;
          return ((o = r.previousEvent) == null ? void 0 : o.type) === "TRIGGER.ENTER";
        },
        isTriggerArrowUpEvent: (t, r) => {
          var o;
          return ((o = r.previousEvent) == null ? void 0 : o.type) === "TRIGGER.ARROW_UP";
        },
        isTriggerArrowDownEvent: (t, r) => {
          var o;
          return ((o = r.previousEvent) == null ? void 0 : o.type) === "TRIGGER.ARROW_DOWN";
        }
      },
      activities: {
        trackFormControlState(t, r, { initialContext: o }) {
          return jf(ft.getHiddenSelectEl(t), {
            onFieldsetDisabledChange(a) {
              t.fieldsetDisabled = a;
            },
            onFormReset() {
              Qn.selectedItems(t, o.value);
            }
          });
        },
        trackDismissableElement(t, r, { send: o }) {
          return Uf(() => ft.getContentEl(t), {
            defer: !0,
            exclude: [ft.getTriggerEl(t), ft.getClearTriggerEl(t)],
            onFocusOutside: t.onFocusOutside,
            onPointerDownOutside: t.onPointerDownOutside,
            onInteractOutside(l) {
              var u;
              (u = t.onInteractOutside) == null || u.call(t, l), t.restoreFocus = !l.detail.focusable;
            },
            onDismiss() {
              o({ type: "CONTENT.INTERACT_OUTSIDE" });
            }
          });
        },
        computePlacement(t) {
          return t.currentPlacement = t.positioning.placement, uu(() => ft.getTriggerEl(t), () => ft.getPositionerEl(t), {
            defer: !0,
            ...t.positioning,
            onComplete(a) {
              t.currentPlacement = a.placement;
            }
          });
        },
        scrollToHighlightedItem(t, r, { getState: o }) {
          const a = (u) => {
            if (o().event.type.includes("POINTER"))
              return;
            const p = ft.getHighlightedOptionEl(t), y = ft.getContentEl(t);
            if (t.scrollToIndexFn) {
              const A = t.collection.indexOf(t.highlightedValue);
              t.scrollToIndexFn({ index: A, immediate: u });
              return;
            }
            wb(p, { rootEl: y, block: "nearest" });
          };
          return Ct(() => a(!0)), Dh(() => ft.getContentEl(t), {
            defer: !0,
            attributes: ["data-activedescendant"],
            callback() {
              a(!1);
            }
          });
        }
      },
      actions: {
        reposition(t, r) {
          const o = () => ft.getPositionerEl(t);
          uu(ft.getTriggerEl(t), o, {
            ...t.positioning,
            ...r.options,
            defer: !0,
            listeners: !1,
            onComplete(a) {
              t.currentPlacement = a.placement;
            }
          });
        },
        toggleVisibility(t, r, { send: o }) {
          o({ type: t.open ? "CONTROLLED.OPEN" : "CONTROLLED.CLOSE", previousEvent: r });
        },
        highlightPreviousItem(t) {
          if (t.highlightedValue == null)
            return;
          const r = t.collection.prev(t.highlightedValue);
          Qn.highlightedItem(t, r);
        },
        highlightNextItem(t) {
          if (t.highlightedValue == null)
            return;
          const r = t.collection.next(t.highlightedValue);
          Qn.highlightedItem(t, r);
        },
        highlightFirstItem(t) {
          const r = t.collection.first();
          Qn.highlightedItem(t, r);
        },
        highlightLastItem(t) {
          const r = t.collection.last();
          Qn.highlightedItem(t, r);
        },
        setInitialFocus(t) {
          Ct(() => {
            const r = Cb({
              root: ft.getContentEl(t)
            });
            r == null || r.focus({ preventScroll: !0 });
          });
        },
        setFinalFocus(t) {
          Ct(() => {
            var r;
            (r = ft.getTriggerEl(t)) == null || r.focus({ preventScroll: !0 });
          });
        },
        selectHighlightedItem(t, r) {
          const o = r.value ?? t.highlightedValue;
          o != null && Qn.selectedItem(t, o);
        },
        highlightComputedFirstItem(t) {
          const r = t.hasSelectedItems ? t.collection.sort(t.value)[0] : t.collection.first();
          Qn.highlightedItem(t, r);
        },
        highlightComputedLastItem(t) {
          const r = t.hasSelectedItems ? t.collection.sort(t.value)[0] : t.collection.last();
          Qn.highlightedItem(t, r);
        },
        highlightFirstSelectedItem(t) {
          if (!t.hasSelectedItems)
            return;
          const [r] = t.collection.sort(t.value);
          Qn.highlightedItem(t, r);
        },
        highlightItem(t, r) {
          Qn.highlightedItem(t, r.value);
        },
        highlightMatchingItem(t, r) {
          const o = t.collection.search(r.key, {
            state: t.typeahead,
            currentValue: t.highlightedValue
          });
          o != null && Qn.highlightedItem(t, o);
        },
        setHighlightedItem(t, r) {
          Qn.highlightedItem(t, r.value);
        },
        clearHighlightedItem(t) {
          Qn.highlightedItem(t, null, !0);
        },
        selectItem(t, r) {
          Qn.selectedItem(t, r.value);
        },
        clearItem(t, r) {
          const o = t.value.filter((a) => a !== r.value);
          Qn.selectedItems(t, o);
        },
        setSelectedItems(t, r) {
          Qn.selectedItems(t, r.value);
        },
        clearSelectedItems(t) {
          Qn.selectedItems(t, []);
        },
        selectPreviousItem(t) {
          const r = t.collection.prev(t.value[0]);
          Qn.selectedItem(t, r);
        },
        selectNextItem(t) {
          const r = t.collection.next(t.value[0]);
          Qn.selectedItem(t, r);
        },
        selectFirstItem(t) {
          const r = t.collection.first();
          Qn.selectedItem(t, r);
        },
        selectLastItem(t) {
          const r = t.collection.last();
          Qn.selectedItem(t, r);
        },
        selectMatchingItem(t, r) {
          const o = t.collection.search(r.key, {
            state: t.typeahead,
            currentValue: t.value[0]
          });
          o != null && Qn.selectedItem(t, o);
        },
        scrollContentToTop(t) {
          var r;
          t.scrollToIndexFn ? t.scrollToIndexFn({ index: 0, immediate: !0 }) : (r = ft.getContentEl(t)) == null || r.scrollTo(0, 0);
        },
        invokeOnOpen(t) {
          var r;
          (r = t.onOpenChange) == null || r.call(t, { open: !0 });
        },
        invokeOnClose(t) {
          var r;
          (r = t.onOpenChange) == null || r.call(t, { open: !1 });
        },
        syncSelectElement(t) {
          const r = ft.getHiddenSelectEl(t);
          if (r) {
            if (t.value.length === 0 && !t.multiple) {
              r.selectedIndex = -1;
              return;
            }
            for (const o of r.options)
              o.selected = t.value.includes(o.value);
          }
        },
        setCollection(t, r) {
          t.collection = r.value;
        },
        syncCollection(t) {
          const r = t.collection.items(t.value), o = t.collection.itemsToString(r);
          t.highlightedItem = t.collection.item(t.highlightedValue), t.selectedItems = r, t.valueAsString = o;
        },
        syncSelectedItems(t) {
          xh.valueChange(t);
        },
        syncHighlightedItem(t) {
          xh.highlightChange(t);
        }
      }
    }
  );
}
function WU(e) {
  Ct(() => {
    const n = ft.getHiddenSelectEl(e);
    if (!n)
      return;
    const t = ft.getWin(e), r = new t.Event("change", { bubbles: !0, composed: !0 });
    n.dispatchEvent(r);
  });
}
var xh = {
  valueChange: (e) => {
    const n = e.selectedItems;
    e.selectedItems = e.value.map((t) => {
      const r = n.find((o) => e.collection.itemToValue(o) === t);
      return r || e.collection.item(t);
    }), e.valueAsString = e.collection.itemsToString(e.selectedItems);
  },
  highlightChange: (e) => {
    e.highlightedItem = e.collection.item(e.highlightedValue);
  }
}, Pp = {
  valueChange: (e) => {
    var n;
    xh.valueChange(e), (n = e.onValueChange) == null || n.call(e, {
      value: Array.from(e.value),
      items: Array.from(e.selectedItems)
    }), WU(e);
  },
  highlightChange: (e) => {
    var n;
    xh.highlightChange(e), (n = e.onHighlightChange) == null || n.call(e, {
      highlightedValue: e.highlightedValue,
      highlightedItem: e.highlightedItem,
      highlightedIndex: e.collection.indexOf(e.highlightedValue)
    });
  }
}, Qn = {
  selectedItem: (e, n, t = !1) => {
    if (!vr(e.value, n) && !(n == null && !t)) {
      if (n == null && t) {
        e.value = [], Pp.valueChange(e);
        return;
      }
      e.value = e.multiple ? JA(e.value, n) : [n], Pp.valueChange(e);
    }
  },
  selectedItems: (e, n) => {
    vr(e.value, n) || (e.value = n, Pp.valueChange(e));
  },
  highlightedItem: (e, n, t = !1) => {
    vr(e.highlightedValue, n) || n == null && !t || (e.highlightedValue = n ?? null, Pp.highlightChange(e));
  }
};
nn()([
  "closeOnSelect",
  "collection",
  "dir",
  "disabled",
  "form",
  "getRootNode",
  "highlightedValue",
  "id",
  "ids",
  "invalid",
  "loopFocus",
  "multiple",
  "name",
  "onFocusOutside",
  "onHighlightChange",
  "onInteractOutside",
  "onOpenChange",
  "onPointerDownOutside",
  "onValueChange",
  "open.controlled",
  "open",
  "composite",
  "positioning",
  "readOnly",
  "scrollToIndexFn",
  "value"
]);
nn()(["item", "persistFocus"]);
nn()(["id"]);
nn()(["htmlFor"]);
const HU = (e) => {
  const [n, t] = Ft()(e, [
    "isItemDisabled",
    "itemToValue",
    "itemToString",
    "items"
  ]), r = oc(
    () => Ay(n),
    Object.values(n)
  ), { getRootNode: o } = Jr(), { dir: a } = ko(), l = {
    id: gr(),
    dir: a,
    getRootNode: o,
    collection: r,
    open: e.defaultOpen,
    value: e.defaultValue,
    "open.controlled": e.open !== void 0,
    ...t
  }, u = {
    ...l,
    collection: r,
    value: e.value,
    onValueChange: en(e.onValueChange, { sync: !0 }),
    onHighlightChange: en(e.onHighlightChange),
    onOpenChange: en(e.onOpenChange)
  }, [f, p] = Or(UU(l), {
    context: u
  });
  return VU(f, p, yr);
}, GU = (e, n) => {
  const [t, r] = fu(e), [o, a] = Ft()(r, [
    "closeOnSelect",
    "composite",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "form",
    "highlightedValue",
    "id",
    "ids",
    "invalid",
    "isItemDisabled",
    "items",
    "itemToString",
    "itemToValue",
    "loopFocus",
    "multiple",
    "name",
    "onFocusOutside",
    "onHighlightChange",
    "onInteractOutside",
    "onOpenChange",
    "onPointerDownOutside",
    "onValueChange",
    "open",
    "positioning",
    "readOnly",
    "scrollToIndexFn",
    "value"
  ]), l = HU(o), u = cc(be({ present: l.open }, t)), f = be(l.getRootProps(), a);
  return /* @__PURE__ */ I.jsx(OU, { value: l, children: /* @__PURE__ */ I.jsx(Ad, { value: u, children: /* @__PURE__ */ I.jsx(ve.div, { ...f, ref: n }) }) });
}, YU = oe(GU), cT = oe((e, n) => {
  const t = ms(), r = be(t.getTriggerProps(), e);
  return /* @__PURE__ */ I.jsx(ve.button, { ...r, ref: n });
});
cT.displayName = "SelectTrigger";
const uT = oe((e, n) => {
  const { children: t, placeholder: r, ...o } = e, a = ms();
  return /* @__PURE__ */ I.jsx(ve.span, { ...lw.build().valueText.attrs, ...o, ref: n, children: t || a.valueAsString || r });
});
uT.displayName = "SelectValueText";
const [zU, Sy] = xt({
  name: "SwitchContext",
  hookName: "useSwitchContext",
  providerName: "<SwitchProvider />"
}), dT = oe((e, n) => {
  const t = Sy(), r = be(t.getControlProps(), e);
  return /* @__PURE__ */ I.jsx(ve.span, { ...r, ref: n });
});
dT.displayName = "SwitchControl";
const fT = oe(
  (e, n) => {
    const t = Sy(), r = be(t.getHiddenInputProps(), e);
    return /* @__PURE__ */ I.jsx(ve.input, { ...r, ref: n });
  }
);
fT.displayName = "SwitchHiddenInput";
var ah = (e, n = []) => ({
  parts: (...t) => {
    if (ZU(n))
      return ah(e, t);
    throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
  },
  extendWith: (...t) => ah(e, [...n, ...t]),
  rename: (t) => ah(t, n),
  keys: () => n,
  build: () => [...new Set(n)].reduce(
    (t, r) => Object.assign(t, {
      [r]: {
        selector: [
          `&[data-scope="${yf(e)}"][data-part="${yf(r)}"]`,
          `& [data-scope="${yf(e)}"][data-part="${yf(r)}"]`
        ].join(", "),
        attrs: { "data-scope": yf(e), "data-part": yf(r) }
      }
    }),
    {}
  )
}), yf = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), ZU = (e) => e.length === 0, KU = ah("switch").parts("root", "label", "control", "thumb"), kp = KU.build(), Kr = so({
  getRootId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.root) ?? `switch:${e.id}`;
  },
  getLabelId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.label) ?? `switch:${e.id}:label`;
  },
  getThumbId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.thumb) ?? `switch:${e.id}:thumb`;
  },
  getControlId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.control) ?? `switch:${e.id}:control`;
  },
  getRootEl: (e) => Kr.getById(e, Kr.getRootId(e)),
  getHiddenInputId: (e) => {
    var n;
    return ((n = e.ids) == null ? void 0 : n.input) ?? `switch:${e.id}:input`;
  },
  getHiddenInputEl: (e) => Kr.getById(e, Kr.getHiddenInputId(e))
});
function XU(e, n, t) {
  const r = e.context.isDisabled, o = !r && e.context.focused, a = e.context.checked, l = e.context.readOnly, u = {
    "data-active": se(e.context.active),
    "data-focus": se(o),
    "data-readonly": se(l),
    "data-hover": se(e.context.hovered),
    "data-disabled": se(r),
    "data-state": e.context.checked ? "checked" : "unchecked",
    "data-invalid": se(e.context.invalid)
  };
  return {
    checked: a,
    disabled: r,
    focused: o,
    setChecked(f) {
      n({ type: "CHECKED.SET", checked: f, isTrusted: !1 });
    },
    toggleChecked() {
      n({ type: "CHECKED.TOGGLE", checked: a, isTrusted: !1 });
    },
    getRootProps() {
      return t.label({
        ...kp.root.attrs,
        ...u,
        dir: e.context.dir,
        id: Kr.getRootId(e.context),
        htmlFor: Kr.getHiddenInputId(e.context),
        onPointerMove() {
          r || n({ type: "CONTEXT.SET", context: { hovered: !0 } });
        },
        onPointerLeave() {
          r || n({ type: "CONTEXT.SET", context: { hovered: !1 } });
        },
        onClick(f) {
          f.target === Kr.getHiddenInputEl(e.context) && f.stopPropagation();
        }
      });
    },
    getLabelProps() {
      return t.element({
        ...kp.label.attrs,
        ...u,
        dir: e.context.dir,
        id: Kr.getLabelId(e.context)
      });
    },
    getThumbProps() {
      return t.element({
        ...kp.thumb.attrs,
        ...u,
        dir: e.context.dir,
        id: Kr.getThumbId(e.context),
        "aria-hidden": !0
      });
    },
    getControlProps() {
      return t.element({
        ...kp.control.attrs,
        ...u,
        dir: e.context.dir,
        id: Kr.getControlId(e.context),
        "aria-hidden": !0
      });
    },
    getHiddenInputProps() {
      return t.input({
        id: Kr.getHiddenInputId(e.context),
        type: "checkbox",
        required: e.context.required,
        defaultChecked: a,
        disabled: r,
        "aria-labelledby": Kr.getLabelId(e.context),
        "aria-invalid": e.context.invalid,
        name: e.context.name,
        form: e.context.form,
        value: e.context.value,
        style: Ff,
        onChange(f) {
          if (l) {
            f.preventDefault();
            return;
          }
          const p = f.currentTarget.checked;
          n({ type: "CHECKED.SET", checked: p, isTrusted: !0 });
        }
      });
    }
  };
}
var { not: YC } = Ma;
function JU(e) {
  const n = br(e);
  return Rr(
    {
      id: "switch",
      initial: "ready",
      context: {
        checked: !1,
        label: "switch",
        value: "on",
        disabled: !1,
        ...n,
        fieldsetDisabled: !1
      },
      computed: {
        isDisabled: (t) => t.disabled || t.fieldsetDisabled
      },
      watch: {
        disabled: "removeFocusIfNeeded",
        checked: "syncInputElement"
      },
      activities: ["trackFormControlState", "trackPressEvent", "trackFocusVisible"],
      on: {
        "CHECKED.TOGGLE": [
          {
            guard: YC("isTrusted"),
            actions: ["toggleChecked", "dispatchChangeEvent"]
          },
          {
            actions: ["toggleChecked"]
          }
        ],
        "CHECKED.SET": [
          {
            guard: YC("isTrusted"),
            actions: ["setChecked", "dispatchChangeEvent"]
          },
          {
            actions: ["setChecked"]
          }
        ],
        "CONTEXT.SET": {
          actions: ["setContext"]
        }
      },
      states: {
        ready: {}
      }
    },
    {
      guards: {
        isTrusted: (t, r) => !!r.isTrusted
      },
      activities: {
        trackPressEvent(t) {
          if (!t.isDisabled)
            return zA({
              pointerNode: Kr.getRootEl(t),
              keyboardNode: Kr.getHiddenInputEl(t),
              isValidKey: (r) => r.key === " ",
              onPress: () => t.active = !1,
              onPressStart: () => t.active = !0,
              onPressEnd: () => t.active = !1
            });
        },
        trackFocusVisible(t) {
          if (!t.isDisabled)
            return YA(Kr.getHiddenInputEl(t), {
              onFocus: () => t.focused = !0,
              onBlur: () => t.focused = !1
            });
        },
        trackFormControlState(t, r, { send: o, initialContext: a }) {
          return jf(Kr.getHiddenInputEl(t), {
            onFieldsetDisabledChange(l) {
              t.fieldsetDisabled = l;
            },
            onFormReset() {
              o({ type: "CHECKED.SET", checked: !!a.checked, src: "form-reset" });
            }
          });
        }
      },
      actions: {
        setContext(t, r) {
          Object.assign(t, r.context);
        },
        syncInputElement(t) {
          const r = Kr.getHiddenInputEl(t);
          r && (r.checked = !!t.checked);
        },
        removeFocusIfNeeded(t) {
          t.disabled && t.focused && (t.focused = !1);
        },
        setChecked(t, r) {
          zC.checked(t, r.checked);
        },
        toggleChecked(t, r) {
          zC.checked(t, !t.checked);
        },
        dispatchChangeEvent(t) {
          const r = Kr.getHiddenInputEl(t);
          Kb(r, { checked: t.checked });
        }
      }
    }
  );
}
var QU = {
  change: (e) => {
    var n;
    (n = e.onCheckedChange) == null || n.call(e, { checked: e.checked });
  }
}, zC = {
  checked: (e, n) => {
    vr(e.checked, n) || (e.checked = n, QU.change(e));
  }
};
nn()([
  "checked",
  "dir",
  "disabled",
  "form",
  "getRootNode",
  "id",
  "ids",
  "invalid",
  "label",
  "name",
  "onCheckedChange",
  "readOnly",
  "required",
  "value"
]);
const qU = (e) => {
  const { getRootNode: n } = Jr(), { dir: t } = ko(), r = {
    id: gr(),
    dir: t,
    getRootNode: n,
    checked: e.defaultChecked,
    ...e
  }, o = {
    ...r,
    checked: e.checked,
    onCheckedChange: en(e.onCheckedChange, { sync: !0 })
  }, [a, l] = Or(JU(r), { context: o });
  return XU(a, l, yr);
}, gT = oe((e, n) => {
  const [t, r] = Ft()(e, [
    "checked",
    "defaultChecked",
    "disabled",
    "form",
    "id",
    "ids",
    "invalid",
    "label",
    "name",
    "onCheckedChange",
    "readOnly",
    "required",
    "value"
  ]), o = qU(t), a = be(o.getRootProps(), r);
  return /* @__PURE__ */ I.jsx(zU, { value: o, children: /* @__PURE__ */ I.jsx(ve.label, { ...a, ref: n }) });
});
gT.displayName = "SwitchRoot";
const pT = oe((e, n) => {
  const t = Sy(), r = be(t.getThumbProps(), e);
  return /* @__PURE__ */ I.jsx(ve.span, { ...r, ref: n });
});
pT.displayName = "SwitchThumb";
var sh = (e, n = []) => ({
  parts: (...t) => {
    if (_U(n))
      return sh(e, t);
    throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
  },
  extendWith: (...t) => sh(e, [...n, ...t]),
  rename: (t) => sh(t, n),
  keys: () => n,
  build: () => [...new Set(n)].reduce(
    (t, r) => Object.assign(t, {
      [r]: {
        selector: [
          `&[data-scope="${Cf(e)}"][data-part="${Cf(r)}"]`,
          `& [data-scope="${Cf(e)}"][data-part="${Cf(r)}"]`
        ].join(", "),
        attrs: { "data-scope": Cf(e), "data-part": Cf(r) }
      }
    }),
    {}
  )
}), Cf = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), _U = (e) => e.length === 0, $U = sh("toast").parts(
  "group",
  "root",
  "title",
  "description",
  "actionTrigger",
  "closeTrigger"
), Af = $U.build(), Ai = so({
  getRegionId: (e) => `toast-group:${e}`,
  getRegionEl: (e, n) => Ai.getById(e, `toast-group:${n}`),
  getRootId: (e) => `toast:${e.id}`,
  getRootEl: (e) => Ai.getById(e, Ai.getRootId(e)),
  getTitleId: (e) => `toast:${e.id}:title`,
  getDescriptionId: (e) => `toast:${e.id}:description`,
  getCloseTriggerId: (e) => `toast${e.id}:close`
});
function wy(e, n) {
  return e.filter((t) => t.state.context.placement === n);
}
var ZC = {
  info: 5e3,
  error: 5e3,
  success: 2e3,
  loading: 1 / 0,
  DEFAULT: 5e3
};
function KC(e, n) {
  return e ?? ZC[n] ?? ZC.DEFAULT;
}
function eW(e, n) {
  var y;
  const t = e.offsets, r = typeof t == "string" ? { left: t, right: t, bottom: t, top: t } : t, o = e.dir === "rtl", a = n.replace("-start", o ? "-right" : "-left").replace("-end", o ? "-left" : "-right"), l = a.includes("right"), u = a.includes("left"), f = {
    position: "fixed",
    pointerEvents: e.count > 0 ? void 0 : "none",
    display: "flex",
    flexDirection: "column",
    "--gap": `${e.gap}px`,
    "--first-height": `${((y = e.heights[0]) == null ? void 0 : y.height) || 0}px`,
    zIndex: FA
  };
  let p = "center";
  if (l && (p = "flex-end"), u && (p = "flex-start"), f.alignItems = p, a.includes("top")) {
    const A = r.top;
    f.top = `max(env(safe-area-inset-top, 0px), ${A})`;
  }
  if (a.includes("bottom")) {
    const A = r.bottom;
    f.bottom = `max(env(safe-area-inset-bottom, 0px), ${A})`;
  }
  if (!a.includes("left")) {
    const A = r.right;
    f.insetInlineEnd = `calc(env(safe-area-inset-right, 0px) + ${A})`;
  }
  if (!a.includes("right")) {
    const A = r.left;
    f.insetInlineStart = `calc(env(safe-area-inset-left, 0px) + ${A})`;
  }
  return f;
}
function tW(e, n) {
  const [t] = e.placement.split("-"), r = !e.frontmost, o = !e.stacked, a = {
    position: "absolute",
    pointerEvents: "auto",
    "--opacity": "0",
    "--remove-delay": `${e.removeDelay}ms`,
    "--duration": `${e.type === "loading" ? Number.MAX_SAFE_INTEGER : e.duration}ms`,
    "--initial-height": `${e.height}px`,
    "--offset": `${e.offset}px`,
    "--index": e.index,
    "--z-index": e.zIndex,
    "--lift-amount": "calc(var(--lift) * var(--gap))",
    "--y": "100%",
    "--x": "0"
  }, l = (u) => Object.assign(a, u);
  return t === "top" ? l({
    top: "0",
    "--sign": "-1",
    "--y": "-100%",
    "--lift": "1"
  }) : t === "bottom" && l({
    bottom: "0",
    "--sign": "1",
    "--y": "100%",
    "--lift": "-1"
  }), e.mounted && (l({
    "--y": "0",
    "--opacity": "1"
  }), e.stacked && l({
    "--y": "calc(var(--lift) * var(--offset))",
    "--height": "var(--initial-height)"
  })), n || l({
    "--opacity": "0",
    pointerEvents: "none"
  }), r && o && (l({
    "--base-scale": "var(--index) * 0.05 + 1",
    "--y": "calc(var(--lift-amount) * var(--index))",
    "--scale": "calc(-1 * var(--base-scale))",
    "--height": "var(--first-height)"
  }), n || l({
    "--y": "calc(var(--sign) * 40%)"
  })), r && e.stacked && !n && l({
    "--y": "calc(var(--lift) * var(--offset) + var(--lift) * -100%)"
  }), e.frontmost && !n && l({
    "--y": "calc(var(--lift) * -100%)"
  }), a;
}
function nW(e, n) {
  const t = {
    position: "absolute",
    inset: "0",
    scale: "1 2",
    pointerEvents: n ? "none" : "auto"
  }, r = (o) => Object.assign(t, o);
  return e.frontmost && !n && r({
    height: "calc(var(--initial-height) + 80%)"
  }), t;
}
function rW(e, n) {
  return {
    position: "absolute",
    left: "0",
    height: "calc(var(--gap) + 2px)",
    bottom: "100%",
    width: "100%"
  };
}
function oW(e, n, t) {
  function r() {
    return kF(e) ? e.getState() : e;
  }
  function o(y) {
    return wy(r().context.toasts, y);
  }
  function a(y) {
    const A = r().context.toasts;
    return A.length ? !!A.find((w) => w.id == y) : !1;
  }
  function l(y) {
    const A = `toast:${XD()}`, w = y.id ? y.id : A;
    return a(w) || n({ type: "ADD_TOAST", toast: { ...y, id: w } }), w;
  }
  function u(y, A) {
    return a(y) && n({ type: "UPDATE_TOAST", id: y, toast: A }), y;
  }
  function f(y) {
    const { id: A } = y;
    return (A ? a(A) : !1) && A != null ? u(A, y) : l(y);
  }
  function p(y) {
    y == null ? n("DISMISS_ALL") : a(y) && n({ type: "DISMISS_TOAST", id: y });
  }
  return {
    getCount() {
      return r().context.count;
    },
    getPlacements() {
      const A = r().context.toasts.map((w) => w.state.context.placement);
      return Array.from(new Set(A));
    },
    getToastsByPlacement: o,
    isVisible: a,
    create: l,
    update: u,
    upsert: f,
    dismiss: p,
    remove(y) {
      y == null ? n("REMOVE_ALL") : a(y) && n({ type: "REMOVE_TOAST", id: y });
    },
    dismissByPlacement(y) {
      o(y).forEach((w) => p(w.id));
    },
    loading(y) {
      return f({ ...y, type: "loading" });
    },
    success(y) {
      return f({ ...y, type: "success" });
    },
    error(y) {
      return f({ ...y, type: "error" });
    },
    promise(y, A, w = {}) {
      const F = f({ ...w, ...A.loading, type: "loading" });
      return Bp(y).then((j) => {
        const N = Bp(A.success, j);
        f({ ...w, ...N, id: F, type: "success" });
      }).catch((j) => {
        const N = Bp(A.error, j);
        f({ ...w, ...N, id: F, type: "error" });
      }).finally(() => {
        var j;
        (j = A.finally) == null || j.call(A);
      }), F;
    },
    pause(y) {
      y == null ? n("PAUSE_ALL") : a(y) && n({ type: "PAUSE_TOAST", id: y });
    },
    resume(y) {
      y == null ? n("RESUME_ALL") : a(y) && n({ type: "RESUME_TOAST", id: y });
    },
    getGroupProps(y) {
      const { placement: A, label: w = "Notifications" } = y, F = r(), j = F.context.hotkey.join("+").replace(/Key/g, "").replace(/Digit/g, ""), [N, D = "center"] = A.split("-");
      return t.element({
        ...Af.group.attrs,
        dir: F.context.dir,
        tabIndex: -1,
        "aria-label": `${A} ${w} ${j}`,
        id: Ai.getRegionId(A),
        "data-placement": A,
        "data-side": N,
        "data-align": D,
        "aria-live": "polite",
        role: "region",
        style: eW(F.context, A),
        onMouseMove() {
          n({ type: "REGION.POINTER_ENTER", placement: A });
        },
        onMouseLeave() {
          n({ type: "REGION.POINTER_LEAVE", placement: A });
        },
        onFocus(k) {
          n({ type: "REGION.FOCUS", target: k.relatedTarget });
        },
        onBlur(k) {
          F.context.isFocusWithin && !ol(k.currentTarget, k.relatedTarget) && n({ type: "REGION.BLUR" });
        }
      });
    },
    subscribe(y) {
      const A = r();
      return ch(A.context.toasts, () => {
        const F = o(A.context.placement).map((j) => j.getState().context);
        y(F);
      });
    }
  };
}
var { not: iW, and: aW, or: sW } = Ma;
function lW(e) {
  const { type: n = "info", duration: t, id: r = "1", placement: o = "bottom", removeDelay: a = 200, ...l } = e, u = br(l), f = KC(t, n);
  return Rr(
    {
      id: r,
      context: {
        id: r,
        type: n,
        remaining: f,
        duration: f,
        removeDelay: a,
        createdAt: Date.now(),
        placement: o,
        ...u,
        height: 0,
        offset: 0,
        frontmost: !1,
        mounted: !1,
        index: -1,
        zIndex: 0
      },
      initial: n === "loading" ? "visible:persist" : "visible",
      on: {
        UPDATE: [
          {
            guard: aW("hasTypeChanged", "isChangingToLoading"),
            target: "visible:persist",
            actions: ["setContext"]
          },
          {
            guard: sW("hasDurationChanged", "hasTypeChanged"),
            target: "visible:updating",
            actions: ["setContext"]
          },
          {
            actions: ["setContext"]
          }
        ],
        MEASURE: {
          actions: ["measureHeight"]
        }
      },
      entry: ["invokeOnVisible"],
      activities: ["trackHeight"],
      states: {
        "visible:updating": {
          tags: ["visible", "updating"],
          after: {
            0: "visible"
          }
        },
        "visible:persist": {
          tags: ["visible", "paused"],
          on: {
            RESUME: {
              guard: iW("isLoadingType"),
              target: "visible",
              actions: ["setCreatedAt"]
            },
            DISMISS: "dismissing"
          }
        },
        visible: {
          tags: ["visible"],
          after: {
            VISIBLE_DURATION: "dismissing"
          },
          on: {
            DISMISS: "dismissing",
            PAUSE: {
              target: "visible:persist",
              actions: "setRemainingDuration"
            }
          }
        },
        dismissing: {
          entry: "invokeOnDismiss",
          after: {
            REMOVE_DELAY: {
              target: "unmounted",
              actions: "notifyParentToRemove"
            }
          }
        },
        unmounted: {
          entry: "invokeOnUnmount",
          type: "final"
        }
      }
    },
    {
      activities: {
        trackHeight(p, y, { self: A }) {
          let w;
          return Ct(() => {
            const F = Ai.getRootEl(p);
            if (!F)
              return;
            p.mounted = !0;
            const j = $s(F, "[data-ghost]");
            Fh(
              j.length !== 2,
              "[toast] No ghost element found in toast. Render the `ghostBefore` and `ghostAfter` elements"
            );
            const N = () => {
              const z = F.style.height;
              F.style.height = "auto";
              const q = F.getBoundingClientRect().height;
              F.style.height = z, p.height = q, A.sendParent({ type: "UPDATE_HEIGHT", id: A.id, height: q, placement: p.placement });
            };
            N();
            const D = Ai.getWin(p), k = new D.MutationObserver(N);
            k.observe(F, { childList: !0, subtree: !0, characterData: !0 }), w = () => k.disconnect();
          }), () => w == null ? void 0 : w();
        }
      },
      guards: {
        isChangingToLoading: (p, y) => {
          var A;
          return ((A = y.toast) == null ? void 0 : A.type) === "loading";
        },
        isLoadingType: (p) => p.type === "loading",
        hasTypeChanged: (p, y) => {
          var A;
          return ((A = y.toast) == null ? void 0 : A.type) != null && y.toast.type !== p.type;
        },
        hasDurationChanged: (p, y) => {
          var A;
          return ((A = y.toast) == null ? void 0 : A.duration) != null && y.toast.duration !== p.duration;
        }
      },
      delays: {
        VISIBLE_DURATION: (p) => p.remaining,
        REMOVE_DELAY: (p) => p.removeDelay
      },
      actions: {
        measureHeight(p, y, { self: A }) {
          Ct(() => {
            const w = Ai.getRootEl(p);
            if (!w)
              return;
            p.mounted = !0;
            const F = w.style.height;
            w.style.height = "auto";
            const j = w.getBoundingClientRect().height;
            w.style.height = F, p.height = j, A.sendParent({ type: "UPDATE_HEIGHT", id: A.id, height: j, placement: p.placement });
          });
        },
        setRemainingDuration(p) {
          p.remaining -= Date.now() - p.createdAt;
        },
        setCreatedAt(p) {
          p.createdAt = Date.now();
        },
        notifyParentToRemove(p, y, { self: A }) {
          A.sendParent({ type: "REMOVE_TOAST", id: A.id });
        },
        invokeOnDismiss(p) {
          var y;
          (y = p.onStatusChange) == null || y.call(p, { status: "dismissing" });
        },
        invokeOnUnmount(p) {
          var y;
          (y = p.onStatusChange) == null || y.call(p, { status: "unmounted" });
        },
        invokeOnVisible(p) {
          var y;
          (y = p.onStatusChange) == null || y.call(p, { status: "visible" });
        },
        setContext(p, y) {
          var j, N;
          const A = (j = y.toast) == null ? void 0 : j.duration, w = ((N = y.toast) == null ? void 0 : N.type) ?? p.type, F = KC(A, w);
          Object.assign(p, {
            ...y.toast,
            duration: F,
            remaining: F
          });
        }
      }
    }
  );
}
function cW(e) {
  const n = br(e);
  return Rr(
    {
      id: "toaster",
      initial: n.overlap ? "overlap" : "stack",
      context: {
        dir: "ltr",
        max: Number.MAX_SAFE_INTEGER,
        gap: 16,
        pauseOnPageIdle: !1,
        hotkey: ["altKey", "KeyT"],
        offsets: "1rem",
        placement: "bottom",
        removeDelay: 200,
        ...n,
        toasts: [],
        lastFocusedEl: null,
        isFocusWithin: !1,
        heights: []
      },
      computed: {
        count: (t) => t.toasts.length
      },
      activities: ["trackDocumentVisibility", "trackHotKeyPress"],
      watch: {
        toasts: ["collapsedIfEmpty", "setDismissableBranch"]
      },
      exit: ["removeToasts", "clearDismissableBranch", "clearLastFocusedEl"],
      on: {
        PAUSE_TOAST: {
          actions: ["pauseToast"]
        },
        PAUSE_ALL: {
          actions: ["pauseToasts"]
        },
        RESUME_TOAST: {
          actions: ["resumeToast"]
        },
        RESUME_ALL: {
          actions: ["resumeToasts"]
        },
        ADD_TOAST: {
          guard: "isWithinRange",
          actions: ["createToast", "syncToastIndex"]
        },
        UPDATE_TOAST: {
          actions: ["updateToast"]
        },
        DISMISS_TOAST: {
          actions: ["dismissToast"]
        },
        DISMISS_ALL: {
          actions: ["dismissToasts"]
        },
        REMOVE_TOAST: {
          actions: ["removeToast", "syncToastIndex", "syncToastOffset"]
        },
        REMOVE_ALL: {
          actions: ["removeToasts"]
        },
        UPDATE_HEIGHT: {
          actions: ["syncHeights", "syncToastOffset"]
        },
        "DOC.HOTKEY": {
          actions: ["focusRegionEl"]
        },
        "REGION.BLUR": [
          {
            guard: "isOverlapping",
            target: "overlap",
            actions: ["resumeToasts", "restoreLastFocusedEl"]
          },
          {
            actions: ["resumeToasts", "restoreLastFocusedEl"]
          }
        ]
      },
      states: {
        stack: {
          entry: ["expandToasts"],
          on: {
            "REGION.POINTER_LEAVE": [
              {
                guard: "isOverlapping",
                target: "overlap",
                actions: ["resumeToasts"]
              },
              {
                actions: ["resumeToasts"]
              }
            ],
            "REGION.OVERLAP": {
              target: "overlap"
            },
            "REGION.FOCUS": {
              actions: ["setLastFocusedEl", "pauseToasts"]
            },
            "REGION.POINTER_ENTER": {
              actions: ["pauseToasts"]
            }
          }
        },
        overlap: {
          entry: ["collapseToasts"],
          on: {
            "REGION.STACK": {
              target: "stack"
            },
            "REGION.POINTER_ENTER": {
              target: "stack",
              actions: ["pauseToasts"]
            },
            "REGION.FOCUS": {
              target: "stack",
              actions: ["setLastFocusedEl", "pauseToasts"]
            }
          }
        }
      }
    },
    {
      guards: {
        isWithinRange: (t) => t.toasts.length < t.max,
        isOverlapping: (t) => !!t.overlap
      },
      activities: {
        trackHotKeyPress(t, r, { send: o }) {
          return Dn(document, "keydown", (l) => {
            t.hotkey.every((f) => l[f] || l.code === f) && o({ type: "DOC.HOTKEY" });
          }, { capture: !0 });
        },
        trackDocumentVisibility(t, r, { send: o }) {
          if (!t.pauseOnPageIdle)
            return;
          const a = Ai.getDoc(t);
          return Dn(a, "visibilitychange", () => {
            o(a.visibilityState === "hidden" ? "PAUSE_ALL" : "RESUME_ALL");
          });
        }
      },
      actions: {
        setDismissableBranch(t) {
          var l;
          const o = wy(t.toasts, t.placement).length > 0;
          if (!o) {
            (l = t._cleanup) == null || l.call(t);
            return;
          }
          if (o && t._cleanup)
            return;
          const a = () => Ai.getRegionEl(t, t.placement);
          t._cleanup = PB(a, { defer: !0 });
        },
        clearDismissableBranch(t) {
          var r;
          (r = t._cleanup) == null || r.call(t);
        },
        focusRegionEl(t) {
          queueMicrotask(() => {
            var r;
            (r = Ai.getRegionEl(t, t.placement)) == null || r.focus();
          });
        },
        expandToasts(t) {
          Rp(t, (r) => {
            r.state.context.stacked = !0;
          });
        },
        collapseToasts(t) {
          Rp(t, (r) => {
            r.state.context.stacked = !1;
          });
        },
        collapsedIfEmpty(t, r, { send: o }) {
          !t.overlap || t.toasts.length > 1 || o("REGION.OVERLAP");
        },
        pauseToast(t, r, { self: o }) {
          o.sendChild("PAUSE", r.id);
        },
        pauseToasts(t) {
          t.toasts.forEach((r) => r.send("PAUSE"));
        },
        resumeToast(t, r, { self: o }) {
          o.sendChild("RESUME", r.id);
        },
        resumeToasts(t) {
          t.toasts.forEach((r) => r.send("RESUME"));
        },
        measureToasts(t) {
          t.toasts.forEach((r) => r.send("MEASURE"));
        },
        createToast(t, r, { self: o, getState: a }) {
          const l = {
            placement: t.placement,
            duration: t.duration,
            removeDelay: t.removeDelay,
            ...r.toast,
            dir: t.dir,
            getRootNode: t.getRootNode,
            stacked: a().matches("stack")
          }, u = lW(l), f = o.spawn(u);
          t.toasts = [f, ...t.toasts];
        },
        updateToast(t, r, { self: o }) {
          o.sendChild({ type: "UPDATE", toast: r.toast }, r.id);
        },
        dismissToast(t, r, { self: o }) {
          o.sendChild("DISMISS", r.id);
        },
        dismissToasts(t) {
          t.toasts.forEach((r) => r.send("DISMISS"));
        },
        removeToast(t, r, { self: o }) {
          o.stopChild(r.id), t.toasts = t.toasts.filter((a) => a.id !== r.id), t.heights = t.heights.filter((a) => a.id !== r.id);
        },
        removeToasts(t, r, { self: o }) {
          t.toasts.forEach((a) => o.stopChild(a.id)), t.toasts = [], t.heights = [];
        },
        syncHeights(t, r) {
          const o = t.heights.find((a) => a.id === r.id);
          if (o)
            o.height = r.height, o.placement = r.placement;
          else {
            const a = { id: r.id, height: r.height, placement: r.placement };
            t.heights = [a, ...t.heights];
          }
        },
        syncToastIndex(t) {
          Rp(t, (r, o, a) => {
            r.state.context.index = o, r.state.context.frontmost = o === 0, r.state.context.zIndex = a.length - o;
          });
        },
        syncToastOffset(t, r) {
          const o = r.placement ?? t.placement;
          Rp({ ...t, placement: o }, (a) => {
            const l = Math.max(
              t.heights.findIndex((f) => f.id === a.id),
              0
            ), u = t.heights.reduce((f, p, y) => y >= l ? f : f + p.height, 0);
            a.state.context.offset = l * t.gap + u;
          });
        },
        setLastFocusedEl(t, r) {
          t.isFocusWithin || !r.target || (t.isFocusWithin = !0, t.lastFocusedEl = Hn(r.target));
        },
        restoreLastFocusedEl(t) {
          t.isFocusWithin = !1, t.lastFocusedEl && (t.lastFocusedEl.focus({ preventScroll: !0 }), t.lastFocusedEl = null);
        },
        clearLastFocusedEl(t) {
          t.lastFocusedEl && (t.lastFocusedEl.focus({ preventScroll: !0 }), t.lastFocusedEl = null, t.isFocusWithin = !1);
        }
      }
    }
  );
}
function Rp(e, n) {
  wy(e.toasts, e.placement).forEach(n);
}
function uW(e, n, t) {
  const r = e.hasTag("visible"), o = e.hasTag("paused"), a = e.context.placement, l = e.context.type, [u, f = "center"] = a.split("-");
  return {
    type: l,
    title: e.context.title,
    description: e.context.description,
    placement: a,
    visible: r,
    paused: o,
    pause() {
      n("PAUSE");
    },
    resume() {
      n("RESUME");
    },
    dismiss() {
      n("DISMISS");
    },
    getRootProps() {
      return t.element({
        ...Af.root.attrs,
        dir: e.context.dir,
        id: Ai.getRootId(e.context),
        "data-state": r ? "open" : "closed",
        "data-type": l,
        "data-placement": a,
        "data-align": f,
        "data-side": u,
        "data-mounted": se(e.context.mounted),
        "data-paused": se(o),
        "data-first": se(e.context.frontmost),
        "data-sibling": se(!e.context.frontmost),
        "data-stack": se(e.context.stacked),
        "data-overlap": se(!e.context.stacked),
        role: "status",
        "aria-atomic": "true",
        tabIndex: 0,
        style: tW(e.context, r),
        onKeyDown(p) {
          p.defaultPrevented || p.key == "Escape" && (n("DISMISS"), p.preventDefault());
        }
      });
    },
    /* Leave a ghost div to avoid setting hover to false when transitioning out */
    getGhostBeforeProps() {
      return t.element({
        "data-ghost": "before",
        style: nW(e.context, r)
      });
    },
    /* Needed to avoid setting hover to false when in between toasts */
    getGhostAfterProps() {
      return t.element({
        "data-ghost": "after",
        style: rW(e.context)
      });
    },
    getTitleProps() {
      return t.element({
        ...Af.title.attrs,
        id: Ai.getTitleId(e.context)
      });
    },
    getDescriptionProps() {
      return t.element({
        ...Af.description.attrs,
        id: Ai.getDescriptionId(e.context)
      });
    },
    getActionTriggerProps() {
      return t.button({
        ...Af.actionTrigger.attrs,
        type: "button",
        onClick(p) {
          p.defaultPrevented || n("DISMISS");
        }
      });
    },
    getCloseTriggerProps() {
      return t.button({
        id: Ai.getCloseTriggerId(e.context),
        ...Af.closeTrigger.attrs,
        type: "button",
        "aria-label": "Dismiss notification",
        onClick(p) {
          p.defaultPrevented || n("DISMISS");
        }
      });
    }
  };
}
var nb = {
  connect: oW,
  machine: cW
};
const dW = (e) => {
  const n = nb.machine({ id: "1", ...e });
  return { ...nb.connect(n, n.send, yr), machine: n };
}, [fW, Gh] = xt({
  name: "ToastContext",
  hookName: "useToastContext",
  providerName: "<ToastProvider />"
}), hT = oe(
  (e, n) => {
    const t = Gh(), r = be(t.getCloseTriggerProps(), e);
    return /* @__PURE__ */ I.jsx(ve.button, { ...r, ref: n });
  }
);
hT.displayName = "ToastCloseTrigger";
const mT = oe((e, n) => {
  const t = Gh(), r = be(t.getDescriptionProps(), e);
  return /* @__PURE__ */ I.jsx(ve.div, { ...r, ref: n });
});
mT.displayName = "ToastDescription";
const vT = oe((e, n) => {
  const t = Gh(), r = be(t.getRootProps(), e);
  return /* @__PURE__ */ I.jsxs("div", { ...r, ref: n, children: [
    /* @__PURE__ */ I.jsx("div", { ...t.getGhostBeforeProps() }),
    e.children,
    /* @__PURE__ */ I.jsx("div", { ...t.getGhostAfterProps() })
  ] });
});
vT.displayName = "ToastRoot";
const bT = oe((e, n) => {
  const t = Gh(), r = be(t.getTitleProps(), e);
  return /* @__PURE__ */ I.jsx(ve.div, { ...r, ref: n });
});
bT.displayName = "ToastTitle";
const yT = oe((e, n) => {
  const { toaster: t, children: r, ...o } = e, [a, l] = Or(t.machine), u = a.context.placement, f = nb.connect(a, l, yr), p = f.getToastsByPlacement(u), y = be(f.getGroupProps({ placement: u }), o);
  return /* @__PURE__ */ I.jsx(ve.div, { ...y, ref: n, children: p.map((A) => /* @__PURE__ */ I.jsx(gW, { value: A, children: (w) => r(w) }, A.id)) });
});
yT.displayName = "Toaster";
const gW = (e) => {
  const [n, t] = YF(e.value), r = uW(n, t, yr);
  return /* @__PURE__ */ I.jsx(fW, { value: r, children: e.children(n.context) });
}, pW = (e) => typeof e == "function", hW = (e, ...n) => pW(e) ? e(...n) : e, mW = (e) => {
  const { value: n, children: t } = e, [r, o] = du(), a = oc(() => () => hW(n) ?? (r == null ? void 0 : r.ownerDocument) ?? document, [n, r]), l = oc(
    () => ({
      getRootNode: a,
      getWindow: () => cl(a()),
      getDocument: () => Df(a())
    }),
    [a]
  );
  return /* @__PURE__ */ I.jsxs(rN, { value: l, children: [
    t,
    !n && /* @__PURE__ */ I.jsx("span", { hidden: !0, ref: o })
  ] });
};
function jg(e) {
  return typeof e == "object" && e != null && !Array.isArray(e);
}
function Yh(e) {
  return Object.fromEntries(Object.entries(e ?? {}).filter(([n, t]) => t !== void 0));
}
var vW = (e) => e === "base";
function bW(e) {
  return e.slice().filter((n) => !vW(n));
}
function XC(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
}
function yW(e) {
  let n = "", t;
  for (t = Math.abs(e); t > 52; t = t / 52 | 0)
    n = XC(t % 52) + n;
  return XC(t % 52) + n;
}
function CW(e, n) {
  let t = n.length;
  for (; t; )
    e = e * 33 ^ n.charCodeAt(--t);
  return e;
}
function EW(e) {
  return yW(CW(5381, e) >>> 0);
}
var CT = /\s*!(important)?/i;
function AW(e) {
  return typeof e == "string" ? CT.test(e) : !1;
}
function SW(e) {
  return typeof e == "string" ? e.replace(CT, "").trim() : e;
}
function ET(e) {
  return typeof e == "string" ? e.replaceAll(" ", "_") : e;
}
var Hf = (e) => {
  const n = /* @__PURE__ */ new Map();
  return (...r) => {
    const o = JSON.stringify(r);
    if (n.has(o))
      return n.get(o);
    const a = e(...r);
    return n.set(o, a), a;
  };
};
function Iy(...e) {
  return e.filter(Boolean).reduce((t, r) => (Object.keys(r).forEach((o) => {
    const a = t[o], l = r[o];
    jg(a) && jg(l) ? t[o] = Iy(a, l) : t[o] = l;
  }), t), {});
}
var wW = (e) => e != null;
function xy(e, n, t = {}) {
  const { stop: r, getKey: o } = t;
  function a(l, u = []) {
    if (jg(l) || Array.isArray(l)) {
      const f = {};
      for (const [p, y] of Object.entries(l)) {
        const A = (o == null ? void 0 : o(p, y)) ?? p, w = [...u, A];
        if (r != null && r(l, w))
          return n(l, u);
        const F = a(y, w);
        wW(F) && (f[A] = F);
      }
      return f;
    }
    return n(l, u);
  }
  return a(e);
}
function IW(e, n) {
  return Array.isArray(e) ? e.map((t) => n(t)) : jg(e) ? xy(e, (t) => n(t)) : n(e);
}
function xW(e, n) {
  return e.reduce(
    (t, r, o) => {
      const a = n[o];
      return r != null && (t[a] = r), t;
    },
    {}
  );
}
function AT(e, n, t = !0) {
  const { utility: r, conditions: o } = n, { hasShorthand: a, resolveShorthand: l } = r;
  return xy(
    e,
    (u) => Array.isArray(u) ? xW(u, o.breakpoints.keys) : u,
    {
      stop: (u) => Array.isArray(u),
      getKey: t ? (u) => a ? l(u) : u : void 0
    }
  );
}
var TW = {
  shift: (e) => e,
  finalize: (e) => e,
  breakpoints: { keys: [] }
}, PW = (e) => typeof e == "string" ? e.replaceAll(/[\n\s]+/g, " ") : e;
function kW(e) {
  const { utility: n, hash: t, conditions: r = TW } = e, o = (l) => [n.prefix, l].filter(Boolean).join("-"), a = (l, u) => {
    let f;
    if (t) {
      const p = [...r.finalize(l), u];
      f = o(n.toHash(p, EW));
    } else
      f = [...r.finalize(l), o(u)].join(":");
    return f;
  };
  return Hf(({ base: l, ...u } = {}) => {
    const f = Object.assign(u, l), p = AT(f, e), y = /* @__PURE__ */ new Set();
    return xy(p, (A, w) => {
      const F = AW(A);
      if (A == null)
        return;
      const [j, ...N] = r.shift(w), D = bW(N), k = n.transform(j, SW(PW(A)));
      let z = a(D, k.className);
      F && (z = `${z}!`), y.add(z);
    }), Array.from(y).join(" ");
  });
}
function RW(...e) {
  return e.filter((n) => jg(n) && Object.keys(Yh(n)).length > 0);
}
function OW(e) {
  function n(o) {
    const a = RW(...o);
    return a.length === 1 ? a : a.map((l) => AT(l, e));
  }
  function t(...o) {
    return Iy(...n(o));
  }
  function r(...o) {
    return Object.assign({}, ...n(o));
  }
  return { mergeCss: Hf(t), assignCss: r };
}
var DW = /([A-Z])/g, FW = /^ms-/, NW = Hf((e) => e.startsWith("--") ? e : e.replace(DW, "-$1").replace(FW, "-ms-").toLowerCase()), MW = ["min", "max", "clamp", "calc"], LW = new RegExp(`^(${MW.join("|")})\\(.*\\)`), BW = (e) => typeof e == "string" && LW.test(e), VW = "cm,mm,Q,in,pc,pt,px,em,ex,ch,rem,lh,rlh,vw,vh,vmin,vmax,vb,vi,svw,svh,lvw,lvh,dvw,dvh,cqw,cqh,cqi,cqb,cqmin,cqmax,%", jW = `(?:${VW.split(",").join("|")})`, UW = new RegExp(`^[+-]?[0-9]*.?[0-9]+(?:[eE][+-]?[0-9]+)?${jW}$`), WW = (e) => typeof e == "string" && UW.test(e), HW = (e) => typeof e == "string" && /^var\(--.+\)$/.test(e), Gf = {
  map: IW,
  isCssFunction: BW,
  isCssVar: HW,
  isCssUnit: WW
}, Yf = (e, n) => {
  if (!(e != null && e.defaultValues))
    return n;
  const t = typeof e.defaultValues == "function" ? e.defaultValues(n) : e.defaultValues;
  return Object.assign({}, t, Yh(n));
}, GW = (e = {}) => {
  const n = (o) => {
    var a;
    return {
      className: [e.className, o].filter(Boolean).join("__"),
      base: ((a = e.base) == null ? void 0 : a[o]) ?? {},
      variants: {},
      defaultVariants: e.defaultVariants ?? {},
      compoundVariants: e.compoundVariants ? YW(e.compoundVariants, o) : []
    };
  }, r = (e.slots ?? []).map((o) => [o, n(o)]);
  for (const [o, a] of Object.entries(e.variants ?? {}))
    for (const [l, u] of Object.entries(a))
      r.forEach(([f, p]) => {
        var y;
        (y = p.variants)[o] ?? (y[o] = {}), p.variants[o][l] = u[f] ?? {};
      });
  return Object.fromEntries(r);
}, YW = (e, n) => e.filter((t) => t.css[n]).map((t) => ({ ...t, css: t.css[n] }));
function uc(e, ...n) {
  const t = Object.getOwnPropertyDescriptors(e), r = Object.keys(t), o = (l) => {
    const u = {};
    for (let f = 0; f < l.length; f++) {
      const p = l[f];
      t[p] && (Object.defineProperty(u, p, t[p]), delete t[p]);
    }
    return u;
  }, a = (l) => o(Array.isArray(l) ? l : r.filter(l));
  return n.map(a).concat(o(r));
}
var zW = (...e) => e.filter(Boolean).reduce((n, t) => Array.from(/* @__PURE__ */ new Set([...n, ...t])), []), ST = ["htmlSize", "htmlTranslate", "htmlWidth", "htmlHeight"];
function ZW(e) {
  return ST.includes(e) ? e.replace("html", "").toLowerCase() : e;
}
function rb(e) {
  return Object.fromEntries(Object.entries(e).map(([n, t]) => [ZW(n), t]));
}
rb.keys = ST;
const KW = "_hover,_focus,_focusWithin,_focusVisible,_disabled,_active,_visited,_target,_readOnly,_readWrite,_empty,_checked,_enabled,_expanded,_highlighted,_before,_after,_firstLetter,_firstLine,_marker,_selection,_file,_backdrop,_first,_last,_only,_even,_odd,_firstOfType,_lastOfType,_onlyOfType,_peerFocus,_peerHover,_peerActive,_peerFocusWithin,_peerFocusVisible,_peerDisabled,_peerChecked,_peerInvalid,_peerExpanded,_peerPlaceholderShown,_groupFocus,_groupHover,_groupActive,_groupFocusWithin,_groupFocusVisible,_groupDisabled,_groupChecked,_groupExpanded,_groupInvalid,_indeterminate,_required,_valid,_invalid,_autofill,_inRange,_outOfRange,_placeholder,_placeholderShown,_pressed,_selected,_default,_optional,_open,_closed,_fullscreen,_loading,_currentPage,_currentStep,_motionReduce,_motionSafe,_print,_landscape,_portrait,_dark,_light,_osDark,_osLight,_highContrast,_lessContrast,_moreContrast,_ltr,_rtl,_scrollbar,_scrollbarThumb,_scrollbarTrack,_horizontal,_vertical,_starting,sm,smOnly,smDown,md,mdOnly,mdDown,lg,lgOnly,lgDown,xl,xlOnly,xlDown,2xl,2xlOnly,2xlDown,smToMd,smToLg,smToXl,smTo2xl,mdToLg,mdToXl,mdTo2xl,lgToXl,lgTo2xl,xlTo2xl,@/xs,@/sm,@/md,@/lg,@/xl,@/2xl,@/3xl,@/4xl,@/5xl,@/6xl,@/7xl,@/8xl,base", wT = new Set(KW.split(","));
function JC(e) {
  return wT.has(e) || /^@|&|&$/.test(e);
}
const XW = /^_/, JW = /&|@/;
function QW(e) {
  return e.map((n) => wT.has(n) ? n.replace(XW, "") : JW.test(n) ? `[${ET(n.trim())}]` : n);
}
function qW(e) {
  return e.sort((n, t) => {
    const r = JC(n), o = JC(t);
    return r && !o ? 1 : !r && o ? -1 : 0;
  });
}
const _W = "aspectRatio:aspect,boxDecorationBreak:decoration,zIndex:z,boxSizing:box,objectPosition:obj-pos,objectFit:obj-fit,overscrollBehavior:overscroll,overscrollBehaviorX:overscroll-x,overscrollBehaviorY:overscroll-y,position:pos/1,top:top,left:left,insetInline:inset-x/insetX,insetBlock:inset-y/insetY,inset:inset,insetBlockEnd:inset-b,insetBlockStart:inset-t,insetInlineEnd:end/insetEnd/1,insetInlineStart:start/insetStart/1,right:right,bottom:bottom,float:float,visibility:vis,display:d,hideFrom:hide,hideBelow:show,flexBasis:basis,flex:flex,flexDirection:flex/flexDir,flexGrow:grow,flexShrink:shrink,gridTemplateColumns:grid-cols,gridTemplateRows:grid-rows,gridColumn:col-span,gridRow:row-span,gridColumnStart:col-start,gridColumnEnd:col-end,gridAutoFlow:grid-flow,gridAutoColumns:auto-cols,gridAutoRows:auto-rows,gap:gap,gridGap:gap,gridRowGap:gap-x,gridColumnGap:gap-y,rowGap:gap-x,columnGap:gap-y,justifyContent:justify,alignContent:content,alignItems:items,alignSelf:self,padding:p/1,paddingLeft:pl/1,paddingRight:pr/1,paddingTop:pt/1,paddingBottom:pb/1,paddingBlock:py/1/paddingY,paddingBlockEnd:pb,paddingBlockStart:pt,paddingInline:px/paddingX/1,paddingInlineEnd:pe/1/paddingEnd,paddingInlineStart:ps/1/paddingStart,marginLeft:ml/1,marginRight:mr/1,marginTop:mt/1,marginBottom:mb/1,margin:m/1,marginBlock:my/1/marginY,marginBlockEnd:mb,marginBlockStart:mt,marginInline:mx/1/marginX,marginInlineEnd:me/1/marginEnd,marginInlineStart:ms/1/marginStart,spaceX:space-x,spaceY:space-y,outlineWidth:ring-width/ringWidth,outlineColor:ring-color/ringColor,outline:ring/1,outlineOffset:ring-offset/ringOffset,divideX:divide-x,divideY:divide-y,divideColor:divide-color,divideStyle:divide-style,width:w/1,inlineSize:w,minWidth:min-w/minW,minInlineSize:min-w,maxWidth:max-w/maxW,maxInlineSize:max-w,height:h/1,blockSize:h,minHeight:min-h/minH,minBlockSize:min-h,maxHeight:max-h/maxH,maxBlockSize:max-b,color:text,fontFamily:font,fontSize:fs,fontWeight:fw,fontSmoothing:smoothing,fontVariantNumeric:numeric,letterSpacing:tracking,lineHeight:leading,textAlign:text-align,textDecoration:text-decor,textDecorationColor:text-decor-color,textEmphasisColor:text-emphasis-color,textDecorationStyle:decoration-style,textDecorationThickness:decoration-thickness,textUnderlineOffset:underline-offset,textTransform:text-transform,textIndent:indent,textShadow:text-shadow,textShadowColor:text-shadow/textShadowColor,textOverflow:text-overflow,verticalAlign:v-align,wordBreak:break,textWrap:text-wrap,truncate:truncate,lineClamp:clamp,listStyleType:list-type,listStylePosition:list-pos,listStyleImage:list-img,backgroundPosition:bg-pos/bgPosition,backgroundPositionX:bg-pos-x/bgPositionX,backgroundPositionY:bg-pos-y/bgPositionY,backgroundAttachment:bg-attach/bgAttachment,backgroundClip:bg-clip/bgClip,background:bg/1,backgroundColor:bg/bgColor,backgroundOrigin:bg-origin/bgOrigin,backgroundImage:bg-img/bgImage,backgroundRepeat:bg-repeat/bgRepeat,backgroundBlendMode:bg-blend/bgBlendMode,backgroundSize:bg-size/bgSize,backgroundGradient:bg-gradient/bgGradient,textGradient:text-gradient,gradientFromPosition:gradient-from-pos,gradientToPosition:gradient-to-pos,gradientFrom:gradient-from,gradientTo:gradient-to,gradientVia:gradient-via,gradientViaPosition:gradient-via-pos,borderRadius:rounded/1,borderTopLeftRadius:rounded-tl/roundedTopLeft,borderTopRightRadius:rounded-tr/roundedTopRight,borderBottomRightRadius:rounded-br/roundedBottomRight,borderBottomLeftRadius:rounded-bl/roundedBottomLeft,borderTopRadius:rounded-t/roundedTop,borderRightRadius:rounded-r/roundedRight,borderBottomRadius:rounded-b/roundedBottom,borderLeftRadius:rounded-l/roundedLeft,borderStartStartRadius:rounded-ss/roundedStartStart,borderStartEndRadius:rounded-se/roundedStartEnd,borderStartRadius:rounded-s/roundedStart,borderEndStartRadius:rounded-es/roundedEndStart,borderEndEndRadius:rounded-ee/roundedEndEnd,borderEndRadius:rounded-e/roundedEnd,border:border,borderWidth:border-w,borderTopWidth:border-tw,borderLeftWidth:border-lw,borderRightWidth:border-rw,borderBottomWidth:border-bw,borderColor:border,borderInline:border-x/borderX,borderInlineWidth:border-x/borderXWidth,borderInlineColor:border-x/borderXColor,borderBlock:border-y/borderY,borderBlockWidth:border-y/borderYWidth,borderBlockColor:border-y/borderYColor,borderLeft:border-l,borderLeftColor:border-l,borderInlineStart:border-s/borderStart,borderInlineStartWidth:border-s/borderStartWidth,borderInlineStartColor:border-s/borderStartColor,borderRight:border-r,borderRightColor:border-r,borderInlineEnd:border-e/borderEnd,borderInlineEndWidth:border-e/borderEndWidth,borderInlineEndColor:border-e/borderEndColor,borderTop:border-t,borderTopColor:border-t,borderBottom:border-b,borderBottomColor:border-b,borderBlockEnd:border-be,borderBlockEndColor:border-be,borderBlockStart:border-bs,borderBlockStartColor:border-bs,boxShadow:shadow/1,boxShadowColor:shadow-color/shadowColor,mixBlendMode:mix-blend,filter:filter,brightness:brightness,contrast:contrast,grayscale:grayscale,hueRotate:hue-rotate,invert:invert,saturate:saturate,sepia:sepia,dropShadow:drop-shadow,blur:blur,backdropFilter:backdrop,backdropBlur:backdrop-blur,backdropBrightness:backdrop-brightness,backdropContrast:backdrop-contrast,backdropGrayscale:backdrop-grayscale,backdropHueRotate:backdrop-hue-rotate,backdropInvert:backdrop-invert,backdropOpacity:backdrop-opacity,backdropSaturate:backdrop-saturate,backdropSepia:backdrop-sepia,borderCollapse:border,borderSpacing:border-spacing,borderSpacingX:border-spacing-x,borderSpacingY:border-spacing-y,tableLayout:table,transitionTimingFunction:ease,transitionDelay:delay,transitionDuration:duration,transitionProperty:transition-prop,transition:transition,animation:animation,animationName:animation-name,animationTimingFunction:animation-ease,animationDuration:animation-duration,animationDelay:animation-delay,transformOrigin:origin,rotate:rotate,rotateX:rotate-x,rotateY:rotate-y,rotateZ:rotate-z,scale:scale,scaleX:scale-x,scaleY:scale-y,translate:translate,translateX:translate-x/x,translateY:translate-y/y,translateZ:translate-z/z,accentColor:accent,caretColor:caret,scrollBehavior:scroll,scrollbar:scrollbar,scrollMargin:scroll-m,scrollMarginLeft:scroll-ml,scrollMarginRight:scroll-mr,scrollMarginTop:scroll-mt,scrollMarginBottom:scroll-mb,scrollMarginBlock:scroll-my/scrollMarginY,scrollMarginBlockEnd:scroll-mb,scrollMarginBlockStart:scroll-mt,scrollMarginInline:scroll-mx/scrollMarginX,scrollMarginInlineEnd:scroll-me,scrollMarginInlineStart:scroll-ms,scrollPadding:scroll-p,scrollPaddingBlock:scroll-pb/scrollPaddingY,scrollPaddingBlockStart:scroll-pt,scrollPaddingBlockEnd:scroll-pb,scrollPaddingInline:scroll-px/scrollPaddingX,scrollPaddingInlineEnd:scroll-pe,scrollPaddingInlineStart:scroll-ps,scrollPaddingLeft:scroll-pl,scrollPaddingRight:scroll-pr,scrollPaddingTop:scroll-pt,scrollPaddingBottom:scroll-pb,scrollSnapAlign:snap-align,scrollSnapStop:snap-stop,scrollSnapType:snap-type,scrollSnapStrictness:snap-strictness,scrollSnapMargin:snap-m,scrollSnapMarginTop:snap-mt,scrollSnapMarginBottom:snap-mb,scrollSnapMarginLeft:snap-ml,scrollSnapMarginRight:snap-mr,touchAction:touch,userSelect:select,fill:fill,stroke:stroke,strokeWidth:stroke-w,srOnly:sr,debug:debug,appearance:appearance,backfaceVisibility:backface,clipPath:clip-path,hyphens:hyphens,mask:mask,maskImage:mask-image,maskSize:mask-size,textSizeAdjust:text-adjust,container:cq,containerName:cq-name,containerType:cq-type,textStyle:textStyle", IT = /* @__PURE__ */ new Map(), xT = /* @__PURE__ */ new Map();
_W.split(",").forEach((e) => {
  const [n, t] = e.split(":"), [r, ...o] = t.split("/");
  IT.set(n, r), o.length && o.forEach((a) => {
    xT.set(a === "1" ? r : a, n);
  });
});
const QC = (e) => xT.get(e) || e, TT = {
  conditions: {
    shift: qW,
    finalize: QW,
    breakpoints: { keys: ["base", "sm", "md", "lg", "xl", "2xl"] }
  },
  utility: {
    transform: (e, n) => {
      const t = QC(e);
      return { className: `${IT.get(t) || NW(t)}_${ET(n)}` };
    },
    hasShorthand: !0,
    toHash: (e, n) => n(e.join(":")),
    resolveShorthand: QC
  }
}, $W = kW(TT), ni = (...e) => $W(pd(...e));
ni.raw = (...e) => pd(...e);
const { mergeCss: pd, assignCss: VY } = OW(TT);
function sc() {
  let e = "", n = 0, t;
  for (; n < arguments.length; )
    (t = arguments[n++]) && typeof t == "string" && (e && (e += " "), e += t);
  return e;
}
const qC = (e) => ({
  base: {},
  variants: {},
  defaultVariants: {},
  compoundVariants: [],
  ...e
});
function Ii(e) {
  const { base: n, variants: t, defaultVariants: r, compoundVariants: o } = qC(e), a = (w) => ({ ...r, ...Yh(w) });
  function l(w = {}) {
    var D;
    const F = a(w);
    let j = { ...n };
    for (const [k, z] of Object.entries(F))
      (D = t[k]) != null && D[z] && (j = pd(j, t[k][z]));
    const N = eH(o, F);
    return pd(j, N);
  }
  function u(w) {
    const F = qC(w.config), j = zW(w.variantKeys, Object.keys(t));
    return Ii({
      base: pd(n, F.base),
      variants: Object.fromEntries(
        j.map((N) => [N, pd(t[N], F.variants[N])])
      ),
      defaultVariants: Iy(r, F.defaultVariants),
      compoundVariants: [...o, ...F.compoundVariants]
    });
  }
  function f(w) {
    return ni(l(w));
  }
  const p = Object.keys(t);
  function y(w) {
    return uc(w, p);
  }
  const A = Object.fromEntries(Object.entries(t).map(([w, F]) => [w, Object.keys(F)]));
  return Object.assign(Hf(f), {
    __cva__: !0,
    variantMap: A,
    variantKeys: p,
    raw: l,
    config: e,
    merge: u,
    splitVariantProps: y,
    getVariantProps: a
  });
}
function eH(e, n) {
  let t = {};
  return e.forEach((r) => {
    Object.entries(r).every(([a, l]) => a === "css" ? !0 : (Array.isArray(l) ? l : [l]).some((f) => n[a] === f)) && (t = pd(t, r.css));
  }), t;
}
const tH = (e, n) => e + "__" + n;
function Ro(e) {
  const n = Object.entries(GW(e)).map(([y, A]) => [y, Ii(A)]), t = e.defaultVariants ?? {};
  function r(y) {
    const A = n.map(([w, F]) => [w, sc(F(y), e.className && tH(e.className, w))]);
    return Object.fromEntries(A);
  }
  function o(y) {
    const A = n.map(([w, F]) => [w, F.raw(y)]);
    return Object.fromEntries(A);
  }
  const a = e.variants ?? {}, l = Object.keys(a);
  function u(y) {
    return uc(y, l);
  }
  const f = (y) => ({ ...t || {}, ...Yh(y) }), p = Object.fromEntries(
    Object.entries(a).map(([y, A]) => [y, Object.keys(A)])
  );
  return Object.assign(Hf(r), {
    __cva__: !1,
    raw: o,
    variantMap: p,
    variantKeys: l,
    splitVariantProps: u,
    getVariantProps: f
  });
}
var nH = "css,pos,insetX,insetY,insetEnd,end,insetStart,start,flexDir,p,pl,pr,pt,pb,py,paddingY,paddingX,px,pe,paddingEnd,ps,paddingStart,ml,mr,mt,mb,m,my,marginY,mx,marginX,me,marginEnd,ms,marginStart,ringWidth,ringColor,ring,ringOffset,w,minW,maxW,h,minH,maxH,textShadowColor,bgPosition,bgPositionX,bgPositionY,bgAttachment,bgClip,bg,bgColor,bgOrigin,bgImage,bgRepeat,bgBlendMode,bgSize,bgGradient,rounded,roundedTopLeft,roundedTopRight,roundedBottomRight,roundedBottomLeft,roundedTop,roundedRight,roundedBottom,roundedLeft,roundedStartStart,roundedStartEnd,roundedStart,roundedEndStart,roundedEndEnd,roundedEnd,borderX,borderXWidth,borderXColor,borderY,borderYWidth,borderYColor,borderStart,borderStartWidth,borderStartColor,borderEnd,borderEndWidth,borderEndColor,shadow,shadowColor,x,y,z,scrollMarginY,scrollMarginX,scrollPaddingY,scrollPaddingX,aspectRatio,boxDecorationBreak,zIndex,boxSizing,objectPosition,objectFit,overscrollBehavior,overscrollBehaviorX,overscrollBehaviorY,position,top,left,insetInline,insetBlock,inset,insetBlockEnd,insetBlockStart,insetInlineEnd,insetInlineStart,right,bottom,float,visibility,display,hideFrom,hideBelow,flexBasis,flex,flexDirection,flexGrow,flexShrink,gridTemplateColumns,gridTemplateRows,gridColumn,gridRow,gridColumnStart,gridColumnEnd,gridAutoFlow,gridAutoColumns,gridAutoRows,gap,gridGap,gridRowGap,gridColumnGap,rowGap,columnGap,justifyContent,alignContent,alignItems,alignSelf,padding,paddingLeft,paddingRight,paddingTop,paddingBottom,paddingBlock,paddingBlockEnd,paddingBlockStart,paddingInline,paddingInlineEnd,paddingInlineStart,marginLeft,marginRight,marginTop,marginBottom,margin,marginBlock,marginBlockEnd,marginBlockStart,marginInline,marginInlineEnd,marginInlineStart,spaceX,spaceY,outlineWidth,outlineColor,outline,outlineOffset,divideX,divideY,divideColor,divideStyle,width,inlineSize,minWidth,minInlineSize,maxWidth,maxInlineSize,height,blockSize,minHeight,minBlockSize,maxHeight,maxBlockSize,color,fontFamily,fontSize,fontWeight,fontSmoothing,fontVariantNumeric,letterSpacing,lineHeight,textAlign,textDecoration,textDecorationColor,textEmphasisColor,textDecorationStyle,textDecorationThickness,textUnderlineOffset,textTransform,textIndent,textShadow,textOverflow,verticalAlign,wordBreak,textWrap,truncate,lineClamp,listStyleType,listStylePosition,listStyleImage,backgroundPosition,backgroundPositionX,backgroundPositionY,backgroundAttachment,backgroundClip,background,backgroundColor,backgroundOrigin,backgroundImage,backgroundRepeat,backgroundBlendMode,backgroundSize,backgroundGradient,textGradient,gradientFromPosition,gradientToPosition,gradientFrom,gradientTo,gradientVia,gradientViaPosition,borderRadius,borderTopLeftRadius,borderTopRightRadius,borderBottomRightRadius,borderBottomLeftRadius,borderTopRadius,borderRightRadius,borderBottomRadius,borderLeftRadius,borderStartStartRadius,borderStartEndRadius,borderStartRadius,borderEndStartRadius,borderEndEndRadius,borderEndRadius,border,borderWidth,borderTopWidth,borderLeftWidth,borderRightWidth,borderBottomWidth,borderColor,borderInline,borderInlineWidth,borderInlineColor,borderBlock,borderBlockWidth,borderBlockColor,borderLeft,borderLeftColor,borderInlineStart,borderInlineStartWidth,borderInlineStartColor,borderRight,borderRightColor,borderInlineEnd,borderInlineEndWidth,borderInlineEndColor,borderTop,borderTopColor,borderBottom,borderBottomColor,borderBlockEnd,borderBlockEndColor,borderBlockStart,borderBlockStartColor,opacity,boxShadow,boxShadowColor,mixBlendMode,filter,brightness,contrast,grayscale,hueRotate,invert,saturate,sepia,dropShadow,blur,backdropFilter,backdropBlur,backdropBrightness,backdropContrast,backdropGrayscale,backdropHueRotate,backdropInvert,backdropOpacity,backdropSaturate,backdropSepia,borderCollapse,borderSpacing,borderSpacingX,borderSpacingY,tableLayout,transitionTimingFunction,transitionDelay,transitionDuration,transitionProperty,transition,animation,animationName,animationTimingFunction,animationDuration,animationDelay,transformOrigin,rotate,rotateX,rotateY,rotateZ,scale,scaleX,scaleY,translate,translateX,translateY,translateZ,accentColor,caretColor,scrollBehavior,scrollbar,scrollMargin,scrollMarginLeft,scrollMarginRight,scrollMarginTop,scrollMarginBottom,scrollMarginBlock,scrollMarginBlockEnd,scrollMarginBlockStart,scrollMarginInline,scrollMarginInlineEnd,scrollMarginInlineStart,scrollPadding,scrollPaddingBlock,scrollPaddingBlockStart,scrollPaddingBlockEnd,scrollPaddingInline,scrollPaddingInlineEnd,scrollPaddingInlineStart,scrollPaddingLeft,scrollPaddingRight,scrollPaddingTop,scrollPaddingBottom,scrollSnapAlign,scrollSnapStop,scrollSnapType,scrollSnapStrictness,scrollSnapMargin,scrollSnapMarginTop,scrollSnapMarginBottom,scrollSnapMarginLeft,scrollSnapMarginRight,touchAction,userSelect,fill,stroke,strokeWidth,srOnly,debug,appearance,backfaceVisibility,clipPath,hyphens,mask,maskImage,maskSize,textSizeAdjust,container,containerName,containerType,colorPalette,_hover,_focus,_focusWithin,_focusVisible,_disabled,_active,_visited,_target,_readOnly,_readWrite,_empty,_checked,_enabled,_expanded,_highlighted,_before,_after,_firstLetter,_firstLine,_marker,_selection,_file,_backdrop,_first,_last,_only,_even,_odd,_firstOfType,_lastOfType,_onlyOfType,_peerFocus,_peerHover,_peerActive,_peerFocusWithin,_peerFocusVisible,_peerDisabled,_peerChecked,_peerInvalid,_peerExpanded,_peerPlaceholderShown,_groupFocus,_groupHover,_groupActive,_groupFocusWithin,_groupFocusVisible,_groupDisabled,_groupChecked,_groupExpanded,_groupInvalid,_indeterminate,_required,_valid,_invalid,_autofill,_inRange,_outOfRange,_placeholder,_placeholderShown,_pressed,_selected,_default,_optional,_open,_closed,_fullscreen,_loading,_currentPage,_currentStep,_motionReduce,_motionSafe,_print,_landscape,_portrait,_dark,_light,_osDark,_osLight,_highContrast,_lessContrast,_moreContrast,_ltr,_rtl,_scrollbar,_scrollbarThumb,_scrollbarTrack,_horizontal,_vertical,_starting,sm,smOnly,smDown,md,mdOnly,mdDown,lg,lgOnly,lgDown,xl,xlOnly,xlDown,2xl,2xlOnly,2xlDown,smToMd,smToLg,smToXl,smTo2xl,mdToLg,mdToXl,mdTo2xl,lgToXl,lgTo2xl,xlTo2xl,@/xs,@/sm,@/md,@/lg,@/xl,@/2xl,@/3xl,@/4xl,@/5xl,@/6xl,@/7xl,@/8xl,textStyle", rH = nH.split(","), oH = "WebkitAppearance,WebkitBorderBefore,WebkitBorderBeforeColor,WebkitBorderBeforeStyle,WebkitBorderBeforeWidth,WebkitBoxReflect,WebkitLineClamp,WebkitMask,WebkitMaskAttachment,WebkitMaskClip,WebkitMaskComposite,WebkitMaskImage,WebkitMaskOrigin,WebkitMaskPosition,WebkitMaskPositionX,WebkitMaskPositionY,WebkitMaskRepeat,WebkitMaskRepeatX,WebkitMaskRepeatY,WebkitMaskSize,WebkitOverflowScrolling,WebkitTapHighlightColor,WebkitTextFillColor,WebkitTextStroke,WebkitTextStrokeColor,WebkitTextStrokeWidth,WebkitTouchCallout,WebkitUserModify,accentColor,alignContent,alignItems,alignSelf,alignTracks,all,animation,animationComposition,animationDelay,animationDirection,animationDuration,animationFillMode,animationIterationCount,animationName,animationPlayState,animationRange,animationRangeEnd,animationRangeStart,animationTimingFunction,animationTimeline,appearance,aspectRatio,azimuth,backdropFilter,backfaceVisibility,background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundPositionX,backgroundPositionY,backgroundRepeat,backgroundSize,blockSize,border,borderBlock,borderBlockColor,borderBlockStyle,borderBlockWidth,borderBlockEnd,borderBlockEndColor,borderBlockEndStyle,borderBlockEndWidth,borderBlockStart,borderBlockStartColor,borderBlockStartStyle,borderBlockStartWidth,borderBottom,borderBottomColor,borderBottomLeftRadius,borderBottomRightRadius,borderBottomStyle,borderBottomWidth,borderCollapse,borderColor,borderEndEndRadius,borderEndStartRadius,borderImage,borderImageOutset,borderImageRepeat,borderImageSlice,borderImageSource,borderImageWidth,borderInline,borderInlineEnd,borderInlineColor,borderInlineStyle,borderInlineWidth,borderInlineEndColor,borderInlineEndStyle,borderInlineEndWidth,borderInlineStart,borderInlineStartColor,borderInlineStartStyle,borderInlineStartWidth,borderLeft,borderLeftColor,borderLeftStyle,borderLeftWidth,borderRadius,borderRight,borderRightColor,borderRightStyle,borderRightWidth,borderSpacing,borderStartEndRadius,borderStartStartRadius,borderStyle,borderTop,borderTopColor,borderTopLeftRadius,borderTopRightRadius,borderTopStyle,borderTopWidth,borderWidth,bottom,boxAlign,boxDecorationBreak,boxDirection,boxFlex,boxFlexGroup,boxLines,boxOrdinalGroup,boxOrient,boxPack,boxShadow,boxSizing,breakAfter,breakBefore,breakInside,captionSide,caret,caretColor,caretShape,clear,clip,clipPath,color,colorScheme,columnCount,columnFill,columnGap,columnRule,columnRuleColor,columnRuleStyle,columnRuleWidth,columnSpan,columnWidth,columns,contain,containIntrinsicSize,containIntrinsicBlockSize,containIntrinsicHeight,containIntrinsicInlineSize,containIntrinsicWidth,container,containerName,containerType,content,contentVisibility,counterIncrement,counterReset,counterSet,cursor,direction,display,emptyCells,filter,flex,flexBasis,flexDirection,flexFlow,flexGrow,flexShrink,flexWrap,float,font,fontFamily,fontFeatureSettings,fontKerning,fontLanguageOverride,fontOpticalSizing,fontPalette,fontVariationSettings,fontSize,fontSizeAdjust,fontSmooth,fontStretch,fontStyle,fontSynthesis,fontSynthesisPosition,fontSynthesisSmallCaps,fontSynthesisStyle,fontSynthesisWeight,fontVariant,fontVariantAlternates,fontVariantCaps,fontVariantEastAsian,fontVariantEmoji,fontVariantLigatures,fontVariantNumeric,fontVariantPosition,fontWeight,forcedColorAdjust,gap,grid,gridArea,gridAutoColumns,gridAutoFlow,gridAutoRows,gridColumn,gridColumnEnd,gridColumnGap,gridColumnStart,gridGap,gridRow,gridRowEnd,gridRowGap,gridRowStart,gridTemplate,gridTemplateAreas,gridTemplateColumns,gridTemplateRows,hangingPunctuation,height,hyphenateCharacter,hyphenateLimitChars,hyphens,imageOrientation,imageRendering,imageResolution,imeMode,initialLetter,initialLetterAlign,inlineSize,inputSecurity,inset,insetBlock,insetBlockEnd,insetBlockStart,insetInline,insetInlineEnd,insetInlineStart,isolation,justifyContent,justifyItems,justifySelf,justifyTracks,left,letterSpacing,lineBreak,lineClamp,lineHeight,lineHeightStep,listStyle,listStyleImage,listStylePosition,listStyleType,margin,marginBlock,marginBlockEnd,marginBlockStart,marginBottom,marginInline,marginInlineEnd,marginInlineStart,marginLeft,marginRight,marginTop,marginTrim,mask,maskBorder,maskBorderMode,maskBorderOutset,maskBorderRepeat,maskBorderSlice,maskBorderSource,maskBorderWidth,maskClip,maskComposite,maskImage,maskMode,maskOrigin,maskPosition,maskRepeat,maskSize,maskType,masonryAutoFlow,mathDepth,mathShift,mathStyle,maxBlockSize,maxHeight,maxInlineSize,maxLines,maxWidth,minBlockSize,minHeight,minInlineSize,minWidth,mixBlendMode,objectFit,objectPosition,offset,offsetAnchor,offsetDistance,offsetPath,offsetPosition,offsetRotate,opacity,order,orphans,outline,outlineColor,outlineOffset,outlineStyle,outlineWidth,overflow,overflowAnchor,overflowBlock,overflowClipBox,overflowClipMargin,overflowInline,overflowWrap,overflowX,overflowY,overlay,overscrollBehavior,overscrollBehaviorBlock,overscrollBehaviorInline,overscrollBehaviorX,overscrollBehaviorY,padding,paddingBlock,paddingBlockEnd,paddingBlockStart,paddingBottom,paddingInline,paddingInlineEnd,paddingInlineStart,paddingLeft,paddingRight,paddingTop,page,pageBreakAfter,pageBreakBefore,pageBreakInside,paintOrder,perspective,perspectiveOrigin,placeContent,placeItems,placeSelf,pointerEvents,position,printColorAdjust,quotes,resize,right,rotate,rowGap,rubyAlign,rubyMerge,rubyPosition,scale,scrollbarColor,scrollbarGutter,scrollbarWidth,scrollBehavior,scrollMargin,scrollMarginBlock,scrollMarginBlockStart,scrollMarginBlockEnd,scrollMarginBottom,scrollMarginInline,scrollMarginInlineStart,scrollMarginInlineEnd,scrollMarginLeft,scrollMarginRight,scrollMarginTop,scrollPadding,scrollPaddingBlock,scrollPaddingBlockStart,scrollPaddingBlockEnd,scrollPaddingBottom,scrollPaddingInline,scrollPaddingInlineStart,scrollPaddingInlineEnd,scrollPaddingLeft,scrollPaddingRight,scrollPaddingTop,scrollSnapAlign,scrollSnapCoordinate,scrollSnapDestination,scrollSnapPointsX,scrollSnapPointsY,scrollSnapStop,scrollSnapType,scrollSnapTypeX,scrollSnapTypeY,scrollTimeline,scrollTimelineAxis,scrollTimelineName,shapeImageThreshold,shapeMargin,shapeOutside,tabSize,tableLayout,textAlign,textAlignLast,textCombineUpright,textDecoration,textDecorationColor,textDecorationLine,textDecorationSkip,textDecorationSkipInk,textDecorationStyle,textDecorationThickness,textEmphasis,textEmphasisColor,textEmphasisPosition,textEmphasisStyle,textIndent,textJustify,textOrientation,textOverflow,textRendering,textShadow,textSizeAdjust,textTransform,textUnderlineOffset,textUnderlinePosition,textWrap,timelineScope,top,touchAction,transform,transformBox,transformOrigin,transformStyle,transition,transitionBehavior,transitionDelay,transitionDuration,transitionProperty,transitionTimingFunction,translate,unicodeBidi,userSelect,verticalAlign,viewTimeline,viewTimelineAxis,viewTimelineInset,viewTimelineName,viewTransitionName,visibility,whiteSpace,whiteSpaceCollapse,widows,width,willChange,wordBreak,wordSpacing,wordWrap,writingMode,zIndex,zoom,alignmentBaseline,baselineShift,clipRule,colorInterpolation,colorRendering,dominantBaseline,fill,fillOpacity,fillRule,floodColor,floodOpacity,glyphOrientationVertical,lightingColor,marker,markerEnd,markerMid,markerStart,shapeRendering,stopColor,stopOpacity,stroke,strokeDasharray,strokeDashoffset,strokeLinecap,strokeLinejoin,strokeMiterlimit,strokeOpacity,strokeWidth,textAnchor,vectorEffect", iH = oH.split(",").concat(rH), aH = new Map(iH.map((e) => [e, !0])), sH = /&|@/, Ty = /* @__PURE__ */ Hf((e) => aH.has(e) || e.startsWith("--") || sH.test(e));
const zh = (e) => uc(e, Ty), lH = (e, n) => !n.includes(e) && !Ty(e), cH = (e, n) => e.__shouldForwardProps__ && n ? (t) => e.__shouldForwardProps__(t) && n(t) : n, uH = (e, n) => {
  var r;
  if (e && !n)
    return e;
  if (!e && n)
    return n;
  if (e.__cva__ && n.__cva__ || e.__recipe__ && n.__recipe__)
    return e.merge(n);
  const t = new TypeError("Cannot merge cva with recipe. Please use either cva or recipe.");
  throw (r = TypeError.captureStackTrace) == null || r.call(TypeError, t), t;
}, dH = (e) => typeof e == "string" ? e : (e == null ? void 0 : e.displayName) || (e == null ? void 0 : e.name) || "Component";
function $m(e, n = {}, t = {}) {
  const r = n.__cva__ || n.__recipe__ ? n : Ii(n), o = t.shouldForwardProp || lH, a = (w) => o(w, r.variantKeys), l = Object.assign(
    t.dataAttr && n.__name__ ? { "data-recipe": n.__name__ } : {},
    t.defaultProps
  ), u = uH(e.__cva__, r), f = cH(e, a), p = e.__base__ || e, y = /* @__PURE__ */ oe(function(F, j) {
    const { as: N = p, children: D, ...k } = F, z = oc(() => Object.assign({}, l, k), [k]), [q, Ce, ee, Fe, Oe] = oc(() => uc(z, rb.keys, f, u.variantKeys, Ty), [z]);
    function He() {
      var Ie;
      const { css: we, ...ae } = Fe, ge = (Ie = u.__getCompoundVariantCss__) == null ? void 0 : Ie.call(u, ee);
      return sc(u(ee, !1), ni(ge, ae, we), z.className);
    }
    function Re() {
      const { css: we, ...ae } = Fe, ge = u.raw(ee);
      return sc(ni(ge, ae, we), z.className);
    }
    const Se = n.__recipe__ ? He : Re;
    return Ed(N, {
      ref: j,
      ...Ce,
      ...Oe,
      ...rb(q),
      className: Se()
    }, z.children ?? D);
  }), A = dH(p);
  return y.displayName = `styled.${A}`, y.__cva__ = u, y.__base__ = p, y.__shouldForwardProps__ = a, y;
}
function fH() {
  const e = /* @__PURE__ */ new Map();
  return new Proxy($m, {
    apply(n, t, r) {
      return $m(...r);
    },
    get(n, t) {
      return e.has(t) || e.set(t, $m(t)), e.get(t);
    }
  });
}
const It = /* @__PURE__ */ fH(), _C = {
  transform(e) {
    return e;
  }
}, gH = (e = {}) => {
  const n = Yf(_C, e);
  return _C.transform(n, Gf);
}, ll = /* @__PURE__ */ oe(function(n, t) {
  const [r, o] = uc(n, []), a = gH(r), l = { ref: t, ...a, ...o };
  return Ed(It.div, l);
}), $C = {
  transform(e) {
    const { direction: n, align: t, justify: r, wrap: o, basis: a, grow: l, shrink: u, ...f } = e;
    return {
      display: "flex",
      flexDirection: n,
      alignItems: t,
      justifyContent: r,
      flexWrap: o,
      flexBasis: a,
      flexGrow: l,
      flexShrink: u,
      ...f
    };
  }
}, pH = (e = {}) => {
  const n = Yf($C, e);
  return $C.transform(n, Gf);
}, Si = /* @__PURE__ */ oe(function(n, t) {
  const [r, o] = uc(n, ["align", "justify", "direction", "wrap", "basis", "grow", "shrink"]), a = pH(r), l = { ref: t, ...a, ...o };
  return Ed(It.div, l);
}), eE = {
  transform(e) {
    const { align: n, justify: t, direction: r, gap: o, ...a } = e;
    return {
      display: "flex",
      flexDirection: r,
      alignItems: n,
      justifyContent: t,
      gap: o,
      ...a
    };
  },
  defaultValues: { direction: "column", gap: "10px" }
}, hH = (e = {}) => {
  const n = Yf(eE, e);
  return eE.transform(n, Gf);
}, tE = /* @__PURE__ */ oe(function(n, t) {
  const [r, o] = uc(n, ["align", "justify", "direction", "gap"]), a = hH(r), l = { ref: t, ...a, ...o };
  return Ed(It.div, l);
}), nE = {
  transform(e) {
    const { justify: n, gap: t, ...r } = e;
    return {
      display: "flex",
      alignItems: "center",
      justifyContent: n,
      gap: t,
      flexDirection: "row",
      ...r
    };
  },
  defaultValues: { gap: "10px" }
}, mH = (e = {}) => {
  const n = Yf(nE, e);
  return nE.transform(n, Gf);
}, rE = /* @__PURE__ */ oe(function(n, t) {
  const [r, o] = uc(n, ["justify", "gap"]), a = mH(r), l = { ref: t, ...a, ...o };
  return Ed(It.div, l);
}), oE = {
  transform(e, { map: n, isCssUnit: t }) {
    const { columnGap: r, rowGap: o, gap: a, columns: l, minChildWidth: u, ...f } = e, p = (y) => t(y) ? y : `token(sizes.${y}, ${y})`;
    return {
      display: "grid",
      gridTemplateColumns: l != null ? n(l, (y) => `repeat(${y}, minmax(0, 1fr))`) : u != null ? n(u, (y) => `repeat(auto-fit, minmax(${p(y)}, 1fr))`) : void 0,
      gap: a,
      columnGap: r,
      rowGap: o,
      ...f
    };
  },
  defaultValues(e) {
    return { gap: e.columnGap || e.rowGap ? void 0 : "10px" };
  }
}, vH = (e = {}) => {
  const n = Yf(oE, e);
  return oE.transform(n, Gf);
}, bH = /* @__PURE__ */ oe(function(n, t) {
  const [r, o] = uc(n, ["gap", "columnGap", "rowGap", "columns", "minChildWidth"]), a = vH(r), l = { ref: t, ...a, ...o };
  return Ed(It.div, l);
}), iE = {
  transform(e) {
    return {
      srOnly: !0,
      ...e
    };
  }
}, PT = (e = {}) => {
  const n = Yf(iE, e);
  return iE.transform(n, Gf);
}, kT = (e) => ni(PT(e));
kT.raw = PT;
const yH = ({ Element: e, ...n }) => /* @__PURE__ */ I.jsx(e, { ...n }), fr = It(yH, {
  variants: {
    size: {
      sm: {
        width: "icons.sm",
        height: "icons.sm",
        strokeWidth: 1.5
      },
      md: {
        width: "icons.md",
        height: "icons.md",
        strokeWidth: 1.75
      },
      lg: {
        width: "icons.lg",
        height: "icons.lg",
        strokeWidth: 1.75
      },
      xl: {
        width: "icons.xl",
        height: "icons.xl",
        strokeWidth: 2.5
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
}), CH = {
  ring: () => /* @__PURE__ */ I.jsxs(I.Fragment, { children: [
    /* @__PURE__ */ I.jsx(
      "path",
      {
        d: "M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z",
        opacity: ".25"
      }
    ),
    /* @__PURE__ */ I.jsx("path", { d: "M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z", children: /* @__PURE__ */ I.jsx(
      "animateTransform",
      {
        attributeName: "transform",
        type: "rotate",
        dur: "0.75s",
        values: "0 12 12;360 12 12",
        repeatCount: "indefinite"
      }
    ) })
  ] })
}, EH = ({ variant: e = "ring", ...n }) => /* @__PURE__ */ I.jsx("div", { ...n, children: /* @__PURE__ */ I.jsx(
  "svg",
  {
    fill: "currentColor",
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    children: CH[e]()
  }
) }), AH = It(EH), RT = ({ isLoading: e, buttonSize: n, Element: t }) => {
  const r = n === "sm" ? "sm" : "md";
  if (e)
    return /* @__PURE__ */ I.jsx(fr, { Element: AH, size: r });
  if (t)
    return /* @__PURE__ */ I.jsx(fr, { Element: t, size: r });
}, Fg = {
  // We don't specify an explicit height to prevent multiline contents from clipping
  sm: { px: "150", py: "50", fontSize: "xs", lineHeight: "xs" },
  md: { px: "200", py: "100", fontSize: "xs", lineHeight: "xs" },
  lg: { px: "200", py: "150" }
}, qg = "md", SH = Ii({
  base: {
    fontFamily: "body",
    fontWeight: "medium",
    fontSize: "md",
    lineHeight: "sm",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transitionDuration: "normal",
    transitionProperty: "background",
    transitionTimingFunction: "default",
    _disabled: {
      opacity: "30%",
      cursor: "not-allowed"
    },
    cursor: "pointer",
    borderRadius: "100",
    color: "text.inverse",
    columnGap: "100"
  },
  variants: {
    visual: {
      primary: {
        bg: {
          base: "bg.darkest",
          _hover: { base: "bg.mid", _disabled: "bg.darkest" }
        }
      },
      accent: {
        bg: {
          base: "bg.accent.dark",
          _hover: { base: "bg.accent.mid", _disabled: "bg.accent.dark" }
        }
      },
      warning: {
        bg: {
          base: "bg.warning.dark",
          _hover: { base: "bg.warning.mid", _disabled: "bg.warning.dark" }
        }
      },
      success: {
        bg: {
          base: "bg.success.dark",
          _hover: { base: "bg.success.mid", _disabled: "bg.success.dark" }
        }
      },
      destructive: {
        bg: {
          base: "bg.error.dark",
          _hover: { base: "bg.error.mid", _disabled: "bg.error.dark" }
        }
      },
      outline: {
        bg: {
          base: "white",
          _hover: { base: "bg.lightest", _disabled: "white" }
        },
        color: "text.dark",
        border: "1px token(colors.border.light) solid"
      }
    },
    size: {
      ...Fg
    }
  },
  defaultVariants: {
    visual: "primary",
    size: qg
  }
}), OT = It("button", SH), ti = ({
  isLoading: e = !1,
  disabled: n = !1,
  isIconRightAligned: t = !1,
  Icon: r,
  children: o,
  // Ensure `size` is always set so that it is passed through to `Adornment`.
  // By default, Panda *will* use `defaultVariants` if `size` is not
  // specified, but this happens much later in the render process, after we've
  // already rendered `Adornment`.
  size: a = qg,
  ...l
}) => {
  const u = r && !o ? { px: "9px", py: "9px" } : void 0, f = /* @__PURE__ */ I.jsx(RT, { isLoading: e, Element: r, buttonSize: a });
  return /* @__PURE__ */ I.jsx(OT, { size: a, ...u, ...l, disabled: e || n, children: /* @__PURE__ */ I.jsxs(I.Fragment, { children: [
    !t && f,
    o,
    t && f
  ] }) });
}, DT = Ii({
  base: {
    fontFamily: "body",
    fontWeight: "medium",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    _disabled: {
      opacity: "30%",
      cursor: "not-allowed"
    },
    cursor: "pointer",
    color: {
      base: "text.accent.dark",
      _hover: { base: "text.accent.mid", _disabled: "text.accent.dark" },
      _disabled: "text.accent.dark"
    },
    columnGap: "50"
  },
  variants: {
    size: {
      sm: { fontSize: "xs", lineHeight: "xs" },
      lg: { fontSize: "md", lineHeight: "sm" }
    }
  },
  defaultVariants: {
    size: "lg"
  }
}), wH = It("button", DT), jY = It("a", DT), IH = It(ll, {
  base: {
    pr: "200",
    borderRightWidth: "1px",
    borderRightStyle: "solid"
  },
  variants: {
    visual: {
      primary: {
        borderRightColor: "border.light"
      },
      accent: {
        borderRightColor: "white"
      },
      warning: {
        borderRightColor: "white"
      },
      success: {
        borderRightColor: "white"
      },
      destructive: {
        borderRightColor: "white"
      },
      outline: {
        borderRightColor: "border.light"
      }
    },
    size: { ...Fg }
  },
  defaultVariants: {
    size: qg,
    visual: "primary"
  }
}), xH = It(ll, {
  base: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  variants: {
    size: {
      sm: { ...Fg.sm, px: "150" },
      md: { ...Fg.md, px: "150" },
      lg: { ...Fg.lg }
    }
  },
  defaultVariants: {
    size: qg
  }
}), UY = ({
  isLoading: e = !1,
  disabled: n = !1,
  Icon: t,
  children: r,
  visual: o,
  // Ensure `size` is always set so that it is passed through to `Adornment`.
  // By default, Panda *will* use `defaultVariants` if `size` is not
  // specified, but this happens much later in the render process, after we've
  // already rendered `Adornment`.
  size: a = qg,
  ...l
}) => {
  const u = /* @__PURE__ */ I.jsx(RT, { isLoading: e, Element: t, buttonSize: a });
  return /* @__PURE__ */ I.jsxs(
    OT,
    {
      p: "0!",
      columnGap: 0,
      size: a,
      visual: o,
      ...l,
      disabled: e || n,
      children: [
        /* @__PURE__ */ I.jsx(IH, { size: a, visual: o, children: r }),
        /* @__PURE__ */ I.jsx(xH, { size: a, children: u })
      ]
    }
  );
}, TH = Ro({
  className: "datePicker",
  slots: [...QS.keys()],
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "200",
      position: "relative",
      fontFamily: "body",
      fontSize: "xs",
      lineHeight: "xs",
      width: "full",
      height: "full"
    },
    content: {
      display: "flex",
      flexDirection: "column",
      gap: "150",
      width: "full",
      height: "full"
    },
    viewControl: {
      display: "flex",
      gap: "2",
      justifyContent: "space-between"
    },
    table: {
      width: "full",
      height: "full"
    },
    tableHeader: {
      width: "8",
      height: "10",
      color: "text.dark",
      fontWeight: "medium"
    },
    tableCell: { position: "relative" },
    tableCellTrigger: {
      cursor: "pointer",
      fontWeight: "medium",
      transitionDuration: "normal",
      transitionProperty: "background, color",
      transitionTimingFunction: "default",
      fontSize: "xs",
      lineHeight: "xs",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "100",
      background: {
        base: "white",
        _hover: {
          base: "bg.lightest",
          _disabled: "white"
        }
      },
      color: "text.dark",
      border: "1px token(colors.border.light) solid"
    },
    view: {
      display: "flex",
      flexDirection: "column",
      gap: "3",
      height: "full",
      width: "full"
    }
  }
}), vs = (e) => {
  const n = cb(null);
  return {
    withRootProvider: (a) => (u) => {
      const [f, p] = e.splitVariantProps(u), y = e(f);
      return /* @__PURE__ */ I.jsx(n.Provider, { value: y, children: /* @__PURE__ */ I.jsx(a, { ...p }) });
    },
    withProvider: (a, l) => {
      const u = It(a);
      return oe((f, p) => {
        const [y, A] = e.splitVariantProps(f), w = e(y);
        return /* @__PURE__ */ I.jsx(n.Provider, { value: w, children: /* @__PURE__ */ I.jsx(
          u,
          {
            ...A,
            ref: p,
            className: sc(w == null ? void 0 : w[l], f.className)
          }
        ) });
      });
    },
    withContext: (a, l) => {
      const u = It(a);
      return oe((f, p) => {
        const y = PA(n);
        return /* @__PURE__ */ I.jsx(
          u,
          {
            ...f,
            ref: p,
            className: sc(y == null ? void 0 : y[l], f.className)
          }
        );
      });
    }
  };
}, { withProvider: PH, withContext: Qr } = vs(TH), kH = PH(
  jI,
  "root"
);
Qr(iI, "content");
Qr(aI, "monthSelect");
const RH = Qr(sI, "nextTrigger");
Qr(lI, "positioner");
Qr(cI, "presetTrigger");
const OH = Qr(uI, "prevTrigger"), DH = Qr(dI, "rangeText"), aE = Qr(WI, "tableBody"), Py = Qr(HI, "tableCell"), ky = Qr(GI, "tableCellTrigger"), FH = Qr(YI, "tableHead"), NH = Qr(zI, "tableHeader"), sE = Qr(UI, "table"), ev = Qr(ZI, "tableRow"), MH = Qr(XI, "viewControl"), lE = Qr(KI, "view"), LH = Qr(JI, "viewTrigger");
Qr(QI, "yearSelect");
const cE = It("div", {
  base: { mx: "-6px", height: "full" }
});
function _n(e) {
  const n = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && n === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || n === "[object Number]" || typeof e == "string" || n === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function Na(e, n) {
  return e instanceof Date ? new e.constructor(n) : new Date(n);
}
function FT(e, n) {
  const t = _n(e);
  return isNaN(n) ? Na(e, NaN) : (n && t.setDate(t.getDate() + n), t);
}
function NT(e, n) {
  const t = _n(e);
  if (isNaN(n))
    return Na(e, NaN);
  if (!n)
    return t;
  const r = t.getDate(), o = Na(e, t.getTime());
  o.setMonth(t.getMonth() + n + 1, 0);
  const a = o.getDate();
  return r >= a ? o : (t.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    r
  ), t);
}
function MT(e, n) {
  const {
    years: t = 0,
    months: r = 0,
    weeks: o = 0,
    days: a = 0,
    hours: l = 0,
    minutes: u = 0,
    seconds: f = 0
  } = n, p = _n(e), y = r || t ? NT(p, r + t * 12) : p, A = a || o ? FT(y, a + o * 7) : y, w = u + l * 60, j = (f + w * 60) * 1e3;
  return Na(e, A.getTime() + j);
}
const LT = 6048e5, BH = 864e5;
let VH = {};
function Zh() {
  return VH;
}
function Ug(e, n) {
  var u, f, p, y;
  const t = Zh(), r = (n == null ? void 0 : n.weekStartsOn) ?? ((f = (u = n == null ? void 0 : n.locale) == null ? void 0 : u.options) == null ? void 0 : f.weekStartsOn) ?? t.weekStartsOn ?? ((y = (p = t.locale) == null ? void 0 : p.options) == null ? void 0 : y.weekStartsOn) ?? 0, o = _n(e), a = o.getDay(), l = (a < r ? 7 : 0) + a - r;
  return o.setDate(o.getDate() - l), o.setHours(0, 0, 0, 0), o;
}
function Th(e) {
  return Ug(e, { weekStartsOn: 1 });
}
function BT(e) {
  const n = _n(e), t = n.getFullYear(), r = Na(e, 0);
  r.setFullYear(t + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const o = Th(r), a = Na(e, 0);
  a.setFullYear(t, 0, 4), a.setHours(0, 0, 0, 0);
  const l = Th(a);
  return n.getTime() >= o.getTime() ? t + 1 : n.getTime() >= l.getTime() ? t : t - 1;
}
function Ph(e) {
  const n = _n(e);
  return n.setHours(0, 0, 0, 0), n;
}
function uE(e) {
  const n = _n(e), t = new Date(
    Date.UTC(
      n.getFullYear(),
      n.getMonth(),
      n.getDate(),
      n.getHours(),
      n.getMinutes(),
      n.getSeconds(),
      n.getMilliseconds()
    )
  );
  return t.setUTCFullYear(n.getFullYear()), +e - +t;
}
function Kh(e, n) {
  const t = Ph(e), r = Ph(n), o = +t - uE(t), a = +r - uE(r);
  return Math.round((o - a) / BH);
}
function jH(e) {
  const n = BT(e), t = Na(e, 0);
  return t.setFullYear(n, 0, 4), t.setHours(0, 0, 0, 0), Th(t);
}
function Ng(e, n) {
  const t = Ph(e), r = Ph(n);
  return +t == +r;
}
function UH(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function WH(e) {
  if (!UH(e) && typeof e != "number")
    return !1;
  const n = _n(e);
  return !isNaN(Number(n));
}
function HH(e) {
  const n = _n(e), t = Na(e, 0);
  return t.setFullYear(n.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
const GH = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, YH = (e, n, t) => {
  let r;
  const o = GH[e];
  return typeof o == "string" ? r = o : n === 1 ? r = o.one : r = o.other.replace("{{count}}", n.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + r : r + " ago" : r;
};
function tv(e) {
  return (n = {}) => {
    const t = n.width ? String(n.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const zH = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, ZH = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, KH = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, XH = {
  date: tv({
    formats: zH,
    defaultWidth: "full"
  }),
  time: tv({
    formats: ZH,
    defaultWidth: "full"
  }),
  dateTime: tv({
    formats: KH,
    defaultWidth: "full"
  })
}, JH = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, QH = (e, n, t, r) => JH[e];
function wg(e) {
  return (n, t) => {
    const r = t != null && t.context ? String(t.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const l = e.defaultFormattingWidth || e.defaultWidth, u = t != null && t.width ? String(t.width) : l;
      o = e.formattingValues[u] || e.formattingValues[l];
    } else {
      const l = e.defaultWidth, u = t != null && t.width ? String(t.width) : e.defaultWidth;
      o = e.values[u] || e.values[l];
    }
    const a = e.argumentCallback ? e.argumentCallback(n) : n;
    return o[a];
  };
}
const qH = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, _H = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, $H = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, e3 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, t3 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, n3 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, r3 = (e, n) => {
  const t = Number(e), r = t % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, o3 = {
  ordinalNumber: r3,
  era: wg({
    values: qH,
    defaultWidth: "wide"
  }),
  quarter: wg({
    values: _H,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: wg({
    values: $H,
    defaultWidth: "wide"
  }),
  day: wg({
    values: e3,
    defaultWidth: "wide"
  }),
  dayPeriod: wg({
    values: t3,
    defaultWidth: "wide",
    formattingValues: n3,
    defaultFormattingWidth: "wide"
  })
};
function Ig(e) {
  return (n, t = {}) => {
    const r = t.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = n.match(o);
    if (!a)
      return null;
    const l = a[0], u = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], f = Array.isArray(u) ? a3(u, (A) => A.test(l)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      i3(u, (A) => A.test(l))
    );
    let p;
    p = e.valueCallback ? e.valueCallback(f) : f, p = t.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      t.valueCallback(p)
    ) : p;
    const y = n.slice(l.length);
    return { value: p, rest: y };
  };
}
function i3(e, n) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && n(e[t]))
      return t;
}
function a3(e, n) {
  for (let t = 0; t < e.length; t++)
    if (n(e[t]))
      return t;
}
function s3(e) {
  return (n, t = {}) => {
    const r = n.match(e.matchPattern);
    if (!r)
      return null;
    const o = r[0], a = n.match(e.parsePattern);
    if (!a)
      return null;
    let l = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    l = t.valueCallback ? t.valueCallback(l) : l;
    const u = n.slice(o.length);
    return { value: l, rest: u };
  };
}
const l3 = /^(\d+)(th|st|nd|rd)?/i, c3 = /\d+/i, u3 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, d3 = {
  any: [/^b/i, /^(a|c)/i]
}, f3 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, g3 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, p3 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, h3 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, m3 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, v3 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, b3 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, y3 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, C3 = {
  ordinalNumber: s3({
    matchPattern: l3,
    parsePattern: c3,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ig({
    matchPatterns: u3,
    defaultMatchWidth: "wide",
    parsePatterns: d3,
    defaultParseWidth: "any"
  }),
  quarter: Ig({
    matchPatterns: f3,
    defaultMatchWidth: "wide",
    parsePatterns: g3,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ig({
    matchPatterns: p3,
    defaultMatchWidth: "wide",
    parsePatterns: h3,
    defaultParseWidth: "any"
  }),
  day: Ig({
    matchPatterns: m3,
    defaultMatchWidth: "wide",
    parsePatterns: v3,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ig({
    matchPatterns: b3,
    defaultMatchWidth: "any",
    parsePatterns: y3,
    defaultParseWidth: "any"
  })
}, E3 = {
  code: "en-US",
  formatDistance: YH,
  formatLong: XH,
  formatRelative: QH,
  localize: o3,
  match: C3,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function A3(e) {
  const n = _n(e);
  return Kh(n, HH(n)) + 1;
}
function S3(e) {
  const n = _n(e), t = +Th(n) - +jH(n);
  return Math.round(t / LT) + 1;
}
function VT(e, n) {
  var y, A, w, F;
  const t = _n(e), r = t.getFullYear(), o = Zh(), a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((A = (y = n == null ? void 0 : n.locale) == null ? void 0 : y.options) == null ? void 0 : A.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((F = (w = o.locale) == null ? void 0 : w.options) == null ? void 0 : F.firstWeekContainsDate) ?? 1, l = Na(e, 0);
  l.setFullYear(r + 1, 0, a), l.setHours(0, 0, 0, 0);
  const u = Ug(l, n), f = Na(e, 0);
  f.setFullYear(r, 0, a), f.setHours(0, 0, 0, 0);
  const p = Ug(f, n);
  return t.getTime() >= u.getTime() ? r + 1 : t.getTime() >= p.getTime() ? r : r - 1;
}
function w3(e, n) {
  var u, f, p, y;
  const t = Zh(), r = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((f = (u = n == null ? void 0 : n.locale) == null ? void 0 : u.options) == null ? void 0 : f.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((y = (p = t.locale) == null ? void 0 : p.options) == null ? void 0 : y.firstWeekContainsDate) ?? 1, o = VT(e, n), a = Na(e, 0);
  return a.setFullYear(o, 0, r), a.setHours(0, 0, 0, 0), Ug(a, n);
}
function I3(e, n) {
  const t = _n(e), r = +Ug(t, n) - +w3(t, n);
  return Math.round(r / LT) + 1;
}
function mn(e, n) {
  const t = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(n, "0");
  return t + r;
}
const qc = {
  // Year
  y(e, n) {
    const t = e.getFullYear(), r = t > 0 ? t : 1 - t;
    return mn(n === "yy" ? r % 100 : r, n.length);
  },
  // Month
  M(e, n) {
    const t = e.getMonth();
    return n === "M" ? String(t + 1) : mn(t + 1, 2);
  },
  // Day of the month
  d(e, n) {
    return mn(e.getDate(), n.length);
  },
  // AM or PM
  a(e, n) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, n) {
    return mn(e.getHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H(e, n) {
    return mn(e.getHours(), n.length);
  },
  // Minute
  m(e, n) {
    return mn(e.getMinutes(), n.length);
  },
  // Second
  s(e, n) {
    return mn(e.getSeconds(), n.length);
  },
  // Fraction of second
  S(e, n) {
    const t = n.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, t - 3)
    );
    return mn(o, n.length);
  }
}, Ef = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, dE = {
  // Era
  G: function(e, n, t) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return t.era(r, { width: "abbreviated" });
      case "GGGGG":
        return t.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return t.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, n, t) {
    if (n === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return t.ordinalNumber(o, { unit: "year" });
    }
    return qc.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, t, r) {
    const o = VT(e, r), a = o > 0 ? o : 1 - o;
    if (n === "YY") {
      const l = a % 100;
      return mn(l, 2);
    }
    return n === "Yo" ? t.ordinalNumber(a, { unit: "year" }) : mn(a, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    const t = BT(e);
    return mn(t, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    const t = e.getFullYear();
    return mn(t, n.length);
  },
  // Quarter
  Q: function(e, n, t) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(r);
      case "QQ":
        return mn(r, 2);
      case "Qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return t.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return t.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, t) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(r);
      case "qq":
        return mn(r, 2);
      case "qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return t.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return t.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, t) {
    const r = e.getMonth();
    switch (n) {
      case "M":
      case "MM":
        return qc.M(e, n);
      case "Mo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return t.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return t.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return t.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, n, t) {
    const r = e.getMonth();
    switch (n) {
      case "L":
        return String(r + 1);
      case "LL":
        return mn(r + 1, 2);
      case "Lo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return t.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return t.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return t.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, n, t, r) {
    const o = I3(e, r);
    return n === "wo" ? t.ordinalNumber(o, { unit: "week" }) : mn(o, n.length);
  },
  // ISO week of year
  I: function(e, n, t) {
    const r = S3(e);
    return n === "Io" ? t.ordinalNumber(r, { unit: "week" }) : mn(r, n.length);
  },
  // Day of the month
  d: function(e, n, t) {
    return n === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : qc.d(e, n);
  },
  // Day of year
  D: function(e, n, t) {
    const r = A3(e);
    return n === "Do" ? t.ordinalNumber(r, { unit: "dayOfYear" }) : mn(r, n.length);
  },
  // Day of week
  E: function(e, n, t) {
    const r = e.getDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, t, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(a);
      case "ee":
        return mn(a, 2);
      case "eo":
        return t.ordinalNumber(a, { unit: "day" });
      case "eee":
        return t.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return t.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return t.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return t.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, t, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(a);
      case "cc":
        return mn(a, n.length);
      case "co":
        return t.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return t.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return t.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return t.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return t.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, t) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (n) {
      case "i":
        return String(o);
      case "ii":
        return mn(o, n.length);
      case "io":
        return t.ordinalNumber(o, { unit: "day" });
      case "iii":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, t) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, t) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = Ef.noon : r === 0 ? o = Ef.midnight : o = r / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, t) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = Ef.evening : r >= 12 ? o = Ef.afternoon : r >= 4 ? o = Ef.morning : o = Ef.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, t) {
    if (n === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), t.ordinalNumber(r, { unit: "hour" });
    }
    return qc.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, t) {
    return n === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : qc.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, t) {
    const r = e.getHours() % 12;
    return n === "Ko" ? t.ordinalNumber(r, { unit: "hour" }) : mn(r, n.length);
  },
  // Hour [1-24]
  k: function(e, n, t) {
    let r = e.getHours();
    return r === 0 && (r = 24), n === "ko" ? t.ordinalNumber(r, { unit: "hour" }) : mn(r, n.length);
  },
  // Minute
  m: function(e, n, t) {
    return n === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : qc.m(e, n);
  },
  // Second
  s: function(e, n, t) {
    return n === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : qc.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return qc.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, t) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (n) {
      case "X":
        return gE(r);
      case "XXXX":
      case "XX":
        return dd(r);
      case "XXXXX":
      case "XXX":
      default:
        return dd(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, t) {
    const r = e.getTimezoneOffset();
    switch (n) {
      case "x":
        return gE(r);
      case "xxxx":
      case "xx":
        return dd(r);
      case "xxxxx":
      case "xxx":
      default:
        return dd(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, t) {
    const r = e.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + fE(r, ":");
      case "OOOO":
      default:
        return "GMT" + dd(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, t) {
    const r = e.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + fE(r, ":");
      case "zzzz":
      default:
        return "GMT" + dd(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, t) {
    const r = Math.trunc(e.getTime() / 1e3);
    return mn(r, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, t) {
    const r = e.getTime();
    return mn(r, n.length);
  }
};
function fE(e, n = "") {
  const t = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), a = r % 60;
  return a === 0 ? t + String(o) : t + String(o) + n + mn(a, 2);
}
function gE(e, n) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + mn(Math.abs(e) / 60, 2) : dd(e, n);
}
function dd(e, n = "") {
  const t = e > 0 ? "-" : "+", r = Math.abs(e), o = mn(Math.trunc(r / 60), 2), a = mn(r % 60, 2);
  return t + o + n + a;
}
const pE = (e, n) => {
  switch (e) {
    case "P":
      return n.date({ width: "short" });
    case "PP":
      return n.date({ width: "medium" });
    case "PPP":
      return n.date({ width: "long" });
    case "PPPP":
    default:
      return n.date({ width: "full" });
  }
}, jT = (e, n) => {
  switch (e) {
    case "p":
      return n.time({ width: "short" });
    case "pp":
      return n.time({ width: "medium" });
    case "ppp":
      return n.time({ width: "long" });
    case "pppp":
    default:
      return n.time({ width: "full" });
  }
}, x3 = (e, n) => {
  const t = e.match(/(P+)(p+)?/) || [], r = t[1], o = t[2];
  if (!o)
    return pE(e, n);
  let a;
  switch (r) {
    case "P":
      a = n.dateTime({ width: "short" });
      break;
    case "PP":
      a = n.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = n.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = n.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", pE(r, n)).replace("{{time}}", jT(o, n));
}, T3 = {
  p: jT,
  P: x3
}, P3 = /^D+$/, k3 = /^Y+$/, R3 = ["D", "DD", "YY", "YYYY"];
function O3(e) {
  return P3.test(e);
}
function D3(e) {
  return k3.test(e);
}
function F3(e, n, t) {
  const r = N3(e, n, t);
  if (console.warn(r), R3.includes(e))
    throw new RangeError(r);
}
function N3(e, n, t) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${n}\`) for formatting ${r} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const M3 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, L3 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, B3 = /^'([^]*?)'?$/, V3 = /''/g, j3 = /[a-zA-Z]/;
function U3(e, n, t) {
  var y, A, w, F, j, N, D, k;
  const r = Zh(), o = (t == null ? void 0 : t.locale) ?? r.locale ?? E3, a = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((A = (y = t == null ? void 0 : t.locale) == null ? void 0 : y.options) == null ? void 0 : A.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((F = (w = r.locale) == null ? void 0 : w.options) == null ? void 0 : F.firstWeekContainsDate) ?? 1, l = (t == null ? void 0 : t.weekStartsOn) ?? ((N = (j = t == null ? void 0 : t.locale) == null ? void 0 : j.options) == null ? void 0 : N.weekStartsOn) ?? r.weekStartsOn ?? ((k = (D = r.locale) == null ? void 0 : D.options) == null ? void 0 : k.weekStartsOn) ?? 0, u = _n(e);
  if (!WH(u))
    throw new RangeError("Invalid time value");
  let f = n.match(L3).map((z) => {
    const q = z[0];
    if (q === "p" || q === "P") {
      const Ce = T3[q];
      return Ce(z, o.formatLong);
    }
    return z;
  }).join("").match(M3).map((z) => {
    if (z === "''")
      return { isToken: !1, value: "'" };
    const q = z[0];
    if (q === "'")
      return { isToken: !1, value: W3(z) };
    if (dE[q])
      return { isToken: !0, value: z };
    if (q.match(j3))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + q + "`"
      );
    return { isToken: !1, value: z };
  });
  o.localize.preprocessor && (f = o.localize.preprocessor(u, f));
  const p = {
    firstWeekContainsDate: a,
    weekStartsOn: l,
    locale: o
  };
  return f.map((z) => {
    if (!z.isToken)
      return z.value;
    const q = z.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && D3(q) || !(t != null && t.useAdditionalDayOfYearTokens) && O3(q)) && F3(q, n, String(e));
    const Ce = dE[q[0]];
    return Ce(u, q, o.localize, p);
  }).join("");
}
function W3(e) {
  const n = e.match(B3);
  return n ? n[1].replace(V3, "'") : e;
}
function Of(e, n) {
  const t = _n(e), r = _n(n);
  return t.getTime() > r.getTime();
}
function Wg(e, n) {
  const t = _n(e), r = _n(n);
  return +t < +r;
}
function kh(e, n) {
  const t = _n(e), r = _n(n);
  return t.getFullYear() === r.getFullYear() && t.getMonth() === r.getMonth();
}
function hE(e, n) {
  const t = _n(e), r = _n(n);
  return t.getFullYear() === r.getFullYear();
}
function H3(e, n) {
  return FT(e, -n);
}
function G3(e, n) {
  return NT(e, -n);
}
function Y3(e, n) {
  const {
    years: t = 0,
    months: r = 0,
    weeks: o = 0,
    days: a = 0,
    hours: l = 0,
    minutes: u = 0,
    seconds: f = 0
  } = n, p = G3(e, r + t * 12), y = H3(p, a + o * 7), A = u + l * 60, F = (f + A * 60) * 1e3;
  return Na(e, y.getTime() - F);
}
function z3(e, n) {
  const t = J3(n);
  return "formatToParts" in t ? K3(t, e) : X3(t, e);
}
const Z3 = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function K3(e, n) {
  try {
    const t = e.formatToParts(n), r = [];
    for (let o = 0; o < t.length; o++) {
      const a = Z3[t[o].type];
      a !== void 0 && (r[a] = parseInt(t[o].value, 10));
    }
    return r;
  } catch (t) {
    if (t instanceof RangeError)
      return [NaN];
    throw t;
  }
}
function X3(e, n) {
  const t = e.format(n), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(t);
  return [
    parseInt(r[3], 10),
    parseInt(r[1], 10),
    parseInt(r[2], 10),
    parseInt(r[4], 10),
    parseInt(r[5], 10),
    parseInt(r[6], 10)
  ];
}
const nv = {};
function J3(e) {
  if (!nv[e]) {
    const n = new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), t = n === "06/25/2014, 00:00:00" || n === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    nv[e] = t ? new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return nv[e];
}
function UT(e, n, t, r, o, a, l) {
  const u = /* @__PURE__ */ new Date(0);
  return u.setUTCFullYear(e, n, t), u.setUTCHours(r, o, a, l), u;
}
const mE = 36e5, Q3 = 6e4, rv = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function WT(e, n, t) {
  if (!e)
    return 0;
  let r = rv.timezoneZ.exec(e);
  if (r)
    return 0;
  let o, a;
  if (r = rv.timezoneHH.exec(e), r)
    return o = parseInt(r[1], 10), vE(o) ? -(o * mE) : NaN;
  if (r = rv.timezoneHHMM.exec(e), r) {
    o = parseInt(r[2], 10);
    const l = parseInt(r[3], 10);
    return vE(o, l) ? (a = Math.abs(o) * mE + l * Q3, r[1] === "+" ? -a : a) : NaN;
  }
  if ($3(e)) {
    n = new Date(n || Date.now());
    const l = t ? n : q3(n), u = ob(l, e);
    return -(t ? u : _3(n, u, e));
  }
  return NaN;
}
function q3(e) {
  return UT(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds());
}
function ob(e, n) {
  const t = z3(e, n), r = UT(t[0], t[1] - 1, t[2], t[3] % 24, t[4], t[5], 0).getTime();
  let o = e.getTime();
  const a = o % 1e3;
  return o -= a >= 0 ? a : 1e3 + a, r - o;
}
function _3(e, n, t) {
  let o = e.getTime() - n;
  const a = ob(new Date(o), t);
  if (n === a)
    return n;
  o -= a - n;
  const l = ob(new Date(o), t);
  return a === l ? a : Math.max(a, l);
}
function vE(e, n) {
  return -23 <= e && e <= 23 && (n == null || 0 <= n && n <= 59);
}
const bE = {};
function $3(e) {
  if (bE[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), bE[e] = !0, !0;
  } catch {
    return !1;
  }
}
function yE(e) {
  const n = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return n.setUTCFullYear(e.getFullYear()), +e - +n;
}
const e2 = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, ov = 36e5, CE = 6e4, t2 = 2, ei = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: e2
};
function n2(e, n = {}) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  const t = n.additionalDigits == null ? t2 : Number(n.additionalDigits);
  if (t !== 2 && t !== 1 && t !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (Object.prototype.toString.call(e) !== "[object String]")
    return /* @__PURE__ */ new Date(NaN);
  const r = r2(e), { year: o, restDateString: a } = o2(r.date, t), l = i2(a, o);
  if (l === null || isNaN(l.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  if (l) {
    const u = l.getTime();
    let f = 0, p;
    if (r.time && (f = a2(r.time), f === null || isNaN(f)))
      return /* @__PURE__ */ new Date(NaN);
    if (r.timeZone || n.timeZone) {
      if (p = WT(r.timeZone || n.timeZone, new Date(u + f)), isNaN(p))
        return /* @__PURE__ */ new Date(NaN);
    } else
      p = yE(new Date(u + f)), p = yE(new Date(u + f + p));
    return new Date(u + f + p);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function r2(e) {
  const n = {};
  let t = ei.dateTimePattern.exec(e), r;
  if (t ? (n.date = t[1], r = t[3]) : (t = ei.datePattern.exec(e), t ? (n.date = t[1], r = t[2]) : (n.date = null, r = e)), r) {
    const o = ei.timeZone.exec(r);
    o ? (n.time = r.replace(o[1], ""), n.timeZone = o[1].trim()) : n.time = r;
  }
  return n;
}
function o2(e, n) {
  if (e) {
    const t = ei.YYY[n], r = ei.YYYYY[n];
    let o = ei.YYYY.exec(e) || r.exec(e);
    if (o) {
      const a = o[1];
      return {
        year: parseInt(a, 10),
        restDateString: e.slice(a.length)
      };
    }
    if (o = ei.YY.exec(e) || t.exec(e), o) {
      const a = o[1];
      return {
        year: parseInt(a, 10) * 100,
        restDateString: e.slice(a.length)
      };
    }
  }
  return {
    year: null
  };
}
function i2(e, n) {
  if (n === null)
    return null;
  let t, r, o;
  if (!e || !e.length)
    return t = /* @__PURE__ */ new Date(0), t.setUTCFullYear(n), t;
  let a = ei.MM.exec(e);
  if (a)
    return t = /* @__PURE__ */ new Date(0), r = parseInt(a[1], 10) - 1, AE(n, r) ? (t.setUTCFullYear(n, r), t) : /* @__PURE__ */ new Date(NaN);
  if (a = ei.DDD.exec(e), a) {
    t = /* @__PURE__ */ new Date(0);
    const l = parseInt(a[1], 10);
    return c2(n, l) ? (t.setUTCFullYear(n, 0, l), t) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = ei.MMDD.exec(e), a) {
    t = /* @__PURE__ */ new Date(0), r = parseInt(a[1], 10) - 1;
    const l = parseInt(a[2], 10);
    return AE(n, r, l) ? (t.setUTCFullYear(n, r, l), t) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = ei.Www.exec(e), a)
    return o = parseInt(a[1], 10) - 1, SE(o) ? EE(n, o) : /* @__PURE__ */ new Date(NaN);
  if (a = ei.WwwD.exec(e), a) {
    o = parseInt(a[1], 10) - 1;
    const l = parseInt(a[2], 10) - 1;
    return SE(o, l) ? EE(n, o, l) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function a2(e) {
  let n, t, r = ei.HH.exec(e);
  if (r)
    return n = parseFloat(r[1].replace(",", ".")), iv(n) ? n % 24 * ov : NaN;
  if (r = ei.HHMM.exec(e), r)
    return n = parseInt(r[1], 10), t = parseFloat(r[2].replace(",", ".")), iv(n, t) ? n % 24 * ov + t * CE : NaN;
  if (r = ei.HHMMSS.exec(e), r) {
    n = parseInt(r[1], 10), t = parseInt(r[2], 10);
    const o = parseFloat(r[3].replace(",", "."));
    return iv(n, t, o) ? n % 24 * ov + t * CE + o * 1e3 : NaN;
  }
  return null;
}
function EE(e, n, t) {
  n = n || 0, t = t || 0;
  const r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  const o = r.getUTCDay() || 7, a = n * 7 + t + 1 - o;
  return r.setUTCDate(r.getUTCDate() + a), r;
}
const s2 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], l2 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function HT(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function AE(e, n, t) {
  if (n < 0 || n > 11)
    return !1;
  if (t != null) {
    if (t < 1)
      return !1;
    const r = HT(e);
    if (r && t > l2[n] || !r && t > s2[n])
      return !1;
  }
  return !0;
}
function c2(e, n) {
  if (n < 1)
    return !1;
  const t = HT(e);
  return !(t && n > 366 || !t && n > 365);
}
function SE(e, n) {
  return !(e < 0 || e > 52 || n != null && (n < 0 || n > 6));
}
function iv(e, n, t) {
  return !(e < 0 || e >= 25 || n != null && (n < 0 || n >= 60) || t != null && (t < 0 || t >= 60));
}
function u2(e, n, t) {
  e = n2(e, t);
  const r = WT(n, e, !0), o = new Date(e.getTime() - r), a = /* @__PURE__ */ new Date(0);
  return a.setFullYear(o.getUTCFullYear(), o.getUTCMonth(), o.getUTCDate()), a.setHours(o.getUTCHours(), o.getUTCMinutes(), o.getUTCSeconds(), o.getUTCMilliseconds()), a;
}
var Rh = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Rh.exports;
(function(e, n) {
  (function() {
    var t, r = "4.17.21", o = 200, a = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", l = "Expected a function", u = "Invalid `variable` option passed into `_.template`", f = "__lodash_hash_undefined__", p = 500, y = "__lodash_placeholder__", A = 1, w = 2, F = 4, j = 1, N = 2, D = 1, k = 2, z = 4, q = 8, Ce = 16, ee = 32, Fe = 64, Oe = 128, He = 256, Re = 512, Se = 30, we = "...", ae = 800, ge = 16, Ie = 1, Ye = 2, Ke = 3, ze = 1 / 0, ue = 9007199254740991, de = 17976931348623157e292, Q = NaN, me = 4294967295, Le = me - 1, Je = me >>> 1, Xe = [
      ["ary", Oe],
      ["bind", D],
      ["bindKey", k],
      ["curry", q],
      ["curryRight", Ce],
      ["flip", Re],
      ["partial", ee],
      ["partialRight", Fe],
      ["rearg", He]
    ], je = "[object Arguments]", Ue = "[object Array]", it = "[object AsyncFunction]", ct = "[object Boolean]", lt = "[object Date]", dt = "[object DOMException]", Mt = "[object Error]", Be = "[object Function]", Wt = "[object GeneratorFunction]", Ht = "[object Map]", Fn = "[object Number]", Fr = "[object Null]", $n = "[object Object]", er = "[object Promise]", Nr = "[object Proxy]", Cr = "[object RegExp]", Gn = "[object Set]", Rn = "[object String]", An = "[object Symbol]", Sn = "[object Undefined]", Mr = "[object WeakMap]", ii = "[object WeakSet]", tr = "[object ArrayBuffer]", tn = "[object DataView]", co = "[object Float32Array]", Oo = "[object Float64Array]", uo = "[object Int8Array]", Do = "[object Int16Array]", fo = "[object Int32Array]", xi = "[object Uint8Array]", Fo = "[object Uint8ClampedArray]", Lr = "[object Uint16Array]", No = "[object Uint32Array]", aa = /\b__p \+= '';/g, Nn = /\b(__p \+=) '' \+/g, Er = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Yn = /&(?:amp|lt|gt|quot|#39);/g, Bt = /[&<>"']/g, Br = RegExp(Yn.source), Mo = RegExp(Bt.source), Lo = /<%-([\s\S]+?)%>/g, Ar = /<%([\s\S]+?)%>/g, Bo = /<%=([\s\S]+?)%>/g, Vr = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ln = /^\w*$/, Ti = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Vo = /[\\^$.*+?()[\]{}|]/g, Pi = RegExp(Vo.source), cn = /^\s+/, ki = /\s/, Ba = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Va = /\{\n\/\* \[wrapped with (.+)\] \*/, X = /,? & /, ke = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Ve = /[()=,{}\[\]\/\s]/, at = /\\(\\)?/g, St = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Ot = /\w*$/, Tt = /^[-+]0x[0-9a-f]+$/i, Et = /^0b[01]+$/i, vn = /^\[object .+?Constructor\]$/, Kt = /^0o[0-7]+$/i, Xt = /^(?:0|[1-9]\d*)$/, pn = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Un = /($^)/, go = /['\n\r\u2028\u2029\\]/g, an = "\\ud800-\\udfff", bn = "\\u0300-\\u036f", po = "\\ufe20-\\ufe2f", qr = "\\u20d0-\\u20ff", Mn = bn + po + qr, Ri = "\\u2700-\\u27bf", _r = "a-z\\xdf-\\xf6\\xf8-\\xff", ho = "\\xac\\xb1\\xd7\\xf7", pr = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", jo = "\\u2000-\\u206f", ai = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", sa = "A-Z\\xc0-\\xd6\\xd8-\\xde", la = "\\ufe0e\\ufe0f", Oi = ho + pr + jo + ai, mo = "['’]", ja = "[" + an + "]", Di = "[" + Oi + "]", Uo = "[" + Mn + "]", v = "\\d+", P = "[" + Ri + "]", V = "[" + _r + "]", H = "[^" + an + Oi + v + Ri + _r + sa + "]", le = "\\ud83c[\\udffb-\\udfff]", ne = "(?:" + Uo + "|" + le + ")", ye = "[^" + an + "]", Ne = "(?:\\ud83c[\\udde6-\\uddff]){2}", Qe = "[\\ud800-\\udbff][\\udc00-\\udfff]", nt = "[" + sa + "]", et = "\\u200d", jt = "(?:" + V + "|" + H + ")", Sr = "(?:" + nt + "|" + H + ")", zn = "(?:" + mo + "(?:d|ll|m|re|s|t|ve))?", Zn = "(?:" + mo + "(?:D|LL|M|RE|S|T|VE))?", vo = ne + "?", jr = "[" + la + "]?", ca = "(?:" + et + "(?:" + [ye, Ne, Qe].join("|") + ")" + jr + vo + ")*", si = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Fi = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", bo = jr + vo + ca, Ua = "(?:" + [P, Ne, Qe].join("|") + ")" + bo, hu = "(?:" + [ye + Uo + "?", Uo, Ne, Qe, ja].join("|") + ")", mu = RegExp(mo, "g"), dl = RegExp(Uo, "g"), fl = RegExp(le + "(?=" + le + ")|" + hu + bo, "g"), gl = RegExp([
      nt + "?" + V + "+" + zn + "(?=" + [Di, nt, "$"].join("|") + ")",
      Sr + "+" + Zn + "(?=" + [Di, nt + jt, "$"].join("|") + ")",
      nt + "?" + jt + "+" + zn,
      nt + "+" + Zn,
      Fi,
      si,
      v,
      Ua
    ].join("|"), "g"), Wo = RegExp("[" + et + an + Mn + la + "]"), Wa = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Cs = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], rn = -1, Gt = {};
    Gt[co] = Gt[Oo] = Gt[uo] = Gt[Do] = Gt[fo] = Gt[xi] = Gt[Fo] = Gt[Lr] = Gt[No] = !0, Gt[je] = Gt[Ue] = Gt[tr] = Gt[ct] = Gt[tn] = Gt[lt] = Gt[Mt] = Gt[Be] = Gt[Ht] = Gt[Fn] = Gt[$n] = Gt[Cr] = Gt[Gn] = Gt[Rn] = Gt[Mr] = !1;
    var Pt = {};
    Pt[je] = Pt[Ue] = Pt[tr] = Pt[tn] = Pt[ct] = Pt[lt] = Pt[co] = Pt[Oo] = Pt[uo] = Pt[Do] = Pt[fo] = Pt[Ht] = Pt[Fn] = Pt[$n] = Pt[Cr] = Pt[Gn] = Pt[Rn] = Pt[An] = Pt[xi] = Pt[Fo] = Pt[Lr] = Pt[No] = !0, Pt[Mt] = Pt[Be] = Pt[Mr] = !1;
    var Ni = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, li = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, Es = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, ci = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, $r = parseFloat, pl = parseInt, As = typeof cg == "object" && cg && cg.Object === Object && cg, dc = typeof self == "object" && self && self.Object === Object && self, Ln = As || dc || Function("return this")(), Ss = n && !n.nodeType && n, Mi = Ss && !0 && e && !e.nodeType && e, fc = Mi && Mi.exports === Ss, ua = fc && As.process, nr = function() {
      try {
        var te = Mi && Mi.require && Mi.require("util").types;
        return te || ua && ua.binding && ua.binding("util");
      } catch {
      }
    }(), Ha = nr && nr.isArrayBuffer, da = nr && nr.isDate, gc = nr && nr.isMap, fa = nr && nr.isRegExp, ws = nr && nr.isSet, Is = nr && nr.isTypedArray;
    function Bn(te, Ee, he) {
      switch (he.length) {
        case 0:
          return te.call(Ee);
        case 1:
          return te.call(Ee, he[0]);
        case 2:
          return te.call(Ee, he[0], he[1]);
        case 3:
          return te.call(Ee, he[0], he[1], he[2]);
      }
      return te.apply(Ee, he);
    }
    function ga(te, Ee, he, Ze) {
      for (var ht = -1, Ut = te == null ? 0 : te.length; ++ht < Ut; ) {
        var wn = te[ht];
        Ee(Ze, wn, he(wn), te);
      }
      return Ze;
    }
    function rr(te, Ee) {
      for (var he = -1, Ze = te == null ? 0 : te.length; ++he < Ze && Ee(te[he], he, te) !== !1; )
        ;
      return te;
    }
    function pc(te, Ee) {
      for (var he = te == null ? 0 : te.length; he-- && Ee(te[he], he, te) !== !1; )
        ;
      return te;
    }
    function xs(te, Ee) {
      for (var he = -1, Ze = te == null ? 0 : te.length; ++he < Ze; )
        if (!Ee(te[he], he, te))
          return !1;
      return !0;
    }
    function Ho(te, Ee) {
      for (var he = -1, Ze = te == null ? 0 : te.length, ht = 0, Ut = []; ++he < Ze; ) {
        var wn = te[he];
        Ee(wn, he, te) && (Ut[ht++] = wn);
      }
      return Ut;
    }
    function Li(te, Ee) {
      var he = te == null ? 0 : te.length;
      return !!he && Bi(te, Ee, 0) > -1;
    }
    function or(te, Ee, he) {
      for (var Ze = -1, ht = te == null ? 0 : te.length; ++Ze < ht; )
        if (he(Ee, te[Ze]))
          return !0;
      return !1;
    }
    function sn(te, Ee) {
      for (var he = -1, Ze = te == null ? 0 : te.length, ht = Array(Ze); ++he < Ze; )
        ht[he] = Ee(te[he], he, te);
      return ht;
    }
    function eo(te, Ee) {
      for (var he = -1, Ze = Ee.length, ht = te.length; ++he < Ze; )
        te[ht + he] = Ee[he];
      return te;
    }
    function hl(te, Ee, he, Ze) {
      var ht = -1, Ut = te == null ? 0 : te.length;
      for (Ze && Ut && (he = te[++ht]); ++ht < Ut; )
        he = Ee(he, te[ht], ht, te);
      return he;
    }
    function hc(te, Ee, he, Ze) {
      var ht = te == null ? 0 : te.length;
      for (Ze && ht && (he = te[--ht]); ht--; )
        he = Ee(he, te[ht], ht, te);
      return he;
    }
    function pa(te, Ee) {
      for (var he = -1, Ze = te == null ? 0 : te.length; ++he < Ze; )
        if (Ee(te[he], he, te))
          return !0;
      return !1;
    }
    var mc = b("length");
    function vc(te) {
      return te.split("");
    }
    function Ts(te) {
      return te.match(ke) || [];
    }
    function Ga(te, Ee, he) {
      var Ze;
      return he(te, function(ht, Ut, wn) {
        if (Ee(ht, Ut, wn))
          return Ze = Ut, !1;
      }), Ze;
    }
    function Ya(te, Ee, he, Ze) {
      for (var ht = te.length, Ut = he + (Ze ? 1 : -1); Ze ? Ut-- : ++Ut < ht; )
        if (Ee(te[Ut], Ut, te))
          return Ut;
      return -1;
    }
    function Bi(te, Ee, he) {
      return Ee === Ee ? Xf(te, Ee, he) : Ya(te, Ps, he);
    }
    function bc(te, Ee, he, Ze) {
      for (var ht = he - 1, Ut = te.length; ++ht < Ut; )
        if (Ze(te[ht], Ee))
          return ht;
      return -1;
    }
    function Ps(te) {
      return te !== te;
    }
    function ml(te, Ee) {
      var he = te == null ? 0 : te.length;
      return he ? ce(te, Ee) / he : Q;
    }
    function b(te) {
      return function(Ee) {
        return Ee == null ? t : Ee[te];
      };
    }
    function T(te) {
      return function(Ee) {
        return te == null ? t : te[Ee];
      };
    }
    function L(te, Ee, he, Ze, ht) {
      return ht(te, function(Ut, wn, Jt) {
        he = Ze ? (Ze = !1, Ut) : Ee(he, Ut, wn, Jt);
      }), he;
    }
    function G(te, Ee) {
      var he = te.length;
      for (te.sort(Ee); he--; )
        te[he] = te[he].value;
      return te;
    }
    function ce(te, Ee) {
      for (var he, Ze = -1, ht = te.length; ++Ze < ht; ) {
        var Ut = Ee(te[Ze]);
        Ut !== t && (he = he === t ? Ut : he + Ut);
      }
      return he;
    }
    function ie(te, Ee) {
      for (var he = -1, Ze = Array(te); ++he < te; )
        Ze[he] = Ee(he);
      return Ze;
    }
    function Ae(te, Ee) {
      return sn(Ee, function(he) {
        return [he, te[he]];
      });
    }
    function Me(te) {
      return te && te.slice(0, yu(te) + 1).replace(cn, "");
    }
    function qe(te) {
      return function(Ee) {
        return te(Ee);
      };
    }
    function At(te, Ee) {
      return sn(Ee, function(he) {
        return te[he];
      });
    }
    function pt(te, Ee) {
      return te.has(Ee);
    }
    function on(te, Ee) {
      for (var he = -1, Ze = te.length; ++he < Ze && Bi(Ee, te[he], 0) > -1; )
        ;
      return he;
    }
    function hr(te, Ee) {
      for (var he = te.length; he-- && Bi(Ee, te[he], 0) > -1; )
        ;
      return he;
    }
    function to(te, Ee) {
      for (var he = te.length, Ze = 0; he--; )
        te[he] === Ee && ++Ze;
      return Ze;
    }
    var no = T(Ni), ks = T(li);
    function yc(te) {
      return "\\" + ci[te];
    }
    function vl(te, Ee) {
      return te == null ? t : te[Ee];
    }
    function Rs(te) {
      return Wo.test(te);
    }
    function zf(te) {
      return Wa.test(te);
    }
    function Zf(te) {
      for (var Ee, he = []; !(Ee = te.next()).done; )
        he.push(Ee.value);
      return he;
    }
    function vu(te) {
      var Ee = -1, he = Array(te.size);
      return te.forEach(function(Ze, ht) {
        he[++Ee] = [ht, Ze];
      }), he;
    }
    function xd(te, Ee) {
      return function(he) {
        return te(Ee(he));
      };
    }
    function ha(te, Ee) {
      for (var he = -1, Ze = te.length, ht = 0, Ut = []; ++he < Ze; ) {
        var wn = te[he];
        (wn === Ee || wn === y) && (te[he] = y, Ut[ht++] = he);
      }
      return Ut;
    }
    function Os(te) {
      var Ee = -1, he = Array(te.size);
      return te.forEach(function(Ze) {
        he[++Ee] = Ze;
      }), he;
    }
    function Kf(te) {
      var Ee = -1, he = Array(te.size);
      return te.forEach(function(Ze) {
        he[++Ee] = [Ze, Ze];
      }), he;
    }
    function Xf(te, Ee, he) {
      for (var Ze = he - 1, ht = te.length; ++Ze < ht; )
        if (te[Ze] === Ee)
          return Ze;
      return -1;
    }
    function bu(te, Ee, he) {
      for (var Ze = he + 1; Ze--; )
        if (te[Ze] === Ee)
          return Ze;
      return Ze;
    }
    function Ds(te) {
      return Rs(te) ? Cu(te) : mc(te);
    }
    function ro(te) {
      return Rs(te) ? yo(te) : vc(te);
    }
    function yu(te) {
      for (var Ee = te.length; Ee-- && ki.test(te.charAt(Ee)); )
        ;
      return Ee;
    }
    var Td = T(Es);
    function Cu(te) {
      for (var Ee = fl.lastIndex = 0; fl.test(te); )
        ++Ee;
      return Ee;
    }
    function yo(te) {
      return te.match(fl) || [];
    }
    function Jf(te) {
      return te.match(gl) || [];
    }
    var Pd = function te(Ee) {
      Ee = Ee == null ? Ln : Kn.defaults(Ln.Object(), Ee, Kn.pick(Ln, Cs));
      var he = Ee.Array, Ze = Ee.Date, ht = Ee.Error, Ut = Ee.Function, wn = Ee.Math, Jt = Ee.Object, ma = Ee.RegExp, Eu = Ee.String, Ur = Ee.TypeError, za = he.prototype, Qf = Ut.prototype, Za = Jt.prototype, Cc = Ee["__core-js_shared__"], Ec = Qf.toString, _t = Za.hasOwnProperty, kd = 0, yn = function() {
        var i = /[^.]+$/.exec(Cc && Cc.keys && Cc.keys.IE_PROTO || "");
        return i ? "Symbol(src)_1." + i : "";
      }(), va = Za.toString, Au = Ec.call(Jt), Cn = Ln._, Fs = ma(
        "^" + Ec.call(_t).replace(Vo, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Ns = fc ? Ee.Buffer : t, ui = Ee.Symbol, Ms = Ee.Uint8Array, Ac = Ns ? Ns.allocUnsafe : t, Ls = xd(Jt.getPrototypeOf, Jt), Su = Jt.create, wu = Za.propertyIsEnumerable, Ka = za.splice, Sc = ui ? ui.isConcatSpreadable : t, Vi = ui ? ui.iterator : t, Go = ui ? ui.toStringTag : t, ji = function() {
        try {
          var i = $u(Jt, "defineProperty");
          return i({}, "", {}), i;
        } catch {
        }
      }(), bl = Ee.clearTimeout !== Ln.clearTimeout && Ee.clearTimeout, yl = Ze && Ze.now !== Ln.Date.now && Ze.now, wc = Ee.setTimeout !== Ln.setTimeout && Ee.setTimeout, Cl = wn.ceil, Bs = wn.floor, El = Jt.getOwnPropertySymbols, Iu = Ns ? Ns.isBuffer : t, xu = Ee.isFinite, Vs = za.join, Tu = xd(Jt.keys, Jt), xn = wn.max, Tn = wn.min, Pu = Ze.now, ku = Ee.parseInt, Ui = wn.random, Rd = za.reverse, Wi = $u(Ee, "DataView"), Yo = $u(Ee, "Map"), Al = $u(Ee, "Promise"), wr = $u(Ee, "Set"), ba = $u(Ee, "WeakMap"), ya = $u(Jt, "create"), Ca = ba && new ba(), Ea = {}, Sl = ed(Wi), Od = ed(Yo), Dd = ed(Al), Ic = ed(wr), wl = ed(ba), js = ui ? ui.prototype : t, Il = js ? js.valueOf : t, Xa = js ? js.toString : t;
      function B(i) {
        if (Jn(i) && !Dt(i) && !(i instanceof kt)) {
          if (i instanceof Ir)
            return i;
          if (_t.call(i, "__wrapped__"))
            return Ky(i);
        }
        return new Ir(i);
      }
      var Aa = /* @__PURE__ */ function() {
        function i() {
        }
        return function(s) {
          if (!Wn(s))
            return {};
          if (Su)
            return Su(s);
          i.prototype = s;
          var g = new i();
          return i.prototype = t, g;
        };
      }();
      function Ja() {
      }
      function Ir(i, s) {
        this.__wrapped__ = i, this.__actions__ = [], this.__chain__ = !!s, this.__index__ = 0, this.__values__ = t;
      }
      B.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Lo,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Ar,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Bo,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: B
        }
      }, B.prototype = Ja.prototype, B.prototype.constructor = B, Ir.prototype = Aa(Ja.prototype), Ir.prototype.constructor = Ir;
      function kt(i) {
        this.__wrapped__ = i, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = me, this.__views__ = [];
      }
      function xc() {
        var i = new kt(this.__wrapped__);
        return i.__actions__ = sr(this.__actions__), i.__dir__ = this.__dir__, i.__filtered__ = this.__filtered__, i.__iteratees__ = sr(this.__iteratees__), i.__takeCount__ = this.__takeCount__, i.__views__ = sr(this.__views__), i;
      }
      function Us() {
        if (this.__filtered__) {
          var i = new kt(this);
          i.__dir__ = -1, i.__filtered__ = !0;
        } else
          i = this.clone(), i.__dir__ *= -1;
        return i;
      }
      function xl() {
        var i = this.__wrapped__.value(), s = this.__dir__, g = Dt(i), E = s < 0, O = g ? i.length : 0, U = _T(0, O, this.__views__), K = U.start, $ = U.end, re = $ - K, xe = E ? $ : K - 1, Te = this.__iteratees__, De = Te.length, Ge = 0, rt = Tn(re, this.__takeCount__);
        if (!g || !E && O == re && rt == re)
          return Gr(i, this.__actions__);
        var vt = [];
        e:
          for (; re-- && Ge < rt; ) {
            xe += s;
            for (var Vt = -1, bt = i[xe]; ++Vt < De; ) {
              var Zt = Te[Vt], Qt = Zt.iteratee, Ji = Zt.type, qo = Qt(bt);
              if (Ji == Ye)
                bt = qo;
              else if (!qo) {
                if (Ji == Ie)
                  continue e;
                break e;
              }
            }
            vt[Ge++] = bt;
          }
        return vt;
      }
      kt.prototype = Aa(Ja.prototype), kt.prototype.constructor = kt;
      function di(i) {
        var s = -1, g = i == null ? 0 : i.length;
        for (this.clear(); ++s < g; ) {
          var E = i[s];
          this.set(E[0], E[1]);
        }
      }
      function Ws() {
        this.__data__ = ya ? ya(null) : {}, this.size = 0;
      }
      function Tc(i) {
        var s = this.has(i) && delete this.__data__[i];
        return this.size -= s ? 1 : 0, s;
      }
      function Pc(i) {
        var s = this.__data__;
        if (ya) {
          var g = s[i];
          return g === f ? t : g;
        }
        return _t.call(s, i) ? s[i] : t;
      }
      function kc(i) {
        var s = this.__data__;
        return ya ? s[i] !== t : _t.call(s, i);
      }
      function Fd(i, s) {
        var g = this.__data__;
        return this.size += this.has(i) ? 0 : 1, g[i] = ya && s === t ? f : s, this;
      }
      di.prototype.clear = Ws, di.prototype.delete = Tc, di.prototype.get = Pc, di.prototype.has = kc, di.prototype.set = Fd;
      function fi(i) {
        var s = -1, g = i == null ? 0 : i.length;
        for (this.clear(); ++s < g; ) {
          var E = i[s];
          this.set(E[0], E[1]);
        }
      }
      function Nd() {
        this.__data__ = [], this.size = 0;
      }
      function qf(i) {
        var s = this.__data__, g = Eo(s, i);
        if (g < 0)
          return !1;
        var E = s.length - 1;
        return g == E ? s.pop() : Ka.call(s, g, 1), --this.size, !0;
      }
      function _f(i) {
        var s = this.__data__, g = Eo(s, i);
        return g < 0 ? t : s[g][1];
      }
      function Md(i) {
        return Eo(this.__data__, i) > -1;
      }
      function $f(i, s) {
        var g = this.__data__, E = Eo(g, i);
        return E < 0 ? (++this.size, g.push([i, s])) : g[E][1] = s, this;
      }
      fi.prototype.clear = Nd, fi.prototype.delete = qf, fi.prototype.get = _f, fi.prototype.has = Md, fi.prototype.set = $f;
      function Hi(i) {
        var s = -1, g = i == null ? 0 : i.length;
        for (this.clear(); ++s < g; ) {
          var E = i[s];
          this.set(E[0], E[1]);
        }
      }
      function Rc() {
        this.size = 0, this.__data__ = {
          hash: new di(),
          map: new (Yo || fi)(),
          string: new di()
        };
      }
      function Oc(i) {
        var s = $g(this, i).delete(i);
        return this.size -= s ? 1 : 0, s;
      }
      function eg(i) {
        return $g(this, i).get(i);
      }
      function Ru(i) {
        return $g(this, i).has(i);
      }
      function Dc(i, s) {
        var g = $g(this, i), E = g.size;
        return g.set(i, s), this.size += g.size == E ? 0 : 1, this;
      }
      Hi.prototype.clear = Rc, Hi.prototype.delete = Oc, Hi.prototype.get = eg, Hi.prototype.has = Ru, Hi.prototype.set = Dc;
      function Qa(i) {
        var s = -1, g = i == null ? 0 : i.length;
        for (this.__data__ = new Hi(); ++s < g; )
          this.add(i[s]);
      }
      function tg(i) {
        return this.__data__.set(i, f), this;
      }
      function ng(i) {
        return this.__data__.has(i);
      }
      Qa.prototype.add = Qa.prototype.push = tg, Qa.prototype.has = ng;
      function zo(i) {
        var s = this.__data__ = new fi(i);
        this.size = s.size;
      }
      function Gi() {
        this.__data__ = new fi(), this.size = 0;
      }
      function Ou(i) {
        var s = this.__data__, g = s.delete(i);
        return this.size = s.size, g;
      }
      function Fc(i) {
        return this.__data__.get(i);
      }
      function Yt(i) {
        return this.__data__.has(i);
      }
      function qa(i, s) {
        var g = this.__data__;
        if (g instanceof fi) {
          var E = g.__data__;
          if (!Yo || E.length < o - 1)
            return E.push([i, s]), this.size = ++g.size, this;
          g = this.__data__ = new Hi(E);
        }
        return g.set(i, s), this.size = g.size, this;
      }
      zo.prototype.clear = Gi, zo.prototype.delete = Ou, zo.prototype.get = Fc, zo.prototype.has = Yt, zo.prototype.set = qa;
      function Sa(i, s) {
        var g = Dt(i), E = !g && td(i), O = !g && !E && Xc(i), U = !g && !E && !O && Jd(i), K = g || E || O || U, $ = K ? ie(i.length, Eu) : [], re = $.length;
        for (var xe in i)
          (s || _t.call(i, xe)) && !(K && // Safari 9 has enumerable `arguments.length` in strict mode.
          (xe == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          O && (xe == "offset" || xe == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          U && (xe == "buffer" || xe == "byteLength" || xe == "byteOffset") || // Skip index properties.
          zl(xe, re))) && $.push(xe);
        return $;
      }
      function $t(i) {
        var s = i.length;
        return s ? i[Uc(0, s - 1)] : t;
      }
      function Co(i, s) {
        return ep(sr(i), wa(s, 0, i.length));
      }
      function _a(i) {
        return ep(sr(i));
      }
      function Hs(i, s, g) {
        (g !== t && !ss(i[s], g) || g === t && !(s in i)) && ir(i, s, g);
      }
      function On(i, s, g) {
        var E = i[s];
        (!(_t.call(i, s) && ss(E, g)) || g === t && !(s in i)) && ir(i, s, g);
      }
      function Eo(i, s) {
        for (var g = i.length; g--; )
          if (ss(i[g][0], s))
            return g;
        return -1;
      }
      function $a(i, s, g, E) {
        return Ia(i, function(O, U, K) {
          s(E, O, g(O), K);
        }), E;
      }
      function Zo(i, s) {
        return i && hi(s, Yr(s), i);
      }
      function es(i, s) {
        return i && hi(s, vi(s), i);
      }
      function ir(i, s, g) {
        s == "__proto__" && ji ? ji(i, s, {
          configurable: !0,
          enumerable: !0,
          value: g,
          writable: !0
        }) : i[s] = g;
      }
      function Du(i, s) {
        for (var g = -1, E = s.length, O = he(E), U = i == null; ++g < E; )
          O[g] = U ? t : hm(i, s[g]);
        return O;
      }
      function wa(i, s, g) {
        return i === i && (g !== t && (i = i <= g ? i : g), s !== t && (i = i >= s ? i : s)), i;
      }
      function xr(i, s, g, E, O, U) {
        var K, $ = s & A, re = s & w, xe = s & F;
        if (g && (K = O ? g(i, E, O, U) : g(i)), K !== t)
          return K;
        if (!Wn(i))
          return i;
        var Te = Dt(i);
        if (Te) {
          if (K = eP(i), !$)
            return sr(i, K);
        } else {
          var De = Io(i), Ge = De == Be || De == Wt;
          if (Xc(i))
            return Ju(i, $);
          if (De == $n || De == je || Ge && !O) {
            if (K = re || Ge ? {} : Vy(i), !$)
              return re ? Zc(i, es(K, i)) : Zd(i, Zo(K, i));
          } else {
            if (!Pt[De])
              return O ? i : {};
            K = tP(i, De, $);
          }
        }
        U || (U = new zo());
        var rt = U.get(i);
        if (rt)
          return rt;
        U.set(i, K), g0(i) ? i.forEach(function(bt) {
          K.add(xr(bt, s, g, bt, i, U));
        }) : d0(i) && i.forEach(function(bt, Zt) {
          K.set(Zt, xr(bt, s, g, Zt, i, U));
        });
        var vt = xe ? re ? tm : em : re ? vi : Yr, Vt = Te ? t : vt(i);
        return rr(Vt || i, function(bt, Zt) {
          Vt && (Zt = bt, bt = i[Zt]), On(K, Zt, xr(bt, s, g, Zt, i, U));
        }), K;
      }
      function Fu(i) {
        var s = Yr(i);
        return function(g) {
          return Ld(g, i, s);
        };
      }
      function Ld(i, s, g) {
        var E = g.length;
        if (i == null)
          return !E;
        for (i = Jt(i); E--; ) {
          var O = g[E], U = s[O], K = i[O];
          if (K === t && !(O in i) || !U(K))
            return !1;
        }
        return !0;
      }
      function Nu(i, s, g) {
        if (typeof i != "function")
          throw new Ur(l);
        return sg(function() {
          i.apply(t, g);
        }, s);
      }
      function Yi(i, s, g, E) {
        var O = -1, U = Li, K = !0, $ = i.length, re = [], xe = s.length;
        if (!$)
          return re;
        g && (s = sn(s, qe(g))), E ? (U = or, K = !1) : s.length >= o && (U = pt, K = !1, s = new Qa(s));
        e:
          for (; ++O < $; ) {
            var Te = i[O], De = g == null ? Te : g(Te);
            if (Te = E || Te !== 0 ? Te : 0, K && De === De) {
              for (var Ge = xe; Ge--; )
                if (s[Ge] === De)
                  continue e;
              re.push(Te);
            } else
              U(s, De, E) || re.push(Te);
          }
        return re;
      }
      var Ia = m(gi), Mu = m(Vu, !0);
      function Nc(i, s) {
        var g = !0;
        return Ia(i, function(E, O, U) {
          return g = !!s(E, O, U), g;
        }), g;
      }
      function Mc(i, s, g) {
        for (var E = -1, O = i.length; ++E < O; ) {
          var U = i[E], K = s(U);
          if (K != null && ($ === t ? K === K && !Xi(K) : g(K, $)))
            var $ = K, re = U;
        }
        return re;
      }
      function Bd(i, s, g, E) {
        var O = i.length;
        for (g = Lt(g), g < 0 && (g = -g > O ? 0 : O + g), E = E === t || E > O ? O : Lt(E), E < 0 && (E += O), E = g > E ? 0 : h0(E); g < E; )
          i[g++] = s;
        return i;
      }
      function Lu(i, s) {
        var g = [];
        return Ia(i, function(E, O, U) {
          s(E, O, U) && g.push(E);
        }), g;
      }
      function ar(i, s, g, E, O) {
        var U = -1, K = i.length;
        for (g || (g = rP), O || (O = []); ++U < K; ) {
          var $ = i[U];
          s > 0 && g($) ? s > 1 ? ar($, s - 1, g, E, O) : eo(O, $) : E || (O[O.length] = $);
        }
        return O;
      }
      var Bu = S(), Vd = S(!0);
      function gi(i, s) {
        return i && Bu(i, s, Yr);
      }
      function Vu(i, s) {
        return i && Vd(i, s, Yr);
      }
      function Lc(i, s) {
        return Ho(s, function(g) {
          return Zl(i[g]);
        });
      }
      function ts(i, s) {
        s = Ki(s, i);
        for (var g = 0, E = s.length; i != null && g < E; )
          i = i[Qs(s[g++])];
        return g && g == E ? i : t;
      }
      function Tl(i, s, g) {
        var E = s(i);
        return Dt(i) ? E : eo(E, g(i));
      }
      function mr(i) {
        return i == null ? i === t ? Sn : Fr : Go && Go in Jt(i) ? qT(i) : uP(i);
      }
      function Pl(i, s) {
        return i > s;
      }
      function kl(i, s) {
        return i != null && _t.call(i, s);
      }
      function jd(i, s) {
        return i != null && s in Jt(i);
      }
      function Rl(i, s, g) {
        return i >= Tn(s, g) && i < xn(s, g);
      }
      function Gs(i, s, g) {
        for (var E = g ? or : Li, O = i[0].length, U = i.length, K = U, $ = he(U), re = 1 / 0, xe = []; K--; ) {
          var Te = i[K];
          K && s && (Te = sn(Te, qe(s))), re = Tn(Te.length, re), $[K] = !g && (s || O >= 120 && Te.length >= 120) ? new Qa(K && Te) : t;
        }
        Te = i[0];
        var De = -1, Ge = $[0];
        e:
          for (; ++De < O && xe.length < re; ) {
            var rt = Te[De], vt = s ? s(rt) : rt;
            if (rt = g || rt !== 0 ? rt : 0, !(Ge ? pt(Ge, vt) : E(xe, vt, g))) {
              for (K = U; --K; ) {
                var Vt = $[K];
                if (!(Vt ? pt(Vt, vt) : E(i[K], vt, g)))
                  continue e;
              }
              Ge && Ge.push(vt), xe.push(rt);
            }
          }
        return xe;
      }
      function ju(i, s, g, E) {
        return gi(i, function(O, U, K) {
          s(E, g(O), U, K);
        }), E;
      }
      function Ao(i, s, g) {
        s = Ki(s, i), i = Hy(i, s);
        var E = i == null ? i : i[Qs(Ta(s))];
        return E == null ? t : Bn(E, i, g);
      }
      function Ol(i) {
        return Jn(i) && mr(i) == je;
      }
      function Bc(i) {
        return Jn(i) && mr(i) == tr;
      }
      function ns(i) {
        return Jn(i) && mr(i) == lt;
      }
      function Ys(i, s, g, E, O) {
        return i === s ? !0 : i == null || s == null || !Jn(i) && !Jn(s) ? i !== i && s !== s : Uu(i, s, g, E, Ys, O);
      }
      function Uu(i, s, g, E, O, U) {
        var K = Dt(i), $ = Dt(s), re = K ? Ue : Io(i), xe = $ ? Ue : Io(s);
        re = re == je ? $n : re, xe = xe == je ? $n : xe;
        var Te = re == $n, De = xe == $n, Ge = re == xe;
        if (Ge && Xc(i)) {
          if (!Xc(s))
            return !1;
          K = !0, Te = !1;
        }
        if (Ge && !Te)
          return U || (U = new zo()), K || Jd(i) ? Gl(i, s, g, E, O, U) : _h(i, s, re, g, E, O, U);
        if (!(g & j)) {
          var rt = Te && _t.call(i, "__wrapped__"), vt = De && _t.call(s, "__wrapped__");
          if (rt || vt) {
            var Vt = rt ? i.value() : i, bt = vt ? s.value() : s;
            return U || (U = new zo()), O(Vt, bt, g, E, U);
          }
        }
        return Ge ? (U || (U = new zo()), $h(i, s, g, E, O, U)) : !1;
      }
      function rs(i) {
        return Jn(i) && Io(i) == Ht;
      }
      function Wu(i, s, g, E) {
        var O = g.length, U = O, K = !E;
        if (i == null)
          return !U;
        for (i = Jt(i); O--; ) {
          var $ = g[O];
          if (K && $[2] ? $[1] !== i[$[0]] : !($[0] in i))
            return !1;
        }
        for (; ++O < U; ) {
          $ = g[O];
          var re = $[0], xe = i[re], Te = $[1];
          if (K && $[2]) {
            if (xe === t && !(re in i))
              return !1;
          } else {
            var De = new zo();
            if (E)
              var Ge = E(xe, Te, re, i, s, De);
            if (!(Ge === t ? Ys(Te, xe, j | N, E, De) : Ge))
              return !1;
          }
        }
        return !0;
      }
      function Hu(i) {
        if (!Wn(i) || iP(i))
          return !1;
        var s = Zl(i) ? Fs : vn;
        return s.test(ed(i));
      }
      function pi(i) {
        return Jn(i) && mr(i) == Cr;
      }
      function rg(i) {
        return Jn(i) && Io(i) == Gn;
      }
      function og(i) {
        return Jn(i) && ap(i.length) && !!Gt[mr(i)];
      }
      function zs(i) {
        return typeof i == "function" ? i : i == null ? bi : typeof i == "object" ? Dt(i) ? Xo(i[0], i[1]) : zi(i) : x0(i);
      }
      function Dl(i) {
        if (!ag(i))
          return Tu(i);
        var s = [];
        for (var g in Jt(i))
          _t.call(i, g) && g != "constructor" && s.push(g);
        return s;
      }
      function Vc(i) {
        if (!Wn(i))
          return cP(i);
        var s = ag(i), g = [];
        for (var E in i)
          E == "constructor" && (s || !_t.call(i, E)) || g.push(E);
        return g;
      }
      function Ko(i, s) {
        return i < s;
      }
      function Zs(i, s) {
        var g = -1, E = mi(i) ? he(i.length) : [];
        return Ia(i, function(O, U, K) {
          E[++g] = s(O, U, K);
        }), E;
      }
      function zi(i) {
        var s = rm(i);
        return s.length == 1 && s[0][2] ? Uy(s[0][0], s[0][1]) : function(g) {
          return g === i || Wu(g, i, s);
        };
      }
      function Xo(i, s) {
        return im(i) && jy(s) ? Uy(Qs(i), s) : function(g) {
          var E = hm(g, i);
          return E === t && E === s ? mm(g, i) : Ys(s, E, j | N);
        };
      }
      function Ks(i, s, g, E, O) {
        i !== s && Bu(s, function(U, K) {
          if (O || (O = new zo()), Wn(U))
            So(i, s, K, g, Ks, E, O);
          else {
            var $ = E ? E(sm(i, K), U, K + "", i, s, O) : t;
            $ === t && ($ = U), Hs(i, K, $);
          }
        }, vi);
      }
      function So(i, s, g, E, O, U, K) {
        var $ = sm(i, g), re = sm(s, g), xe = K.get(re);
        if (xe) {
          Hs(i, g, xe);
          return;
        }
        var Te = U ? U($, re, g + "", i, s, K) : t, De = Te === t;
        if (De) {
          var Ge = Dt(re), rt = !Ge && Xc(re), vt = !Ge && !rt && Jd(re);
          Te = re, Ge || rt || vt ? Dt($) ? Te = $ : lr($) ? Te = sr($) : rt ? (De = !1, Te = Ju(re, !0)) : vt ? (De = !1, Te = Qu(re, !0)) : Te = [] : lg(re) || td(re) ? (Te = $, td($) ? Te = m0($) : (!Wn($) || Zl($)) && (Te = Vy(re))) : De = !1;
        }
        De && (K.set(re, Te), O(Te, re, E, U, K), K.delete(re)), Hs(i, g, Te);
      }
      function os(i, s) {
        var g = i.length;
        if (g)
          return s += s < 0 ? g : 0, zl(s, g) ? i[s] : t;
      }
      function jc(i, s, g) {
        s.length ? s = sn(s, function(U) {
          return Dt(U) ? function(K) {
            return ts(K, U.length === 1 ? U[0] : U);
          } : U;
        }) : s = [bi];
        var E = -1;
        s = sn(s, qe(mt()));
        var O = Zs(i, function(U, K, $) {
          var re = sn(s, function(xe) {
            return xe(U);
          });
          return { criteria: re, index: ++E, value: U };
        });
        return G(O, function(U, K) {
          return Hl(U, K, g);
        });
      }
      function wo(i, s) {
        return Zi(i, s, function(g, E) {
          return mm(i, E);
        });
      }
      function Zi(i, s, g) {
        for (var E = -1, O = s.length, U = {}; ++E < O; ) {
          var K = s[E], $ = ts(i, K);
          g($, K) && as(U, Ki(K, i), $);
        }
        return U;
      }
      function Gu(i) {
        return function(s) {
          return ts(s, i);
        };
      }
      function is(i, s, g, E) {
        var O = E ? bc : Bi, U = -1, K = s.length, $ = i;
        for (i === s && (s = sr(s)), g && ($ = sn(i, qe(g))); ++U < K; )
          for (var re = 0, xe = s[U], Te = g ? g(xe) : xe; (re = O($, Te, re, E)) > -1; )
            $ !== i && Ka.call($, re, 1), Ka.call(i, re, 1);
        return i;
      }
      function Fl(i, s) {
        for (var g = i ? s.length : 0, E = g - 1; g--; ) {
          var O = s[g];
          if (g == E || O !== U) {
            var U = O;
            zl(O) ? Ka.call(i, O, 1) : Ku(i, O);
          }
        }
        return i;
      }
      function Uc(i, s) {
        return i + Bs(Ui() * (s - i + 1));
      }
      function Ud(i, s, g, E) {
        for (var O = -1, U = xn(Cl((s - i) / (g || 1)), 0), K = he(U); U--; )
          K[E ? U : ++O] = i, i += g;
        return K;
      }
      function Yu(i, s) {
        var g = "";
        if (!i || s < 1 || s > ue)
          return g;
        do
          s % 2 && (g += i), s = Bs(s / 2), s && (i += i);
        while (s);
        return g;
      }
      function wt(i, s) {
        return lm(Wy(i, s, bi), i + "");
      }
      function Nl(i) {
        return $t(Qd(i));
      }
      function Wd(i, s) {
        var g = Qd(i);
        return ep(g, wa(s, 0, g.length));
      }
      function as(i, s, g, E) {
        if (!Wn(i))
          return i;
        s = Ki(s, i);
        for (var O = -1, U = s.length, K = U - 1, $ = i; $ != null && ++O < U; ) {
          var re = Qs(s[O]), xe = g;
          if (re === "__proto__" || re === "constructor" || re === "prototype")
            return i;
          if (O != K) {
            var Te = $[re];
            xe = E ? E(Te, re, $) : t, xe === t && (xe = Wn(Te) ? Te : zl(s[O + 1]) ? [] : {});
          }
          On($, re, xe), $ = $[re];
        }
        return i;
      }
      var Xs = Ca ? function(i, s) {
        return Ca.set(i, s), i;
      } : bi, zu = ji ? function(i, s) {
        return ji(i, "toString", {
          configurable: !0,
          enumerable: !1,
          value: bm(s),
          writable: !0
        });
      } : bi;
      function Zu(i) {
        return ep(Qd(i));
      }
      function Wr(i, s, g) {
        var E = -1, O = i.length;
        s < 0 && (s = -s > O ? 0 : O + s), g = g > O ? O : g, g < 0 && (g += O), O = s > g ? 0 : g - s >>> 0, s >>>= 0;
        for (var U = he(O); ++E < O; )
          U[E] = i[E + s];
        return U;
      }
      function Hd(i, s) {
        var g;
        return Ia(i, function(E, O, U) {
          return g = s(E, O, U), !g;
        }), !!g;
      }
      function Ml(i, s, g) {
        var E = 0, O = i == null ? E : i.length;
        if (typeof s == "number" && s === s && O <= Je) {
          for (; E < O; ) {
            var U = E + O >>> 1, K = i[U];
            K !== null && !Xi(K) && (g ? K <= s : K < s) ? E = U + 1 : O = U;
          }
          return O;
        }
        return Ll(i, s, bi, g);
      }
      function Ll(i, s, g, E) {
        var O = 0, U = i == null ? 0 : i.length;
        if (U === 0)
          return 0;
        s = g(s);
        for (var K = s !== s, $ = s === null, re = Xi(s), xe = s === t; O < U; ) {
          var Te = Bs((O + U) / 2), De = g(i[Te]), Ge = De !== t, rt = De === null, vt = De === De, Vt = Xi(De);
          if (K)
            var bt = E || vt;
          else
            xe ? bt = vt && (E || Ge) : $ ? bt = vt && Ge && (E || !rt) : re ? bt = vt && Ge && !rt && (E || !Vt) : rt || Vt ? bt = !1 : bt = E ? De <= s : De < s;
          bt ? O = Te + 1 : U = Te;
        }
        return Tn(U, Le);
      }
      function Gd(i, s) {
        for (var g = -1, E = i.length, O = 0, U = []; ++g < E; ) {
          var K = i[g], $ = s ? s(K) : K;
          if (!g || !ss($, re)) {
            var re = $;
            U[O++] = K === 0 ? 0 : K;
          }
        }
        return U;
      }
      function Yd(i) {
        return typeof i == "number" ? i : Xi(i) ? Q : +i;
      }
      function Hr(i) {
        if (typeof i == "string")
          return i;
        if (Dt(i))
          return sn(i, Hr) + "";
        if (Xi(i))
          return Xa ? Xa.call(i) : "";
        var s = i + "";
        return s == "0" && 1 / i == -ze ? "-0" : s;
      }
      function xa(i, s, g) {
        var E = -1, O = Li, U = i.length, K = !0, $ = [], re = $;
        if (g)
          K = !1, O = or;
        else if (U >= o) {
          var xe = s ? null : hn(i);
          if (xe)
            return Os(xe);
          K = !1, O = pt, re = new Qa();
        } else
          re = s ? [] : $;
        e:
          for (; ++E < U; ) {
            var Te = i[E], De = s ? s(Te) : Te;
            if (Te = g || Te !== 0 ? Te : 0, K && De === De) {
              for (var Ge = re.length; Ge--; )
                if (re[Ge] === De)
                  continue e;
              s && re.push(De), $.push(Te);
            } else
              O(re, De, g) || (re !== $ && re.push(De), $.push(Te));
          }
        return $;
      }
      function Ku(i, s) {
        return s = Ki(s, i), i = Hy(i, s), i == null || delete i[Qs(Ta(s))];
      }
      function Wc(i, s, g, E) {
        return as(i, s, g(ts(i, s)), E);
      }
      function Hc(i, s, g, E) {
        for (var O = i.length, U = E ? O : -1; (E ? U-- : ++U < O) && s(i[U], U, i); )
          ;
        return g ? Wr(i, E ? 0 : U, E ? U + 1 : O) : Wr(i, E ? U + 1 : 0, E ? O : U);
      }
      function Gr(i, s) {
        var g = i;
        return g instanceof kt && (g = g.value()), hl(s, function(E, O) {
          return O.func.apply(O.thisArg, eo([E], O.args));
        }, g);
      }
      function Bl(i, s, g) {
        var E = i.length;
        if (E < 2)
          return E ? xa(i[0]) : [];
        for (var O = -1, U = he(E); ++O < E; )
          for (var K = i[O], $ = -1; ++$ < E; )
            $ != O && (U[O] = Yi(U[O] || K, i[$], s, g));
        return xa(ar(U, 1), s, g);
      }
      function Xu(i, s, g) {
        for (var E = -1, O = i.length, U = s.length, K = {}; ++E < O; ) {
          var $ = E < U ? s[E] : t;
          g(K, i[E], $);
        }
        return K;
      }
      function Tr(i) {
        return lr(i) ? i : [];
      }
      function Vl(i) {
        return typeof i == "function" ? i : bi;
      }
      function Ki(i, s) {
        return Dt(i) ? i : im(i, s) ? [i] : Zy(un(i));
      }
      var ig = wt;
      function Jo(i, s, g) {
        var E = i.length;
        return g = g === t ? E : g, !s && g >= E ? i : Wr(i, s, g);
      }
      var jl = bl || function(i) {
        return Ln.clearTimeout(i);
      };
      function Ju(i, s) {
        if (s)
          return i.slice();
        var g = i.length, E = Ac ? Ac(g) : new i.constructor(g);
        return i.copy(E), E;
      }
      function Gc(i) {
        var s = new i.constructor(i.byteLength);
        return new Ms(s).set(new Ms(i)), s;
      }
      function Ul(i, s) {
        var g = s ? Gc(i.buffer) : i.buffer;
        return new i.constructor(g, i.byteOffset, i.byteLength);
      }
      function Wl(i) {
        var s = new i.constructor(i.source, Ot.exec(i));
        return s.lastIndex = i.lastIndex, s;
      }
      function Yc(i) {
        return Il ? Jt(Il.call(i)) : {};
      }
      function Qu(i, s) {
        var g = s ? Gc(i.buffer) : i.buffer;
        return new i.constructor(g, i.byteOffset, i.length);
      }
      function Js(i, s) {
        if (i !== s) {
          var g = i !== t, E = i === null, O = i === i, U = Xi(i), K = s !== t, $ = s === null, re = s === s, xe = Xi(s);
          if (!$ && !xe && !U && i > s || U && K && re && !$ && !xe || E && K && re || !g && re || !O)
            return 1;
          if (!E && !U && !xe && i < s || xe && g && O && !E && !U || $ && g && O || !K && O || !re)
            return -1;
        }
        return 0;
      }
      function Hl(i, s, g) {
        for (var E = -1, O = i.criteria, U = s.criteria, K = O.length, $ = g.length; ++E < K; ) {
          var re = Js(O[E], U[E]);
          if (re) {
            if (E >= $)
              return re;
            var xe = g[E];
            return re * (xe == "desc" ? -1 : 1);
          }
        }
        return i.index - s.index;
      }
      function zd(i, s, g, E) {
        for (var O = -1, U = i.length, K = g.length, $ = -1, re = s.length, xe = xn(U - K, 0), Te = he(re + xe), De = !E; ++$ < re; )
          Te[$] = s[$];
        for (; ++O < K; )
          (De || O < U) && (Te[g[O]] = i[O]);
        for (; xe--; )
          Te[$++] = i[O++];
        return Te;
      }
      function zc(i, s, g, E) {
        for (var O = -1, U = i.length, K = -1, $ = g.length, re = -1, xe = s.length, Te = xn(U - $, 0), De = he(Te + xe), Ge = !E; ++O < Te; )
          De[O] = i[O];
        for (var rt = O; ++re < xe; )
          De[rt + re] = s[re];
        for (; ++K < $; )
          (Ge || O < U) && (De[rt + g[K]] = i[O++]);
        return De;
      }
      function sr(i, s) {
        var g = -1, E = i.length;
        for (s || (s = he(E)); ++g < E; )
          s[g] = i[g];
        return s;
      }
      function hi(i, s, g, E) {
        var O = !g;
        g || (g = {});
        for (var U = -1, K = s.length; ++U < K; ) {
          var $ = s[U], re = E ? E(g[$], i[$], $, g, i) : t;
          re === t && (re = i[$]), O ? ir(g, $, re) : On(g, $, re);
        }
        return g;
      }
      function Zd(i, s) {
        return hi(i, om(i), s);
      }
      function Zc(i, s) {
        return hi(i, Ly(i), s);
      }
      function Kc(i, s) {
        return function(g, E) {
          var O = Dt(g) ? ga : $a, U = s ? s() : {};
          return O(g, i, mt(E, 2), U);
        };
      }
      function d(i) {
        return wt(function(s, g) {
          var E = -1, O = g.length, U = O > 1 ? g[O - 1] : t, K = O > 2 ? g[2] : t;
          for (U = i.length > 3 && typeof U == "function" ? (O--, U) : t, K && Qo(g[0], g[1], K) && (U = O < 3 ? t : U, O = 1), s = Jt(s); ++E < O; ) {
            var $ = g[E];
            $ && i(s, $, E, U);
          }
          return s;
        });
      }
      function m(i, s) {
        return function(g, E) {
          if (g == null)
            return g;
          if (!mi(g))
            return i(g, E);
          for (var O = g.length, U = s ? O : -1, K = Jt(g); (s ? U-- : ++U < O) && E(K[U], U, K) !== !1; )
            ;
          return g;
        };
      }
      function S(i) {
        return function(s, g, E) {
          for (var O = -1, U = Jt(s), K = E(s), $ = K.length; $--; ) {
            var re = K[i ? $ : ++O];
            if (g(U[re], re, U) === !1)
              break;
          }
          return s;
        };
      }
      function R(i, s, g) {
        var E = s & D, O = _(i);
        function U() {
          var K = this && this !== Ln && this instanceof U ? O : i;
          return K.apply(E ? g : this, arguments);
        }
        return U;
      }
      function W(i) {
        return function(s) {
          s = un(s);
          var g = Rs(s) ? ro(s) : t, E = g ? g[0] : s.charAt(0), O = g ? Jo(g, 1).join("") : s.slice(1);
          return E[i]() + O;
        };
      }
      function Z(i) {
        return function(s) {
          return hl(w0(S0(s).replace(mu, "")), i, "");
        };
      }
      function _(i) {
        return function() {
          var s = arguments;
          switch (s.length) {
            case 0:
              return new i();
            case 1:
              return new i(s[0]);
            case 2:
              return new i(s[0], s[1]);
            case 3:
              return new i(s[0], s[1], s[2]);
            case 4:
              return new i(s[0], s[1], s[2], s[3]);
            case 5:
              return new i(s[0], s[1], s[2], s[3], s[4]);
            case 6:
              return new i(s[0], s[1], s[2], s[3], s[4], s[5]);
            case 7:
              return new i(s[0], s[1], s[2], s[3], s[4], s[5], s[6]);
          }
          var g = Aa(i.prototype), E = i.apply(g, s);
          return Wn(E) ? E : g;
        };
      }
      function pe(i, s, g) {
        var E = _(i);
        function O() {
          for (var U = arguments.length, K = he(U), $ = U, re = Xd(O); $--; )
            K[$] = arguments[$];
          var xe = U < 3 && K[0] !== re && K[U - 1] !== re ? [] : ha(K, re);
          if (U -= xe.length, U < g)
            return _e(
              i,
              s,
              C,
              O.placeholder,
              t,
              K,
              xe,
              t,
              t,
              g - U
            );
          var Te = this && this !== Ln && this instanceof O ? E : i;
          return Bn(Te, this, K);
        }
        return O;
      }
      function c(i) {
        return function(s, g, E) {
          var O = Jt(s);
          if (!mi(s)) {
            var U = mt(g, 3);
            s = Yr(s), g = function($) {
              return U(O[$], $, O);
            };
          }
          var K = i(s, g, E);
          return K > -1 ? O[U ? s[K] : K] : t;
        };
      }
      function h(i) {
        return Yl(function(s) {
          var g = s.length, E = g, O = Ir.prototype.thru;
          for (i && s.reverse(); E--; ) {
            var U = s[E];
            if (typeof U != "function")
              throw new Ur(l);
            if (O && !K && _g(U) == "wrapper")
              var K = new Ir([], !0);
          }
          for (E = K ? E : g; ++E < g; ) {
            U = s[E];
            var $ = _g(U), re = $ == "wrapper" ? nm(U) : t;
            re && am(re[0]) && re[1] == (Oe | q | ee | He) && !re[4].length && re[9] == 1 ? K = K[_g(re[0])].apply(K, re[3]) : K = U.length == 1 && am(U) ? K[$]() : K.thru(U);
          }
          return function() {
            var xe = arguments, Te = xe[0];
            if (K && xe.length == 1 && Dt(Te))
              return K.plant(Te).value();
            for (var De = 0, Ge = g ? s[De].apply(this, xe) : Te; ++De < g; )
              Ge = s[De].call(this, Ge);
            return Ge;
          };
        });
      }
      function C(i, s, g, E, O, U, K, $, re, xe) {
        var Te = s & Oe, De = s & D, Ge = s & k, rt = s & (q | Ce), vt = s & Re, Vt = Ge ? t : _(i);
        function bt() {
          for (var Zt = arguments.length, Qt = he(Zt), Ji = Zt; Ji--; )
            Qt[Ji] = arguments[Ji];
          if (rt)
            var qo = Xd(bt), Qi = to(Qt, qo);
          if (E && (Qt = zd(Qt, E, O, rt)), U && (Qt = zc(Qt, U, K, rt)), Zt -= Qi, rt && Zt < xe) {
            var cr = ha(Qt, qo);
            return _e(
              i,
              s,
              C,
              bt.placeholder,
              g,
              Qt,
              cr,
              $,
              re,
              xe - Zt
            );
          }
          var ls = De ? g : this, Xl = Ge ? ls[i] : i;
          return Zt = Qt.length, $ ? Qt = dP(Qt, $) : vt && Zt > 1 && Qt.reverse(), Te && re < Zt && (Qt.length = re), this && this !== Ln && this instanceof bt && (Xl = Vt || _(Xl)), Xl.apply(ls, Qt);
        }
        return bt;
      }
      function x(i, s) {
        return function(g, E) {
          return ju(g, i, s(E), {});
        };
      }
      function M(i, s) {
        return function(g, E) {
          var O;
          if (g === t && E === t)
            return s;
          if (g !== t && (O = g), E !== t) {
            if (O === t)
              return E;
            typeof g == "string" || typeof E == "string" ? (g = Hr(g), E = Hr(E)) : (g = Yd(g), E = Yd(E)), O = i(g, E);
          }
          return O;
        };
      }
      function Y(i) {
        return Yl(function(s) {
          return s = sn(s, qe(mt())), wt(function(g) {
            var E = this;
            return i(s, function(O) {
              return Bn(O, E, g);
            });
          });
        });
      }
      function J(i, s) {
        s = s === t ? " " : Hr(s);
        var g = s.length;
        if (g < 2)
          return g ? Yu(s, i) : s;
        var E = Yu(s, Cl(i / Ds(s)));
        return Rs(s) ? Jo(ro(E), 0, i).join("") : E.slice(0, i);
      }
      function fe(i, s, g, E) {
        var O = s & D, U = _(i);
        function K() {
          for (var $ = -1, re = arguments.length, xe = -1, Te = E.length, De = he(Te + re), Ge = this && this !== Ln && this instanceof K ? U : i; ++xe < Te; )
            De[xe] = E[xe];
          for (; re--; )
            De[xe++] = arguments[++$];
          return Bn(Ge, O ? g : this, De);
        }
        return K;
      }
      function Pe(i) {
        return function(s, g, E) {
          return E && typeof E != "number" && Qo(s, g, E) && (g = E = t), s = Kl(s), g === t ? (g = s, s = 0) : g = Kl(g), E = E === t ? s < g ? 1 : -1 : Kl(E), Ud(s, g, E, i);
        };
      }
      function We(i) {
        return function(s, g) {
          return typeof s == "string" && typeof g == "string" || (s = Pa(s), g = Pa(g)), i(s, g);
        };
      }
      function _e(i, s, g, E, O, U, K, $, re, xe) {
        var Te = s & q, De = Te ? K : t, Ge = Te ? t : K, rt = Te ? U : t, vt = Te ? t : U;
        s |= Te ? ee : Fe, s &= ~(Te ? Fe : ee), s & z || (s &= ~(D | k));
        var Vt = [
          i,
          s,
          O,
          rt,
          De,
          vt,
          Ge,
          $,
          re,
          xe
        ], bt = g.apply(t, Vt);
        return am(i) && Gy(bt, Vt), bt.placeholder = E, Yy(bt, i, s);
      }
      function gt(i) {
        var s = wn[i];
        return function(g, E) {
          if (g = Pa(g), E = E == null ? 0 : Tn(Lt(E), 292), E && xu(g)) {
            var O = (un(g) + "e").split("e"), U = s(O[0] + "e" + (+O[1] + E));
            return O = (un(U) + "e").split("e"), +(O[0] + "e" + (+O[1] - E));
          }
          return s(g);
        };
      }
      var hn = wr && 1 / Os(new wr([, -0]))[1] == ze ? function(i) {
        return new wr(i);
      } : Em;
      function Xn(i) {
        return function(s) {
          var g = Io(s);
          return g == Ht ? vu(s) : g == Gn ? Kf(s) : Ae(s, i(s));
        };
      }
      function Vn(i, s, g, E, O, U, K, $) {
        var re = s & k;
        if (!re && typeof i != "function")
          throw new Ur(l);
        var xe = E ? E.length : 0;
        if (xe || (s &= ~(ee | Fe), E = O = t), K = K === t ? K : xn(Lt(K), 0), $ = $ === t ? $ : Lt($), xe -= O ? O.length : 0, s & Fe) {
          var Te = E, De = O;
          E = O = t;
        }
        var Ge = re ? t : nm(i), rt = [
          i,
          s,
          g,
          E,
          O,
          Te,
          De,
          U,
          K,
          $
        ];
        if (Ge && lP(rt, Ge), i = rt[0], s = rt[1], g = rt[2], E = rt[3], O = rt[4], $ = rt[9] = rt[9] === t ? re ? 0 : i.length : xn(rt[9] - xe, 0), !$ && s & (q | Ce) && (s &= ~(q | Ce)), !s || s == D)
          var vt = R(i, s, g);
        else
          s == q || s == Ce ? vt = pe(i, s, $) : (s == ee || s == (D | ee)) && !O.length ? vt = fe(i, s, g, E) : vt = C.apply(t, rt);
        var Vt = Ge ? Xs : Gy;
        return Yy(Vt(vt, rt), i, s);
      }
      function qu(i, s, g, E) {
        return i === t || ss(i, Za[g]) && !_t.call(E, g) ? s : i;
      }
      function _u(i, s, g, E, O, U) {
        return Wn(i) && Wn(s) && (U.set(s, i), Ks(i, s, t, _u, U), U.delete(s)), i;
      }
      function Kd(i) {
        return lg(i) ? t : i;
      }
      function Gl(i, s, g, E, O, U) {
        var K = g & j, $ = i.length, re = s.length;
        if ($ != re && !(K && re > $))
          return !1;
        var xe = U.get(i), Te = U.get(s);
        if (xe && Te)
          return xe == s && Te == i;
        var De = -1, Ge = !0, rt = g & N ? new Qa() : t;
        for (U.set(i, s), U.set(s, i); ++De < $; ) {
          var vt = i[De], Vt = s[De];
          if (E)
            var bt = K ? E(Vt, vt, De, s, i, U) : E(vt, Vt, De, i, s, U);
          if (bt !== t) {
            if (bt)
              continue;
            Ge = !1;
            break;
          }
          if (rt) {
            if (!pa(s, function(Zt, Qt) {
              if (!pt(rt, Qt) && (vt === Zt || O(vt, Zt, g, E, U)))
                return rt.push(Qt);
            })) {
              Ge = !1;
              break;
            }
          } else if (!(vt === Vt || O(vt, Vt, g, E, U))) {
            Ge = !1;
            break;
          }
        }
        return U.delete(i), U.delete(s), Ge;
      }
      function _h(i, s, g, E, O, U, K) {
        switch (g) {
          case tn:
            if (i.byteLength != s.byteLength || i.byteOffset != s.byteOffset)
              return !1;
            i = i.buffer, s = s.buffer;
          case tr:
            return !(i.byteLength != s.byteLength || !U(new Ms(i), new Ms(s)));
          case ct:
          case lt:
          case Fn:
            return ss(+i, +s);
          case Mt:
            return i.name == s.name && i.message == s.message;
          case Cr:
          case Rn:
            return i == s + "";
          case Ht:
            var $ = vu;
          case Gn:
            var re = E & j;
            if ($ || ($ = Os), i.size != s.size && !re)
              return !1;
            var xe = K.get(i);
            if (xe)
              return xe == s;
            E |= N, K.set(i, s);
            var Te = Gl($(i), $(s), E, O, U, K);
            return K.delete(i), Te;
          case An:
            if (Il)
              return Il.call(i) == Il.call(s);
        }
        return !1;
      }
      function $h(i, s, g, E, O, U) {
        var K = g & j, $ = em(i), re = $.length, xe = em(s), Te = xe.length;
        if (re != Te && !K)
          return !1;
        for (var De = re; De--; ) {
          var Ge = $[De];
          if (!(K ? Ge in s : _t.call(s, Ge)))
            return !1;
        }
        var rt = U.get(i), vt = U.get(s);
        if (rt && vt)
          return rt == s && vt == i;
        var Vt = !0;
        U.set(i, s), U.set(s, i);
        for (var bt = K; ++De < re; ) {
          Ge = $[De];
          var Zt = i[Ge], Qt = s[Ge];
          if (E)
            var Ji = K ? E(Qt, Zt, Ge, s, i, U) : E(Zt, Qt, Ge, i, s, U);
          if (!(Ji === t ? Zt === Qt || O(Zt, Qt, g, E, U) : Ji)) {
            Vt = !1;
            break;
          }
          bt || (bt = Ge == "constructor");
        }
        if (Vt && !bt) {
          var qo = i.constructor, Qi = s.constructor;
          qo != Qi && "constructor" in i && "constructor" in s && !(typeof qo == "function" && qo instanceof qo && typeof Qi == "function" && Qi instanceof Qi) && (Vt = !1);
        }
        return U.delete(i), U.delete(s), Vt;
      }
      function Yl(i) {
        return lm(Wy(i, t, Qy), i + "");
      }
      function em(i) {
        return Tl(i, Yr, om);
      }
      function tm(i) {
        return Tl(i, vi, Ly);
      }
      var nm = Ca ? function(i) {
        return Ca.get(i);
      } : Em;
      function _g(i) {
        for (var s = i.name + "", g = Ea[s], E = _t.call(Ea, s) ? g.length : 0; E--; ) {
          var O = g[E], U = O.func;
          if (U == null || U == i)
            return O.name;
        }
        return s;
      }
      function Xd(i) {
        var s = _t.call(B, "placeholder") ? B : i;
        return s.placeholder;
      }
      function mt() {
        var i = B.iteratee || ym;
        return i = i === ym ? zs : i, arguments.length ? i(arguments[0], arguments[1]) : i;
      }
      function $g(i, s) {
        var g = i.__data__;
        return oP(s) ? g[typeof s == "string" ? "string" : "hash"] : g.map;
      }
      function rm(i) {
        for (var s = Yr(i), g = s.length; g--; ) {
          var E = s[g], O = i[E];
          s[g] = [E, O, jy(O)];
        }
        return s;
      }
      function $u(i, s) {
        var g = vl(i, s);
        return Hu(g) ? g : t;
      }
      function qT(i) {
        var s = _t.call(i, Go), g = i[Go];
        try {
          i[Go] = t;
          var E = !0;
        } catch {
        }
        var O = va.call(i);
        return E && (s ? i[Go] = g : delete i[Go]), O;
      }
      var om = El ? function(i) {
        return i == null ? [] : (i = Jt(i), Ho(El(i), function(s) {
          return wu.call(i, s);
        }));
      } : Am, Ly = El ? function(i) {
        for (var s = []; i; )
          eo(s, om(i)), i = Ls(i);
        return s;
      } : Am, Io = mr;
      (Wi && Io(new Wi(new ArrayBuffer(1))) != tn || Yo && Io(new Yo()) != Ht || Al && Io(Al.resolve()) != er || wr && Io(new wr()) != Gn || ba && Io(new ba()) != Mr) && (Io = function(i) {
        var s = mr(i), g = s == $n ? i.constructor : t, E = g ? ed(g) : "";
        if (E)
          switch (E) {
            case Sl:
              return tn;
            case Od:
              return Ht;
            case Dd:
              return er;
            case Ic:
              return Gn;
            case wl:
              return Mr;
          }
        return s;
      });
      function _T(i, s, g) {
        for (var E = -1, O = g.length; ++E < O; ) {
          var U = g[E], K = U.size;
          switch (U.type) {
            case "drop":
              i += K;
              break;
            case "dropRight":
              s -= K;
              break;
            case "take":
              s = Tn(s, i + K);
              break;
            case "takeRight":
              i = xn(i, s - K);
              break;
          }
        }
        return { start: i, end: s };
      }
      function $T(i) {
        var s = i.match(Va);
        return s ? s[1].split(X) : [];
      }
      function By(i, s, g) {
        s = Ki(s, i);
        for (var E = -1, O = s.length, U = !1; ++E < O; ) {
          var K = Qs(s[E]);
          if (!(U = i != null && g(i, K)))
            break;
          i = i[K];
        }
        return U || ++E != O ? U : (O = i == null ? 0 : i.length, !!O && ap(O) && zl(K, O) && (Dt(i) || td(i)));
      }
      function eP(i) {
        var s = i.length, g = new i.constructor(s);
        return s && typeof i[0] == "string" && _t.call(i, "index") && (g.index = i.index, g.input = i.input), g;
      }
      function Vy(i) {
        return typeof i.constructor == "function" && !ag(i) ? Aa(Ls(i)) : {};
      }
      function tP(i, s, g) {
        var E = i.constructor;
        switch (s) {
          case tr:
            return Gc(i);
          case ct:
          case lt:
            return new E(+i);
          case tn:
            return Ul(i, g);
          case co:
          case Oo:
          case uo:
          case Do:
          case fo:
          case xi:
          case Fo:
          case Lr:
          case No:
            return Qu(i, g);
          case Ht:
            return new E();
          case Fn:
          case Rn:
            return new E(i);
          case Cr:
            return Wl(i);
          case Gn:
            return new E();
          case An:
            return Yc(i);
        }
      }
      function nP(i, s) {
        var g = s.length;
        if (!g)
          return i;
        var E = g - 1;
        return s[E] = (g > 1 ? "& " : "") + s[E], s = s.join(g > 2 ? ", " : " "), i.replace(Ba, `{
/* [wrapped with ` + s + `] */
`);
      }
      function rP(i) {
        return Dt(i) || td(i) || !!(Sc && i && i[Sc]);
      }
      function zl(i, s) {
        var g = typeof i;
        return s = s ?? ue, !!s && (g == "number" || g != "symbol" && Xt.test(i)) && i > -1 && i % 1 == 0 && i < s;
      }
      function Qo(i, s, g) {
        if (!Wn(g))
          return !1;
        var E = typeof s;
        return (E == "number" ? mi(g) && zl(s, g.length) : E == "string" && s in g) ? ss(g[s], i) : !1;
      }
      function im(i, s) {
        if (Dt(i))
          return !1;
        var g = typeof i;
        return g == "number" || g == "symbol" || g == "boolean" || i == null || Xi(i) ? !0 : ln.test(i) || !Vr.test(i) || s != null && i in Jt(s);
      }
      function oP(i) {
        var s = typeof i;
        return s == "string" || s == "number" || s == "symbol" || s == "boolean" ? i !== "__proto__" : i === null;
      }
      function am(i) {
        var s = _g(i), g = B[s];
        if (typeof g != "function" || !(s in kt.prototype))
          return !1;
        if (i === g)
          return !0;
        var E = nm(g);
        return !!E && i === E[0];
      }
      function iP(i) {
        return !!yn && yn in i;
      }
      var aP = Cc ? Zl : Sm;
      function ag(i) {
        var s = i && i.constructor, g = typeof s == "function" && s.prototype || Za;
        return i === g;
      }
      function jy(i) {
        return i === i && !Wn(i);
      }
      function Uy(i, s) {
        return function(g) {
          return g == null ? !1 : g[i] === s && (s !== t || i in Jt(g));
        };
      }
      function sP(i) {
        var s = op(i, function(E) {
          return g.size === p && g.clear(), E;
        }), g = s.cache;
        return s;
      }
      function lP(i, s) {
        var g = i[1], E = s[1], O = g | E, U = O < (D | k | Oe), K = E == Oe && g == q || E == Oe && g == He && i[7].length <= s[8] || E == (Oe | He) && s[7].length <= s[8] && g == q;
        if (!(U || K))
          return i;
        E & D && (i[2] = s[2], O |= g & D ? 0 : z);
        var $ = s[3];
        if ($) {
          var re = i[3];
          i[3] = re ? zd(re, $, s[4]) : $, i[4] = re ? ha(i[3], y) : s[4];
        }
        return $ = s[5], $ && (re = i[5], i[5] = re ? zc(re, $, s[6]) : $, i[6] = re ? ha(i[5], y) : s[6]), $ = s[7], $ && (i[7] = $), E & Oe && (i[8] = i[8] == null ? s[8] : Tn(i[8], s[8])), i[9] == null && (i[9] = s[9]), i[0] = s[0], i[1] = O, i;
      }
      function cP(i) {
        var s = [];
        if (i != null)
          for (var g in Jt(i))
            s.push(g);
        return s;
      }
      function uP(i) {
        return va.call(i);
      }
      function Wy(i, s, g) {
        return s = xn(s === t ? i.length - 1 : s, 0), function() {
          for (var E = arguments, O = -1, U = xn(E.length - s, 0), K = he(U); ++O < U; )
            K[O] = E[s + O];
          O = -1;
          for (var $ = he(s + 1); ++O < s; )
            $[O] = E[O];
          return $[s] = g(K), Bn(i, this, $);
        };
      }
      function Hy(i, s) {
        return s.length < 2 ? i : ts(i, Wr(s, 0, -1));
      }
      function dP(i, s) {
        for (var g = i.length, E = Tn(s.length, g), O = sr(i); E--; ) {
          var U = s[E];
          i[E] = zl(U, g) ? O[U] : t;
        }
        return i;
      }
      function sm(i, s) {
        if (!(s === "constructor" && typeof i[s] == "function") && s != "__proto__")
          return i[s];
      }
      var Gy = zy(Xs), sg = wc || function(i, s) {
        return Ln.setTimeout(i, s);
      }, lm = zy(zu);
      function Yy(i, s, g) {
        var E = s + "";
        return lm(i, nP(E, fP($T(E), g)));
      }
      function zy(i) {
        var s = 0, g = 0;
        return function() {
          var E = Pu(), O = ge - (E - g);
          if (g = E, O > 0) {
            if (++s >= ae)
              return arguments[0];
          } else
            s = 0;
          return i.apply(t, arguments);
        };
      }
      function ep(i, s) {
        var g = -1, E = i.length, O = E - 1;
        for (s = s === t ? E : s; ++g < s; ) {
          var U = Uc(g, O), K = i[U];
          i[U] = i[g], i[g] = K;
        }
        return i.length = s, i;
      }
      var Zy = sP(function(i) {
        var s = [];
        return i.charCodeAt(0) === 46 && s.push(""), i.replace(Ti, function(g, E, O, U) {
          s.push(O ? U.replace(at, "$1") : E || g);
        }), s;
      });
      function Qs(i) {
        if (typeof i == "string" || Xi(i))
          return i;
        var s = i + "";
        return s == "0" && 1 / i == -ze ? "-0" : s;
      }
      function ed(i) {
        if (i != null) {
          try {
            return Ec.call(i);
          } catch {
          }
          try {
            return i + "";
          } catch {
          }
        }
        return "";
      }
      function fP(i, s) {
        return rr(Xe, function(g) {
          var E = "_." + g[0];
          s & g[1] && !Li(i, E) && i.push(E);
        }), i.sort();
      }
      function Ky(i) {
        if (i instanceof kt)
          return i.clone();
        var s = new Ir(i.__wrapped__, i.__chain__);
        return s.__actions__ = sr(i.__actions__), s.__index__ = i.__index__, s.__values__ = i.__values__, s;
      }
      function gP(i, s, g) {
        (g ? Qo(i, s, g) : s === t) ? s = 1 : s = xn(Lt(s), 0);
        var E = i == null ? 0 : i.length;
        if (!E || s < 1)
          return [];
        for (var O = 0, U = 0, K = he(Cl(E / s)); O < E; )
          K[U++] = Wr(i, O, O += s);
        return K;
      }
      function pP(i) {
        for (var s = -1, g = i == null ? 0 : i.length, E = 0, O = []; ++s < g; ) {
          var U = i[s];
          U && (O[E++] = U);
        }
        return O;
      }
      function hP() {
        var i = arguments.length;
        if (!i)
          return [];
        for (var s = he(i - 1), g = arguments[0], E = i; E--; )
          s[E - 1] = arguments[E];
        return eo(Dt(g) ? sr(g) : [g], ar(s, 1));
      }
      var mP = wt(function(i, s) {
        return lr(i) ? Yi(i, ar(s, 1, lr, !0)) : [];
      }), vP = wt(function(i, s) {
        var g = Ta(s);
        return lr(g) && (g = t), lr(i) ? Yi(i, ar(s, 1, lr, !0), mt(g, 2)) : [];
      }), bP = wt(function(i, s) {
        var g = Ta(s);
        return lr(g) && (g = t), lr(i) ? Yi(i, ar(s, 1, lr, !0), t, g) : [];
      });
      function yP(i, s, g) {
        var E = i == null ? 0 : i.length;
        return E ? (s = g || s === t ? 1 : Lt(s), Wr(i, s < 0 ? 0 : s, E)) : [];
      }
      function CP(i, s, g) {
        var E = i == null ? 0 : i.length;
        return E ? (s = g || s === t ? 1 : Lt(s), s = E - s, Wr(i, 0, s < 0 ? 0 : s)) : [];
      }
      function EP(i, s) {
        return i && i.length ? Hc(i, mt(s, 3), !0, !0) : [];
      }
      function AP(i, s) {
        return i && i.length ? Hc(i, mt(s, 3), !0) : [];
      }
      function SP(i, s, g, E) {
        var O = i == null ? 0 : i.length;
        return O ? (g && typeof g != "number" && Qo(i, s, g) && (g = 0, E = O), Bd(i, s, g, E)) : [];
      }
      function Xy(i, s, g) {
        var E = i == null ? 0 : i.length;
        if (!E)
          return -1;
        var O = g == null ? 0 : Lt(g);
        return O < 0 && (O = xn(E + O, 0)), Ya(i, mt(s, 3), O);
      }
      function Jy(i, s, g) {
        var E = i == null ? 0 : i.length;
        if (!E)
          return -1;
        var O = E - 1;
        return g !== t && (O = Lt(g), O = g < 0 ? xn(E + O, 0) : Tn(O, E - 1)), Ya(i, mt(s, 3), O, !0);
      }
      function Qy(i) {
        var s = i == null ? 0 : i.length;
        return s ? ar(i, 1) : [];
      }
      function wP(i) {
        var s = i == null ? 0 : i.length;
        return s ? ar(i, ze) : [];
      }
      function IP(i, s) {
        var g = i == null ? 0 : i.length;
        return g ? (s = s === t ? 1 : Lt(s), ar(i, s)) : [];
      }
      function xP(i) {
        for (var s = -1, g = i == null ? 0 : i.length, E = {}; ++s < g; ) {
          var O = i[s];
          E[O[0]] = O[1];
        }
        return E;
      }
      function qy(i) {
        return i && i.length ? i[0] : t;
      }
      function TP(i, s, g) {
        var E = i == null ? 0 : i.length;
        if (!E)
          return -1;
        var O = g == null ? 0 : Lt(g);
        return O < 0 && (O = xn(E + O, 0)), Bi(i, s, O);
      }
      function PP(i) {
        var s = i == null ? 0 : i.length;
        return s ? Wr(i, 0, -1) : [];
      }
      var kP = wt(function(i) {
        var s = sn(i, Tr);
        return s.length && s[0] === i[0] ? Gs(s) : [];
      }), RP = wt(function(i) {
        var s = Ta(i), g = sn(i, Tr);
        return s === Ta(g) ? s = t : g.pop(), g.length && g[0] === i[0] ? Gs(g, mt(s, 2)) : [];
      }), OP = wt(function(i) {
        var s = Ta(i), g = sn(i, Tr);
        return s = typeof s == "function" ? s : t, s && g.pop(), g.length && g[0] === i[0] ? Gs(g, t, s) : [];
      });
      function DP(i, s) {
        return i == null ? "" : Vs.call(i, s);
      }
      function Ta(i) {
        var s = i == null ? 0 : i.length;
        return s ? i[s - 1] : t;
      }
      function FP(i, s, g) {
        var E = i == null ? 0 : i.length;
        if (!E)
          return -1;
        var O = E;
        return g !== t && (O = Lt(g), O = O < 0 ? xn(E + O, 0) : Tn(O, E - 1)), s === s ? bu(i, s, O) : Ya(i, Ps, O, !0);
      }
      function NP(i, s) {
        return i && i.length ? os(i, Lt(s)) : t;
      }
      var MP = wt(_y);
      function _y(i, s) {
        return i && i.length && s && s.length ? is(i, s) : i;
      }
      function LP(i, s, g) {
        return i && i.length && s && s.length ? is(i, s, mt(g, 2)) : i;
      }
      function BP(i, s, g) {
        return i && i.length && s && s.length ? is(i, s, t, g) : i;
      }
      var VP = Yl(function(i, s) {
        var g = i == null ? 0 : i.length, E = Du(i, s);
        return Fl(i, sn(s, function(O) {
          return zl(O, g) ? +O : O;
        }).sort(Js)), E;
      });
      function jP(i, s) {
        var g = [];
        if (!(i && i.length))
          return g;
        var E = -1, O = [], U = i.length;
        for (s = mt(s, 3); ++E < U; ) {
          var K = i[E];
          s(K, E, i) && (g.push(K), O.push(E));
        }
        return Fl(i, O), g;
      }
      function cm(i) {
        return i == null ? i : Rd.call(i);
      }
      function UP(i, s, g) {
        var E = i == null ? 0 : i.length;
        return E ? (g && typeof g != "number" && Qo(i, s, g) ? (s = 0, g = E) : (s = s == null ? 0 : Lt(s), g = g === t ? E : Lt(g)), Wr(i, s, g)) : [];
      }
      function WP(i, s) {
        return Ml(i, s);
      }
      function HP(i, s, g) {
        return Ll(i, s, mt(g, 2));
      }
      function GP(i, s) {
        var g = i == null ? 0 : i.length;
        if (g) {
          var E = Ml(i, s);
          if (E < g && ss(i[E], s))
            return E;
        }
        return -1;
      }
      function YP(i, s) {
        return Ml(i, s, !0);
      }
      function zP(i, s, g) {
        return Ll(i, s, mt(g, 2), !0);
      }
      function ZP(i, s) {
        var g = i == null ? 0 : i.length;
        if (g) {
          var E = Ml(i, s, !0) - 1;
          if (ss(i[E], s))
            return E;
        }
        return -1;
      }
      function KP(i) {
        return i && i.length ? Gd(i) : [];
      }
      function XP(i, s) {
        return i && i.length ? Gd(i, mt(s, 2)) : [];
      }
      function JP(i) {
        var s = i == null ? 0 : i.length;
        return s ? Wr(i, 1, s) : [];
      }
      function QP(i, s, g) {
        return i && i.length ? (s = g || s === t ? 1 : Lt(s), Wr(i, 0, s < 0 ? 0 : s)) : [];
      }
      function qP(i, s, g) {
        var E = i == null ? 0 : i.length;
        return E ? (s = g || s === t ? 1 : Lt(s), s = E - s, Wr(i, s < 0 ? 0 : s, E)) : [];
      }
      function _P(i, s) {
        return i && i.length ? Hc(i, mt(s, 3), !1, !0) : [];
      }
      function $P(i, s) {
        return i && i.length ? Hc(i, mt(s, 3)) : [];
      }
      var ek = wt(function(i) {
        return xa(ar(i, 1, lr, !0));
      }), tk = wt(function(i) {
        var s = Ta(i);
        return lr(s) && (s = t), xa(ar(i, 1, lr, !0), mt(s, 2));
      }), nk = wt(function(i) {
        var s = Ta(i);
        return s = typeof s == "function" ? s : t, xa(ar(i, 1, lr, !0), t, s);
      });
      function rk(i) {
        return i && i.length ? xa(i) : [];
      }
      function ok(i, s) {
        return i && i.length ? xa(i, mt(s, 2)) : [];
      }
      function ik(i, s) {
        return s = typeof s == "function" ? s : t, i && i.length ? xa(i, t, s) : [];
      }
      function um(i) {
        if (!(i && i.length))
          return [];
        var s = 0;
        return i = Ho(i, function(g) {
          if (lr(g))
            return s = xn(g.length, s), !0;
        }), ie(s, function(g) {
          return sn(i, b(g));
        });
      }
      function $y(i, s) {
        if (!(i && i.length))
          return [];
        var g = um(i);
        return s == null ? g : sn(g, function(E) {
          return Bn(s, t, E);
        });
      }
      var ak = wt(function(i, s) {
        return lr(i) ? Yi(i, s) : [];
      }), sk = wt(function(i) {
        return Bl(Ho(i, lr));
      }), lk = wt(function(i) {
        var s = Ta(i);
        return lr(s) && (s = t), Bl(Ho(i, lr), mt(s, 2));
      }), ck = wt(function(i) {
        var s = Ta(i);
        return s = typeof s == "function" ? s : t, Bl(Ho(i, lr), t, s);
      }), uk = wt(um);
      function dk(i, s) {
        return Xu(i || [], s || [], On);
      }
      function fk(i, s) {
        return Xu(i || [], s || [], as);
      }
      var gk = wt(function(i) {
        var s = i.length, g = s > 1 ? i[s - 1] : t;
        return g = typeof g == "function" ? (i.pop(), g) : t, $y(i, g);
      });
      function e0(i) {
        var s = B(i);
        return s.__chain__ = !0, s;
      }
      function pk(i, s) {
        return s(i), i;
      }
      function tp(i, s) {
        return s(i);
      }
      var hk = Yl(function(i) {
        var s = i.length, g = s ? i[0] : 0, E = this.__wrapped__, O = function(U) {
          return Du(U, i);
        };
        return s > 1 || this.__actions__.length || !(E instanceof kt) || !zl(g) ? this.thru(O) : (E = E.slice(g, +g + (s ? 1 : 0)), E.__actions__.push({
          func: tp,
          args: [O],
          thisArg: t
        }), new Ir(E, this.__chain__).thru(function(U) {
          return s && !U.length && U.push(t), U;
        }));
      });
      function mk() {
        return e0(this);
      }
      function vk() {
        return new Ir(this.value(), this.__chain__);
      }
      function bk() {
        this.__values__ === t && (this.__values__ = p0(this.value()));
        var i = this.__index__ >= this.__values__.length, s = i ? t : this.__values__[this.__index__++];
        return { done: i, value: s };
      }
      function yk() {
        return this;
      }
      function Ck(i) {
        for (var s, g = this; g instanceof Ja; ) {
          var E = Ky(g);
          E.__index__ = 0, E.__values__ = t, s ? O.__wrapped__ = E : s = E;
          var O = E;
          g = g.__wrapped__;
        }
        return O.__wrapped__ = i, s;
      }
      function Ek() {
        var i = this.__wrapped__;
        if (i instanceof kt) {
          var s = i;
          return this.__actions__.length && (s = new kt(this)), s = s.reverse(), s.__actions__.push({
            func: tp,
            args: [cm],
            thisArg: t
          }), new Ir(s, this.__chain__);
        }
        return this.thru(cm);
      }
      function Ak() {
        return Gr(this.__wrapped__, this.__actions__);
      }
      var Sk = Kc(function(i, s, g) {
        _t.call(i, g) ? ++i[g] : ir(i, g, 1);
      });
      function wk(i, s, g) {
        var E = Dt(i) ? xs : Nc;
        return g && Qo(i, s, g) && (s = t), E(i, mt(s, 3));
      }
      function Ik(i, s) {
        var g = Dt(i) ? Ho : Lu;
        return g(i, mt(s, 3));
      }
      var xk = c(Xy), Tk = c(Jy);
      function Pk(i, s) {
        return ar(np(i, s), 1);
      }
      function kk(i, s) {
        return ar(np(i, s), ze);
      }
      function Rk(i, s, g) {
        return g = g === t ? 1 : Lt(g), ar(np(i, s), g);
      }
      function t0(i, s) {
        var g = Dt(i) ? rr : Ia;
        return g(i, mt(s, 3));
      }
      function n0(i, s) {
        var g = Dt(i) ? pc : Mu;
        return g(i, mt(s, 3));
      }
      var Ok = Kc(function(i, s, g) {
        _t.call(i, g) ? i[g].push(s) : ir(i, g, [s]);
      });
      function Dk(i, s, g, E) {
        i = mi(i) ? i : Qd(i), g = g && !E ? Lt(g) : 0;
        var O = i.length;
        return g < 0 && (g = xn(O + g, 0)), sp(i) ? g <= O && i.indexOf(s, g) > -1 : !!O && Bi(i, s, g) > -1;
      }
      var Fk = wt(function(i, s, g) {
        var E = -1, O = typeof s == "function", U = mi(i) ? he(i.length) : [];
        return Ia(i, function(K) {
          U[++E] = O ? Bn(s, K, g) : Ao(K, s, g);
        }), U;
      }), Nk = Kc(function(i, s, g) {
        ir(i, g, s);
      });
      function np(i, s) {
        var g = Dt(i) ? sn : Zs;
        return g(i, mt(s, 3));
      }
      function Mk(i, s, g, E) {
        return i == null ? [] : (Dt(s) || (s = s == null ? [] : [s]), g = E ? t : g, Dt(g) || (g = g == null ? [] : [g]), jc(i, s, g));
      }
      var Lk = Kc(function(i, s, g) {
        i[g ? 0 : 1].push(s);
      }, function() {
        return [[], []];
      });
      function Bk(i, s, g) {
        var E = Dt(i) ? hl : L, O = arguments.length < 3;
        return E(i, mt(s, 4), g, O, Ia);
      }
      function Vk(i, s, g) {
        var E = Dt(i) ? hc : L, O = arguments.length < 3;
        return E(i, mt(s, 4), g, O, Mu);
      }
      function jk(i, s) {
        var g = Dt(i) ? Ho : Lu;
        return g(i, ip(mt(s, 3)));
      }
      function Uk(i) {
        var s = Dt(i) ? $t : Nl;
        return s(i);
      }
      function Wk(i, s, g) {
        (g ? Qo(i, s, g) : s === t) ? s = 1 : s = Lt(s);
        var E = Dt(i) ? Co : Wd;
        return E(i, s);
      }
      function Hk(i) {
        var s = Dt(i) ? _a : Zu;
        return s(i);
      }
      function Gk(i) {
        if (i == null)
          return 0;
        if (mi(i))
          return sp(i) ? Ds(i) : i.length;
        var s = Io(i);
        return s == Ht || s == Gn ? i.size : Dl(i).length;
      }
      function Yk(i, s, g) {
        var E = Dt(i) ? pa : Hd;
        return g && Qo(i, s, g) && (s = t), E(i, mt(s, 3));
      }
      var zk = wt(function(i, s) {
        if (i == null)
          return [];
        var g = s.length;
        return g > 1 && Qo(i, s[0], s[1]) ? s = [] : g > 2 && Qo(s[0], s[1], s[2]) && (s = [s[0]]), jc(i, ar(s, 1), []);
      }), rp = yl || function() {
        return Ln.Date.now();
      };
      function Zk(i, s) {
        if (typeof s != "function")
          throw new Ur(l);
        return i = Lt(i), function() {
          if (--i < 1)
            return s.apply(this, arguments);
        };
      }
      function r0(i, s, g) {
        return s = g ? t : s, s = i && s == null ? i.length : s, Vn(i, Oe, t, t, t, t, s);
      }
      function o0(i, s) {
        var g;
        if (typeof s != "function")
          throw new Ur(l);
        return i = Lt(i), function() {
          return --i > 0 && (g = s.apply(this, arguments)), i <= 1 && (s = t), g;
        };
      }
      var dm = wt(function(i, s, g) {
        var E = D;
        if (g.length) {
          var O = ha(g, Xd(dm));
          E |= ee;
        }
        return Vn(i, E, s, g, O);
      }), i0 = wt(function(i, s, g) {
        var E = D | k;
        if (g.length) {
          var O = ha(g, Xd(i0));
          E |= ee;
        }
        return Vn(s, E, i, g, O);
      });
      function a0(i, s, g) {
        s = g ? t : s;
        var E = Vn(i, q, t, t, t, t, t, s);
        return E.placeholder = a0.placeholder, E;
      }
      function s0(i, s, g) {
        s = g ? t : s;
        var E = Vn(i, Ce, t, t, t, t, t, s);
        return E.placeholder = s0.placeholder, E;
      }
      function l0(i, s, g) {
        var E, O, U, K, $, re, xe = 0, Te = !1, De = !1, Ge = !0;
        if (typeof i != "function")
          throw new Ur(l);
        s = Pa(s) || 0, Wn(g) && (Te = !!g.leading, De = "maxWait" in g, U = De ? xn(Pa(g.maxWait) || 0, s) : U, Ge = "trailing" in g ? !!g.trailing : Ge);
        function rt(cr) {
          var ls = E, Xl = O;
          return E = O = t, xe = cr, K = i.apply(Xl, ls), K;
        }
        function vt(cr) {
          return xe = cr, $ = sg(Zt, s), Te ? rt(cr) : K;
        }
        function Vt(cr) {
          var ls = cr - re, Xl = cr - xe, T0 = s - ls;
          return De ? Tn(T0, U - Xl) : T0;
        }
        function bt(cr) {
          var ls = cr - re, Xl = cr - xe;
          return re === t || ls >= s || ls < 0 || De && Xl >= U;
        }
        function Zt() {
          var cr = rp();
          if (bt(cr))
            return Qt(cr);
          $ = sg(Zt, Vt(cr));
        }
        function Qt(cr) {
          return $ = t, Ge && E ? rt(cr) : (E = O = t, K);
        }
        function Ji() {
          $ !== t && jl($), xe = 0, E = re = O = $ = t;
        }
        function qo() {
          return $ === t ? K : Qt(rp());
        }
        function Qi() {
          var cr = rp(), ls = bt(cr);
          if (E = arguments, O = this, re = cr, ls) {
            if ($ === t)
              return vt(re);
            if (De)
              return jl($), $ = sg(Zt, s), rt(re);
          }
          return $ === t && ($ = sg(Zt, s)), K;
        }
        return Qi.cancel = Ji, Qi.flush = qo, Qi;
      }
      var Kk = wt(function(i, s) {
        return Nu(i, 1, s);
      }), Xk = wt(function(i, s, g) {
        return Nu(i, Pa(s) || 0, g);
      });
      function Jk(i) {
        return Vn(i, Re);
      }
      function op(i, s) {
        if (typeof i != "function" || s != null && typeof s != "function")
          throw new Ur(l);
        var g = function() {
          var E = arguments, O = s ? s.apply(this, E) : E[0], U = g.cache;
          if (U.has(O))
            return U.get(O);
          var K = i.apply(this, E);
          return g.cache = U.set(O, K) || U, K;
        };
        return g.cache = new (op.Cache || Hi)(), g;
      }
      op.Cache = Hi;
      function ip(i) {
        if (typeof i != "function")
          throw new Ur(l);
        return function() {
          var s = arguments;
          switch (s.length) {
            case 0:
              return !i.call(this);
            case 1:
              return !i.call(this, s[0]);
            case 2:
              return !i.call(this, s[0], s[1]);
            case 3:
              return !i.call(this, s[0], s[1], s[2]);
          }
          return !i.apply(this, s);
        };
      }
      function Qk(i) {
        return o0(2, i);
      }
      var qk = ig(function(i, s) {
        s = s.length == 1 && Dt(s[0]) ? sn(s[0], qe(mt())) : sn(ar(s, 1), qe(mt()));
        var g = s.length;
        return wt(function(E) {
          for (var O = -1, U = Tn(E.length, g); ++O < U; )
            E[O] = s[O].call(this, E[O]);
          return Bn(i, this, E);
        });
      }), fm = wt(function(i, s) {
        var g = ha(s, Xd(fm));
        return Vn(i, ee, t, s, g);
      }), c0 = wt(function(i, s) {
        var g = ha(s, Xd(c0));
        return Vn(i, Fe, t, s, g);
      }), _k = Yl(function(i, s) {
        return Vn(i, He, t, t, t, s);
      });
      function $k(i, s) {
        if (typeof i != "function")
          throw new Ur(l);
        return s = s === t ? s : Lt(s), wt(i, s);
      }
      function e1(i, s) {
        if (typeof i != "function")
          throw new Ur(l);
        return s = s == null ? 0 : xn(Lt(s), 0), wt(function(g) {
          var E = g[s], O = Jo(g, 0, s);
          return E && eo(O, E), Bn(i, this, O);
        });
      }
      function t1(i, s, g) {
        var E = !0, O = !0;
        if (typeof i != "function")
          throw new Ur(l);
        return Wn(g) && (E = "leading" in g ? !!g.leading : E, O = "trailing" in g ? !!g.trailing : O), l0(i, s, {
          leading: E,
          maxWait: s,
          trailing: O
        });
      }
      function n1(i) {
        return r0(i, 1);
      }
      function r1(i, s) {
        return fm(Vl(s), i);
      }
      function o1() {
        if (!arguments.length)
          return [];
        var i = arguments[0];
        return Dt(i) ? i : [i];
      }
      function i1(i) {
        return xr(i, F);
      }
      function a1(i, s) {
        return s = typeof s == "function" ? s : t, xr(i, F, s);
      }
      function s1(i) {
        return xr(i, A | F);
      }
      function l1(i, s) {
        return s = typeof s == "function" ? s : t, xr(i, A | F, s);
      }
      function c1(i, s) {
        return s == null || Ld(i, s, Yr(s));
      }
      function ss(i, s) {
        return i === s || i !== i && s !== s;
      }
      var u1 = We(Pl), d1 = We(function(i, s) {
        return i >= s;
      }), td = Ol(/* @__PURE__ */ function() {
        return arguments;
      }()) ? Ol : function(i) {
        return Jn(i) && _t.call(i, "callee") && !wu.call(i, "callee");
      }, Dt = he.isArray, f1 = Ha ? qe(Ha) : Bc;
      function mi(i) {
        return i != null && ap(i.length) && !Zl(i);
      }
      function lr(i) {
        return Jn(i) && mi(i);
      }
      function g1(i) {
        return i === !0 || i === !1 || Jn(i) && mr(i) == ct;
      }
      var Xc = Iu || Sm, p1 = da ? qe(da) : ns;
      function h1(i) {
        return Jn(i) && i.nodeType === 1 && !lg(i);
      }
      function m1(i) {
        if (i == null)
          return !0;
        if (mi(i) && (Dt(i) || typeof i == "string" || typeof i.splice == "function" || Xc(i) || Jd(i) || td(i)))
          return !i.length;
        var s = Io(i);
        if (s == Ht || s == Gn)
          return !i.size;
        if (ag(i))
          return !Dl(i).length;
        for (var g in i)
          if (_t.call(i, g))
            return !1;
        return !0;
      }
      function v1(i, s) {
        return Ys(i, s);
      }
      function b1(i, s, g) {
        g = typeof g == "function" ? g : t;
        var E = g ? g(i, s) : t;
        return E === t ? Ys(i, s, t, g) : !!E;
      }
      function gm(i) {
        if (!Jn(i))
          return !1;
        var s = mr(i);
        return s == Mt || s == dt || typeof i.message == "string" && typeof i.name == "string" && !lg(i);
      }
      function y1(i) {
        return typeof i == "number" && xu(i);
      }
      function Zl(i) {
        if (!Wn(i))
          return !1;
        var s = mr(i);
        return s == Be || s == Wt || s == it || s == Nr;
      }
      function u0(i) {
        return typeof i == "number" && i == Lt(i);
      }
      function ap(i) {
        return typeof i == "number" && i > -1 && i % 1 == 0 && i <= ue;
      }
      function Wn(i) {
        var s = typeof i;
        return i != null && (s == "object" || s == "function");
      }
      function Jn(i) {
        return i != null && typeof i == "object";
      }
      var d0 = gc ? qe(gc) : rs;
      function C1(i, s) {
        return i === s || Wu(i, s, rm(s));
      }
      function E1(i, s, g) {
        return g = typeof g == "function" ? g : t, Wu(i, s, rm(s), g);
      }
      function A1(i) {
        return f0(i) && i != +i;
      }
      function S1(i) {
        if (aP(i))
          throw new ht(a);
        return Hu(i);
      }
      function w1(i) {
        return i === null;
      }
      function I1(i) {
        return i == null;
      }
      function f0(i) {
        return typeof i == "number" || Jn(i) && mr(i) == Fn;
      }
      function lg(i) {
        if (!Jn(i) || mr(i) != $n)
          return !1;
        var s = Ls(i);
        if (s === null)
          return !0;
        var g = _t.call(s, "constructor") && s.constructor;
        return typeof g == "function" && g instanceof g && Ec.call(g) == Au;
      }
      var pm = fa ? qe(fa) : pi;
      function x1(i) {
        return u0(i) && i >= -ue && i <= ue;
      }
      var g0 = ws ? qe(ws) : rg;
      function sp(i) {
        return typeof i == "string" || !Dt(i) && Jn(i) && mr(i) == Rn;
      }
      function Xi(i) {
        return typeof i == "symbol" || Jn(i) && mr(i) == An;
      }
      var Jd = Is ? qe(Is) : og;
      function T1(i) {
        return i === t;
      }
      function P1(i) {
        return Jn(i) && Io(i) == Mr;
      }
      function k1(i) {
        return Jn(i) && mr(i) == ii;
      }
      var R1 = We(Ko), O1 = We(function(i, s) {
        return i <= s;
      });
      function p0(i) {
        if (!i)
          return [];
        if (mi(i))
          return sp(i) ? ro(i) : sr(i);
        if (Vi && i[Vi])
          return Zf(i[Vi]());
        var s = Io(i), g = s == Ht ? vu : s == Gn ? Os : Qd;
        return g(i);
      }
      function Kl(i) {
        if (!i)
          return i === 0 ? i : 0;
        if (i = Pa(i), i === ze || i === -ze) {
          var s = i < 0 ? -1 : 1;
          return s * de;
        }
        return i === i ? i : 0;
      }
      function Lt(i) {
        var s = Kl(i), g = s % 1;
        return s === s ? g ? s - g : s : 0;
      }
      function h0(i) {
        return i ? wa(Lt(i), 0, me) : 0;
      }
      function Pa(i) {
        if (typeof i == "number")
          return i;
        if (Xi(i))
          return Q;
        if (Wn(i)) {
          var s = typeof i.valueOf == "function" ? i.valueOf() : i;
          i = Wn(s) ? s + "" : s;
        }
        if (typeof i != "string")
          return i === 0 ? i : +i;
        i = Me(i);
        var g = Et.test(i);
        return g || Kt.test(i) ? pl(i.slice(2), g ? 2 : 8) : Tt.test(i) ? Q : +i;
      }
      function m0(i) {
        return hi(i, vi(i));
      }
      function D1(i) {
        return i ? wa(Lt(i), -ue, ue) : i === 0 ? i : 0;
      }
      function un(i) {
        return i == null ? "" : Hr(i);
      }
      var F1 = d(function(i, s) {
        if (ag(s) || mi(s)) {
          hi(s, Yr(s), i);
          return;
        }
        for (var g in s)
          _t.call(s, g) && On(i, g, s[g]);
      }), v0 = d(function(i, s) {
        hi(s, vi(s), i);
      }), lp = d(function(i, s, g, E) {
        hi(s, vi(s), i, E);
      }), N1 = d(function(i, s, g, E) {
        hi(s, Yr(s), i, E);
      }), M1 = Yl(Du);
      function L1(i, s) {
        var g = Aa(i);
        return s == null ? g : Zo(g, s);
      }
      var B1 = wt(function(i, s) {
        i = Jt(i);
        var g = -1, E = s.length, O = E > 2 ? s[2] : t;
        for (O && Qo(s[0], s[1], O) && (E = 1); ++g < E; )
          for (var U = s[g], K = vi(U), $ = -1, re = K.length; ++$ < re; ) {
            var xe = K[$], Te = i[xe];
            (Te === t || ss(Te, Za[xe]) && !_t.call(i, xe)) && (i[xe] = U[xe]);
          }
        return i;
      }), V1 = wt(function(i) {
        return i.push(t, _u), Bn(b0, t, i);
      });
      function j1(i, s) {
        return Ga(i, mt(s, 3), gi);
      }
      function U1(i, s) {
        return Ga(i, mt(s, 3), Vu);
      }
      function W1(i, s) {
        return i == null ? i : Bu(i, mt(s, 3), vi);
      }
      function H1(i, s) {
        return i == null ? i : Vd(i, mt(s, 3), vi);
      }
      function G1(i, s) {
        return i && gi(i, mt(s, 3));
      }
      function Y1(i, s) {
        return i && Vu(i, mt(s, 3));
      }
      function z1(i) {
        return i == null ? [] : Lc(i, Yr(i));
      }
      function Z1(i) {
        return i == null ? [] : Lc(i, vi(i));
      }
      function hm(i, s, g) {
        var E = i == null ? t : ts(i, s);
        return E === t ? g : E;
      }
      function K1(i, s) {
        return i != null && By(i, s, kl);
      }
      function mm(i, s) {
        return i != null && By(i, s, jd);
      }
      var X1 = x(function(i, s, g) {
        s != null && typeof s.toString != "function" && (s = va.call(s)), i[s] = g;
      }, bm(bi)), J1 = x(function(i, s, g) {
        s != null && typeof s.toString != "function" && (s = va.call(s)), _t.call(i, s) ? i[s].push(g) : i[s] = [g];
      }, mt), Q1 = wt(Ao);
      function Yr(i) {
        return mi(i) ? Sa(i) : Dl(i);
      }
      function vi(i) {
        return mi(i) ? Sa(i, !0) : Vc(i);
      }
      function q1(i, s) {
        var g = {};
        return s = mt(s, 3), gi(i, function(E, O, U) {
          ir(g, s(E, O, U), E);
        }), g;
      }
      function _1(i, s) {
        var g = {};
        return s = mt(s, 3), gi(i, function(E, O, U) {
          ir(g, O, s(E, O, U));
        }), g;
      }
      var $1 = d(function(i, s, g) {
        Ks(i, s, g);
      }), b0 = d(function(i, s, g, E) {
        Ks(i, s, g, E);
      }), eR = Yl(function(i, s) {
        var g = {};
        if (i == null)
          return g;
        var E = !1;
        s = sn(s, function(U) {
          return U = Ki(U, i), E || (E = U.length > 1), U;
        }), hi(i, tm(i), g), E && (g = xr(g, A | w | F, Kd));
        for (var O = s.length; O--; )
          Ku(g, s[O]);
        return g;
      });
      function tR(i, s) {
        return y0(i, ip(mt(s)));
      }
      var nR = Yl(function(i, s) {
        return i == null ? {} : wo(i, s);
      });
      function y0(i, s) {
        if (i == null)
          return {};
        var g = sn(tm(i), function(E) {
          return [E];
        });
        return s = mt(s), Zi(i, g, function(E, O) {
          return s(E, O[0]);
        });
      }
      function rR(i, s, g) {
        s = Ki(s, i);
        var E = -1, O = s.length;
        for (O || (O = 1, i = t); ++E < O; ) {
          var U = i == null ? t : i[Qs(s[E])];
          U === t && (E = O, U = g), i = Zl(U) ? U.call(i) : U;
        }
        return i;
      }
      function oR(i, s, g) {
        return i == null ? i : as(i, s, g);
      }
      function iR(i, s, g, E) {
        return E = typeof E == "function" ? E : t, i == null ? i : as(i, s, g, E);
      }
      var C0 = Xn(Yr), E0 = Xn(vi);
      function aR(i, s, g) {
        var E = Dt(i), O = E || Xc(i) || Jd(i);
        if (s = mt(s, 4), g == null) {
          var U = i && i.constructor;
          O ? g = E ? new U() : [] : Wn(i) ? g = Zl(U) ? Aa(Ls(i)) : {} : g = {};
        }
        return (O ? rr : gi)(i, function(K, $, re) {
          return s(g, K, $, re);
        }), g;
      }
      function sR(i, s) {
        return i == null ? !0 : Ku(i, s);
      }
      function lR(i, s, g) {
        return i == null ? i : Wc(i, s, Vl(g));
      }
      function cR(i, s, g, E) {
        return E = typeof E == "function" ? E : t, i == null ? i : Wc(i, s, Vl(g), E);
      }
      function Qd(i) {
        return i == null ? [] : At(i, Yr(i));
      }
      function uR(i) {
        return i == null ? [] : At(i, vi(i));
      }
      function dR(i, s, g) {
        return g === t && (g = s, s = t), g !== t && (g = Pa(g), g = g === g ? g : 0), s !== t && (s = Pa(s), s = s === s ? s : 0), wa(Pa(i), s, g);
      }
      function fR(i, s, g) {
        return s = Kl(s), g === t ? (g = s, s = 0) : g = Kl(g), i = Pa(i), Rl(i, s, g);
      }
      function gR(i, s, g) {
        if (g && typeof g != "boolean" && Qo(i, s, g) && (s = g = t), g === t && (typeof s == "boolean" ? (g = s, s = t) : typeof i == "boolean" && (g = i, i = t)), i === t && s === t ? (i = 0, s = 1) : (i = Kl(i), s === t ? (s = i, i = 0) : s = Kl(s)), i > s) {
          var E = i;
          i = s, s = E;
        }
        if (g || i % 1 || s % 1) {
          var O = Ui();
          return Tn(i + O * (s - i + $r("1e-" + ((O + "").length - 1))), s);
        }
        return Uc(i, s);
      }
      var pR = Z(function(i, s, g) {
        return s = s.toLowerCase(), i + (g ? A0(s) : s);
      });
      function A0(i) {
        return vm(un(i).toLowerCase());
      }
      function S0(i) {
        return i = un(i), i && i.replace(pn, no).replace(dl, "");
      }
      function hR(i, s, g) {
        i = un(i), s = Hr(s);
        var E = i.length;
        g = g === t ? E : wa(Lt(g), 0, E);
        var O = g;
        return g -= s.length, g >= 0 && i.slice(g, O) == s;
      }
      function mR(i) {
        return i = un(i), i && Mo.test(i) ? i.replace(Bt, ks) : i;
      }
      function vR(i) {
        return i = un(i), i && Pi.test(i) ? i.replace(Vo, "\\$&") : i;
      }
      var bR = Z(function(i, s, g) {
        return i + (g ? "-" : "") + s.toLowerCase();
      }), yR = Z(function(i, s, g) {
        return i + (g ? " " : "") + s.toLowerCase();
      }), CR = W("toLowerCase");
      function ER(i, s, g) {
        i = un(i), s = Lt(s);
        var E = s ? Ds(i) : 0;
        if (!s || E >= s)
          return i;
        var O = (s - E) / 2;
        return J(Bs(O), g) + i + J(Cl(O), g);
      }
      function AR(i, s, g) {
        i = un(i), s = Lt(s);
        var E = s ? Ds(i) : 0;
        return s && E < s ? i + J(s - E, g) : i;
      }
      function SR(i, s, g) {
        i = un(i), s = Lt(s);
        var E = s ? Ds(i) : 0;
        return s && E < s ? J(s - E, g) + i : i;
      }
      function wR(i, s, g) {
        return g || s == null ? s = 0 : s && (s = +s), ku(un(i).replace(cn, ""), s || 0);
      }
      function IR(i, s, g) {
        return (g ? Qo(i, s, g) : s === t) ? s = 1 : s = Lt(s), Yu(un(i), s);
      }
      function xR() {
        var i = arguments, s = un(i[0]);
        return i.length < 3 ? s : s.replace(i[1], i[2]);
      }
      var TR = Z(function(i, s, g) {
        return i + (g ? "_" : "") + s.toLowerCase();
      });
      function PR(i, s, g) {
        return g && typeof g != "number" && Qo(i, s, g) && (s = g = t), g = g === t ? me : g >>> 0, g ? (i = un(i), i && (typeof s == "string" || s != null && !pm(s)) && (s = Hr(s), !s && Rs(i)) ? Jo(ro(i), 0, g) : i.split(s, g)) : [];
      }
      var kR = Z(function(i, s, g) {
        return i + (g ? " " : "") + vm(s);
      });
      function RR(i, s, g) {
        return i = un(i), g = g == null ? 0 : wa(Lt(g), 0, i.length), s = Hr(s), i.slice(g, g + s.length) == s;
      }
      function OR(i, s, g) {
        var E = B.templateSettings;
        g && Qo(i, s, g) && (s = t), i = un(i), s = lp({}, s, E, qu);
        var O = lp({}, s.imports, E.imports, qu), U = Yr(O), K = At(O, U), $, re, xe = 0, Te = s.interpolate || Un, De = "__p += '", Ge = ma(
          (s.escape || Un).source + "|" + Te.source + "|" + (Te === Bo ? St : Un).source + "|" + (s.evaluate || Un).source + "|$",
          "g"
        ), rt = "//# sourceURL=" + (_t.call(s, "sourceURL") ? (s.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++rn + "]") + `
`;
        i.replace(Ge, function(bt, Zt, Qt, Ji, qo, Qi) {
          return Qt || (Qt = Ji), De += i.slice(xe, Qi).replace(go, yc), Zt && ($ = !0, De += `' +
__e(` + Zt + `) +
'`), qo && (re = !0, De += `';
` + qo + `;
__p += '`), Qt && (De += `' +
((__t = (` + Qt + `)) == null ? '' : __t) +
'`), xe = Qi + bt.length, bt;
        }), De += `';
`;
        var vt = _t.call(s, "variable") && s.variable;
        if (!vt)
          De = `with (obj) {
` + De + `
}
`;
        else if (Ve.test(vt))
          throw new ht(u);
        De = (re ? De.replace(aa, "") : De).replace(Nn, "$1").replace(Er, "$1;"), De = "function(" + (vt || "obj") + `) {
` + (vt ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + ($ ? ", __e = _.escape" : "") + (re ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + De + `return __p
}`;
        var Vt = I0(function() {
          return Ut(U, rt + "return " + De).apply(t, K);
        });
        if (Vt.source = De, gm(Vt))
          throw Vt;
        return Vt;
      }
      function DR(i) {
        return un(i).toLowerCase();
      }
      function FR(i) {
        return un(i).toUpperCase();
      }
      function NR(i, s, g) {
        if (i = un(i), i && (g || s === t))
          return Me(i);
        if (!i || !(s = Hr(s)))
          return i;
        var E = ro(i), O = ro(s), U = on(E, O), K = hr(E, O) + 1;
        return Jo(E, U, K).join("");
      }
      function MR(i, s, g) {
        if (i = un(i), i && (g || s === t))
          return i.slice(0, yu(i) + 1);
        if (!i || !(s = Hr(s)))
          return i;
        var E = ro(i), O = hr(E, ro(s)) + 1;
        return Jo(E, 0, O).join("");
      }
      function LR(i, s, g) {
        if (i = un(i), i && (g || s === t))
          return i.replace(cn, "");
        if (!i || !(s = Hr(s)))
          return i;
        var E = ro(i), O = on(E, ro(s));
        return Jo(E, O).join("");
      }
      function BR(i, s) {
        var g = Se, E = we;
        if (Wn(s)) {
          var O = "separator" in s ? s.separator : O;
          g = "length" in s ? Lt(s.length) : g, E = "omission" in s ? Hr(s.omission) : E;
        }
        i = un(i);
        var U = i.length;
        if (Rs(i)) {
          var K = ro(i);
          U = K.length;
        }
        if (g >= U)
          return i;
        var $ = g - Ds(E);
        if ($ < 1)
          return E;
        var re = K ? Jo(K, 0, $).join("") : i.slice(0, $);
        if (O === t)
          return re + E;
        if (K && ($ += re.length - $), pm(O)) {
          if (i.slice($).search(O)) {
            var xe, Te = re;
            for (O.global || (O = ma(O.source, un(Ot.exec(O)) + "g")), O.lastIndex = 0; xe = O.exec(Te); )
              var De = xe.index;
            re = re.slice(0, De === t ? $ : De);
          }
        } else if (i.indexOf(Hr(O), $) != $) {
          var Ge = re.lastIndexOf(O);
          Ge > -1 && (re = re.slice(0, Ge));
        }
        return re + E;
      }
      function VR(i) {
        return i = un(i), i && Br.test(i) ? i.replace(Yn, Td) : i;
      }
      var jR = Z(function(i, s, g) {
        return i + (g ? " " : "") + s.toUpperCase();
      }), vm = W("toUpperCase");
      function w0(i, s, g) {
        return i = un(i), s = g ? t : s, s === t ? zf(i) ? Jf(i) : Ts(i) : i.match(s) || [];
      }
      var I0 = wt(function(i, s) {
        try {
          return Bn(i, t, s);
        } catch (g) {
          return gm(g) ? g : new ht(g);
        }
      }), UR = Yl(function(i, s) {
        return rr(s, function(g) {
          g = Qs(g), ir(i, g, dm(i[g], i));
        }), i;
      });
      function WR(i) {
        var s = i == null ? 0 : i.length, g = mt();
        return i = s ? sn(i, function(E) {
          if (typeof E[1] != "function")
            throw new Ur(l);
          return [g(E[0]), E[1]];
        }) : [], wt(function(E) {
          for (var O = -1; ++O < s; ) {
            var U = i[O];
            if (Bn(U[0], this, E))
              return Bn(U[1], this, E);
          }
        });
      }
      function HR(i) {
        return Fu(xr(i, A));
      }
      function bm(i) {
        return function() {
          return i;
        };
      }
      function GR(i, s) {
        return i == null || i !== i ? s : i;
      }
      var YR = h(), zR = h(!0);
      function bi(i) {
        return i;
      }
      function ym(i) {
        return zs(typeof i == "function" ? i : xr(i, A));
      }
      function ZR(i) {
        return zi(xr(i, A));
      }
      function KR(i, s) {
        return Xo(i, xr(s, A));
      }
      var XR = wt(function(i, s) {
        return function(g) {
          return Ao(g, i, s);
        };
      }), JR = wt(function(i, s) {
        return function(g) {
          return Ao(i, g, s);
        };
      });
      function Cm(i, s, g) {
        var E = Yr(s), O = Lc(s, E);
        g == null && !(Wn(s) && (O.length || !E.length)) && (g = s, s = i, i = this, O = Lc(s, Yr(s)));
        var U = !(Wn(g) && "chain" in g) || !!g.chain, K = Zl(i);
        return rr(O, function($) {
          var re = s[$];
          i[$] = re, K && (i.prototype[$] = function() {
            var xe = this.__chain__;
            if (U || xe) {
              var Te = i(this.__wrapped__), De = Te.__actions__ = sr(this.__actions__);
              return De.push({ func: re, args: arguments, thisArg: i }), Te.__chain__ = xe, Te;
            }
            return re.apply(i, eo([this.value()], arguments));
          });
        }), i;
      }
      function QR() {
        return Ln._ === this && (Ln._ = Cn), this;
      }
      function Em() {
      }
      function qR(i) {
        return i = Lt(i), wt(function(s) {
          return os(s, i);
        });
      }
      var _R = Y(sn), $R = Y(xs), eO = Y(pa);
      function x0(i) {
        return im(i) ? b(Qs(i)) : Gu(i);
      }
      function tO(i) {
        return function(s) {
          return i == null ? t : ts(i, s);
        };
      }
      var nO = Pe(), rO = Pe(!0);
      function Am() {
        return [];
      }
      function Sm() {
        return !1;
      }
      function oO() {
        return {};
      }
      function iO() {
        return "";
      }
      function aO() {
        return !0;
      }
      function sO(i, s) {
        if (i = Lt(i), i < 1 || i > ue)
          return [];
        var g = me, E = Tn(i, me);
        s = mt(s), i -= me;
        for (var O = ie(E, s); ++g < i; )
          s(g);
        return O;
      }
      function lO(i) {
        return Dt(i) ? sn(i, Qs) : Xi(i) ? [i] : sr(Zy(un(i)));
      }
      function cO(i) {
        var s = ++kd;
        return un(i) + s;
      }
      var uO = M(function(i, s) {
        return i + s;
      }, 0), dO = gt("ceil"), fO = M(function(i, s) {
        return i / s;
      }, 1), gO = gt("floor");
      function pO(i) {
        return i && i.length ? Mc(i, bi, Pl) : t;
      }
      function hO(i, s) {
        return i && i.length ? Mc(i, mt(s, 2), Pl) : t;
      }
      function mO(i) {
        return ml(i, bi);
      }
      function vO(i, s) {
        return ml(i, mt(s, 2));
      }
      function bO(i) {
        return i && i.length ? Mc(i, bi, Ko) : t;
      }
      function yO(i, s) {
        return i && i.length ? Mc(i, mt(s, 2), Ko) : t;
      }
      var CO = M(function(i, s) {
        return i * s;
      }, 1), EO = gt("round"), AO = M(function(i, s) {
        return i - s;
      }, 0);
      function SO(i) {
        return i && i.length ? ce(i, bi) : 0;
      }
      function wO(i, s) {
        return i && i.length ? ce(i, mt(s, 2)) : 0;
      }
      return B.after = Zk, B.ary = r0, B.assign = F1, B.assignIn = v0, B.assignInWith = lp, B.assignWith = N1, B.at = M1, B.before = o0, B.bind = dm, B.bindAll = UR, B.bindKey = i0, B.castArray = o1, B.chain = e0, B.chunk = gP, B.compact = pP, B.concat = hP, B.cond = WR, B.conforms = HR, B.constant = bm, B.countBy = Sk, B.create = L1, B.curry = a0, B.curryRight = s0, B.debounce = l0, B.defaults = B1, B.defaultsDeep = V1, B.defer = Kk, B.delay = Xk, B.difference = mP, B.differenceBy = vP, B.differenceWith = bP, B.drop = yP, B.dropRight = CP, B.dropRightWhile = EP, B.dropWhile = AP, B.fill = SP, B.filter = Ik, B.flatMap = Pk, B.flatMapDeep = kk, B.flatMapDepth = Rk, B.flatten = Qy, B.flattenDeep = wP, B.flattenDepth = IP, B.flip = Jk, B.flow = YR, B.flowRight = zR, B.fromPairs = xP, B.functions = z1, B.functionsIn = Z1, B.groupBy = Ok, B.initial = PP, B.intersection = kP, B.intersectionBy = RP, B.intersectionWith = OP, B.invert = X1, B.invertBy = J1, B.invokeMap = Fk, B.iteratee = ym, B.keyBy = Nk, B.keys = Yr, B.keysIn = vi, B.map = np, B.mapKeys = q1, B.mapValues = _1, B.matches = ZR, B.matchesProperty = KR, B.memoize = op, B.merge = $1, B.mergeWith = b0, B.method = XR, B.methodOf = JR, B.mixin = Cm, B.negate = ip, B.nthArg = qR, B.omit = eR, B.omitBy = tR, B.once = Qk, B.orderBy = Mk, B.over = _R, B.overArgs = qk, B.overEvery = $R, B.overSome = eO, B.partial = fm, B.partialRight = c0, B.partition = Lk, B.pick = nR, B.pickBy = y0, B.property = x0, B.propertyOf = tO, B.pull = MP, B.pullAll = _y, B.pullAllBy = LP, B.pullAllWith = BP, B.pullAt = VP, B.range = nO, B.rangeRight = rO, B.rearg = _k, B.reject = jk, B.remove = jP, B.rest = $k, B.reverse = cm, B.sampleSize = Wk, B.set = oR, B.setWith = iR, B.shuffle = Hk, B.slice = UP, B.sortBy = zk, B.sortedUniq = KP, B.sortedUniqBy = XP, B.split = PR, B.spread = e1, B.tail = JP, B.take = QP, B.takeRight = qP, B.takeRightWhile = _P, B.takeWhile = $P, B.tap = pk, B.throttle = t1, B.thru = tp, B.toArray = p0, B.toPairs = C0, B.toPairsIn = E0, B.toPath = lO, B.toPlainObject = m0, B.transform = aR, B.unary = n1, B.union = ek, B.unionBy = tk, B.unionWith = nk, B.uniq = rk, B.uniqBy = ok, B.uniqWith = ik, B.unset = sR, B.unzip = um, B.unzipWith = $y, B.update = lR, B.updateWith = cR, B.values = Qd, B.valuesIn = uR, B.without = ak, B.words = w0, B.wrap = r1, B.xor = sk, B.xorBy = lk, B.xorWith = ck, B.zip = uk, B.zipObject = dk, B.zipObjectDeep = fk, B.zipWith = gk, B.entries = C0, B.entriesIn = E0, B.extend = v0, B.extendWith = lp, Cm(B, B), B.add = uO, B.attempt = I0, B.camelCase = pR, B.capitalize = A0, B.ceil = dO, B.clamp = dR, B.clone = i1, B.cloneDeep = s1, B.cloneDeepWith = l1, B.cloneWith = a1, B.conformsTo = c1, B.deburr = S0, B.defaultTo = GR, B.divide = fO, B.endsWith = hR, B.eq = ss, B.escape = mR, B.escapeRegExp = vR, B.every = wk, B.find = xk, B.findIndex = Xy, B.findKey = j1, B.findLast = Tk, B.findLastIndex = Jy, B.findLastKey = U1, B.floor = gO, B.forEach = t0, B.forEachRight = n0, B.forIn = W1, B.forInRight = H1, B.forOwn = G1, B.forOwnRight = Y1, B.get = hm, B.gt = u1, B.gte = d1, B.has = K1, B.hasIn = mm, B.head = qy, B.identity = bi, B.includes = Dk, B.indexOf = TP, B.inRange = fR, B.invoke = Q1, B.isArguments = td, B.isArray = Dt, B.isArrayBuffer = f1, B.isArrayLike = mi, B.isArrayLikeObject = lr, B.isBoolean = g1, B.isBuffer = Xc, B.isDate = p1, B.isElement = h1, B.isEmpty = m1, B.isEqual = v1, B.isEqualWith = b1, B.isError = gm, B.isFinite = y1, B.isFunction = Zl, B.isInteger = u0, B.isLength = ap, B.isMap = d0, B.isMatch = C1, B.isMatchWith = E1, B.isNaN = A1, B.isNative = S1, B.isNil = I1, B.isNull = w1, B.isNumber = f0, B.isObject = Wn, B.isObjectLike = Jn, B.isPlainObject = lg, B.isRegExp = pm, B.isSafeInteger = x1, B.isSet = g0, B.isString = sp, B.isSymbol = Xi, B.isTypedArray = Jd, B.isUndefined = T1, B.isWeakMap = P1, B.isWeakSet = k1, B.join = DP, B.kebabCase = bR, B.last = Ta, B.lastIndexOf = FP, B.lowerCase = yR, B.lowerFirst = CR, B.lt = R1, B.lte = O1, B.max = pO, B.maxBy = hO, B.mean = mO, B.meanBy = vO, B.min = bO, B.minBy = yO, B.stubArray = Am, B.stubFalse = Sm, B.stubObject = oO, B.stubString = iO, B.stubTrue = aO, B.multiply = CO, B.nth = NP, B.noConflict = QR, B.noop = Em, B.now = rp, B.pad = ER, B.padEnd = AR, B.padStart = SR, B.parseInt = wR, B.random = gR, B.reduce = Bk, B.reduceRight = Vk, B.repeat = IR, B.replace = xR, B.result = rR, B.round = EO, B.runInContext = te, B.sample = Uk, B.size = Gk, B.snakeCase = TR, B.some = Yk, B.sortedIndex = WP, B.sortedIndexBy = HP, B.sortedIndexOf = GP, B.sortedLastIndex = YP, B.sortedLastIndexBy = zP, B.sortedLastIndexOf = ZP, B.startCase = kR, B.startsWith = RR, B.subtract = AO, B.sum = SO, B.sumBy = wO, B.template = OR, B.times = sO, B.toFinite = Kl, B.toInteger = Lt, B.toLength = h0, B.toLower = DR, B.toNumber = Pa, B.toSafeInteger = D1, B.toString = un, B.toUpper = FR, B.trim = NR, B.trimEnd = MR, B.trimStart = LR, B.truncate = BR, B.unescape = VR, B.uniqueId = cO, B.upperCase = jR, B.upperFirst = vm, B.each = t0, B.eachRight = n0, B.first = qy, Cm(B, function() {
        var i = {};
        return gi(B, function(s, g) {
          _t.call(B.prototype, g) || (i[g] = s);
        }), i;
      }(), { chain: !1 }), B.VERSION = r, rr(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(i) {
        B[i].placeholder = B;
      }), rr(["drop", "take"], function(i, s) {
        kt.prototype[i] = function(g) {
          g = g === t ? 1 : xn(Lt(g), 0);
          var E = this.__filtered__ && !s ? new kt(this) : this.clone();
          return E.__filtered__ ? E.__takeCount__ = Tn(g, E.__takeCount__) : E.__views__.push({
            size: Tn(g, me),
            type: i + (E.__dir__ < 0 ? "Right" : "")
          }), E;
        }, kt.prototype[i + "Right"] = function(g) {
          return this.reverse()[i](g).reverse();
        };
      }), rr(["filter", "map", "takeWhile"], function(i, s) {
        var g = s + 1, E = g == Ie || g == Ke;
        kt.prototype[i] = function(O) {
          var U = this.clone();
          return U.__iteratees__.push({
            iteratee: mt(O, 3),
            type: g
          }), U.__filtered__ = U.__filtered__ || E, U;
        };
      }), rr(["head", "last"], function(i, s) {
        var g = "take" + (s ? "Right" : "");
        kt.prototype[i] = function() {
          return this[g](1).value()[0];
        };
      }), rr(["initial", "tail"], function(i, s) {
        var g = "drop" + (s ? "" : "Right");
        kt.prototype[i] = function() {
          return this.__filtered__ ? new kt(this) : this[g](1);
        };
      }), kt.prototype.compact = function() {
        return this.filter(bi);
      }, kt.prototype.find = function(i) {
        return this.filter(i).head();
      }, kt.prototype.findLast = function(i) {
        return this.reverse().find(i);
      }, kt.prototype.invokeMap = wt(function(i, s) {
        return typeof i == "function" ? new kt(this) : this.map(function(g) {
          return Ao(g, i, s);
        });
      }), kt.prototype.reject = function(i) {
        return this.filter(ip(mt(i)));
      }, kt.prototype.slice = function(i, s) {
        i = Lt(i);
        var g = this;
        return g.__filtered__ && (i > 0 || s < 0) ? new kt(g) : (i < 0 ? g = g.takeRight(-i) : i && (g = g.drop(i)), s !== t && (s = Lt(s), g = s < 0 ? g.dropRight(-s) : g.take(s - i)), g);
      }, kt.prototype.takeRightWhile = function(i) {
        return this.reverse().takeWhile(i).reverse();
      }, kt.prototype.toArray = function() {
        return this.take(me);
      }, gi(kt.prototype, function(i, s) {
        var g = /^(?:filter|find|map|reject)|While$/.test(s), E = /^(?:head|last)$/.test(s), O = B[E ? "take" + (s == "last" ? "Right" : "") : s], U = E || /^find/.test(s);
        O && (B.prototype[s] = function() {
          var K = this.__wrapped__, $ = E ? [1] : arguments, re = K instanceof kt, xe = $[0], Te = re || Dt(K), De = function(Zt) {
            var Qt = O.apply(B, eo([Zt], $));
            return E && Ge ? Qt[0] : Qt;
          };
          Te && g && typeof xe == "function" && xe.length != 1 && (re = Te = !1);
          var Ge = this.__chain__, rt = !!this.__actions__.length, vt = U && !Ge, Vt = re && !rt;
          if (!U && Te) {
            K = Vt ? K : new kt(this);
            var bt = i.apply(K, $);
            return bt.__actions__.push({ func: tp, args: [De], thisArg: t }), new Ir(bt, Ge);
          }
          return vt && Vt ? i.apply(this, $) : (bt = this.thru(De), vt ? E ? bt.value()[0] : bt.value() : bt);
        });
      }), rr(["pop", "push", "shift", "sort", "splice", "unshift"], function(i) {
        var s = za[i], g = /^(?:push|sort|unshift)$/.test(i) ? "tap" : "thru", E = /^(?:pop|shift)$/.test(i);
        B.prototype[i] = function() {
          var O = arguments;
          if (E && !this.__chain__) {
            var U = this.value();
            return s.apply(Dt(U) ? U : [], O);
          }
          return this[g](function(K) {
            return s.apply(Dt(K) ? K : [], O);
          });
        };
      }), gi(kt.prototype, function(i, s) {
        var g = B[s];
        if (g) {
          var E = g.name + "";
          _t.call(Ea, E) || (Ea[E] = []), Ea[E].push({ name: s, func: g });
        }
      }), Ea[C(t, k).name] = [{
        name: "wrapper",
        func: t
      }], kt.prototype.clone = xc, kt.prototype.reverse = Us, kt.prototype.value = xl, B.prototype.at = hk, B.prototype.chain = mk, B.prototype.commit = vk, B.prototype.next = bk, B.prototype.plant = Ck, B.prototype.reverse = Ek, B.prototype.toJSON = B.prototype.valueOf = B.prototype.value = Ak, B.prototype.first = B.prototype.head, Vi && (B.prototype[Vi] = yk), B;
    }, Kn = Pd();
    Mi ? ((Mi.exports = Kn)._ = Kn, Ss._ = Kn) : Ln._ = Kn;
  }).call(cg);
})(Rh, Rh.exports);
var d2 = Rh.exports;
const wE = /* @__PURE__ */ DA(d2), f2 = (e) => {
  const [n, t, r] = e.split("-");
  return r && t && n ? {
    day: Number(r),
    month: Number(t),
    year: Number(n)
  } : void 0;
}, Jl = (e) => {
  const n = u2(e, "UTC");
  return {
    day: n.getDate(),
    month: n.getMonth() + 1,
    year: n.getFullYear()
  };
}, Mg = (e, n) => n == null ? void 0 : n.find(
  (t) => t.day === e.day && t.month === e.month && t.year === e.year
), g2 = (e, n) => {
  const t = new Date(e.year, e.month, e.day), r = n ? new Date(n.year, n.month, n.day) : void 0;
  return r ? Wg(t, r) : !1;
}, qn = (e) => new Date(e.year, e.month - 1, e.day), GT = (e, n, t, r, o) => {
  const a = e ? qn(e) : void 0, l = e && a && !n ? t == null ? void 0 : t.find((F) => Of(qn(F), a)) : void 0, u = e && a && !n ? r == null ? void 0 : r.find((F) => Of(qn(F), a)) : void 0, f = u ? f2(
    U3(
      MT(qn(u), { days: 1 }),
      "yyyy-M-d"
    )
  ) : void 0, p = f ? qn(f) : void 0, y = l ? qn(l) : void 0, A = wE.sortBy(
    wE.compact([
      p,
      y,
      o
    ])
  );
  return A.length > 0 ? Jl(A[0].toISOString()) : l ?? f;
}, p2 = (e, n, t, r, o, a, l) => {
  const u = /* @__PURE__ */ new Date(), f = qn(e), p = r ? qn(r) : void 0, y = !!Mg(
    e,
    n
  ), A = r && p && !o ? Wg(f, p) : !1, F = Wg(f, u) && !Ng(f, u) && !!l, j = a ? Of(f, a) && !Ng(f, a) : !1, N = GT(
    r,
    o,
    n,
    t,
    a
  ), D = N ? qn(N) : void 0, k = D ? Of(f, D) || Ng(f, D) : !1;
  return y || A || k || F || j;
}, h2 = (e, n, t, r, o) => {
  const a = !!Mg(e, n) || (o ? Ng(qn(e), qn(o)) : !1);
  return a && !t || a && !!t && !!r;
}, m2 = (e, n, t) => {
  const r = g2(e, n);
  if (!t || !n || r)
    return !1;
  const o = qn(e), a = qn(n);
  return Kh(o, a) < t;
}, v2 = (e, n, t) => {
  if (!t || !n)
    return !1;
  const r = qn(e), o = qn(n);
  return Kh(r, o) > t;
}, b2 = (e, n, t, r, o) => {
  if (!n)
    return !1;
  const a = GT(
    e,
    void 0,
    t,
    r,
    o
  ), l = qn(e), u = a ? Y3(qn(a), { days: 1 }) : void 0, f = u ? Kh(u, l) : void 0;
  return !!(f && f < n);
}, y2 = ({
  showMinNightsHint: e,
  showCheckOutOnlyHint: n,
  minNights: t
}) => n ? "Check-out only" : e ? `${t}-night minimum` : "", C2 = Ii({
  base: {
    py: "50",
    px: "150",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "300",
    width: "max-content",
    height: "fit-content",
    overflow: "hidden",
    columnGap: "75",
    color: "text.inverse",
    "& > p, > svg": { zIndex: 1 }
  },
  variants: {
    visual: {
      primary: {
        bgColor: "bg.darkest"
      },
      accent: {
        bgColor: "bg.accent.dark"
      },
      success: {
        bgColor: "bg.success.dark"
      },
      highlight: {
        bgColor: "bg.highlight.dark"
      },
      warning: {
        bgColor: "bg.warning.dark"
      },
      destructive: {
        bgColor: "bg.error.dark"
      }
    },
    mode: {
      dark: {
        color: "text.inverse"
      },
      light: {
        color: "text.dark"
      },
      blur: {
        color: "text.inverse",
        backdropFilter: "blur(4px)"
      }
    }
  },
  compoundVariants: [
    {
      visual: "primary",
      mode: "light",
      css: { bgColor: "bg.lighter" }
    },
    {
      visual: "accent",
      mode: "light",
      css: { color: "text.accent.dark", bgColor: "bg.accent.light" }
    },
    {
      visual: "success",
      mode: "light",
      css: { color: "text.success.dark", bgColor: "bg.success.light" }
    },
    {
      visual: "highlight",
      mode: "light",
      css: { color: "text.highlight.dark", bgColor: "bg.highlight.light" }
    },
    {
      visual: "warning",
      mode: "light",
      css: { color: "text.warning.dark", bgColor: "bg.warning.light" }
    },
    {
      visual: "destructive",
      mode: "light",
      css: { color: "text.error.dark", bgColor: "bg.error.light" }
    },
    {
      visual: "primary",
      mode: "blur",
      css: { bgColor: "bg.darkest/75" }
    },
    {
      visual: "accent",
      mode: "blur",
      css: { bgColor: "bg.accent.dark/75" }
    },
    {
      visual: "success",
      mode: "blur",
      css: { bgColor: "bg.success.dark/75" }
    },
    {
      visual: "warning",
      mode: "blur",
      css: { bgColor: "bg.warning.dark/75" }
    },
    {
      visual: "destructive",
      mode: "blur",
      css: { bgColor: "bg.error.dark/75" }
    }
  ],
  defaultVariants: {
    visual: "primary",
    mode: "dark"
  }
}), E2 = Ii({
  base: {
    fontFamily: "body"
  },
  variants: {
    visual: {
      bodySemiBold: {
        fontSize: "md",
        lineHeight: "sm",
        fontWeight: "semiBold"
      },
      bodyMedium: {
        fontSize: "md",
        lineHeight: "sm",
        fontWeight: "medium"
      },
      bodyRegular: {
        fontSize: "md",
        lineHeight: "sm",
        fontWeight: "normal"
      },
      smallSemiBold: {
        fontSize: "xs",
        lineHeight: "xs",
        fontWeight: "semiBold"
      },
      smallMedium: {
        fontSize: "xs",
        lineHeight: "xs",
        fontWeight: "medium"
      },
      smallRegular: {
        fontSize: "xs",
        lineHeight: "xs",
        fontWeight: "normal"
      },
      smallTag: {
        fontSize: "2xs",
        lineHeight: "2xs",
        fontWeight: "semiBold",
        letterSpacing: "wide"
      },
      smallLabel: {
        fontSize: "2xs",
        lineHeight: "2xs",
        fontWeight: "bold",
        letterSpacing: "wider",
        textTransform: "uppercase"
      }
    }
  },
  defaultVariants: {
    visual: "bodyRegular"
  }
}), Xr = oe((e, n) => {
  const { as: t = "p", ...r } = e, o = oc(
    () => It(t, E2),
    [t]
  );
  return /* @__PURE__ */ I.jsx(o, { ref: n, ...r });
}), Ry = ({ children: e, visual: n, Icon: t, mode: r }) => /* @__PURE__ */ I.jsxs(ll, { className: C2({ visual: n, mode: r }), children: [
  /* @__PURE__ */ I.jsx(Xr, { visual: "smallTag", children: e }),
  t && /* @__PURE__ */ I.jsx(fr, { Element: t, size: "sm" })
] }), A2 = ({
  day: e,
  startDateValue: n,
  endDateValue: t,
  unavailableDates: r,
  checkOutOnlyDates: o,
  minNights: a,
  maxNights: l,
  lastCalendarDateValue: u,
  disablePastDates: f
}) => {
  const [p, y] = du(!1), A = e, F = qn(A).getDay(), j = u ? MT(qn(u), { days: 1 }) : void 0, N = !n || !!(n && t), D = !t && !!n, k = p2(
    A,
    r,
    o,
    n,
    t,
    j,
    f
  ), z = h2(
    A,
    o,
    n,
    t,
    u
  ), q = D && m2(A, n, a), Ce = D && v2(A, n, l), ee = N && b2(
    A,
    a,
    r,
    o,
    j
  ), Fe = {
    ...k || Ce ? {
      "data-unavailable": !0,
      "aria-disabled": !0,
      "data-disabled": !0
    } : {},
    ...z ? { "data-check-out-only": !0 } : {},
    ...q ? { "data-under-min-night": !0 } : {},
    ...ee ? { "data-outside-min-night-range": !0 } : {}
  }, Oe = q && a && a > 1, He = N && (Oe || ee || z);
  return /* @__PURE__ */ I.jsxs(Py, { value: e, children: [
    /* @__PURE__ */ I.jsx(
      ll,
      {
        onMouseEnter: () => {
          Oe && y(!0);
        },
        onMouseLeave: () => y(!1),
        onClick: () => {
          He && y(!0);
        },
        cursor: k ? void 0 : "pointer",
        height: "full",
        children: /* @__PURE__ */ I.jsx(
          ky,
          {
            width: "full",
            height: "full",
            css: {
              "&[data-in-range]": {
                background: "bg.lighter"
              },
              "&[data-range-start], &[data-range-end]": {
                background: "bg.darkest",
                borderColor: "border.dark",
                color: "text.inverse",
                // Set hover background to important to override any and all
                // other hover background settings
                _hover: { background: "bg.darkest!" },
                // Set opacity to !important to override other data properties
                // that effect the opacity
                opacity: "1 !important",
                _disabled: {
                  opacity: "0.3 !important"
                }
              },
              "&[data-range-start]": {
                pointerEvents: N ? void 0 : "none"
              },
              "&[data-under-min-night], &[data-outside-min-night-range]": {
                opacity: 0.6,
                pointerEvents: "none",
                _disabled: {
                  opacity: 0.3
                }
              },
              "&[data-check-out-only]": {
                opacity: 0.6,
                pointerEvents: "none",
                _hover: { background: "white" }
              },
              _disabled: {
                opacity: 0.3,
                pointerEvents: "none",
                background: "transparent",
                borderColor: "transparent",
                "&[data-in-range]": {
                  background: "bg.lighter"
                },
                "&[data-range-start], &[data-range-end]": {
                  background: "bg.darkest",
                  borderColor: "border.dark",
                  color: "text.inverse",
                  _hover: { background: "bg.darkest" }
                }
              },
              margin: "0 auto"
            },
            ...Fe,
            children: A.day
          }
        )
      }
    ),
    p && /* @__PURE__ */ I.jsx(
      ll,
      {
        position: "absolute",
        top: "-28px",
        right: F > 3 ? 0 : void 0,
        children: /* @__PURE__ */ I.jsx(Ry, { children: y2({
          showMinNightsHint: q || ee,
          showCheckOutOnlyHint: z,
          minNights: a
        }) })
      }
    )
  ] });
}, S2 = ({
  day: e,
  primaryRangeDates: n,
  highlightedRangeDates: t,
  lastCalendarDateValue: r,
  outlinedDates: o,
  disablePastDates: a
}) => {
  const l = e, u = qn(l), f = r ? qn(r) : void 0, p = f ? Of(u, f) : !1, y = !!Mg(
    l,
    t
  ), A = !!Mg(l, n), w = !!Mg(l, o), j = Wg(u, /* @__PURE__ */ new Date()) && !Ng(u, /* @__PURE__ */ new Date()) && a, N = {
    ...p || j ? {
      "data-unavailable": !0,
      "aria-disabled": !0,
      "data-disabled": !0
    } : {},
    ...A ? { "data-primary-range": !0 } : {},
    ...y && !A ? { "data-highlighted-range": !0 } : {},
    ...w ? { "data-outlined-date": !0 } : {}
  };
  return /* @__PURE__ */ I.jsx(Py, { value: e, children: /* @__PURE__ */ I.jsx(ll, { height: "full", children: /* @__PURE__ */ I.jsx(
    ky,
    {
      width: "full",
      height: "full",
      css: {
        _selected: {
          color: "text.inverse",
          // Set background & borderColor to important to override all
          // other background/borderColor settings
          background: "bg.darkest!",
          borderColor: "border.dark!",
          _hover: { background: "bg.darkest" }
        },
        "&[data-primary-range]": {
          background: "bg.lighter",
          _hover: { background: "bg.lighter" }
        },
        "&[data-highlighted-range]": {
          background: "bg.highlight.light",
          borderColor: "border.highlight",
          _hover: { background: "bg.highlight.light" }
        },
        "&[data-outlined-date]": {
          borderColor: "border.dark",
          outline: "1px solid token(colors.border.dark)"
        },
        _disabled: {
          opacity: 0.3,
          pointerEvents: "none",
          background: "transparent",
          borderColor: "transparent"
        },
        margin: "0 auto"
      },
      ...N,
      children: l.day
    }
  ) }) });
}, w2 = [
  { label: "Booked", visual: "dark" },
  {
    label: "Closure",
    visual: "highlight"
  },
  { label: "Available", visual: "light" }
], I2 = Ii({
  base: {
    borderWidth: "2px",
    borderRadius: "25",
    width: "12px",
    height: "12px"
  },
  variants: {
    visual: {
      dark: {
        borderColor: "border.dark",
        bg: "white"
      },
      highlight: {
        borderColor: "border.highlight",
        bg: "bg.highlight.light"
      },
      light: {
        borderColor: "border.light",
        bg: "white"
      }
    }
  },
  defaultVariants: {
    visual: "dark"
  }
}), x2 = It("div", I2), T2 = () => /* @__PURE__ */ I.jsx(Si, { width: "full", gap: "200", alignItems: "center", children: w2.map((e) => /* @__PURE__ */ I.jsxs(
  Si,
  {
    alignItems: "center",
    justifyContent: "center",
    gap: "75",
    children: [
      /* @__PURE__ */ I.jsx(x2, { visual: e.visual }),
      /* @__PURE__ */ I.jsx(Xr, { visual: "smallMedium", color: "text.mid", children: e.label })
    ]
  },
  e.label
)) }), ri = $o.createContext({});
var P2 = Object.defineProperty, IE = Object.getOwnPropertySymbols, k2 = Object.prototype.hasOwnProperty, R2 = Object.prototype.propertyIsEnumerable, xE = (e, n, t) => n in e ? P2(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, av = (e, n) => {
  for (var t in n || (n = {}))
    k2.call(n, t) && xE(e, t, n[t]);
  if (IE)
    for (var t of IE(n))
      R2.call(n, t) && xE(e, t, n[t]);
  return e;
};
const O2 = (e, n) => {
  const t = yt.useContext(ri), r = av(av({}, t), e);
  return yt.createElement("svg", av({ width: "1.5em", height: "1.5em", viewBox: "0 0 24 24", strokeWidth: 1.5, fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: n }, r), yt.createElement("path", { d: "M17 8L12 3L7 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), yt.createElement("path", { d: "M17 16L12 21L7 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}, D2 = oe(O2);
var YT = D2, F2 = Object.defineProperty, TE = Object.getOwnPropertySymbols, N2 = Object.prototype.hasOwnProperty, M2 = Object.prototype.propertyIsEnumerable, PE = (e, n, t) => n in e ? F2(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, sv = (e, n) => {
  for (var t in n || (n = {}))
    N2.call(n, t) && PE(e, t, n[t]);
  if (TE)
    for (var t of TE(n))
      M2.call(n, t) && PE(e, t, n[t]);
  return e;
};
const L2 = (e, n) => {
  const t = yt.useContext(ri), r = sv(sv({}, t), e);
  return yt.createElement("svg", sv({ width: "1.5em", height: "1.5em", strokeWidth: 1.5, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: n }, r), yt.createElement("path", { d: "M7 12.5L10 15.5L17 8.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), yt.createElement("path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}, B2 = oe(L2);
var V2 = B2, j2 = Object.defineProperty, kE = Object.getOwnPropertySymbols, U2 = Object.prototype.hasOwnProperty, W2 = Object.prototype.propertyIsEnumerable, RE = (e, n, t) => n in e ? j2(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, lv = (e, n) => {
  for (var t in n || (n = {}))
    U2.call(n, t) && RE(e, t, n[t]);
  if (kE)
    for (var t of kE(n))
      W2.call(n, t) && RE(e, t, n[t]);
  return e;
};
const H2 = (e, n) => {
  const t = yt.useContext(ri), r = lv(lv({}, t), e);
  return yt.createElement("svg", lv({ width: "1.5em", height: "1.5em", strokeWidth: 1.5, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: n }, r), yt.createElement("path", { d: "M5 13L9 17L19 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}, G2 = oe(H2);
var Xh = G2, Y2 = Object.defineProperty, OE = Object.getOwnPropertySymbols, z2 = Object.prototype.hasOwnProperty, Z2 = Object.prototype.propertyIsEnumerable, DE = (e, n, t) => n in e ? Y2(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, cv = (e, n) => {
  for (var t in n || (n = {}))
    z2.call(n, t) && DE(e, t, n[t]);
  if (OE)
    for (var t of OE(n))
      Z2.call(n, t) && DE(e, t, n[t]);
  return e;
};
const K2 = (e, n) => {
  const t = yt.useContext(ri), r = cv(cv({}, t), e);
  return yt.createElement("svg", cv({ width: "1.5em", height: "1.5em", strokeWidth: 1.5, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: n }, r), yt.createElement("path", { d: "M7 13.161L12.4644 7.6966C12.8549 7.30607 13.4881 7.30607 13.8786 7.6966L15.9999 9.81792C16.3904 10.2084 16.3904 10.8416 15.9999 11.2321L14.0711 13.161M7 13.161L4.82764 15.3334C4.73428 15.4267 4.66034 15.5376 4.61007 15.6597L3.58204 18.1563C3.07438 19.3892 4.30728 20.6221 5.54018 20.1145L8.03681 19.0865C8.1589 19.0362 8.26981 18.9622 8.36317 18.8689L14.0711 13.161M7 13.161H14.0711", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), yt.createElement("path", { d: "M13.878 3.45401L15.9993 5.57533M20.242 9.81798L18.1206 7.69666M15.9993 5.57533L17.4135 4.16112C17.8041 3.7706 18.4372 3.7706 18.8277 4.16112L19.5349 4.86823C19.9254 5.25875 19.9254 5.89192 19.5349 6.28244L18.1206 7.69666M15.9993 5.57533L18.1206 7.69666", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}, X2 = oe(K2);
var J2 = X2, Q2 = Object.defineProperty, FE = Object.getOwnPropertySymbols, q2 = Object.prototype.hasOwnProperty, _2 = Object.prototype.propertyIsEnumerable, NE = (e, n, t) => n in e ? Q2(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, uv = (e, n) => {
  for (var t in n || (n = {}))
    q2.call(n, t) && NE(e, t, n[t]);
  if (FE)
    for (var t of FE(n))
      _2.call(n, t) && NE(e, t, n[t]);
  return e;
};
const $2 = (e, n) => {
  const t = yt.useContext(ri), r = uv(uv({}, t), e);
  return yt.createElement("svg", uv({ width: "1.5em", height: "1.5em", strokeWidth: 1.5, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: n }, r), yt.createElement("path", { d: "M6 9L12 15L18 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}, eG = oe($2);
var zT = eG, tG = Object.defineProperty, ME = Object.getOwnPropertySymbols, nG = Object.prototype.hasOwnProperty, rG = Object.prototype.propertyIsEnumerable, LE = (e, n, t) => n in e ? tG(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, dv = (e, n) => {
  for (var t in n || (n = {}))
    nG.call(n, t) && LE(e, t, n[t]);
  if (ME)
    for (var t of ME(n))
      rG.call(n, t) && LE(e, t, n[t]);
  return e;
};
const oG = (e, n) => {
  const t = yt.useContext(ri), r = dv(dv({}, t), e);
  return yt.createElement("svg", dv({ width: "1.5em", height: "1.5em", strokeWidth: 1.5, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: n }, r), yt.createElement("path", { d: "M15 6L9 12L15 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}, iG = oe(oG);
var Oy = iG, aG = Object.defineProperty, BE = Object.getOwnPropertySymbols, sG = Object.prototype.hasOwnProperty, lG = Object.prototype.propertyIsEnumerable, VE = (e, n, t) => n in e ? aG(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, fv = (e, n) => {
  for (var t in n || (n = {}))
    sG.call(n, t) && VE(e, t, n[t]);
  if (BE)
    for (var t of BE(n))
      lG.call(n, t) && VE(e, t, n[t]);
  return e;
};
const cG = (e, n) => {
  const t = yt.useContext(ri), r = fv(fv({}, t), e);
  return yt.createElement("svg", fv({ width: "1.5em", height: "1.5em", strokeWidth: 1.5, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: n }, r), yt.createElement("path", { d: "M9 6L15 12L9 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}, uG = oe(cG);
var Dy = uG, dG = Object.defineProperty, jE = Object.getOwnPropertySymbols, fG = Object.prototype.hasOwnProperty, gG = Object.prototype.propertyIsEnumerable, UE = (e, n, t) => n in e ? dG(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, gv = (e, n) => {
  for (var t in n || (n = {}))
    fG.call(n, t) && UE(e, t, n[t]);
  if (jE)
    for (var t of jE(n))
      gG.call(n, t) && UE(e, t, n[t]);
  return e;
};
const pG = (e, n) => {
  const t = yt.useContext(ri), r = gv(gv({}, t), e);
  return yt.createElement("svg", gv({ width: "1.5em", height: "1.5em", strokeWidth: 1.5, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: n }, r), yt.createElement("path", { d: "M6 15L12 9L18 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}, hG = oe(pG);
var mG = hG, vG = Object.defineProperty, WE = Object.getOwnPropertySymbols, bG = Object.prototype.hasOwnProperty, yG = Object.prototype.propertyIsEnumerable, HE = (e, n, t) => n in e ? vG(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, pv = (e, n) => {
  for (var t in n || (n = {}))
    bG.call(n, t) && HE(e, t, n[t]);
  if (WE)
    for (var t of WE(n))
      yG.call(n, t) && HE(e, t, n[t]);
  return e;
};
const CG = (e, n) => {
  const t = yt.useContext(ri), r = pv(pv({}, t), e);
  return yt.createElement("svg", pv({ width: "1.5em", height: "1.5em", viewBox: "0 0 24 24", strokeWidth: 1.5, fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: n }, r), yt.createElement("path", { d: "M8.5 4H6C4.89543 4 4 4.89543 4 6V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V6C20 4.89543 19.1046 4 18 4H15.5", stroke: "currentColor", strokeLinecap: "round" }), yt.createElement("path", { d: "M8 6.4V4.5C8 4.22386 8.22386 4 8.5 4C8.77614 4 9.00422 3.77604 9.05152 3.50398C9.19968 2.65171 9.77399 1 12 1C14.226 1 14.8003 2.65171 14.9485 3.50398C14.9958 3.77604 15.2239 4 15.5 4C15.7761 4 16 4.22386 16 4.5V6.4C16 6.73137 15.7314 7 15.4 7H8.6C8.26863 7 8 6.73137 8 6.4Z", stroke: "currentColor", strokeLinecap: "round" }));
}, EG = oe(CG);
var AG = EG, SG = Object.defineProperty, GE = Object.getOwnPropertySymbols, wG = Object.prototype.hasOwnProperty, IG = Object.prototype.propertyIsEnumerable, YE = (e, n, t) => n in e ? SG(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, hv = (e, n) => {
  for (var t in n || (n = {}))
    wG.call(n, t) && YE(e, t, n[t]);
  if (GE)
    for (var t of GE(n))
      IG.call(n, t) && YE(e, t, n[t]);
  return e;
};
const xG = (e, n) => {
  const t = yt.useContext(ri), r = hv(hv({}, t), e);
  return yt.createElement("svg", hv({ width: "1.5em", height: "1.5em", strokeWidth: 1.5, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: n }, r), yt.createElement("path", { d: "M21 3.6V20.4C21 20.7314 20.7314 21 20.4 21H3.6C3.26863 21 3 20.7314 3 20.4V3.6C3 3.26863 3.26863 3 3.6 3H20.4C20.7314 3 21 3.26863 21 3.6Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}, TG = oe(xG);
var PG = TG, kG = Object.defineProperty, zE = Object.getOwnPropertySymbols, RG = Object.prototype.hasOwnProperty, OG = Object.prototype.propertyIsEnumerable, ZE = (e, n, t) => n in e ? kG(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, mv = (e, n) => {
  for (var t in n || (n = {}))
    RG.call(n, t) && ZE(e, t, n[t]);
  if (zE)
    for (var t of zE(n))
      OG.call(n, t) && ZE(e, t, n[t]);
  return e;
};
const DG = (e, n) => {
  const t = yt.useContext(ri), r = mv(mv({}, t), e);
  return yt.createElement("svg", mv({ width: "1.5em", height: "1.5em", viewBox: "0 0 24 24", strokeWidth: 1.5, fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: n }, r), yt.createElement("path", { d: "M20 9L18.005 20.3463C17.8369 21.3026 17.0062 22 16.0353 22H7.96474C6.99379 22 6.1631 21.3026 5.99496 20.3463L4 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), yt.createElement("path", { d: "M21 6L15.375 6M3 6L8.625 6M8.625 6V4C8.625 2.89543 9.52043 2 10.625 2H13.375C14.4796 2 15.375 2.89543 15.375 4V6M8.625 6L15.375 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}, FG = oe(DG);
var NG = FG, MG = Object.defineProperty, KE = Object.getOwnPropertySymbols, LG = Object.prototype.hasOwnProperty, BG = Object.prototype.propertyIsEnumerable, XE = (e, n, t) => n in e ? MG(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, vv = (e, n) => {
  for (var t in n || (n = {}))
    LG.call(n, t) && XE(e, t, n[t]);
  if (KE)
    for (var t of KE(n))
      BG.call(n, t) && XE(e, t, n[t]);
  return e;
};
const VG = (e, n) => {
  const t = yt.useContext(ri), r = vv(vv({}, t), e);
  return yt.createElement("svg", vv({ width: "1.5em", height: "1.5em", strokeWidth: 1.5, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: n }, r), yt.createElement("path", { d: "M6.75827 17.2426L12.0009 12M17.2435 6.75736L12.0009 12M12.0009 12L6.75827 6.75736M12.0009 12L17.2435 17.2426", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
}, jG = oe(VG);
var Fy = jG, UG = Object.defineProperty, JE = Object.getOwnPropertySymbols, WG = Object.prototype.hasOwnProperty, HG = Object.prototype.propertyIsEnumerable, QE = (e, n, t) => n in e ? UG(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, bv = (e, n) => {
  for (var t in n || (n = {}))
    WG.call(n, t) && QE(e, t, n[t]);
  if (JE)
    for (var t of JE(n))
      HG.call(n, t) && QE(e, t, n[t]);
  return e;
};
const GG = (e, n) => {
  const t = yt.useContext(ri), r = bv(bv({}, t), e);
  return yt.createElement("svg", bv({ width: "1.5em", height: "1.5em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: n }, r), yt.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM7.53044 11.9697C7.23755 11.6768 6.76268 11.6768 6.46978 11.9697C6.17689 12.2626 6.17689 12.7374 6.46978 13.0303L9.46978 16.0303C9.76268 16.3232 10.2376 16.3232 10.5304 16.0303L17.5304 9.03033C17.8233 8.73744 17.8233 8.26256 17.5304 7.96967C17.2375 7.67678 16.7627 7.67678 16.4698 7.96967L10.0001 14.4393L7.53044 11.9697Z", fill: "currentColor" }));
}, YG = oe(GG);
var zG = YG, ZG = Object.defineProperty, qE = Object.getOwnPropertySymbols, KG = Object.prototype.hasOwnProperty, XG = Object.prototype.propertyIsEnumerable, _E = (e, n, t) => n in e ? ZG(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, yv = (e, n) => {
  for (var t in n || (n = {}))
    KG.call(n, t) && _E(e, t, n[t]);
  if (qE)
    for (var t of qE(n))
      XG.call(n, t) && _E(e, t, n[t]);
  return e;
};
const JG = (e, n) => {
  const t = yt.useContext(ri), r = yv(yv({}, t), e);
  return yt.createElement("svg", yv({ width: "1.5em", height: "1.5em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: n }, r), yt.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.6 2.25C2.85442 2.25 2.25 2.85441 2.25 3.6V20.4C2.25 21.1456 2.85441 21.75 3.6 21.75H20.4C21.1456 21.75 21.75 21.1456 21.75 20.4V3.6C21.75 2.85442 21.1456 2.25 20.4 2.25H3.6ZM17.5303 9.03033C17.8232 8.73744 17.8232 8.26256 17.5303 7.96967C17.2374 7.67678 16.7626 7.67678 16.4697 7.96967L10 14.4393L7.53033 11.9697C7.23744 11.6768 6.76256 11.6768 6.46967 11.9697C6.17678 12.2626 6.17678 12.7374 6.46967 13.0303L9.46967 16.0303C9.76256 16.3232 10.2374 16.3232 10.5303 16.0303L17.5303 9.03033Z", fill: "currentColor" }));
}, QG = oe(JG);
var qG = QG, _G = Object.defineProperty, $E = Object.getOwnPropertySymbols, $G = Object.prototype.hasOwnProperty, e4 = Object.prototype.propertyIsEnumerable, eA = (e, n, t) => n in e ? _G(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, Cv = (e, n) => {
  for (var t in n || (n = {}))
    $G.call(n, t) && eA(e, t, n[t]);
  if ($E)
    for (var t of $E(n))
      e4.call(n, t) && eA(e, t, n[t]);
  return e;
};
const t4 = (e, n) => {
  const t = yt.useContext(ri), r = Cv(Cv({}, t), e);
  return yt.createElement("svg", Cv({ width: "1.5em", height: "1.5em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: n }, r), yt.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.6 2.25C2.85442 2.25 2.25 2.85441 2.25 3.6V20.4C2.25 21.1456 2.85441 21.75 3.6 21.75H20.4C21.1456 21.75 21.75 21.1456 21.75 20.4V3.6C21.75 2.85442 21.1456 2.25 20.4 2.25H3.6ZM9 11.25C8.58579 11.25 8.25 11.5858 8.25 12C8.25 12.4142 8.58579 12.75 9 12.75H12H15C15.4142 12.75 15.75 12.4142 15.75 12C15.75 11.5858 15.4142 11.25 15 11.25H12H9Z", fill: "currentColor" }));
}, n4 = oe(t4);
var r4 = n4;
const tA = ({
  api: e,
  disablePastDates: n,
  lastCalendarDate: t,
  onJumpToToday: r,
  isMonthView: o = !1,
  displayJumpToToday: a = !1
}) => {
  const l = /* @__PURE__ */ new Date(), u = () => {
    e.selectToday(), e.setView("day"), r == null || r();
  };
  return /* @__PURE__ */ I.jsxs(MH, { children: [
    a && /* @__PURE__ */ I.jsx(ti, { size: "sm", visual: "outline", onClick: u, children: "Today" }),
    /* @__PURE__ */ I.jsx(LH, { asChild: !0, children: /* @__PURE__ */ I.jsx(ti, { size: "sm", visual: "outline", children: /* @__PURE__ */ I.jsx(DH, {}) }) }),
    /* @__PURE__ */ I.jsxs(Si, { gap: "100", children: [
      /* @__PURE__ */ I.jsx(OH, { asChild: !0, children: /* @__PURE__ */ I.jsx(
        ti,
        {
          size: "sm",
          visual: "outline",
          Icon: Oy,
          disabled: n ? o ? hE(e.focusedValueAsString, l) : kh(e.focusedValueAsString, l) : void 0
        }
      ) }),
      /* @__PURE__ */ I.jsx(RH, { asChild: !0, children: /* @__PURE__ */ I.jsx(
        ti,
        {
          size: "sm",
          visual: "outline",
          Icon: Dy,
          disabled: t ? o ? hE(e.focusedValueAsString, t) : kh(e.focusedValueAsString, t) : void 0
        }
      ) })
    ] })
  ] });
}, WY = ({
  value: e,
  unavailableDatesISO: n = [],
  checkOutOnlyDatesISO: t = [],
  highlightedRangeDatesISO: r = [],
  primaryRangeDatesISO: o = [],
  outlinedDatesISO: a = [],
  minNights: l,
  maxNights: u,
  lastCalendarDateISO: f,
  onClearDatesClick: p,
  selectionMode: y = "range",
  disablePastDates: A = !0,
  displayLegend: w,
  displayJumpToToday: F,
  onJumpToToday: j,
  ...N
}) => {
  const D = e && e.length > 0 ? Jl(e[0]) : void 0, k = e && e.length > 1 ? Jl(e[1]) : void 0, z = /* @__PURE__ */ new Date(), q = n.map(
    (Se) => Jl(Se)
  ), Ce = t.map(
    (Se) => Jl(Se)
  ), ee = r.map(
    (Se) => Jl(Se)
  ), Fe = o.map(
    (Se) => Jl(Se)
  ), Oe = a.map(
    (Se) => Jl(Se)
  ), He = f ? Jl(f) : void 0, Re = He ? qn(He) : void 0;
  return /* @__PURE__ */ I.jsxs(
    kH,
    {
      selectionMode: y,
      closeOnSelect: !1,
      open: !0,
      value: e,
      alignItems: "flex-start",
      ...N,
      children: [
        /* @__PURE__ */ I.jsx(lE, { view: "day", children: /* @__PURE__ */ I.jsx(EC, { children: (Se) => /* @__PURE__ */ I.jsxs(I.Fragment, { children: [
          /* @__PURE__ */ I.jsx(
            tA,
            {
              api: Se,
              disablePastDates: A,
              lastCalendarDate: Re,
              displayJumpToToday: F,
              onJumpToToday: j
            }
          ),
          /* @__PURE__ */ I.jsx(cE, { children: /* @__PURE__ */ I.jsxs(sE, { borderSpacing: "6px", borderCollapse: "separate", children: [
            /* @__PURE__ */ I.jsx(FH, { children: /* @__PURE__ */ I.jsx(ev, { children: Se.weekDays.map((we, ae) => /* @__PURE__ */ I.jsx(NH, { children: we.short.slice(0, -1) }, ae)) }) }),
            /* @__PURE__ */ I.jsx(aE, { children: Se.weeks.map((we, ae) => /* @__PURE__ */ I.jsx(ev, { children: we.map((ge, Ie) => y === "single" ? /* @__PURE__ */ I.jsx(
              S2,
              {
                day: ge,
                lastCalendarDateValue: He,
                highlightedRangeDates: ee,
                primaryRangeDates: Fe,
                outlinedDates: Oe,
                disablePastDates: A
              },
              Ie
            ) : /* @__PURE__ */ I.jsx(
              A2,
              {
                day: ge,
                startDateValue: D,
                endDateValue: k,
                unavailableDates: q,
                checkOutOnlyDates: Ce,
                minNights: l,
                maxNights: u,
                lastCalendarDateValue: He,
                disablePastDates: A
              },
              Ie
            )) }, ae)) })
          ] }) })
        ] }) }) }),
        /* @__PURE__ */ I.jsx(lE, { view: "month", children: /* @__PURE__ */ I.jsx(EC, { children: (Se) => /* @__PURE__ */ I.jsxs(I.Fragment, { children: [
          /* @__PURE__ */ I.jsx(
            tA,
            {
              api: Se,
              disablePastDates: A,
              lastCalendarDate: Re,
              displayJumpToToday: F,
              onJumpToToday: j,
              isMonthView: !0
            }
          ),
          /* @__PURE__ */ I.jsx(cE, { children: /* @__PURE__ */ I.jsx(sE, { borderSpacing: "6px", borderCollapse: "separate", children: /* @__PURE__ */ I.jsx(aE, { children: Se.getMonthsGrid({ columns: 4, format: "short" }).map((we, ae) => /* @__PURE__ */ I.jsx(ev, { children: we.map((ge, Ie) => {
            const Ye = new Date(
              Se.focusedValueAsDate.getFullYear(),
              ge.value - 1,
              1
            ), Ke = Wg(Ye, z) && !kh(Ye, z), ze = Re ? Of(Ye, Re) && !kh(Ye, Re) : !1;
            return /* @__PURE__ */ I.jsx(Py, { value: ge.value, children: /* @__PURE__ */ I.jsx(ky, { asChild: !0, children: /* @__PURE__ */ I.jsx(
              ti,
              {
                visual: "outline",
                w: "full",
                h: "full",
                disabled: A ? Ke || ze : void 0,
                children: ge.label
              }
            ) }) }, Ie);
          }) }, ae)) }) }) })
        ] }) }) }),
        w && y === "single" && /* @__PURE__ */ I.jsx(T2, {}),
        p && /* @__PURE__ */ I.jsx(
          wH,
          {
            size: "sm",
            onClick: p,
            disabled: y === "range" ? !e || e.length < 2 : void 0,
            children: "Clear dates"
          }
        )
      ]
    }
  );
}, o4 = It("div", {
  base: {
    display: "flex",
    flexDir: "column",
    rounded: 100,
    borderColor: "border.light",
    borderWidth: 1,
    overflow: "hidden",
    boxShadow: 50
  },
  variants: {
    size: {
      sm: { width: 280 },
      lg: { minWidth: 280, maxWidth: 360 }
    }
  }
}), i4 = It("div", {
  base: {
    position: "relative",
    width: "full",
    height: 220,
    overflow: "hidden",
    minWidth: 360
  }
}), a4 = It("div", {
  base: {
    flexGrow: 1,
    justifyContent: "space-between",
    display: "flex",
    flexDir: "column",
    gap: 300,
    p: 300
  }
}), s4 = It("div", {
  base: {
    display: "flex",
    justifyContent: "space-between",
    gap: 400
  }
}), l4 = ({ mainText: e, subText: n, ...t }) => /* @__PURE__ */ I.jsxs(ll, { display: "flex", flexDir: "column", gap: 50, ...t, children: [
  /* @__PURE__ */ I.jsx(Xr, { visual: "bodySemiBold", lineClamp: 2, "data-maintext": !0, children: e }),
  /* @__PURE__ */ I.jsx(
    Xr,
    {
      visual: "smallMedium",
      lineClamp: 2,
      color: "text.light",
      "data-subtext": !0,
      children: n
    }
  )
] }), HY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Body: a4,
  BodyContent: s4,
  Hero: i4,
  Surface: o4,
  Title: l4
}, Symbol.toStringTag, { value: "Module" })), c4 = It(dw, {
  base: {
    width: "full",
    top: "calc(50% - (token(spacing.100) * 2))",
    position: "absolute",
    paddingX: "250",
    zIndex: 1,
    display: "flex",
    transitionDuration: "normal",
    transitionProperty: "opacity",
    transitionTimingFunction: "ease-in-out",
    opacity: { base: 1, md: 0 },
    justifyContent: "space-between"
  }
}), u4 = It("img", {
  base: {
    objectFit: "cover",
    objectPosition: "center",
    width: "full"
  }
}), d4 = It("div", {
  base: {
    position: "absolute",
    bottom: "250",
    right: "250",
    zIndex: 1
  }
}), f4 = It(bw, {
  base: {
    overflow: "hidden",
    position: "relative",
    _hover: {
      "& > [data-scope='carousel'][data-part='control']": {
        opacity: { md: 1 }
      }
    }
  }
}), g4 = It(gw, {
  base: { height: "100%" }
}), p4 = It(yw, {
  base: { height: "100%" }
}), h4 = ({
  imageCount: e,
  ...n
}) => {
  const { index: t } = Nf();
  return /* @__PURE__ */ I.jsx(d4, { ...n, children: /* @__PURE__ */ I.jsxs(Ry, { visual: "primary", mode: "blur", children: [
    t + 1,
    " / ",
    e
  ] }) });
}, m4 = ({ tagClassName: e, images: n, ...t }) => {
  var a;
  const { className: r } = t, o = (a = r == null ? void 0 : r.match(/\bh_[^\s]+/g)) == null ? void 0 : a[0];
  return /* @__PURE__ */ I.jsxs(f4, { loop: !0, ...t, children: [
    /* @__PURE__ */ I.jsxs(c4, { children: [
      /* @__PURE__ */ I.jsx(hw, { asChild: !0, children: /* @__PURE__ */ I.jsx(ti, { visual: "outline", Icon: Oy, size: "md" }) }),
      /* @__PURE__ */ I.jsx(pw, { asChild: !0, children: /* @__PURE__ */ I.jsx(ti, { visual: "outline", Icon: Dy, size: "md" }) })
    ] }),
    /* @__PURE__ */ I.jsx(h4, { className: e, imageCount: n.length }),
    /* @__PURE__ */ I.jsx(p4, { children: /* @__PURE__ */ I.jsx(g4, { children: n.map((l, u) => {
      var f;
      return /* @__PURE__ */ I.jsx(fw, { index: u, children: /* @__PURE__ */ I.jsx(
        u4,
        {
          src: l.full_url,
          alt: (f = l.caption) == null ? void 0 : f.en,
          className: o ?? ni({ height: "full" })
        }
      ) }, l.full_url);
    }) }) })
  ] });
}, GY = It(m4), v4 = () => /* @__PURE__ */ I.jsx(xw, { copied: /* @__PURE__ */ I.jsx(fr, { Element: Xh }), children: /* @__PURE__ */ I.jsx(fr, { Element: AG }) }), YY = ({ disabled: e, ...n }) => /* @__PURE__ */ I.jsx(Tw, { ...n, children: /* @__PURE__ */ I.jsx(Iw, { children: /* @__PURE__ */ I.jsx(Pw, { asChild: !0, children: /* @__PURE__ */ I.jsx(
  ti,
  {
    visual: "outline",
    Icon: v4,
    type: "button",
    disabled: e
  }
) }) }) }), b4 = Ro({
  className: "fileUpload",
  slots: rw.keys(),
  base: {
    root: {
      userSelect: "none",
      display: "flex",
      flexDirection: "column",
      gap: "200",
      width: "100%",
      fontFamily: "body",
      position: "relative"
    },
    label: {
      color: "text.mid",
      fontSize: "md",
      lineHeight: "sm"
    },
    dropzone: {
      alignItems: "center",
      background: "bg.wa.light",
      borderRadius: "150",
      borderWidth: "1px",
      borderColor: "border.light",
      display: "flex",
      flexDirection: "column",
      gap: "150",
      justifyContent: "center",
      minHeight: "xs",
      px: "300",
      py: "200",
      transitionDuration: "normal",
      transitionProperty: "background, border",
      transitionTimingFunction: "default",
      _invalid: {
        bg: "error.lightest",
        borderColor: "border.error"
      },
      _hover: {
        background: {
          base: "bg.wa.lightest",
          _invalid: "bg.error.lightest"
        }
      }
    },
    item: {
      animation: "fadeIn 0.25s",
      background: "white",
      borderRadius: "100",
      borderWidth: "1px",
      borderColor: "border.light",
      columnGap: "3",
      display: "grid",
      gridTemplateColumns: "auto 1fr auto",
      gridTemplateAreas: `
        "preview name delete"
        "preview size delete"
        `,
      p: "200"
    },
    itemGroup: {
      display: "flex",
      flexDirection: "column",
      gap: "100"
    },
    itemName: {
      color: "text.dark",
      fontSize: "xs",
      lineHeight: "xs",
      gridArea: "name"
    },
    itemSizeText: {
      color: "text.mid",
      fontSize: "xs",
      lineHeight: "xs",
      gridArea: "size"
    },
    itemDeleteTrigger: {
      alignSelf: "center",
      gridArea: "delete",
      color: "icon.light",
      cursor: "pointer",
      transitionDuration: "normal",
      transitionProperty: "color",
      transitionTimingFunction: "default",
      _hover: {
        color: "icon.mid"
      }
    },
    itemPreview: {
      gridArea: "preview"
    },
    itemPreviewImage: {
      aspectRatio: "1",
      height: "10",
      width: "10",
      objectFit: "scale-down"
    }
  }
}), { withProvider: y4, withContext: ul } = vs(b4), C4 = y4(
  fx,
  "root"
), E4 = ul(tx, "dropzone"), A4 = ul(ox, "itemDeleteTrigger"), S4 = ul(ix, "itemGroup"), w4 = ul(ax, "itemName"), I4 = ul(lx, "itemPreviewImage"), x4 = ul(sx, "itemPreview"), T4 = ul(rx, "item"), P4 = ul(cx, "itemSizeText"), k4 = ul(ux, "label"), R4 = ul(gx, "trigger"), zY = ({
  label: e = "Drop your files here or",
  buttonLabel: n = "Upload files",
  maxFiles: t,
  ...r
}) => /* @__PURE__ */ I.jsxs(C4, { maxFiles: t, ...r, children: [
  /* @__PURE__ */ I.jsxs(E4, { children: [
    /* @__PURE__ */ I.jsx(k4, { children: e }),
    /* @__PURE__ */ I.jsx(R4, { asChild: !0, children: /* @__PURE__ */ I.jsx(ti, { visual: "outline", children: n }) }),
    /* @__PURE__ */ I.jsx(Xr, { visual: "smallMedium", color: "text.light", children: !!t && `Maximum ${t} file(s)` })
  ] }),
  /* @__PURE__ */ I.jsx(S4, { children: /* @__PURE__ */ I.jsx(zj, { children: ({ acceptedFiles: o }) => o.map((a, l) => /* @__PURE__ */ I.jsxs(T4, { file: a, children: [
    /* @__PURE__ */ I.jsx(x4, { type: "image/*", children: /* @__PURE__ */ I.jsx(I4, {}) }),
    /* @__PURE__ */ I.jsx(w4, {}),
    /* @__PURE__ */ I.jsx(P4, {}),
    /* @__PURE__ */ I.jsx(A4, { asChild: !0, children: /* @__PURE__ */ I.jsx(fr, { Element: NG, size: "sm" }) })
  ] }, l)) }) }),
  /* @__PURE__ */ I.jsx(nx, {})
] }), O4 = Ii({
  base: {
    appearance: "none",
    background: "none",
    borderColor: "border.light",
    borderRadius: 100,
    borderWidth: "1px",
    color: "text.dark",
    fontFamily: "body",
    fontSize: "md",
    lineHeight: "xs",
    outline: 0,
    position: "relative",
    transitionDuration: "normal",
    transitionProperty: "box-shadow, border-color",
    transitionTimingFunction: "default",
    width: "full",
    px: 150,
    py: 100,
    _disabled: {
      _placeholder: {
        color: "text.disabled"
      },
      borderColor: "border.disabled",
      color: "text.disabled",
      cursor: "not-allowed"
    },
    _focus: {
      borderColor: "border.dark",
      boxShadow: "0 0 0 1px token(colors.border.dark)"
    },
    _hover: {
      _enabled: {
        borderColor: "border.mid",
        boxShadow: "0 0 0 1px token(colors.border.mid)"
      },
      _focus: {
        borderColor: "border.dark",
        boxShadow: "0 0 0 1px token(colors.border.dark)"
      }
    },
    _invalid: {
      color: "text.error.dark",
      borderColor: "border.error",
      boxShadow: "0 0 0 1px token(colors.border.error)"
    }
  }
}), D4 = It(ve.input, O4), Ev = oe(
  ({ label: e, hint: n, ...t }, r) => /* @__PURE__ */ I.jsxs(
    Xr,
    {
      as: "label",
      visual: "smallMedium",
      color: "text.mid",
      w: "full",
      display: "block",
      children: [
        e,
        /* @__PURE__ */ I.jsx(D4, { ...t, my: 50, className: "peer", ref: r }),
        n && /* @__PURE__ */ I.jsx(
          Xr,
          {
            as: "span",
            _peerInvalid: { color: "text.error.dark" },
            color: "text.light",
            visual: "smallMedium",
            children: n
          }
        )
      ]
    }
  )
), F4 = Ii({
  base: {
    zIndex: "modal",
    position: "absolute",
    right: { base: "200", md: "400" },
    top: "200",
    p: "100",
    cursor: "pointer",
    transitionDuration: "normal",
    transitionProperty: "color",
    transitionTimingFunction: "default"
  },
  variants: {
    visual: {
      light: {
        color: "white",
        bg: "ink.800/70",
        backdropFilter: "blur(8px)",
        borderRadius: "full"
      },
      dark: {
        color: "text.dark",
        _hover: { color: "text.mid" }
      }
    }
  },
  defaultVariants: {
    visual: "light"
  }
}), N4 = It(
  _I,
  F4
), M4 = It(qI, {
  base: {
    zIndex: "modal",
    bg: "ink.800/70",
    width: "full",
    height: "full",
    position: "fixed",
    top: 0,
    _open: {
      animation: "fadeIn 200ms",
      animationTimingFunction: "entrance.productive"
    },
    _closed: {
      animation: "fadeOut 200ms",
      animationTimingFunction: "exit.productive"
    }
  }
}), L4 = Ii({
  base: {
    bg: "white",
    overflow: "hidden",
    position: "relative",
    _open: {
      animation: "bottomToOrigin 300ms",
      animationTimingFunction: "entrance.expressive"
    },
    _closed: {
      animation: "originToBottom 300ms",
      animationTimingFunction: "exit.expressive"
    },
    mdDown: {
      borderTopLeftRadius: "300",
      borderTopRightRadius: "300",
      mt: "300"
    }
  },
  variants: {
    placement: {
      leftPane: {
        md: {
          width: "modals.pane",
          boxShadow: "25px 0px 40px -15px rgba(10, 10, 10, 0.15)",
          _open: {
            animation: "leftToOrigin 300ms",
            animationTimingFunction: "entrance.expressive"
          },
          _closed: {
            animation: "originToLeft 300ms",
            animationTimingFunction: "exit.expressive"
          }
        }
      },
      rightPane: {
        md: {
          width: "modals.pane",
          boxShadow: "-25px 0px 40px -15px rgba(10, 10, 10, 0.15)",
          _open: {
            animation: "rightToOrigin 300ms",
            animationTimingFunction: "entrance.expressive"
          },
          _closed: {
            animation: "originToRight 300ms",
            animationTimingFunction: "exit.expressive"
          },
          justifySelf: "end"
        }
      },
      centerPane: {
        md: {
          minWidth: "modals.center",
          boxShadow: "0px 6px 12px 0px rgba(0, 0, 0, 0.08)",
          borderRadius: "300",
          _open: {
            animation: "fadeInBottomToOrigin 300ms",
            animationTimingFunction: "entrance.expressive"
          },
          _closed: {
            animation: "fadeOutOriginToBottom 300ms",
            animationTimingFunction: "exit.expressive"
          },
          justifySelf: "center",
          alignSelf: "center"
        }
      }
    }
  },
  defaultVariants: {
    placement: "rightPane"
  }
}), B4 = It($I, L4), V4 = It(ex, {
  base: {
    zIndex: "modal",
    position: "fixed",
    display: "grid",
    width: "100vw",
    height: "100vh",
    top: 0
  }
}), j4 = It("div", {
  base: { overflowY: "auto" },
  variants: {
    placement: {
      rightPane: {
        height: "100%"
      },
      leftPane: {
        height: "100%"
      },
      centerPane: {
        maxH: "90vh",
        height: "100%"
      },
      noMaxH: {
        height: "100%"
      }
    }
  },
  defaultVariants: {
    placement: "rightPane"
  }
}), U4 = It("div", {
  base: {
    position: "absolute",
    top: "200",
    left: "200",
    // Override tag padding
    "& > div": {
      px: "200",
      py: "100"
    },
    // Override tag font styles
    "& p": {
      fontSize: "md",
      lineHeight: "sm"
    },
    zIndex: "modal",
    _open: {
      animation: "fadeIn 200ms",
      animationTimingFunction: "entrance.expressive"
    }
  }
}), nA = ({
  placement: e,
  children: n,
  tagText: t,
  hideCloseTrigger: r,
  closeTriggerVisual: o,
  noMaxH: a = !1,
  ...l
}) => /* @__PURE__ */ I.jsxs(
  Gj,
  {
    lazyMount: !0,
    unmountOnExit: !0,
    preventScroll: !0,
    closeOnEscape: !1,
    closeOnInteractOutside: !1,
    ...l,
    children: [
      /* @__PURE__ */ I.jsx(M4, {}),
      /* @__PURE__ */ I.jsx(V4, { children: /* @__PURE__ */ I.jsxs(B4, { placement: e, children: [
        t && /* @__PURE__ */ I.jsx(
          U4,
          {
            "data-open": !!t,
            "data-state": t ? "open" : "closed",
            children: /* @__PURE__ */ I.jsx(Ry, { mode: "blur", children: t })
          }
        ),
        !r && /* @__PURE__ */ I.jsx(N4, { visual: o, children: /* @__PURE__ */ I.jsx(fr, { Element: Fy, size: "lg" }) }),
        /* @__PURE__ */ I.jsx(
          j4,
          {
            id: "trekker-scroll-container",
            placement: a ? "noMaxH" : e,
            children: n
          }
        )
      ] }) })
    ]
  }
), ZY = ({ portal: e, ...n }) => e ? /* @__PURE__ */ I.jsx(Lx, { children: /* @__PURE__ */ I.jsx(nA, { ...n }) }) : /* @__PURE__ */ I.jsx(nA, { ...n }), rA = {
  alignItems: "center",
  borderColor: "border.mid",
  color: "icon.dark",
  cursor: "pointer",
  display: "inline-flex",
  justifyContent: "center",
  transitionDuration: "normal",
  transitionProperty: "background, border-color, color, box-shadow",
  transitionTimingFunction: "default",
  _hover: {
    background: "bg.lightest"
  },
  _disabled: {
    color: "icon.disabled",
    cursor: "not-allowed",
    _hover: {
      background: "transparent",
      color: "icon.disabled"
    }
  }
}, oA = Ro({
  className: "numberInput",
  slots: iw.keys(),
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "75",
      fontFamily: "body"
    },
    control: {
      bg: "white",
      borderColor: "border.mid",
      borderRadius: "100",
      borderWidth: "1px",
      display: "grid",
      divideX: "1px",
      gridTemplateColumns: "1fr 32px",
      gridTemplateRows: "1fr 1fr",
      overflow: "hidden",
      transitionDuration: "normal",
      transitionProperty: "border-color, box-shadow",
      transitionTimingFunction: "default",
      lineHeight: "xs",
      fontWeight: "medium",
      _focusWithin: {
        borderColor: "border.dark",
        boxShadow: "0 0 0 1px token(colors.border.dark)"
      },
      _hover: {
        borderColor: "border.mid",
        boxShadow: "0 0 0 1px token(colors.border.mid)",
        _focusWithin: {
          borderColor: "border.dark",
          boxShadow: "0 0 0 1px token(colors.border.dark)"
        }
      },
      _disabled: {
        opacity: 0.4,
        _hover: {
          boxShadow: "0 0 0 0 transparent"
        }
      },
      _invalid: {
        color: "text.error.dark",
        borderColor: "border.error",
        boxShadow: "0 0 0 1px token(colors.border.error)"
      }
    },
    input: {
      background: "transparent",
      border: "none",
      gridRow: "2",
      outline: "none",
      width: "full"
    },
    label: {
      color: "text.mid",
      fontWeight: "medium",
      fontSize: "xs",
      lineHeight: "xs"
    },
    decrementTrigger: { ...rA, borderTopWidth: "1px" },
    incrementTrigger: rA
  },
  defaultVariants: {
    size: "md"
  },
  variants: {
    size: {
      sm: {
        control: {
          ps: "100",
          fontSize: "sm",
          h: "9"
        }
      },
      md: {
        control: {
          ps: "150",
          fontSize: "md",
          h: "10"
        }
      },
      lg: {
        control: {
          ps: "150",
          fontSize: "md",
          h: "11"
        }
      }
    }
  }
}), W4 = oe(
  (e, n) => {
    const [t, r] = oA.splitVariantProps(e), [o, a] = zh(r), { label: l, hint: u, className: f, ...p } = a, y = oA(t);
    return /* @__PURE__ */ I.jsxs(
      Rx,
      {
        ref: n,
        className: sc(y.root, ni(o), f),
        ...p,
        children: [
          l && /* @__PURE__ */ I.jsx(xx, { className: y.label, children: l }),
          /* @__PURE__ */ I.jsxs(Ax, { className: y.control + " peer", children: [
            /* @__PURE__ */ I.jsx(Ix, { className: y.input }),
            /* @__PURE__ */ I.jsx(wx, { className: y.incrementTrigger, children: /* @__PURE__ */ I.jsx(fr, { Element: mG, size: "sm" }) }),
            /* @__PURE__ */ I.jsx(Sx, { className: y.decrementTrigger, children: /* @__PURE__ */ I.jsx(fr, { Element: zT, size: "sm" }) })
          ] }),
          u && /* @__PURE__ */ I.jsx(
            Xr,
            {
              as: "span",
              color: "text.light",
              visual: "smallMedium",
              _peerInvalid: { color: "text.error.dark" },
              children: u
            }
          )
        ]
      }
    );
  }
);
W4.displayName = "NumberInput";
const H4 = Yb.keys(), G4 = H4.concat([
  "itemContent"
]), Y4 = Ro({
  slots: G4,
  base: {
    root: {
      display: "flex",
      flexDirection: {
        _vertical: "column",
        _horizontal: "row"
      },
      gap: {
        _vertical: 150,
        _horizontal: 200
      }
    },
    itemControl: {
      background: "transparent",
      borderColor: "border.light",
      borderRadius: "full",
      borderWidth: "1px",
      transitionDuration: "normal",
      transitionProperty: "all",
      transitionTimingFunction: "linear",
      width: "5",
      height: "5",
      display: "flex",
      alignSelf: "start",
      margin: 50,
      _hover: {
        borderColor: "border.mid"
      },
      _checked: {
        background: "white",
        borderColor: "bg.darkest",
        outlineColor: "bg.darkest",
        outlineStyle: "solid",
        outlineWidth: "5px",
        outlineOffset: "-5px",
        _hover: {
          background: "white",
          borderColor: "bg.darkest"
        }
      },
      _disabled: {
        opacity: 0.4,
        pointerEvents: "none"
      }
    },
    item: {
      alignItems: "center",
      cursor: "pointer",
      display: "flex",
      gap: 200,
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
      }
    },
    itemContent: {
      display: "flex",
      flexDir: "column",
      gap: 50
    },
    itemText: {
      fontFamily: "body",
      fontWeight: "medium",
      fontSize: "md",
      lineHeight: "sm",
      color: "text.dark",
      "&[data-helper=true]": {
        color: "text.light",
        fontWeight: "normal"
      }
    }
  }
}), { withProvider: z4, withContext: Jh } = vs(Y4), Z4 = z4(
  Zx,
  "root"
), K4 = Jh(jx, "itemControl"), X4 = Jh(Vx, "item"), iA = Jh(Wx, "itemText"), J4 = Jh(
  It("div"),
  "itemContent"
), KY = ({ children: e, helperText: n, ...t }) => /* @__PURE__ */ I.jsxs(X4, { ...t, value: t.value, children: [
  /* @__PURE__ */ I.jsx(K4, {}),
  /* @__PURE__ */ I.jsxs(J4, { children: [
    /* @__PURE__ */ I.jsx(iA, { children: e }),
    n && /* @__PURE__ */ I.jsx(iA, { "data-helper": !0, children: n })
  ] }),
  /* @__PURE__ */ I.jsx(Ux, {})
] }), XY = ({ children: e, ...n }) => /* @__PURE__ */ I.jsx(Z4, { ...n, children: e }), Q4 = It("hr", {
  base: {
    border: "none",
    bgColor: "border.dark",
    height: "2px",
    borderRadius: 100
  }
}), JY = ({
  text: e,
  divider: n = !1,
  Icon: t,
  children: r
}) => /* @__PURE__ */ I.jsxs(Si, { width: "full", flexDir: "column", gap: 200, children: [
  /* @__PURE__ */ I.jsxs(Si, { justifyContent: "space-between", children: [
    /* @__PURE__ */ I.jsxs(Si, { gap: 150, alignItems: "center", children: [
      t && /* @__PURE__ */ I.jsx(fr, { Element: t }),
      /* @__PURE__ */ I.jsx(Xr, { visual: "bodySemiBold", children: e })
    ] }),
    r
  ] }),
  n && /* @__PURE__ */ I.jsx(Q4, {})
] }), q4 = Ii({
  base: {
    fontFamily: "heading",
    fontWeight: "semiBold",
    letterSpacing: "tightest"
  },
  variants: {
    size: {
      h1: { fontSize: "5xl", lineHeight: "4xl" },
      h2: { fontSize: "4xl", lineHeight: "3xl" },
      h3: { fontSize: "3xl", lineHeight: "2xl" },
      h4: { fontSize: "2xl", lineHeight: "xl" },
      h5: { fontSize: "lg", lineHeight: "sm", letterSpacing: "normal" }
    }
  },
  defaultVariants: {
    size: "h2"
  }
}), _4 = ({ size: e = "h2", ...n }) => {
  const t = It(e, q4);
  return /* @__PURE__ */ I.jsx(t, { size: e, ...n });
}, $4 = It(_4), e7 = It("hr", {
  base: {
    width: "full",
    color: "border.light"
  }
}), t7 = ni({
  color: "icon.light",
  "&[data-state=true]": { color: "icon.success.mid" }
}), QY = ({
  checked: e = !1,
  children: n,
  rightElement: t
}) => /* @__PURE__ */ I.jsxs(Si, { width: "full", gap: 200, alignItems: "center", children: [
  /* @__PURE__ */ I.jsxs(Si, { gap: 100, alignItems: "center", shrink: 0, children: [
    /* @__PURE__ */ I.jsx(
      fr,
      {
        "data-state": e,
        size: "lg",
        Element: e ? zG : V2,
        className: t7
      }
    ),
    /* @__PURE__ */ I.jsx($4, { size: "h5", color: e ? "text.dark" : "text.mid", children: n })
  ] }),
  /* @__PURE__ */ I.jsx(e7, {}),
  t && /* @__PURE__ */ I.jsx(ll, { w: "max", children: t })
] }), n7 = '@font-face{font-family:IBM Plex Mono;font-style:normal;font-display:swap;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,d09GRgABAAAAABZ4AA4AAAAAJEgAAQABAAAAAAAAAAAAAAAAAAAAAAAAAABHREVGAAABRAAAABYAAAAWABEABEdQT1MAAAFcAAAAHgAAAB5EdEx1R1NVQgAAAXwAAAAtAAAALiN2JIJPUy8yAAABrAAAAFgAAABgazzoamNtYXAAAAIEAAAA1wAAATBKyGioZ2FzcAAAAtwAAAAQAAAAEAAYACFnbHlmAAAC7AAAD1oAABmgMEjnr2hlYWQAABJIAAAANgAAADYdb2VjaGhlYQAAEoAAAAAfAAAAJAWIAENobXR4AAASoAAAAIwAAADUD7cMxGxvY2EAABMsAAAA1AAAANR6iIAabWF4cAAAFAAAAAAcAAAAIACdAmNuYW1lAAAUHAAAANIAAAG6IgA/BnBvc3QAABTwAAABhwAAA9Ns6MOMAAEAAAAMAAAAAAAAAAIAAQABAAMAAQAAAAEAAAAKABwAHAABREZMVAAIAAQAAAAA//8AAAAAAAB42mNgZGBg4GLQAUJmFzefEAaJ5MqiHAaRnMSSPAYRBhBgARH//4NIAJZPBzwAAAB42i2FMQ5AQBQF5327iY3SBfYSOpVORL+VcB2VzkVUKhdyBbEJk8kMzpI2PNhqCRi+a6JVUwarfPBWkMVEDj99N0ZdLPFwem5wUj2jnYw5O/MixQvwUgrxeNosigEGgEAUBXdrjhAg7NXqCHWTAIggKIpKEKQLBCAiAoKAKLB9yTNvYJRSjuAKnrz+jPbFRoY4JCYlp6SmZWBiYePg4jGdtVIERCRkFFQ09IzMrOyc3H/xCie4DygIHowcAAAAgKX3a7xt1bZtY4CeOkEn6MxN5gJu3XuUUFJR0zAys3dwdAIBF4b+FNwqulP1pO5F24eOT11fer71/RgLmotaiFlJWEvaSmuoePQq51rWlbwbJfd2Msoe1Dxredf0ZuDXyL+JkKmwmYiluI3UGWx9MPYAAAEAAwAIAAoAEAAF//8AD3jalVkHWNtYttaVbKpjkG3ZBoybjAtgYyw3wBiDaYZABBElxOlh0uvb6b1umT7be9+d3ivzSto3vW7vvSTbszt9xuKdeyUMzDDZ2ZnPUnSie85/zv3vKQpFU06KopOMjmKoUooSWBfb4GJdTtoqe9BX5M2M7p1XUvQn4L2e+VdoL11NuagWinK5vT5ej3i3NxaNd6BY1Mu7S0p9aUaImDlW4BoiaboTgawemczo7y1+rZYd7hrbvOvs/ZmOaI8pXuGOZHzr9wzKP3UIXm7/YE9b2BMUpNzgqNDWFuD9Jm89mx+Xf9efqKrhTRN+L+cPUIAiNf8KehNQVFNuimrgSxQEQsQixASW9xGz0RC9YPk2TWTfpj17Nu2LaETxqrqwh+M84br+kRFp8w2XXXbDZqnwToe+zlc7V+ur00/0T/dPgI1N4KmN/p1iwyiwQhx7ZQJbPp7jE5F4J8L+6mkwYac3iUtsfA9U96tm6N/Jz6lWOojqoiGwkQUbHPhRTzVSlNYdomPRNC1E7KDTxYFWIRJPWPSIIVZcMXAJxZLrutx8eioWnUg55SvMgQ5PdLWpw7Jn3JUMWJCfa4jpvAPbOtPbB7zebD7htbrbGy3hRn80i35ibWxzl1a6kwEzRSFqK1zeAQ+tin/qtvGs4hb8aauoKbPyYefYVjGdsoY8ZhF7Y+Rrq3dslB9CnQN9Oqu3Rv6cygszeGKkXMs94Ux62qcGS92O5vhUp9PZORVfuGfHx7Pww7jTnRj3wPbO9LYBb58oDUkiuWC8sfkkzdMaioUHAemZJhQTEozgQEICfVecp8rN9sb61ee1vzQ+NaIZoTWFa80urrL3BvTWj06cAIwOoE47PQcMrwTu+vhS3igYEc8I6Ncdr3ZM/eDAD+TXyrc+/+ST9Fyhn94i3wM2Z2BNGaypJKeCW/h/Bt0tfwuNyvejGXou9+fcKzl4V4J3Ncq7hIcxF8fDKZDuvhvde/fdWTqazRaey2L+JiFaTvoJiFZgpWgV6auSCzVn8imbLZXPLNwb270s621vVO+61vw1kxMfzre25j88MXlNvjXnSk3EDkcnUy5XajJ6ODaRcuEIsmB8QEHoYknkupDAsIg+vXn7hGZq+8bTyIBuffjLX35Ynpb/hlfUAdJOQNq2gDOe4CHqMVfMlV488EjBXlIqcHwpDpAecSazyl4UbhmO2irLNt58k/xLdKCsNJ30DjhiTTviTQMRW1nJlk/chDzyzZW6nlRgpFEIHNTZWrP+Ol919xTTraszxBN2vjXktwbTPrNjFRZWeSztGb5JCLdCvqoAhP3AvBiVpVZTlGWlZGQRMEQzOVUAK00DLoZXspdvWZLCNwHWXt82tH6qq8nrbdLHyuoaWu3BNMuYun2joiy3thgdFrakvazOJziEIY7RZ11Wj1UXTXQ6UWsociSiWz00uiaWjTXzLpPXbvB7m/hzz47XDMxU1TjZOkvQY07FOxJptr6Bk/yhqkAIfaNv0O0e7Ht3TkD4zC+LsR4eQwDYQtIDhu5CRxezwEhiBqeH6ShOD5OQDJw4Lcg/QubFPLAsPQzgbEDyAtg2AT/CwI8qYCbVgA8IUJgTlF8lEliU/ExSegGN3vqFL9z6hmPHNU8/Tc/1ne57q4++RL4JHVzK7WJOA4Qxlc1LqOJTsHNFeqMbWV8mxDUHPPp+yznrs5tSdWdf1tjRYJCfMjR0EIabXdHJtKuiPh50Ta2PbLhauvN/CdErKgjBEWUnJ1xDORX0iXgi5m1BAi4LnJAQSvWolDM7EI8zOCqd7hbbqv1efWJ11/TQdGY4WWYxNemTY5npoVOnnk2UaMoj//Nj+O9/am1aTUni2VOn8InohNrzCl2teOf1JexIUNIbTkeRTlQ8E0q5KOXsCG7IIu5ydVhH2wYzQvjay7cmelM5S5LfPrZjNhKMxv9LFw2HvYGQR+8LZHM6V8Dv8QrJoe5wslJT1tU6PIUtb4LLm+DdKpKvSwUkQLJO8IjfJJZpEDMMV7kwTGvkN69C1xbeQaVXyWfjdSJc/gTrTBAVpVx3IkE5n51YB/qc1jaQkKbEeGdqWBT/6nCsER++JxxyOF8ovAMnLA5RdcP6CtBAagWnuNaEEguec1hPXJwazc+sufULQUEIrkarRZHWPD49MjrZ6/E3+vmj6AioAzw06JsElvnggWd4Y5pJxELIxwi4CrFwZfA+2RmLEf4W4DF9Z01KZdWssZJz6obGZ/rG+9aPDa+yc5UmQ1XZ2qnZvnGUlo+hcqvTWEFrte4mxMjPoSj5yc1urZauMDms8uv4LbDvB4aWA0OD6g6a/90GMvjYoZrJs72dQ7v7xvuHtuY/nO1pH7J2eXaN7j+wus0R91td6XW6/lhktqeTE7pzh7lwe6MnEEtul3JryrUas7/DFxpJ2Ml+KDXlvfsoSnotqsdX+bciPSd/5Rm6sdCPNj9T+AFe1wzrIrAOsngCFz6jRUjgYEEhvHYn/6eZawO094LJ31VaHQFbKjdDW+RHDx5AucK37F6uFNan8PGE9VYcdz1S8oiw0GewmAl3ausGGtOTUYukdyX8wW6nJCFjpc6e3tD1xBPhbMCo06ENhX4KWBEGbX7QVmQF+x5WsNiz8Hj/xtnZjZ/5TKS9PdKPpPFx8Ozk3tnZvblYW7QtJv+DPgQa5+fV3vJ7tBewUlQJtfUfFFWUM1RRvl2Vq5mfLqH01EJ8KpXzgYsUlF8XyV38Z/ftQ4flXxw9Kv4y/cfer6d/id/eD91EmZIrtFAeig0Kz5KcpxYM2PgmhLJSlYEcDtT/mnJWzP6EO3SVIRPc0htzOD9Fa3p/7XBMbD23ta+ZA2xKFieYNQpmmmBWMhTx0aD4SC2RM1RRvh2uGKV5/kP0BKD0QMUmaSt2hrwGztJVIUhfK2e2hnj/qVMrZbYPvwQISF4jyIwKsn8SBCD/EMl3cFosIfQB8x3c+H91T9e/f8bbPJ2r0EaazpD0eqWyK4qn5Xe4Z0ksNlUu8cEH0aMPPigP9tL53t7CN3ohikqGJD6YFB8KcCvKjxblWwqKb9sguhaIbg1EN4RaEI91FyNqRySk6AWLm922XxT3X7v2ErbWYLJVSZkcY6u/8ySt+dGPTtRyWg3D1d7yEtY4BWiDCqsSqrbYezS6vcTUz+OiGE/7r157HtGqX9PeXuszrfenT2LF55zzo+N1qupem+fWsymEY0AnQHstnDf+ffV+9VN/2Hz52rOr7AaTQz8MSv1mabOIjvT+6EfHai2g0Vp7Y6+98Ssncc8KEcAVswo0EqyAGDgWAzWSeFqcyOVPi9hLOfPSdSdPgoekGmTIKSMryH6Q9+PiQ0j7kPgQeb9Xzpw8qZ5dM9mRkkW+U8ySecFG8StPDKRZM7pLOFfUu9LMIP8ATw2occW5oaREEtEtoiSJVBEFzhStFKV6rQHr2HIIKYbNltIQKrbcau8KNEa1m3Y4U5OJ4Y3mjL47zCe8RqM36Yn2mtpMa9K5Ct1NB7Htnpjb32xpbHdPK32WL5QB+oJtMrUQ7pUq3IProvx7RfnWpXKmoijfpmaCDMittIb07sXWHeBpTowNiRpxaM0JCPwzv/rVM4V3nlLPLd0F73M4cwAvqhBv9KnrSi2Y16+1T3Vo2qT8kcc3j6Y1qZH8/9w0kTt/fPx8VCLvm5zcVzgOeUHpHghOblleGFaZY8X6Yyv0FdjE6bzW1p9UWwtg09LeAii1tDuxKt0JRDzmJnosQPA0WuhQDKGa9N3ixnRjVBT/wtlK8pNffvieae1NN2ntdbhNAaSkTyFIzcsiqs65sPtaqpibCRuqyLOD5N5LYF0ZWXcWXBfltxflO1W52iXD+moSCQGe69V6zqpFh8WH4lPow/LzTzwhbUM3ocbcrzPyvUjM4BXT83naBivckFNJ7VG7fFhF1itdcj3C1fSfX7fYFoox1kcq9ETMsk66eL1hsHtaqcryyzCHvqFU6unz9gJKMrkS9OUKeq2CnnRfxFtL0duinLxvWfSWQvNvzO+mLwKsTXifGeLYGXo2pQi1Zmaz49nlXRsIlnRtqeFh0rN9gL7tyC8BHenZCGqrgvo0QQfy3aSXC5Hq9MF6Objxrwxsd52hmdu9caSirKflTN3cxP7K6yBuytRP2FBB4kjqFUFasyy+inxPUT6rnutB8KCFniM1iCRwll+MaLEG/cYVZPdeKEkXfmLd1azdYLYbZsZGPN5X5GP0HInXX/g6Rqt1BJ75pdrpdSj8Mqr64DAt26VitXgqKUnJnpYb1l1a5TRUGqqqyye6u+wh9qyWHpRW1H/uc2Dgry47o6XLDTbzUzne98rnFjr5KbCj1KP3oFbd+dpXXpn9yLrz2XrOXM+Od3fVtxg2zUr0oRwBftpTrwXg/mdzDcG/kP5chIikyRQKjGNV/KyaUMbflqS3peER1CkfV1wv3Ej6uVbAMlTsqvHHGmUt3yo9jKoelx6WlNdzhRvxWtgRMqmSnapc3CmKWfJ1xkkFV6pNxcmVKU623MrfaORnWG/7IRRf+Faz8oeamho8v6Jc9cIHG8wXFQXwai3hST9EpRZQNag1K47xQM1iSNe6+FkDlyzbvl0XXxbuj7hXDZZbXUHn2rGxtc6gy1o+qKtvTHpHyvWPfPWeudrmhM1lCTgMl+w6vOsSgyNgcdW2Buq114N1MmsQttYusrUov6QoP2uZ/MGifIcqV784gRc64oUJvNhAzy2rSsVqZsS5ozou5TWbpvK/++GmsSnNpJT/0f1jI9d/5jPXo+1o8sPXX/9h+Q75d78E3co8Q7DUKVj+pZyomMofG+HPipOOQiWttTfYKZFhJ+YLp+uBVitMO0AvpNhSdDaEGKXOKQUKqyNWcOCp+HCLSWrt6nFEaiRJywn1PQUGJsPUE09MjpXeeitdWYHnJ2Qs09HXgg/KFEV8sBXjSSoEyKFCqJNVsSDwsWKlmJbUSlCc1TDB/7ocvvz1ZUxiie6v0BejR+mjFAO6odx8BVnlk/TRXnDwU/RudIz+HrUKR9SI6zmmmRkXImHZ04uO2loH/D6v3undtSa9qfZdF9D4AD2E/spUKP+uYPQlHJCjLb8NT/TF4UcPmW93fRl+GNXV9Fr0XYbCGBFOHAkLmTS6kAVaXNQsZKy2QX+lU6dzVvoHbdYMvTYYbrPs1tC0ZrelLRwknjE+9CizZ5lnzB7iGWNCx5hL/nPPGNP7evYKePbg+3j2yjLPCuDZ7R/cs8K7PPt/rptXPwAAAAEAAAACAMRSDb9PXw889QAJA+gAAAAA3TwD/wAAAADfkRy5/vz+ogKIBF8AAAAJAAIAAAAAAAB42mNgZGBgYfz3loGBKeLfn39/mDqAIqiAEQCllQbMAHjaHMwBp8JQAEDhzwX0QMyDx/YAYShZhhu5IxFcjCYYBUC/P6Dm+gCOEyb/kmg2eEg6jbtRb+3PyqDSqx3NsoNgI2tFW0my0noZ1Gq/jotsNnu6+TE6SMWoK06luJbXw6DRqOxN7oLwedssRnlxEQXZTl+ctcVaJepEW5PedwsYpjFsZmiF0QCDUxx9AAAAFABXAIkAuwD6ASABUgFyAYwBogG3AfMCDAJdAsUDAwMlA2MDlQPSA+4EDgQ2BHYEtgTSBPIFGQVCBU4FWgViBXkFqAW0BcAFzAYBBg0GTQZjBm8GewakBtMG/AcVBywHOAdvB3cHrQe5B8UH0QfpCA0IGQg9CGIIbgh2CH4IigiWCJ4ItwjpCPUJAQkNCVAJXAmdCaUJsQm9CecKGwpGCmEKegqGCskK0QsICxQLIAssCzQLWgtmC5ALvAvIC+4L9gwDDCwMQQxjDHAMmQyuDNB42mNgZGBgyGT8waDFkMnABuYhADMDIwAwlAICeNqNkDVWA1AQRS/udGj1G9zdGtzdocLi7slWWBYrYB1UvGJwSb7eOeMD1OKlgrLKOuCaF+MyOnk2LqeZJ+MKZnk0rqSfuHEVrVwbV9PNpHGzCPyktePMM6Kd4p4kAeKkxcOkxGH9MZL4GOGAdXbZYpk9DgnjIS+KEdUd4hgPPjKEuSXJOR6SKALS4xhnmAnzde/e7t3fffU3+wXMQ1Ra3i/SP/lWdOMUUL/40BxQjYwyxozI/JAVSeIMi5cIazvePUghCY9+j/4sHh4YfgWUE0EnAAB42lzD00EFABSA4fNl27Zt3GzbLdB7a4QRWitvEp7vj0iJiIj4vY9ERIhk7v5flRJrsRk7cRy30RZd0RcjkZAaL9LiWboMmbJky5ErT74ChYoUK1GqTLkKlapUq1GrTr0GjZo0a9GqTbsOnbp069GrT78Bg4YMGzFqzLgJk6ZMmzErYc68BYuWLFuxas26DZu2bNuxa8++A4eOHDtxGm/xGN/OnLtw6SrzT4l6iTklBobspXmZABrm4EhiEIgBYEoA2MDTGJN/SFe3NK8ujaaUwij/hnT1n7GtnyXfrGzbUjm28Walv5RZ6X9mRl7bninPyrl9k/7cl9z18nfx7A3aeSIzz7/dmuWuH7L9FZn17kNel1zZ3Tnszc7EwLLtifK8+W7fqD/3T256e1/h2Xto5wlMPP92a5Kb/pG/7QpMevchryLfbO4c9mb7G1dSUWpZql5yZVEOd25iclF+nl5yYnEqb0pmalFqcWYxmCeYUZqXnlhUmpuTWFoCFuFHaIsH8QEWZ+fYAA==) format("woff");unicode-range:U+0460-052F,U+1C80-1C88,U+20B4,U+2DE0-2DFF,U+A640-A69F,U+FE2E-FE2F}@font-face{font-family:IBM Plex Mono;font-style:normal;font-display:swap;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff");unicode-range:U+0301,U+0400-045F,U+0490-0491,U+04B0-04B1,U+2116}@font-face{font-family:IBM Plex Mono;font-style:normal;font-display:swap;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff");unicode-range:U+0102-0103,U+0110-0111,U+0128-0129,U+0168-0169,U+01A0-01A1,U+01AF-01B0,U+0300-0301,U+0303-0304,U+0308-0309,U+0323,U+0329,U+1EA0-1EF9,U+20AB}@font-face{font-family:IBM Plex Mono;font-style:normal;font-display:swap;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff");unicode-range:U+0100-02AF,U+0304,U+0308,U+0329,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:IBM Plex Mono;font-style:normal;font-display:swap;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}', r7 = '@font-face{font-family:Figtree Variable;font-style:normal;font-display:swap;font-weight:300 900;src:url(data:font/woff2;base64,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) format("woff2-variations");unicode-range:U+0100-02AF,U+0304,U+0308,U+0329,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:Figtree Variable;font-style:normal;font-display:swap;font-weight:300 900;src:url(data:font/woff2;base64,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) format("woff2-variations");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}';
var ld = {};
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aA;
function o7() {
  if (aA)
    return ld;
  aA = 1;
  var e = $o;
  function n(v) {
    for (var P = "https://reactjs.org/docs/error-decoder.html?invariant=" + v, V = 1; V < arguments.length; V++)
      P += "&args[]=" + encodeURIComponent(arguments[V]);
    return "Minified React error #" + v + "; visit " + P + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var t = Object.prototype.hasOwnProperty, r = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, o = {}, a = {};
  function l(v) {
    return t.call(a, v) ? !0 : t.call(o, v) ? !1 : r.test(v) ? a[v] = !0 : (o[v] = !0, !1);
  }
  function u(v, P, V, H, le, ne, ye) {
    this.acceptsBooleans = P === 2 || P === 3 || P === 4, this.attributeName = H, this.attributeNamespace = le, this.mustUseProperty = V, this.propertyName = v, this.type = P, this.sanitizeURL = ne, this.removeEmptyString = ye;
  }
  var f = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(v) {
    f[v] = new u(v, 0, !1, v, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(v) {
    var P = v[0];
    f[P] = new u(P, 1, !1, v[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(v) {
    f[v] = new u(v, 2, !1, v.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(v) {
    f[v] = new u(v, 2, !1, v, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(v) {
    f[v] = new u(v, 3, !1, v.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(v) {
    f[v] = new u(v, 3, !0, v, null, !1, !1);
  }), ["capture", "download"].forEach(function(v) {
    f[v] = new u(v, 4, !1, v, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(v) {
    f[v] = new u(v, 6, !1, v, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(v) {
    f[v] = new u(v, 5, !1, v.toLowerCase(), null, !1, !1);
  });
  var p = /[\-:]([a-z])/g;
  function y(v) {
    return v[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(v) {
    var P = v.replace(
      p,
      y
    );
    f[P] = new u(P, 1, !1, v, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(v) {
    var P = v.replace(p, y);
    f[P] = new u(P, 1, !1, v, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(v) {
    var P = v.replace(p, y);
    f[P] = new u(P, 1, !1, v, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(v) {
    f[v] = new u(v, 1, !1, v.toLowerCase(), null, !1, !1);
  }), f.xlinkHref = new u("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(v) {
    f[v] = new u(v, 1, !1, v.toLowerCase(), null, !0, !0);
  });
  var A = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, w = ["Webkit", "ms", "Moz", "O"];
  Object.keys(A).forEach(function(v) {
    w.forEach(function(P) {
      P = P + v.charAt(0).toUpperCase() + v.substring(1), A[P] = A[v];
    });
  });
  var F = /["'&<>]/;
  function j(v) {
    if (typeof v == "boolean" || typeof v == "number")
      return "" + v;
    v = "" + v;
    var P = F.exec(v);
    if (P) {
      var V = "", H, le = 0;
      for (H = P.index; H < v.length; H++) {
        switch (v.charCodeAt(H)) {
          case 34:
            P = "&quot;";
            break;
          case 38:
            P = "&amp;";
            break;
          case 39:
            P = "&#x27;";
            break;
          case 60:
            P = "&lt;";
            break;
          case 62:
            P = "&gt;";
            break;
          default:
            continue;
        }
        le !== H && (V += v.substring(le, H)), le = H + 1, V += P;
      }
      v = le !== H ? V + v.substring(le, H) : V;
    }
    return v;
  }
  var N = /([A-Z])/g, D = /^ms-/, k = Array.isArray;
  function z(v, P) {
    return { insertionMode: v, selectedValue: P };
  }
  function q(v, P, V) {
    switch (P) {
      case "select":
        return z(1, V.value != null ? V.value : V.defaultValue);
      case "svg":
        return z(2, null);
      case "math":
        return z(3, null);
      case "foreignObject":
        return z(1, null);
      case "table":
        return z(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return z(5, null);
      case "colgroup":
        return z(7, null);
      case "tr":
        return z(6, null);
    }
    return 4 <= v.insertionMode || v.insertionMode === 0 ? z(1, null) : v;
  }
  var Ce = /* @__PURE__ */ new Map();
  function ee(v, P, V) {
    if (typeof V != "object")
      throw Error(n(62));
    P = !0;
    for (var H in V)
      if (t.call(V, H)) {
        var le = V[H];
        if (le != null && typeof le != "boolean" && le !== "") {
          if (H.indexOf("--") === 0) {
            var ne = j(H);
            le = j(("" + le).trim());
          } else {
            ne = H;
            var ye = Ce.get(ne);
            ye !== void 0 || (ye = j(ne.replace(N, "-$1").toLowerCase().replace(D, "-ms-")), Ce.set(ne, ye)), ne = ye, le = typeof le == "number" ? le === 0 || t.call(A, H) ? "" + le : le + "px" : j(("" + le).trim());
          }
          P ? (P = !1, v.push(' style="', ne, ":", le)) : v.push(";", ne, ":", le);
        }
      }
    P || v.push('"');
  }
  function Fe(v, P, V, H) {
    switch (V) {
      case "style":
        ee(v, P, H);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < V.length) || V[0] !== "o" && V[0] !== "O" || V[1] !== "n" && V[1] !== "N") {
      if (P = f.hasOwnProperty(V) ? f[V] : null, P !== null) {
        switch (typeof H) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!P.acceptsBooleans)
              return;
        }
        switch (V = P.attributeName, P.type) {
          case 3:
            H && v.push(" ", V, '=""');
            break;
          case 4:
            H === !0 ? v.push(" ", V, '=""') : H !== !1 && v.push(" ", V, '="', j(H), '"');
            break;
          case 5:
            isNaN(H) || v.push(" ", V, '="', j(H), '"');
            break;
          case 6:
            !isNaN(H) && 1 <= H && v.push(" ", V, '="', j(H), '"');
            break;
          default:
            P.sanitizeURL && (H = "" + H), v.push(" ", V, '="', j(H), '"');
        }
      } else if (l(V)) {
        switch (typeof H) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (P = V.toLowerCase().slice(0, 5), P !== "data-" && P !== "aria-")
              return;
        }
        v.push(" ", V, '="', j(H), '"');
      }
    }
  }
  function Oe(v, P, V) {
    if (P != null) {
      if (V != null)
        throw Error(n(60));
      if (typeof P != "object" || !("__html" in P))
        throw Error(n(61));
      P = P.__html, P != null && v.push("" + P);
    }
  }
  function He(v) {
    var P = "";
    return e.Children.forEach(v, function(V) {
      V != null && (P += V);
    }), P;
  }
  function Re(v, P, V, H) {
    v.push(ae(V));
    var le = V = null, ne;
    for (ne in P)
      if (t.call(P, ne)) {
        var ye = P[ne];
        if (ye != null)
          switch (ne) {
            case "children":
              V = ye;
              break;
            case "dangerouslySetInnerHTML":
              le = ye;
              break;
            default:
              Fe(v, H, ne, ye);
          }
      }
    return v.push(">"), Oe(v, le, V), typeof V == "string" ? (v.push(j(V)), null) : V;
  }
  var Se = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, we = /* @__PURE__ */ new Map();
  function ae(v) {
    var P = we.get(v);
    if (P === void 0) {
      if (!Se.test(v))
        throw Error(n(65, v));
      P = "<" + v, we.set(v, P);
    }
    return P;
  }
  function ge(v, P, V, H, le) {
    switch (P) {
      case "select":
        v.push(ae("select"));
        var ne = null, ye = null;
        for (et in V)
          if (t.call(V, et)) {
            var Ne = V[et];
            if (Ne != null)
              switch (et) {
                case "children":
                  ne = Ne;
                  break;
                case "dangerouslySetInnerHTML":
                  ye = Ne;
                  break;
                case "defaultValue":
                case "value":
                  break;
                default:
                  Fe(v, H, et, Ne);
              }
          }
        return v.push(">"), Oe(v, ye, ne), ne;
      case "option":
        ye = le.selectedValue, v.push(ae("option"));
        var Qe = Ne = null, nt = null, et = null;
        for (ne in V)
          if (t.call(V, ne)) {
            var jt = V[ne];
            if (jt != null)
              switch (ne) {
                case "children":
                  Ne = jt;
                  break;
                case "selected":
                  nt = jt;
                  break;
                case "dangerouslySetInnerHTML":
                  et = jt;
                  break;
                case "value":
                  Qe = jt;
                default:
                  Fe(v, H, ne, jt);
              }
          }
        if (ye != null)
          if (V = Qe !== null ? "" + Qe : He(Ne), k(ye)) {
            for (H = 0; H < ye.length; H++)
              if ("" + ye[H] === V) {
                v.push(' selected=""');
                break;
              }
          } else
            "" + ye === V && v.push(' selected=""');
        else
          nt && v.push(' selected=""');
        return v.push(">"), Oe(v, et, Ne), Ne;
      case "textarea":
        v.push(ae("textarea")), et = ye = ne = null;
        for (Ne in V)
          if (t.call(V, Ne) && (Qe = V[Ne], Qe != null))
            switch (Ne) {
              case "children":
                et = Qe;
                break;
              case "value":
                ne = Qe;
                break;
              case "defaultValue":
                ye = Qe;
                break;
              case "dangerouslySetInnerHTML":
                throw Error(n(91));
              default:
                Fe(
                  v,
                  H,
                  Ne,
                  Qe
                );
            }
        if (ne === null && ye !== null && (ne = ye), v.push(">"), et != null) {
          if (ne != null)
            throw Error(n(92));
          if (k(et) && 1 < et.length)
            throw Error(n(93));
          ne = "" + et;
        }
        return typeof ne == "string" && ne[0] === `
` && v.push(`
`), ne !== null && v.push(j("" + ne)), null;
      case "input":
        v.push(ae("input")), Qe = et = Ne = ne = null;
        for (ye in V)
          if (t.call(V, ye) && (nt = V[ye], nt != null))
            switch (ye) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(n(399, "input"));
              case "defaultChecked":
                Qe = nt;
                break;
              case "defaultValue":
                Ne = nt;
                break;
              case "checked":
                et = nt;
                break;
              case "value":
                ne = nt;
                break;
              default:
                Fe(v, H, ye, nt);
            }
        return et !== null ? Fe(v, H, "checked", et) : Qe !== null && Fe(v, H, "checked", Qe), ne !== null ? Fe(v, H, "value", ne) : Ne !== null && Fe(v, H, "value", Ne), v.push("/>"), null;
      case "menuitem":
        v.push(ae("menuitem"));
        for (var Sr in V)
          if (t.call(V, Sr) && (ne = V[Sr], ne != null))
            switch (Sr) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(n(400));
              default:
                Fe(v, H, Sr, ne);
            }
        return v.push(">"), null;
      case "title":
        v.push(ae("title")), ne = null;
        for (jt in V)
          if (t.call(V, jt) && (ye = V[jt], ye != null))
            switch (jt) {
              case "children":
                ne = ye;
                break;
              case "dangerouslySetInnerHTML":
                throw Error(n(434));
              default:
                Fe(v, H, jt, ye);
            }
        return v.push(">"), ne;
      case "listing":
      case "pre":
        v.push(ae(P)), ye = ne = null;
        for (Qe in V)
          if (t.call(V, Qe) && (Ne = V[Qe], Ne != null))
            switch (Qe) {
              case "children":
                ne = Ne;
                break;
              case "dangerouslySetInnerHTML":
                ye = Ne;
                break;
              default:
                Fe(v, H, Qe, Ne);
            }
        if (v.push(">"), ye != null) {
          if (ne != null)
            throw Error(n(60));
          if (typeof ye != "object" || !("__html" in ye))
            throw Error(n(61));
          V = ye.__html, V != null && (typeof V == "string" && 0 < V.length && V[0] === `
` ? v.push(`
`, V) : v.push("" + V));
        }
        return typeof ne == "string" && ne[0] === `
` && v.push(`
`), ne;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        v.push(ae(P));
        for (var zn in V)
          if (t.call(V, zn) && (ne = V[zn], ne != null))
            switch (zn) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(n(399, P));
              default:
                Fe(v, H, zn, ne);
            }
        return v.push("/>"), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return Re(
          v,
          V,
          P,
          H
        );
      case "html":
        return le.insertionMode === 0 && v.push("<!DOCTYPE html>"), Re(v, V, P, H);
      default:
        if (P.indexOf("-") === -1 && typeof V.is != "string")
          return Re(v, V, P, H);
        v.push(ae(P)), ye = ne = null;
        for (nt in V)
          if (t.call(V, nt) && (Ne = V[nt], Ne != null))
            switch (nt) {
              case "children":
                ne = Ne;
                break;
              case "dangerouslySetInnerHTML":
                ye = Ne;
                break;
              case "style":
                ee(v, H, Ne);
                break;
              case "suppressContentEditableWarning":
              case "suppressHydrationWarning":
                break;
              default:
                l(nt) && typeof Ne != "function" && typeof Ne != "symbol" && v.push(" ", nt, '="', j(Ne), '"');
            }
        return v.push(">"), Oe(v, ye, ne), ne;
    }
  }
  function Ie(v, P, V) {
    if (v.push('<!--$?--><template id="'), V === null)
      throw Error(n(395));
    return v.push(V), v.push('"></template>');
  }
  function Ye(v, P, V, H) {
    switch (V.insertionMode) {
      case 0:
      case 1:
        return v.push('<div hidden id="'), v.push(P.segmentPrefix), P = H.toString(16), v.push(P), v.push('">');
      case 2:
        return v.push('<svg aria-hidden="true" style="display:none" id="'), v.push(P.segmentPrefix), P = H.toString(16), v.push(P), v.push('">');
      case 3:
        return v.push('<math aria-hidden="true" style="display:none" id="'), v.push(P.segmentPrefix), P = H.toString(16), v.push(P), v.push('">');
      case 4:
        return v.push('<table hidden id="'), v.push(P.segmentPrefix), P = H.toString(16), v.push(P), v.push('">');
      case 5:
        return v.push('<table hidden><tbody id="'), v.push(P.segmentPrefix), P = H.toString(16), v.push(P), v.push('">');
      case 6:
        return v.push('<table hidden><tr id="'), v.push(P.segmentPrefix), P = H.toString(16), v.push(P), v.push('">');
      case 7:
        return v.push('<table hidden><colgroup id="'), v.push(P.segmentPrefix), P = H.toString(16), v.push(P), v.push('">');
      default:
        throw Error(n(397));
    }
  }
  function Ke(v, P) {
    switch (P.insertionMode) {
      case 0:
      case 1:
        return v.push("</div>");
      case 2:
        return v.push("</svg>");
      case 3:
        return v.push("</math>");
      case 4:
        return v.push("</table>");
      case 5:
        return v.push("</tbody></table>");
      case 6:
        return v.push("</tr></table>");
      case 7:
        return v.push("</colgroup></table>");
      default:
        throw Error(n(397));
    }
  }
  var ze = /[<\u2028\u2029]/g;
  function ue(v) {
    return JSON.stringify(v).replace(ze, function(P) {
      switch (P) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  function de(v, P) {
    return P = P === void 0 ? "" : P, { bootstrapChunks: [], startInlineScript: "<script>", placeholderPrefix: P + "P:", segmentPrefix: P + "S:", boundaryPrefix: P + "B:", idPrefix: P, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1, generateStaticMarkup: v };
  }
  function Q(v, P, V, H) {
    return V.generateStaticMarkup ? (v.push(j(P)), !1) : (P === "" ? v = H : (H && v.push("<!-- -->"), v.push(j(P)), v = !0), v);
  }
  var me = Object.assign, Le = Symbol.for("react.element"), Je = Symbol.for("react.portal"), Xe = Symbol.for("react.fragment"), je = Symbol.for("react.strict_mode"), Ue = Symbol.for("react.profiler"), it = Symbol.for("react.provider"), ct = Symbol.for("react.context"), lt = Symbol.for("react.forward_ref"), dt = Symbol.for("react.suspense"), Mt = Symbol.for("react.suspense_list"), Be = Symbol.for("react.memo"), Wt = Symbol.for("react.lazy"), Ht = Symbol.for("react.scope"), Fn = Symbol.for("react.debug_trace_mode"), Fr = Symbol.for("react.legacy_hidden"), $n = Symbol.for("react.default_value"), er = Symbol.iterator;
  function Nr(v) {
    if (v == null)
      return null;
    if (typeof v == "function")
      return v.displayName || v.name || null;
    if (typeof v == "string")
      return v;
    switch (v) {
      case Xe:
        return "Fragment";
      case Je:
        return "Portal";
      case Ue:
        return "Profiler";
      case je:
        return "StrictMode";
      case dt:
        return "Suspense";
      case Mt:
        return "SuspenseList";
    }
    if (typeof v == "object")
      switch (v.$$typeof) {
        case ct:
          return (v.displayName || "Context") + ".Consumer";
        case it:
          return (v._context.displayName || "Context") + ".Provider";
        case lt:
          var P = v.render;
          return v = v.displayName, v || (v = P.displayName || P.name || "", v = v !== "" ? "ForwardRef(" + v + ")" : "ForwardRef"), v;
        case Be:
          return P = v.displayName || null, P !== null ? P : Nr(v.type) || "Memo";
        case Wt:
          P = v._payload, v = v._init;
          try {
            return Nr(v(P));
          } catch {
          }
      }
    return null;
  }
  var Cr = {};
  function Gn(v, P) {
    if (v = v.contextTypes, !v)
      return Cr;
    var V = {}, H;
    for (H in v)
      V[H] = P[H];
    return V;
  }
  var Rn = null;
  function An(v, P) {
    if (v !== P) {
      v.context._currentValue2 = v.parentValue, v = v.parent;
      var V = P.parent;
      if (v === null) {
        if (V !== null)
          throw Error(n(401));
      } else {
        if (V === null)
          throw Error(n(401));
        An(v, V);
      }
      P.context._currentValue2 = P.value;
    }
  }
  function Sn(v) {
    v.context._currentValue2 = v.parentValue, v = v.parent, v !== null && Sn(v);
  }
  function Mr(v) {
    var P = v.parent;
    P !== null && Mr(P), v.context._currentValue2 = v.value;
  }
  function ii(v, P) {
    if (v.context._currentValue2 = v.parentValue, v = v.parent, v === null)
      throw Error(n(402));
    v.depth === P.depth ? An(v, P) : ii(v, P);
  }
  function tr(v, P) {
    var V = P.parent;
    if (V === null)
      throw Error(n(402));
    v.depth === V.depth ? An(v, V) : tr(v, V), P.context._currentValue2 = P.value;
  }
  function tn(v) {
    var P = Rn;
    P !== v && (P === null ? Mr(v) : v === null ? Sn(P) : P.depth === v.depth ? An(P, v) : P.depth > v.depth ? ii(P, v) : tr(P, v), Rn = v);
  }
  var co = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(v, P) {
    v = v._reactInternals, v.queue !== null && v.queue.push(P);
  }, enqueueReplaceState: function(v, P) {
    v = v._reactInternals, v.replace = !0, v.queue = [P];
  }, enqueueForceUpdate: function() {
  } };
  function Oo(v, P, V, H) {
    var le = v.state !== void 0 ? v.state : null;
    v.updater = co, v.props = V, v.state = le;
    var ne = { queue: [], replace: !1 };
    v._reactInternals = ne;
    var ye = P.contextType;
    if (v.context = typeof ye == "object" && ye !== null ? ye._currentValue2 : H, ye = P.getDerivedStateFromProps, typeof ye == "function" && (ye = ye(V, le), le = ye == null ? le : me({}, le, ye), v.state = le), typeof P.getDerivedStateFromProps != "function" && typeof v.getSnapshotBeforeUpdate != "function" && (typeof v.UNSAFE_componentWillMount == "function" || typeof v.componentWillMount == "function"))
      if (P = v.state, typeof v.componentWillMount == "function" && v.componentWillMount(), typeof v.UNSAFE_componentWillMount == "function" && v.UNSAFE_componentWillMount(), P !== v.state && co.enqueueReplaceState(v, v.state, null), ne.queue !== null && 0 < ne.queue.length)
        if (P = ne.queue, ye = ne.replace, ne.queue = null, ne.replace = !1, ye && P.length === 1)
          v.state = P[0];
        else {
          for (ne = ye ? P[0] : v.state, le = !0, ye = ye ? 1 : 0; ye < P.length; ye++) {
            var Ne = P[ye];
            Ne = typeof Ne == "function" ? Ne.call(v, ne, V, H) : Ne, Ne != null && (le ? (le = !1, ne = me({}, ne, Ne)) : me(ne, Ne));
          }
          v.state = ne;
        }
      else
        ne.queue = null;
  }
  var uo = { id: 1, overflow: "" };
  function Do(v, P, V) {
    var H = v.id;
    v = v.overflow;
    var le = 32 - fo(H) - 1;
    H &= ~(1 << le), V += 1;
    var ne = 32 - fo(P) + le;
    if (30 < ne) {
      var ye = le - le % 5;
      return ne = (H & (1 << ye) - 1).toString(32), H >>= ye, le -= ye, { id: 1 << 32 - fo(P) + le | V << le | H, overflow: ne + v };
    }
    return { id: 1 << ne | V << le | H, overflow: v };
  }
  var fo = Math.clz32 ? Math.clz32 : Lr, xi = Math.log, Fo = Math.LN2;
  function Lr(v) {
    return v >>>= 0, v === 0 ? 32 : 31 - (xi(v) / Fo | 0) | 0;
  }
  function No(v, P) {
    return v === P && (v !== 0 || 1 / v === 1 / P) || v !== v && P !== P;
  }
  var aa = typeof Object.is == "function" ? Object.is : No, Nn = null, Er = null, Yn = null, Bt = null, Br = !1, Mo = !1, Lo = 0, Ar = null, Bo = 0;
  function Vr() {
    if (Nn === null)
      throw Error(n(321));
    return Nn;
  }
  function ln() {
    if (0 < Bo)
      throw Error(n(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function Ti() {
    return Bt === null ? Yn === null ? (Br = !1, Yn = Bt = ln()) : (Br = !0, Bt = Yn) : Bt.next === null ? (Br = !1, Bt = Bt.next = ln()) : (Br = !0, Bt = Bt.next), Bt;
  }
  function Vo() {
    Er = Nn = null, Mo = !1, Yn = null, Bo = 0, Bt = Ar = null;
  }
  function Pi(v, P) {
    return typeof P == "function" ? P(v) : P;
  }
  function cn(v, P, V) {
    if (Nn = Vr(), Bt = Ti(), Br) {
      var H = Bt.queue;
      if (P = H.dispatch, Ar !== null && (V = Ar.get(H), V !== void 0)) {
        Ar.delete(H), H = Bt.memoizedState;
        do
          H = v(H, V.action), V = V.next;
        while (V !== null);
        return Bt.memoizedState = H, [H, P];
      }
      return [Bt.memoizedState, P];
    }
    return v = v === Pi ? typeof P == "function" ? P() : P : V !== void 0 ? V(P) : P, Bt.memoizedState = v, v = Bt.queue = { last: null, dispatch: null }, v = v.dispatch = Ba.bind(null, Nn, v), [Bt.memoizedState, v];
  }
  function ki(v, P) {
    if (Nn = Vr(), Bt = Ti(), P = P === void 0 ? null : P, Bt !== null) {
      var V = Bt.memoizedState;
      if (V !== null && P !== null) {
        var H = V[1];
        e:
          if (H === null)
            H = !1;
          else {
            for (var le = 0; le < H.length && le < P.length; le++)
              if (!aa(P[le], H[le])) {
                H = !1;
                break e;
              }
            H = !0;
          }
        if (H)
          return V[0];
      }
    }
    return v = v(), Bt.memoizedState = [v, P], v;
  }
  function Ba(v, P, V) {
    if (25 <= Bo)
      throw Error(n(301));
    if (v === Nn)
      if (Mo = !0, v = { action: V, next: null }, Ar === null && (Ar = /* @__PURE__ */ new Map()), V = Ar.get(P), V === void 0)
        Ar.set(P, v);
      else {
        for (P = V; P.next !== null; )
          P = P.next;
        P.next = v;
      }
  }
  function Va() {
    throw Error(n(394));
  }
  function X() {
  }
  var ke = { readContext: function(v) {
    return v._currentValue2;
  }, useContext: function(v) {
    return Vr(), v._currentValue2;
  }, useMemo: ki, useReducer: cn, useRef: function(v) {
    Nn = Vr(), Bt = Ti();
    var P = Bt.memoizedState;
    return P === null ? (v = { current: v }, Bt.memoizedState = v) : P;
  }, useState: function(v) {
    return cn(Pi, v);
  }, useInsertionEffect: X, useLayoutEffect: function() {
  }, useCallback: function(v, P) {
    return ki(function() {
      return v;
    }, P);
  }, useImperativeHandle: X, useEffect: X, useDebugValue: X, useDeferredValue: function(v) {
    return Vr(), v;
  }, useTransition: function() {
    return Vr(), [
      !1,
      Va
    ];
  }, useId: function() {
    var v = Er.treeContext, P = v.overflow;
    v = v.id, v = (v & ~(1 << 32 - fo(v) - 1)).toString(32) + P;
    var V = Ve;
    if (V === null)
      throw Error(n(404));
    return P = Lo++, v = ":" + V.idPrefix + "R" + v, 0 < P && (v += "H" + P.toString(32)), v + ":";
  }, useMutableSource: function(v, P) {
    return Vr(), P(v._source);
  }, useSyncExternalStore: function(v, P, V) {
    if (V === void 0)
      throw Error(n(407));
    return V();
  } }, Ve = null, at = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function St(v) {
    return console.error(v), null;
  }
  function Ot() {
  }
  function Tt(v, P, V, H, le, ne, ye, Ne, Qe) {
    var nt = [], et = /* @__PURE__ */ new Set();
    return P = { destination: null, responseState: P, progressiveChunkSize: H === void 0 ? 12800 : H, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: et, pingedTasks: nt, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: le === void 0 ? St : le, onAllReady: ne === void 0 ? Ot : ne, onShellReady: ye === void 0 ? Ot : ye, onShellError: Ne === void 0 ? Ot : Ne, onFatalError: Qe === void 0 ? Ot : Qe }, V = vn(P, 0, null, V, !1, !1), V.parentFlushed = !0, v = Et(P, v, null, V, et, Cr, null, uo), nt.push(v), P;
  }
  function Et(v, P, V, H, le, ne, ye, Ne) {
    v.allPendingTasks++, V === null ? v.pendingRootTasks++ : V.pendingTasks++;
    var Qe = { node: P, ping: function() {
      var nt = v.pingedTasks;
      nt.push(Qe), nt.length === 1 && pr(v);
    }, blockedBoundary: V, blockedSegment: H, abortSet: le, legacyContext: ne, context: ye, treeContext: Ne };
    return le.add(Qe), Qe;
  }
  function vn(v, P, V, H, le, ne) {
    return { status: 0, id: -1, index: P, parentFlushed: !1, chunks: [], children: [], formatContext: H, boundary: V, lastPushedText: le, textEmbedded: ne };
  }
  function Kt(v, P) {
    if (v = v.onError(P), v != null && typeof v != "string")
      throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof v + '" instead');
    return v;
  }
  function Xt(v, P) {
    var V = v.onShellError;
    V(P), V = v.onFatalError, V(P), v.destination !== null ? (v.status = 2, v.destination.destroy(P)) : (v.status = 1, v.fatalError = P);
  }
  function pn(v, P, V, H, le) {
    for (Nn = {}, Er = P, Lo = 0, v = V(H, le); Mo; )
      Mo = !1, Lo = 0, Bo += 1, Bt = null, v = V(H, le);
    return Vo(), v;
  }
  function Un(v, P, V, H) {
    var le = V.render(), ne = H.childContextTypes;
    if (ne != null) {
      var ye = P.legacyContext;
      if (typeof V.getChildContext != "function")
        H = ye;
      else {
        V = V.getChildContext();
        for (var Ne in V)
          if (!(Ne in ne))
            throw Error(n(108, Nr(H) || "Unknown", Ne));
        H = me({}, ye, V);
      }
      P.legacyContext = H, bn(v, P, le), P.legacyContext = ye;
    } else
      bn(v, P, le);
  }
  function go(v, P) {
    if (v && v.defaultProps) {
      P = me({}, P), v = v.defaultProps;
      for (var V in v)
        P[V] === void 0 && (P[V] = v[V]);
      return P;
    }
    return P;
  }
  function an(v, P, V, H, le) {
    if (typeof V == "function")
      if (V.prototype && V.prototype.isReactComponent) {
        le = Gn(V, P.legacyContext);
        var ne = V.contextType;
        ne = new V(H, typeof ne == "object" && ne !== null ? ne._currentValue2 : le), Oo(ne, V, H, le), Un(v, P, ne, V);
      } else {
        ne = Gn(V, P.legacyContext), le = pn(v, P, V, H, ne);
        var ye = Lo !== 0;
        if (typeof le == "object" && le !== null && typeof le.render == "function" && le.$$typeof === void 0)
          Oo(le, V, H, ne), Un(v, P, le, V);
        else if (ye) {
          H = P.treeContext, P.treeContext = Do(H, 1, 0);
          try {
            bn(v, P, le);
          } finally {
            P.treeContext = H;
          }
        } else
          bn(v, P, le);
      }
    else if (typeof V == "string") {
      switch (le = P.blockedSegment, ne = ge(le.chunks, V, H, v.responseState, le.formatContext), le.lastPushedText = !1, ye = le.formatContext, le.formatContext = q(ye, V, H), qr(v, P, ne), le.formatContext = ye, V) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          le.chunks.push("</", V, ">");
      }
      le.lastPushedText = !1;
    } else {
      switch (V) {
        case Fr:
        case Fn:
        case je:
        case Ue:
        case Xe:
          bn(v, P, H.children);
          return;
        case Mt:
          bn(v, P, H.children);
          return;
        case Ht:
          throw Error(n(343));
        case dt:
          e: {
            V = P.blockedBoundary, le = P.blockedSegment, ne = H.fallback, H = H.children, ye = /* @__PURE__ */ new Set();
            var Ne = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: ye, errorDigest: null }, Qe = vn(v, le.chunks.length, Ne, le.formatContext, !1, !1);
            le.children.push(Qe), le.lastPushedText = !1;
            var nt = vn(v, 0, null, le.formatContext, !1, !1);
            nt.parentFlushed = !0, P.blockedBoundary = Ne, P.blockedSegment = nt;
            try {
              if (qr(
                v,
                P,
                H
              ), v.responseState.generateStaticMarkup || nt.lastPushedText && nt.textEmbedded && nt.chunks.push("<!-- -->"), nt.status = 1, _r(Ne, nt), Ne.pendingTasks === 0)
                break e;
            } catch (et) {
              nt.status = 4, Ne.forceClientRender = !0, Ne.errorDigest = Kt(v, et);
            } finally {
              P.blockedBoundary = V, P.blockedSegment = le;
            }
            P = Et(v, ne, V, Qe, ye, P.legacyContext, P.context, P.treeContext), v.pingedTasks.push(P);
          }
          return;
      }
      if (typeof V == "object" && V !== null)
        switch (V.$$typeof) {
          case lt:
            if (H = pn(v, P, V.render, H, le), Lo !== 0) {
              V = P.treeContext, P.treeContext = Do(V, 1, 0);
              try {
                bn(v, P, H);
              } finally {
                P.treeContext = V;
              }
            } else
              bn(v, P, H);
            return;
          case Be:
            V = V.type, H = go(V, H), an(v, P, V, H, le);
            return;
          case it:
            if (le = H.children, V = V._context, H = H.value, ne = V._currentValue2, V._currentValue2 = H, ye = Rn, Rn = H = { parent: ye, depth: ye === null ? 0 : ye.depth + 1, context: V, parentValue: ne, value: H }, P.context = H, bn(v, P, le), v = Rn, v === null)
              throw Error(n(403));
            H = v.parentValue, v.context._currentValue2 = H === $n ? v.context._defaultValue : H, v = Rn = v.parent, P.context = v;
            return;
          case ct:
            H = H.children, H = H(V._currentValue2), bn(v, P, H);
            return;
          case Wt:
            le = V._init, V = le(V._payload), H = go(V, H), an(
              v,
              P,
              V,
              H,
              void 0
            );
            return;
        }
      throw Error(n(130, V == null ? V : typeof V, ""));
    }
  }
  function bn(v, P, V) {
    if (P.node = V, typeof V == "object" && V !== null) {
      switch (V.$$typeof) {
        case Le:
          an(v, P, V.type, V.props, V.ref);
          return;
        case Je:
          throw Error(n(257));
        case Wt:
          var H = V._init;
          V = H(V._payload), bn(v, P, V);
          return;
      }
      if (k(V)) {
        po(v, P, V);
        return;
      }
      if (V === null || typeof V != "object" ? H = null : (H = er && V[er] || V["@@iterator"], H = typeof H == "function" ? H : null), H && (H = H.call(V))) {
        if (V = H.next(), !V.done) {
          var le = [];
          do
            le.push(V.value), V = H.next();
          while (!V.done);
          po(v, P, le);
        }
        return;
      }
      throw v = Object.prototype.toString.call(V), Error(n(31, v === "[object Object]" ? "object with keys {" + Object.keys(V).join(", ") + "}" : v));
    }
    typeof V == "string" ? (H = P.blockedSegment, H.lastPushedText = Q(P.blockedSegment.chunks, V, v.responseState, H.lastPushedText)) : typeof V == "number" && (H = P.blockedSegment, H.lastPushedText = Q(P.blockedSegment.chunks, "" + V, v.responseState, H.lastPushedText));
  }
  function po(v, P, V) {
    for (var H = V.length, le = 0; le < H; le++) {
      var ne = P.treeContext;
      P.treeContext = Do(ne, H, le);
      try {
        qr(v, P, V[le]);
      } finally {
        P.treeContext = ne;
      }
    }
  }
  function qr(v, P, V) {
    var H = P.blockedSegment.formatContext, le = P.legacyContext, ne = P.context;
    try {
      return bn(v, P, V);
    } catch (Qe) {
      if (Vo(), typeof Qe == "object" && Qe !== null && typeof Qe.then == "function") {
        V = Qe;
        var ye = P.blockedSegment, Ne = vn(v, ye.chunks.length, null, ye.formatContext, ye.lastPushedText, !0);
        ye.children.push(Ne), ye.lastPushedText = !1, v = Et(v, P.node, P.blockedBoundary, Ne, P.abortSet, P.legacyContext, P.context, P.treeContext).ping, V.then(v, v), P.blockedSegment.formatContext = H, P.legacyContext = le, P.context = ne, tn(ne);
      } else
        throw P.blockedSegment.formatContext = H, P.legacyContext = le, P.context = ne, tn(ne), Qe;
    }
  }
  function Mn(v) {
    var P = v.blockedBoundary;
    v = v.blockedSegment, v.status = 3, ho(this, P, v);
  }
  function Ri(v, P, V) {
    var H = v.blockedBoundary;
    v.blockedSegment.status = 3, H === null ? (P.allPendingTasks--, P.status !== 2 && (P.status = 2, P.destination !== null && P.destination.push(null))) : (H.pendingTasks--, H.forceClientRender || (H.forceClientRender = !0, v = V === void 0 ? Error(n(432)) : V, H.errorDigest = P.onError(v), H.parentFlushed && P.clientRenderedBoundaries.push(H)), H.fallbackAbortableTasks.forEach(function(le) {
      return Ri(le, P, V);
    }), H.fallbackAbortableTasks.clear(), P.allPendingTasks--, P.allPendingTasks === 0 && (H = P.onAllReady, H()));
  }
  function _r(v, P) {
    if (P.chunks.length === 0 && P.children.length === 1 && P.children[0].boundary === null) {
      var V = P.children[0];
      V.id = P.id, V.parentFlushed = !0, V.status === 1 && _r(v, V);
    } else
      v.completedSegments.push(P);
  }
  function ho(v, P, V) {
    if (P === null) {
      if (V.parentFlushed) {
        if (v.completedRootSegment !== null)
          throw Error(n(389));
        v.completedRootSegment = V;
      }
      v.pendingRootTasks--, v.pendingRootTasks === 0 && (v.onShellError = Ot, P = v.onShellReady, P());
    } else
      P.pendingTasks--, P.forceClientRender || (P.pendingTasks === 0 ? (V.parentFlushed && V.status === 1 && _r(P, V), P.parentFlushed && v.completedBoundaries.push(P), P.fallbackAbortableTasks.forEach(Mn, v), P.fallbackAbortableTasks.clear()) : V.parentFlushed && V.status === 1 && (_r(P, V), P.completedSegments.length === 1 && P.parentFlushed && v.partialBoundaries.push(P)));
    v.allPendingTasks--, v.allPendingTasks === 0 && (v = v.onAllReady, v());
  }
  function pr(v) {
    if (v.status !== 2) {
      var P = Rn, V = at.current;
      at.current = ke;
      var H = Ve;
      Ve = v.responseState;
      try {
        var le = v.pingedTasks, ne;
        for (ne = 0; ne < le.length; ne++) {
          var ye = le[ne], Ne = v, Qe = ye.blockedSegment;
          if (Qe.status === 0) {
            tn(ye.context);
            try {
              bn(Ne, ye, ye.node), Ne.responseState.generateStaticMarkup || Qe.lastPushedText && Qe.textEmbedded && Qe.chunks.push("<!-- -->"), ye.abortSet.delete(ye), Qe.status = 1, ho(Ne, ye.blockedBoundary, Qe);
            } catch (Zn) {
              if (Vo(), typeof Zn == "object" && Zn !== null && typeof Zn.then == "function") {
                var nt = ye.ping;
                Zn.then(nt, nt);
              } else {
                ye.abortSet.delete(ye), Qe.status = 4;
                var et = ye.blockedBoundary, jt = Zn, Sr = Kt(Ne, jt);
                if (et === null ? Xt(Ne, jt) : (et.pendingTasks--, et.forceClientRender || (et.forceClientRender = !0, et.errorDigest = Sr, et.parentFlushed && Ne.clientRenderedBoundaries.push(et))), Ne.allPendingTasks--, Ne.allPendingTasks === 0) {
                  var zn = Ne.onAllReady;
                  zn();
                }
              }
            } finally {
            }
          }
        }
        le.splice(0, ne), v.destination !== null && mo(v, v.destination);
      } catch (Zn) {
        Kt(v, Zn), Xt(v, Zn);
      } finally {
        Ve = H, at.current = V, V === ke && tn(P);
      }
    }
  }
  function jo(v, P, V) {
    switch (V.parentFlushed = !0, V.status) {
      case 0:
        var H = V.id = v.nextSegmentId++;
        return V.lastPushedText = !1, V.textEmbedded = !1, v = v.responseState, P.push('<template id="'), P.push(v.placeholderPrefix), v = H.toString(16), P.push(v), P.push('"></template>');
      case 1:
        V.status = 2;
        var le = !0;
        H = V.chunks;
        var ne = 0;
        V = V.children;
        for (var ye = 0; ye < V.length; ye++) {
          for (le = V[ye]; ne < le.index; ne++)
            P.push(H[ne]);
          le = ai(v, P, le);
        }
        for (; ne < H.length - 1; ne++)
          P.push(H[ne]);
        return ne < H.length && (le = P.push(H[ne])), le;
      default:
        throw Error(n(390));
    }
  }
  function ai(v, P, V) {
    var H = V.boundary;
    if (H === null)
      return jo(v, P, V);
    if (H.parentFlushed = !0, H.forceClientRender)
      return v.responseState.generateStaticMarkup || (H = H.errorDigest, P.push("<!--$!-->"), P.push("<template"), H && (P.push(' data-dgst="'), H = j(H), P.push(H), P.push('"')), P.push("></template>")), jo(v, P, V), v = v.responseState.generateStaticMarkup ? !0 : P.push("<!--/$-->"), v;
    if (0 < H.pendingTasks) {
      H.rootSegmentID = v.nextSegmentId++, 0 < H.completedSegments.length && v.partialBoundaries.push(H);
      var le = v.responseState, ne = le.nextSuspenseID++;
      return le = le.boundaryPrefix + ne.toString(16), H = H.id = le, Ie(P, v.responseState, H), jo(v, P, V), P.push("<!--/$-->");
    }
    if (H.byteSize > v.progressiveChunkSize)
      return H.rootSegmentID = v.nextSegmentId++, v.completedBoundaries.push(H), Ie(P, v.responseState, H.id), jo(v, P, V), P.push("<!--/$-->");
    if (v.responseState.generateStaticMarkup || P.push("<!--$-->"), V = H.completedSegments, V.length !== 1)
      throw Error(n(391));
    return ai(v, P, V[0]), v = v.responseState.generateStaticMarkup ? !0 : P.push("<!--/$-->"), v;
  }
  function sa(v, P, V) {
    return Ye(P, v.responseState, V.formatContext, V.id), ai(v, P, V), Ke(P, V.formatContext);
  }
  function la(v, P, V) {
    for (var H = V.completedSegments, le = 0; le < H.length; le++)
      Oi(v, P, V, H[le]);
    if (H.length = 0, v = v.responseState, H = V.id, V = V.rootSegmentID, P.push(v.startInlineScript), v.sentCompleteBoundaryFunction ? P.push('$RC("') : (v.sentCompleteBoundaryFunction = !0, P.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("')), H === null)
      throw Error(n(395));
    return V = V.toString(16), P.push(H), P.push('","'), P.push(v.segmentPrefix), P.push(V), P.push('")<\/script>');
  }
  function Oi(v, P, V, H) {
    if (H.status === 2)
      return !0;
    var le = H.id;
    if (le === -1) {
      if ((H.id = V.rootSegmentID) === -1)
        throw Error(n(392));
      return sa(v, P, H);
    }
    return sa(v, P, H), v = v.responseState, P.push(v.startInlineScript), v.sentCompleteSegmentFunction ? P.push('$RS("') : (v.sentCompleteSegmentFunction = !0, P.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("')), P.push(v.segmentPrefix), le = le.toString(16), P.push(le), P.push('","'), P.push(v.placeholderPrefix), P.push(le), P.push('")<\/script>');
  }
  function mo(v, P) {
    try {
      var V = v.completedRootSegment;
      if (V !== null && v.pendingRootTasks === 0) {
        ai(v, P, V), v.completedRootSegment = null;
        var H = v.responseState.bootstrapChunks;
        for (V = 0; V < H.length - 1; V++)
          P.push(H[V]);
        V < H.length && P.push(H[V]);
      }
      var le = v.clientRenderedBoundaries, ne;
      for (ne = 0; ne < le.length; ne++) {
        var ye = le[ne];
        H = P;
        var Ne = v.responseState, Qe = ye.id, nt = ye.errorDigest, et = ye.errorMessage, jt = ye.errorComponentStack;
        if (H.push(Ne.startInlineScript), Ne.sentClientRenderFunction ? H.push('$RX("') : (Ne.sentClientRenderFunction = !0, H.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("')), Qe === null)
          throw Error(n(395));
        if (H.push(Qe), H.push('"'), nt || et || jt) {
          H.push(",");
          var Sr = ue(nt || "");
          H.push(Sr);
        }
        if (et || jt) {
          H.push(",");
          var zn = ue(et || "");
          H.push(zn);
        }
        if (jt) {
          H.push(",");
          var Zn = ue(jt);
          H.push(Zn);
        }
        if (!H.push(")<\/script>")) {
          v.destination = null, ne++, le.splice(0, ne);
          return;
        }
      }
      le.splice(0, ne);
      var vo = v.completedBoundaries;
      for (ne = 0; ne < vo.length; ne++)
        if (!la(v, P, vo[ne])) {
          v.destination = null, ne++, vo.splice(0, ne);
          return;
        }
      vo.splice(0, ne);
      var jr = v.partialBoundaries;
      for (ne = 0; ne < jr.length; ne++) {
        var ca = jr[ne];
        e: {
          le = v, ye = P;
          var si = ca.completedSegments;
          for (Ne = 0; Ne < si.length; Ne++)
            if (!Oi(le, ye, ca, si[Ne])) {
              Ne++, si.splice(0, Ne);
              var Fi = !1;
              break e;
            }
          si.splice(0, Ne), Fi = !0;
        }
        if (!Fi) {
          v.destination = null, ne++, jr.splice(0, ne);
          return;
        }
      }
      jr.splice(0, ne);
      var bo = v.completedBoundaries;
      for (ne = 0; ne < bo.length; ne++)
        if (!la(v, P, bo[ne])) {
          v.destination = null, ne++, bo.splice(0, ne);
          return;
        }
      bo.splice(0, ne);
    } finally {
      v.allPendingTasks === 0 && v.pingedTasks.length === 0 && v.clientRenderedBoundaries.length === 0 && v.completedBoundaries.length === 0 && P.push(null);
    }
  }
  function ja(v, P) {
    try {
      var V = v.abortableTasks;
      V.forEach(function(H) {
        return Ri(H, v, P);
      }), V.clear(), v.destination !== null && mo(v, v.destination);
    } catch (H) {
      Kt(v, H), Xt(v, H);
    }
  }
  function Di() {
  }
  function Uo(v, P, V, H) {
    var le = !1, ne = null, ye = "", Ne = { push: function(nt) {
      return nt !== null && (ye += nt), !0;
    }, destroy: function(nt) {
      le = !0, ne = nt;
    } }, Qe = !1;
    if (v = Tt(v, de(V, P ? P.identifierPrefix : void 0), { insertionMode: 1, selectedValue: null }, 1 / 0, Di, void 0, function() {
      Qe = !0;
    }, void 0, void 0), pr(v), ja(v, H), v.status === 1)
      v.status = 2, Ne.destroy(v.fatalError);
    else if (v.status !== 2 && v.destination === null) {
      v.destination = Ne;
      try {
        mo(v, Ne);
      } catch (nt) {
        Kt(v, nt), Xt(v, nt);
      }
    }
    if (le)
      throw ne;
    if (!Qe)
      throw Error(n(426));
    return ye;
  }
  return ld.renderToNodeStream = function() {
    throw Error(n(207));
  }, ld.renderToStaticMarkup = function(v, P) {
    return Uo(v, P, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, ld.renderToStaticNodeStream = function() {
    throw Error(n(208));
  }, ld.renderToString = function(v, P) {
    return Uo(v, P, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, ld.version = "18.2.0", ld;
}
var Op = {};
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sA;
function i7() {
  if (sA)
    return Op;
  sA = 1;
  var e = $o;
  function n(b) {
    for (var T = "https://reactjs.org/docs/error-decoder.html?invariant=" + b, L = 1; L < arguments.length; L++)
      T += "&args[]=" + encodeURIComponent(arguments[L]);
    return "Minified React error #" + b + "; visit " + T + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var t = null, r = 0;
  function o(b, T) {
    if (T.length !== 0)
      if (512 < T.length)
        0 < r && (b.enqueue(new Uint8Array(t.buffer, 0, r)), t = new Uint8Array(512), r = 0), b.enqueue(T);
      else {
        var L = t.length - r;
        L < T.length && (L === 0 ? b.enqueue(t) : (t.set(T.subarray(0, L), r), b.enqueue(t), T = T.subarray(L)), t = new Uint8Array(512), r = 0), t.set(T, r), r += T.length;
      }
  }
  function a(b, T) {
    return o(b, T), !0;
  }
  function l(b) {
    t && 0 < r && (b.enqueue(new Uint8Array(t.buffer, 0, r)), t = null, r = 0);
  }
  var u = new TextEncoder();
  function f(b) {
    return u.encode(b);
  }
  function p(b) {
    return u.encode(b);
  }
  function y(b, T) {
    typeof b.error == "function" ? b.error(T) : b.close();
  }
  var A = Object.prototype.hasOwnProperty, w = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, F = {}, j = {};
  function N(b) {
    return A.call(j, b) ? !0 : A.call(F, b) ? !1 : w.test(b) ? j[b] = !0 : (F[b] = !0, !1);
  }
  function D(b, T, L, G, ce, ie, Ae) {
    this.acceptsBooleans = T === 2 || T === 3 || T === 4, this.attributeName = G, this.attributeNamespace = ce, this.mustUseProperty = L, this.propertyName = b, this.type = T, this.sanitizeURL = ie, this.removeEmptyString = Ae;
  }
  var k = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(b) {
    k[b] = new D(b, 0, !1, b, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(b) {
    var T = b[0];
    k[T] = new D(T, 1, !1, b[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(b) {
    k[b] = new D(b, 2, !1, b.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(b) {
    k[b] = new D(b, 2, !1, b, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(b) {
    k[b] = new D(b, 3, !1, b.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(b) {
    k[b] = new D(b, 3, !0, b, null, !1, !1);
  }), ["capture", "download"].forEach(function(b) {
    k[b] = new D(b, 4, !1, b, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(b) {
    k[b] = new D(b, 6, !1, b, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(b) {
    k[b] = new D(b, 5, !1, b.toLowerCase(), null, !1, !1);
  });
  var z = /[\-:]([a-z])/g;
  function q(b) {
    return b[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(b) {
    var T = b.replace(
      z,
      q
    );
    k[T] = new D(T, 1, !1, b, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(b) {
    var T = b.replace(z, q);
    k[T] = new D(T, 1, !1, b, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(b) {
    var T = b.replace(z, q);
    k[T] = new D(T, 1, !1, b, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(b) {
    k[b] = new D(b, 1, !1, b.toLowerCase(), null, !1, !1);
  }), k.xlinkHref = new D("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(b) {
    k[b] = new D(b, 1, !1, b.toLowerCase(), null, !0, !0);
  });
  var Ce = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, ee = ["Webkit", "ms", "Moz", "O"];
  Object.keys(Ce).forEach(function(b) {
    ee.forEach(function(T) {
      T = T + b.charAt(0).toUpperCase() + b.substring(1), Ce[T] = Ce[b];
    });
  });
  var Fe = /["'&<>]/;
  function Oe(b) {
    if (typeof b == "boolean" || typeof b == "number")
      return "" + b;
    b = "" + b;
    var T = Fe.exec(b);
    if (T) {
      var L = "", G, ce = 0;
      for (G = T.index; G < b.length; G++) {
        switch (b.charCodeAt(G)) {
          case 34:
            T = "&quot;";
            break;
          case 38:
            T = "&amp;";
            break;
          case 39:
            T = "&#x27;";
            break;
          case 60:
            T = "&lt;";
            break;
          case 62:
            T = "&gt;";
            break;
          default:
            continue;
        }
        ce !== G && (L += b.substring(ce, G)), ce = G + 1, L += T;
      }
      b = ce !== G ? L + b.substring(ce, G) : L;
    }
    return b;
  }
  var He = /([A-Z])/g, Re = /^ms-/, Se = Array.isArray, we = p("<script>"), ae = p("<\/script>"), ge = p('<script src="'), Ie = p('<script type="module" src="'), Ye = p('" async=""><\/script>'), Ke = /(<\/|<)(s)(cript)/gi;
  function ze(b, T, L, G) {
    return "" + T + (L === "s" ? "\\u0073" : "\\u0053") + G;
  }
  function ue(b, T, L, G, ce) {
    b = b === void 0 ? "" : b, T = T === void 0 ? we : p('<script nonce="' + Oe(T) + '">');
    var ie = [];
    if (L !== void 0 && ie.push(T, f(("" + L).replace(Ke, ze)), ae), G !== void 0)
      for (L = 0; L < G.length; L++)
        ie.push(ge, f(Oe(G[L])), Ye);
    if (ce !== void 0)
      for (G = 0; G < ce.length; G++)
        ie.push(Ie, f(Oe(ce[G])), Ye);
    return { bootstrapChunks: ie, startInlineScript: T, placeholderPrefix: p(b + "P:"), segmentPrefix: p(b + "S:"), boundaryPrefix: b + "B:", idPrefix: b, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1 };
  }
  function de(b, T) {
    return { insertionMode: b, selectedValue: T };
  }
  function Q(b) {
    return de(b === "http://www.w3.org/2000/svg" ? 2 : b === "http://www.w3.org/1998/Math/MathML" ? 3 : 0, null);
  }
  function me(b, T, L) {
    switch (T) {
      case "select":
        return de(1, L.value != null ? L.value : L.defaultValue);
      case "svg":
        return de(2, null);
      case "math":
        return de(3, null);
      case "foreignObject":
        return de(1, null);
      case "table":
        return de(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return de(5, null);
      case "colgroup":
        return de(7, null);
      case "tr":
        return de(6, null);
    }
    return 4 <= b.insertionMode || b.insertionMode === 0 ? de(1, null) : b;
  }
  var Le = p("<!-- -->");
  function Je(b, T, L, G) {
    return T === "" ? G : (G && b.push(Le), b.push(f(Oe(T))), !0);
  }
  var Xe = /* @__PURE__ */ new Map(), je = p(' style="'), Ue = p(":"), it = p(";");
  function ct(b, T, L) {
    if (typeof L != "object")
      throw Error(n(62));
    T = !0;
    for (var G in L)
      if (A.call(L, G)) {
        var ce = L[G];
        if (ce != null && typeof ce != "boolean" && ce !== "") {
          if (G.indexOf("--") === 0) {
            var ie = f(Oe(G));
            ce = f(Oe(("" + ce).trim()));
          } else {
            ie = G;
            var Ae = Xe.get(ie);
            Ae !== void 0 || (Ae = p(Oe(ie.replace(He, "-$1").toLowerCase().replace(Re, "-ms-"))), Xe.set(ie, Ae)), ie = Ae, ce = typeof ce == "number" ? ce === 0 || A.call(Ce, G) ? f("" + ce) : f(ce + "px") : f(Oe(("" + ce).trim()));
          }
          T ? (T = !1, b.push(je, ie, Ue, ce)) : b.push(it, ie, Ue, ce);
        }
      }
    T || b.push(Mt);
  }
  var lt = p(" "), dt = p('="'), Mt = p('"'), Be = p('=""');
  function Wt(b, T, L, G) {
    switch (L) {
      case "style":
        ct(b, T, G);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < L.length) || L[0] !== "o" && L[0] !== "O" || L[1] !== "n" && L[1] !== "N") {
      if (T = k.hasOwnProperty(L) ? k[L] : null, T !== null) {
        switch (typeof G) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!T.acceptsBooleans)
              return;
        }
        switch (L = f(T.attributeName), T.type) {
          case 3:
            G && b.push(lt, L, Be);
            break;
          case 4:
            G === !0 ? b.push(lt, L, Be) : G !== !1 && b.push(lt, L, dt, f(Oe(G)), Mt);
            break;
          case 5:
            isNaN(G) || b.push(lt, L, dt, f(Oe(G)), Mt);
            break;
          case 6:
            !isNaN(G) && 1 <= G && b.push(lt, L, dt, f(Oe(G)), Mt);
            break;
          default:
            T.sanitizeURL && (G = "" + G), b.push(lt, L, dt, f(Oe(G)), Mt);
        }
      } else if (N(L)) {
        switch (typeof G) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (T = L.toLowerCase().slice(0, 5), T !== "data-" && T !== "aria-")
              return;
        }
        b.push(lt, f(L), dt, f(Oe(G)), Mt);
      }
    }
  }
  var Ht = p(">"), Fn = p("/>");
  function Fr(b, T, L) {
    if (T != null) {
      if (L != null)
        throw Error(n(60));
      if (typeof T != "object" || !("__html" in T))
        throw Error(n(61));
      T = T.__html, T != null && b.push(f("" + T));
    }
  }
  function $n(b) {
    var T = "";
    return e.Children.forEach(b, function(L) {
      L != null && (T += L);
    }), T;
  }
  var er = p(' selected=""');
  function Nr(b, T, L, G) {
    b.push(An(L));
    var ce = L = null, ie;
    for (ie in T)
      if (A.call(T, ie)) {
        var Ae = T[ie];
        if (Ae != null)
          switch (ie) {
            case "children":
              L = Ae;
              break;
            case "dangerouslySetInnerHTML":
              ce = Ae;
              break;
            default:
              Wt(b, G, ie, Ae);
          }
      }
    return b.push(Ht), Fr(b, ce, L), typeof L == "string" ? (b.push(f(Oe(L))), null) : L;
  }
  var Cr = p(`
`), Gn = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Rn = /* @__PURE__ */ new Map();
  function An(b) {
    var T = Rn.get(b);
    if (T === void 0) {
      if (!Gn.test(b))
        throw Error(n(65, b));
      T = p("<" + b), Rn.set(b, T);
    }
    return T;
  }
  var Sn = p("<!DOCTYPE html>");
  function Mr(b, T, L, G, ce) {
    switch (T) {
      case "select":
        b.push(An("select"));
        var ie = null, Ae = null;
        for (pt in L)
          if (A.call(L, pt)) {
            var Me = L[pt];
            if (Me != null)
              switch (pt) {
                case "children":
                  ie = Me;
                  break;
                case "dangerouslySetInnerHTML":
                  Ae = Me;
                  break;
                case "defaultValue":
                case "value":
                  break;
                default:
                  Wt(b, G, pt, Me);
              }
          }
        return b.push(Ht), Fr(b, Ae, ie), ie;
      case "option":
        Ae = ce.selectedValue, b.push(An("option"));
        var qe = Me = null, At = null, pt = null;
        for (ie in L)
          if (A.call(L, ie)) {
            var on = L[ie];
            if (on != null)
              switch (ie) {
                case "children":
                  Me = on;
                  break;
                case "selected":
                  At = on;
                  break;
                case "dangerouslySetInnerHTML":
                  pt = on;
                  break;
                case "value":
                  qe = on;
                default:
                  Wt(b, G, ie, on);
              }
          }
        if (Ae != null)
          if (L = qe !== null ? "" + qe : $n(Me), Se(Ae)) {
            for (G = 0; G < Ae.length; G++)
              if ("" + Ae[G] === L) {
                b.push(er);
                break;
              }
          } else
            "" + Ae === L && b.push(er);
        else
          At && b.push(er);
        return b.push(Ht), Fr(b, pt, Me), Me;
      case "textarea":
        b.push(An("textarea")), pt = Ae = ie = null;
        for (Me in L)
          if (A.call(L, Me) && (qe = L[Me], qe != null))
            switch (Me) {
              case "children":
                pt = qe;
                break;
              case "value":
                ie = qe;
                break;
              case "defaultValue":
                Ae = qe;
                break;
              case "dangerouslySetInnerHTML":
                throw Error(n(91));
              default:
                Wt(b, G, Me, qe);
            }
        if (ie === null && Ae !== null && (ie = Ae), b.push(Ht), pt != null) {
          if (ie != null)
            throw Error(n(92));
          if (Se(pt) && 1 < pt.length)
            throw Error(n(93));
          ie = "" + pt;
        }
        return typeof ie == "string" && ie[0] === `
` && b.push(Cr), ie !== null && b.push(f(Oe("" + ie))), null;
      case "input":
        b.push(An("input")), qe = pt = Me = ie = null;
        for (Ae in L)
          if (A.call(L, Ae) && (At = L[Ae], At != null))
            switch (Ae) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(n(399, "input"));
              case "defaultChecked":
                qe = At;
                break;
              case "defaultValue":
                Me = At;
                break;
              case "checked":
                pt = At;
                break;
              case "value":
                ie = At;
                break;
              default:
                Wt(b, G, Ae, At);
            }
        return pt !== null ? Wt(
          b,
          G,
          "checked",
          pt
        ) : qe !== null && Wt(b, G, "checked", qe), ie !== null ? Wt(b, G, "value", ie) : Me !== null && Wt(b, G, "value", Me), b.push(Fn), null;
      case "menuitem":
        b.push(An("menuitem"));
        for (var hr in L)
          if (A.call(L, hr) && (ie = L[hr], ie != null))
            switch (hr) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(n(400));
              default:
                Wt(b, G, hr, ie);
            }
        return b.push(Ht), null;
      case "title":
        b.push(An("title")), ie = null;
        for (on in L)
          if (A.call(L, on) && (Ae = L[on], Ae != null))
            switch (on) {
              case "children":
                ie = Ae;
                break;
              case "dangerouslySetInnerHTML":
                throw Error(n(434));
              default:
                Wt(b, G, on, Ae);
            }
        return b.push(Ht), ie;
      case "listing":
      case "pre":
        b.push(An(T)), Ae = ie = null;
        for (qe in L)
          if (A.call(L, qe) && (Me = L[qe], Me != null))
            switch (qe) {
              case "children":
                ie = Me;
                break;
              case "dangerouslySetInnerHTML":
                Ae = Me;
                break;
              default:
                Wt(b, G, qe, Me);
            }
        if (b.push(Ht), Ae != null) {
          if (ie != null)
            throw Error(n(60));
          if (typeof Ae != "object" || !("__html" in Ae))
            throw Error(n(61));
          L = Ae.__html, L != null && (typeof L == "string" && 0 < L.length && L[0] === `
` ? b.push(Cr, f(L)) : b.push(f("" + L)));
        }
        return typeof ie == "string" && ie[0] === `
` && b.push(Cr), ie;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        b.push(An(T));
        for (var to in L)
          if (A.call(L, to) && (ie = L[to], ie != null))
            switch (to) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(n(399, T));
              default:
                Wt(b, G, to, ie);
            }
        return b.push(Fn), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return Nr(b, L, T, G);
      case "html":
        return ce.insertionMode === 0 && b.push(Sn), Nr(b, L, T, G);
      default:
        if (T.indexOf("-") === -1 && typeof L.is != "string")
          return Nr(b, L, T, G);
        b.push(An(T)), Ae = ie = null;
        for (At in L)
          if (A.call(L, At) && (Me = L[At], Me != null))
            switch (At) {
              case "children":
                ie = Me;
                break;
              case "dangerouslySetInnerHTML":
                Ae = Me;
                break;
              case "style":
                ct(b, G, Me);
                break;
              case "suppressContentEditableWarning":
              case "suppressHydrationWarning":
                break;
              default:
                N(At) && typeof Me != "function" && typeof Me != "symbol" && b.push(lt, f(At), dt, f(Oe(Me)), Mt);
            }
        return b.push(Ht), Fr(b, Ae, ie), ie;
    }
  }
  var ii = p("</"), tr = p(">"), tn = p('<template id="'), co = p('"></template>'), Oo = p("<!--$-->"), uo = p('<!--$?--><template id="'), Do = p('"></template>'), fo = p("<!--$!-->"), xi = p("<!--/$-->"), Fo = p("<template"), Lr = p('"'), No = p(' data-dgst="');
  p(' data-msg="'), p(' data-stck="');
  var aa = p("></template>");
  function Nn(b, T, L) {
    if (o(b, uo), L === null)
      throw Error(n(395));
    return o(b, L), a(b, Do);
  }
  var Er = p('<div hidden id="'), Yn = p('">'), Bt = p("</div>"), Br = p('<svg aria-hidden="true" style="display:none" id="'), Mo = p('">'), Lo = p("</svg>"), Ar = p('<math aria-hidden="true" style="display:none" id="'), Bo = p('">'), Vr = p("</math>"), ln = p('<table hidden id="'), Ti = p('">'), Vo = p("</table>"), Pi = p('<table hidden><tbody id="'), cn = p('">'), ki = p("</tbody></table>"), Ba = p('<table hidden><tr id="'), Va = p('">'), X = p("</tr></table>"), ke = p('<table hidden><colgroup id="'), Ve = p('">'), at = p("</colgroup></table>");
  function St(b, T, L, G) {
    switch (L.insertionMode) {
      case 0:
      case 1:
        return o(b, Er), o(b, T.segmentPrefix), o(b, f(G.toString(16))), a(b, Yn);
      case 2:
        return o(b, Br), o(b, T.segmentPrefix), o(b, f(G.toString(16))), a(b, Mo);
      case 3:
        return o(b, Ar), o(b, T.segmentPrefix), o(b, f(G.toString(16))), a(b, Bo);
      case 4:
        return o(b, ln), o(b, T.segmentPrefix), o(b, f(G.toString(16))), a(b, Ti);
      case 5:
        return o(b, Pi), o(b, T.segmentPrefix), o(b, f(G.toString(16))), a(b, cn);
      case 6:
        return o(b, Ba), o(b, T.segmentPrefix), o(b, f(G.toString(16))), a(b, Va);
      case 7:
        return o(
          b,
          ke
        ), o(b, T.segmentPrefix), o(b, f(G.toString(16))), a(b, Ve);
      default:
        throw Error(n(397));
    }
  }
  function Ot(b, T) {
    switch (T.insertionMode) {
      case 0:
      case 1:
        return a(b, Bt);
      case 2:
        return a(b, Lo);
      case 3:
        return a(b, Vr);
      case 4:
        return a(b, Vo);
      case 5:
        return a(b, ki);
      case 6:
        return a(b, X);
      case 7:
        return a(b, at);
      default:
        throw Error(n(397));
    }
  }
  var Tt = p('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), Et = p('$RS("'), vn = p('","'), Kt = p('")<\/script>'), Xt = p('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), pn = p('$RC("'), Un = p('","'), go = p('")<\/script>'), an = p('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), bn = p('$RX("'), po = p('"'), qr = p(")<\/script>"), Mn = p(","), Ri = /[<\u2028\u2029]/g;
  function _r(b) {
    return JSON.stringify(b).replace(Ri, function(T) {
      switch (T) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  var ho = Object.assign, pr = Symbol.for("react.element"), jo = Symbol.for("react.portal"), ai = Symbol.for("react.fragment"), sa = Symbol.for("react.strict_mode"), la = Symbol.for("react.profiler"), Oi = Symbol.for("react.provider"), mo = Symbol.for("react.context"), ja = Symbol.for("react.forward_ref"), Di = Symbol.for("react.suspense"), Uo = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), P = Symbol.for("react.lazy"), V = Symbol.for("react.scope"), H = Symbol.for("react.debug_trace_mode"), le = Symbol.for("react.legacy_hidden"), ne = Symbol.for("react.default_value"), ye = Symbol.iterator;
  function Ne(b) {
    if (b == null)
      return null;
    if (typeof b == "function")
      return b.displayName || b.name || null;
    if (typeof b == "string")
      return b;
    switch (b) {
      case ai:
        return "Fragment";
      case jo:
        return "Portal";
      case la:
        return "Profiler";
      case sa:
        return "StrictMode";
      case Di:
        return "Suspense";
      case Uo:
        return "SuspenseList";
    }
    if (typeof b == "object")
      switch (b.$$typeof) {
        case mo:
          return (b.displayName || "Context") + ".Consumer";
        case Oi:
          return (b._context.displayName || "Context") + ".Provider";
        case ja:
          var T = b.render;
          return b = b.displayName, b || (b = T.displayName || T.name || "", b = b !== "" ? "ForwardRef(" + b + ")" : "ForwardRef"), b;
        case v:
          return T = b.displayName || null, T !== null ? T : Ne(b.type) || "Memo";
        case P:
          T = b._payload, b = b._init;
          try {
            return Ne(b(T));
          } catch {
          }
      }
    return null;
  }
  var Qe = {};
  function nt(b, T) {
    if (b = b.contextTypes, !b)
      return Qe;
    var L = {}, G;
    for (G in b)
      L[G] = T[G];
    return L;
  }
  var et = null;
  function jt(b, T) {
    if (b !== T) {
      b.context._currentValue = b.parentValue, b = b.parent;
      var L = T.parent;
      if (b === null) {
        if (L !== null)
          throw Error(n(401));
      } else {
        if (L === null)
          throw Error(n(401));
        jt(b, L);
      }
      T.context._currentValue = T.value;
    }
  }
  function Sr(b) {
    b.context._currentValue = b.parentValue, b = b.parent, b !== null && Sr(b);
  }
  function zn(b) {
    var T = b.parent;
    T !== null && zn(T), b.context._currentValue = b.value;
  }
  function Zn(b, T) {
    if (b.context._currentValue = b.parentValue, b = b.parent, b === null)
      throw Error(n(402));
    b.depth === T.depth ? jt(b, T) : Zn(b, T);
  }
  function vo(b, T) {
    var L = T.parent;
    if (L === null)
      throw Error(n(402));
    b.depth === L.depth ? jt(b, L) : vo(b, L), T.context._currentValue = T.value;
  }
  function jr(b) {
    var T = et;
    T !== b && (T === null ? zn(b) : b === null ? Sr(T) : T.depth === b.depth ? jt(T, b) : T.depth > b.depth ? Zn(T, b) : vo(T, b), et = b);
  }
  var ca = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(b, T) {
    b = b._reactInternals, b.queue !== null && b.queue.push(T);
  }, enqueueReplaceState: function(b, T) {
    b = b._reactInternals, b.replace = !0, b.queue = [T];
  }, enqueueForceUpdate: function() {
  } };
  function si(b, T, L, G) {
    var ce = b.state !== void 0 ? b.state : null;
    b.updater = ca, b.props = L, b.state = ce;
    var ie = { queue: [], replace: !1 };
    b._reactInternals = ie;
    var Ae = T.contextType;
    if (b.context = typeof Ae == "object" && Ae !== null ? Ae._currentValue : G, Ae = T.getDerivedStateFromProps, typeof Ae == "function" && (Ae = Ae(L, ce), ce = Ae == null ? ce : ho({}, ce, Ae), b.state = ce), typeof T.getDerivedStateFromProps != "function" && typeof b.getSnapshotBeforeUpdate != "function" && (typeof b.UNSAFE_componentWillMount == "function" || typeof b.componentWillMount == "function"))
      if (T = b.state, typeof b.componentWillMount == "function" && b.componentWillMount(), typeof b.UNSAFE_componentWillMount == "function" && b.UNSAFE_componentWillMount(), T !== b.state && ca.enqueueReplaceState(b, b.state, null), ie.queue !== null && 0 < ie.queue.length)
        if (T = ie.queue, Ae = ie.replace, ie.queue = null, ie.replace = !1, Ae && T.length === 1)
          b.state = T[0];
        else {
          for (ie = Ae ? T[0] : b.state, ce = !0, Ae = Ae ? 1 : 0; Ae < T.length; Ae++) {
            var Me = T[Ae];
            Me = typeof Me == "function" ? Me.call(b, ie, L, G) : Me, Me != null && (ce ? (ce = !1, ie = ho({}, ie, Me)) : ho(ie, Me));
          }
          b.state = ie;
        }
      else
        ie.queue = null;
  }
  var Fi = { id: 1, overflow: "" };
  function bo(b, T, L) {
    var G = b.id;
    b = b.overflow;
    var ce = 32 - Ua(G) - 1;
    G &= ~(1 << ce), L += 1;
    var ie = 32 - Ua(T) + ce;
    if (30 < ie) {
      var Ae = ce - ce % 5;
      return ie = (G & (1 << Ae) - 1).toString(32), G >>= Ae, ce -= Ae, { id: 1 << 32 - Ua(T) + ce | L << ce | G, overflow: ie + b };
    }
    return { id: 1 << ie | L << ce | G, overflow: b };
  }
  var Ua = Math.clz32 ? Math.clz32 : dl, hu = Math.log, mu = Math.LN2;
  function dl(b) {
    return b >>>= 0, b === 0 ? 32 : 31 - (hu(b) / mu | 0) | 0;
  }
  function fl(b, T) {
    return b === T && (b !== 0 || 1 / b === 1 / T) || b !== b && T !== T;
  }
  var gl = typeof Object.is == "function" ? Object.is : fl, Wo = null, Wa = null, Cs = null, rn = null, Gt = !1, Pt = !1, Ni = 0, li = null, Es = 0;
  function ci() {
    if (Wo === null)
      throw Error(n(321));
    return Wo;
  }
  function $r() {
    if (0 < Es)
      throw Error(n(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function pl() {
    return rn === null ? Cs === null ? (Gt = !1, Cs = rn = $r()) : (Gt = !0, rn = Cs) : rn.next === null ? (Gt = !1, rn = rn.next = $r()) : (Gt = !0, rn = rn.next), rn;
  }
  function As() {
    Wa = Wo = null, Pt = !1, Cs = null, Es = 0, rn = li = null;
  }
  function dc(b, T) {
    return typeof T == "function" ? T(b) : T;
  }
  function Ln(b, T, L) {
    if (Wo = ci(), rn = pl(), Gt) {
      var G = rn.queue;
      if (T = G.dispatch, li !== null && (L = li.get(G), L !== void 0)) {
        li.delete(G), G = rn.memoizedState;
        do
          G = b(G, L.action), L = L.next;
        while (L !== null);
        return rn.memoizedState = G, [G, T];
      }
      return [rn.memoizedState, T];
    }
    return b = b === dc ? typeof T == "function" ? T() : T : L !== void 0 ? L(T) : T, rn.memoizedState = b, b = rn.queue = { last: null, dispatch: null }, b = b.dispatch = Mi.bind(null, Wo, b), [rn.memoizedState, b];
  }
  function Ss(b, T) {
    if (Wo = ci(), rn = pl(), T = T === void 0 ? null : T, rn !== null) {
      var L = rn.memoizedState;
      if (L !== null && T !== null) {
        var G = L[1];
        e:
          if (G === null)
            G = !1;
          else {
            for (var ce = 0; ce < G.length && ce < T.length; ce++)
              if (!gl(T[ce], G[ce])) {
                G = !1;
                break e;
              }
            G = !0;
          }
        if (G)
          return L[0];
      }
    }
    return b = b(), rn.memoizedState = [b, T], b;
  }
  function Mi(b, T, L) {
    if (25 <= Es)
      throw Error(n(301));
    if (b === Wo)
      if (Pt = !0, b = { action: L, next: null }, li === null && (li = /* @__PURE__ */ new Map()), L = li.get(T), L === void 0)
        li.set(T, b);
      else {
        for (T = L; T.next !== null; )
          T = T.next;
        T.next = b;
      }
  }
  function fc() {
    throw Error(n(394));
  }
  function ua() {
  }
  var nr = { readContext: function(b) {
    return b._currentValue;
  }, useContext: function(b) {
    return ci(), b._currentValue;
  }, useMemo: Ss, useReducer: Ln, useRef: function(b) {
    Wo = ci(), rn = pl();
    var T = rn.memoizedState;
    return T === null ? (b = { current: b }, rn.memoizedState = b) : T;
  }, useState: function(b) {
    return Ln(dc, b);
  }, useInsertionEffect: ua, useLayoutEffect: function() {
  }, useCallback: function(b, T) {
    return Ss(function() {
      return b;
    }, T);
  }, useImperativeHandle: ua, useEffect: ua, useDebugValue: ua, useDeferredValue: function(b) {
    return ci(), b;
  }, useTransition: function() {
    return ci(), [!1, fc];
  }, useId: function() {
    var b = Wa.treeContext, T = b.overflow;
    b = b.id, b = (b & ~(1 << 32 - Ua(b) - 1)).toString(32) + T;
    var L = Ha;
    if (L === null)
      throw Error(n(404));
    return T = Ni++, b = ":" + L.idPrefix + "R" + b, 0 < T && (b += "H" + T.toString(32)), b + ":";
  }, useMutableSource: function(b, T) {
    return ci(), T(b._source);
  }, useSyncExternalStore: function(b, T, L) {
    if (L === void 0)
      throw Error(n(407));
    return L();
  } }, Ha = null, da = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function gc(b) {
    return console.error(b), null;
  }
  function fa() {
  }
  function ws(b, T, L, G, ce, ie, Ae, Me, qe) {
    var At = [], pt = /* @__PURE__ */ new Set();
    return T = { destination: null, responseState: T, progressiveChunkSize: G === void 0 ? 12800 : G, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: pt, pingedTasks: At, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: ce === void 0 ? gc : ce, onAllReady: ie === void 0 ? fa : ie, onShellReady: Ae === void 0 ? fa : Ae, onShellError: Me === void 0 ? fa : Me, onFatalError: qe === void 0 ? fa : qe }, L = Bn(T, 0, null, L, !1, !1), L.parentFlushed = !0, b = Is(T, b, null, L, pt, Qe, null, Fi), At.push(b), T;
  }
  function Is(b, T, L, G, ce, ie, Ae, Me) {
    b.allPendingTasks++, L === null ? b.pendingRootTasks++ : L.pendingTasks++;
    var qe = { node: T, ping: function() {
      var At = b.pingedTasks;
      At.push(qe), At.length === 1 && vc(b);
    }, blockedBoundary: L, blockedSegment: G, abortSet: ce, legacyContext: ie, context: Ae, treeContext: Me };
    return ce.add(qe), qe;
  }
  function Bn(b, T, L, G, ce, ie) {
    return { status: 0, id: -1, index: T, parentFlushed: !1, chunks: [], children: [], formatContext: G, boundary: L, lastPushedText: ce, textEmbedded: ie };
  }
  function ga(b, T) {
    if (b = b.onError(T), b != null && typeof b != "string")
      throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof b + '" instead');
    return b;
  }
  function rr(b, T) {
    var L = b.onShellError;
    L(T), L = b.onFatalError, L(T), b.destination !== null ? (b.status = 2, y(b.destination, T)) : (b.status = 1, b.fatalError = T);
  }
  function pc(b, T, L, G, ce) {
    for (Wo = {}, Wa = T, Ni = 0, b = L(G, ce); Pt; )
      Pt = !1, Ni = 0, Es += 1, rn = null, b = L(G, ce);
    return As(), b;
  }
  function xs(b, T, L, G) {
    var ce = L.render(), ie = G.childContextTypes;
    if (ie != null) {
      var Ae = T.legacyContext;
      if (typeof L.getChildContext != "function")
        G = Ae;
      else {
        L = L.getChildContext();
        for (var Me in L)
          if (!(Me in ie))
            throw Error(n(108, Ne(G) || "Unknown", Me));
        G = ho({}, Ae, L);
      }
      T.legacyContext = G, or(b, T, ce), T.legacyContext = Ae;
    } else
      or(b, T, ce);
  }
  function Ho(b, T) {
    if (b && b.defaultProps) {
      T = ho({}, T), b = b.defaultProps;
      for (var L in b)
        T[L] === void 0 && (T[L] = b[L]);
      return T;
    }
    return T;
  }
  function Li(b, T, L, G, ce) {
    if (typeof L == "function")
      if (L.prototype && L.prototype.isReactComponent) {
        ce = nt(L, T.legacyContext);
        var ie = L.contextType;
        ie = new L(G, typeof ie == "object" && ie !== null ? ie._currentValue : ce), si(ie, L, G, ce), xs(b, T, ie, L);
      } else {
        ie = nt(L, T.legacyContext), ce = pc(b, T, L, G, ie);
        var Ae = Ni !== 0;
        if (typeof ce == "object" && ce !== null && typeof ce.render == "function" && ce.$$typeof === void 0)
          si(ce, L, G, ie), xs(b, T, ce, L);
        else if (Ae) {
          G = T.treeContext, T.treeContext = bo(G, 1, 0);
          try {
            or(b, T, ce);
          } finally {
            T.treeContext = G;
          }
        } else
          or(b, T, ce);
      }
    else if (typeof L == "string") {
      switch (ce = T.blockedSegment, ie = Mr(ce.chunks, L, G, b.responseState, ce.formatContext), ce.lastPushedText = !1, Ae = ce.formatContext, ce.formatContext = me(Ae, L, G), eo(b, T, ie), ce.formatContext = Ae, L) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          ce.chunks.push(ii, f(L), tr);
      }
      ce.lastPushedText = !1;
    } else {
      switch (L) {
        case le:
        case H:
        case sa:
        case la:
        case ai:
          or(b, T, G.children);
          return;
        case Uo:
          or(b, T, G.children);
          return;
        case V:
          throw Error(n(343));
        case Di:
          e: {
            L = T.blockedBoundary, ce = T.blockedSegment, ie = G.fallback, G = G.children, Ae = /* @__PURE__ */ new Set();
            var Me = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: Ae, errorDigest: null }, qe = Bn(b, ce.chunks.length, Me, ce.formatContext, !1, !1);
            ce.children.push(qe), ce.lastPushedText = !1;
            var At = Bn(b, 0, null, ce.formatContext, !1, !1);
            At.parentFlushed = !0, T.blockedBoundary = Me, T.blockedSegment = At;
            try {
              if (eo(
                b,
                T,
                G
              ), At.lastPushedText && At.textEmbedded && At.chunks.push(Le), At.status = 1, pa(Me, At), Me.pendingTasks === 0)
                break e;
            } catch (pt) {
              At.status = 4, Me.forceClientRender = !0, Me.errorDigest = ga(b, pt);
            } finally {
              T.blockedBoundary = L, T.blockedSegment = ce;
            }
            T = Is(b, ie, L, qe, Ae, T.legacyContext, T.context, T.treeContext), b.pingedTasks.push(T);
          }
          return;
      }
      if (typeof L == "object" && L !== null)
        switch (L.$$typeof) {
          case ja:
            if (G = pc(b, T, L.render, G, ce), Ni !== 0) {
              L = T.treeContext, T.treeContext = bo(L, 1, 0);
              try {
                or(b, T, G);
              } finally {
                T.treeContext = L;
              }
            } else
              or(b, T, G);
            return;
          case v:
            L = L.type, G = Ho(L, G), Li(b, T, L, G, ce);
            return;
          case Oi:
            if (ce = G.children, L = L._context, G = G.value, ie = L._currentValue, L._currentValue = G, Ae = et, et = G = { parent: Ae, depth: Ae === null ? 0 : Ae.depth + 1, context: L, parentValue: ie, value: G }, T.context = G, or(b, T, ce), b = et, b === null)
              throw Error(n(403));
            G = b.parentValue, b.context._currentValue = G === ne ? b.context._defaultValue : G, b = et = b.parent, T.context = b;
            return;
          case mo:
            G = G.children, G = G(L._currentValue), or(b, T, G);
            return;
          case P:
            ce = L._init, L = ce(L._payload), G = Ho(L, G), Li(b, T, L, G, void 0);
            return;
        }
      throw Error(n(
        130,
        L == null ? L : typeof L,
        ""
      ));
    }
  }
  function or(b, T, L) {
    if (T.node = L, typeof L == "object" && L !== null) {
      switch (L.$$typeof) {
        case pr:
          Li(b, T, L.type, L.props, L.ref);
          return;
        case jo:
          throw Error(n(257));
        case P:
          var G = L._init;
          L = G(L._payload), or(b, T, L);
          return;
      }
      if (Se(L)) {
        sn(b, T, L);
        return;
      }
      if (L === null || typeof L != "object" ? G = null : (G = ye && L[ye] || L["@@iterator"], G = typeof G == "function" ? G : null), G && (G = G.call(L))) {
        if (L = G.next(), !L.done) {
          var ce = [];
          do
            ce.push(L.value), L = G.next();
          while (!L.done);
          sn(b, T, ce);
        }
        return;
      }
      throw b = Object.prototype.toString.call(L), Error(n(31, b === "[object Object]" ? "object with keys {" + Object.keys(L).join(", ") + "}" : b));
    }
    typeof L == "string" ? (G = T.blockedSegment, G.lastPushedText = Je(T.blockedSegment.chunks, L, b.responseState, G.lastPushedText)) : typeof L == "number" && (G = T.blockedSegment, G.lastPushedText = Je(T.blockedSegment.chunks, "" + L, b.responseState, G.lastPushedText));
  }
  function sn(b, T, L) {
    for (var G = L.length, ce = 0; ce < G; ce++) {
      var ie = T.treeContext;
      T.treeContext = bo(ie, G, ce);
      try {
        eo(b, T, L[ce]);
      } finally {
        T.treeContext = ie;
      }
    }
  }
  function eo(b, T, L) {
    var G = T.blockedSegment.formatContext, ce = T.legacyContext, ie = T.context;
    try {
      return or(b, T, L);
    } catch (qe) {
      if (As(), typeof qe == "object" && qe !== null && typeof qe.then == "function") {
        L = qe;
        var Ae = T.blockedSegment, Me = Bn(b, Ae.chunks.length, null, Ae.formatContext, Ae.lastPushedText, !0);
        Ae.children.push(Me), Ae.lastPushedText = !1, b = Is(b, T.node, T.blockedBoundary, Me, T.abortSet, T.legacyContext, T.context, T.treeContext).ping, L.then(b, b), T.blockedSegment.formatContext = G, T.legacyContext = ce, T.context = ie, jr(ie);
      } else
        throw T.blockedSegment.formatContext = G, T.legacyContext = ce, T.context = ie, jr(ie), qe;
    }
  }
  function hl(b) {
    var T = b.blockedBoundary;
    b = b.blockedSegment, b.status = 3, mc(this, T, b);
  }
  function hc(b, T, L) {
    var G = b.blockedBoundary;
    b.blockedSegment.status = 3, G === null ? (T.allPendingTasks--, T.status !== 2 && (T.status = 2, T.destination !== null && T.destination.close())) : (G.pendingTasks--, G.forceClientRender || (G.forceClientRender = !0, b = L === void 0 ? Error(n(432)) : L, G.errorDigest = T.onError(b), G.parentFlushed && T.clientRenderedBoundaries.push(G)), G.fallbackAbortableTasks.forEach(function(ce) {
      return hc(ce, T, L);
    }), G.fallbackAbortableTasks.clear(), T.allPendingTasks--, T.allPendingTasks === 0 && (G = T.onAllReady, G()));
  }
  function pa(b, T) {
    if (T.chunks.length === 0 && T.children.length === 1 && T.children[0].boundary === null) {
      var L = T.children[0];
      L.id = T.id, L.parentFlushed = !0, L.status === 1 && pa(b, L);
    } else
      b.completedSegments.push(T);
  }
  function mc(b, T, L) {
    if (T === null) {
      if (L.parentFlushed) {
        if (b.completedRootSegment !== null)
          throw Error(n(389));
        b.completedRootSegment = L;
      }
      b.pendingRootTasks--, b.pendingRootTasks === 0 && (b.onShellError = fa, T = b.onShellReady, T());
    } else
      T.pendingTasks--, T.forceClientRender || (T.pendingTasks === 0 ? (L.parentFlushed && L.status === 1 && pa(T, L), T.parentFlushed && b.completedBoundaries.push(T), T.fallbackAbortableTasks.forEach(hl, b), T.fallbackAbortableTasks.clear()) : L.parentFlushed && L.status === 1 && (pa(T, L), T.completedSegments.length === 1 && T.parentFlushed && b.partialBoundaries.push(T)));
    b.allPendingTasks--, b.allPendingTasks === 0 && (b = b.onAllReady, b());
  }
  function vc(b) {
    if (b.status !== 2) {
      var T = et, L = da.current;
      da.current = nr;
      var G = Ha;
      Ha = b.responseState;
      try {
        var ce = b.pingedTasks, ie;
        for (ie = 0; ie < ce.length; ie++) {
          var Ae = ce[ie], Me = b, qe = Ae.blockedSegment;
          if (qe.status === 0) {
            jr(Ae.context);
            try {
              or(Me, Ae, Ae.node), qe.lastPushedText && qe.textEmbedded && qe.chunks.push(Le), Ae.abortSet.delete(Ae), qe.status = 1, mc(Me, Ae.blockedBoundary, qe);
            } catch (no) {
              if (As(), typeof no == "object" && no !== null && typeof no.then == "function") {
                var At = Ae.ping;
                no.then(At, At);
              } else {
                Ae.abortSet.delete(Ae), qe.status = 4;
                var pt = Ae.blockedBoundary, on = no, hr = ga(Me, on);
                if (pt === null ? rr(Me, on) : (pt.pendingTasks--, pt.forceClientRender || (pt.forceClientRender = !0, pt.errorDigest = hr, pt.parentFlushed && Me.clientRenderedBoundaries.push(pt))), Me.allPendingTasks--, Me.allPendingTasks === 0) {
                  var to = Me.onAllReady;
                  to();
                }
              }
            } finally {
            }
          }
        }
        ce.splice(0, ie), b.destination !== null && Ps(b, b.destination);
      } catch (no) {
        ga(b, no), rr(b, no);
      } finally {
        Ha = G, da.current = L, L === nr && jr(T);
      }
    }
  }
  function Ts(b, T, L) {
    switch (L.parentFlushed = !0, L.status) {
      case 0:
        var G = L.id = b.nextSegmentId++;
        return L.lastPushedText = !1, L.textEmbedded = !1, b = b.responseState, o(T, tn), o(T, b.placeholderPrefix), b = f(G.toString(16)), o(T, b), a(T, co);
      case 1:
        L.status = 2;
        var ce = !0;
        G = L.chunks;
        var ie = 0;
        L = L.children;
        for (var Ae = 0; Ae < L.length; Ae++) {
          for (ce = L[Ae]; ie < ce.index; ie++)
            o(T, G[ie]);
          ce = Ga(b, T, ce);
        }
        for (; ie < G.length - 1; ie++)
          o(T, G[ie]);
        return ie < G.length && (ce = a(T, G[ie])), ce;
      default:
        throw Error(n(390));
    }
  }
  function Ga(b, T, L) {
    var G = L.boundary;
    if (G === null)
      return Ts(b, T, L);
    if (G.parentFlushed = !0, G.forceClientRender)
      G = G.errorDigest, a(T, fo), o(T, Fo), G && (o(T, No), o(T, f(Oe(G))), o(T, Lr)), a(T, aa), Ts(b, T, L);
    else if (0 < G.pendingTasks) {
      G.rootSegmentID = b.nextSegmentId++, 0 < G.completedSegments.length && b.partialBoundaries.push(G);
      var ce = b.responseState, ie = ce.nextSuspenseID++;
      ce = p(ce.boundaryPrefix + ie.toString(16)), G = G.id = ce, Nn(T, b.responseState, G), Ts(b, T, L);
    } else if (G.byteSize > b.progressiveChunkSize)
      G.rootSegmentID = b.nextSegmentId++, b.completedBoundaries.push(G), Nn(T, b.responseState, G.id), Ts(b, T, L);
    else {
      if (a(T, Oo), L = G.completedSegments, L.length !== 1)
        throw Error(n(391));
      Ga(b, T, L[0]);
    }
    return a(T, xi);
  }
  function Ya(b, T, L) {
    return St(T, b.responseState, L.formatContext, L.id), Ga(b, T, L), Ot(T, L.formatContext);
  }
  function Bi(b, T, L) {
    for (var G = L.completedSegments, ce = 0; ce < G.length; ce++)
      bc(b, T, L, G[ce]);
    if (G.length = 0, b = b.responseState, G = L.id, L = L.rootSegmentID, o(T, b.startInlineScript), b.sentCompleteBoundaryFunction ? o(T, pn) : (b.sentCompleteBoundaryFunction = !0, o(T, Xt)), G === null)
      throw Error(n(395));
    return L = f(L.toString(16)), o(T, G), o(T, Un), o(T, b.segmentPrefix), o(T, L), a(T, go);
  }
  function bc(b, T, L, G) {
    if (G.status === 2)
      return !0;
    var ce = G.id;
    if (ce === -1) {
      if ((G.id = L.rootSegmentID) === -1)
        throw Error(n(392));
      return Ya(b, T, G);
    }
    return Ya(b, T, G), b = b.responseState, o(T, b.startInlineScript), b.sentCompleteSegmentFunction ? o(T, Et) : (b.sentCompleteSegmentFunction = !0, o(T, Tt)), o(T, b.segmentPrefix), ce = f(ce.toString(16)), o(T, ce), o(T, vn), o(T, b.placeholderPrefix), o(T, ce), a(T, Kt);
  }
  function Ps(b, T) {
    t = new Uint8Array(512), r = 0;
    try {
      var L = b.completedRootSegment;
      if (L !== null && b.pendingRootTasks === 0) {
        Ga(b, T, L), b.completedRootSegment = null;
        var G = b.responseState.bootstrapChunks;
        for (L = 0; L < G.length - 1; L++)
          o(T, G[L]);
        L < G.length && a(T, G[L]);
      }
      var ce = b.clientRenderedBoundaries, ie;
      for (ie = 0; ie < ce.length; ie++) {
        var Ae = ce[ie];
        G = T;
        var Me = b.responseState, qe = Ae.id, At = Ae.errorDigest, pt = Ae.errorMessage, on = Ae.errorComponentStack;
        if (o(G, Me.startInlineScript), Me.sentClientRenderFunction ? o(G, bn) : (Me.sentClientRenderFunction = !0, o(
          G,
          an
        )), qe === null)
          throw Error(n(395));
        o(G, qe), o(G, po), (At || pt || on) && (o(G, Mn), o(G, f(_r(At || "")))), (pt || on) && (o(G, Mn), o(G, f(_r(pt || "")))), on && (o(G, Mn), o(G, f(_r(on)))), a(G, qr);
      }
      ce.splice(0, ie);
      var hr = b.completedBoundaries;
      for (ie = 0; ie < hr.length; ie++)
        Bi(b, T, hr[ie]);
      hr.splice(0, ie), l(T), t = new Uint8Array(512), r = 0;
      var to = b.partialBoundaries;
      for (ie = 0; ie < to.length; ie++) {
        var no = to[ie];
        e: {
          ce = b, Ae = T;
          var ks = no.completedSegments;
          for (Me = 0; Me < ks.length; Me++)
            if (!bc(
              ce,
              Ae,
              no,
              ks[Me]
            )) {
              Me++, ks.splice(0, Me);
              var yc = !1;
              break e;
            }
          ks.splice(0, Me), yc = !0;
        }
        if (!yc) {
          b.destination = null, ie++, to.splice(0, ie);
          return;
        }
      }
      to.splice(0, ie);
      var vl = b.completedBoundaries;
      for (ie = 0; ie < vl.length; ie++)
        Bi(b, T, vl[ie]);
      vl.splice(0, ie);
    } finally {
      l(T), b.allPendingTasks === 0 && b.pingedTasks.length === 0 && b.clientRenderedBoundaries.length === 0 && b.completedBoundaries.length === 0 && T.close();
    }
  }
  function ml(b, T) {
    try {
      var L = b.abortableTasks;
      L.forEach(function(G) {
        return hc(G, b, T);
      }), L.clear(), b.destination !== null && Ps(b, b.destination);
    } catch (G) {
      ga(b, G), rr(b, G);
    }
  }
  return Op.renderToReadableStream = function(b, T) {
    return new Promise(function(L, G) {
      var ce, ie, Ae = new Promise(function(pt, on) {
        ie = pt, ce = on;
      }), Me = ws(b, ue(T ? T.identifierPrefix : void 0, T ? T.nonce : void 0, T ? T.bootstrapScriptContent : void 0, T ? T.bootstrapScripts : void 0, T ? T.bootstrapModules : void 0), Q(T ? T.namespaceURI : void 0), T ? T.progressiveChunkSize : void 0, T ? T.onError : void 0, ie, function() {
        var pt = new ReadableStream({ type: "bytes", pull: function(on) {
          if (Me.status === 1)
            Me.status = 2, y(on, Me.fatalError);
          else if (Me.status !== 2 && Me.destination === null) {
            Me.destination = on;
            try {
              Ps(Me, on);
            } catch (hr) {
              ga(Me, hr), rr(Me, hr);
            }
          }
        }, cancel: function() {
          ml(Me);
        } }, { highWaterMark: 0 });
        pt.allReady = Ae, L(pt);
      }, function(pt) {
        Ae.catch(function() {
        }), G(pt);
      }, ce);
      if (T && T.signal) {
        var qe = T.signal, At = function() {
          ml(Me, qe.reason), qe.removeEventListener("abort", At);
        };
        qe.addEventListener("abort", At);
      }
      vc(Me);
    });
  }, Op.version = "18.2.0", Op;
}
var cd = {};
/**
 * @license React
 * react-dom-server-legacy.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lA;
function a7() {
  return lA || (lA = 1, process.env.NODE_ENV !== "production" && function() {
    var e = $o, n = "18.2.0", t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(c) {
      {
        for (var h = arguments.length, C = new Array(h > 1 ? h - 1 : 0), x = 1; x < h; x++)
          C[x - 1] = arguments[x];
        a("warn", c, C);
      }
    }
    function o(c) {
      {
        for (var h = arguments.length, C = new Array(h > 1 ? h - 1 : 0), x = 1; x < h; x++)
          C[x - 1] = arguments[x];
        a("error", c, C);
      }
    }
    function a(c, h, C) {
      {
        var x = t.ReactDebugCurrentFrame, M = x.getStackAddendum();
        M !== "" && (h += "%s", C = C.concat([M]));
        var Y = C.map(function(J) {
          return String(J);
        });
        Y.unshift("Warning: " + h), Function.prototype.apply.call(console[c], console, Y);
      }
    }
    function l(c) {
      c();
    }
    function u(c) {
    }
    function f(c, h) {
      p(c, h);
    }
    function p(c, h) {
      return c.push(h);
    }
    function y(c) {
    }
    function A(c) {
      c.push(null);
    }
    function w(c) {
      return c;
    }
    function F(c) {
      return c;
    }
    function j(c, h) {
      c.destroy(h);
    }
    function N(c) {
      {
        var h = typeof Symbol == "function" && Symbol.toStringTag, C = h && c[Symbol.toStringTag] || c.constructor.name || "Object";
        return C;
      }
    }
    function D(c) {
      try {
        return k(c), !1;
      } catch {
        return !0;
      }
    }
    function k(c) {
      return "" + c;
    }
    function z(c, h) {
      if (D(c))
        return o("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", h, N(c)), k(c);
    }
    function q(c, h) {
      if (D(c))
        return o("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", h, N(c)), k(c);
    }
    function Ce(c) {
      if (D(c))
        return o("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", N(c)), k(c);
    }
    var ee = Object.prototype.hasOwnProperty, Fe = 0, Oe = 1, He = 2, Re = 3, Se = 4, we = 5, ae = 6, ge = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", Ie = ge + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", Ye = new RegExp("^[" + ge + "][" + Ie + "]*$"), Ke = {}, ze = {};
    function ue(c) {
      return ee.call(ze, c) ? !0 : ee.call(Ke, c) ? !1 : Ye.test(c) ? (ze[c] = !0, !0) : (Ke[c] = !0, o("Invalid attribute name: `%s`", c), !1);
    }
    function de(c, h, C, x) {
      if (C !== null && C.type === Fe)
        return !1;
      switch (typeof h) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (x)
            return !1;
          if (C !== null)
            return !C.acceptsBooleans;
          var M = c.toLowerCase().slice(0, 5);
          return M !== "data-" && M !== "aria-";
        }
        default:
          return !1;
      }
    }
    function Q(c) {
      return Le.hasOwnProperty(c) ? Le[c] : null;
    }
    function me(c, h, C, x, M, Y, J) {
      this.acceptsBooleans = h === He || h === Re || h === Se, this.attributeName = x, this.attributeNamespace = M, this.mustUseProperty = C, this.propertyName = c, this.type = h, this.sanitizeURL = Y, this.removeEmptyString = J;
    }
    var Le = {}, Je = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    Je.forEach(function(c) {
      Le[c] = new me(
        c,
        Fe,
        !1,
        // mustUseProperty
        c,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(c) {
      var h = c[0], C = c[1];
      Le[h] = new me(
        h,
        Oe,
        !1,
        // mustUseProperty
        C,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(c) {
      Le[c] = new me(
        c,
        He,
        !1,
        // mustUseProperty
        c.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(c) {
      Le[c] = new me(
        c,
        He,
        !1,
        // mustUseProperty
        c,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(c) {
      Le[c] = new me(
        c,
        Re,
        !1,
        // mustUseProperty
        c.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(c) {
      Le[c] = new me(
        c,
        Re,
        !0,
        // mustUseProperty
        c,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(c) {
      Le[c] = new me(
        c,
        Se,
        !1,
        // mustUseProperty
        c,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(c) {
      Le[c] = new me(
        c,
        ae,
        !1,
        // mustUseProperty
        c,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(c) {
      Le[c] = new me(
        c,
        we,
        !1,
        // mustUseProperty
        c.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Xe = /[\-\:]([a-z])/g, je = function(c) {
      return c[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(c) {
      var h = c.replace(Xe, je);
      Le[h] = new me(
        h,
        Oe,
        !1,
        // mustUseProperty
        c,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(c) {
      var h = c.replace(Xe, je);
      Le[h] = new me(
        h,
        Oe,
        !1,
        // mustUseProperty
        c,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(c) {
      var h = c.replace(Xe, je);
      Le[h] = new me(
        h,
        Oe,
        !1,
        // mustUseProperty
        c,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(c) {
      Le[c] = new me(
        c,
        Oe,
        !1,
        // mustUseProperty
        c.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Ue = "xlinkHref";
    Le[Ue] = new me(
      "xlinkHref",
      Oe,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(c) {
      Le[c] = new me(
        c,
        Oe,
        !1,
        // mustUseProperty
        c.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var it = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function ct(c, h) {
      return c + h.charAt(0).toUpperCase() + h.substring(1);
    }
    var lt = ["Webkit", "ms", "Moz", "O"];
    Object.keys(it).forEach(function(c) {
      lt.forEach(function(h) {
        it[ct(h, c)] = it[c];
      });
    });
    var dt = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function Mt(c, h) {
      dt[h.type] || h.onChange || h.onInput || h.readOnly || h.disabled || h.value == null || o("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), h.onChange || h.readOnly || h.disabled || h.checked == null || o("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function Be(c, h) {
      if (c.indexOf("-") === -1)
        return typeof h.is == "string";
      switch (c) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Wt = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, Ht = {}, Fn = new RegExp("^(aria)-[" + Ie + "]*$"), Fr = new RegExp("^(aria)[A-Z][" + Ie + "]*$");
    function $n(c, h) {
      {
        if (ee.call(Ht, h) && Ht[h])
          return !0;
        if (Fr.test(h)) {
          var C = "aria-" + h.slice(4).toLowerCase(), x = Wt.hasOwnProperty(C) ? C : null;
          if (x == null)
            return o("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", h), Ht[h] = !0, !0;
          if (h !== x)
            return o("Invalid ARIA attribute `%s`. Did you mean `%s`?", h, x), Ht[h] = !0, !0;
        }
        if (Fn.test(h)) {
          var M = h.toLowerCase(), Y = Wt.hasOwnProperty(M) ? M : null;
          if (Y == null)
            return Ht[h] = !0, !1;
          if (h !== Y)
            return o("Unknown ARIA attribute `%s`. Did you mean `%s`?", h, Y), Ht[h] = !0, !0;
        }
      }
      return !0;
    }
    function er(c, h) {
      {
        var C = [];
        for (var x in h) {
          var M = $n(c, x);
          M || C.push(x);
        }
        var Y = C.map(function(J) {
          return "`" + J + "`";
        }).join(", ");
        C.length === 1 ? o("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", Y, c) : C.length > 1 && o("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", Y, c);
      }
    }
    function Nr(c, h) {
      Be(c, h) || er(c, h);
    }
    var Cr = !1;
    function Gn(c, h) {
      {
        if (c !== "input" && c !== "textarea" && c !== "select")
          return;
        h != null && h.value === null && !Cr && (Cr = !0, c === "select" && h.multiple ? o("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", c) : o("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", c));
      }
    }
    var Rn = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, An = function() {
    };
    {
      var Sn = {}, Mr = /^on./, ii = /^on[^A-Z]/, tr = new RegExp("^(aria)-[" + Ie + "]*$"), tn = new RegExp("^(aria)[A-Z][" + Ie + "]*$");
      An = function(c, h, C, x) {
        if (ee.call(Sn, h) && Sn[h])
          return !0;
        var M = h.toLowerCase();
        if (M === "onfocusin" || M === "onfocusout")
          return o("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), Sn[h] = !0, !0;
        if (x != null) {
          var Y = x.registrationNameDependencies, J = x.possibleRegistrationNames;
          if (Y.hasOwnProperty(h))
            return !0;
          var fe = J.hasOwnProperty(M) ? J[M] : null;
          if (fe != null)
            return o("Invalid event handler property `%s`. Did you mean `%s`?", h, fe), Sn[h] = !0, !0;
          if (Mr.test(h))
            return o("Unknown event handler property `%s`. It will be ignored.", h), Sn[h] = !0, !0;
        } else if (Mr.test(h))
          return ii.test(h) && o("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", h), Sn[h] = !0, !0;
        if (tr.test(h) || tn.test(h))
          return !0;
        if (M === "innerhtml")
          return o("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), Sn[h] = !0, !0;
        if (M === "aria")
          return o("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), Sn[h] = !0, !0;
        if (M === "is" && C !== null && C !== void 0 && typeof C != "string")
          return o("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof C), Sn[h] = !0, !0;
        if (typeof C == "number" && isNaN(C))
          return o("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", h), Sn[h] = !0, !0;
        var Pe = Q(h), We = Pe !== null && Pe.type === Fe;
        if (Rn.hasOwnProperty(M)) {
          var _e = Rn[M];
          if (_e !== h)
            return o("Invalid DOM property `%s`. Did you mean `%s`?", h, _e), Sn[h] = !0, !0;
        } else if (!We && h !== M)
          return o("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", h, M), Sn[h] = !0, !0;
        return typeof C == "boolean" && de(h, C, Pe, !1) ? (C ? o('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', C, h, h, C, h) : o('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', C, h, h, C, h, h, h), Sn[h] = !0, !0) : We ? !0 : de(h, C, Pe, !1) ? (Sn[h] = !0, !1) : ((C === "false" || C === "true") && Pe !== null && Pe.type === Re && (o("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", C, h, C === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', h, C), Sn[h] = !0), !0);
      };
    }
    var co = function(c, h, C) {
      {
        var x = [];
        for (var M in h) {
          var Y = An(c, M, h[M], C);
          Y || x.push(M);
        }
        var J = x.map(function(fe) {
          return "`" + fe + "`";
        }).join(", ");
        x.length === 1 ? o("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", J, c) : x.length > 1 && o("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", J, c);
      }
    };
    function Oo(c, h, C) {
      Be(c, h) || co(c, h, C);
    }
    var uo = function() {
    };
    {
      var Do = /^(?:webkit|moz|o)[A-Z]/, fo = /^-ms-/, xi = /-(.)/g, Fo = /;\s*$/, Lr = {}, No = {}, aa = !1, Nn = !1, Er = function(c) {
        return c.replace(xi, function(h, C) {
          return C.toUpperCase();
        });
      }, Yn = function(c) {
        Lr.hasOwnProperty(c) && Lr[c] || (Lr[c] = !0, o(
          "Unsupported style property %s. Did you mean %s?",
          c,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Er(c.replace(fo, "ms-"))
        ));
      }, Bt = function(c) {
        Lr.hasOwnProperty(c) && Lr[c] || (Lr[c] = !0, o("Unsupported vendor-prefixed style property %s. Did you mean %s?", c, c.charAt(0).toUpperCase() + c.slice(1)));
      }, Br = function(c, h) {
        No.hasOwnProperty(h) && No[h] || (No[h] = !0, o(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, c, h.replace(Fo, "")));
      }, Mo = function(c, h) {
        aa || (aa = !0, o("`NaN` is an invalid value for the `%s` css style property.", c));
      }, Lo = function(c, h) {
        Nn || (Nn = !0, o("`Infinity` is an invalid value for the `%s` css style property.", c));
      };
      uo = function(c, h) {
        c.indexOf("-") > -1 ? Yn(c) : Do.test(c) ? Bt(c) : Fo.test(h) && Br(c, h), typeof h == "number" && (isNaN(h) ? Mo(c, h) : isFinite(h) || Lo(c, h));
      };
    }
    var Ar = uo, Bo = /["'&<>]/;
    function Vr(c) {
      Ce(c);
      var h = "" + c, C = Bo.exec(h);
      if (!C)
        return h;
      var x, M = "", Y, J = 0;
      for (Y = C.index; Y < h.length; Y++) {
        switch (h.charCodeAt(Y)) {
          case 34:
            x = "&quot;";
            break;
          case 38:
            x = "&amp;";
            break;
          case 39:
            x = "&#x27;";
            break;
          case 60:
            x = "&lt;";
            break;
          case 62:
            x = "&gt;";
            break;
          default:
            continue;
        }
        J !== Y && (M += h.substring(J, Y)), J = Y + 1, M += x;
      }
      return J !== Y ? M + h.substring(J, Y) : M;
    }
    function ln(c) {
      return typeof c == "boolean" || typeof c == "number" ? "" + c : Vr(c);
    }
    var Ti = /([A-Z])/g, Vo = /^ms-/;
    function Pi(c) {
      return c.replace(Ti, "-$1").toLowerCase().replace(Vo, "-ms-");
    }
    var cn = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, ki = !1;
    function Ba(c) {
      !ki && cn.test(c) && (ki = !0, o("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(c)));
    }
    var Va = Array.isArray;
    function X(c) {
      return Va(c);
    }
    var ke = "<script>", Ve = "<\/script>", at = '<script src="', St = '<script type="module" src="', Ot = '" async=""><\/script>';
    function Tt(c) {
      return Ce(c), ("" + c).replace(Et, vn);
    }
    var Et = /(<\/|<)(s)(cript)/gi, vn = function(c, h, C, x) {
      return "" + h + (C === "s" ? "\\u0073" : "\\u0053") + x;
    };
    function Kt(c, h, C, x, M) {
      var Y = c === void 0 ? "" : c, J = h === void 0 ? ke : '<script nonce="' + ln(h) + '">', fe = [];
      if (C !== void 0 && fe.push(J, Tt(C), Ve), x !== void 0)
        for (var Pe = 0; Pe < x.length; Pe++)
          fe.push(at, ln(x[Pe]), Ot);
      if (M !== void 0)
        for (var We = 0; We < M.length; We++)
          fe.push(St, ln(M[We]), Ot);
      return {
        bootstrapChunks: fe,
        startInlineScript: J,
        placeholderPrefix: Y + "P:",
        segmentPrefix: Y + "S:",
        boundaryPrefix: Y + "B:",
        idPrefix: Y,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
      };
    }
    var Xt = 0, pn = 1, Un = 2, go = 3, an = 4, bn = 5, po = 6, qr = 7;
    function Mn(c, h) {
      return {
        insertionMode: c,
        selectedValue: h
      };
    }
    function Ri(c, h, C) {
      switch (h) {
        case "select":
          return Mn(pn, C.value != null ? C.value : C.defaultValue);
        case "svg":
          return Mn(Un, null);
        case "math":
          return Mn(go, null);
        case "foreignObject":
          return Mn(pn, null);
        case "table":
          return Mn(an, null);
        case "thead":
        case "tbody":
        case "tfoot":
          return Mn(bn, null);
        case "colgroup":
          return Mn(qr, null);
        case "tr":
          return Mn(po, null);
      }
      return c.insertionMode >= an || c.insertionMode === Xt ? Mn(pn, null) : c;
    }
    var _r = null;
    function ho(c) {
      var h = c.nextSuspenseID++;
      return c.boundaryPrefix + h.toString(16);
    }
    function pr(c, h, C) {
      var x = c.idPrefix, M = ":" + x + "R" + h;
      return C > 0 && (M += "H" + C.toString(32)), M + ":";
    }
    function jo(c) {
      return ln(c);
    }
    var ai = "<!-- -->";
    function sa(c, h, C, x) {
      return h === "" ? x : (x && c.push(ai), c.push(jo(h)), !0);
    }
    function la(c, h, C, x) {
      C && x && c.push(ai);
    }
    var Oi = /* @__PURE__ */ new Map();
    function mo(c) {
      var h = Oi.get(c);
      if (h !== void 0)
        return h;
      var C = ln(Pi(c));
      return Oi.set(c, C), C;
    }
    var ja = ' style="', Di = ":", Uo = ";";
    function v(c, h, C) {
      if (typeof C != "object")
        throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      var x = !0;
      for (var M in C)
        if (ee.call(C, M)) {
          var Y = C[M];
          if (!(Y == null || typeof Y == "boolean" || Y === "")) {
            var J = void 0, fe = void 0, Pe = M.indexOf("--") === 0;
            Pe ? (J = ln(M), q(Y, M), fe = ln(("" + Y).trim())) : (Ar(M, Y), J = mo(M), typeof Y == "number" ? Y !== 0 && !ee.call(it, M) ? fe = Y + "px" : fe = "" + Y : (q(Y, M), fe = ln(("" + Y).trim()))), x ? (x = !1, c.push(ja, J, Di, fe)) : c.push(Uo, J, Di, fe);
          }
        }
      x || c.push(H);
    }
    var P = " ", V = '="', H = '"', le = '=""';
    function ne(c, h, C, x) {
      switch (C) {
        case "style": {
          v(c, h, x);
          return;
        }
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
          return;
      }
      if (
        // shouldIgnoreAttribute
        // We have already filtered out null/undefined and reserved words.
        !(C.length > 2 && (C[0] === "o" || C[0] === "O") && (C[1] === "n" || C[1] === "N"))
      ) {
        var M = Q(C);
        if (M !== null) {
          switch (typeof x) {
            case "function":
            case "symbol":
              return;
            case "boolean":
              if (!M.acceptsBooleans)
                return;
          }
          var Y = M.attributeName, J = Y;
          switch (M.type) {
            case Re:
              x && c.push(P, J, le);
              return;
            case Se:
              x === !0 ? c.push(P, J, le) : x === !1 || c.push(P, J, V, ln(x), H);
              return;
            case we:
              isNaN(x) || c.push(P, J, V, ln(x), H);
              break;
            case ae:
              !isNaN(x) && x >= 1 && c.push(P, J, V, ln(x), H);
              break;
            default:
              M.sanitizeURL && (z(x, Y), x = "" + x, Ba(x)), c.push(P, J, V, ln(x), H);
          }
        } else if (ue(C)) {
          switch (typeof x) {
            case "function":
            case "symbol":
              return;
            case "boolean": {
              var fe = C.toLowerCase().slice(0, 5);
              if (fe !== "data-" && fe !== "aria-")
                return;
            }
          }
          c.push(P, C, V, ln(x), H);
        }
      }
    }
    var ye = ">", Ne = "/>";
    function Qe(c, h, C) {
      if (h != null) {
        if (C != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof h != "object" || !("__html" in h))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var x = h.__html;
        x != null && (Ce(x), c.push("" + x));
      }
    }
    var nt = !1, et = !1, jt = !1, Sr = !1, zn = !1, Zn = !1, vo = !1;
    function jr(c, h) {
      {
        var C = c[h];
        if (C != null) {
          var x = X(C);
          c.multiple && !x ? o("The `%s` prop supplied to <select> must be an array if `multiple` is true.", h) : !c.multiple && x && o("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", h);
        }
      }
    }
    function ca(c, h, C) {
      Mt("select", h), jr(h, "value"), jr(h, "defaultValue"), h.value !== void 0 && h.defaultValue !== void 0 && !jt && (o("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), jt = !0), c.push(Pt("select"));
      var x = null, M = null;
      for (var Y in h)
        if (ee.call(h, Y)) {
          var J = h[Y];
          if (J == null)
            continue;
          switch (Y) {
            case "children":
              x = J;
              break;
            case "dangerouslySetInnerHTML":
              M = J;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              ne(c, C, Y, J);
              break;
          }
        }
      return c.push(ye), Qe(c, M, x), x;
    }
    function si(c) {
      var h = "";
      return e.Children.forEach(c, function(C) {
        C != null && (h += C, !zn && typeof C != "string" && typeof C != "number" && (zn = !0, o("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }), h;
    }
    var Fi = ' selected=""';
    function bo(c, h, C, x) {
      var M = x.selectedValue;
      c.push(Pt("option"));
      var Y = null, J = null, fe = null, Pe = null;
      for (var We in h)
        if (ee.call(h, We)) {
          var _e = h[We];
          if (_e == null)
            continue;
          switch (We) {
            case "children":
              Y = _e;
              break;
            case "selected":
              fe = _e, vo || (o("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), vo = !0);
              break;
            case "dangerouslySetInnerHTML":
              Pe = _e;
              break;
            case "value":
              J = _e;
            default:
              ne(c, C, We, _e);
              break;
          }
        }
      if (M != null) {
        var gt;
        if (J !== null ? (z(J, "value"), gt = "" + J) : (Pe !== null && (Zn || (Zn = !0, o("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."))), gt = si(Y)), X(M))
          for (var hn = 0; hn < M.length; hn++) {
            z(M[hn], "value");
            var Xn = "" + M[hn];
            if (Xn === gt) {
              c.push(Fi);
              break;
            }
          }
        else
          z(M, "select.value"), "" + M === gt && c.push(Fi);
      } else
        fe && c.push(Fi);
      return c.push(ye), Qe(c, Pe, Y), Y;
    }
    function Ua(c, h, C) {
      Mt("input", h), h.checked !== void 0 && h.defaultChecked !== void 0 && !et && (o("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", h.type), et = !0), h.value !== void 0 && h.defaultValue !== void 0 && !nt && (o("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", h.type), nt = !0), c.push(Pt("input"));
      var x = null, M = null, Y = null, J = null;
      for (var fe in h)
        if (ee.call(h, fe)) {
          var Pe = h[fe];
          if (Pe == null)
            continue;
          switch (fe) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            case "defaultChecked":
              J = Pe;
              break;
            case "defaultValue":
              M = Pe;
              break;
            case "checked":
              Y = Pe;
              break;
            case "value":
              x = Pe;
              break;
            default:
              ne(c, C, fe, Pe);
              break;
          }
        }
      return Y !== null ? ne(c, C, "checked", Y) : J !== null && ne(c, C, "checked", J), x !== null ? ne(c, C, "value", x) : M !== null && ne(c, C, "value", M), c.push(Ne), null;
    }
    function hu(c, h, C) {
      Mt("textarea", h), h.value !== void 0 && h.defaultValue !== void 0 && !Sr && (o("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Sr = !0), c.push(Pt("textarea"));
      var x = null, M = null, Y = null;
      for (var J in h)
        if (ee.call(h, J)) {
          var fe = h[J];
          if (fe == null)
            continue;
          switch (J) {
            case "children":
              Y = fe;
              break;
            case "value":
              x = fe;
              break;
            case "defaultValue":
              M = fe;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
            default:
              ne(c, C, J, fe);
              break;
          }
        }
      if (x === null && M !== null && (x = M), c.push(ye), Y != null) {
        if (o("Use the `defaultValue` or `value` props instead of setting children on <textarea>."), x != null)
          throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
        if (X(Y)) {
          if (Y.length > 1)
            throw new Error("<textarea> can only have at most one child.");
          Ce(Y[0]), x = "" + Y[0];
        }
        Ce(Y), x = "" + Y;
      }
      return typeof x == "string" && x[0] === `
` && c.push(Wa), x !== null && (z(x, "value"), c.push(jo("" + x))), null;
    }
    function mu(c, h, C, x) {
      c.push(Pt(C));
      for (var M in h)
        if (ee.call(h, M)) {
          var Y = h[M];
          if (Y == null)
            continue;
          switch (M) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error(C + " is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            default:
              ne(c, x, M, Y);
              break;
          }
        }
      return c.push(Ne), null;
    }
    function dl(c, h, C) {
      c.push(Pt("menuitem"));
      for (var x in h)
        if (ee.call(h, x)) {
          var M = h[x];
          if (M == null)
            continue;
          switch (x) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("menuitems cannot have `children` nor `dangerouslySetInnerHTML`.");
            default:
              ne(c, C, x, M);
              break;
          }
        }
      return c.push(ye), null;
    }
    function fl(c, h, C) {
      c.push(Pt("title"));
      var x = null;
      for (var M in h)
        if (ee.call(h, M)) {
          var Y = h[M];
          if (Y == null)
            continue;
          switch (M) {
            case "children":
              x = Y;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <title>.");
            default:
              ne(c, C, M, Y);
              break;
          }
        }
      c.push(ye);
      {
        var J = Array.isArray(x) && x.length < 2 ? x[0] || null : x;
        Array.isArray(x) && x.length > 1 ? o("A title element received an array with more than 1 element as children. In browsers title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : J != null && J.$$typeof != null ? o("A title element received a React element for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : J != null && typeof J != "string" && typeof J != "number" && o("A title element received a value that was not a string or number for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
      }
      return x;
    }
    function gl(c, h, C, x) {
      c.push(Pt(C));
      var M = null, Y = null;
      for (var J in h)
        if (ee.call(h, J)) {
          var fe = h[J];
          if (fe == null)
            continue;
          switch (J) {
            case "children":
              M = fe;
              break;
            case "dangerouslySetInnerHTML":
              Y = fe;
              break;
            default:
              ne(c, x, J, fe);
              break;
          }
        }
      return c.push(ye), Qe(c, Y, M), typeof M == "string" ? (c.push(jo(M)), null) : M;
    }
    function Wo(c, h, C, x) {
      c.push(Pt(C));
      var M = null, Y = null;
      for (var J in h)
        if (ee.call(h, J)) {
          var fe = h[J];
          if (fe == null)
            continue;
          switch (J) {
            case "children":
              M = fe;
              break;
            case "dangerouslySetInnerHTML":
              Y = fe;
              break;
            case "style":
              v(c, x, fe);
              break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
              break;
            default:
              ue(J) && typeof fe != "function" && typeof fe != "symbol" && c.push(P, J, V, ln(fe), H);
              break;
          }
        }
      return c.push(ye), Qe(c, Y, M), M;
    }
    var Wa = `
`;
    function Cs(c, h, C, x) {
      c.push(Pt(C));
      var M = null, Y = null;
      for (var J in h)
        if (ee.call(h, J)) {
          var fe = h[J];
          if (fe == null)
            continue;
          switch (J) {
            case "children":
              M = fe;
              break;
            case "dangerouslySetInnerHTML":
              Y = fe;
              break;
            default:
              ne(c, x, J, fe);
              break;
          }
        }
      if (c.push(ye), Y != null) {
        if (M != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof Y != "object" || !("__html" in Y))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var Pe = Y.__html;
        Pe != null && (typeof Pe == "string" && Pe.length > 0 && Pe[0] === `
` ? c.push(Wa, Pe) : (Ce(Pe), c.push("" + Pe)));
      }
      return typeof M == "string" && M[0] === `
` && c.push(Wa), M;
    }
    var rn = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Gt = /* @__PURE__ */ new Map();
    function Pt(c) {
      var h = Gt.get(c);
      if (h === void 0) {
        if (!rn.test(c))
          throw new Error("Invalid tag: " + c);
        h = "<" + c, Gt.set(c, h);
      }
      return h;
    }
    var Ni = "<!DOCTYPE html>";
    function li(c, h, C, x, M) {
      switch (Nr(h, C), Gn(h, C), Oo(h, C, null), !C.suppressContentEditableWarning && C.contentEditable && C.children != null && o("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), M.insertionMode !== Un && M.insertionMode !== go && h.indexOf("-") === -1 && typeof C.is != "string" && h.toLowerCase() !== h && o("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", h), h) {
        case "select":
          return ca(c, C, x);
        case "option":
          return bo(c, C, x, M);
        case "textarea":
          return hu(c, C, x);
        case "input":
          return Ua(c, C, x);
        case "menuitem":
          return dl(c, C, x);
        case "title":
          return fl(c, C, x);
        case "listing":
        case "pre":
          return Cs(c, C, h, x);
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          return mu(c, C, h, x);
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return gl(c, C, h, x);
        case "html":
          return M.insertionMode === Xt && c.push(Ni), gl(c, C, h, x);
        default:
          return h.indexOf("-") === -1 && typeof C.is != "string" ? gl(c, C, h, x) : Wo(c, C, h, x);
      }
    }
    var Es = "</", ci = ">";
    function $r(c, h, C) {
      switch (h) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          c.push(Es, h, ci);
      }
    }
    function pl(c, h) {
      for (var C = h.bootstrapChunks, x = 0; x < C.length - 1; x++)
        f(c, C[x]);
      return x < C.length ? p(c, C[x]) : !0;
    }
    var As = '<template id="', dc = '"></template>';
    function Ln(c, h, C) {
      f(c, As), f(c, h.placeholderPrefix);
      var x = C.toString(16);
      return f(c, x), p(c, dc);
    }
    var Ss = "<!--$-->", Mi = '<!--$?--><template id="', fc = '"></template>', ua = "<!--$!-->", nr = "<!--/$-->", Ha = "<template", da = '"', gc = ' data-dgst="', fa = ' data-msg="', ws = ' data-stck="', Is = "></template>";
    function Bn(c, h) {
      return p(c, Ss);
    }
    function ga(c, h, C) {
      if (f(c, Mi), C === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return f(c, C), p(c, fc);
    }
    function rr(c, h, C, x, M) {
      var Y;
      return Y = p(c, ua), f(c, Ha), C && (f(c, gc), f(c, ln(C)), f(c, da)), x && (f(c, fa), f(c, ln(x)), f(c, da)), M && (f(c, ws), f(c, ln(M)), f(c, da)), Y = p(c, Is), Y;
    }
    function pc(c, h) {
      return p(c, nr);
    }
    function xs(c, h) {
      return p(c, nr);
    }
    function Ho(c, h) {
      return p(c, nr);
    }
    var Li = '<div hidden id="', or = '">', sn = "</div>", eo = '<svg aria-hidden="true" style="display:none" id="', hl = '">', hc = "</svg>", pa = '<math aria-hidden="true" style="display:none" id="', mc = '">', vc = "</math>", Ts = '<table hidden id="', Ga = '">', Ya = "</table>", Bi = '<table hidden><tbody id="', bc = '">', Ps = "</tbody></table>", ml = '<table hidden><tr id="', b = '">', T = "</tr></table>", L = '<table hidden><colgroup id="', G = '">', ce = "</colgroup></table>";
    function ie(c, h, C, x) {
      switch (C.insertionMode) {
        case Xt:
        case pn:
          return f(c, Li), f(c, h.segmentPrefix), f(c, x.toString(16)), p(c, or);
        case Un:
          return f(c, eo), f(c, h.segmentPrefix), f(c, x.toString(16)), p(c, hl);
        case go:
          return f(c, pa), f(c, h.segmentPrefix), f(c, x.toString(16)), p(c, mc);
        case an:
          return f(c, Ts), f(c, h.segmentPrefix), f(c, x.toString(16)), p(c, Ga);
        case bn:
          return f(c, Bi), f(c, h.segmentPrefix), f(c, x.toString(16)), p(c, bc);
        case po:
          return f(c, ml), f(c, h.segmentPrefix), f(c, x.toString(16)), p(c, b);
        case qr:
          return f(c, L), f(c, h.segmentPrefix), f(c, x.toString(16)), p(c, G);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    function Ae(c, h) {
      switch (h.insertionMode) {
        case Xt:
        case pn:
          return p(c, sn);
        case Un:
          return p(c, hc);
        case go:
          return p(c, vc);
        case an:
          return p(c, Ya);
        case bn:
          return p(c, Ps);
        case po:
          return p(c, T);
        case qr:
          return p(c, ce);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    var Me = "function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}", qe = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}', At = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}', pt = Me + ';$RS("', on = '$RS("', hr = '","', to = '")<\/script>';
    function no(c, h, C) {
      f(c, h.startInlineScript), h.sentCompleteSegmentFunction ? f(c, on) : (h.sentCompleteSegmentFunction = !0, f(c, pt)), f(c, h.segmentPrefix);
      var x = C.toString(16);
      return f(c, x), f(c, hr), f(c, h.placeholderPrefix), f(c, x), p(c, to);
    }
    var ks = qe + ';$RC("', yc = '$RC("', vl = '","', Rs = '")<\/script>';
    function zf(c, h, C, x) {
      if (f(c, h.startInlineScript), h.sentCompleteBoundaryFunction ? f(c, yc) : (h.sentCompleteBoundaryFunction = !0, f(c, ks)), C === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      var M = x.toString(16);
      return f(c, C), f(c, vl), f(c, h.segmentPrefix), f(c, M), p(c, Rs);
    }
    var Zf = At + ';$RX("', vu = '$RX("', xd = '"', ha = ")<\/script>", Os = ",";
    function Kf(c, h, C, x, M, Y) {
      if (f(c, h.startInlineScript), h.sentClientRenderFunction ? f(c, vu) : (h.sentClientRenderFunction = !0, f(c, Zf)), C === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return f(c, C), f(c, xd), (x || M || Y) && (f(c, Os), f(c, bu(x || ""))), (M || Y) && (f(c, Os), f(c, bu(M || ""))), Y && (f(c, Os), f(c, bu(Y))), p(c, ha);
    }
    var Xf = /[<\u2028\u2029]/g;
    function bu(c) {
      var h = JSON.stringify(c);
      return h.replace(Xf, function(C) {
        switch (C) {
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw new Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
      });
    }
    function Ds(c, h) {
      var C = Kt(h, void 0);
      return {
        // Keep this in sync with ReactDOMServerFormatConfig
        bootstrapChunks: C.bootstrapChunks,
        startInlineScript: C.startInlineScript,
        placeholderPrefix: C.placeholderPrefix,
        segmentPrefix: C.segmentPrefix,
        boundaryPrefix: C.boundaryPrefix,
        idPrefix: C.idPrefix,
        nextSuspenseID: C.nextSuspenseID,
        sentCompleteSegmentFunction: C.sentCompleteSegmentFunction,
        sentCompleteBoundaryFunction: C.sentCompleteBoundaryFunction,
        sentClientRenderFunction: C.sentClientRenderFunction,
        // This is an extra field for the legacy renderer
        generateStaticMarkup: c
      };
    }
    function ro() {
      return {
        insertionMode: pn,
        // We skip the root mode because we don't want to emit the DOCTYPE in legacy mode.
        selectedValue: null
      };
    }
    function yu(c, h, C, x) {
      return C.generateStaticMarkup ? (c.push(ln(h)), !1) : sa(c, h, C, x);
    }
    function Td(c, h, C, x) {
      if (!h.generateStaticMarkup)
        return la(c, h, C, x);
    }
    function Cu(c, h) {
      return h.generateStaticMarkup ? !0 : Bn(c);
    }
    function yo(c, h, C, x, M) {
      return h.generateStaticMarkup ? !0 : rr(c, h, C, x, M);
    }
    function Jf(c, h) {
      return h.generateStaticMarkup ? !0 : pc(c);
    }
    function Pd(c, h) {
      return h.generateStaticMarkup ? !0 : Ho(c);
    }
    var Kn = Object.assign, te = Symbol.for("react.element"), Ee = Symbol.for("react.portal"), he = Symbol.for("react.fragment"), Ze = Symbol.for("react.strict_mode"), ht = Symbol.for("react.profiler"), Ut = Symbol.for("react.provider"), wn = Symbol.for("react.context"), Jt = Symbol.for("react.forward_ref"), ma = Symbol.for("react.suspense"), Eu = Symbol.for("react.suspense_list"), Ur = Symbol.for("react.memo"), za = Symbol.for("react.lazy"), Qf = Symbol.for("react.scope"), Za = Symbol.for("react.debug_trace_mode"), Cc = Symbol.for("react.legacy_hidden"), Ec = Symbol.for("react.default_value"), _t = Symbol.iterator, kd = "@@iterator";
    function yn(c) {
      if (c === null || typeof c != "object")
        return null;
      var h = _t && c[_t] || c[kd];
      return typeof h == "function" ? h : null;
    }
    function va(c, h, C) {
      var x = c.displayName;
      if (x)
        return x;
      var M = h.displayName || h.name || "";
      return M !== "" ? C + "(" + M + ")" : C;
    }
    function Au(c) {
      return c.displayName || "Context";
    }
    function Cn(c) {
      if (c == null)
        return null;
      if (typeof c.tag == "number" && o("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof c == "function")
        return c.displayName || c.name || null;
      if (typeof c == "string")
        return c;
      switch (c) {
        case he:
          return "Fragment";
        case Ee:
          return "Portal";
        case ht:
          return "Profiler";
        case Ze:
          return "StrictMode";
        case ma:
          return "Suspense";
        case Eu:
          return "SuspenseList";
      }
      if (typeof c == "object")
        switch (c.$$typeof) {
          case wn:
            var h = c;
            return Au(h) + ".Consumer";
          case Ut:
            var C = c;
            return Au(C._context) + ".Provider";
          case Jt:
            return va(c, c.render, "ForwardRef");
          case Ur:
            var x = c.displayName || null;
            return x !== null ? x : Cn(c.type) || "Memo";
          case za: {
            var M = c, Y = M._payload, J = M._init;
            try {
              return Cn(J(Y));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Fs = 0, Ns, ui, Ms, Ac, Ls, Su, wu;
    function Ka() {
    }
    Ka.__reactDisabledLog = !0;
    function Sc() {
      {
        if (Fs === 0) {
          Ns = console.log, ui = console.info, Ms = console.warn, Ac = console.error, Ls = console.group, Su = console.groupCollapsed, wu = console.groupEnd;
          var c = {
            configurable: !0,
            enumerable: !0,
            value: Ka,
            writable: !0
          };
          Object.defineProperties(console, {
            info: c,
            log: c,
            warn: c,
            error: c,
            group: c,
            groupCollapsed: c,
            groupEnd: c
          });
        }
        Fs++;
      }
    }
    function Vi() {
      {
        if (Fs--, Fs === 0) {
          var c = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Kn({}, c, {
              value: Ns
            }),
            info: Kn({}, c, {
              value: ui
            }),
            warn: Kn({}, c, {
              value: Ms
            }),
            error: Kn({}, c, {
              value: Ac
            }),
            group: Kn({}, c, {
              value: Ls
            }),
            groupCollapsed: Kn({}, c, {
              value: Su
            }),
            groupEnd: Kn({}, c, {
              value: wu
            })
          });
        }
        Fs < 0 && o("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Go = t.ReactCurrentDispatcher, ji;
    function bl(c, h, C) {
      {
        if (ji === void 0)
          try {
            throw Error();
          } catch (M) {
            var x = M.stack.trim().match(/\n( *(at )?)/);
            ji = x && x[1] || "";
          }
        return `
` + ji + c;
      }
    }
    var yl = !1, wc;
    {
      var Cl = typeof WeakMap == "function" ? WeakMap : Map;
      wc = new Cl();
    }
    function Bs(c, h) {
      if (!c || yl)
        return "";
      {
        var C = wc.get(c);
        if (C !== void 0)
          return C;
      }
      var x;
      yl = !0;
      var M = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Y;
      Y = Go.current, Go.current = null, Sc();
      try {
        if (h) {
          var J = function() {
            throw Error();
          };
          if (Object.defineProperty(J.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(J, []);
            } catch (Vn) {
              x = Vn;
            }
            Reflect.construct(c, [], J);
          } else {
            try {
              J.call();
            } catch (Vn) {
              x = Vn;
            }
            c.call(J.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Vn) {
            x = Vn;
          }
          c();
        }
      } catch (Vn) {
        if (Vn && x && typeof Vn.stack == "string") {
          for (var fe = Vn.stack.split(`
`), Pe = x.stack.split(`
`), We = fe.length - 1, _e = Pe.length - 1; We >= 1 && _e >= 0 && fe[We] !== Pe[_e]; )
            _e--;
          for (; We >= 1 && _e >= 0; We--, _e--)
            if (fe[We] !== Pe[_e]) {
              if (We !== 1 || _e !== 1)
                do
                  if (We--, _e--, _e < 0 || fe[We] !== Pe[_e]) {
                    var gt = `
` + fe[We].replace(" at new ", " at ");
                    return c.displayName && gt.includes("<anonymous>") && (gt = gt.replace("<anonymous>", c.displayName)), typeof c == "function" && wc.set(c, gt), gt;
                  }
                while (We >= 1 && _e >= 0);
              break;
            }
        }
      } finally {
        yl = !1, Go.current = Y, Vi(), Error.prepareStackTrace = M;
      }
      var hn = c ? c.displayName || c.name : "", Xn = hn ? bl(hn) : "";
      return typeof c == "function" && wc.set(c, Xn), Xn;
    }
    function El(c, h, C) {
      return Bs(c, !0);
    }
    function Iu(c, h, C) {
      return Bs(c, !1);
    }
    function xu(c) {
      var h = c.prototype;
      return !!(h && h.isReactComponent);
    }
    function Vs(c, h, C) {
      if (c == null)
        return "";
      if (typeof c == "function")
        return Bs(c, xu(c));
      if (typeof c == "string")
        return bl(c);
      switch (c) {
        case ma:
          return bl("Suspense");
        case Eu:
          return bl("SuspenseList");
      }
      if (typeof c == "object")
        switch (c.$$typeof) {
          case Jt:
            return Iu(c.render);
          case Ur:
            return Vs(c.type, h, C);
          case za: {
            var x = c, M = x._payload, Y = x._init;
            try {
              return Vs(Y(M), h, C);
            } catch {
            }
          }
        }
      return "";
    }
    var Tu = {}, xn = t.ReactDebugCurrentFrame;
    function Tn(c) {
      if (c) {
        var h = c._owner, C = Vs(c.type, c._source, h ? h.type : null);
        xn.setExtraStackFrame(C);
      } else
        xn.setExtraStackFrame(null);
    }
    function Pu(c, h, C, x, M) {
      {
        var Y = Function.call.bind(ee);
        for (var J in c)
          if (Y(c, J)) {
            var fe = void 0;
            try {
              if (typeof c[J] != "function") {
                var Pe = Error((x || "React class") + ": " + C + " type `" + J + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof c[J] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Pe.name = "Invariant Violation", Pe;
              }
              fe = c[J](h, J, x, C, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (We) {
              fe = We;
            }
            fe && !(fe instanceof Error) && (Tn(M), o("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", x || "React class", C, J, typeof fe), Tn(null)), fe instanceof Error && !(fe.message in Tu) && (Tu[fe.message] = !0, Tn(M), o("Failed %s type: %s", C, fe.message), Tn(null));
          }
      }
    }
    var ku;
    ku = {};
    var Ui = {};
    Object.freeze(Ui);
    function Rd(c, h) {
      {
        var C = c.contextTypes;
        if (!C)
          return Ui;
        var x = {};
        for (var M in C)
          x[M] = h[M];
        {
          var Y = Cn(c) || "Unknown";
          Pu(C, x, "context", Y);
        }
        return x;
      }
    }
    function Wi(c, h, C, x) {
      {
        if (typeof c.getChildContext != "function") {
          {
            var M = Cn(h) || "Unknown";
            ku[M] || (ku[M] = !0, o("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", M, M));
          }
          return C;
        }
        var Y = c.getChildContext();
        for (var J in Y)
          if (!(J in x))
            throw new Error((Cn(h) || "Unknown") + '.getChildContext(): key "' + J + '" is not defined in childContextTypes.');
        {
          var fe = Cn(h) || "Unknown";
          Pu(x, Y, "child context", fe);
        }
        return Kn({}, C, Y);
      }
    }
    var Yo;
    Yo = {};
    var Al = null, wr = null;
    function ba(c) {
      c.context._currentValue2 = c.parentValue;
    }
    function ya(c) {
      c.context._currentValue2 = c.value;
    }
    function Ca(c, h) {
      if (c !== h) {
        ba(c);
        var C = c.parent, x = h.parent;
        if (C === null) {
          if (x !== null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
        } else {
          if (x === null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
          Ca(C, x);
        }
        ya(h);
      }
    }
    function Ea(c) {
      ba(c);
      var h = c.parent;
      h !== null && Ea(h);
    }
    function Sl(c) {
      var h = c.parent;
      h !== null && Sl(h), ya(c);
    }
    function Od(c, h) {
      ba(c);
      var C = c.parent;
      if (C === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      C.depth === h.depth ? Ca(C, h) : Od(C, h);
    }
    function Dd(c, h) {
      var C = h.parent;
      if (C === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      c.depth === C.depth ? Ca(c, C) : Dd(c, C), ya(h);
    }
    function Ic(c) {
      var h = wr, C = c;
      h !== C && (h === null ? Sl(C) : C === null ? Ea(h) : h.depth === C.depth ? Ca(h, C) : h.depth > C.depth ? Od(h, C) : Dd(h, C), wr = C);
    }
    function wl(c, h) {
      var C;
      C = c._currentValue2, c._currentValue2 = h, c._currentRenderer2 !== void 0 && c._currentRenderer2 !== null && c._currentRenderer2 !== Yo && o("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), c._currentRenderer2 = Yo;
      var x = wr, M = {
        parent: x,
        depth: x === null ? 0 : x.depth + 1,
        context: c,
        parentValue: C,
        value: h
      };
      return wr = M, M;
    }
    function js(c) {
      var h = wr;
      if (h === null)
        throw new Error("Tried to pop a Context at the root of the app. This is a bug in React.");
      h.context !== c && o("The parent context is not the expected context. This is probably a bug in React.");
      {
        var C = h.parentValue;
        C === Ec ? h.context._currentValue2 = h.context._defaultValue : h.context._currentValue2 = C, c._currentRenderer2 !== void 0 && c._currentRenderer2 !== null && c._currentRenderer2 !== Yo && o("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), c._currentRenderer2 = Yo;
      }
      return wr = h.parent;
    }
    function Il() {
      return wr;
    }
    function Xa(c) {
      var h = c._currentValue2;
      return h;
    }
    function B(c) {
      return c._reactInternals;
    }
    function Aa(c, h) {
      c._reactInternals = h;
    }
    var Ja = {}, Ir = {}, kt, xc, Us, xl, di, Ws, Tc, Pc, kc;
    {
      kt = /* @__PURE__ */ new Set(), xc = /* @__PURE__ */ new Set(), Us = /* @__PURE__ */ new Set(), Tc = /* @__PURE__ */ new Set(), xl = /* @__PURE__ */ new Set(), Pc = /* @__PURE__ */ new Set(), kc = /* @__PURE__ */ new Set();
      var Fd = /* @__PURE__ */ new Set();
      Ws = function(c, h) {
        if (!(c === null || typeof c == "function")) {
          var C = h + "_" + c;
          Fd.has(C) || (Fd.add(C), o("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", h, c));
        }
      }, di = function(c, h) {
        if (h === void 0) {
          var C = Cn(c) || "Component";
          xl.has(C) || (xl.add(C), o("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", C));
        }
      };
    }
    function fi(c, h) {
      {
        var C = c.constructor, x = C && Cn(C) || "ReactClass", M = x + "." + h;
        if (Ja[M])
          return;
        o(`%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.

Please check the code for the %s component.`, h, h, x), Ja[M] = !0;
      }
    }
    var Nd = {
      isMounted: function(c) {
        return !1;
      },
      enqueueSetState: function(c, h, C) {
        var x = B(c);
        x.queue === null ? fi(c, "setState") : (x.queue.push(h), C != null && Ws(C, "setState"));
      },
      enqueueReplaceState: function(c, h, C) {
        var x = B(c);
        x.replace = !0, x.queue = [h], C != null && Ws(C, "setState");
      },
      enqueueForceUpdate: function(c, h) {
        var C = B(c);
        C.queue === null ? fi(c, "forceUpdate") : h != null && Ws(h, "setState");
      }
    };
    function qf(c, h, C, x, M) {
      var Y = C(M, x);
      di(h, Y);
      var J = Y == null ? x : Kn({}, x, Y);
      return J;
    }
    function _f(c, h, C) {
      var x = Ui, M = c.contextType;
      if ("contextType" in c) {
        var Y = (
          // Allow null for conditional declaration
          M === null || M !== void 0 && M.$$typeof === wn && M._context === void 0
        );
        if (!Y && !kc.has(c)) {
          kc.add(c);
          var J = "";
          M === void 0 ? J = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof M != "object" ? J = " However, it is set to a " + typeof M + "." : M.$$typeof === Ut ? J = " Did you accidentally pass the Context.Provider instead?" : M._context !== void 0 ? J = " Did you accidentally pass the Context.Consumer instead?" : J = " However, it is set to an object with keys {" + Object.keys(M).join(", ") + "}.", o("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", Cn(c) || "Component", J);
        }
      }
      typeof M == "object" && M !== null ? x = Xa(M) : x = C;
      var fe = new c(h, x);
      {
        if (typeof c.getDerivedStateFromProps == "function" && (fe.state === null || fe.state === void 0)) {
          var Pe = Cn(c) || "Component";
          kt.has(Pe) || (kt.add(Pe), o("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", Pe, fe.state === null ? "null" : "undefined", Pe));
        }
        if (typeof c.getDerivedStateFromProps == "function" || typeof fe.getSnapshotBeforeUpdate == "function") {
          var We = null, _e = null, gt = null;
          if (typeof fe.componentWillMount == "function" && fe.componentWillMount.__suppressDeprecationWarning !== !0 ? We = "componentWillMount" : typeof fe.UNSAFE_componentWillMount == "function" && (We = "UNSAFE_componentWillMount"), typeof fe.componentWillReceiveProps == "function" && fe.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? _e = "componentWillReceiveProps" : typeof fe.UNSAFE_componentWillReceiveProps == "function" && (_e = "UNSAFE_componentWillReceiveProps"), typeof fe.componentWillUpdate == "function" && fe.componentWillUpdate.__suppressDeprecationWarning !== !0 ? gt = "componentWillUpdate" : typeof fe.UNSAFE_componentWillUpdate == "function" && (gt = "UNSAFE_componentWillUpdate"), We !== null || _e !== null || gt !== null) {
            var hn = Cn(c) || "Component", Xn = typeof c.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            Us.has(hn) || (Us.add(hn), o(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, hn, Xn, We !== null ? `
  ` + We : "", _e !== null ? `
  ` + _e : "", gt !== null ? `
  ` + gt : ""));
          }
        }
      }
      return fe;
    }
    function Md(c, h, C) {
      {
        var x = Cn(h) || "Component", M = c.render;
        M || (h.prototype && typeof h.prototype.render == "function" ? o("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", x) : o("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", x)), c.getInitialState && !c.getInitialState.isReactClassApproved && !c.state && o("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", x), c.getDefaultProps && !c.getDefaultProps.isReactClassApproved && o("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", x), c.propTypes && o("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", x), c.contextType && o("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", x), c.contextTypes && o("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", x), h.contextType && h.contextTypes && !Pc.has(h) && (Pc.add(h), o("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", x)), typeof c.componentShouldUpdate == "function" && o("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", x), h.prototype && h.prototype.isPureReactComponent && typeof c.shouldComponentUpdate < "u" && o("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", Cn(h) || "A pure component"), typeof c.componentDidUnmount == "function" && o("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", x), typeof c.componentDidReceiveProps == "function" && o("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", x), typeof c.componentWillRecieveProps == "function" && o("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", x), typeof c.UNSAFE_componentWillRecieveProps == "function" && o("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", x);
        var Y = c.props !== C;
        c.props !== void 0 && Y && o("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", x, x), c.defaultProps && o("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", x, x), typeof c.getSnapshotBeforeUpdate == "function" && typeof c.componentDidUpdate != "function" && !xc.has(h) && (xc.add(h), o("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", Cn(h))), typeof c.getDerivedStateFromProps == "function" && o("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", x), typeof c.getDerivedStateFromError == "function" && o("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", x), typeof h.getSnapshotBeforeUpdate == "function" && o("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", x);
        var J = c.state;
        J && (typeof J != "object" || X(J)) && o("%s.state: must be set to an object or null", x), typeof c.getChildContext == "function" && typeof h.childContextTypes != "object" && o("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", x);
      }
    }
    function $f(c, h) {
      var C = h.state;
      if (typeof h.componentWillMount == "function") {
        if (h.componentWillMount.__suppressDeprecationWarning !== !0) {
          var x = Cn(c) || "Unknown";
          Ir[x] || (r(
            // keep this warning in sync with ReactStrictModeWarning.js
            `componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.

Please update the following components: %s`,
            x
          ), Ir[x] = !0);
        }
        h.componentWillMount();
      }
      typeof h.UNSAFE_componentWillMount == "function" && h.UNSAFE_componentWillMount(), C !== h.state && (o("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", Cn(c) || "Component"), Nd.enqueueReplaceState(h, h.state, null));
    }
    function Hi(c, h, C, x) {
      if (c.queue !== null && c.queue.length > 0) {
        var M = c.queue, Y = c.replace;
        if (c.queue = null, c.replace = !1, Y && M.length === 1)
          h.state = M[0];
        else {
          for (var J = Y ? M[0] : h.state, fe = !0, Pe = Y ? 1 : 0; Pe < M.length; Pe++) {
            var We = M[Pe], _e = typeof We == "function" ? We.call(h, J, C, x) : We;
            _e != null && (fe ? (fe = !1, J = Kn({}, J, _e)) : Kn(J, _e));
          }
          h.state = J;
        }
      } else
        c.queue = null;
    }
    function Rc(c, h, C, x) {
      Md(c, h, C);
      var M = c.state !== void 0 ? c.state : null;
      c.updater = Nd, c.props = C, c.state = M;
      var Y = {
        queue: [],
        replace: !1
      };
      Aa(c, Y);
      var J = h.contextType;
      if (typeof J == "object" && J !== null ? c.context = Xa(J) : c.context = x, c.state === C) {
        var fe = Cn(h) || "Component";
        Tc.has(fe) || (Tc.add(fe), o("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", fe));
      }
      var Pe = h.getDerivedStateFromProps;
      typeof Pe == "function" && (c.state = qf(c, h, Pe, M, C)), typeof h.getDerivedStateFromProps != "function" && typeof c.getSnapshotBeforeUpdate != "function" && (typeof c.UNSAFE_componentWillMount == "function" || typeof c.componentWillMount == "function") && ($f(h, c), Hi(Y, c, C, x));
    }
    var Oc = {
      id: 1,
      overflow: ""
    };
    function eg(c) {
      var h = c.overflow, C = c.id, x = C & ~Qa(C);
      return x.toString(32) + h;
    }
    function Ru(c, h, C) {
      var x = c.id, M = c.overflow, Y = Dc(x) - 1, J = x & ~(1 << Y), fe = C + 1, Pe = Dc(h) + Y;
      if (Pe > 30) {
        var We = Y - Y % 5, _e = (1 << We) - 1, gt = (J & _e).toString(32), hn = J >> We, Xn = Y - We, Vn = Dc(h) + Xn, qu = fe << Xn, _u = qu | hn, Kd = gt + M;
        return {
          id: 1 << Vn | _u,
          overflow: Kd
        };
      } else {
        var Gl = fe << Y, _h = Gl | J, $h = M;
        return {
          id: 1 << Pe | _h,
          overflow: $h
        };
      }
    }
    function Dc(c) {
      return 32 - tg(c);
    }
    function Qa(c) {
      return 1 << Dc(c) - 1;
    }
    var tg = Math.clz32 ? Math.clz32 : Gi, ng = Math.log, zo = Math.LN2;
    function Gi(c) {
      var h = c >>> 0;
      return h === 0 ? 32 : 31 - (ng(h) / zo | 0) | 0;
    }
    function Ou(c, h) {
      return c === h && (c !== 0 || 1 / c === 1 / h) || c !== c && h !== h;
    }
    var Fc = typeof Object.is == "function" ? Object.is : Ou, Yt = null, qa = null, Sa = null, $t = null, Co = !1, _a = !1, Hs = 0, On = null, Eo = 0, $a = 25, Zo = !1, es;
    function ir() {
      if (Yt === null)
        throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
      return Zo && o("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks"), Yt;
    }
    function Du(c, h) {
      if (h === null)
        return o("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", es), !1;
      c.length !== h.length && o(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, es, "[" + c.join(", ") + "]", "[" + h.join(", ") + "]");
      for (var C = 0; C < h.length && C < c.length; C++)
        if (!Fc(c[C], h[C]))
          return !1;
      return !0;
    }
    function wa() {
      if (Eo > 0)
        throw new Error("Rendered more hooks than during the previous render");
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }
    function xr() {
      return $t === null ? Sa === null ? (Co = !1, Sa = $t = wa()) : (Co = !0, $t = Sa) : $t.next === null ? (Co = !1, $t = $t.next = wa()) : (Co = !0, $t = $t.next), $t;
    }
    function Fu(c, h) {
      Yt = h, qa = c, Zo = !1, Hs = 0;
    }
    function Ld(c, h, C, x) {
      for (; _a; )
        _a = !1, Hs = 0, Eo += 1, $t = null, C = c(h, x);
      return Yi(), C;
    }
    function Nu() {
      var c = Hs !== 0;
      return c;
    }
    function Yi() {
      Zo = !1, Yt = null, qa = null, _a = !1, Sa = null, Eo = 0, On = null, $t = null;
    }
    function Ia(c) {
      return Zo && o("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), Xa(c);
    }
    function Mu(c) {
      return es = "useContext", ir(), Xa(c);
    }
    function Nc(c, h) {
      return typeof h == "function" ? h(c) : h;
    }
    function Mc(c) {
      return es = "useState", Bd(
        Nc,
        // useReducer has a special case to support lazy useState initializers
        c
      );
    }
    function Bd(c, h, C) {
      if (c !== Nc && (es = "useReducer"), Yt = ir(), $t = xr(), Co) {
        var x = $t.queue, M = x.dispatch;
        if (On !== null) {
          var Y = On.get(x);
          if (Y !== void 0) {
            On.delete(x);
            var J = $t.memoizedState, fe = Y;
            do {
              var Pe = fe.action;
              Zo = !0, J = c(J, Pe), Zo = !1, fe = fe.next;
            } while (fe !== null);
            return $t.memoizedState = J, [J, M];
          }
        }
        return [$t.memoizedState, M];
      } else {
        Zo = !0;
        var We;
        c === Nc ? We = typeof h == "function" ? h() : h : We = C !== void 0 ? C(h) : h, Zo = !1, $t.memoizedState = We;
        var _e = $t.queue = {
          last: null,
          dispatch: null
        }, gt = _e.dispatch = Vd.bind(null, Yt, _e);
        return [$t.memoizedState, gt];
      }
    }
    function Lu(c, h) {
      Yt = ir(), $t = xr();
      var C = h === void 0 ? null : h;
      if ($t !== null) {
        var x = $t.memoizedState;
        if (x !== null && C !== null) {
          var M = x[1];
          if (Du(C, M))
            return x[0];
        }
      }
      Zo = !0;
      var Y = c();
      return Zo = !1, $t.memoizedState = [Y, C], Y;
    }
    function ar(c) {
      Yt = ir(), $t = xr();
      var h = $t.memoizedState;
      if (h === null) {
        var C = {
          current: c
        };
        return Object.seal(C), $t.memoizedState = C, C;
      } else
        return h;
    }
    function Bu(c, h) {
      es = "useLayoutEffect", o("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
    }
    function Vd(c, h, C) {
      if (Eo >= $a)
        throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
      if (c === Yt) {
        _a = !0;
        var x = {
          action: C,
          next: null
        };
        On === null && (On = /* @__PURE__ */ new Map());
        var M = On.get(h);
        if (M === void 0)
          On.set(h, x);
        else {
          for (var Y = M; Y.next !== null; )
            Y = Y.next;
          Y.next = x;
        }
      }
    }
    function gi(c, h) {
      return Lu(function() {
        return c;
      }, h);
    }
    function Vu(c, h, C) {
      return ir(), h(c._source);
    }
    function Lc(c, h, C) {
      if (C === void 0)
        throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
      return C();
    }
    function ts(c) {
      return ir(), c;
    }
    function Tl() {
      throw new Error("startTransition cannot be called during server rendering.");
    }
    function mr() {
      return ir(), [!1, Tl];
    }
    function Pl() {
      var c = qa, h = eg(c.treeContext), C = Rl;
      if (C === null)
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component.");
      var x = Hs++;
      return pr(C, h, x);
    }
    function kl() {
    }
    var jd = {
      readContext: Ia,
      useContext: Mu,
      useMemo: Lu,
      useReducer: Bd,
      useRef: ar,
      useState: Mc,
      useInsertionEffect: kl,
      useLayoutEffect: Bu,
      useCallback: gi,
      // useImperativeHandle is not run in the server environment
      useImperativeHandle: kl,
      // Effects are not run in the server environment.
      useEffect: kl,
      // Debugging effect
      useDebugValue: kl,
      useDeferredValue: ts,
      useTransition: mr,
      useId: Pl,
      // Subscriptions are not setup in a server environment.
      useMutableSource: Vu,
      useSyncExternalStore: Lc
    }, Rl = null;
    function Gs(c) {
      Rl = c;
    }
    function ju(c) {
      try {
        var h = "", C = c;
        do {
          switch (C.tag) {
            case 0:
              h += bl(C.type, null, null);
              break;
            case 1:
              h += Iu(C.type, null, null);
              break;
            case 2:
              h += El(C.type, null, null);
              break;
          }
          C = C.parent;
        } while (C);
        return h;
      } catch (x) {
        return `
Error generating stack: ` + x.message + `
` + x.stack;
      }
    }
    var Ao = t.ReactCurrentDispatcher, Ol = t.ReactDebugCurrentFrame, Bc = 0, ns = 1, Ys = 2, Uu = 3, rs = 4, Wu = 0, Hu = 1, pi = 2, rg = 12800;
    function og(c) {
      return console.error(c), null;
    }
    function zs() {
    }
    function Dl(c, h, C, x, M, Y, J, fe, Pe) {
      var We = [], _e = /* @__PURE__ */ new Set(), gt = {
        destination: null,
        responseState: h,
        progressiveChunkSize: x === void 0 ? rg : x,
        status: Wu,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: _e,
        pingedTasks: We,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: M === void 0 ? og : M,
        onAllReady: Y === void 0 ? zs : Y,
        onShellReady: J === void 0 ? zs : J,
        onShellError: fe === void 0 ? zs : fe,
        onFatalError: Pe === void 0 ? zs : Pe
      }, hn = zi(
        gt,
        0,
        null,
        C,
        // Root segments are never embedded in Text on either edge
        !1,
        !1
      );
      hn.parentFlushed = !0;
      var Xn = Zs(gt, c, null, hn, _e, Ui, Al, Oc);
      return We.push(Xn), gt;
    }
    function Vc(c, h) {
      var C = c.pingedTasks;
      C.push(h), C.length === 1 && l(function() {
        return Qu(c);
      });
    }
    function Ko(c, h) {
      return {
        id: _r,
        rootSegmentID: -1,
        parentFlushed: !1,
        pendingTasks: 0,
        forceClientRender: !1,
        completedSegments: [],
        byteSize: 0,
        fallbackAbortableTasks: h,
        errorDigest: null
      };
    }
    function Zs(c, h, C, x, M, Y, J, fe) {
      c.allPendingTasks++, C === null ? c.pendingRootTasks++ : C.pendingTasks++;
      var Pe = {
        node: h,
        ping: function() {
          return Vc(c, Pe);
        },
        blockedBoundary: C,
        blockedSegment: x,
        abortSet: M,
        legacyContext: Y,
        context: J,
        treeContext: fe
      };
      return Pe.componentStack = null, M.add(Pe), Pe;
    }
    function zi(c, h, C, x, M, Y) {
      return {
        status: Bc,
        id: -1,
        // lazily assigned later
        index: h,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: x,
        boundary: C,
        lastPushedText: M,
        textEmbedded: Y
      };
    }
    var Xo = null;
    function Ks() {
      return Xo === null || Xo.componentStack === null ? "" : ju(Xo.componentStack);
    }
    function So(c, h) {
      c.componentStack = {
        tag: 0,
        parent: c.componentStack,
        type: h
      };
    }
    function os(c, h) {
      c.componentStack = {
        tag: 1,
        parent: c.componentStack,
        type: h
      };
    }
    function jc(c, h) {
      c.componentStack = {
        tag: 2,
        parent: c.componentStack,
        type: h
      };
    }
    function wo(c) {
      c.componentStack === null ? o("Unexpectedly popped too many stack frames. This is a bug in React.") : c.componentStack = c.componentStack.parent;
    }
    var Zi = null;
    function Gu(c, h) {
      {
        var C;
        typeof h == "string" ? C = h : h && typeof h.message == "string" ? C = h.message : C = String(h);
        var x = Zi || Ks();
        Zi = null, c.errorMessage = C, c.errorComponentStack = x;
      }
    }
    function is(c, h) {
      var C = c.onError(h);
      if (C != null && typeof C != "string")
        throw new Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof C + '" instead');
      return C;
    }
    function Fl(c, h) {
      var C = c.onShellError;
      C(h);
      var x = c.onFatalError;
      x(h), c.destination !== null ? (c.status = pi, j(c.destination, h)) : (c.status = Hu, c.fatalError = h);
    }
    function Uc(c, h, C) {
      So(h, "Suspense");
      var x = h.blockedBoundary, M = h.blockedSegment, Y = C.fallback, J = C.children, fe = /* @__PURE__ */ new Set(), Pe = Ko(c, fe), We = M.chunks.length, _e = zi(
        c,
        We,
        Pe,
        M.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      M.children.push(_e), M.lastPushedText = !1;
      var gt = zi(
        c,
        0,
        null,
        M.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      gt.parentFlushed = !0, h.blockedBoundary = Pe, h.blockedSegment = gt;
      try {
        if (Jo(c, h, J), Td(gt.chunks, c.responseState, gt.lastPushedText, gt.textEmbedded), gt.status = ns, Ul(Pe, gt), Pe.pendingTasks === 0) {
          wo(h);
          return;
        }
      } catch (Xn) {
        gt.status = rs, Pe.forceClientRender = !0, Pe.errorDigest = is(c, Xn), Gu(Pe, Xn);
      } finally {
        h.blockedBoundary = x, h.blockedSegment = M;
      }
      var hn = Zs(c, Y, x, _e, fe, h.legacyContext, h.context, h.treeContext);
      hn.componentStack = h.componentStack, c.pingedTasks.push(hn), wo(h);
    }
    function Ud(c, h, C, x) {
      So(h, C);
      var M = h.blockedSegment, Y = li(M.chunks, C, x, c.responseState, M.formatContext);
      M.lastPushedText = !1;
      var J = M.formatContext;
      M.formatContext = Ri(J, C, x), Jo(c, h, Y), M.formatContext = J, $r(M.chunks, C), M.lastPushedText = !1, wo(h);
    }
    function Yu(c) {
      return c.prototype && c.prototype.isReactComponent;
    }
    function wt(c, h, C, x, M) {
      var Y = {};
      Fu(h, Y);
      var J = C(x, M);
      return Ld(C, x, J, M);
    }
    function Nl(c, h, C, x, M) {
      var Y = C.render();
      C.props !== M && (Wr || o("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", Cn(x) || "a component"), Wr = !0);
      {
        var J = x.childContextTypes;
        if (J != null) {
          var fe = h.legacyContext, Pe = Wi(C, x, fe, J);
          h.legacyContext = Pe, Tr(c, h, Y), h.legacyContext = fe;
          return;
        }
      }
      Tr(c, h, Y);
    }
    function Wd(c, h, C, x) {
      jc(h, C);
      var M = Rd(C, h.legacyContext), Y = _f(C, x, M);
      Rc(Y, C, x, M), Nl(c, h, Y, C, x), wo(h);
    }
    var as = {}, Xs = {}, zu = {}, Zu = {}, Wr = !1, Hd = !1, Ml = !1, Ll = !1;
    function Gd(c, h, C, x) {
      var M;
      if (M = Rd(C, h.legacyContext), os(h, C), C.prototype && typeof C.prototype.render == "function") {
        var Y = Cn(C) || "Unknown";
        as[Y] || (o("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", Y, Y), as[Y] = !0);
      }
      var J = wt(c, h, C, x, M), fe = Nu();
      if (typeof J == "object" && J !== null && typeof J.render == "function" && J.$$typeof === void 0) {
        var Pe = Cn(C) || "Unknown";
        Xs[Pe] || (o("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", Pe, Pe, Pe), Xs[Pe] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof J == "object" && J !== null && typeof J.render == "function" && J.$$typeof === void 0
      ) {
        {
          var We = Cn(C) || "Unknown";
          Xs[We] || (o("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", We, We, We), Xs[We] = !0);
        }
        Rc(J, C, x, M), Nl(c, h, J, C, x);
      } else if (Yd(C), fe) {
        var _e = h.treeContext, gt = 1, hn = 0;
        h.treeContext = Ru(_e, gt, hn);
        try {
          Tr(c, h, J);
        } finally {
          h.treeContext = _e;
        }
      } else
        Tr(c, h, J);
      wo(h);
    }
    function Yd(c) {
      {
        if (c && c.childContextTypes && o("%s(...): childContextTypes cannot be defined on a function component.", c.displayName || c.name || "Component"), typeof c.getDerivedStateFromProps == "function") {
          var h = Cn(c) || "Unknown";
          Zu[h] || (o("%s: Function components do not support getDerivedStateFromProps.", h), Zu[h] = !0);
        }
        if (typeof c.contextType == "object" && c.contextType !== null) {
          var C = Cn(c) || "Unknown";
          zu[C] || (o("%s: Function components do not support contextType.", C), zu[C] = !0);
        }
      }
    }
    function Hr(c, h) {
      if (c && c.defaultProps) {
        var C = Kn({}, h), x = c.defaultProps;
        for (var M in x)
          C[M] === void 0 && (C[M] = x[M]);
        return C;
      }
      return h;
    }
    function xa(c, h, C, x, M) {
      os(h, C.render);
      var Y = wt(c, h, C.render, x, M), J = Nu();
      if (J) {
        var fe = h.treeContext, Pe = 1, We = 0;
        h.treeContext = Ru(fe, Pe, We);
        try {
          Tr(c, h, Y);
        } finally {
          h.treeContext = fe;
        }
      } else
        Tr(c, h, Y);
      wo(h);
    }
    function Ku(c, h, C, x, M) {
      var Y = C.type, J = Hr(Y, x);
      Bl(c, h, Y, J, M);
    }
    function Wc(c, h, C, x) {
      C._context === void 0 ? C !== C.Consumer && (Ll || (Ll = !0, o("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : C = C._context;
      var M = x.children;
      typeof M != "function" && o("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
      var Y = Xa(C), J = M(Y);
      Tr(c, h, J);
    }
    function Hc(c, h, C, x) {
      var M = C._context, Y = x.value, J = x.children, fe;
      fe = h.context, h.context = wl(M, Y), Tr(c, h, J), h.context = js(M), fe !== h.context && o("Popping the context provider did not return back to the original snapshot. This is a bug in React.");
    }
    function Gr(c, h, C, x, M) {
      So(h, "Lazy");
      var Y = C._payload, J = C._init, fe = J(Y), Pe = Hr(fe, x);
      Bl(c, h, fe, Pe, M), wo(h);
    }
    function Bl(c, h, C, x, M) {
      if (typeof C == "function")
        if (Yu(C)) {
          Wd(c, h, C, x);
          return;
        } else {
          Gd(c, h, C, x);
          return;
        }
      if (typeof C == "string") {
        Ud(c, h, C, x);
        return;
      }
      switch (C) {
        case Cc:
        case Za:
        case Ze:
        case ht:
        case he: {
          Tr(c, h, x.children);
          return;
        }
        case Eu: {
          So(h, "SuspenseList"), Tr(c, h, x.children), wo(h);
          return;
        }
        case Qf:
          throw new Error("ReactDOMServer does not yet support scope components.");
        case ma: {
          Uc(c, h, x);
          return;
        }
      }
      if (typeof C == "object" && C !== null)
        switch (C.$$typeof) {
          case Jt: {
            xa(c, h, C, x, M);
            return;
          }
          case Ur: {
            Ku(c, h, C, x, M);
            return;
          }
          case Ut: {
            Hc(c, h, C, x);
            return;
          }
          case wn: {
            Wc(c, h, C, x);
            return;
          }
          case za: {
            Gr(c, h, C, x);
            return;
          }
        }
      var Y = "";
      throw (C === void 0 || typeof C == "object" && C !== null && Object.keys(C).length === 0) && (Y += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (C == null ? C : typeof C) + "." + Y));
    }
    function Xu(c, h) {
      typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
      c[Symbol.toStringTag] === "Generator" && (Hd || o("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), Hd = !0), c.entries === h && (Ml || o("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Ml = !0);
    }
    function Tr(c, h, C) {
      try {
        return Vl(c, h, C);
      } catch (x) {
        throw typeof x == "object" && x !== null && typeof x.then == "function" || (Zi = Zi !== null ? Zi : Ks()), x;
      }
    }
    function Vl(c, h, C) {
      if (h.node = C, typeof C == "object" && C !== null) {
        switch (C.$$typeof) {
          case te: {
            var x = C, M = x.type, Y = x.props, J = x.ref;
            Bl(c, h, M, Y, J);
            return;
          }
          case Ee:
            throw new Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");
          case za: {
            var fe = C, Pe = fe._payload, We = fe._init, _e;
            try {
              _e = We(Pe);
            } catch (Gl) {
              throw typeof Gl == "object" && Gl !== null && typeof Gl.then == "function" && So(h, "Lazy"), Gl;
            }
            Tr(c, h, _e);
            return;
          }
        }
        if (X(C)) {
          Ki(c, h, C);
          return;
        }
        var gt = yn(C);
        if (gt) {
          Xu(C, gt);
          var hn = gt.call(C);
          if (hn) {
            var Xn = hn.next();
            if (!Xn.done) {
              var Vn = [];
              do
                Vn.push(Xn.value), Xn = hn.next();
              while (!Xn.done);
              Ki(c, h, Vn);
              return;
            }
            return;
          }
        }
        var qu = Object.prototype.toString.call(C);
        throw new Error("Objects are not valid as a React child (found: " + (qu === "[object Object]" ? "object with keys {" + Object.keys(C).join(", ") + "}" : qu) + "). If you meant to render a collection of children, use an array instead.");
      }
      if (typeof C == "string") {
        var _u = h.blockedSegment;
        _u.lastPushedText = yu(h.blockedSegment.chunks, C, c.responseState, _u.lastPushedText);
        return;
      }
      if (typeof C == "number") {
        var Kd = h.blockedSegment;
        Kd.lastPushedText = yu(h.blockedSegment.chunks, "" + C, c.responseState, Kd.lastPushedText);
        return;
      }
      typeof C == "function" && o("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function Ki(c, h, C) {
      for (var x = C.length, M = 0; M < x; M++) {
        var Y = h.treeContext;
        h.treeContext = Ru(Y, x, M);
        try {
          Jo(c, h, C[M]);
        } finally {
          h.treeContext = Y;
        }
      }
    }
    function ig(c, h, C) {
      var x = h.blockedSegment, M = x.chunks.length, Y = zi(
        c,
        M,
        null,
        x.formatContext,
        // Adopt the parent segment's leading text embed
        x.lastPushedText,
        // Assume we are text embedded at the trailing edge
        !0
      );
      x.children.push(Y), x.lastPushedText = !1;
      var J = Zs(c, h.node, h.blockedBoundary, Y, h.abortSet, h.legacyContext, h.context, h.treeContext);
      h.componentStack !== null && (J.componentStack = h.componentStack.parent);
      var fe = J.ping;
      C.then(fe, fe);
    }
    function Jo(c, h, C) {
      var x = h.blockedSegment.formatContext, M = h.legacyContext, Y = h.context, J = null;
      J = h.componentStack;
      try {
        return Tr(c, h, C);
      } catch (fe) {
        if (Yi(), typeof fe == "object" && fe !== null && typeof fe.then == "function") {
          ig(c, h, fe), h.blockedSegment.formatContext = x, h.legacyContext = M, h.context = Y, Ic(Y), h.componentStack = J;
          return;
        } else
          throw h.blockedSegment.formatContext = x, h.legacyContext = M, h.context = Y, Ic(Y), h.componentStack = J, fe;
      }
    }
    function jl(c, h, C, x) {
      var M = is(c, x);
      if (h === null ? Fl(c, x) : (h.pendingTasks--, h.forceClientRender || (h.forceClientRender = !0, h.errorDigest = M, Gu(h, x), h.parentFlushed && c.clientRenderedBoundaries.push(h))), c.allPendingTasks--, c.allPendingTasks === 0) {
        var Y = c.onAllReady;
        Y();
      }
    }
    function Ju(c) {
      var h = this, C = c.blockedBoundary, x = c.blockedSegment;
      x.status = Uu, Wl(h, C, x);
    }
    function Gc(c, h, C) {
      var x = c.blockedBoundary, M = c.blockedSegment;
      if (M.status = Uu, x === null)
        h.allPendingTasks--, h.status !== pi && (h.status = pi, h.destination !== null && A(h.destination));
      else {
        if (x.pendingTasks--, !x.forceClientRender) {
          x.forceClientRender = !0;
          var Y = C === void 0 ? new Error("The render was aborted by the server without a reason.") : C;
          x.errorDigest = h.onError(Y);
          {
            var J = "The server did not finish this Suspense boundary: ";
            Y && typeof Y.message == "string" ? Y = J + Y.message : Y = J + String(Y);
            var fe = Xo;
            Xo = c;
            try {
              Gu(x, Y);
            } finally {
              Xo = fe;
            }
          }
          x.parentFlushed && h.clientRenderedBoundaries.push(x);
        }
        if (x.fallbackAbortableTasks.forEach(function(We) {
          return Gc(We, h, C);
        }), x.fallbackAbortableTasks.clear(), h.allPendingTasks--, h.allPendingTasks === 0) {
          var Pe = h.onAllReady;
          Pe();
        }
      }
    }
    function Ul(c, h) {
      if (h.chunks.length === 0 && h.children.length === 1 && h.children[0].boundary === null) {
        var C = h.children[0];
        C.id = h.id, C.parentFlushed = !0, C.status === ns && Ul(c, C);
      } else {
        var x = c.completedSegments;
        x.push(h);
      }
    }
    function Wl(c, h, C) {
      if (h === null) {
        if (C.parentFlushed) {
          if (c.completedRootSegment !== null)
            throw new Error("There can only be one root segment. This is a bug in React.");
          c.completedRootSegment = C;
        }
        if (c.pendingRootTasks--, c.pendingRootTasks === 0) {
          c.onShellError = zs;
          var x = c.onShellReady;
          x();
        }
      } else if (h.pendingTasks--, !h.forceClientRender) {
        if (h.pendingTasks === 0)
          C.parentFlushed && C.status === ns && Ul(h, C), h.parentFlushed && c.completedBoundaries.push(h), h.fallbackAbortableTasks.forEach(Ju, c), h.fallbackAbortableTasks.clear();
        else if (C.parentFlushed && C.status === ns) {
          Ul(h, C);
          var M = h.completedSegments;
          M.length === 1 && h.parentFlushed && c.partialBoundaries.push(h);
        }
      }
      if (c.allPendingTasks--, c.allPendingTasks === 0) {
        var Y = c.onAllReady;
        Y();
      }
    }
    function Yc(c, h) {
      var C = h.blockedSegment;
      if (C.status === Bc) {
        Ic(h.context);
        var x = null;
        x = Xo, Xo = h;
        try {
          Tr(c, h, h.node), Td(C.chunks, c.responseState, C.lastPushedText, C.textEmbedded), h.abortSet.delete(h), C.status = ns, Wl(c, h.blockedBoundary, C);
        } catch (Y) {
          if (Yi(), typeof Y == "object" && Y !== null && typeof Y.then == "function") {
            var M = h.ping;
            Y.then(M, M);
          } else
            h.abortSet.delete(h), C.status = rs, jl(c, h.blockedBoundary, C, Y);
        } finally {
          Xo = x;
        }
      }
    }
    function Qu(c) {
      if (c.status !== pi) {
        var h = Il(), C = Ao.current;
        Ao.current = jd;
        var x;
        x = Ol.getCurrentStack, Ol.getCurrentStack = Ks;
        var M = Rl;
        Gs(c.responseState);
        try {
          var Y = c.pingedTasks, J;
          for (J = 0; J < Y.length; J++) {
            var fe = Y[J];
            Yc(c, fe);
          }
          Y.splice(0, J), c.destination !== null && Zc(c, c.destination);
        } catch (Pe) {
          is(c, Pe), Fl(c, Pe);
        } finally {
          Gs(M), Ao.current = C, Ol.getCurrentStack = x, C === jd && Ic(h);
        }
      }
    }
    function Js(c, h, C) {
      switch (C.parentFlushed = !0, C.status) {
        case Bc: {
          var x = C.id = c.nextSegmentId++;
          return C.lastPushedText = !1, C.textEmbedded = !1, Ln(h, c.responseState, x);
        }
        case ns: {
          C.status = Ys;
          for (var M = !0, Y = C.chunks, J = 0, fe = C.children, Pe = 0; Pe < fe.length; Pe++) {
            for (var We = fe[Pe]; J < We.index; J++)
              f(h, Y[J]);
            M = Hl(c, h, We);
          }
          for (; J < Y.length - 1; J++)
            f(h, Y[J]);
          return J < Y.length && (M = p(h, Y[J])), M;
        }
        default:
          throw new Error("Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.");
      }
    }
    function Hl(c, h, C) {
      var x = C.boundary;
      if (x === null)
        return Js(c, h, C);
      if (x.parentFlushed = !0, x.forceClientRender)
        return yo(h, c.responseState, x.errorDigest, x.errorMessage, x.errorComponentStack), Js(c, h, C), Pd(h, c.responseState);
      if (x.pendingTasks > 0) {
        x.rootSegmentID = c.nextSegmentId++, x.completedSegments.length > 0 && c.partialBoundaries.push(x);
        var M = x.id = ho(c.responseState);
        return ga(h, c.responseState, M), Js(c, h, C), xs(h, c.responseState);
      } else {
        if (x.byteSize > c.progressiveChunkSize)
          return x.rootSegmentID = c.nextSegmentId++, c.completedBoundaries.push(x), ga(h, c.responseState, x.id), Js(c, h, C), xs(h, c.responseState);
        Cu(h, c.responseState);
        var Y = x.completedSegments;
        if (Y.length !== 1)
          throw new Error("A previously unvisited boundary must have exactly one root segment. This is a bug in React.");
        var J = Y[0];
        return Hl(c, h, J), Jf(h, c.responseState);
      }
    }
    function zd(c, h, C) {
      return Kf(h, c.responseState, C.id, C.errorDigest, C.errorMessage, C.errorComponentStack);
    }
    function zc(c, h, C) {
      return ie(h, c.responseState, C.formatContext, C.id), Hl(c, h, C), Ae(h, C.formatContext);
    }
    function sr(c, h, C) {
      for (var x = C.completedSegments, M = 0; M < x.length; M++) {
        var Y = x[M];
        Zd(c, h, C, Y);
      }
      return x.length = 0, zf(h, c.responseState, C.id, C.rootSegmentID);
    }
    function hi(c, h, C) {
      for (var x = C.completedSegments, M = 0; M < x.length; M++) {
        var Y = x[M];
        if (!Zd(c, h, C, Y))
          return M++, x.splice(0, M), !1;
      }
      return x.splice(0, M), !0;
    }
    function Zd(c, h, C, x) {
      if (x.status === Ys)
        return !0;
      var M = x.id;
      if (M === -1) {
        var Y = x.id = C.rootSegmentID;
        if (Y === -1)
          throw new Error("A root segment ID must have been assigned by now. This is a bug in React.");
        return zc(c, h, x);
      } else
        return zc(c, h, x), no(h, c.responseState, M);
    }
    function Zc(c, h) {
      try {
        var C = c.completedRootSegment;
        C !== null && c.pendingRootTasks === 0 && (Hl(c, h, C), c.completedRootSegment = null, pl(h, c.responseState));
        var x = c.clientRenderedBoundaries, M;
        for (M = 0; M < x.length; M++) {
          var Y = x[M];
          if (!zd(c, h, Y)) {
            c.destination = null, M++, x.splice(0, M);
            return;
          }
        }
        x.splice(0, M);
        var J = c.completedBoundaries;
        for (M = 0; M < J.length; M++) {
          var fe = J[M];
          if (!sr(c, h, fe)) {
            c.destination = null, M++, J.splice(0, M);
            return;
          }
        }
        J.splice(0, M);
        var Pe = c.partialBoundaries;
        for (M = 0; M < Pe.length; M++) {
          var We = Pe[M];
          if (!hi(c, h, We)) {
            c.destination = null, M++, Pe.splice(0, M);
            return;
          }
        }
        Pe.splice(0, M);
        var _e = c.completedBoundaries;
        for (M = 0; M < _e.length; M++) {
          var gt = _e[M];
          if (!sr(c, h, gt)) {
            c.destination = null, M++, _e.splice(0, M);
            return;
          }
        }
        _e.splice(0, M);
      } finally {
        c.allPendingTasks === 0 && c.pingedTasks.length === 0 && c.clientRenderedBoundaries.length === 0 && c.completedBoundaries.length === 0 && (c.abortableTasks.size !== 0 && o("There was still abortable task at the root when we closed. This is a bug in React."), A(h));
      }
    }
    function Kc(c) {
      l(function() {
        return Qu(c);
      });
    }
    function d(c, h) {
      if (c.status === Hu) {
        c.status = pi, j(h, c.fatalError);
        return;
      }
      if (c.status !== pi && c.destination === null) {
        c.destination = h;
        try {
          Zc(c, h);
        } catch (C) {
          is(c, C), Fl(c, C);
        }
      }
    }
    function m(c, h) {
      try {
        var C = c.abortableTasks;
        C.forEach(function(x) {
          return Gc(x, c, h);
        }), C.clear(), c.destination !== null && Zc(c, c.destination);
      } catch (x) {
        is(c, x), Fl(c, x);
      }
    }
    function S() {
    }
    function R(c, h, C, x) {
      var M = !1, Y = null, J = "", fe = {
        push: function(gt) {
          return gt !== null && (J += gt), !0;
        },
        destroy: function(gt) {
          M = !0, Y = gt;
        }
      }, Pe = !1;
      function We() {
        Pe = !0;
      }
      var _e = Dl(c, Ds(C, h ? h.identifierPrefix : void 0), ro(), 1 / 0, S, void 0, We, void 0, void 0);
      if (Kc(_e), m(_e, x), d(_e, fe), M)
        throw Y;
      if (!Pe)
        throw new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
      return J;
    }
    function W(c, h) {
      return R(c, h, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
    }
    function Z(c, h) {
      return R(c, h, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
    }
    function _() {
      throw new Error("ReactDOMServer.renderToNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToString() instead.");
    }
    function pe() {
      throw new Error("ReactDOMServer.renderToStaticNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToStaticMarkup() instead.");
    }
    cd.renderToNodeStream = _, cd.renderToStaticMarkup = Z, cd.renderToStaticNodeStream = pe, cd.renderToString = W, cd.version = n;
  }()), cd;
}
var Dp = {};
/**
 * @license React
 * react-dom-server.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cA;
function s7() {
  return cA || (cA = 1, process.env.NODE_ENV !== "production" && function() {
    var e = $o, n = "18.2.0", t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(d) {
      {
        for (var m = arguments.length, S = new Array(m > 1 ? m - 1 : 0), R = 1; R < m; R++)
          S[R - 1] = arguments[R];
        a("warn", d, S);
      }
    }
    function o(d) {
      {
        for (var m = arguments.length, S = new Array(m > 1 ? m - 1 : 0), R = 1; R < m; R++)
          S[R - 1] = arguments[R];
        a("error", d, S);
      }
    }
    function a(d, m, S) {
      {
        var R = t.ReactDebugCurrentFrame, W = R.getStackAddendum();
        W !== "" && (m += "%s", S = S.concat([W]));
        var Z = S.map(function(_) {
          return String(_);
        });
        Z.unshift("Warning: " + m), Function.prototype.apply.call(console[d], console, Z);
      }
    }
    function l(d) {
      d();
    }
    var u = 512, f = null, p = 0;
    function y(d) {
      f = new Uint8Array(u), p = 0;
    }
    function A(d, m) {
      if (m.length !== 0) {
        if (m.length > u) {
          p > 0 && (d.enqueue(new Uint8Array(f.buffer, 0, p)), f = new Uint8Array(u), p = 0), d.enqueue(m);
          return;
        }
        var S = m, R = f.length - p;
        R < S.length && (R === 0 ? d.enqueue(f) : (f.set(S.subarray(0, R), p), d.enqueue(f), S = S.subarray(R)), f = new Uint8Array(u), p = 0), f.set(S, p), p += S.length;
      }
    }
    function w(d, m) {
      return A(d, m), !0;
    }
    function F(d) {
      f && p > 0 && (d.enqueue(new Uint8Array(f.buffer, 0, p)), f = null, p = 0);
    }
    function j(d) {
      d.close();
    }
    var N = new TextEncoder();
    function D(d) {
      return N.encode(d);
    }
    function k(d) {
      return N.encode(d);
    }
    function z(d, m) {
      typeof d.error == "function" ? d.error(m) : d.close();
    }
    function q(d) {
      {
        var m = typeof Symbol == "function" && Symbol.toStringTag, S = m && d[Symbol.toStringTag] || d.constructor.name || "Object";
        return S;
      }
    }
    function Ce(d) {
      try {
        return ee(d), !1;
      } catch {
        return !0;
      }
    }
    function ee(d) {
      return "" + d;
    }
    function Fe(d, m) {
      if (Ce(d))
        return o("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", m, q(d)), ee(d);
    }
    function Oe(d, m) {
      if (Ce(d))
        return o("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", m, q(d)), ee(d);
    }
    function He(d) {
      if (Ce(d))
        return o("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", q(d)), ee(d);
    }
    var Re = Object.prototype.hasOwnProperty, Se = 0, we = 1, ae = 2, ge = 3, Ie = 4, Ye = 5, Ke = 6, ze = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", ue = ze + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", de = new RegExp("^[" + ze + "][" + ue + "]*$"), Q = {}, me = {};
    function Le(d) {
      return Re.call(me, d) ? !0 : Re.call(Q, d) ? !1 : de.test(d) ? (me[d] = !0, !0) : (Q[d] = !0, o("Invalid attribute name: `%s`", d), !1);
    }
    function Je(d, m, S, R) {
      if (S !== null && S.type === Se)
        return !1;
      switch (typeof m) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (R)
            return !1;
          if (S !== null)
            return !S.acceptsBooleans;
          var W = d.toLowerCase().slice(0, 5);
          return W !== "data-" && W !== "aria-";
        }
        default:
          return !1;
      }
    }
    function Xe(d) {
      return Ue.hasOwnProperty(d) ? Ue[d] : null;
    }
    function je(d, m, S, R, W, Z, _) {
      this.acceptsBooleans = m === ae || m === ge || m === Ie, this.attributeName = R, this.attributeNamespace = W, this.mustUseProperty = S, this.propertyName = d, this.type = m, this.sanitizeURL = Z, this.removeEmptyString = _;
    }
    var Ue = {}, it = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    it.forEach(function(d) {
      Ue[d] = new je(
        d,
        Se,
        !1,
        // mustUseProperty
        d,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(d) {
      var m = d[0], S = d[1];
      Ue[m] = new je(
        m,
        we,
        !1,
        // mustUseProperty
        S,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(d) {
      Ue[d] = new je(
        d,
        ae,
        !1,
        // mustUseProperty
        d.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(d) {
      Ue[d] = new je(
        d,
        ae,
        !1,
        // mustUseProperty
        d,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(d) {
      Ue[d] = new je(
        d,
        ge,
        !1,
        // mustUseProperty
        d.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(d) {
      Ue[d] = new je(
        d,
        ge,
        !0,
        // mustUseProperty
        d,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(d) {
      Ue[d] = new je(
        d,
        Ie,
        !1,
        // mustUseProperty
        d,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(d) {
      Ue[d] = new je(
        d,
        Ke,
        !1,
        // mustUseProperty
        d,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(d) {
      Ue[d] = new je(
        d,
        Ye,
        !1,
        // mustUseProperty
        d.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var ct = /[\-\:]([a-z])/g, lt = function(d) {
      return d[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(d) {
      var m = d.replace(ct, lt);
      Ue[m] = new je(
        m,
        we,
        !1,
        // mustUseProperty
        d,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(d) {
      var m = d.replace(ct, lt);
      Ue[m] = new je(
        m,
        we,
        !1,
        // mustUseProperty
        d,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(d) {
      var m = d.replace(ct, lt);
      Ue[m] = new je(
        m,
        we,
        !1,
        // mustUseProperty
        d,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(d) {
      Ue[d] = new je(
        d,
        we,
        !1,
        // mustUseProperty
        d.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var dt = "xlinkHref";
    Ue[dt] = new je(
      "xlinkHref",
      we,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(d) {
      Ue[d] = new je(
        d,
        we,
        !1,
        // mustUseProperty
        d.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var Mt = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function Be(d, m) {
      return d + m.charAt(0).toUpperCase() + m.substring(1);
    }
    var Wt = ["Webkit", "ms", "Moz", "O"];
    Object.keys(Mt).forEach(function(d) {
      Wt.forEach(function(m) {
        Mt[Be(m, d)] = Mt[d];
      });
    });
    var Ht = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function Fn(d, m) {
      Ht[m.type] || m.onChange || m.onInput || m.readOnly || m.disabled || m.value == null || o("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), m.onChange || m.readOnly || m.disabled || m.checked == null || o("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function Fr(d, m) {
      if (d.indexOf("-") === -1)
        return typeof m.is == "string";
      switch (d) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var $n = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, er = {}, Nr = new RegExp("^(aria)-[" + ue + "]*$"), Cr = new RegExp("^(aria)[A-Z][" + ue + "]*$");
    function Gn(d, m) {
      {
        if (Re.call(er, m) && er[m])
          return !0;
        if (Cr.test(m)) {
          var S = "aria-" + m.slice(4).toLowerCase(), R = $n.hasOwnProperty(S) ? S : null;
          if (R == null)
            return o("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", m), er[m] = !0, !0;
          if (m !== R)
            return o("Invalid ARIA attribute `%s`. Did you mean `%s`?", m, R), er[m] = !0, !0;
        }
        if (Nr.test(m)) {
          var W = m.toLowerCase(), Z = $n.hasOwnProperty(W) ? W : null;
          if (Z == null)
            return er[m] = !0, !1;
          if (m !== Z)
            return o("Unknown ARIA attribute `%s`. Did you mean `%s`?", m, Z), er[m] = !0, !0;
        }
      }
      return !0;
    }
    function Rn(d, m) {
      {
        var S = [];
        for (var R in m) {
          var W = Gn(d, R);
          W || S.push(R);
        }
        var Z = S.map(function(_) {
          return "`" + _ + "`";
        }).join(", ");
        S.length === 1 ? o("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", Z, d) : S.length > 1 && o("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", Z, d);
      }
    }
    function An(d, m) {
      Fr(d, m) || Rn(d, m);
    }
    var Sn = !1;
    function Mr(d, m) {
      {
        if (d !== "input" && d !== "textarea" && d !== "select")
          return;
        m != null && m.value === null && !Sn && (Sn = !0, d === "select" && m.multiple ? o("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", d) : o("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", d));
      }
    }
    var ii = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, tr = function() {
    };
    {
      var tn = {}, co = /^on./, Oo = /^on[^A-Z]/, uo = new RegExp("^(aria)-[" + ue + "]*$"), Do = new RegExp("^(aria)[A-Z][" + ue + "]*$");
      tr = function(d, m, S, R) {
        if (Re.call(tn, m) && tn[m])
          return !0;
        var W = m.toLowerCase();
        if (W === "onfocusin" || W === "onfocusout")
          return o("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), tn[m] = !0, !0;
        if (R != null) {
          var Z = R.registrationNameDependencies, _ = R.possibleRegistrationNames;
          if (Z.hasOwnProperty(m))
            return !0;
          var pe = _.hasOwnProperty(W) ? _[W] : null;
          if (pe != null)
            return o("Invalid event handler property `%s`. Did you mean `%s`?", m, pe), tn[m] = !0, !0;
          if (co.test(m))
            return o("Unknown event handler property `%s`. It will be ignored.", m), tn[m] = !0, !0;
        } else if (co.test(m))
          return Oo.test(m) && o("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", m), tn[m] = !0, !0;
        if (uo.test(m) || Do.test(m))
          return !0;
        if (W === "innerhtml")
          return o("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), tn[m] = !0, !0;
        if (W === "aria")
          return o("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), tn[m] = !0, !0;
        if (W === "is" && S !== null && S !== void 0 && typeof S != "string")
          return o("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof S), tn[m] = !0, !0;
        if (typeof S == "number" && isNaN(S))
          return o("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", m), tn[m] = !0, !0;
        var c = Xe(m), h = c !== null && c.type === Se;
        if (ii.hasOwnProperty(W)) {
          var C = ii[W];
          if (C !== m)
            return o("Invalid DOM property `%s`. Did you mean `%s`?", m, C), tn[m] = !0, !0;
        } else if (!h && m !== W)
          return o("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", m, W), tn[m] = !0, !0;
        return typeof S == "boolean" && Je(m, S, c, !1) ? (S ? o('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', S, m, m, S, m) : o('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', S, m, m, S, m, m, m), tn[m] = !0, !0) : h ? !0 : Je(m, S, c, !1) ? (tn[m] = !0, !1) : ((S === "false" || S === "true") && c !== null && c.type === ge && (o("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", S, m, S === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', m, S), tn[m] = !0), !0);
      };
    }
    var fo = function(d, m, S) {
      {
        var R = [];
        for (var W in m) {
          var Z = tr(d, W, m[W], S);
          Z || R.push(W);
        }
        var _ = R.map(function(pe) {
          return "`" + pe + "`";
        }).join(", ");
        R.length === 1 ? o("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", _, d) : R.length > 1 && o("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", _, d);
      }
    };
    function xi(d, m, S) {
      Fr(d, m) || fo(d, m, S);
    }
    var Fo = function() {
    };
    {
      var Lr = /^(?:webkit|moz|o)[A-Z]/, No = /^-ms-/, aa = /-(.)/g, Nn = /;\s*$/, Er = {}, Yn = {}, Bt = !1, Br = !1, Mo = function(d) {
        return d.replace(aa, function(m, S) {
          return S.toUpperCase();
        });
      }, Lo = function(d) {
        Er.hasOwnProperty(d) && Er[d] || (Er[d] = !0, o(
          "Unsupported style property %s. Did you mean %s?",
          d,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Mo(d.replace(No, "ms-"))
        ));
      }, Ar = function(d) {
        Er.hasOwnProperty(d) && Er[d] || (Er[d] = !0, o("Unsupported vendor-prefixed style property %s. Did you mean %s?", d, d.charAt(0).toUpperCase() + d.slice(1)));
      }, Bo = function(d, m) {
        Yn.hasOwnProperty(m) && Yn[m] || (Yn[m] = !0, o(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, d, m.replace(Nn, "")));
      }, Vr = function(d, m) {
        Bt || (Bt = !0, o("`NaN` is an invalid value for the `%s` css style property.", d));
      }, ln = function(d, m) {
        Br || (Br = !0, o("`Infinity` is an invalid value for the `%s` css style property.", d));
      };
      Fo = function(d, m) {
        d.indexOf("-") > -1 ? Lo(d) : Lr.test(d) ? Ar(d) : Nn.test(m) && Bo(d, m), typeof m == "number" && (isNaN(m) ? Vr(d, m) : isFinite(m) || ln(d, m));
      };
    }
    var Ti = Fo, Vo = /["'&<>]/;
    function Pi(d) {
      He(d);
      var m = "" + d, S = Vo.exec(m);
      if (!S)
        return m;
      var R, W = "", Z, _ = 0;
      for (Z = S.index; Z < m.length; Z++) {
        switch (m.charCodeAt(Z)) {
          case 34:
            R = "&quot;";
            break;
          case 38:
            R = "&amp;";
            break;
          case 39:
            R = "&#x27;";
            break;
          case 60:
            R = "&lt;";
            break;
          case 62:
            R = "&gt;";
            break;
          default:
            continue;
        }
        _ !== Z && (W += m.substring(_, Z)), _ = Z + 1, W += R;
      }
      return _ !== Z ? W + m.substring(_, Z) : W;
    }
    function cn(d) {
      return typeof d == "boolean" || typeof d == "number" ? "" + d : Pi(d);
    }
    var ki = /([A-Z])/g, Ba = /^ms-/;
    function Va(d) {
      return d.replace(ki, "-$1").toLowerCase().replace(Ba, "-ms-");
    }
    var X = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, ke = !1;
    function Ve(d) {
      !ke && X.test(d) && (ke = !0, o("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(d)));
    }
    var at = Array.isArray;
    function St(d) {
      return at(d);
    }
    var Ot = k("<script>"), Tt = k("<\/script>"), Et = k('<script src="'), vn = k('<script type="module" src="'), Kt = k('" async=""><\/script>');
    function Xt(d) {
      return He(d), ("" + d).replace(pn, Un);
    }
    var pn = /(<\/|<)(s)(cript)/gi, Un = function(d, m, S, R) {
      return "" + m + (S === "s" ? "\\u0073" : "\\u0053") + R;
    };
    function go(d, m, S, R, W) {
      var Z = d === void 0 ? "" : d, _ = m === void 0 ? Ot : k('<script nonce="' + cn(m) + '">'), pe = [];
      if (S !== void 0 && pe.push(_, D(Xt(S)), Tt), R !== void 0)
        for (var c = 0; c < R.length; c++)
          pe.push(Et, D(cn(R[c])), Kt);
      if (W !== void 0)
        for (var h = 0; h < W.length; h++)
          pe.push(vn, D(cn(W[h])), Kt);
      return {
        bootstrapChunks: pe,
        startInlineScript: _,
        placeholderPrefix: k(Z + "P:"),
        segmentPrefix: k(Z + "S:"),
        boundaryPrefix: Z + "B:",
        idPrefix: Z,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
      };
    }
    var an = 0, bn = 1, po = 2, qr = 3, Mn = 4, Ri = 5, _r = 6, ho = 7;
    function pr(d, m) {
      return {
        insertionMode: d,
        selectedValue: m
      };
    }
    function jo(d) {
      var m = d === "http://www.w3.org/2000/svg" ? po : d === "http://www.w3.org/1998/Math/MathML" ? qr : an;
      return pr(m, null);
    }
    function ai(d, m, S) {
      switch (m) {
        case "select":
          return pr(bn, S.value != null ? S.value : S.defaultValue);
        case "svg":
          return pr(po, null);
        case "math":
          return pr(qr, null);
        case "foreignObject":
          return pr(bn, null);
        case "table":
          return pr(Mn, null);
        case "thead":
        case "tbody":
        case "tfoot":
          return pr(Ri, null);
        case "colgroup":
          return pr(ho, null);
        case "tr":
          return pr(_r, null);
      }
      return d.insertionMode >= Mn || d.insertionMode === an ? pr(bn, null) : d;
    }
    var sa = null;
    function la(d) {
      var m = d.nextSuspenseID++;
      return k(d.boundaryPrefix + m.toString(16));
    }
    function Oi(d, m, S) {
      var R = d.idPrefix, W = ":" + R + "R" + m;
      return S > 0 && (W += "H" + S.toString(32)), W + ":";
    }
    function mo(d) {
      return cn(d);
    }
    var ja = k("<!-- -->");
    function Di(d, m, S, R) {
      return m === "" ? R : (R && d.push(ja), d.push(D(mo(m))), !0);
    }
    function Uo(d, m, S, R) {
      S && R && d.push(ja);
    }
    var v = /* @__PURE__ */ new Map();
    function P(d) {
      var m = v.get(d);
      if (m !== void 0)
        return m;
      var S = k(cn(Va(d)));
      return v.set(d, S), S;
    }
    var V = k(' style="'), H = k(":"), le = k(";");
    function ne(d, m, S) {
      if (typeof S != "object")
        throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      var R = !0;
      for (var W in S)
        if (Re.call(S, W)) {
          var Z = S[W];
          if (!(Z == null || typeof Z == "boolean" || Z === "")) {
            var _ = void 0, pe = void 0, c = W.indexOf("--") === 0;
            c ? (_ = D(cn(W)), Oe(Z, W), pe = D(cn(("" + Z).trim()))) : (Ti(W, Z), _ = P(W), typeof Z == "number" ? Z !== 0 && !Re.call(Mt, W) ? pe = D(Z + "px") : pe = D("" + Z) : (Oe(Z, W), pe = D(cn(("" + Z).trim())))), R ? (R = !1, d.push(V, _, H, pe)) : d.push(le, _, H, pe);
          }
        }
      R || d.push(Qe);
    }
    var ye = k(" "), Ne = k('="'), Qe = k('"'), nt = k('=""');
    function et(d, m, S, R) {
      switch (S) {
        case "style": {
          ne(d, m, R);
          return;
        }
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
          return;
      }
      if (
        // shouldIgnoreAttribute
        // We have already filtered out null/undefined and reserved words.
        !(S.length > 2 && (S[0] === "o" || S[0] === "O") && (S[1] === "n" || S[1] === "N"))
      ) {
        var W = Xe(S);
        if (W !== null) {
          switch (typeof R) {
            case "function":
            case "symbol":
              return;
            case "boolean":
              if (!W.acceptsBooleans)
                return;
          }
          var Z = W.attributeName, _ = D(Z);
          switch (W.type) {
            case ge:
              R && d.push(ye, _, nt);
              return;
            case Ie:
              R === !0 ? d.push(ye, _, nt) : R === !1 || d.push(ye, _, Ne, D(cn(R)), Qe);
              return;
            case Ye:
              isNaN(R) || d.push(ye, _, Ne, D(cn(R)), Qe);
              break;
            case Ke:
              !isNaN(R) && R >= 1 && d.push(ye, _, Ne, D(cn(R)), Qe);
              break;
            default:
              W.sanitizeURL && (Fe(R, Z), R = "" + R, Ve(R)), d.push(ye, _, Ne, D(cn(R)), Qe);
          }
        } else if (Le(S)) {
          switch (typeof R) {
            case "function":
            case "symbol":
              return;
            case "boolean": {
              var pe = S.toLowerCase().slice(0, 5);
              if (pe !== "data-" && pe !== "aria-")
                return;
            }
          }
          d.push(ye, D(S), Ne, D(cn(R)), Qe);
        }
      }
    }
    var jt = k(">"), Sr = k("/>");
    function zn(d, m, S) {
      if (m != null) {
        if (S != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof m != "object" || !("__html" in m))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var R = m.__html;
        R != null && (He(R), d.push(D("" + R)));
      }
    }
    var Zn = !1, vo = !1, jr = !1, ca = !1, si = !1, Fi = !1, bo = !1;
    function Ua(d, m) {
      {
        var S = d[m];
        if (S != null) {
          var R = St(S);
          d.multiple && !R ? o("The `%s` prop supplied to <select> must be an array if `multiple` is true.", m) : !d.multiple && R && o("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", m);
        }
      }
    }
    function hu(d, m, S) {
      Fn("select", m), Ua(m, "value"), Ua(m, "defaultValue"), m.value !== void 0 && m.defaultValue !== void 0 && !jr && (o("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), jr = !0), d.push($r("select"));
      var R = null, W = null;
      for (var Z in m)
        if (Re.call(m, Z)) {
          var _ = m[Z];
          if (_ == null)
            continue;
          switch (Z) {
            case "children":
              R = _;
              break;
            case "dangerouslySetInnerHTML":
              W = _;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              et(d, S, Z, _);
              break;
          }
        }
      return d.push(jt), zn(d, W, R), R;
    }
    function mu(d) {
      var m = "";
      return e.Children.forEach(d, function(S) {
        S != null && (m += S, !si && typeof S != "string" && typeof S != "number" && (si = !0, o("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }), m;
    }
    var dl = k(' selected=""');
    function fl(d, m, S, R) {
      var W = R.selectedValue;
      d.push($r("option"));
      var Z = null, _ = null, pe = null, c = null;
      for (var h in m)
        if (Re.call(m, h)) {
          var C = m[h];
          if (C == null)
            continue;
          switch (h) {
            case "children":
              Z = C;
              break;
            case "selected":
              pe = C, bo || (o("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), bo = !0);
              break;
            case "dangerouslySetInnerHTML":
              c = C;
              break;
            case "value":
              _ = C;
            default:
              et(d, S, h, C);
              break;
          }
        }
      if (W != null) {
        var x;
        if (_ !== null ? (Fe(_, "value"), x = "" + _) : (c !== null && (Fi || (Fi = !0, o("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."))), x = mu(Z)), St(W))
          for (var M = 0; M < W.length; M++) {
            Fe(W[M], "value");
            var Y = "" + W[M];
            if (Y === x) {
              d.push(dl);
              break;
            }
          }
        else
          Fe(W, "select.value"), "" + W === x && d.push(dl);
      } else
        pe && d.push(dl);
      return d.push(jt), zn(d, c, Z), Z;
    }
    function gl(d, m, S) {
      Fn("input", m), m.checked !== void 0 && m.defaultChecked !== void 0 && !vo && (o("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", m.type), vo = !0), m.value !== void 0 && m.defaultValue !== void 0 && !Zn && (o("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", m.type), Zn = !0), d.push($r("input"));
      var R = null, W = null, Z = null, _ = null;
      for (var pe in m)
        if (Re.call(m, pe)) {
          var c = m[pe];
          if (c == null)
            continue;
          switch (pe) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            case "defaultChecked":
              _ = c;
              break;
            case "defaultValue":
              W = c;
              break;
            case "checked":
              Z = c;
              break;
            case "value":
              R = c;
              break;
            default:
              et(d, S, pe, c);
              break;
          }
        }
      return Z !== null ? et(d, S, "checked", Z) : _ !== null && et(d, S, "checked", _), R !== null ? et(d, S, "value", R) : W !== null && et(d, S, "value", W), d.push(Sr), null;
    }
    function Wo(d, m, S) {
      Fn("textarea", m), m.value !== void 0 && m.defaultValue !== void 0 && !ca && (o("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components"), ca = !0), d.push($r("textarea"));
      var R = null, W = null, Z = null;
      for (var _ in m)
        if (Re.call(m, _)) {
          var pe = m[_];
          if (pe == null)
            continue;
          switch (_) {
            case "children":
              Z = pe;
              break;
            case "value":
              R = pe;
              break;
            case "defaultValue":
              W = pe;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
            default:
              et(d, S, _, pe);
              break;
          }
        }
      if (R === null && W !== null && (R = W), d.push(jt), Z != null) {
        if (o("Use the `defaultValue` or `value` props instead of setting children on <textarea>."), R != null)
          throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
        if (St(Z)) {
          if (Z.length > 1)
            throw new Error("<textarea> can only have at most one child.");
          He(Z[0]), R = "" + Z[0];
        }
        He(Z), R = "" + Z;
      }
      return typeof R == "string" && R[0] === `
` && d.push(Ni), R !== null && (Fe(R, "value"), d.push(D(mo("" + R)))), null;
    }
    function Wa(d, m, S, R) {
      d.push($r(S));
      for (var W in m)
        if (Re.call(m, W)) {
          var Z = m[W];
          if (Z == null)
            continue;
          switch (W) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error(S + " is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            default:
              et(d, R, W, Z);
              break;
          }
        }
      return d.push(Sr), null;
    }
    function Cs(d, m, S) {
      d.push($r("menuitem"));
      for (var R in m)
        if (Re.call(m, R)) {
          var W = m[R];
          if (W == null)
            continue;
          switch (R) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("menuitems cannot have `children` nor `dangerouslySetInnerHTML`.");
            default:
              et(d, S, R, W);
              break;
          }
        }
      return d.push(jt), null;
    }
    function rn(d, m, S) {
      d.push($r("title"));
      var R = null;
      for (var W in m)
        if (Re.call(m, W)) {
          var Z = m[W];
          if (Z == null)
            continue;
          switch (W) {
            case "children":
              R = Z;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <title>.");
            default:
              et(d, S, W, Z);
              break;
          }
        }
      d.push(jt);
      {
        var _ = Array.isArray(R) && R.length < 2 ? R[0] || null : R;
        Array.isArray(R) && R.length > 1 ? o("A title element received an array with more than 1 element as children. In browsers title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : _ != null && _.$$typeof != null ? o("A title element received a React element for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : _ != null && typeof _ != "string" && typeof _ != "number" && o("A title element received a value that was not a string or number for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
      }
      return R;
    }
    function Gt(d, m, S, R) {
      d.push($r(S));
      var W = null, Z = null;
      for (var _ in m)
        if (Re.call(m, _)) {
          var pe = m[_];
          if (pe == null)
            continue;
          switch (_) {
            case "children":
              W = pe;
              break;
            case "dangerouslySetInnerHTML":
              Z = pe;
              break;
            default:
              et(d, R, _, pe);
              break;
          }
        }
      return d.push(jt), zn(d, Z, W), typeof W == "string" ? (d.push(D(mo(W))), null) : W;
    }
    function Pt(d, m, S, R) {
      d.push($r(S));
      var W = null, Z = null;
      for (var _ in m)
        if (Re.call(m, _)) {
          var pe = m[_];
          if (pe == null)
            continue;
          switch (_) {
            case "children":
              W = pe;
              break;
            case "dangerouslySetInnerHTML":
              Z = pe;
              break;
            case "style":
              ne(d, R, pe);
              break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
              break;
            default:
              Le(_) && typeof pe != "function" && typeof pe != "symbol" && d.push(ye, D(_), Ne, D(cn(pe)), Qe);
              break;
          }
        }
      return d.push(jt), zn(d, Z, W), W;
    }
    var Ni = k(`
`);
    function li(d, m, S, R) {
      d.push($r(S));
      var W = null, Z = null;
      for (var _ in m)
        if (Re.call(m, _)) {
          var pe = m[_];
          if (pe == null)
            continue;
          switch (_) {
            case "children":
              W = pe;
              break;
            case "dangerouslySetInnerHTML":
              Z = pe;
              break;
            default:
              et(d, R, _, pe);
              break;
          }
        }
      if (d.push(jt), Z != null) {
        if (W != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof Z != "object" || !("__html" in Z))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var c = Z.__html;
        c != null && (typeof c == "string" && c.length > 0 && c[0] === `
` ? d.push(Ni, D(c)) : (He(c), d.push(D("" + c))));
      }
      return typeof W == "string" && W[0] === `
` && d.push(Ni), W;
    }
    var Es = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, ci = /* @__PURE__ */ new Map();
    function $r(d) {
      var m = ci.get(d);
      if (m === void 0) {
        if (!Es.test(d))
          throw new Error("Invalid tag: " + d);
        m = k("<" + d), ci.set(d, m);
      }
      return m;
    }
    var pl = k("<!DOCTYPE html>");
    function As(d, m, S, R, W) {
      switch (An(m, S), Mr(m, S), xi(m, S, null), !S.suppressContentEditableWarning && S.contentEditable && S.children != null && o("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), W.insertionMode !== po && W.insertionMode !== qr && m.indexOf("-") === -1 && typeof S.is != "string" && m.toLowerCase() !== m && o("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", m), m) {
        case "select":
          return hu(d, S, R);
        case "option":
          return fl(d, S, R, W);
        case "textarea":
          return Wo(d, S, R);
        case "input":
          return gl(d, S, R);
        case "menuitem":
          return Cs(d, S, R);
        case "title":
          return rn(d, S, R);
        case "listing":
        case "pre":
          return li(d, S, m, R);
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          return Wa(d, S, m, R);
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return Gt(d, S, m, R);
        case "html":
          return W.insertionMode === an && d.push(pl), Gt(d, S, m, R);
        default:
          return m.indexOf("-") === -1 && typeof S.is != "string" ? Gt(d, S, m, R) : Pt(d, S, m, R);
      }
    }
    var dc = k("</"), Ln = k(">");
    function Ss(d, m, S) {
      switch (m) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          d.push(dc, D(m), Ln);
      }
    }
    function Mi(d, m) {
      for (var S = m.bootstrapChunks, R = 0; R < S.length - 1; R++)
        A(d, S[R]);
      return R < S.length ? w(d, S[R]) : !0;
    }
    var fc = k('<template id="'), ua = k('"></template>');
    function nr(d, m, S) {
      A(d, fc), A(d, m.placeholderPrefix);
      var R = D(S.toString(16));
      return A(d, R), w(d, ua);
    }
    var Ha = k("<!--$-->"), da = k('<!--$?--><template id="'), gc = k('"></template>'), fa = k("<!--$!-->"), ws = k("<!--/$-->"), Is = k("<template"), Bn = k('"'), ga = k(' data-dgst="'), rr = k(' data-msg="'), pc = k(' data-stck="'), xs = k("></template>");
    function Ho(d, m) {
      return w(d, Ha);
    }
    function Li(d, m, S) {
      if (A(d, da), S === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return A(d, S), w(d, gc);
    }
    function or(d, m, S, R, W) {
      var Z;
      return Z = w(d, fa), A(d, Is), S && (A(d, ga), A(d, D(cn(S))), A(d, Bn)), R && (A(d, rr), A(d, D(cn(R))), A(d, Bn)), W && (A(d, pc), A(d, D(cn(W))), A(d, Bn)), Z = w(d, xs), Z;
    }
    function sn(d, m) {
      return w(d, ws);
    }
    function eo(d, m) {
      return w(d, ws);
    }
    function hl(d, m) {
      return w(d, ws);
    }
    var hc = k('<div hidden id="'), pa = k('">'), mc = k("</div>"), vc = k('<svg aria-hidden="true" style="display:none" id="'), Ts = k('">'), Ga = k("</svg>"), Ya = k('<math aria-hidden="true" style="display:none" id="'), Bi = k('">'), bc = k("</math>"), Ps = k('<table hidden id="'), ml = k('">'), b = k("</table>"), T = k('<table hidden><tbody id="'), L = k('">'), G = k("</tbody></table>"), ce = k('<table hidden><tr id="'), ie = k('">'), Ae = k("</tr></table>"), Me = k('<table hidden><colgroup id="'), qe = k('">'), At = k("</colgroup></table>");
    function pt(d, m, S, R) {
      switch (S.insertionMode) {
        case an:
        case bn:
          return A(d, hc), A(d, m.segmentPrefix), A(d, D(R.toString(16))), w(d, pa);
        case po:
          return A(d, vc), A(d, m.segmentPrefix), A(d, D(R.toString(16))), w(d, Ts);
        case qr:
          return A(d, Ya), A(d, m.segmentPrefix), A(d, D(R.toString(16))), w(d, Bi);
        case Mn:
          return A(d, Ps), A(d, m.segmentPrefix), A(d, D(R.toString(16))), w(d, ml);
        case Ri:
          return A(d, T), A(d, m.segmentPrefix), A(d, D(R.toString(16))), w(d, L);
        case _r:
          return A(d, ce), A(d, m.segmentPrefix), A(d, D(R.toString(16))), w(d, ie);
        case ho:
          return A(d, Me), A(d, m.segmentPrefix), A(d, D(R.toString(16))), w(d, qe);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    function on(d, m) {
      switch (m.insertionMode) {
        case an:
        case bn:
          return w(d, mc);
        case po:
          return w(d, Ga);
        case qr:
          return w(d, bc);
        case Mn:
          return w(d, b);
        case Ri:
          return w(d, G);
        case _r:
          return w(d, Ae);
        case ho:
          return w(d, At);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    var hr = "function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}", to = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}', no = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}', ks = k(hr + ';$RS("'), yc = k('$RS("'), vl = k('","'), Rs = k('")<\/script>');
    function zf(d, m, S) {
      A(d, m.startInlineScript), m.sentCompleteSegmentFunction ? A(d, yc) : (m.sentCompleteSegmentFunction = !0, A(d, ks)), A(d, m.segmentPrefix);
      var R = D(S.toString(16));
      return A(d, R), A(d, vl), A(d, m.placeholderPrefix), A(d, R), w(d, Rs);
    }
    var Zf = k(to + ';$RC("'), vu = k('$RC("'), xd = k('","'), ha = k('")<\/script>');
    function Os(d, m, S, R) {
      if (A(d, m.startInlineScript), m.sentCompleteBoundaryFunction ? A(d, vu) : (m.sentCompleteBoundaryFunction = !0, A(d, Zf)), S === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      var W = D(R.toString(16));
      return A(d, S), A(d, xd), A(d, m.segmentPrefix), A(d, W), w(d, ha);
    }
    var Kf = k(no + ';$RX("'), Xf = k('$RX("'), bu = k('"'), Ds = k(")<\/script>"), ro = k(",");
    function yu(d, m, S, R, W, Z) {
      if (A(d, m.startInlineScript), m.sentClientRenderFunction ? A(d, Xf) : (m.sentClientRenderFunction = !0, A(d, Kf)), S === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return A(d, S), A(d, bu), (R || W || Z) && (A(d, ro), A(d, D(Cu(R || "")))), (W || Z) && (A(d, ro), A(d, D(Cu(W || "")))), Z && (A(d, ro), A(d, D(Cu(Z)))), w(d, Ds);
    }
    var Td = /[<\u2028\u2029]/g;
    function Cu(d) {
      var m = JSON.stringify(d);
      return m.replace(Td, function(S) {
        switch (S) {
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw new Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
      });
    }
    var yo = Object.assign, Jf = Symbol.for("react.element"), Pd = Symbol.for("react.portal"), Kn = Symbol.for("react.fragment"), te = Symbol.for("react.strict_mode"), Ee = Symbol.for("react.profiler"), he = Symbol.for("react.provider"), Ze = Symbol.for("react.context"), ht = Symbol.for("react.forward_ref"), Ut = Symbol.for("react.suspense"), wn = Symbol.for("react.suspense_list"), Jt = Symbol.for("react.memo"), ma = Symbol.for("react.lazy"), Eu = Symbol.for("react.scope"), Ur = Symbol.for("react.debug_trace_mode"), za = Symbol.for("react.legacy_hidden"), Qf = Symbol.for("react.default_value"), Za = Symbol.iterator, Cc = "@@iterator";
    function Ec(d) {
      if (d === null || typeof d != "object")
        return null;
      var m = Za && d[Za] || d[Cc];
      return typeof m == "function" ? m : null;
    }
    function _t(d, m, S) {
      var R = d.displayName;
      if (R)
        return R;
      var W = m.displayName || m.name || "";
      return W !== "" ? S + "(" + W + ")" : S;
    }
    function kd(d) {
      return d.displayName || "Context";
    }
    function yn(d) {
      if (d == null)
        return null;
      if (typeof d.tag == "number" && o("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof d == "function")
        return d.displayName || d.name || null;
      if (typeof d == "string")
        return d;
      switch (d) {
        case Kn:
          return "Fragment";
        case Pd:
          return "Portal";
        case Ee:
          return "Profiler";
        case te:
          return "StrictMode";
        case Ut:
          return "Suspense";
        case wn:
          return "SuspenseList";
      }
      if (typeof d == "object")
        switch (d.$$typeof) {
          case Ze:
            var m = d;
            return kd(m) + ".Consumer";
          case he:
            var S = d;
            return kd(S._context) + ".Provider";
          case ht:
            return _t(d, d.render, "ForwardRef");
          case Jt:
            var R = d.displayName || null;
            return R !== null ? R : yn(d.type) || "Memo";
          case ma: {
            var W = d, Z = W._payload, _ = W._init;
            try {
              return yn(_(Z));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var va = 0, Au, Cn, Fs, Ns, ui, Ms, Ac;
    function Ls() {
    }
    Ls.__reactDisabledLog = !0;
    function Su() {
      {
        if (va === 0) {
          Au = console.log, Cn = console.info, Fs = console.warn, Ns = console.error, ui = console.group, Ms = console.groupCollapsed, Ac = console.groupEnd;
          var d = {
            configurable: !0,
            enumerable: !0,
            value: Ls,
            writable: !0
          };
          Object.defineProperties(console, {
            info: d,
            log: d,
            warn: d,
            error: d,
            group: d,
            groupCollapsed: d,
            groupEnd: d
          });
        }
        va++;
      }
    }
    function wu() {
      {
        if (va--, va === 0) {
          var d = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: yo({}, d, {
              value: Au
            }),
            info: yo({}, d, {
              value: Cn
            }),
            warn: yo({}, d, {
              value: Fs
            }),
            error: yo({}, d, {
              value: Ns
            }),
            group: yo({}, d, {
              value: ui
            }),
            groupCollapsed: yo({}, d, {
              value: Ms
            }),
            groupEnd: yo({}, d, {
              value: Ac
            })
          });
        }
        va < 0 && o("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ka = t.ReactCurrentDispatcher, Sc;
    function Vi(d, m, S) {
      {
        if (Sc === void 0)
          try {
            throw Error();
          } catch (W) {
            var R = W.stack.trim().match(/\n( *(at )?)/);
            Sc = R && R[1] || "";
          }
        return `
` + Sc + d;
      }
    }
    var Go = !1, ji;
    {
      var bl = typeof WeakMap == "function" ? WeakMap : Map;
      ji = new bl();
    }
    function yl(d, m) {
      if (!d || Go)
        return "";
      {
        var S = ji.get(d);
        if (S !== void 0)
          return S;
      }
      var R;
      Go = !0;
      var W = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Z;
      Z = Ka.current, Ka.current = null, Su();
      try {
        if (m) {
          var _ = function() {
            throw Error();
          };
          if (Object.defineProperty(_.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_, []);
            } catch (J) {
              R = J;
            }
            Reflect.construct(d, [], _);
          } else {
            try {
              _.call();
            } catch (J) {
              R = J;
            }
            d.call(_.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (J) {
            R = J;
          }
          d();
        }
      } catch (J) {
        if (J && R && typeof J.stack == "string") {
          for (var pe = J.stack.split(`
`), c = R.stack.split(`
`), h = pe.length - 1, C = c.length - 1; h >= 1 && C >= 0 && pe[h] !== c[C]; )
            C--;
          for (; h >= 1 && C >= 0; h--, C--)
            if (pe[h] !== c[C]) {
              if (h !== 1 || C !== 1)
                do
                  if (h--, C--, C < 0 || pe[h] !== c[C]) {
                    var x = `
` + pe[h].replace(" at new ", " at ");
                    return d.displayName && x.includes("<anonymous>") && (x = x.replace("<anonymous>", d.displayName)), typeof d == "function" && ji.set(d, x), x;
                  }
                while (h >= 1 && C >= 0);
              break;
            }
        }
      } finally {
        Go = !1, Ka.current = Z, wu(), Error.prepareStackTrace = W;
      }
      var M = d ? d.displayName || d.name : "", Y = M ? Vi(M) : "";
      return typeof d == "function" && ji.set(d, Y), Y;
    }
    function wc(d, m, S) {
      return yl(d, !0);
    }
    function Cl(d, m, S) {
      return yl(d, !1);
    }
    function Bs(d) {
      var m = d.prototype;
      return !!(m && m.isReactComponent);
    }
    function El(d, m, S) {
      if (d == null)
        return "";
      if (typeof d == "function")
        return yl(d, Bs(d));
      if (typeof d == "string")
        return Vi(d);
      switch (d) {
        case Ut:
          return Vi("Suspense");
        case wn:
          return Vi("SuspenseList");
      }
      if (typeof d == "object")
        switch (d.$$typeof) {
          case ht:
            return Cl(d.render);
          case Jt:
            return El(d.type, m, S);
          case ma: {
            var R = d, W = R._payload, Z = R._init;
            try {
              return El(Z(W), m, S);
            } catch {
            }
          }
        }
      return "";
    }
    var Iu = {}, xu = t.ReactDebugCurrentFrame;
    function Vs(d) {
      if (d) {
        var m = d._owner, S = El(d.type, d._source, m ? m.type : null);
        xu.setExtraStackFrame(S);
      } else
        xu.setExtraStackFrame(null);
    }
    function Tu(d, m, S, R, W) {
      {
        var Z = Function.call.bind(Re);
        for (var _ in d)
          if (Z(d, _)) {
            var pe = void 0;
            try {
              if (typeof d[_] != "function") {
                var c = Error((R || "React class") + ": " + S + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof d[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw c.name = "Invariant Violation", c;
              }
              pe = d[_](m, _, R, S, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (h) {
              pe = h;
            }
            pe && !(pe instanceof Error) && (Vs(W), o("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", R || "React class", S, _, typeof pe), Vs(null)), pe instanceof Error && !(pe.message in Iu) && (Iu[pe.message] = !0, Vs(W), o("Failed %s type: %s", S, pe.message), Vs(null));
          }
      }
    }
    var xn;
    xn = {};
    var Tn = {};
    Object.freeze(Tn);
    function Pu(d, m) {
      {
        var S = d.contextTypes;
        if (!S)
          return Tn;
        var R = {};
        for (var W in S)
          R[W] = m[W];
        {
          var Z = yn(d) || "Unknown";
          Tu(S, R, "context", Z);
        }
        return R;
      }
    }
    function ku(d, m, S, R) {
      {
        if (typeof d.getChildContext != "function") {
          {
            var W = yn(m) || "Unknown";
            xn[W] || (xn[W] = !0, o("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", W, W));
          }
          return S;
        }
        var Z = d.getChildContext();
        for (var _ in Z)
          if (!(_ in R))
            throw new Error((yn(m) || "Unknown") + '.getChildContext(): key "' + _ + '" is not defined in childContextTypes.');
        {
          var pe = yn(m) || "Unknown";
          Tu(R, Z, "child context", pe);
        }
        return yo({}, S, Z);
      }
    }
    var Ui;
    Ui = {};
    var Rd = null, Wi = null;
    function Yo(d) {
      d.context._currentValue = d.parentValue;
    }
    function Al(d) {
      d.context._currentValue = d.value;
    }
    function wr(d, m) {
      if (d !== m) {
        Yo(d);
        var S = d.parent, R = m.parent;
        if (S === null) {
          if (R !== null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
        } else {
          if (R === null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
          wr(S, R);
        }
        Al(m);
      }
    }
    function ba(d) {
      Yo(d);
      var m = d.parent;
      m !== null && ba(m);
    }
    function ya(d) {
      var m = d.parent;
      m !== null && ya(m), Al(d);
    }
    function Ca(d, m) {
      Yo(d);
      var S = d.parent;
      if (S === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      S.depth === m.depth ? wr(S, m) : Ca(S, m);
    }
    function Ea(d, m) {
      var S = m.parent;
      if (S === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      d.depth === S.depth ? wr(d, S) : Ea(d, S), Al(m);
    }
    function Sl(d) {
      var m = Wi, S = d;
      m !== S && (m === null ? ya(S) : S === null ? ba(m) : m.depth === S.depth ? wr(m, S) : m.depth > S.depth ? Ca(m, S) : Ea(m, S), Wi = S);
    }
    function Od(d, m) {
      var S;
      S = d._currentValue, d._currentValue = m, d._currentRenderer !== void 0 && d._currentRenderer !== null && d._currentRenderer !== Ui && o("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), d._currentRenderer = Ui;
      var R = Wi, W = {
        parent: R,
        depth: R === null ? 0 : R.depth + 1,
        context: d,
        parentValue: S,
        value: m
      };
      return Wi = W, W;
    }
    function Dd(d) {
      var m = Wi;
      if (m === null)
        throw new Error("Tried to pop a Context at the root of the app. This is a bug in React.");
      m.context !== d && o("The parent context is not the expected context. This is probably a bug in React.");
      {
        var S = m.parentValue;
        S === Qf ? m.context._currentValue = m.context._defaultValue : m.context._currentValue = S, d._currentRenderer !== void 0 && d._currentRenderer !== null && d._currentRenderer !== Ui && o("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), d._currentRenderer = Ui;
      }
      return Wi = m.parent;
    }
    function Ic() {
      return Wi;
    }
    function wl(d) {
      var m = d._currentValue;
      return m;
    }
    function js(d) {
      return d._reactInternals;
    }
    function Il(d, m) {
      d._reactInternals = m;
    }
    var Xa = {}, B = {}, Aa, Ja, Ir, kt, xc, Us, xl, di, Ws;
    {
      Aa = /* @__PURE__ */ new Set(), Ja = /* @__PURE__ */ new Set(), Ir = /* @__PURE__ */ new Set(), xl = /* @__PURE__ */ new Set(), kt = /* @__PURE__ */ new Set(), di = /* @__PURE__ */ new Set(), Ws = /* @__PURE__ */ new Set();
      var Tc = /* @__PURE__ */ new Set();
      Us = function(d, m) {
        if (!(d === null || typeof d == "function")) {
          var S = m + "_" + d;
          Tc.has(S) || (Tc.add(S), o("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", m, d));
        }
      }, xc = function(d, m) {
        if (m === void 0) {
          var S = yn(d) || "Component";
          kt.has(S) || (kt.add(S), o("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", S));
        }
      };
    }
    function Pc(d, m) {
      {
        var S = d.constructor, R = S && yn(S) || "ReactClass", W = R + "." + m;
        if (Xa[W])
          return;
        o(`%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.

Please check the code for the %s component.`, m, m, R), Xa[W] = !0;
      }
    }
    var kc = {
      isMounted: function(d) {
        return !1;
      },
      enqueueSetState: function(d, m, S) {
        var R = js(d);
        R.queue === null ? Pc(d, "setState") : (R.queue.push(m), S != null && Us(S, "setState"));
      },
      enqueueReplaceState: function(d, m, S) {
        var R = js(d);
        R.replace = !0, R.queue = [m], S != null && Us(S, "setState");
      },
      enqueueForceUpdate: function(d, m) {
        var S = js(d);
        S.queue === null ? Pc(d, "forceUpdate") : m != null && Us(m, "setState");
      }
    };
    function Fd(d, m, S, R, W) {
      var Z = S(W, R);
      xc(m, Z);
      var _ = Z == null ? R : yo({}, R, Z);
      return _;
    }
    function fi(d, m, S) {
      var R = Tn, W = d.contextType;
      if ("contextType" in d) {
        var Z = (
          // Allow null for conditional declaration
          W === null || W !== void 0 && W.$$typeof === Ze && W._context === void 0
        );
        if (!Z && !Ws.has(d)) {
          Ws.add(d);
          var _ = "";
          W === void 0 ? _ = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof W != "object" ? _ = " However, it is set to a " + typeof W + "." : W.$$typeof === he ? _ = " Did you accidentally pass the Context.Provider instead?" : W._context !== void 0 ? _ = " Did you accidentally pass the Context.Consumer instead?" : _ = " However, it is set to an object with keys {" + Object.keys(W).join(", ") + "}.", o("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", yn(d) || "Component", _);
        }
      }
      typeof W == "object" && W !== null ? R = wl(W) : R = S;
      var pe = new d(m, R);
      {
        if (typeof d.getDerivedStateFromProps == "function" && (pe.state === null || pe.state === void 0)) {
          var c = yn(d) || "Component";
          Aa.has(c) || (Aa.add(c), o("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", c, pe.state === null ? "null" : "undefined", c));
        }
        if (typeof d.getDerivedStateFromProps == "function" || typeof pe.getSnapshotBeforeUpdate == "function") {
          var h = null, C = null, x = null;
          if (typeof pe.componentWillMount == "function" && pe.componentWillMount.__suppressDeprecationWarning !== !0 ? h = "componentWillMount" : typeof pe.UNSAFE_componentWillMount == "function" && (h = "UNSAFE_componentWillMount"), typeof pe.componentWillReceiveProps == "function" && pe.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? C = "componentWillReceiveProps" : typeof pe.UNSAFE_componentWillReceiveProps == "function" && (C = "UNSAFE_componentWillReceiveProps"), typeof pe.componentWillUpdate == "function" && pe.componentWillUpdate.__suppressDeprecationWarning !== !0 ? x = "componentWillUpdate" : typeof pe.UNSAFE_componentWillUpdate == "function" && (x = "UNSAFE_componentWillUpdate"), h !== null || C !== null || x !== null) {
            var M = yn(d) || "Component", Y = typeof d.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            Ir.has(M) || (Ir.add(M), o(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, M, Y, h !== null ? `
  ` + h : "", C !== null ? `
  ` + C : "", x !== null ? `
  ` + x : ""));
          }
        }
      }
      return pe;
    }
    function Nd(d, m, S) {
      {
        var R = yn(m) || "Component", W = d.render;
        W || (m.prototype && typeof m.prototype.render == "function" ? o("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", R) : o("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", R)), d.getInitialState && !d.getInitialState.isReactClassApproved && !d.state && o("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", R), d.getDefaultProps && !d.getDefaultProps.isReactClassApproved && o("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", R), d.propTypes && o("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", R), d.contextType && o("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", R), d.contextTypes && o("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", R), m.contextType && m.contextTypes && !di.has(m) && (di.add(m), o("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", R)), typeof d.componentShouldUpdate == "function" && o("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", R), m.prototype && m.prototype.isPureReactComponent && typeof d.shouldComponentUpdate < "u" && o("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", yn(m) || "A pure component"), typeof d.componentDidUnmount == "function" && o("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", R), typeof d.componentDidReceiveProps == "function" && o("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", R), typeof d.componentWillRecieveProps == "function" && o("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", R), typeof d.UNSAFE_componentWillRecieveProps == "function" && o("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", R);
        var Z = d.props !== S;
        d.props !== void 0 && Z && o("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", R, R), d.defaultProps && o("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", R, R), typeof d.getSnapshotBeforeUpdate == "function" && typeof d.componentDidUpdate != "function" && !Ja.has(m) && (Ja.add(m), o("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", yn(m))), typeof d.getDerivedStateFromProps == "function" && o("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", R), typeof d.getDerivedStateFromError == "function" && o("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", R), typeof m.getSnapshotBeforeUpdate == "function" && o("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", R);
        var _ = d.state;
        _ && (typeof _ != "object" || St(_)) && o("%s.state: must be set to an object or null", R), typeof d.getChildContext == "function" && typeof m.childContextTypes != "object" && o("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", R);
      }
    }
    function qf(d, m) {
      var S = m.state;
      if (typeof m.componentWillMount == "function") {
        if (m.componentWillMount.__suppressDeprecationWarning !== !0) {
          var R = yn(d) || "Unknown";
          B[R] || (r(
            // keep this warning in sync with ReactStrictModeWarning.js
            `componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.

Please update the following components: %s`,
            R
          ), B[R] = !0);
        }
        m.componentWillMount();
      }
      typeof m.UNSAFE_componentWillMount == "function" && m.UNSAFE_componentWillMount(), S !== m.state && (o("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", yn(d) || "Component"), kc.enqueueReplaceState(m, m.state, null));
    }
    function _f(d, m, S, R) {
      if (d.queue !== null && d.queue.length > 0) {
        var W = d.queue, Z = d.replace;
        if (d.queue = null, d.replace = !1, Z && W.length === 1)
          m.state = W[0];
        else {
          for (var _ = Z ? W[0] : m.state, pe = !0, c = Z ? 1 : 0; c < W.length; c++) {
            var h = W[c], C = typeof h == "function" ? h.call(m, _, S, R) : h;
            C != null && (pe ? (pe = !1, _ = yo({}, _, C)) : yo(_, C));
          }
          m.state = _;
        }
      } else
        d.queue = null;
    }
    function Md(d, m, S, R) {
      Nd(d, m, S);
      var W = d.state !== void 0 ? d.state : null;
      d.updater = kc, d.props = S, d.state = W;
      var Z = {
        queue: [],
        replace: !1
      };
      Il(d, Z);
      var _ = m.contextType;
      if (typeof _ == "object" && _ !== null ? d.context = wl(_) : d.context = R, d.state === S) {
        var pe = yn(m) || "Component";
        xl.has(pe) || (xl.add(pe), o("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", pe));
      }
      var c = m.getDerivedStateFromProps;
      typeof c == "function" && (d.state = Fd(d, m, c, W, S)), typeof m.getDerivedStateFromProps != "function" && typeof d.getSnapshotBeforeUpdate != "function" && (typeof d.UNSAFE_componentWillMount == "function" || typeof d.componentWillMount == "function") && (qf(m, d), _f(Z, d, S, R));
    }
    var $f = {
      id: 1,
      overflow: ""
    };
    function Hi(d) {
      var m = d.overflow, S = d.id, R = S & ~eg(S);
      return R.toString(32) + m;
    }
    function Rc(d, m, S) {
      var R = d.id, W = d.overflow, Z = Oc(R) - 1, _ = R & ~(1 << Z), pe = S + 1, c = Oc(m) + Z;
      if (c > 30) {
        var h = Z - Z % 5, C = (1 << h) - 1, x = (_ & C).toString(32), M = _ >> h, Y = Z - h, J = Oc(m) + Y, fe = pe << Y, Pe = fe | M, We = x + W;
        return {
          id: 1 << J | Pe,
          overflow: We
        };
      } else {
        var _e = pe << Z, gt = _e | _, hn = W;
        return {
          id: 1 << c | gt,
          overflow: hn
        };
      }
    }
    function Oc(d) {
      return 32 - Ru(d);
    }
    function eg(d) {
      return 1 << Oc(d) - 1;
    }
    var Ru = Math.clz32 ? Math.clz32 : tg, Dc = Math.log, Qa = Math.LN2;
    function tg(d) {
      var m = d >>> 0;
      return m === 0 ? 32 : 31 - (Dc(m) / Qa | 0) | 0;
    }
    function ng(d, m) {
      return d === m && (d !== 0 || 1 / d === 1 / m) || d !== d && m !== m;
    }
    var zo = typeof Object.is == "function" ? Object.is : ng, Gi = null, Ou = null, Fc = null, Yt = null, qa = !1, Sa = !1, $t = 0, Co = null, _a = 0, Hs = 25, On = !1, Eo;
    function $a() {
      if (Gi === null)
        throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
      return On && o("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks"), Gi;
    }
    function Zo(d, m) {
      if (m === null)
        return o("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", Eo), !1;
      d.length !== m.length && o(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, Eo, "[" + d.join(", ") + "]", "[" + m.join(", ") + "]");
      for (var S = 0; S < m.length && S < d.length; S++)
        if (!zo(d[S], m[S]))
          return !1;
      return !0;
    }
    function es() {
      if (_a > 0)
        throw new Error("Rendered more hooks than during the previous render");
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }
    function ir() {
      return Yt === null ? Fc === null ? (qa = !1, Fc = Yt = es()) : (qa = !0, Yt = Fc) : Yt.next === null ? (qa = !1, Yt = Yt.next = es()) : (qa = !0, Yt = Yt.next), Yt;
    }
    function Du(d, m) {
      Gi = m, Ou = d, On = !1, $t = 0;
    }
    function wa(d, m, S, R) {
      for (; Sa; )
        Sa = !1, $t = 0, _a += 1, Yt = null, S = d(m, R);
      return Fu(), S;
    }
    function xr() {
      var d = $t !== 0;
      return d;
    }
    function Fu() {
      On = !1, Gi = null, Ou = null, Sa = !1, Fc = null, _a = 0, Co = null, Yt = null;
    }
    function Ld(d) {
      return On && o("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), wl(d);
    }
    function Nu(d) {
      return Eo = "useContext", $a(), wl(d);
    }
    function Yi(d, m) {
      return typeof m == "function" ? m(d) : m;
    }
    function Ia(d) {
      return Eo = "useState", Mu(
        Yi,
        // useReducer has a special case to support lazy useState initializers
        d
      );
    }
    function Mu(d, m, S) {
      if (d !== Yi && (Eo = "useReducer"), Gi = $a(), Yt = ir(), qa) {
        var R = Yt.queue, W = R.dispatch;
        if (Co !== null) {
          var Z = Co.get(R);
          if (Z !== void 0) {
            Co.delete(R);
            var _ = Yt.memoizedState, pe = Z;
            do {
              var c = pe.action;
              On = !0, _ = d(_, c), On = !1, pe = pe.next;
            } while (pe !== null);
            return Yt.memoizedState = _, [_, W];
          }
        }
        return [Yt.memoizedState, W];
      } else {
        On = !0;
        var h;
        d === Yi ? h = typeof m == "function" ? m() : m : h = S !== void 0 ? S(m) : m, On = !1, Yt.memoizedState = h;
        var C = Yt.queue = {
          last: null,
          dispatch: null
        }, x = C.dispatch = Lu.bind(null, Gi, C);
        return [Yt.memoizedState, x];
      }
    }
    function Nc(d, m) {
      Gi = $a(), Yt = ir();
      var S = m === void 0 ? null : m;
      if (Yt !== null) {
        var R = Yt.memoizedState;
        if (R !== null && S !== null) {
          var W = R[1];
          if (Zo(S, W))
            return R[0];
        }
      }
      On = !0;
      var Z = d();
      return On = !1, Yt.memoizedState = [Z, S], Z;
    }
    function Mc(d) {
      Gi = $a(), Yt = ir();
      var m = Yt.memoizedState;
      if (m === null) {
        var S = {
          current: d
        };
        return Object.seal(S), Yt.memoizedState = S, S;
      } else
        return m;
    }
    function Bd(d, m) {
      Eo = "useLayoutEffect", o("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
    }
    function Lu(d, m, S) {
      if (_a >= Hs)
        throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
      if (d === Gi) {
        Sa = !0;
        var R = {
          action: S,
          next: null
        };
        Co === null && (Co = /* @__PURE__ */ new Map());
        var W = Co.get(m);
        if (W === void 0)
          Co.set(m, R);
        else {
          for (var Z = W; Z.next !== null; )
            Z = Z.next;
          Z.next = R;
        }
      }
    }
    function ar(d, m) {
      return Nc(function() {
        return d;
      }, m);
    }
    function Bu(d, m, S) {
      return $a(), m(d._source);
    }
    function Vd(d, m, S) {
      if (S === void 0)
        throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
      return S();
    }
    function gi(d) {
      return $a(), d;
    }
    function Vu() {
      throw new Error("startTransition cannot be called during server rendering.");
    }
    function Lc() {
      return $a(), [!1, Vu];
    }
    function ts() {
      var d = Ou, m = Hi(d.treeContext), S = Pl;
      if (S === null)
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component.");
      var R = $t++;
      return Oi(S, m, R);
    }
    function Tl() {
    }
    var mr = {
      readContext: Ld,
      useContext: Nu,
      useMemo: Nc,
      useReducer: Mu,
      useRef: Mc,
      useState: Ia,
      useInsertionEffect: Tl,
      useLayoutEffect: Bd,
      useCallback: ar,
      // useImperativeHandle is not run in the server environment
      useImperativeHandle: Tl,
      // Effects are not run in the server environment.
      useEffect: Tl,
      // Debugging effect
      useDebugValue: Tl,
      useDeferredValue: gi,
      useTransition: Lc,
      useId: ts,
      // Subscriptions are not setup in a server environment.
      useMutableSource: Bu,
      useSyncExternalStore: Vd
    }, Pl = null;
    function kl(d) {
      Pl = d;
    }
    function jd(d) {
      try {
        var m = "", S = d;
        do {
          switch (S.tag) {
            case 0:
              m += Vi(S.type, null, null);
              break;
            case 1:
              m += Cl(S.type, null, null);
              break;
            case 2:
              m += wc(S.type, null, null);
              break;
          }
          S = S.parent;
        } while (S);
        return m;
      } catch (R) {
        return `
Error generating stack: ` + R.message + `
` + R.stack;
      }
    }
    var Rl = t.ReactCurrentDispatcher, Gs = t.ReactDebugCurrentFrame, ju = 0, Ao = 1, Ol = 2, Bc = 3, ns = 4, Ys = 0, Uu = 1, rs = 2, Wu = 12800;
    function Hu(d) {
      return console.error(d), null;
    }
    function pi() {
    }
    function rg(d, m, S, R, W, Z, _, pe, c) {
      var h = [], C = /* @__PURE__ */ new Set(), x = {
        destination: null,
        responseState: m,
        progressiveChunkSize: R === void 0 ? Wu : R,
        status: Ys,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: C,
        pingedTasks: h,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: W === void 0 ? Hu : W,
        onAllReady: Z === void 0 ? pi : Z,
        onShellReady: _ === void 0 ? pi : _,
        onShellError: pe === void 0 ? pi : pe,
        onFatalError: c === void 0 ? pi : c
      }, M = Vc(
        x,
        0,
        null,
        S,
        // Root segments are never embedded in Text on either edge
        !1,
        !1
      );
      M.parentFlushed = !0;
      var Y = Dl(x, d, null, M, C, Tn, Rd, $f);
      return h.push(Y), x;
    }
    function og(d, m) {
      var S = d.pingedTasks;
      S.push(m), S.length === 1 && l(function() {
        return Ul(d);
      });
    }
    function zs(d, m) {
      return {
        id: sa,
        rootSegmentID: -1,
        parentFlushed: !1,
        pendingTasks: 0,
        forceClientRender: !1,
        completedSegments: [],
        byteSize: 0,
        fallbackAbortableTasks: m,
        errorDigest: null
      };
    }
    function Dl(d, m, S, R, W, Z, _, pe) {
      d.allPendingTasks++, S === null ? d.pendingRootTasks++ : S.pendingTasks++;
      var c = {
        node: m,
        ping: function() {
          return og(d, c);
        },
        blockedBoundary: S,
        blockedSegment: R,
        abortSet: W,
        legacyContext: Z,
        context: _,
        treeContext: pe
      };
      return c.componentStack = null, W.add(c), c;
    }
    function Vc(d, m, S, R, W, Z) {
      return {
        status: ju,
        id: -1,
        // lazily assigned later
        index: m,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: R,
        boundary: S,
        lastPushedText: W,
        textEmbedded: Z
      };
    }
    var Ko = null;
    function Zs() {
      return Ko === null || Ko.componentStack === null ? "" : jd(Ko.componentStack);
    }
    function zi(d, m) {
      d.componentStack = {
        tag: 0,
        parent: d.componentStack,
        type: m
      };
    }
    function Xo(d, m) {
      d.componentStack = {
        tag: 1,
        parent: d.componentStack,
        type: m
      };
    }
    function Ks(d, m) {
      d.componentStack = {
        tag: 2,
        parent: d.componentStack,
        type: m
      };
    }
    function So(d) {
      d.componentStack === null ? o("Unexpectedly popped too many stack frames. This is a bug in React.") : d.componentStack = d.componentStack.parent;
    }
    var os = null;
    function jc(d, m) {
      {
        var S;
        typeof m == "string" ? S = m : m && typeof m.message == "string" ? S = m.message : S = String(m);
        var R = os || Zs();
        os = null, d.errorMessage = S, d.errorComponentStack = R;
      }
    }
    function wo(d, m) {
      var S = d.onError(m);
      if (S != null && typeof S != "string")
        throw new Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof S + '" instead');
      return S;
    }
    function Zi(d, m) {
      var S = d.onShellError;
      S(m);
      var R = d.onFatalError;
      R(m), d.destination !== null ? (d.status = rs, z(d.destination, m)) : (d.status = Uu, d.fatalError = m);
    }
    function Gu(d, m, S) {
      zi(m, "Suspense");
      var R = m.blockedBoundary, W = m.blockedSegment, Z = S.fallback, _ = S.children, pe = /* @__PURE__ */ new Set(), c = zs(d, pe), h = W.chunks.length, C = Vc(
        d,
        h,
        c,
        W.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      W.children.push(C), W.lastPushedText = !1;
      var x = Vc(
        d,
        0,
        null,
        W.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      x.parentFlushed = !0, m.blockedBoundary = c, m.blockedSegment = x;
      try {
        if (Vl(d, m, _), Uo(x.chunks, d.responseState, x.lastPushedText, x.textEmbedded), x.status = Ao, jl(c, x), c.pendingTasks === 0) {
          So(m);
          return;
        }
      } catch (Y) {
        x.status = ns, c.forceClientRender = !0, c.errorDigest = wo(d, Y), jc(c, Y);
      } finally {
        m.blockedBoundary = R, m.blockedSegment = W;
      }
      var M = Dl(d, Z, R, C, pe, m.legacyContext, m.context, m.treeContext);
      M.componentStack = m.componentStack, d.pingedTasks.push(M), So(m);
    }
    function is(d, m, S, R) {
      zi(m, S);
      var W = m.blockedSegment, Z = As(W.chunks, S, R, d.responseState, W.formatContext);
      W.lastPushedText = !1;
      var _ = W.formatContext;
      W.formatContext = ai(_, S, R), Vl(d, m, Z), W.formatContext = _, Ss(W.chunks, S), W.lastPushedText = !1, So(m);
    }
    function Fl(d) {
      return d.prototype && d.prototype.isReactComponent;
    }
    function Uc(d, m, S, R, W) {
      var Z = {};
      Du(m, Z);
      var _ = S(R, W);
      return wa(S, R, _, W);
    }
    function Ud(d, m, S, R, W) {
      var Z = S.render();
      S.props !== W && (Xs || o("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", yn(R) || "a component"), Xs = !0);
      {
        var _ = R.childContextTypes;
        if (_ != null) {
          var pe = m.legacyContext, c = ku(S, R, pe, _);
          m.legacyContext = c, Gr(d, m, Z), m.legacyContext = pe;
          return;
        }
      }
      Gr(d, m, Z);
    }
    function Yu(d, m, S, R) {
      Ks(m, S);
      var W = Pu(S, m.legacyContext), Z = fi(S, R, W);
      Md(Z, S, R, W), Ud(d, m, Z, S, R), So(m);
    }
    var wt = {}, Nl = {}, Wd = {}, as = {}, Xs = !1, zu = !1, Zu = !1, Wr = !1;
    function Hd(d, m, S, R) {
      var W;
      if (W = Pu(S, m.legacyContext), Xo(m, S), S.prototype && typeof S.prototype.render == "function") {
        var Z = yn(S) || "Unknown";
        wt[Z] || (o("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", Z, Z), wt[Z] = !0);
      }
      var _ = Uc(d, m, S, R, W), pe = xr();
      if (typeof _ == "object" && _ !== null && typeof _.render == "function" && _.$$typeof === void 0) {
        var c = yn(S) || "Unknown";
        Nl[c] || (o("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", c, c, c), Nl[c] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof _ == "object" && _ !== null && typeof _.render == "function" && _.$$typeof === void 0
      ) {
        {
          var h = yn(S) || "Unknown";
          Nl[h] || (o("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", h, h, h), Nl[h] = !0);
        }
        Md(_, S, R, W), Ud(d, m, _, S, R);
      } else if (Ml(S), pe) {
        var C = m.treeContext, x = 1, M = 0;
        m.treeContext = Rc(C, x, M);
        try {
          Gr(d, m, _);
        } finally {
          m.treeContext = C;
        }
      } else
        Gr(d, m, _);
      So(m);
    }
    function Ml(d) {
      {
        if (d && d.childContextTypes && o("%s(...): childContextTypes cannot be defined on a function component.", d.displayName || d.name || "Component"), typeof d.getDerivedStateFromProps == "function") {
          var m = yn(d) || "Unknown";
          as[m] || (o("%s: Function components do not support getDerivedStateFromProps.", m), as[m] = !0);
        }
        if (typeof d.contextType == "object" && d.contextType !== null) {
          var S = yn(d) || "Unknown";
          Wd[S] || (o("%s: Function components do not support contextType.", S), Wd[S] = !0);
        }
      }
    }
    function Ll(d, m) {
      if (d && d.defaultProps) {
        var S = yo({}, m), R = d.defaultProps;
        for (var W in R)
          S[W] === void 0 && (S[W] = R[W]);
        return S;
      }
      return m;
    }
    function Gd(d, m, S, R, W) {
      Xo(m, S.render);
      var Z = Uc(d, m, S.render, R, W), _ = xr();
      if (_) {
        var pe = m.treeContext, c = 1, h = 0;
        m.treeContext = Rc(pe, c, h);
        try {
          Gr(d, m, Z);
        } finally {
          m.treeContext = pe;
        }
      } else
        Gr(d, m, Z);
      So(m);
    }
    function Yd(d, m, S, R, W) {
      var Z = S.type, _ = Ll(Z, R);
      Wc(d, m, Z, _, W);
    }
    function Hr(d, m, S, R) {
      S._context === void 0 ? S !== S.Consumer && (Wr || (Wr = !0, o("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : S = S._context;
      var W = R.children;
      typeof W != "function" && o("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
      var Z = wl(S), _ = W(Z);
      Gr(d, m, _);
    }
    function xa(d, m, S, R) {
      var W = S._context, Z = R.value, _ = R.children, pe;
      pe = m.context, m.context = Od(W, Z), Gr(d, m, _), m.context = Dd(W), pe !== m.context && o("Popping the context provider did not return back to the original snapshot. This is a bug in React.");
    }
    function Ku(d, m, S, R, W) {
      zi(m, "Lazy");
      var Z = S._payload, _ = S._init, pe = _(Z), c = Ll(pe, R);
      Wc(d, m, pe, c, W), So(m);
    }
    function Wc(d, m, S, R, W) {
      if (typeof S == "function")
        if (Fl(S)) {
          Yu(d, m, S, R);
          return;
        } else {
          Hd(d, m, S, R);
          return;
        }
      if (typeof S == "string") {
        is(d, m, S, R);
        return;
      }
      switch (S) {
        case za:
        case Ur:
        case te:
        case Ee:
        case Kn: {
          Gr(d, m, R.children);
          return;
        }
        case wn: {
          zi(m, "SuspenseList"), Gr(d, m, R.children), So(m);
          return;
        }
        case Eu:
          throw new Error("ReactDOMServer does not yet support scope components.");
        case Ut: {
          Gu(d, m, R);
          return;
        }
      }
      if (typeof S == "object" && S !== null)
        switch (S.$$typeof) {
          case ht: {
            Gd(d, m, S, R, W);
            return;
          }
          case Jt: {
            Yd(d, m, S, R, W);
            return;
          }
          case he: {
            xa(d, m, S, R);
            return;
          }
          case Ze: {
            Hr(d, m, S, R);
            return;
          }
          case ma: {
            Ku(d, m, S, R);
            return;
          }
        }
      var Z = "";
      throw (S === void 0 || typeof S == "object" && S !== null && Object.keys(S).length === 0) && (Z += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (S == null ? S : typeof S) + "." + Z));
    }
    function Hc(d, m) {
      typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
      d[Symbol.toStringTag] === "Generator" && (zu || o("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), zu = !0), d.entries === m && (Zu || o("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Zu = !0);
    }
    function Gr(d, m, S) {
      try {
        return Bl(d, m, S);
      } catch (R) {
        throw typeof R == "object" && R !== null && typeof R.then == "function" || (os = os !== null ? os : Zs()), R;
      }
    }
    function Bl(d, m, S) {
      if (m.node = S, typeof S == "object" && S !== null) {
        switch (S.$$typeof) {
          case Jf: {
            var R = S, W = R.type, Z = R.props, _ = R.ref;
            Wc(d, m, W, Z, _);
            return;
          }
          case Pd:
            throw new Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");
          case ma: {
            var pe = S, c = pe._payload, h = pe._init, C;
            try {
              C = h(c);
            } catch (_e) {
              throw typeof _e == "object" && _e !== null && typeof _e.then == "function" && zi(m, "Lazy"), _e;
            }
            Gr(d, m, C);
            return;
          }
        }
        if (St(S)) {
          Xu(d, m, S);
          return;
        }
        var x = Ec(S);
        if (x) {
          Hc(S, x);
          var M = x.call(S);
          if (M) {
            var Y = M.next();
            if (!Y.done) {
              var J = [];
              do
                J.push(Y.value), Y = M.next();
              while (!Y.done);
              Xu(d, m, J);
              return;
            }
            return;
          }
        }
        var fe = Object.prototype.toString.call(S);
        throw new Error("Objects are not valid as a React child (found: " + (fe === "[object Object]" ? "object with keys {" + Object.keys(S).join(", ") + "}" : fe) + "). If you meant to render a collection of children, use an array instead.");
      }
      if (typeof S == "string") {
        var Pe = m.blockedSegment;
        Pe.lastPushedText = Di(m.blockedSegment.chunks, S, d.responseState, Pe.lastPushedText);
        return;
      }
      if (typeof S == "number") {
        var We = m.blockedSegment;
        We.lastPushedText = Di(m.blockedSegment.chunks, "" + S, d.responseState, We.lastPushedText);
        return;
      }
      typeof S == "function" && o("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function Xu(d, m, S) {
      for (var R = S.length, W = 0; W < R; W++) {
        var Z = m.treeContext;
        m.treeContext = Rc(Z, R, W);
        try {
          Vl(d, m, S[W]);
        } finally {
          m.treeContext = Z;
        }
      }
    }
    function Tr(d, m, S) {
      var R = m.blockedSegment, W = R.chunks.length, Z = Vc(
        d,
        W,
        null,
        R.formatContext,
        // Adopt the parent segment's leading text embed
        R.lastPushedText,
        // Assume we are text embedded at the trailing edge
        !0
      );
      R.children.push(Z), R.lastPushedText = !1;
      var _ = Dl(d, m.node, m.blockedBoundary, Z, m.abortSet, m.legacyContext, m.context, m.treeContext);
      m.componentStack !== null && (_.componentStack = m.componentStack.parent);
      var pe = _.ping;
      S.then(pe, pe);
    }
    function Vl(d, m, S) {
      var R = m.blockedSegment.formatContext, W = m.legacyContext, Z = m.context, _ = null;
      _ = m.componentStack;
      try {
        return Gr(d, m, S);
      } catch (pe) {
        if (Fu(), typeof pe == "object" && pe !== null && typeof pe.then == "function") {
          Tr(d, m, pe), m.blockedSegment.formatContext = R, m.legacyContext = W, m.context = Z, Sl(Z), m.componentStack = _;
          return;
        } else
          throw m.blockedSegment.formatContext = R, m.legacyContext = W, m.context = Z, Sl(Z), m.componentStack = _, pe;
      }
    }
    function Ki(d, m, S, R) {
      var W = wo(d, R);
      if (m === null ? Zi(d, R) : (m.pendingTasks--, m.forceClientRender || (m.forceClientRender = !0, m.errorDigest = W, jc(m, R), m.parentFlushed && d.clientRenderedBoundaries.push(m))), d.allPendingTasks--, d.allPendingTasks === 0) {
        var Z = d.onAllReady;
        Z();
      }
    }
    function ig(d) {
      var m = this, S = d.blockedBoundary, R = d.blockedSegment;
      R.status = Bc, Ju(m, S, R);
    }
    function Jo(d, m, S) {
      var R = d.blockedBoundary, W = d.blockedSegment;
      if (W.status = Bc, R === null)
        m.allPendingTasks--, m.status !== rs && (m.status = rs, m.destination !== null && j(m.destination));
      else {
        if (R.pendingTasks--, !R.forceClientRender) {
          R.forceClientRender = !0;
          var Z = S === void 0 ? new Error("The render was aborted by the server without a reason.") : S;
          R.errorDigest = m.onError(Z);
          {
            var _ = "The server did not finish this Suspense boundary: ";
            Z && typeof Z.message == "string" ? Z = _ + Z.message : Z = _ + String(Z);
            var pe = Ko;
            Ko = d;
            try {
              jc(R, Z);
            } finally {
              Ko = pe;
            }
          }
          R.parentFlushed && m.clientRenderedBoundaries.push(R);
        }
        if (R.fallbackAbortableTasks.forEach(function(h) {
          return Jo(h, m, S);
        }), R.fallbackAbortableTasks.clear(), m.allPendingTasks--, m.allPendingTasks === 0) {
          var c = m.onAllReady;
          c();
        }
      }
    }
    function jl(d, m) {
      if (m.chunks.length === 0 && m.children.length === 1 && m.children[0].boundary === null) {
        var S = m.children[0];
        S.id = m.id, S.parentFlushed = !0, S.status === Ao && jl(d, S);
      } else {
        var R = d.completedSegments;
        R.push(m);
      }
    }
    function Ju(d, m, S) {
      if (m === null) {
        if (S.parentFlushed) {
          if (d.completedRootSegment !== null)
            throw new Error("There can only be one root segment. This is a bug in React.");
          d.completedRootSegment = S;
        }
        if (d.pendingRootTasks--, d.pendingRootTasks === 0) {
          d.onShellError = pi;
          var R = d.onShellReady;
          R();
        }
      } else if (m.pendingTasks--, !m.forceClientRender) {
        if (m.pendingTasks === 0)
          S.parentFlushed && S.status === Ao && jl(m, S), m.parentFlushed && d.completedBoundaries.push(m), m.fallbackAbortableTasks.forEach(ig, d), m.fallbackAbortableTasks.clear();
        else if (S.parentFlushed && S.status === Ao) {
          jl(m, S);
          var W = m.completedSegments;
          W.length === 1 && m.parentFlushed && d.partialBoundaries.push(m);
        }
      }
      if (d.allPendingTasks--, d.allPendingTasks === 0) {
        var Z = d.onAllReady;
        Z();
      }
    }
    function Gc(d, m) {
      var S = m.blockedSegment;
      if (S.status === ju) {
        Sl(m.context);
        var R = null;
        R = Ko, Ko = m;
        try {
          Gr(d, m, m.node), Uo(S.chunks, d.responseState, S.lastPushedText, S.textEmbedded), m.abortSet.delete(m), S.status = Ao, Ju(d, m.blockedBoundary, S);
        } catch (Z) {
          if (Fu(), typeof Z == "object" && Z !== null && typeof Z.then == "function") {
            var W = m.ping;
            Z.then(W, W);
          } else
            m.abortSet.delete(m), S.status = ns, Ki(d, m.blockedBoundary, S, Z);
        } finally {
          Ko = R;
        }
      }
    }
    function Ul(d) {
      if (d.status !== rs) {
        var m = Ic(), S = Rl.current;
        Rl.current = mr;
        var R;
        R = Gs.getCurrentStack, Gs.getCurrentStack = Zs;
        var W = Pl;
        kl(d.responseState);
        try {
          var Z = d.pingedTasks, _;
          for (_ = 0; _ < Z.length; _++) {
            var pe = Z[_];
            Gc(d, pe);
          }
          Z.splice(0, _), d.destination !== null && sr(d, d.destination);
        } catch (c) {
          wo(d, c), Zi(d, c);
        } finally {
          kl(W), Rl.current = S, Gs.getCurrentStack = R, S === mr && Sl(m);
        }
      }
    }
    function Wl(d, m, S) {
      switch (S.parentFlushed = !0, S.status) {
        case ju: {
          var R = S.id = d.nextSegmentId++;
          return S.lastPushedText = !1, S.textEmbedded = !1, nr(m, d.responseState, R);
        }
        case Ao: {
          S.status = Ol;
          for (var W = !0, Z = S.chunks, _ = 0, pe = S.children, c = 0; c < pe.length; c++) {
            for (var h = pe[c]; _ < h.index; _++)
              A(m, Z[_]);
            W = Yc(d, m, h);
          }
          for (; _ < Z.length - 1; _++)
            A(m, Z[_]);
          return _ < Z.length && (W = w(m, Z[_])), W;
        }
        default:
          throw new Error("Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.");
      }
    }
    function Yc(d, m, S) {
      var R = S.boundary;
      if (R === null)
        return Wl(d, m, S);
      if (R.parentFlushed = !0, R.forceClientRender)
        return or(m, d.responseState, R.errorDigest, R.errorMessage, R.errorComponentStack), Wl(d, m, S), hl(m, d.responseState);
      if (R.pendingTasks > 0) {
        R.rootSegmentID = d.nextSegmentId++, R.completedSegments.length > 0 && d.partialBoundaries.push(R);
        var W = R.id = la(d.responseState);
        return Li(m, d.responseState, W), Wl(d, m, S), eo(m, d.responseState);
      } else {
        if (R.byteSize > d.progressiveChunkSize)
          return R.rootSegmentID = d.nextSegmentId++, d.completedBoundaries.push(R), Li(m, d.responseState, R.id), Wl(d, m, S), eo(m, d.responseState);
        Ho(m, d.responseState);
        var Z = R.completedSegments;
        if (Z.length !== 1)
          throw new Error("A previously unvisited boundary must have exactly one root segment. This is a bug in React.");
        var _ = Z[0];
        return Yc(d, m, _), sn(m, d.responseState);
      }
    }
    function Qu(d, m, S) {
      return yu(m, d.responseState, S.id, S.errorDigest, S.errorMessage, S.errorComponentStack);
    }
    function Js(d, m, S) {
      return pt(m, d.responseState, S.formatContext, S.id), Yc(d, m, S), on(m, S.formatContext);
    }
    function Hl(d, m, S) {
      for (var R = S.completedSegments, W = 0; W < R.length; W++) {
        var Z = R[W];
        zc(d, m, S, Z);
      }
      return R.length = 0, Os(m, d.responseState, S.id, S.rootSegmentID);
    }
    function zd(d, m, S) {
      for (var R = S.completedSegments, W = 0; W < R.length; W++) {
        var Z = R[W];
        if (!zc(d, m, S, Z))
          return W++, R.splice(0, W), !1;
      }
      return R.splice(0, W), !0;
    }
    function zc(d, m, S, R) {
      if (R.status === Ol)
        return !0;
      var W = R.id;
      if (W === -1) {
        var Z = R.id = S.rootSegmentID;
        if (Z === -1)
          throw new Error("A root segment ID must have been assigned by now. This is a bug in React.");
        return Js(d, m, R);
      } else
        return Js(d, m, R), zf(m, d.responseState, W);
    }
    function sr(d, m) {
      y();
      try {
        var S = d.completedRootSegment;
        S !== null && d.pendingRootTasks === 0 && (Yc(d, m, S), d.completedRootSegment = null, Mi(m, d.responseState));
        var R = d.clientRenderedBoundaries, W;
        for (W = 0; W < R.length; W++) {
          var Z = R[W];
          Qu(d, m, Z);
        }
        R.splice(0, W);
        var _ = d.completedBoundaries;
        for (W = 0; W < _.length; W++) {
          var pe = _[W];
          Hl(d, m, pe);
        }
        _.splice(0, W), F(m), y(m);
        var c = d.partialBoundaries;
        for (W = 0; W < c.length; W++) {
          var h = c[W];
          if (!zd(d, m, h)) {
            d.destination = null, W++, c.splice(0, W);
            return;
          }
        }
        c.splice(0, W);
        var C = d.completedBoundaries;
        for (W = 0; W < C.length; W++) {
          var x = C[W];
          Hl(d, m, x);
        }
        C.splice(0, W);
      } finally {
        F(m), d.allPendingTasks === 0 && d.pingedTasks.length === 0 && d.clientRenderedBoundaries.length === 0 && d.completedBoundaries.length === 0 && (d.abortableTasks.size !== 0 && o("There was still abortable task at the root when we closed. This is a bug in React."), j(m));
      }
    }
    function hi(d) {
      l(function() {
        return Ul(d);
      });
    }
    function Zd(d, m) {
      if (d.status === Uu) {
        d.status = rs, z(m, d.fatalError);
        return;
      }
      if (d.status !== rs && d.destination === null) {
        d.destination = m;
        try {
          sr(d, m);
        } catch (S) {
          wo(d, S), Zi(d, S);
        }
      }
    }
    function Zc(d, m) {
      try {
        var S = d.abortableTasks;
        S.forEach(function(R) {
          return Jo(R, d, m);
        }), S.clear(), d.destination !== null && sr(d, d.destination);
      } catch (R) {
        wo(d, R), Zi(d, R);
      }
    }
    function Kc(d, m) {
      return new Promise(function(S, R) {
        var W, Z, _ = new Promise(function(M, Y) {
          Z = M, W = Y;
        });
        function pe() {
          var M = new ReadableStream(
            {
              type: "bytes",
              pull: function(Y) {
                Zd(h, Y);
              },
              cancel: function(Y) {
                Zc(h);
              }
            },
            // $FlowFixMe size() methods are not allowed on byte streams.
            {
              highWaterMark: 0
            }
          );
          M.allReady = _, S(M);
        }
        function c(M) {
          _.catch(function() {
          }), R(M);
        }
        var h = rg(d, go(m ? m.identifierPrefix : void 0, m ? m.nonce : void 0, m ? m.bootstrapScriptContent : void 0, m ? m.bootstrapScripts : void 0, m ? m.bootstrapModules : void 0), jo(m ? m.namespaceURI : void 0), m ? m.progressiveChunkSize : void 0, m ? m.onError : void 0, Z, pe, c, W);
        if (m && m.signal) {
          var C = m.signal, x = function() {
            Zc(h, C.reason), C.removeEventListener("abort", x);
          };
          C.addEventListener("abort", x);
        }
        hi(h);
      });
    }
    Dp.renderToReadableStream = Kc, Dp.version = n;
  }()), Dp;
}
var Cd, ib;
process.env.NODE_ENV === "production" ? (Cd = o7(), ib = i7()) : (Cd = a7(), ib = s7());
Cd.version;
var l7 = Cd.renderToString;
Cd.renderToStaticMarkup;
Cd.renderToNodeStream;
Cd.renderToStaticNodeStream;
ib.renderToReadableStream;
var ab = { exports: {} }, Fp = { exports: {} }, fn = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var uA;
function c7() {
  if (uA)
    return fn;
  uA = 1;
  var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, y = e ? Symbol.for("react.forward_ref") : 60112, A = e ? Symbol.for("react.suspense") : 60113, w = e ? Symbol.for("react.suspense_list") : 60120, F = e ? Symbol.for("react.memo") : 60115, j = e ? Symbol.for("react.lazy") : 60116, N = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, z = e ? Symbol.for("react.scope") : 60119;
  function q(ee) {
    if (typeof ee == "object" && ee !== null) {
      var Fe = ee.$$typeof;
      switch (Fe) {
        case n:
          switch (ee = ee.type, ee) {
            case f:
            case p:
            case r:
            case a:
            case o:
            case A:
              return ee;
            default:
              switch (ee = ee && ee.$$typeof, ee) {
                case u:
                case y:
                case j:
                case F:
                case l:
                  return ee;
                default:
                  return Fe;
              }
          }
        case t:
          return Fe;
      }
    }
  }
  function Ce(ee) {
    return q(ee) === p;
  }
  return fn.AsyncMode = f, fn.ConcurrentMode = p, fn.ContextConsumer = u, fn.ContextProvider = l, fn.Element = n, fn.ForwardRef = y, fn.Fragment = r, fn.Lazy = j, fn.Memo = F, fn.Portal = t, fn.Profiler = a, fn.StrictMode = o, fn.Suspense = A, fn.isAsyncMode = function(ee) {
    return Ce(ee) || q(ee) === f;
  }, fn.isConcurrentMode = Ce, fn.isContextConsumer = function(ee) {
    return q(ee) === u;
  }, fn.isContextProvider = function(ee) {
    return q(ee) === l;
  }, fn.isElement = function(ee) {
    return typeof ee == "object" && ee !== null && ee.$$typeof === n;
  }, fn.isForwardRef = function(ee) {
    return q(ee) === y;
  }, fn.isFragment = function(ee) {
    return q(ee) === r;
  }, fn.isLazy = function(ee) {
    return q(ee) === j;
  }, fn.isMemo = function(ee) {
    return q(ee) === F;
  }, fn.isPortal = function(ee) {
    return q(ee) === t;
  }, fn.isProfiler = function(ee) {
    return q(ee) === a;
  }, fn.isStrictMode = function(ee) {
    return q(ee) === o;
  }, fn.isSuspense = function(ee) {
    return q(ee) === A;
  }, fn.isValidElementType = function(ee) {
    return typeof ee == "string" || typeof ee == "function" || ee === r || ee === p || ee === a || ee === o || ee === A || ee === w || typeof ee == "object" && ee !== null && (ee.$$typeof === j || ee.$$typeof === F || ee.$$typeof === l || ee.$$typeof === u || ee.$$typeof === y || ee.$$typeof === D || ee.$$typeof === k || ee.$$typeof === z || ee.$$typeof === N);
  }, fn.typeOf = q, fn;
}
var gn = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dA;
function u7() {
  return dA || (dA = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, y = e ? Symbol.for("react.forward_ref") : 60112, A = e ? Symbol.for("react.suspense") : 60113, w = e ? Symbol.for("react.suspense_list") : 60120, F = e ? Symbol.for("react.memo") : 60115, j = e ? Symbol.for("react.lazy") : 60116, N = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, z = e ? Symbol.for("react.scope") : 60119;
    function q(Be) {
      return typeof Be == "string" || typeof Be == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Be === r || Be === p || Be === a || Be === o || Be === A || Be === w || typeof Be == "object" && Be !== null && (Be.$$typeof === j || Be.$$typeof === F || Be.$$typeof === l || Be.$$typeof === u || Be.$$typeof === y || Be.$$typeof === D || Be.$$typeof === k || Be.$$typeof === z || Be.$$typeof === N);
    }
    function Ce(Be) {
      if (typeof Be == "object" && Be !== null) {
        var Wt = Be.$$typeof;
        switch (Wt) {
          case n:
            var Ht = Be.type;
            switch (Ht) {
              case f:
              case p:
              case r:
              case a:
              case o:
              case A:
                return Ht;
              default:
                var Fn = Ht && Ht.$$typeof;
                switch (Fn) {
                  case u:
                  case y:
                  case j:
                  case F:
                  case l:
                    return Fn;
                  default:
                    return Wt;
                }
            }
          case t:
            return Wt;
        }
      }
    }
    var ee = f, Fe = p, Oe = u, He = l, Re = n, Se = y, we = r, ae = j, ge = F, Ie = t, Ye = a, Ke = o, ze = A, ue = !1;
    function de(Be) {
      return ue || (ue = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Q(Be) || Ce(Be) === f;
    }
    function Q(Be) {
      return Ce(Be) === p;
    }
    function me(Be) {
      return Ce(Be) === u;
    }
    function Le(Be) {
      return Ce(Be) === l;
    }
    function Je(Be) {
      return typeof Be == "object" && Be !== null && Be.$$typeof === n;
    }
    function Xe(Be) {
      return Ce(Be) === y;
    }
    function je(Be) {
      return Ce(Be) === r;
    }
    function Ue(Be) {
      return Ce(Be) === j;
    }
    function it(Be) {
      return Ce(Be) === F;
    }
    function ct(Be) {
      return Ce(Be) === t;
    }
    function lt(Be) {
      return Ce(Be) === a;
    }
    function dt(Be) {
      return Ce(Be) === o;
    }
    function Mt(Be) {
      return Ce(Be) === A;
    }
    gn.AsyncMode = ee, gn.ConcurrentMode = Fe, gn.ContextConsumer = Oe, gn.ContextProvider = He, gn.Element = Re, gn.ForwardRef = Se, gn.Fragment = we, gn.Lazy = ae, gn.Memo = ge, gn.Portal = Ie, gn.Profiler = Ye, gn.StrictMode = Ke, gn.Suspense = ze, gn.isAsyncMode = de, gn.isConcurrentMode = Q, gn.isContextConsumer = me, gn.isContextProvider = Le, gn.isElement = Je, gn.isForwardRef = Xe, gn.isFragment = je, gn.isLazy = Ue, gn.isMemo = it, gn.isPortal = ct, gn.isProfiler = lt, gn.isStrictMode = dt, gn.isSuspense = Mt, gn.isValidElementType = q, gn.typeOf = Ce;
  }()), gn;
}
var fA;
function ZT() {
  return fA || (fA = 1, process.env.NODE_ENV === "production" ? Fp.exports = c7() : Fp.exports = u7()), Fp.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Av, gA;
function d7() {
  if (gA)
    return Av;
  gA = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var l = {}, u = 0; u < 10; u++)
        l["_" + String.fromCharCode(u)] = u;
      var f = Object.getOwnPropertyNames(l).map(function(y) {
        return l[y];
      });
      if (f.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(y) {
        p[y] = y;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Av = o() ? Object.assign : function(a, l) {
    for (var u, f = r(a), p, y = 1; y < arguments.length; y++) {
      u = Object(arguments[y]);
      for (var A in u)
        n.call(u, A) && (f[A] = u[A]);
      if (e) {
        p = e(u);
        for (var w = 0; w < p.length; w++)
          t.call(u, p[w]) && (f[p[w]] = u[p[w]]);
      }
    }
    return f;
  }, Av;
}
var Sv, pA;
function Ny() {
  if (pA)
    return Sv;
  pA = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Sv = e, Sv;
}
var wv, hA;
function KT() {
  return hA || (hA = 1, wv = Function.call.bind(Object.prototype.hasOwnProperty)), wv;
}
var Iv, mA;
function f7() {
  if (mA)
    return Iv;
  mA = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var n = Ny(), t = {}, r = KT();
    e = function(a) {
      var l = "Warning: " + a;
      typeof console < "u" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function o(a, l, u, f, p) {
    if (process.env.NODE_ENV !== "production") {
      for (var y in a)
        if (r(a, y)) {
          var A;
          try {
            if (typeof a[y] != "function") {
              var w = Error(
                (f || "React class") + ": " + u + " type `" + y + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[y] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw w.name = "Invariant Violation", w;
            }
            A = a[y](l, y, f, u, null, n);
          } catch (j) {
            A = j;
          }
          if (A && !(A instanceof Error) && e(
            (f || "React class") + ": type specification of " + u + " `" + y + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof A + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), A instanceof Error && !(A.message in t)) {
            t[A.message] = !0;
            var F = p ? p() : "";
            e(
              "Failed " + u + " type: " + A.message + (F ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, Iv = o, Iv;
}
var xv, vA;
function g7() {
  if (vA)
    return xv;
  vA = 1;
  var e = ZT(), n = d7(), t = Ny(), r = KT(), o = f7(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(u) {
    var f = "Warning: " + u;
    typeof console < "u" && console.error(f);
    try {
      throw new Error(f);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return xv = function(u, f) {
    var p = typeof Symbol == "function" && Symbol.iterator, y = "@@iterator";
    function A(Q) {
      var me = Q && (p && Q[p] || Q[y]);
      if (typeof me == "function")
        return me;
    }
    var w = "<<anonymous>>", F = {
      array: k("array"),
      bigint: k("bigint"),
      bool: k("boolean"),
      func: k("function"),
      number: k("number"),
      object: k("object"),
      string: k("string"),
      symbol: k("symbol"),
      any: z(),
      arrayOf: q,
      element: Ce(),
      elementType: ee(),
      instanceOf: Fe,
      node: Se(),
      objectOf: He,
      oneOf: Oe,
      oneOfType: Re,
      shape: ae,
      exact: ge
    };
    function j(Q, me) {
      return Q === me ? Q !== 0 || 1 / Q === 1 / me : Q !== Q && me !== me;
    }
    function N(Q, me) {
      this.message = Q, this.data = me && typeof me == "object" ? me : {}, this.stack = "";
    }
    N.prototype = Error.prototype;
    function D(Q) {
      if (process.env.NODE_ENV !== "production")
        var me = {}, Le = 0;
      function Je(je, Ue, it, ct, lt, dt, Mt) {
        if (ct = ct || w, dt = dt || it, Mt !== t) {
          if (f) {
            var Be = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Be.name = "Invariant Violation", Be;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Wt = ct + ":" + it;
            !me[Wt] && // Avoid spamming the console because they are often not actionable except for lib authors
            Le < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + dt + "` prop on `" + ct + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), me[Wt] = !0, Le++);
          }
        }
        return Ue[it] == null ? je ? Ue[it] === null ? new N("The " + lt + " `" + dt + "` is marked as required " + ("in `" + ct + "`, but its value is `null`.")) : new N("The " + lt + " `" + dt + "` is marked as required in " + ("`" + ct + "`, but its value is `undefined`.")) : null : Q(Ue, it, ct, lt, dt);
      }
      var Xe = Je.bind(null, !1);
      return Xe.isRequired = Je.bind(null, !0), Xe;
    }
    function k(Q) {
      function me(Le, Je, Xe, je, Ue, it) {
        var ct = Le[Je], lt = Ke(ct);
        if (lt !== Q) {
          var dt = ze(ct);
          return new N(
            "Invalid " + je + " `" + Ue + "` of type " + ("`" + dt + "` supplied to `" + Xe + "`, expected ") + ("`" + Q + "`."),
            { expectedType: Q }
          );
        }
        return null;
      }
      return D(me);
    }
    function z() {
      return D(l);
    }
    function q(Q) {
      function me(Le, Je, Xe, je, Ue) {
        if (typeof Q != "function")
          return new N("Property `" + Ue + "` of component `" + Xe + "` has invalid PropType notation inside arrayOf.");
        var it = Le[Je];
        if (!Array.isArray(it)) {
          var ct = Ke(it);
          return new N("Invalid " + je + " `" + Ue + "` of type " + ("`" + ct + "` supplied to `" + Xe + "`, expected an array."));
        }
        for (var lt = 0; lt < it.length; lt++) {
          var dt = Q(it, lt, Xe, je, Ue + "[" + lt + "]", t);
          if (dt instanceof Error)
            return dt;
        }
        return null;
      }
      return D(me);
    }
    function Ce() {
      function Q(me, Le, Je, Xe, je) {
        var Ue = me[Le];
        if (!u(Ue)) {
          var it = Ke(Ue);
          return new N("Invalid " + Xe + " `" + je + "` of type " + ("`" + it + "` supplied to `" + Je + "`, expected a single ReactElement."));
        }
        return null;
      }
      return D(Q);
    }
    function ee() {
      function Q(me, Le, Je, Xe, je) {
        var Ue = me[Le];
        if (!e.isValidElementType(Ue)) {
          var it = Ke(Ue);
          return new N("Invalid " + Xe + " `" + je + "` of type " + ("`" + it + "` supplied to `" + Je + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return D(Q);
    }
    function Fe(Q) {
      function me(Le, Je, Xe, je, Ue) {
        if (!(Le[Je] instanceof Q)) {
          var it = Q.name || w, ct = de(Le[Je]);
          return new N("Invalid " + je + " `" + Ue + "` of type " + ("`" + ct + "` supplied to `" + Xe + "`, expected ") + ("instance of `" + it + "`."));
        }
        return null;
      }
      return D(me);
    }
    function Oe(Q) {
      if (!Array.isArray(Q))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), l;
      function me(Le, Je, Xe, je, Ue) {
        for (var it = Le[Je], ct = 0; ct < Q.length; ct++)
          if (j(it, Q[ct]))
            return null;
        var lt = JSON.stringify(Q, function(Mt, Be) {
          var Wt = ze(Be);
          return Wt === "symbol" ? String(Be) : Be;
        });
        return new N("Invalid " + je + " `" + Ue + "` of value `" + String(it) + "` " + ("supplied to `" + Xe + "`, expected one of " + lt + "."));
      }
      return D(me);
    }
    function He(Q) {
      function me(Le, Je, Xe, je, Ue) {
        if (typeof Q != "function")
          return new N("Property `" + Ue + "` of component `" + Xe + "` has invalid PropType notation inside objectOf.");
        var it = Le[Je], ct = Ke(it);
        if (ct !== "object")
          return new N("Invalid " + je + " `" + Ue + "` of type " + ("`" + ct + "` supplied to `" + Xe + "`, expected an object."));
        for (var lt in it)
          if (r(it, lt)) {
            var dt = Q(it, lt, Xe, je, Ue + "." + lt, t);
            if (dt instanceof Error)
              return dt;
          }
        return null;
      }
      return D(me);
    }
    function Re(Q) {
      if (!Array.isArray(Q))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var me = 0; me < Q.length; me++) {
        var Le = Q[me];
        if (typeof Le != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ue(Le) + " at index " + me + "."
          ), l;
      }
      function Je(Xe, je, Ue, it, ct) {
        for (var lt = [], dt = 0; dt < Q.length; dt++) {
          var Mt = Q[dt], Be = Mt(Xe, je, Ue, it, ct, t);
          if (Be == null)
            return null;
          Be.data && r(Be.data, "expectedType") && lt.push(Be.data.expectedType);
        }
        var Wt = lt.length > 0 ? ", expected one of type [" + lt.join(", ") + "]" : "";
        return new N("Invalid " + it + " `" + ct + "` supplied to " + ("`" + Ue + "`" + Wt + "."));
      }
      return D(Je);
    }
    function Se() {
      function Q(me, Le, Je, Xe, je) {
        return Ie(me[Le]) ? null : new N("Invalid " + Xe + " `" + je + "` supplied to " + ("`" + Je + "`, expected a ReactNode."));
      }
      return D(Q);
    }
    function we(Q, me, Le, Je, Xe) {
      return new N(
        (Q || "React class") + ": " + me + " type `" + Le + "." + Je + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Xe + "`."
      );
    }
    function ae(Q) {
      function me(Le, Je, Xe, je, Ue) {
        var it = Le[Je], ct = Ke(it);
        if (ct !== "object")
          return new N("Invalid " + je + " `" + Ue + "` of type `" + ct + "` " + ("supplied to `" + Xe + "`, expected `object`."));
        for (var lt in Q) {
          var dt = Q[lt];
          if (typeof dt != "function")
            return we(Xe, je, Ue, lt, ze(dt));
          var Mt = dt(it, lt, Xe, je, Ue + "." + lt, t);
          if (Mt)
            return Mt;
        }
        return null;
      }
      return D(me);
    }
    function ge(Q) {
      function me(Le, Je, Xe, je, Ue) {
        var it = Le[Je], ct = Ke(it);
        if (ct !== "object")
          return new N("Invalid " + je + " `" + Ue + "` of type `" + ct + "` " + ("supplied to `" + Xe + "`, expected `object`."));
        var lt = n({}, Le[Je], Q);
        for (var dt in lt) {
          var Mt = Q[dt];
          if (r(Q, dt) && typeof Mt != "function")
            return we(Xe, je, Ue, dt, ze(Mt));
          if (!Mt)
            return new N(
              "Invalid " + je + " `" + Ue + "` key `" + dt + "` supplied to `" + Xe + "`.\nBad object: " + JSON.stringify(Le[Je], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(Q), null, "  ")
            );
          var Be = Mt(it, dt, Xe, je, Ue + "." + dt, t);
          if (Be)
            return Be;
        }
        return null;
      }
      return D(me);
    }
    function Ie(Q) {
      switch (typeof Q) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !Q;
        case "object":
          if (Array.isArray(Q))
            return Q.every(Ie);
          if (Q === null || u(Q))
            return !0;
          var me = A(Q);
          if (me) {
            var Le = me.call(Q), Je;
            if (me !== Q.entries) {
              for (; !(Je = Le.next()).done; )
                if (!Ie(Je.value))
                  return !1;
            } else
              for (; !(Je = Le.next()).done; ) {
                var Xe = Je.value;
                if (Xe && !Ie(Xe[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Ye(Q, me) {
      return Q === "symbol" ? !0 : me ? me["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && me instanceof Symbol : !1;
    }
    function Ke(Q) {
      var me = typeof Q;
      return Array.isArray(Q) ? "array" : Q instanceof RegExp ? "object" : Ye(me, Q) ? "symbol" : me;
    }
    function ze(Q) {
      if (typeof Q > "u" || Q === null)
        return "" + Q;
      var me = Ke(Q);
      if (me === "object") {
        if (Q instanceof Date)
          return "date";
        if (Q instanceof RegExp)
          return "regexp";
      }
      return me;
    }
    function ue(Q) {
      var me = ze(Q);
      switch (me) {
        case "array":
        case "object":
          return "an " + me;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + me;
        default:
          return me;
      }
    }
    function de(Q) {
      return !Q.constructor || !Q.constructor.name ? w : Q.constructor.name;
    }
    return F.checkPropTypes = o, F.resetWarningCache = o.resetWarningCache, F.PropTypes = F, F;
  }, xv;
}
var Tv, bA;
function p7() {
  if (bA)
    return Tv;
  bA = 1;
  var e = Ny();
  function n() {
  }
  function t() {
  }
  return t.resetWarningCache = n, Tv = function() {
    function r(l, u, f, p, y, A) {
      if (A !== e) {
        var w = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw w.name = "Invariant Violation", w;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: t,
      resetWarningCache: n
    };
    return a.PropTypes = a, a;
  }, Tv;
}
if (process.env.NODE_ENV !== "production") {
  var h7 = ZT(), m7 = !0;
  ab.exports = g7()(h7.isElement, m7);
} else
  ab.exports = p7()();
var v7 = ab.exports;
const ds = /* @__PURE__ */ DA(v7);
var b7 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function XT(e, n) {
  return e(n = { exports: {} }, n.exports), n.exports;
}
var y7 = XT(function(e) {
  (function(n) {
    var t = function(D, k, z) {
      if (!f(k) || y(k) || A(k) || w(k) || u(k))
        return k;
      var q, Ce = 0, ee = 0;
      if (p(k))
        for (q = [], ee = k.length; Ce < ee; Ce++)
          q.push(t(D, k[Ce], z));
      else
        for (var Fe in q = {}, k)
          Object.prototype.hasOwnProperty.call(k, Fe) && (q[D(Fe, z)] = t(D, k[Fe], z));
      return q;
    }, r = function(D) {
      return F(D) ? D : (D = D.replace(/[\-_\s]+(.)?/g, function(k, z) {
        return z ? z.toUpperCase() : "";
      })).substr(0, 1).toLowerCase() + D.substr(1);
    }, o = function(D) {
      var k = r(D);
      return k.substr(0, 1).toUpperCase() + k.substr(1);
    }, a = function(D, k) {
      return function(z, q) {
        var Ce = (q = q || {}).separator || "_", ee = q.split || /(?=[A-Z])/;
        return z.split(ee).join(Ce);
      }(D, k).toLowerCase();
    }, l = Object.prototype.toString, u = function(D) {
      return typeof D == "function";
    }, f = function(D) {
      return D === Object(D);
    }, p = function(D) {
      return l.call(D) == "[object Array]";
    }, y = function(D) {
      return l.call(D) == "[object Date]";
    }, A = function(D) {
      return l.call(D) == "[object RegExp]";
    }, w = function(D) {
      return l.call(D) == "[object Boolean]";
    }, F = function(D) {
      return (D -= 0) == D;
    }, j = function(D, k) {
      var z = k && "process" in k ? k.process : k;
      return typeof z != "function" ? D : function(q, Ce) {
        return z(q, D, Ce);
      };
    }, N = { camelize: r, decamelize: a, pascalize: o, depascalize: a, camelizeKeys: function(D, k) {
      return t(j(r, k), D);
    }, decamelizeKeys: function(D, k) {
      return t(j(a, k), D, k);
    }, pascalizeKeys: function(D, k) {
      return t(j(o, k), D);
    }, depascalizeKeys: function() {
      return this.decamelizeKeys.apply(this, arguments);
    } };
    e.exports ? e.exports = N : n.humps = N;
  })(b7);
}).decamelize, C7 = function(e) {
  if (Array.isArray(e))
    return e;
}, E7 = function(e, n) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) {
    var t = [], r = !0, o = !1, a = void 0;
    try {
      for (var l, u = e[Symbol.iterator](); !(r = (l = u.next()).done) && (t.push(l.value), !n || t.length !== n); r = !0)
        ;
    } catch (f) {
      o = !0, a = f;
    } finally {
      try {
        r || u.return == null || u.return();
      } finally {
        if (o)
          throw a;
      }
    }
    return t;
  }
}, yA = function(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}, A7 = function(e, n) {
  if (e) {
    if (typeof e == "string")
      return yA(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    return t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set" ? Array.from(e) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? yA(e, n) : void 0;
  }
}, S7 = function() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}, w7 = function(e, n) {
  return C7(e) || E7(e, n) || A7(e, n) || S7();
}, JT = XT(function(e) {
  function n() {
    return e.exports = n = Object.assign || function(t) {
      for (var r = 1; r < arguments.length; r++) {
        var o = arguments[r];
        for (var a in o)
          Object.prototype.hasOwnProperty.call(o, a) && (t[a] = o[a]);
      }
      return t;
    }, n.apply(this, arguments);
  }
  e.exports = n;
}), I7 = function(e, n) {
  if (e == null)
    return {};
  var t, r, o = {}, a = Object.keys(e);
  for (r = 0; r < a.length; r++)
    t = a[r], n.indexOf(t) >= 0 || (o[t] = e[t]);
  return o;
}, QT = function(e, n) {
  if (e == null)
    return {};
  var t, r, o = I7(e, n);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      t = a[r], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}, x7 = cb(null);
function sb(e) {
  var n = e.children, t = QT(e, ["children"]);
  return typeof n != "string" && (n = l7(n)), $o.createElement("template", JT({}, t, { dangerouslySetInnerHTML: { __html: n } }));
}
function lb(e) {
  var n = e.root, t = e.children;
  return OA(t, n);
}
function T7(e) {
  var n = oe(function(t, r) {
    var o, a, l = t.mode, u = t.delegatesFocus, f = t.styleSheets, p = t.ssr, y = t.children, A = QT(t, ["mode", "delegatesFocus", "styleSheets", "ssr", "children"]), w = (a = Fa((o = r) && o.current), ra(function() {
      o && (o.current = a.current);
    }, [o]), a), F = du(null), j = w7(F, 2), N = j[0], D = j[1], k = "node_".concat(l).concat(u);
    return kA(function() {
      if (w.current)
        try {
          if (typeof r == "function" && r(w.current), p) {
            var z = w.current.shadowRoot;
            return void D(z);
          }
          var q = w.current.attachShadow({ mode: l, delegatesFocus: u });
          f.length > 0 && (q.adoptedStyleSheets = f), D(q);
        } catch (Ce) {
          (function(ee) {
            var Fe = ee.error, Oe = ee.styleSheets, He = ee.root;
            switch (Fe.name) {
              case "NotSupportedError":
                Oe.length > 0 && (He.adoptedStyleSheets = Oe);
                break;
              default:
                throw Fe;
            }
          })({ error: Ce, styleSheets: f, root: N });
        }
    }, [r, w, f]), $o.createElement($o.Fragment, null, $o.createElement(e.tag, JT({ key: k, ref: w }, A), (N || p) && $o.createElement(x7.Provider, { value: N }, p ? $o.createElement(sb, { shadowroot: l, shadowrootmode: l }, e.render({ root: N, ssr: p, children: y })) : $o.createElement(lb, { root: N }, e.render({ root: N, ssr: p, children: y })))));
  });
  return n.propTypes = { mode: ds.oneOf(["open", "closed"]), delegatesFocus: ds.bool, styleSheets: ds.arrayOf(ds.instanceOf(globalThis.CSSStyleSheet)), ssr: ds.bool, children: ds.node }, n.defaultProps = { mode: "open", delegatesFocus: !1, styleSheets: [], ssr: !1, children: null }, n;
}
sb.propTypes = { children: ds.oneOfType([ds.string, ds.node]) }, sb.defaultProps = { children: "" }, lb.propTypes = { root: ds.object.isRequired, children: ds.node }, lb.defaultProps = { children: null };
var Pv = /* @__PURE__ */ new Map();
function P7() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "core", t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(r) {
    return r.children;
  };
  return new Proxy(e, { get: function(r, o) {
    var a = y7(o, { separator: "-" }), l = "".concat(n, "-").concat(a);
    return Pv.has(l) || Pv.set(l, T7({ tag: a, render: t })), Pv.get(l);
  } });
}
var k7 = P7();
const R7 = Ro({
  className: "toast",
  slots: uw.keys(),
  base: {
    root: {
      background: "white",
      borderRadius: "100",
      boxShadow: "md",
      borderWidth: "1px",
      borderColor: "border.light",
      minWidth: "xs",
      maxWidth: "md",
      p: "300",
      position: "relative",
      fontFamily: "body",
      scale: "var(--scale)",
      translate: "var(--x) var(--y) 0",
      willChange: "translate, opacity, scale",
      zIndex: "var(--z-index)",
      transitionDuration: "slow",
      transitionProperty: "translate, scale, opacity, height",
      transitionTimingFunction: "default",
      _hover: {
        '& [data-part="close-trigger"]': {
          opacity: 1
        }
      }
    },
    title: {
      color: "text.dark",
      fontWeight: "semiBold",
      fontSize: "xs",
      lineHeight: "xs",
      lineClamp: 1
    },
    description: {
      color: "text.mid",
      fontSize: "xs",
      lineHeight: "xs",
      lineClamp: 2
    },
    closeTrigger: {
      transition: "opacity 100ms ease-out",
      opacity: 0,
      position: "absolute",
      color: "icon.light",
      top: "100",
      right: "100",
      cursor: "pointer"
    }
  }
}), { withProvider: O7, withContext: My } = vs(R7), D7 = O7(vT, "root"), F7 = My(hT, "closeTrigger"), N7 = My(mT, "description"), M7 = My(bT, "title"), L7 = ({ title: e, description: n }) => /* @__PURE__ */ I.jsxs(D7, { children: [
  /* @__PURE__ */ I.jsx(Si, { gap: "400", justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ I.jsxs(Si, { flexDir: "column", gap: "50", children: [
    /* @__PURE__ */ I.jsx(M7, { children: e }),
    /* @__PURE__ */ I.jsx(N7, { children: n })
  ] }) }),
  /* @__PURE__ */ I.jsx(F7, { children: /* @__PURE__ */ I.jsx(fr, { Element: Fy, size: "sm" }) })
] }), B7 = dW({
  placement: "top-end",
  duration: 6e3,
  removeDelay: 200,
  overlap: !0,
  gap: 16
}), V7 = () => /* @__PURE__ */ I.jsx(yT, { toaster: B7, children: (e) => {
  var n, t;
  return /* @__PURE__ */ I.jsx(
    L7,
    {
      description: (n = e.description) == null ? void 0 : n.toString(),
      title: (t = e.title) == null ? void 0 : t.toString()
    },
    e.id
  );
} }), qY = ({
  styles: e = [],
  children: n,
  portal: t,
  idSuffix: r = "",
  useShadowDOM: o
}) => {
  ra(() => {
    [n7, r7].forEach((p) => {
      const y = document.createElement("style");
      y.textContent = p, document.head.appendChild(y);
    });
  }, []), ra(() => {
    if (!o && e.length > 0) {
      const p = document.createDocumentFragment();
      return e.forEach((y, A) => {
        const w = document.createElement("style");
        w.textContent = y, w.dataset.dynamicStyle = `style-${A}`, p.appendChild(w);
      }), document.head.appendChild(p), () => {
        Array.from(
          document.head.querySelectorAll("style[data-dynamic-style]")
        ).forEach((y) => {
          document.head.removeChild(y);
        });
      };
    }
  }, [e, o]);
  const a = () => {
    const p = document.getElementById(
      "trekker-environment-root" + r
    );
    return o && p ? p.shadowRoot : document;
  }, l = o ? k7.section : "div", u = t ? Lx : "div", f = o ? { all: "initial" } : {};
  return /* @__PURE__ */ I.jsx(u, { children: /* @__PURE__ */ I.jsxs(
    l,
    {
      style: f,
      id: "trekker-environment-root" + r,
      children: [
        o && e.map((p, y) => /* @__PURE__ */ I.jsx("style", { type: "text/css", children: p }, y)),
        /* @__PURE__ */ I.jsxs(mW, { value: a, children: [
          /* @__PURE__ */ I.jsx(V7, {}),
          /* @__PURE__ */ I.jsx("div", { id: "trekker-style-root", children: n })
        ] })
      ]
    }
  ) });
}, CA = Ro({
  className: "switchRecipe",
  slots: cw.keys(),
  base: {
    root: {
      alignItems: "center",
      display: "flex",
      position: "relative",
      gap: 200,
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
      }
    },
    control: {
      width: "44px",
      height: "24px",
      p: "2px",
      m: "50",
      alignItems: "center",
      alignSelf: "start",
      background: "bg.lighter",
      borderRadius: "full",
      cursor: "pointer",
      display: "inline-flex",
      flexShrink: "0",
      transitionDuration: "normal",
      transitionProperty: "background",
      transitionTimingFunction: "default",
      _checked: {
        background: "bg.darkest"
      },
      _disabled: {
        cursor: "not-allowed"
      }
    },
    thumb: {
      width: "20px",
      height: "20px",
      background: "white",
      borderRadius: "full",
      transitionDuration: "normal",
      transitionProperty: "transform, background",
      transitionTimingFunction: "default",
      _checked: {
        transform: "translateX(100%)",
        background: { base: "white" }
      }
    }
  }
}), j7 = oe(
  (e, n) => {
    const [t, r] = CA.splitVariantProps(e), [o, a] = zh(r), { label: l, hint: u, className: f, ...p } = a, y = CA(t);
    return /* @__PURE__ */ I.jsxs(
      gT,
      {
        ref: n,
        className: sc(y.root, ni(o), f),
        ...p,
        children: [
          /* @__PURE__ */ I.jsx(dT, { className: y.control, children: /* @__PURE__ */ I.jsx(pT, { className: y.thumb }) }),
          l && /* @__PURE__ */ I.jsxs(Si, { direction: "column", gap: 50, children: [
            /* @__PURE__ */ I.jsx(Xr, { visual: "bodyMedium", children: l }),
            u && /* @__PURE__ */ I.jsx(Xr, { color: "text.light", children: u })
          ] }),
          /* @__PURE__ */ I.jsx(fT, {})
        ]
      }
    );
  }
);
j7.displayName = "Switch";
const U7 = Ro({
  className: "table",
  slots: ["root", "body", "cell", "footer", "head", "header", "row", "caption"],
  base: {
    root: {
      fontFamily: "body",
      fontSize: "md",
      lineHeight: "sm",
      color: "text.dark",
      bg: "transparent",
      width: "full"
    },
    body: {},
    caption: {
      textAlign: "left",
      py: 150,
      borderBottomWidth: "1px",
      borderColor: "border.mid",
      fontSize: "2xs",
      lineHeight: "2xs",
      fontWeight: "bold",
      letterSpacing: "wider",
      textTransform: "uppercase",
      color: "text.mid"
    },
    cell: {
      fontWeight: "medium",
      textAlign: "right",
      py: 150
    },
    footer: {
      fontWeight: "medium",
      borderTopWidth: "1px",
      "& tr:last-child": {
        borderBottomWidth: "0"
      }
    },
    header: {
      fontWeight: "normal",
      textAlign: "left",
      py: 150
    },
    row: {
      borderBottomWidth: "1px",
      borderColor: "border.light"
    }
  }
}), { withProvider: W7, withContext: Id } = vs(U7), H7 = W7(
  ve.table,
  "root"
), G7 = Id(ve.tbody, "body"), Y7 = Id(ve.caption, "caption"), z7 = Id(ve.td, "cell"), Z7 = Id(ve.thead, "head"), K7 = Id(ve.th, "header"), X7 = Id(ve.tr, "row"), J7 = Id(ve.tfoot, "footer"), _Y = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Body: G7,
  Caption: Y7,
  Cell: z7,
  Footer: J7,
  Head: Z7,
  Header: K7,
  Root: H7,
  Row: X7
}, Symbol.toStringTag, { value: "Module" })), kv = 300, $Y = ({
  open: e,
  children: n,
  shadowRootIdSuffix: t = "",
  ...r
}) => {
  const [o, a] = du(0), l = Fa(null);
  return ra(() => {
    var w;
    const u = (w = document.querySelector(
      "#trekker-environment-root" + t
    )) == null ? void 0 : w.shadowRoot, f = document.querySelector("#trekker-scroll-container"), y = (u == null ? void 0 : u.querySelector(
      "#trekker-scroll-container"
    )) ?? f, A = ni({
      overflow: "hidden!",
      position: "relative"
    }).split(" ");
    y && (l.current && (y.classList.add(...A), y.appendChild(l.current)), y.scrollTop > 0 && o !== y.scrollTop && a(y.scrollTop), e && y.setAttribute("data-modal-overlay-open", "true"), e || (y == null || y.classList.remove(ni({ overflow: "hidden!" })), y.removeAttribute("data-modal-overlay-open"), setTimeout(() => {
      var F;
      y == null || y.classList.remove(ni({ position: "relative" })), (F = l.current) == null || F.classList.add(kT());
    }, kv - 1)));
  }, [l, e, o]), /* @__PURE__ */ I.jsx(
    ll,
    {
      ref: l,
      h: "full",
      w: "full",
      position: "absolute",
      zIndex: "toast",
      style: { top: `${o}px` },
      overflowY: "auto",
      animation: e ? `rightToOrigin ${kv}ms ease-in-out` : `originToRight ${kv}ms ease-in-out`,
      ...r,
      children: n
    }
  );
}, e8 = () => {
  var l;
  const [e, n] = du(!1), t = (l = document.querySelector(
    "#trekker-environment-root"
  )) == null ? void 0 : l.shadowRoot, r = document.querySelector("#trekker-scroll-container"), a = (t == null ? void 0 : t.querySelector(
    "#trekker-scroll-container"
  )) ?? r;
  return ra(() => {
    if (!a)
      return;
    const u = new MutationObserver((f) => {
      f.forEach((p) => {
        if (p.type === "attributes" && p.attributeName === "data-modal-overlay-open") {
          const y = a.hasAttribute(
            "data-modal-overlay-open"
          );
          n(y);
        }
      });
    });
    return u.observe(a, {
      attributes: !0
    }), n(a.hasAttribute("data-modal-overlay-open")), () => {
      u.disconnect();
    };
  }, [a]), e;
}, Q7 = Ii({
  base: {
    appearance: "none",
    background: "none",
    borderColor: "border.light",
    borderRadius: 100,
    borderWidth: "1px",
    color: "text.dark",
    fontFamily: "body",
    fontSize: "md",
    lineHeight: "xs",
    outline: 0,
    position: "relative",
    transitionDuration: "normal",
    transitionProperty: "border-color outline",
    transitionTimingFunction: "default",
    width: "full",
    px: 150,
    py: 100,
    _disabled: {
      _placeholder: {
        color: "text.disabled"
      },
      borderColor: "border.disabled",
      color: "text.disabled",
      cursor: "not-allowed"
    },
    _focus: {
      borderColor: "border.dark",
      outline: "1px solid token(colors.border.dark)"
    },
    _hover: {
      _enabled: {
        borderColor: "border.mid",
        outline: "1px solid token(colors.border.mid)"
      },
      _focus: {
        borderColor: "border.dark",
        outline: "1px solid token(colors.border.dark)"
      }
    },
    _invalid: {
      color: "text.error.dark",
      borderColor: "border.error",
      outline: "1px solid token(colors.border.error)"
    }
  }
}), q7 = It(ve.textarea, Q7), t8 = oe(
  ({ label: e, hint: n, resize: t = "none", rows: r = 10, ...o }, a) => /* @__PURE__ */ I.jsxs(
    Xr,
    {
      as: "label",
      visual: "smallMedium",
      color: "text.mid",
      w: "full",
      display: "block",
      children: [
        e,
        /* @__PURE__ */ I.jsx(
          q7,
          {
            ...o,
            rows: r,
            resize: t,
            my: 50,
            className: "peer",
            ref: a
          }
        ),
        n && /* @__PURE__ */ I.jsx(
          Xr,
          {
            as: "span",
            _peerInvalid: { color: "text.error.dark" },
            color: "text.light",
            visual: "smallMedium",
            children: n
          }
        )
      ]
    }
  )
), _7 = Ro({
  className: "select",
  slots: lw.keys(),
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "75",
      width: "full",
      fontFamily: "body"
    },
    positioner: {
      width: "var(--reference-width)"
    },
    content: {
      background: "white",
      borderRadius: "100",
      boxShadow: "sm",
      display: "flex",
      flexDirection: "column",
      zIndex: 1e3,
      padding: "75",
      maxH: "190px",
      overflowY: "auto",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "border.light",
      _open: {
        animation: "fadeIn 0.25s",
        animationTimingFunction: "entrance.expressive"
      },
      _closed: {
        animation: "fadeOut 0.2s",
        animationTimingFunction: "exit.expressive"
      },
      _focusVisible: {
        outlineOffset: "2px",
        outline: "2px solid",
        outlineColor: "border.dark"
      }
    },
    item: {
      alignItems: "center",
      borderRadius: "50",
      cursor: "pointer",
      display: "flex",
      justifyContent: "space-between",
      transitionDuration: "fast",
      transitionProperty: "background, color",
      transitionTimingFunction: "default",
      _hover: {
        background: "bg.lightest"
      },
      _highlighted: {
        background: "bg.lightest"
      },
      _disabled: {
        color: "text.disabled",
        cursor: "not-allowed",
        _hover: {
          background: "transparent",
          color: "text.disabled"
        }
      }
    },
    itemGroupLabel: {
      fontWeight: "semiBold",
      fontSize: "2xs",
      lineHeight: "2xs"
    },
    itemIndicator: {
      color: "text.dark"
    },
    label: {
      color: "text.mid",
      fontWeight: "medium",
      fontSize: "xs",
      lineHeight: "xs"
    },
    trigger: {
      appearance: "none",
      alignItems: "center",
      borderColor: "border.light",
      borderRadius: "100",
      cursor: "pointer",
      color: "text.dark",
      display: "inline-flex",
      justifyContent: "space-between",
      outline: 0,
      position: "relative",
      transitionDuration: "normal",
      transitionProperty: "background, box-shadow, border-color",
      transitionTimingFunction: "default",
      lineHeight: "xs",
      width: "full",
      _placeholderShown: {
        color: "text.light",
        fontSize: "md",
        lineHeight: "sm"
      },
      _hover: {
        _enabled: {
          borderColor: "border.mid",
          boxShadow: "0 0 0 1px token(colors.border.mid)"
        },
        _focus: {
          borderColor: "border.dark",
          boxShadow: "0 0 0 1px token(colors.border.dark)"
        }
      },
      _disabled: {
        color: "text.disabled",
        cursor: "not-allowed",
        "& :where(svg)": {
          color: "text.disabled"
        }
      },
      "& :where(svg)": {
        color: "icon.mid"
      }
    }
  },
  defaultVariants: {
    size: "md",
    visual: "outline"
  },
  variants: {
    visual: {
      outline: {
        trigger: {
          borderWidth: "1px",
          _focus: {
            borderColor: "border.dark",
            boxShadow: "0 0 0 1px token(colors.border.dark)"
          }
        }
      }
    },
    size: {
      sm: {
        content: { gap: "50" },
        item: { fontSize: "sm", lineHeight: "sm", px: "100", py: "75" },
        itemIndicator: {
          "& :where(svg)": {
            width: "icons.sm",
            height: "icons.sm"
          }
        },
        itemGroupLabel: {
          px: "100",
          py: "75"
        },
        trigger: {
          px: "150",
          py: "50",
          fontSize: "sm",
          gap: "100",
          "& :where(svg)": {
            width: "icons.sm",
            height: "icons.sm"
          }
        }
      },
      md: {
        content: { gap: "50" },
        item: { fontSize: "md", px: "150", py: "100" },
        itemIndicator: {
          "& :where(svg)": {
            width: "icons.md",
            height: "icons.md"
          }
        },
        itemGroupLabel: {
          px: "150",
          py: "100"
        },
        trigger: {
          px: "150",
          py: "100",
          fontSize: "md",
          gap: "100",
          "& :where(svg)": {
            width: "icons.md",
            height: "icons.md"
          }
        }
      },
      lg: {
        content: { gap: "50" },
        item: { fontSize: "md", px: "150", py: "100" },
        itemIndicator: {
          "& :where(svg)": {
            width: "icons.md",
            height: "icons.md"
          }
        },
        itemGroupLabel: {
          px: "150",
          py: "100"
        },
        trigger: {
          px: "150",
          py: "150",
          fontSize: "md",
          gap: "100",
          "& :where(svg)": {
            width: "icons.md",
            height: "icons.md"
          }
        }
      }
    }
  }
}), { withProvider: $7, withContext: bs } = vs(_7), e6 = $7(YU, "root"), t6 = bs($x, "content"), n6 = bs(eT, "control"), r6 = bs(oT, "itemGroupLabel"), o6 = bs(rT, "itemGroup"), i6 = bs(iT, "itemIndicator"), a6 = bs(nT, "item"), s6 = bs(aT, "itemText"), l6 = bs(sT, "label"), c6 = bs(lT, "positioner"), u6 = bs(cT, "trigger"), d6 = bs(uT, "valueText"), f6 = ({ item: e, label: n, ...t }) => /* @__PURE__ */ I.jsxs(a6, { item: e, ...t, children: [
  /* @__PURE__ */ I.jsx(s6, { children: e.label ?? n }),
  /* @__PURE__ */ I.jsx(i6, { children: /* @__PURE__ */ I.jsx(fr, { Element: Xh }) })
] }), g6 = ({
  placeholder: e,
  label: n,
  children: t,
  ...r
}) => /* @__PURE__ */ I.jsxs(e6, { ...r, children: [
  n && /* @__PURE__ */ I.jsx(l6, { children: n }),
  /* @__PURE__ */ I.jsx(n6, { children: /* @__PURE__ */ I.jsxs(u6, { children: [
    /* @__PURE__ */ I.jsx(d6, { placeholder: e }),
    /* @__PURE__ */ I.jsx(fr, { Element: YT })
  ] }) }),
  /* @__PURE__ */ I.jsx(c6, { children: /* @__PURE__ */ I.jsx(t6, { children: t }) })
] }), n8 = {
  Root: g6,
  Item: f6,
  ItemGroup: o6,
  ItemGroupLabel: r6
}, p6 = Ro({
  className: "navigationItemButton",
  slots: ["icon", "caption", "root"],
  base: {
    root: {
      display: "flex",
      gap: "100",
      cursor: "pointer"
    },
    icon: {
      width: "icons.md",
      height: "icons.md",
      borderRadius: "full",
      transitionDuration: "normal",
      transitionProperty: "background",
      transitionTimingFunction: "default",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      p: "1px"
    },
    caption: {
      transitionDuration: "normal",
      transitionProperty: "color",
      transitionTimingFunction: "default",
      width: "max-content",
      fontWeight: "medium",
      fontSize: "xs",
      lineHeight: "xs"
    }
  },
  variants: {
    visual: {
      neutral: {
        root: {
          _hover: {
            _enabled: {
              "&>[data-icon]": {
                bg: "bg.mid"
              },
              "&>[data-caption]": {
                color: "text.mid"
              }
            }
          },
          _disabled: {
            cursor: "not-allowed"
          }
        },
        icon: {
          bg: "bg.lighter"
        },
        caption: {
          color: "text.light"
        }
      },
      active: {
        icon: {
          bg: "icon.accent.mid"
        },
        caption: {
          color: "text.dark"
        }
      },
      complete: {
        icon: {
          bg: "icon.success.mid",
          color: "text.inverse"
        },
        caption: {
          color: "text.success.dark"
        }
      }
    }
  }
}), EA = ({
  isActive: e,
  isComplete: n,
  value: t,
  onValueChange: r
}) => {
  const o = p6({
    visual: e ? "active" : n ? "complete" : "neutral"
  });
  return /* @__PURE__ */ I.jsxs(
    It.button,
    {
      className: o.root,
      onClick: () => r(t.value),
      disabled: t.disabled,
      children: [
        /* @__PURE__ */ I.jsx(ll, { className: o.icon, "data-icon": !0, children: n && !e && /* @__PURE__ */ I.jsx(fr, { Element: Xh }) }),
        /* @__PURE__ */ I.jsx(Xr, { className: o.caption, "data-caption": !0, children: t.label })
      ]
    }
  );
}, r8 = ({
  data: e,
  onValueChange: n,
  activeValue: t,
  completedValues: r,
  ...o
}) => /* @__PURE__ */ I.jsx(Si, { gap: "300", w: "full", ...o, children: e.map((a) => {
  if (typeof a == "string" || typeof a == "number") {
    const f = t === a, p = !!(r != null && r.includes(a));
    return /* @__PURE__ */ I.jsx(
      EA,
      {
        value: { label: a.toString(), value: a },
        onValueChange: n,
        isActive: f,
        isComplete: p
      },
      a
    );
  }
  const l = t === a.value, u = !!(r != null && r.includes(a.value));
  return /* @__PURE__ */ I.jsx(
    EA,
    {
      value: a,
      onValueChange: n,
      isActive: l,
      isComplete: u
    },
    a.value
  );
}) }), h6 = Ro({
  className: "segmentGroup",
  slots: Vf.keys(),
  base: {
    root: {
      alignItems: "flex-start",
      display: "flex",
      width: "full",
      height: "full",
      flexDirection: {
        _horizontal: "row",
        _vertical: "column"
      },
      gap: {
        _horizontal: "200",
        _vertical: "0"
      },
      borderBottomWidth: {
        _horizontal: "2px"
      },
      borderLeftWidth: {
        _vertical: "2px"
      },
      borderColor: "border.light"
    },
    indicator: {
      borderColor: "border.dark",
      _horizontal: {
        bottom: "0",
        borderBottomWidth: "2px",
        transform: "translateY(2px)",
        width: "var(--width)"
      },
      _vertical: {
        borderLeftWidth: "2px",
        height: "var(--height)",
        transform: "translateX(-2px)"
      }
    },
    item: {
      color: "text.light",
      cursor: "pointer",
      fontWeight: "medium",
      fontSize: "xs",
      lineHeight: "xs",
      fontFamily: "body",
      transitionDuration: "normal",
      transitionProperty: "color, background",
      transitionTimingFunction: "default",
      borderRightRadius: "100",
      _checked: {
        color: "text.dark",
        fontWeight: "semiBold",
        _vertical: {
          bg: "bg.lightest"
        }
      },
      _disabled: {
        color: "text.disabled",
        cursor: "not-allowed",
        _hover: {
          color: "text.disabled"
        }
      },
      width: {
        _vertical: "full"
      },
      px: {
        _horizontal: "75",
        _vertical: "150"
      },
      pb: {
        _horizontal: "75"
      },
      py: {
        _vertical: "100"
      }
    },
    itemText: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "full",
      gap: "100"
    }
  }
}), { withProvider: m6, withContext: Qh } = vs(h6), v6 = m6(_x, "root"), b6 = Qh(Kx, "indicator"), y6 = Qh(Jx, "itemControl"), C6 = Qh(Xx, "item"), E6 = Qh(qx, "itemText"), A6 = ({
  value: e,
  disabled: n,
  children: t
}) => /* @__PURE__ */ I.jsxs(C6, { value: e, disabled: n, children: [
  /* @__PURE__ */ I.jsx(y6, {}),
  /* @__PURE__ */ I.jsx(E6, { children: t }),
  /* @__PURE__ */ I.jsx(Qx, {})
] }), S6 = ({ children: e, ...n }) => /* @__PURE__ */ I.jsxs(v6, { ...n, children: [
  e,
  /* @__PURE__ */ I.jsx(b6, {})
] }), o8 = {
  Root: S6,
  Item: A6
}, w6 = Ii({
  base: {
    px: "250",
    py: "200",
    color: "text.dark",
    display: "flex",
    justifyContent: "center",
    flexDir: "column",
    rowGap: "200",
    position: "relative",
    borderLeftWidth: "4px",
    borderLeftStyle: "solid",
    borderRightRadius: "100"
  },
  variants: {
    visual: {
      primary: { borderLeftColor: "border.mid", bg: "white" },
      accent: { borderLeftColor: "border.accent", bg: "bg.accent.lightest" },
      highlight: {
        borderLeftColor: "border.highlight",
        bg: "bg.highlight.lightest"
      },
      success: { borderLeftColor: "border.success", bg: "bg.success.lightest" },
      warning: { borderLeftColor: "border.warning", bg: "bg.warning.lightest" },
      destructive: {
        borderLeftColor: "border.error",
        bg: "bg.error.lightest"
      }
    }
  }
}), I6 = It("div", w6), x6 = It("button", {
  base: {
    position: "absolute",
    top: "150",
    right: "150",
    color: "icon.dark",
    cursor: "pointer",
    transitionDuration: "normal",
    transitionProperty: "color",
    transitionTimingFunction: "default",
    opacity: 0.5,
    _hover: {
      color: "icon.mid"
    }
  }
}), i8 = ({
  hideCloseTrigger: e,
  Icon: n,
  mainText: t,
  subText: r,
  buttonLabel: o,
  onButtonClick: a,
  ...l
}) => {
  const [u, f] = du(!0);
  return /* @__PURE__ */ I.jsx(
    Bx,
    {
      present: u,
      className: ni({
        _open: {
          animation: "fadeIn 300ms",
          animationTimingFunction: "entrance.expressive"
        },
        _closed: {
          animation: "fadeOut 300ms",
          animationTimingFunction: "exit.expressive"
        }
      }),
      children: /* @__PURE__ */ I.jsxs(I6, { ...l, children: [
        !e && /* @__PURE__ */ I.jsx(x6, { onClick: () => f(!1), children: /* @__PURE__ */ I.jsx(fr, { Element: Fy }) }),
        /* @__PURE__ */ I.jsxs(Si, { width: "full", flexDir: "column", gap: "100", children: [
          (n || t) && /* @__PURE__ */ I.jsxs(Si, { width: "full", alignItems: "center", gap: "100", children: [
            n && /* @__PURE__ */ I.jsx(fr, { Element: n }),
            t && /* @__PURE__ */ I.jsx(Xr, { visual: "bodySemiBold", color: "text.dark", children: t })
          ] }),
          r && /* @__PURE__ */ I.jsx(Xr, { color: "text.dark", children: r })
        ] }),
        o && /* @__PURE__ */ I.jsx(
          ti,
          {
            onClick: a,
            visual: "outline",
            size: "sm",
            maxW: "max-content",
            boxShadow: "xs",
            children: o
          }
        )
      ] })
    }
  );
}, AA = {
  alignItems: "center",
  borderRadius: "50",
  cursor: "pointer",
  display: "flex",
  justifyContent: "space-between",
  transitionDuration: "fast",
  transitionProperty: "background, color",
  transitionTimingFunction: "default",
  px: "150",
  py: "100",
  _hover: {
    background: "bg.lightest",
    "& :where(svg)": {
      color: "icon.dark"
    }
  },
  _highlighted: {
    background: "bg.lightest"
  },
  "& :where(svg)": {
    color: "icon.dark"
  },
  _disabled: {
    color: "text.dark",
    cursor: "not-allowed",
    opacity: 0.3,
    _hover: {
      background: "transparent",
      color: "text.dark"
    }
  }
}, T6 = Ro({
  className: "menu",
  slots: ow.keys(),
  base: {
    content: {
      fontFamily: "body",
      background: "white",
      borderRadius: "100",
      boxShadow: "sm",
      display: "flex",
      flexDirection: "column",
      outline: "none",
      width: "calc(100% + 2rem)",
      zIndex: "modal",
      padding: "75",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "border.light",
      _open: {
        animation: "fadeIn 0.25s",
        animationTimingFunction: "entrance.expressive"
      },
      _closed: {
        animation: "fadeOut 0.2s",
        animationTimingFunction: "exit.expressive"
      }
    },
    itemGroupLabel: {
      color: "text.mid",
      fontWeight: "semiBold",
      fontSize: "2xs",
      lineHeight: "2xs",
      px: "150",
      py: "100"
    },
    itemGroup: {
      display: "flex",
      flexDirection: "column"
    },
    positioner: {
      zIndex: "modal"
    },
    separator: {
      borderColor: "border.light"
    },
    item: AA,
    triggerItem: AA
  }
}), { withRootProvider: P6, withContext: pu } = vs(T6), k6 = P6(
  O5
), R6 = pu(px, "content"), O6 = pu(vx, "itemGroupLabel"), D6 = pu(mx, "itemGroup"), F6 = pu(hx, "item"), N6 = pu(bx, "positioner"), M6 = pu(yx, "separator"), L6 = pu(Ex, "triggerItem"), B6 = pu(Cx, "trigger"), V6 = ({ children: e, ...n }) => /* @__PURE__ */ I.jsx(F6, { ...n, children: e }), j6 = ({ children: e, trigger: n, ...t }) => /* @__PURE__ */ I.jsxs(k6, { ...t, children: [
  /* @__PURE__ */ I.jsx(B6, { asChild: !0, children: n }),
  /* @__PURE__ */ I.jsx(N6, { children: /* @__PURE__ */ I.jsx(R6, { children: e }) })
] }), a8 = {
  Root: j6,
  Item: V6,
  ItemGroup: D6,
  ItemGroupLabel: O6,
  TriggerItem: L6,
  Separator: M6
}, U6 = Ro({
  className: "colorPicker",
  slots: yM.keys(),
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "75",
      fontFamily: "body"
    },
    label: {
      color: "text.mid",
      fontWeight: "medium",
      fontSize: "xs",
      lineHeight: "xs"
    },
    control: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: "100"
    },
    content: {
      fontFamily: "body",
      background: "white",
      borderRadius: "100",
      boxShadow: "sm",
      display: "flex",
      flexDirection: "column",
      maxWidth: "sm",
      p: "200",
      zIndex: "modal",
      _open: {
        animation: "fadeIn 0.25s",
        animationTimingFunction: "entrance.expressive"
      },
      _closed: {
        animation: "fadeOut 0.2s",
        animationTimingFunction: "exit.expressive"
      }
    },
    area: {
      height: "36",
      borderRadius: "50",
      overflow: "hidden"
    },
    areaThumb: {
      borderRadius: "full",
      height: "2.5",
      width: "2.5",
      boxShadow: "white 0px 0px 0px 2px, black 0px 0px 2px 1px",
      outline: "none"
    },
    areaBackground: {
      height: "full"
    },
    channelSlider: {
      borderRadius: "50"
    },
    channelSliderTrack: {
      height: "3",
      borderRadius: "50"
    },
    swatch: {
      height: "6",
      width: "6",
      borderRadius: "50",
      boxShadow: "xs"
    },
    channelSliderThumb: {
      borderRadius: "full",
      height: "2.5",
      width: "2.5",
      boxShadow: "white 0px 0px 0px 2px, black 0px 0px 2px 1px",
      transform: "translate(-50%, -50%)",
      outline: "none"
    },
    transparencyGrid: {
      borderRadius: "50"
    }
  }
}), { withProvider: W6, withContext: oi } = vs(U6), H6 = W6(Qw, "root"), G6 = oi(Ow, "areaBackground"), Y6 = oi(Rw, "area"), z6 = oi(Dw, "areaThumb"), Rv = oi(Fw, "channelInput"), SA = oi(Mw, "channelSlider"), wA = oi(Lw, "channelSliderThumb"), IA = oi(Bw, "channelSliderTrack"), Z6 = oi(Vw, "content"), K6 = oi(jw, "control"), X6 = oi(Uw, "eyeDropperTrigger"), J6 = oi(Hw, "label"), Q6 = oi(Gw, "positioner"), q6 = oi(qw, "swatch"), _6 = oi(_w, "transparencyGrid"), $6 = oi($w, "trigger"), s8 = ({ label: e, ...n }) => /* @__PURE__ */ I.jsxs(H6, { ...n, children: [
  /* @__PURE__ */ I.jsx(DL, { children: (t) => /* @__PURE__ */ I.jsxs(I.Fragment, { children: [
    e && /* @__PURE__ */ I.jsx(J6, { children: e }),
    /* @__PURE__ */ I.jsxs(K6, { children: [
      /* @__PURE__ */ I.jsx(Rv, { channel: "hex", asChild: !0, children: /* @__PURE__ */ I.jsx(Ev, {}) }),
      /* @__PURE__ */ I.jsx($6, { asChild: !0, children: /* @__PURE__ */ I.jsx(ti, { visual: "outline", p: "7.5px!", height: "fit-content", children: /* @__PURE__ */ I.jsx(q6, { value: t.value }) }) })
    ] }),
    /* @__PURE__ */ I.jsx(Q6, { children: /* @__PURE__ */ I.jsx(Z6, { children: /* @__PURE__ */ I.jsxs(tE, { gap: "150", children: [
      /* @__PURE__ */ I.jsxs(Y6, { children: [
        /* @__PURE__ */ I.jsx(G6, {}),
        /* @__PURE__ */ I.jsx(z6, {})
      ] }),
      /* @__PURE__ */ I.jsxs(rE, { gap: "150", children: [
        /* @__PURE__ */ I.jsx(X6, { asChild: !0, children: /* @__PURE__ */ I.jsx(
          ti,
          {
            size: "sm",
            visual: "outline",
            "aria-label": "Pick a color",
            Icon: J2
          }
        ) }),
        /* @__PURE__ */ I.jsxs(tE, { gap: "100", flex: "1", children: [
          /* @__PURE__ */ I.jsxs(SA, { channel: "hue", children: [
            /* @__PURE__ */ I.jsx(IA, {}),
            /* @__PURE__ */ I.jsx(wA, {})
          ] }),
          /* @__PURE__ */ I.jsxs(SA, { channel: "alpha", children: [
            /* @__PURE__ */ I.jsx(_6, { size: "8px" }),
            /* @__PURE__ */ I.jsx(IA, {}),
            /* @__PURE__ */ I.jsx(wA, {})
          ] })
        ] })
      ] }),
      /* @__PURE__ */ I.jsxs(rE, { children: [
        /* @__PURE__ */ I.jsx(Rv, { channel: "hex", asChild: !0, children: /* @__PURE__ */ I.jsx(Ev, {}) }),
        /* @__PURE__ */ I.jsx(Rv, { channel: "alpha", asChild: !0, children: /* @__PURE__ */ I.jsx(Ev, {}) })
      ] })
    ] }) }) })
  ] }) }),
  /* @__PURE__ */ I.jsx(Ww, {})
] }), eY = Ro({
  className: "pagination",
  slots: aw.keys(),
  base: {
    root: {
      display: "flex",
      gap: "75",
      fontFamily: "body"
    },
    item: {
      fontVariantNumeric: "tabular-nums",
      transitionDuration: "normal",
      transitionProperty: "background, color",
      transitionTimingFunction: "default",
      fontSize: "xs",
      lineHeight: "xs",
      width: "8",
      height: "8",
      _selected: {
        bg: "bg.darkest",
        color: "text.inverse",
        _hover: {
          bg: "bg.darkest"
        }
      }
    },
    ellipsis: {
      alignItems: "center",
      color: "text.dark",
      display: "inline-flex",
      fontWeight: "semiBold",
      px: "100"
    },
    nextTrigger: {
      width: "8",
      height: "8",
      position: "relative",
      "& svg": {
        position: "absolute",
        width: "icons.sm",
        height: "icons.sm"
      }
    },
    prevTrigger: {
      width: "8",
      height: "8",
      position: "relative",
      "& svg": {
        position: "absolute",
        width: "icons.sm",
        height: "icons.sm"
      }
    }
  }
}), tY = ({ page: e, ...n }) => {
  const [t, r] = zh(n), { className: o, ...a } = r, l = eY();
  return /* @__PURE__ */ I.jsx(
    Mx,
    {
      className: sc(l.root, ni(t), o),
      page: e,
      ...a,
      children: /* @__PURE__ */ I.jsx(rU, { children: ({ pages: u }) => /* @__PURE__ */ I.jsxs(I.Fragment, { children: [
        /* @__PURE__ */ I.jsx(Nx, { className: l.prevTrigger, asChild: !0, children: /* @__PURE__ */ I.jsx(
          ti,
          {
            visual: "outline",
            Icon: Oy,
            "aria-label": "Previous Page"
          }
        ) }),
        u.map(
          (f, p) => f.type === "page" ? /* @__PURE__ */ I.jsx(
            Dx,
            {
              className: l.item,
              ...f,
              asChild: !0,
              children: /* @__PURE__ */ I.jsx(ti, { visual: "outline", children: f.value })
            },
            p
          ) : /* @__PURE__ */ I.jsx(
            Ox,
            {
              className: l.ellipsis,
              index: p,
              children: "…"
            },
            p
          )
        ),
        /* @__PURE__ */ I.jsx(Fx, { className: l.nextTrigger, asChild: !0, children: /* @__PURE__ */ I.jsx(
          ti,
          {
            visual: "outline",
            Icon: Dy,
            "aria-label": "Next Page"
          }
        ) })
      ] }) })
    }
  );
};
tY.displayName = "Pagination";
const xA = Ro({
  className: "checkbox",
  slots: VS.keys(),
  base: {
    root: {
      cursor: "pointer",
      display: "flex",
      width: "fit-content",
      gap: 200,
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
      }
    },
    control: {
      transitionDuration: "normal",
      transitionTimingFunction: "default",
      width: "icons.md",
      height: "icons.md",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: {
        base: "border.light",
        _checked: "bg.darkest",
        _hover: {
          base: "border.mid",
          _checked: "bg.darkest"
        }
      },
      _disabled: {
        cursor: "not-allowed",
        pointerEvents: "none"
      },
      "&:has(+ :focus-visible)": {
        outline: "2px solid",
        outlineColor: "border.dark"
      }
    }
  }
}), nY = ({ fill: e }) => {
  const { checked: n, indeterminate: t } = zb();
  let r = PG;
  return t ? r = r4 : n && (r = qG), /* @__PURE__ */ I.jsx(fr, { Element: r, style: { fill: e } });
}, rY = oe(
  (e, n) => {
    const [t, r] = xA.splitVariantProps(e), [o, a] = zh(r), { label: l, hint: u, className: f, checkboxFill: p, ...y } = a, A = xA(t);
    return /* @__PURE__ */ I.jsxs(
      ww,
      {
        ref: n,
        className: sc(A.root, ni(o), f),
        ...y,
        children: [
          /* @__PURE__ */ I.jsx(Cw, { className: A.control, children: /* @__PURE__ */ I.jsx(nY, { fill: p }) }),
          l && /* @__PURE__ */ I.jsxs(bH, { gap: 50, children: [
            /* @__PURE__ */ I.jsx(Xr, { visual: "bodyMedium", children: l }),
            u && /* @__PURE__ */ I.jsx(Xr, { color: "text.light", children: u })
          ] }),
          /* @__PURE__ */ I.jsx(Ew, {})
        ]
      }
    );
  }
);
rY.displayName = "Checkbox";
const oY = Ro({
  className: "combobox",
  slots: XS.keys(),
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "75",
      width: "full"
    },
    control: {
      position: "relative",
      width: "full",
      height: "full"
    },
    input: {
      borderColor: "border.light",
      borderRadius: "100",
      borderWidth: "1px",
      pl: "150",
      pr: "500",
      py: "100",
      width: "full",
      _placeholder: {
        fontFamily: "body",
        color: "text.light"
      },
      _disabled: {
        _placeholder: {
          color: "text.disabled"
        },
        borderColor: "border.disabled",
        color: "text.disabled",
        cursor: "not-allowed"
      },
      _focus: {
        borderColor: "border.dark",
        boxShadow: "0 0 0 1px token(colors.border.dark)"
      },
      _hover: {
        _enabled: {
          borderColor: "border.mid",
          boxShadow: "0 0 0 1px token(colors.border.mid)"
        },
        _focus: {
          borderColor: "border.dark",
          boxShadow: "0 0 0 1px token(colors.border.dark)"
        }
      },
      _invalid: {
        color: "text.error.dark",
        borderColor: "border.error",
        boxShadow: "0 0 0 1px token(colors.border.error)"
      }
    },
    label: {
      color: "text.mid",
      fontWeight: "medium",
      fontSize: "xs",
      lineHeight: "xs",
      fontFamily: "body"
    },
    trigger: {
      color: "icon.mid",
      position: "absolute",
      bottom: "0",
      right: "0",
      top: "0"
    },
    content: {
      background: "white",
      borderRadius: "50",
      boxShadow: "200",
      display: "flex",
      flexDirection: "column",
      zIndex: 1e3,
      maxH: "190px",
      overflowY: "auto",
      _open: {
        animation: "fadeIn 0.25s"
      },
      _closed: {
        animation: "fadeOut 0.2s"
      },
      _focusVisible: {
        outlineOffset: "2px",
        outline: "2px solid",
        outlineColor: "border.mid"
      }
    },
    item: {
      alignItems: "center",
      borderRadius: "50",
      cursor: "pointer",
      display: "flex",
      justifyContent: "space-between",
      transitionDuration: "fast",
      transitionProperty: "background, color",
      transitionTimingFunction: "default",
      fontFamily: "body",
      fontWeight: "medium",
      color: "text.mid",
      fontSize: "sm",
      px: "100",
      _hover: {
        background: "bg.lightest"
      },
      _highlighted: {
        background: "bg.lightest"
      },
      _disabled: {
        color: "text.disabled",
        cursor: "not-allowed",
        _hover: {
          background: "transparent"
        }
      }
    },
    itemGroupLabel: {
      color: "text.dark",
      fontWeight: "medium",
      fontSize: "2xs",
      lineHeight: "2xs",
      px: "100"
    },
    itemIndicator: {
      color: "text.mid"
    }
  },
  defaultVariants: {
    size: "md"
  },
  variants: {
    size: {
      sm: {
        content: { p: "25", gap: "50" },
        item: { fontSize: "sm", py: "150" },
        input: { py: "75" },
        itemIndicator: {
          "& :where(svg)": {
            width: "icons.sm",
            height: "icons.sm"
          }
        },
        itemGroupLabel: {
          py: "75"
        },
        label: { fontSize: "sm" },
        trigger: { right: "150" }
      },
      md: {
        content: { p: "50", gap: "50" },
        item: { fontSize: "md", py: "150" },
        itemIndicator: {
          "& :where(svg)": {
            width: "icons.md",
            height: "icons.md"
          }
        },
        itemGroupLabel: {
          py: "75"
        },
        label: { fontSize: "sm" },
        trigger: { right: "3" }
      },
      lg: {
        content: { p: "75", gap: "50" },
        item: { fontSize: "md", py: "150" },
        input: { py: "150", px: "200" },
        itemIndicator: {
          "& :where(svg)": {
            width: "icons.md",
            height: "icons.md"
          }
        },
        itemGroupLabel: {
          py: "75"
        },
        label: { fontSize: "sm" },
        trigger: { right: "200" }
      }
    }
  }
}), { withProvider: iY, withContext: ys } = vs(oY), aY = iY(oI, "root"), sY = ys(ey, "content"), lY = ys(ty, "control"), TA = ys(ny, "input"), cY = ys(iy, "itemGroupLabel"), uY = ys(oy, "itemGroup"), dY = ys(ay, "itemIndicator"), fY = ys(ry, "item"), gY = ys(sy, "itemText"), pY = ys(ly, "label"), hY = ys(cy, "positioner"), mY = ys(dy, "trigger"), vY = ({ label: e, ...n }) => /* @__PURE__ */ I.jsxs(fY, { ...n, children: [
  /* @__PURE__ */ I.jsx(gY, { children: e }),
  /* @__PURE__ */ I.jsx(dY, { children: /* @__PURE__ */ I.jsx(fr, { Element: Xh }) })
] }), bY = ({ label: e, children: n, ...t }) => /* @__PURE__ */ I.jsxs(aY, { ...t, children: [
  /* @__PURE__ */ I.jsx(pY, { children: e }),
  /* @__PURE__ */ I.jsxs(lY, { children: [
    /* @__PURE__ */ I.jsx(TA, { asChild: !0, children: /* @__PURE__ */ I.jsx(TA, {}) }),
    /* @__PURE__ */ I.jsx(mY, { asChild: !0, children: /* @__PURE__ */ I.jsx(It.button, { appearance: "none", cursor: "pointer", children: /* @__PURE__ */ I.jsx(fr, { Element: YT }) }) })
  ] }),
  /* @__PURE__ */ I.jsx(hY, { children: /* @__PURE__ */ I.jsx(sY, { children: n }) })
] }), l8 = {
  Root: bY,
  ItemGroup: uY,
  ItemGroupLabel: cY,
  Item: vY
}, yY = Ro({
  className: "accordion",
  slots: LS.keys(),
  base: {
    root: {
      width: "full",
      divideY: "1px",
      divideColor: "border.mid",
      borderTopWidth: "1px",
      borderBottomWidth: "1px",
      borderColor: "border.mid",
      fontFamily: "body"
    },
    itemTrigger: {
      alignItems: "center",
      color: "text.dark",
      cursor: "pointer",
      display: "flex",
      fontSize: "md",
      lineHeight: "sm",
      fontWeight: "semiBold",
      gap: "150",
      justifyContent: "space-between",
      textAlign: "left",
      width: "full",
      _disabled: {
        opacity: 0.3,
        cursor: "not-allowed"
      }
    },
    itemIndicator: {
      color: "icon.mid",
      transformOrigin: "center",
      transitionDuration: "normal",
      transitionProperty: "transform",
      transitionTimingFunction: "default",
      _open: {
        transform: "rotate(-180deg)"
      }
    },
    itemContent: {
      color: "text.mid",
      overflow: "hidden",
      transitionProperty: "padding-bottom",
      transitionDuration: "normal",
      transitionTimingFunction: "default",
      _open: {
        animation: "slideDown 250ms ease-in-out"
      },
      _closed: {
        animation: "slideUp 250ms ease-in-out"
      }
    }
  },
  defaultVariants: {
    size: "md"
  },
  variants: {
    size: {
      md: {
        itemTrigger: {
          py: "200"
        },
        itemContent: {
          pb: "300",
          pr: "400",
          _closed: {
            pb: "0"
          }
        }
      }
    }
  }
}), { withProvider: CY, withContext: qh } = vs(yY), EY = CY(kS, "root"), AY = qh(Db, "itemContent"), SY = qh(TS, "itemIndicator"), wY = qh(IS, "item"), IY = qh(PS, "itemTrigger"), xY = ({ title: e, children: n, ...t }) => /* @__PURE__ */ I.jsxs(wY, { ...t, children: [
  /* @__PURE__ */ I.jsxs(IY, { children: [
    e,
    /* @__PURE__ */ I.jsx(SY, { children: /* @__PURE__ */ I.jsx(fr, { Element: zT, size: "lg" }) })
  ] }),
  /* @__PURE__ */ I.jsx(AY, { children: n })
] }), TY = ({ children: e, ...n }) => /* @__PURE__ */ I.jsx(EY, { ...n, children: e }), c8 = {
  Root: TY,
  Item: xY,
  Context: YO,
  ItemContext: Db
}, u8 = WO;
export {
  c8 as Accordion,
  FY as ArkCombobox,
  D4 as BaseInput,
  q7 as BaseTextarea,
  ti as Button,
  WY as Calendar,
  HY as Card,
  GY as Carousel,
  rY as Checkbox,
  YY as ClipboardButton,
  s8 as ColorPicker,
  l8 as Combobox,
  zY as FileUpload,
  i8 as Flag,
  $4 as Heading,
  fr as Icon,
  Ev as Input,
  jY as Link,
  wH as LinkButton,
  a8 as Menu,
  ZY as Modal,
  $Y as ModalOverlay,
  UY as MultiActionButton,
  W4 as NumberInput,
  tY as Pagination,
  Lx as Portal,
  r8 as ProgressNavigation,
  KY as Radio,
  XY as RadioGroup,
  JY as SectionHeader,
  o8 as SegmentGroup,
  n8 as Select,
  AH as Spinner,
  QY as StepHeader,
  qY as StyleRoot,
  j7 as Switch,
  _Y as Table,
  Ry as Tag,
  Xr as Text,
  t8 as Textarea,
  L7 as Toast,
  u8 as TrekkerPandaPreset,
  L4 as dialogContentStyles,
  B7 as toastFactory,
  e8 as useIsModalOverlayOpen
};
